import './index-B3Tm5odI.css';var jl = Object.defineProperty;
var Yl = (re, he, Ce) => he in re ? jl(re, he, { enumerable: !0, configurable: !0, writable: !0, value: Ce }) : re[he] = Ce;
var Or = (re, he, Ce) => Yl(re, typeof he != "symbol" ? he + "" : he, Ce);
import { A as Kl, u as Dr, s as Va, a as oa, b as $n, i as zl, T as Wl, C as Ql, c as Xl, d as $l, e as Jl, F as ec, f as aa, g as Ka, t as di, v as ta, h as tc, j as Rs, k as ws, l as nc, m as ja, M as rc, n as ic } from "./vidstack-CpEp8jXV.js";
import { o as gh } from "./vidstack-CpEp8jXV.js";
import { jsx as ve, jsxs as ln, Fragment as pi } from "react/jsx-runtime";
import { createContext as Wa, useContext as Qa, useState as _r, useCallback as Zn, useEffect as Pr, useMemo as Mr, useRef as Nr, forwardRef as ac } from "react";
import { initReactI18next as oc, useTranslation as Hn } from "react-i18next";
import sc from "i18next";
import uc from "i18next-resources-to-backend";
import { useFloating as sa, autoUpdate as ua, shift as Xa, offset as $a, arrow as Ja, useMergeRefs as eo, useListNavigation as ks, useDismiss as to, useInteractions as no, FloatingFocusManager as ro, FloatingArrow as io, detectOverflow as lc } from "@floating-ui/react";
Kl.add("audio/aac");
var Ya = { exports: {} };
/*! For license information please see dash.all.min.js.LICENSE.txt */
var Cs;
function cc() {
  return Cs || (Cs = 1, function(re, he) {
    (function(Ce, rt) {
      re.exports = rt();
    })(self, function() {
      return function() {
        var Ce = { 4593: function(Pe, Ee) {
          var C, ie, T, t, e, p = function(E) {
            for (var h = [], n = 0; n < E.length; ++n) {
              var c = E.charCodeAt(n);
              c < 128 ? h.push(c) : c < 2048 ? (h.push(192 | c >> 6), h.push(128 | 63 & c)) : c < 65536 ? (h.push(224 | c >> 12), h.push(128 | 63 & c >> 6), h.push(128 | 63 & c)) : (h.push(240 | c >> 18), h.push(128 | 63 & c >> 12), h.push(128 | 63 & c >> 6), h.push(128 | 63 & c));
            }
            return h;
          }, m = function(E) {
            for (var h = [], n = 0; n < E.length; ) {
              var c = E[n++];
              c < 128 || (c < 224 ? (c = (31 & c) << 6, c |= 63 & E[n++]) : c < 240 ? (c = (15 & c) << 12, c |= (63 & E[n++]) << 6, c |= 63 & E[n++]) : (c = (7 & c) << 18, c |= (63 & E[n++]) << 12, c |= (63 & E[n++]) << 6, c |= 63 & E[n++])), h.push(String.fromCharCode(c));
            }
            return h.join("");
          }, o = {};
          C = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", ie = function(E) {
            for (var h = 0, n = [], c = 0 | E.length / 3; 0 < c--; ) {
              var d = (E[h] << 16) + (E[h + 1] << 8) + E[h + 2];
              h += 3, n.push(C.charAt(63 & d >> 18)), n.push(C.charAt(63 & d >> 12)), n.push(C.charAt(63 & d >> 6)), n.push(C.charAt(63 & d));
            }
            return E.length - h == 2 ? (d = (E[h] << 16) + (E[h + 1] << 8), n.push(C.charAt(63 & d >> 18)), n.push(C.charAt(63 & d >> 12)), n.push(C.charAt(63 & d >> 6)), n.push("=")) : E.length - h == 1 && (d = E[h] << 16, n.push(C.charAt(63 & d >> 18)), n.push(C.charAt(63 & d >> 12)), n.push("==")), n.join("");
          }, T = function() {
            for (var E = [], h = 0; h < C.length; ++h) E[C.charCodeAt(h)] = h;
            return E[61] = 0, E;
          }(), t = function(E) {
            for (var h = 0, n = [], c = 0 | E.length / 4; 0 < c--; ) {
              var d = (T[E.charCodeAt(h)] << 18) + (T[E.charCodeAt(h + 1)] << 12) + (T[E.charCodeAt(h + 2)] << 6) + T[E.charCodeAt(h + 3)];
              n.push(255 & d >> 16), n.push(255 & d >> 8), n.push(255 & d), h += 4;
            }
            return n && (E.charAt(h - 2) == "=" ? (n.pop(), n.pop()) : E.charAt(h - 1) == "=" && n.pop()), n;
          }, e = { encode: function(E) {
            for (var h = [], n = 0; n < E.length; ++n) h.push(E.charCodeAt(n));
            return h;
          }, decode: function(E) {
            for (var h = 0; h < s.length; ++h) a[h] = String.fromCharCode(a[h]);
            return a.join("");
          } }, o.decodeArray = function(E) {
            var h = t(E);
            return new Uint8Array(h);
          }, o.encodeASCII = function(E) {
            var h = e.encode(E);
            return ie(h);
          }, o.decodeASCII = function(E) {
            var h = t(E);
            return e.decode(h);
          }, o.encode = function(E) {
            var h = p(E);
            return ie(h);
          }, o.decode = function(E) {
            var h = t(E);
            return m(h);
          }, Ee.decode = o.decode, Ee.decodeArray = o.decodeArray, Ee.encode = o.encode, Ee.encodeASCII = o.encodeASCII;
        }, 452: function(Pe, Ee) {
          (function(C) {
            var ie = { 42: 225, 92: 233, 94: 237, 95: 243, 96: 250, 123: 231, 124: 247, 125: 209, 126: 241, 127: 9608, 128: 174, 129: 176, 130: 189, 131: 191, 132: 8482, 133: 162, 134: 163, 135: 9834, 136: 224, 137: 32, 138: 232, 139: 226, 140: 234, 141: 238, 142: 244, 143: 251, 144: 193, 145: 201, 146: 211, 147: 218, 148: 220, 149: 252, 150: 8216, 151: 161, 152: 42, 153: 8217, 154: 9473, 155: 169, 156: 8480, 157: 8226, 158: 8220, 159: 8221, 160: 192, 161: 194, 162: 199, 163: 200, 164: 202, 165: 203, 166: 235, 167: 206, 168: 207, 169: 239, 170: 212, 171: 217, 172: 249, 173: 219, 174: 171, 175: 187, 176: 195, 177: 227, 178: 205, 179: 204, 180: 236, 181: 210, 182: 242, 183: 213, 184: 245, 185: 123, 186: 125, 187: 92, 188: 94, 189: 95, 190: 124, 191: 8764, 192: 196, 193: 228, 194: 214, 195: 246, 196: 223, 197: 165, 198: 164, 199: 9475, 200: 197, 201: 229, 202: 216, 203: 248, 204: 9487, 205: 9491, 206: 9495, 207: 9499 }, T = function(M) {
              var K = M;
              return ie.hasOwnProperty(M) && (K = ie[M]), String.fromCharCode(K);
            }, t = 15, e = 32, p = { 17: 1, 18: 3, 21: 5, 22: 7, 23: 9, 16: 11, 19: 12, 20: 14 }, m = { 17: 2, 18: 4, 21: 6, 22: 8, 23: 10, 19: 13, 20: 15 }, o = { 25: 1, 26: 3, 29: 5, 30: 7, 31: 9, 24: 11, 27: 12, 28: 14 }, E = { 25: 2, 26: 4, 29: 6, 30: 8, 31: 10, 27: 13, 28: 15 }, h = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "black", "transparent"], n = { verboseFilter: { DATA: 3, DEBUG: 3, INFO: 2, WARNING: 2, TEXT: 1, ERROR: 0 }, time: null, verboseLevel: 0, setTime: function(M) {
              this.time = M;
            }, log: function(M, K) {
              var ae = this.verboseFilter[M];
              this.verboseLevel >= ae && console.log(this.time + " [" + M + "] " + K);
            } }, c = function(M) {
              for (var K = [], ae = 0; ae < M.length; ae++) K.push(M[ae].toString(16));
              return K;
            }, d = function(M, K, ae, j, ee) {
              this.foreground = M || "white", this.underline = K || !1, this.italics = ae || !1, this.background = j || "black", this.flash = ee || !1;
            };
            d.prototype = { reset: function() {
              this.foreground = "white", this.underline = !1, this.italics = !1, this.background = "black", this.flash = !1;
            }, setStyles: function(M) {
              for (var K = ["foreground", "underline", "italics", "background", "flash"], ae = 0; ae < K.length; ae++) {
                var j = K[ae];
                M.hasOwnProperty(j) && (this[j] = M[j]);
              }
            }, isDefault: function() {
              return this.foreground === "white" && !this.underline && !this.italics && this.background === "black" && !this.flash;
            }, equals: function(M) {
              return this.foreground === M.foreground && this.underline === M.underline && this.italics === M.italics && this.background === M.background && this.flash === M.flash;
            }, copy: function(M) {
              this.foreground = M.foreground, this.underline = M.underline, this.italics = M.italics, this.background = M.background, this.flash = M.flash;
            }, toString: function() {
              return "color=" + this.foreground + ", underline=" + this.underline + ", italics=" + this.italics + ", background=" + this.background + ", flash=" + this.flash;
            } };
            var S = function(M, K, ae, j, ee, ue) {
              this.uchar = M || " ", this.penState = new d(K, ae, j, ee, ue);
            };
            S.prototype = { reset: function() {
              this.uchar = " ", this.penState.reset();
            }, setChar: function(M, K) {
              this.uchar = M, this.penState.copy(K);
            }, setPenState: function(M) {
              this.penState.copy(M);
            }, equals: function(M) {
              return this.uchar === M.uchar && this.penState.equals(M.penState);
            }, copy: function(M) {
              this.uchar = M.uchar, this.penState.copy(M.penState);
            }, isEmpty: function() {
              return this.uchar === " " && this.penState.isDefault();
            } };
            var x = function() {
              this.chars = [];
              for (var M = 0; M < e; M++) this.chars.push(new S());
              this.pos = 0, this.currPenState = new d();
            };
            x.prototype = { equals: function(M) {
              for (var K = !0, ae = 0; ae < e; ae++) if (!this.chars[ae].equals(M.chars[ae])) {
                K = !1;
                break;
              }
              return K;
            }, copy: function(M) {
              for (var K = 0; K < e; K++) this.chars[K].copy(M.chars[K]);
            }, isEmpty: function() {
              for (var M = !0, K = 0; K < e; K++) if (!this.chars[K].isEmpty()) {
                M = !1;
                break;
              }
              return M;
            }, setCursor: function(M) {
              this.pos !== M && (this.pos = M), this.pos < 0 ? (n.log("ERROR", "Negative cursor position " + this.pos), this.pos = 0) : this.pos > e && (n.log("ERROR", "Too large cursor position " + this.pos), this.pos = e);
            }, moveCursor: function(M) {
              var K = this.pos + M;
              if (M > 1) for (var ae = this.pos + 1; ae < K + 1; ae++) this.chars[ae].setPenState(this.currPenState);
              this.setCursor(K);
            }, backSpace: function() {
              this.moveCursor(-1), this.chars[this.pos].setChar(" ", this.currPenState);
            }, insertChar: function(M) {
              M >= 144 && this.backSpace();
              var K = T(M);
              this.pos >= e ? n.log("ERROR", "Cannot insert " + M.toString(16) + " (" + K + ") at position " + this.pos + ". Skipping it!") : (this.chars[this.pos].setChar(K, this.currPenState), this.moveCursor(1));
            }, clearFromPos: function(M) {
              var K;
              for (K = M; K < e; K++) this.chars[K].reset();
            }, clear: function() {
              this.clearFromPos(0), this.pos = 0, this.currPenState.reset();
            }, clearToEndOfRow: function() {
              this.clearFromPos(this.pos);
            }, getTextString: function() {
              for (var M = [], K = !0, ae = 0; ae < e; ae++) {
                var j = this.chars[ae].uchar;
                j !== " " && (K = !1), M.push(j);
              }
              return K ? "" : M.join("");
            }, setPenStyles: function(M) {
              this.currPenState.setStyles(M), this.chars[this.pos].setPenState(this.currPenState);
            } };
            var B = function() {
              this.rows = [];
              for (var M = 0; M < t; M++) this.rows.push(new x());
              this.currRow = 14, this.nrRollUpRows = null, this.reset();
            };
            B.prototype = { reset: function() {
              for (var M = 0; M < t; M++) this.rows[M].clear();
              this.currRow = 14;
            }, equals: function(M) {
              for (var K = !0, ae = 0; ae < t; ae++) if (!this.rows[ae].equals(M.rows[ae])) {
                K = !1;
                break;
              }
              return K;
            }, copy: function(M) {
              for (var K = 0; K < t; K++) this.rows[K].copy(M.rows[K]);
            }, isEmpty: function() {
              for (var M = !0, K = 0; K < t; K++) if (!this.rows[K].isEmpty()) {
                M = !1;
                break;
              }
              return M;
            }, backSpace: function() {
              this.rows[this.currRow].backSpace();
            }, clearToEndOfRow: function() {
              this.rows[this.currRow].clearToEndOfRow();
            }, insertChar: function(M) {
              this.rows[this.currRow].insertChar(M);
            }, setPen: function(M) {
              this.rows[this.currRow].setPenStyles(M);
            }, moveCursor: function(M) {
              this.rows[this.currRow].moveCursor(M);
            }, setCursor: function(M) {
              n.log("INFO", "setCursor: " + M), this.rows[this.currRow].setCursor(M);
            }, setPAC: function(M) {
              n.log("INFO", "pacData = " + JSON.stringify(M));
              var K = M.row - 1;
              this.nrRollUpRows && K < this.nrRollUpRows - 1 && (K = this.nrRollUpRows - 1), this.currRow = K;
              var ae = this.rows[this.currRow];
              if (M.indent !== null) {
                var j = M.indent, ee = Math.max(j - 1, 0);
                ae.setCursor(M.indent), M.color = ae.chars[ee].penState.foreground;
              }
              var ue = { foreground: M.color, underline: M.underline, italics: M.italics, background: "black", flash: !1 };
              this.setPen(ue);
            }, setBkgData: function(M) {
              n.log("INFO", "bkgData = " + JSON.stringify(M)), this.backSpace(), this.setPen(M), this.insertChar(32);
            }, setRollUpRows: function(M) {
              this.nrRollUpRows = M;
            }, rollUp: function() {
              if (this.nrRollUpRows !== null) {
                n.log("TEXT", this.getDisplayText());
                var M = this.currRow + 1 - this.nrRollUpRows, K = this.rows.splice(M, 1)[0];
                K.clear(), this.rows.splice(this.currRow, 0, K), n.log("INFO", "Rolling up");
              } else n.log("DEBUG", "roll_up but nrRollUpRows not set yet");
            }, getDisplayText: function(M) {
              M = M || !1;
              for (var K = [], ae = "", j = -1, ee = 0; ee < t; ee++) {
                var ue = this.rows[ee].getTextString();
                ue && (j = ee + 1, M ? K.push("Row " + j + ': "' + ue + '"') : K.push(ue.trim()));
              }
              return K.length > 0 && (ae = M ? "[" + K.join(" | ") + "]" : K.join(`
`)), ae;
            }, getTextAndFormat: function() {
              return this.rows;
            } };
            var L = function(M, K) {
              this.chNr = M, this.outputFilter = K, this.mode = null, this.verbose = 0, this.displayedMemory = new B(), this.nonDisplayedMemory = new B(), this.lastOutputScreen = new B(), this.currRollUpRow = this.displayedMemory.rows[14], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null;
            };
            L.prototype = { modes: ["MODE_ROLL-UP", "MODE_POP-ON", "MODE_PAINT-ON", "MODE_TEXT"], reset: function() {
              this.mode = null, this.displayedMemory.reset(), this.nonDisplayedMemory.reset(), this.lastOutputScreen.reset(), this.currRollUpRow = this.displayedMemory.rows[14], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null, this.lastCueEndTime = null;
            }, getHandler: function() {
              return this.outputFilter;
            }, setHandler: function(M) {
              this.outputFilter = M;
            }, setPAC: function(M) {
              this.writeScreen.setPAC(M);
            }, setBkgData: function(M) {
              this.writeScreen.setBkgData(M);
            }, setMode: function(M) {
              M !== this.mode && (this.mode = M, n.log("INFO", "MODE=" + M), this.mode == "MODE_POP-ON" ? this.writeScreen = this.nonDisplayedMemory : (this.writeScreen = this.displayedMemory, this.writeScreen.reset()), this.mode !== "MODE_ROLL-UP" && (this.displayedMemory.nrRollUpRows = null, this.nonDisplayedMemory.nrRollUpRows = null), this.mode = M);
            }, insertChars: function(M) {
              for (var K = 0; K < M.length; K++) this.writeScreen.insertChar(M[K]);
              var ae = this.writeScreen === this.displayedMemory ? "DISP" : "NON_DISP";
              n.log("INFO", ae + ": " + this.writeScreen.getDisplayText(!0)), this.mode !== "MODE_PAINT-ON" && this.mode !== "MODE_ROLL-UP" || (n.log("TEXT", "DISPLAYED: " + this.displayedMemory.getDisplayText(!0)), this.outputDataUpdate());
            }, cc_RCL: function() {
              n.log("INFO", "RCL - Resume Caption Loading"), this.setMode("MODE_POP-ON");
            }, cc_BS: function() {
              n.log("INFO", "BS - BackSpace"), this.mode !== "MODE_TEXT" && (this.writeScreen.backSpace(), this.writeScreen === this.displayedMemory && this.outputDataUpdate());
            }, cc_AOF: function() {
            }, cc_AON: function() {
            }, cc_DER: function() {
              n.log("INFO", "DER- Delete to End of Row"), this.writeScreen.clearToEndOfRow(), this.outputDataUpdate();
            }, cc_RU: function(M) {
              n.log("INFO", "RU(" + M + ") - Roll Up"), this.writeScreen = this.displayedMemory, this.setMode("MODE_ROLL-UP"), this.writeScreen.setRollUpRows(M);
            }, cc_FON: function() {
              n.log("INFO", "FON - Flash On"), this.writeScreen.setPen({ flash: !0 });
            }, cc_RDC: function() {
              n.log("INFO", "RDC - Resume Direct Captioning"), this.setMode("MODE_PAINT-ON");
            }, cc_TR: function() {
              n.log("INFO", "TR"), this.setMode("MODE_TEXT");
            }, cc_RTD: function() {
              n.log("INFO", "RTD"), this.setMode("MODE_TEXT");
            }, cc_EDM: function() {
              n.log("INFO", "EDM - Erase Displayed Memory"), this.displayedMemory.reset(), this.outputDataUpdate();
            }, cc_CR: function() {
              n.log("CR - Carriage Return"), this.writeScreen.rollUp(), this.outputDataUpdate();
            }, cc_ENM: function() {
              n.log("INFO", "ENM - Erase Non-displayed Memory"), this.nonDisplayedMemory.reset();
            }, cc_EOC: function() {
              if (n.log("INFO", "EOC - End Of Caption"), this.mode === "MODE_POP-ON") {
                var M = this.displayedMemory;
                this.displayedMemory = this.nonDisplayedMemory, this.nonDisplayedMemory = M, this.writeScreen = this.nonDisplayedMemory, n.log("TEXT", "DISP: " + this.displayedMemory.getDisplayText());
              }
              this.outputDataUpdate();
            }, cc_TO: function(M) {
              n.log("INFO", "TO(" + M + ") - Tab Offset"), this.writeScreen.moveCursor(M);
            }, cc_MIDROW: function(M) {
              var K = { flash: !1 };
              if (K.underline = M % 2 == 1, K.italics = M >= 46, K.italics) K.foreground = "white";
              else {
                var ae = Math.floor(M / 2) - 16;
                K.foreground = ["white", "green", "blue", "cyan", "red", "yellow", "magenta"][ae];
              }
              n.log("INFO", "MIDROW: " + JSON.stringify(K)), this.writeScreen.setPen(K);
            }, outputDataUpdate: function() {
              var M = n.time;
              M !== null && this.outputFilter && (this.outputFilter.updateData && this.outputFilter.updateData(M, this.displayedMemory), this.cueStartTime !== null || this.displayedMemory.isEmpty() ? this.displayedMemory.equals(this.lastOutputScreen) || (this.outputFilter.newCue && this.outputFilter.newCue(this.cueStartTime, M, this.lastOutputScreen), this.cueStartTime = this.displayedMemory.isEmpty() ? null : M) : this.cueStartTime = M, this.lastOutputScreen.copy(this.displayedMemory));
            }, cueSplitAtTime: function(M) {
              this.outputFilter && (this.displayedMemory.isEmpty() || (this.outputFilter.newCue && this.outputFilter.newCue(this.cueStartTime, M, this.displayedMemory), this.cueStartTime = M));
            } };
            var $ = function(M, K, ae) {
              this.field = M || 1, this.outputs = [K, ae], this.channels = [new L(1, K), new L(2, ae)], this.currChNr = -1, this.lastCmdA = null, this.lastCmdB = null, this.bufferedData = [], this.startTime = null, this.lastTime = null, this.dataCounters = { padding: 0, char: 0, cmd: 0, other: 0 };
            };
            $.prototype = { getHandler: function(M) {
              return this.channels[M].getHandler();
            }, setHandler: function(M, K) {
              this.channels[M].setHandler(K);
            }, addData: function(M, K) {
              var ae, j, ee, ue = !1;
              this.lastTime = M, n.setTime(M);
              for (var Ae = 0; Ae < K.length; Ae += 2) j = 127 & K[Ae], ee = 127 & K[Ae + 1], j >= 16 && j <= 31 && j === this.lastCmdA && ee === this.lastCmdB ? (this.lastCmdA = null, this.lastCmdB = null, n.log("DEBUG", "Repeated command (" + c([j, ee]) + ") is dropped")) : j !== 0 || ee !== 0 ? (n.log("DATA", "[" + c([K[Ae], K[Ae + 1]]) + "] -> (" + c([j, ee]) + ")"), (ae = this.parseCmd(j, ee)) || (ae = this.parseMidrow(j, ee)), ae || (ae = this.parsePAC(j, ee)), ae || (ae = this.parseBackgroundAttributes(j, ee)), ae || (ue = this.parseChars(j, ee)) && (this.currChNr && this.currChNr >= 0 ? this.channels[this.currChNr - 1].insertChars(ue) : n.log("WARNING", "No channel found yet. TEXT-MODE?")), ae ? this.dataCounters.cmd += 2 : ue ? this.dataCounters.char += 2 : (this.dataCounters.other += 2, n.log("WARNING", "Couldn't parse cleaned data " + c([j, ee]) + " orig: " + c([K[Ae], K[Ae + 1]])))) : this.dataCounters.padding += 2;
            }, parseCmd: function(M, K) {
              var ae;
              if (!((M === 20 || M === 21 || M === 28 || M === 29) && 32 <= K && K <= 47 || (M === 23 || M === 31) && 33 <= K && K <= 35)) return !1;
              ae = M === 20 || M === 21 || M === 23 ? 1 : 2;
              var j = this.channels[ae - 1];
              return M === 20 || M === 21 || M === 28 || M === 29 ? K === 32 ? j.cc_RCL() : K === 33 ? j.cc_BS() : K === 34 ? j.cc_AOF() : K === 35 ? j.cc_AON() : K === 36 ? j.cc_DER() : K === 37 ? j.cc_RU(2) : K === 38 ? j.cc_RU(3) : K === 39 ? j.cc_RU(4) : K === 40 ? j.cc_FON() : K === 41 ? j.cc_RDC() : K === 42 ? j.cc_TR() : K === 43 ? j.cc_RTD() : K === 44 ? j.cc_EDM() : K === 45 ? j.cc_CR() : K === 46 ? j.cc_ENM() : K === 47 && j.cc_EOC() : j.cc_TO(K - 32), this.lastCmdA = M, this.lastCmdB = K, this.currChNr = ae, !0;
            }, parseMidrow: function(M, K) {
              var ae = null;
              if ((M === 17 || M === 25) && 32 <= K && K <= 47) {
                if ((ae = M === 17 ? 1 : 2) !== this.currChNr) return n.log("ERROR", "Mismatch channel in midrow parsing"), !1;
                var j = this.channels[ae - 1];
                return j.insertChars([32]), j.cc_MIDROW(K), n.log("DEBUG", "MIDROW (" + c([M, K]) + ")"), this.lastCmdA = M, this.lastCmdB = K, !0;
              }
              return !1;
            }, parsePAC: function(M, K) {
              var ae, j;
              if (!((17 <= M && M <= 23 || 25 <= M && M <= 31) && 64 <= K && K <= 127 || (M === 16 || M === 24) && 64 <= K && K <= 95)) return !1;
              ae = M <= 23 ? 1 : 2, j = 64 <= K && K <= 95 ? ae === 1 ? p[M] : o[M] : ae === 1 ? m[M] : E[M];
              var ee = this.interpretPAC(j, K);
              return this.channels[ae - 1].setPAC(ee), this.lastCmdA = M, this.lastCmdB = K, this.currChNr = ae, !0;
            }, interpretPAC: function(M, K) {
              var ae, j = { color: null, italics: !1, indent: null, underline: !1, row: M };
              return ae = K > 95 ? K - 96 : K - 64, j.underline = (1 & ae) == 1, ae <= 13 ? j.color = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "white"][Math.floor(ae / 2)] : ae <= 15 ? (j.italics = !0, j.color = "white") : j.indent = 4 * Math.floor((ae - 16) / 2), j;
            }, parseChars: function(M, K) {
              var ae = null, j = null, ee = null;
              if (M >= 25 ? (ae = 2, ee = M - 8) : (ae = 1, ee = M), 17 <= ee && ee <= 19) {
                var ue;
                ue = ee === 17 ? K + 80 : ee === 18 ? K + 112 : K + 144, n.log("INFO", "Special char '" + T(ue) + "' in channel " + ae), j = [ue], this.lastCmdA = M, this.lastCmdB = K;
              } else 32 <= M && M <= 127 && (j = K === 0 ? [M] : [M, K], this.lastCmdA = null, this.lastCmdB = null);
              if (j) {
                var Ae = c(j);
                n.log("DEBUG", "Char codes =  " + Ae.join(","));
              }
              return j;
            }, parseBackgroundAttributes: function(M, K) {
              var ae, j, ee;
              return ((M === 16 || M === 24) && 32 <= K && K <= 47 || (M === 23 || M === 31) && 45 <= K && K <= 47) && (ae = {}, M === 16 || M === 24 ? (j = Math.floor((K - 32) / 2), ae.background = h[j], K % 2 == 1 && (ae.background = ae.background + "_semi")) : K === 45 ? ae.background = "transparent" : (ae.foreground = "black", K === 47 && (ae.underline = !0)), ee = M < 24 ? 1 : 2, this.channels[ee - 1].setBkgData(ae), this.lastCmdA = M, this.lastCmdB = K, !0);
            }, reset: function() {
              for (var M = 0; M < this.channels.length; M++) this.channels[M] && this.channels[M].reset();
              this.lastCmdA = null, this.lastCmdB = null;
            }, cueSplitAtTime: function(M) {
              for (var K = 0; K < this.channels.length; K++) this.channels[K] && this.channels[K].cueSplitAtTime(M);
            } }, C.logger = n, C.PenState = d, C.CaptionScreen = B, C.Cea608Parser = $, C.findCea608Nalus = function(M, K, ae) {
              for (var j = 0, ee = K, ue = [], Ae = function(Te, Oe, We, at) {
                if (Te !== 4 || Oe < 8) return null;
                var Se = We.getUint8(at), ke = We.getUint16(at + 1), Rt = We.getUint32(at + 3), _t = We.getUint8(at + 7);
                return Se == 181 && ke == 49 && Rt == 1195456820 && _t == 3;
              }; ee < K + ae; ) {
                if (j = M.getUint32(ee), (31 & M.getUint8(ee + 4)) == 6) for (var Q = ee + 5, Ne = -1; Q < ee + 4 + j - 1; ) {
                  Ne = 0;
                  for (var Ue = 255; Ue === 255; ) Ne += Ue = M.getUint8(Q), Q++;
                  var ze = 0;
                  for (Ue = 255; Ue === 255; ) ze += Ue = M.getUint8(Q), Q++;
                  Ae(Ne, ze, M, Q) && ue.push([Q, ze]), Q += ze;
                }
                ee += j + 4;
              }
              return ue;
            }, C.extractCea608DataFromRange = function(M, K) {
              var ae = K[0], j = [[], []];
              ae += 8;
              var ee = 31 & M.getUint8(ae);
              ae += 2;
              for (var ue = 0; ue < ee; ue++) {
                var Ae = M.getUint8(ae), Q = 4 & Ae, Ne = 3 & Ae;
                ae++;
                var Ue = M.getUint8(ae);
                ae++;
                var ze = M.getUint8(ae);
                ae++, Q && (127 & Ue) + (127 & ze) != 0 && (Ne === 0 ? (j[0].push(Ue), j[0].push(ze)) : Ne === 1 && (j[1].push(Ue), j[1].push(ze)));
              }
              return j;
            };
          })(Ee);
        }, 8416: function(Pe, Ee, C) {
          var ie = C(1139), T = C(5448), t = C(6398), e = C(2032), p = (C(5530), typeof window < "u" && window || C.g), m = p.dashjs;
          m || (m = p.dashjs = {}), m.MediaPlayer = ie.Z, m.FactoryMaker = T.Z, m.Debug = t.Z, m.Version = (0, e.e)();
        }, 6398: function(Pe, Ee, C) {
          var ie = C(5595), T = C(8512), t = C(5448), e = 1, p = 2, m = 3, o = 4, E = 5;
          function h(c) {
            c = c || {};
            var d, S, x, B, L = this.context, $ = (0, ie.Z)(L).getInstance(), M = c.settings, K = [];
            function ae(Ue) {
              return Ue && Ue.bind ? Ue.bind(window.console) : window.console.log.bind(window.console);
            }
            function j() {
              for (var Ue = arguments.length, ze = new Array(Ue), Te = 0; Te < Ue; Te++) ze[Te] = arguments[Te];
              Ne.apply(void 0, [e, this].concat(ze));
            }
            function ee() {
              for (var Ue = arguments.length, ze = new Array(Ue), Te = 0; Te < Ue; Te++) ze[Te] = arguments[Te];
              Ne.apply(void 0, [p, this].concat(ze));
            }
            function ue() {
              for (var Ue = arguments.length, ze = new Array(Ue), Te = 0; Te < Ue; Te++) ze[Te] = arguments[Te];
              Ne.apply(void 0, [m, this].concat(ze));
            }
            function Ae() {
              for (var Ue = arguments.length, ze = new Array(Ue), Te = 0; Te < Ue; Te++) ze[Te] = arguments[Te];
              Ne.apply(void 0, [o, this].concat(ze));
            }
            function Q() {
              for (var Ue = arguments.length, ze = new Array(Ue), Te = 0; Te < Ue; Te++) ze[Te] = arguments[Te];
              Ne.apply(void 0, [E, this].concat(ze));
            }
            function Ne(Ue, ze) {
              var Te = "", Oe = null;
              S && (Oe = (/* @__PURE__ */ new Date()).getTime(), Te += "[" + (Oe - B) + "]"), x && ze && ze.getClassName && (Te += "[" + ze.getClassName() + "]", ze.getType && (Te += "[" + ze.getType() + "]")), Te.length > 0 && (Te += " ");
              for (var We = arguments.length, at = new Array(We > 2 ? We - 2 : 0), Se = 2; Se < We; Se++) at[Se - 2] = arguments[Se];
              Array.apply(null, at).forEach(function(ke) {
                Te += ke + " ";
              }), K[Ue] && M && M.get().debug.logLevel >= Ue && K[Ue](Te), M && M.get().debug.dispatchEvent && $.trigger(T.Z.LOG, { message: Te, level: Ue });
            }
            return d = { getLogger: function(Ue) {
              return { fatal: j.bind(Ue), error: ee.bind(Ue), warn: ue.bind(Ue), info: Ae.bind(Ue), debug: Q.bind(Ue) };
            }, setLogTimestampVisible: function(Ue) {
              S = Ue;
            }, setCalleeNameVisible: function(Ue) {
              x = Ue;
            } }, S = !0, x = !0, B = (/* @__PURE__ */ new Date()).getTime(), typeof window < "u" && window.console && (K[e] = ae(window.console.error), K[p] = ae(window.console.error), K[m] = ae(window.console.warn), K[o] = ae(window.console.info), K[E] = ae(window.console.debug)), d;
          }
          h.__dashjs_factory_name = "Debug";
          var n = t.Z.getSingletonFactory(h);
          n.LOG_LEVEL_NONE = 0, n.LOG_LEVEL_FATAL = e, n.LOG_LEVEL_ERROR = p, n.LOG_LEVEL_WARNING = m, n.LOG_LEVEL_INFO = o, n.LOG_LEVEL_DEBUG = E, t.Z.updateSingletonFactory(h.__dashjs_factory_name, n), Ee.Z = n;
        }, 5595: function(Pe, Ee, C) {
          var ie = C(5448), T = C(8825);
          function t() {
            var p = {};
            function m(E, h, n) {
              var c = -1;
              return p[E] && p[E].some(function(d, S) {
                if (d && d.callback === h && (!n || n === d.scope)) return c = S, !0;
              }), c;
            }
            var o = { on: function(E, h, n) {
              var c = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
              if (!E) throw new Error("event type cannot be null or undefined");
              if (!h || typeof h != "function") throw new Error("listener must be a function: " + h);
              var d = c.priority || 0;
              if (!(m(E, h, n) >= 0)) {
                p[E] = p[E] || [];
                var S = { callback: h, scope: n, priority: d };
                n && n.getStreamId && (S.streamId = n.getStreamId()), n && n.getType && (S.mediaType = n.getType()), c && c.mode && (S.mode = c.mode);
                var x = p[E].some(function(B, L) {
                  if (B && d > B.priority) return p[E].splice(L, 0, S), !0;
                });
                x || p[E].push(S);
              }
            }, off: function(E, h, n) {
              if (E && h && p[E]) {
                var c = m(E, h, n);
                c < 0 || (p[E][c] = null);
              }
            }, trigger: function(E) {
              var h = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
              if (E && p[E]) {
                if ((h = h || {}).hasOwnProperty("type")) throw new Error("'type' is a reserved word for event dispatching");
                h.type = E, n.streamId && (h.streamId = n.streamId), n.mediaType && (h.mediaType = n.mediaType), p[E].filter(function(c) {
                  return !(!c || n.streamId && c.streamId && c.streamId !== n.streamId || n.mediaType && c.mediaType && c.mediaType !== n.mediaType || n.mode && c.mode && c.mode !== n.mode || !c.mode && n.mode && n.mode === T.Z.EVENT_MODE_ON_RECEIVE);
                }).forEach(function(c) {
                  return c && c.callback.call(c.scope, h);
                });
              }
            }, reset: function() {
              p = {};
            } };
            return o;
          }
          t.__dashjs_factory_name = "EventBus";
          var e = ie.Z.getSingletonFactory(t);
          e.EVENT_PRIORITY_LOW = 0, e.EVENT_PRIORITY_HIGH = 5e3, ie.Z.updateSingletonFactory(t.__dashjs_factory_name, e), Ee.Z = e;
        }, 5448: function(Pe, Ee) {
          var C = function() {
            var ie, T = [], t = {}, e = {};
            function p(h, n) {
              for (var c in T) {
                var d = T[c];
                if (d.context === h && d.name === n) return d.instance;
              }
              return null;
            }
            function m(h, n) {
              return n[h];
            }
            function o(h, n, c) {
              h in c && (c[h] = n);
            }
            function E(h, n, c) {
              var d, S = h.__dashjs_factory_name, x = n[S];
              if (x) {
                var B = x.instance;
                if (!x.override) return B.apply({ context: n, factory: ie }, c);
                for (var L in d = h.apply({ context: n }, c), B = B.apply({ context: n, factory: ie, parent: d }, c)) d.hasOwnProperty(L) && (d[L] = B[L]);
              } else d = h.apply({ context: n }, c);
              return d.getClassName = function() {
                return S;
              }, d;
            }
            return ie = { extend: function(h, n, c, d) {
              !d[h] && n && (d[h] = { instance: n, override: c });
            }, getSingletonInstance: p, setSingletonInstance: function(h, n, c) {
              for (var d in T) {
                var S = T[d];
                if (S.context === h && S.name === n) return void (T[d].instance = c);
              }
              T.push({ name: n, context: h, instance: c });
            }, deleteSingletonInstances: function(h) {
              T = T.filter(function(n) {
                return n.context !== h;
              });
            }, getSingletonFactory: function(h) {
              var n = m(h.__dashjs_factory_name, t);
              return n || (n = function(c) {
                var d;
                return c === void 0 && (c = {}), { getInstance: function() {
                  return d || (d = p(c, h.__dashjs_factory_name)), d || (d = E(h, c, arguments), T.push({ name: h.__dashjs_factory_name, context: c, instance: d })), d;
                } };
              }, t[h.__dashjs_factory_name] = n), n;
            }, getSingletonFactoryByName: function(h) {
              return m(h, t);
            }, updateSingletonFactory: function(h, n) {
              o(h, n, t);
            }, getClassFactory: function(h) {
              var n = m(h.__dashjs_factory_name, e);
              return n || (n = function(c) {
                return c === void 0 && (c = {}), { create: function() {
                  return E(h, c, arguments);
                } };
              }, e[h.__dashjs_factory_name] = n), n;
            }, getClassFactoryByName: function(h) {
              return m(h, e);
            }, updateClassFactory: function(h, n) {
              o(h, n, e);
            } }, ie;
          }();
          Ee.Z = C;
        }, 1264: function(Pe, Ee, C) {
          var ie = C(5448), T = C(703), t = C(6398), e = C(3393), p = C(7855), m = C(5595), o = C(8512);
          function E(d) {
            return E = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(S) {
              return typeof S;
            } : function(S) {
              return S && typeof Symbol == "function" && S.constructor === Symbol && S !== Symbol.prototype ? "symbol" : typeof S;
            }, E(d);
          }
          function h(d, S, x) {
            return S in d ? Object.defineProperty(d, S, { value: x, enumerable: !0, configurable: !0, writable: !0 }) : d[S] = x, d;
          }
          function n() {
            var d, S, x = this.context, B = (0, m.Z)(x).getInstance(), L = { "streaming.delay.liveDelay": o.Z.SETTING_UPDATED_LIVE_DELAY, "streaming.delay.liveDelayFragmentCount": o.Z.SETTING_UPDATED_LIVE_DELAY_FRAGMENT_COUNT, "streaming.liveCatchup.enabled": o.Z.SETTING_UPDATED_CATCHUP_ENABLED, "streaming.liveCatchup.playbackRate.min": o.Z.SETTING_UPDATED_PLAYBACK_RATE_MIN, "streaming.liveCatchup.playbackRate.max": o.Z.SETTING_UPDATED_PLAYBACK_RATE_MAX }, $ = { debug: { logLevel: t.Z.LOG_LEVEL_WARNING, dispatchEvent: !1 }, streaming: { abandonLoadTimeout: 1e4, wallclockTimeUpdateInterval: 100, manifestUpdateRetryInterval: 100, liveUpdateTimeThresholdInMilliseconds: 0, cacheInitSegments: !1, applyServiceDescription: !0, applyProducerReferenceTime: !0, applyContentSteering: !0, eventControllerRefreshDelay: 100, enableManifestDurationMismatchFix: !0, parseInbandPrft: !1, enableManifestTimescaleMismatchFix: !1, capabilities: { filterUnsupportedEssentialProperties: !0, useMediaCapabilitiesApi: !1 }, timeShiftBuffer: { calcFromSegmentTimeline: !1, fallbackToSegmentTimeline: !0 }, metrics: { maxListDepth: 100 }, delay: { liveDelayFragmentCount: NaN, liveDelay: NaN, useSuggestedPresentationDelay: !0 }, protection: { keepProtectionMediaKeys: !1, ignoreEmeEncryptedEvent: !1, detectPlayreadyMessageFormat: !0 }, buffer: { enableSeekDecorrelationFix: !1, fastSwitchEnabled: !0, flushBufferAtTrackSwitch: !1, reuseExistingSourceBuffers: !0, bufferPruningInterval: 10, bufferToKeep: 20, bufferTimeAtTopQuality: 30, bufferTimeAtTopQualityLongForm: 60, initialBufferLevel: NaN, stableBufferTime: 12, longFormContentDurationThreshold: 600, stallThreshold: 0.3, useAppendWindow: !0, setStallState: !0, avoidCurrentTimeRangePruning: !1, useChangeTypeForTrackSwitch: !0, mediaSourceDurationInfinity: !0, resetSourceBuffersForTrackSwitch: !1 }, gaps: { jumpGaps: !0, jumpLargeGaps: !0, smallGapLimit: 1.5, threshold: 0.3, enableSeekFix: !0, enableStallFix: !1, stallSeek: 0.1 }, utcSynchronization: { enabled: !0, useManifestDateHeaderTimeSource: !0, backgroundAttempts: 2, timeBetweenSyncAttempts: 30, maximumTimeBetweenSyncAttempts: 600, minimumTimeBetweenSyncAttempts: 2, timeBetweenSyncAttemptsAdjustmentFactor: 2, maximumAllowedDrift: 100, enableBackgroundSyncAfterSegmentDownloadError: !0, defaultTimingSource: { scheme: "urn:mpeg:dash:utc:http-xsdate:2014", value: "https://time.akamai.com/?iso&ms" } }, scheduling: { defaultTimeout: 500, lowLatencyTimeout: 0, scheduleWhilePaused: !0 }, text: { defaultEnabled: !0, dispatchForManualRendering: !1, extendSegmentedCues: !0, imsc: { displayForcedOnlyMode: !1, enableRollUp: !0 }, webvtt: { customRenderingEnabled: !1 } }, liveCatchup: { maxDrift: NaN, playbackRate: { min: NaN, max: NaN }, playbackBufferMin: 0.5, enabled: null, mode: e.Z.LIVE_CATCHUP_MODE_DEFAULT }, lastBitrateCachingInfo: { enabled: !0, ttl: 36e4 }, lastMediaSettingsCachingInfo: { enabled: !0, ttl: 36e4 }, saveLastMediaSettingsForCurrentStreamingSession: !0, cacheLoadThresholds: { video: 50, audio: 5 }, trackSwitchMode: { audio: e.Z.TRACK_SWITCH_MODE_ALWAYS_REPLACE, video: e.Z.TRACK_SWITCH_MODE_NEVER_REPLACE }, selectionModeForInitialTrack: e.Z.TRACK_SELECTION_MODE_HIGHEST_SELECTION_PRIORITY, fragmentRequestTimeout: 2e4, fragmentRequestProgressTimeout: -1, manifestRequestTimeout: 1e4, retryIntervals: (d = {}, h(d, p.w.MPD_TYPE, 500), h(d, p.w.XLINK_EXPANSION_TYPE, 500), h(d, p.w.MEDIA_SEGMENT_TYPE, 1e3), h(d, p.w.INIT_SEGMENT_TYPE, 1e3), h(d, p.w.BITSTREAM_SWITCHING_SEGMENT_TYPE, 1e3), h(d, p.w.INDEX_SEGMENT_TYPE, 1e3), h(d, p.w.MSS_FRAGMENT_INFO_SEGMENT_TYPE, 1e3), h(d, p.w.LICENSE, 1e3), h(d, p.w.OTHER_TYPE, 1e3), h(d, "lowLatencyReductionFactor", 10), d), retryAttempts: (S = {}, h(S, p.w.MPD_TYPE, 3), h(S, p.w.XLINK_EXPANSION_TYPE, 1), h(S, p.w.MEDIA_SEGMENT_TYPE, 3), h(S, p.w.INIT_SEGMENT_TYPE, 3), h(S, p.w.BITSTREAM_SWITCHING_SEGMENT_TYPE, 3), h(S, p.w.INDEX_SEGMENT_TYPE, 3), h(S, p.w.MSS_FRAGMENT_INFO_SEGMENT_TYPE, 3), h(S, p.w.LICENSE, 3), h(S, p.w.OTHER_TYPE, 3), h(S, "lowLatencyMultiplyFactor", 5), S), abr: { movingAverageMethod: e.Z.MOVING_AVERAGE_SLIDING_WINDOW, ABRStrategy: e.Z.ABR_STRATEGY_DYNAMIC, additionalAbrRules: { insufficientBufferRule: !0, switchHistoryRule: !0, droppedFramesRule: !0, abandonRequestsRule: !0 }, abrRulesParameters: { abandonRequestsRule: { graceTimeThreshold: 500, abandonMultiplier: 1.8, minLengthToAverage: 5 } }, bandwidthSafetyFactor: 0.9, useDefaultABRRules: !0, useDeadTimeLatency: !0, limitBitrateByPortal: !1, usePixelRatioInLimitBitrateByPortal: !1, maxBitrate: { audio: -1, video: -1 }, minBitrate: { audio: -1, video: -1 }, maxRepresentationRatio: { audio: 1, video: 1 }, initialBitrate: { audio: -1, video: -1 }, initialRepresentationRatio: { audio: -1, video: -1 }, autoSwitchBitrate: { audio: !0, video: !0 }, fetchThroughputCalculationMode: e.Z.ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING }, cmcd: { enabled: !1, sid: null, cid: null, rtp: null, rtpSafetyFactor: 5, mode: e.Z.CMCD_MODE_QUERY, enabledKeys: ["br", "d", "ot", "tb", "bl", "dl", "mtp", "nor", "nrr", "su", "bs", "rtp", "cid", "pr", "sf", "sid", "st", "v"] }, cmsd: { enabled: !1, abr: { applyMb: !1, etpWeightRatio: 0 } } }, errors: { recoverAttempts: { mediaErrorDecode: 5 } } }, M = T.Z.clone($);
            function K(ae, j, ee) {
              for (var ue in ae) ae.hasOwnProperty(ue) && (j.hasOwnProperty(ue) ? E(ae[ue]) !== "object" || ae[ue] instanceof Array || ae[ue] === null ? (j[ue] = T.Z.clone(ae[ue]), L[ee + ue] && B.trigger(L[ee + ue])) : K(ae[ue], j[ue], ee.slice() + ue + ".") : console.error("Settings parameter " + ee + ue + " is not supported"));
            }
            return { get: function() {
              return M;
            }, update: function(ae) {
              E(ae) === "object" && K(ae, M, "");
            }, reset: function() {
              M = T.Z.clone($);
            } };
          }
          n.__dashjs_factory_name = "Settings";
          var c = ie.Z.getSingletonFactory(n);
          Ee.Z = c;
        }, 703: function(Pe, Ee, C) {
          var ie = C(3875), T = C.n(ie), t = C(1067);
          function e(o) {
            return e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(E) {
              return typeof E;
            } : function(E) {
              return E && typeof Symbol == "function" && E.constructor === Symbol && E !== Symbol.prototype ? "symbol" : typeof E;
            }, e(o);
          }
          function p(o, E) {
            for (var h = 0; h < E.length; h++) {
              var n = E[h];
              n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(o, n.key, n);
            }
          }
          var m = function() {
            function o() {
              (function(n, c) {
                if (!(n instanceof c)) throw new TypeError("Cannot call a class as a function");
              })(this, o);
            }
            var E, h;
            return E = o, h = [{ key: "mixin", value: function(n, c, d) {
              var S, x = {};
              if (n) for (var B in c) c.hasOwnProperty(B) && (S = c[B], B in n && (n[B] === S || B in x && x[B] === S) || (e(n[B]) === "object" && n[B] !== null ? n[B] = o.mixin(n[B], S, d) : n[B] = d(S)));
              return n;
            } }, { key: "clone", value: function(n) {
              if (!n || e(n) !== "object") return n;
              var c;
              if (n instanceof Array) {
                c = [];
                for (var d = 0, S = n.length; d < S; ++d) d in n && c.push(o.clone(n[d]));
              } else c = {};
              return o.mixin(c, n, o.clone);
            } }, { key: "addAditionalQueryParameterToUrl", value: function(n, c) {
              try {
                if (!c || c.length === 0) return n;
                var d = new URL(n);
                return c.forEach(function(S) {
                  S.key && S.value && d.searchParams.set(S.key, S.value);
                }), d.href;
              } catch {
                return n;
              }
            } }, { key: "parseHttpHeaders", value: function(n) {
              var c = {};
              if (!n) return c;
              for (var d = n.trim().split(`\r
`), S = 0, x = d.length; S < x; S++) {
                var B = d[S], L = B.indexOf(": ");
                L > 0 && (c[B.substring(0, L)] = B.substring(L + 2));
              }
              return c;
            } }, { key: "generateUuid", value: function() {
              var n = (/* @__PURE__ */ new Date()).getTime();
              return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
                var d = (n + 16 * Math.random()) % 16 | 0;
                return n = Math.floor(n / 16), (c == "x" ? d : 3 & d | 8).toString(16);
              });
            } }, { key: "generateHashCode", value: function(n) {
              var c = 0;
              if (n.length === 0) return c;
              for (var d = 0; d < n.length; d++) c = (c << 5) - c + n.charCodeAt(d), c |= 0;
              return c;
            } }, { key: "getRelativeUrl", value: function(n, c) {
              try {
                var d = new URL(n), S = new URL(c);
                if (d.protocol = S.protocol, d.origin !== S.origin) return c;
                var x = T().relative(d.pathname.substr(0, d.pathname.lastIndexOf("/")), S.pathname.substr(0, S.pathname.lastIndexOf("/"))), B = x.length === 0 ? 1 : 0;
                return x += S.pathname.substr(S.pathname.lastIndexOf("/") + B, S.pathname.length - 1), S.pathname.length < x.length ? S.pathname : x;
              } catch {
                return c;
              }
            } }, { key: "parseUserAgent", value: function() {
              var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
              try {
                var c = n === null && typeof navigator < "u" ? navigator.userAgent.toLowerCase() : "";
                return (0, t.UAParser)(c);
              } catch {
                return {};
              }
            } }, { key: "stringHasProtocol", value: function(n) {
              return /(http(s?)):\/\//i.test(n);
            } }], h && p(E, h), o;
          }();
          Ee.Z = m;
        }, 2032: function(Pe, Ee, C) {
          function ie() {
            return "4.7.4";
          }
          C.d(Ee, { e: function() {
            return ie;
          } });
        }, 2230: function(Pe, Ee) {
          function C(T, t) {
            for (var e = 0; e < t.length; e++) {
              var p = t[e];
              p.enumerable = p.enumerable || !1, p.configurable = !0, "value" in p && (p.writable = !0), Object.defineProperty(T, p.key, p);
            }
          }
          var ie = function() {
            function T() {
              (function(p, m) {
                if (!(p instanceof m)) throw new TypeError("Cannot call a class as a function");
              })(this, T);
            }
            var t, e;
            return t = T, (e = [{ key: "extend", value: function(p, m) {
              if (p) {
                var o = !!m && m.override, E = !!m && m.publicOnly;
                for (var h in p) !p.hasOwnProperty(h) || this[h] && !o || E && p[h].indexOf("public_") === -1 || (this[h] = p[h]);
              }
            } }]) && C(t.prototype, e), T;
          }();
          Ee.Z = ie;
        }, 4351: function(Pe, Ee, C) {
          function ie(m) {
            return ie = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
              return typeof o;
            } : function(o) {
              return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
            }, ie(m);
          }
          function T(m, o) {
            return T = Object.setPrototypeOf || function(E, h) {
              return E.__proto__ = h, E;
            }, T(m, o);
          }
          function t(m, o) {
            return !o || ie(o) !== "object" && typeof o != "function" ? function(E) {
              if (E === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return E;
            }(m) : o;
          }
          function e(m) {
            return e = Object.setPrototypeOf ? Object.getPrototypeOf : function(o) {
              return o.__proto__ || Object.getPrototypeOf(o);
            }, e(m);
          }
          var p = function(m) {
            (function(c, d) {
              if (typeof d != "function" && d !== null) throw new TypeError("Super expression must either be null or a function");
              c.prototype = Object.create(d && d.prototype, { constructor: { value: c, writable: !0, configurable: !0 } }), d && T(c, d);
            })(n, m);
            var o, E, h = (o = n, E = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var c, d = e(o);
              if (E) {
                var S = e(this).constructor;
                c = Reflect.construct(d, arguments, S);
              } else c = d.apply(this, arguments);
              return t(this, c);
            });
            function n() {
              var c;
              return function(d, S) {
                if (!(d instanceof S)) throw new TypeError("Cannot call a class as a function");
              }(this, n), (c = h.call(this)).ATTEMPT_BACKGROUND_SYNC = "attemptBackgroundSync", c.BUFFERING_COMPLETED = "bufferingCompleted", c.BUFFER_CLEARED = "bufferCleared", c.BYTES_APPENDED_END_FRAGMENT = "bytesAppendedEndFragment", c.BUFFER_REPLACEMENT_STARTED = "bufferReplacementStarted", c.CHECK_FOR_EXISTENCE_COMPLETED = "checkForExistenceCompleted", c.CMSD_STATIC_HEADER = "cmsdStaticHeader", c.CURRENT_TRACK_CHANGED = "currentTrackChanged", c.DATA_UPDATE_COMPLETED = "dataUpdateCompleted", c.INBAND_EVENTS = "inbandEvents", c.INITIAL_STREAM_SWITCH = "initialStreamSwitch", c.INIT_FRAGMENT_LOADED = "initFragmentLoaded", c.INIT_FRAGMENT_NEEDED = "initFragmentNeeded", c.INTERNAL_MANIFEST_LOADED = "internalManifestLoaded", c.ORIGINAL_MANIFEST_LOADED = "originalManifestLoaded", c.LOADING_COMPLETED = "loadingCompleted", c.LOADING_PROGRESS = "loadingProgress", c.LOADING_DATA_PROGRESS = "loadingDataProgress", c.LOADING_ABANDONED = "loadingAborted", c.MANIFEST_UPDATED = "manifestUpdated", c.MEDIA_FRAGMENT_LOADED = "mediaFragmentLoaded", c.MEDIA_FRAGMENT_NEEDED = "mediaFragmentNeeded", c.QUOTA_EXCEEDED = "quotaExceeded", c.SEGMENT_LOCATION_BLACKLIST_ADD = "segmentLocationBlacklistAdd", c.SEGMENT_LOCATION_BLACKLIST_CHANGED = "segmentLocationBlacklistChanged", c.SERVICE_LOCATION_BASE_URL_BLACKLIST_ADD = "serviceLocationBlacklistAdd", c.SERVICE_LOCATION_BASE_URL_BLACKLIST_CHANGED = "serviceLocationBlacklistChanged", c.SERVICE_LOCATION_LOCATION_BLACKLIST_ADD = "serviceLocationLocationBlacklistAdd", c.SERVICE_LOCATION_LOCATION_BLACKLIST_CHANGED = "serviceLocationLocationBlacklistChanged", c.SET_FRAGMENTED_TEXT_AFTER_DISABLED = "setFragmentedTextAfterDisabled", c.SET_NON_FRAGMENTED_TEXT = "setNonFragmentedText", c.SOURCE_BUFFER_ERROR = "sourceBufferError", c.STREAMS_COMPOSED = "streamsComposed", c.STREAM_BUFFERING_COMPLETED = "streamBufferingCompleted", c.STREAM_REQUESTING_COMPLETED = "streamRequestingCompleted", c.TEXT_TRACKS_QUEUE_INITIALIZED = "textTracksQueueInitialized", c.TIME_SYNCHRONIZATION_COMPLETED = "timeSynchronizationComplete", c.UPDATE_TIME_SYNC_OFFSET = "updateTimeSyncOffset", c.URL_RESOLUTION_FAILED = "urlResolutionFailed", c.VIDEO_CHUNK_RECEIVED = "videoChunkReceived", c.WALLCLOCK_TIME_UPDATED = "wallclockTimeUpdated", c.XLINK_ELEMENT_LOADED = "xlinkElementLoaded", c.XLINK_READY = "xlinkReady", c.SEEK_TARGET = "seekTarget", c.SETTING_UPDATED_LIVE_DELAY = "settingUpdatedLiveDelay", c.SETTING_UPDATED_LIVE_DELAY_FRAGMENT_COUNT = "settingUpdatedLiveDelayFragmentCount", c.SETTING_UPDATED_CATCHUP_ENABLED = "settingUpdatedCatchupEnabled", c.SETTING_UPDATED_PLAYBACK_RATE_MIN = "settingUpdatedPlaybackRateMin", c.SETTING_UPDATED_PLAYBACK_RATE_MAX = "settingUpdatedPlaybackRateMax", c;
            }
            return n;
          }(C(8342).Z);
          Ee.Z = p;
        }, 8512: function(Pe, Ee, C) {
          function ie(E) {
            return ie = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(h) {
              return typeof h;
            } : function(h) {
              return h && typeof Symbol == "function" && h.constructor === Symbol && h !== Symbol.prototype ? "symbol" : typeof h;
            }, ie(E);
          }
          function T(E, h) {
            if (!(E instanceof h)) throw new TypeError("Cannot call a class as a function");
          }
          function t(E, h) {
            return t = Object.setPrototypeOf || function(n, c) {
              return n.__proto__ = c, n;
            }, t(E, h);
          }
          function e(E, h) {
            return !h || ie(h) !== "object" && typeof h != "function" ? function(n) {
              if (n === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return n;
            }(E) : h;
          }
          function p(E) {
            return p = Object.setPrototypeOf ? Object.getPrototypeOf : function(h) {
              return h.__proto__ || Object.getPrototypeOf(h);
            }, p(E);
          }
          var m = function(E) {
            (function(S, x) {
              if (typeof x != "function" && x !== null) throw new TypeError("Super expression must either be null or a function");
              S.prototype = Object.create(x && x.prototype, { constructor: { value: S, writable: !0, configurable: !0 } }), x && t(S, x);
            })(d, E);
            var h, n, c = (h = d, n = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var S, x = p(h);
              if (n) {
                var B = p(this).constructor;
                S = Reflect.construct(x, arguments, B);
              } else S = x.apply(this, arguments);
              return e(this, S);
            });
            function d() {
              return T(this, d), c.apply(this, arguments);
            }
            return d;
          }(C(4351).Z), o = new m();
          Ee.Z = o;
        }, 8342: function(Pe, Ee) {
          function C(T, t) {
            for (var e = 0; e < t.length; e++) {
              var p = t[e];
              p.enumerable = p.enumerable || !1, p.configurable = !0, "value" in p && (p.writable = !0), Object.defineProperty(T, p.key, p);
            }
          }
          var ie = function() {
            function T() {
              (function(p, m) {
                if (!(p instanceof m)) throw new TypeError("Cannot call a class as a function");
              })(this, T);
            }
            var t, e;
            return t = T, (e = [{ key: "extend", value: function(p, m) {
              if (p) {
                var o = !!m && m.override, E = !!m && m.publicOnly;
                for (var h in p) !p.hasOwnProperty(h) || this[h] && !o || E && p[h].indexOf("public_") === -1 || (this[h] = p[h]);
              }
            } }]) && C(t.prototype, e), T;
          }();
          Ee.Z = ie;
        }, 9326: function(Pe, Ee, C) {
          var ie = C(3186), T = C(7855), t = C(5448), e = C(8825), p = C(7387), m = C(1553);
          function o(E) {
            var h, n, c, d, S, x = (E = E || {}).eventBus, B = E.debug, L = E.urlUtils, $ = E.type, M = E.streamInfo, K = E.segmentsController, ae = E.timelineConverter, j = E.baseURLController;
            function ee() {
              return $;
            }
            function ue() {
              c = null;
            }
            function Ae(Te, Oe, We) {
              var at, Se, ke = j.resolve(We.path), Rt = {};
              return ke && Oe !== ke.url && L.isRelative(Oe) ? (at = ke.url, Se = ke.serviceLocation, Rt = ke.queryParams, Oe && (at = L.resolve(Oe, at))) : at = Oe, !L.isRelative(at) && (Te.url = at, Te.serviceLocation = Se, Te.queryParams = Rt, !0);
            }
            function Q(Te, Oe) {
              if (Oe == null) return null;
              var We = new ie.Z(), at = Oe.representation, Se = at.adaptation.period.mpd.manifest.Period_asArray[at.adaptation.period.index].AdaptationSet_asArray[at.adaptation.index].Representation_asArray[at.index].bandwidth, ke = Oe.media;
              return ke = (0, p.vi)(ke, "Number", Oe.replacementNumber), ke = (0, p.vi)(ke, "Time", Oe.replacementTime), ke = (0, p.vi)(ke, "Bandwidth", Se), ke = (0, p.Aj)(ke, at.id), ke = (0, p.eR)(ke), We.mediaType = ee(), We.type = T.w.MEDIA_SEGMENT_TYPE, We.range = Oe.mediaRange, We.startTime = Oe.presentationStartTime, We.mediaStartTime = Oe.mediaStartTime, We.duration = Oe.duration, We.timescale = at.timescale, We.availabilityStartTime = Oe.availabilityStartTime, We.availabilityEndTime = Oe.availabilityEndTime, We.availabilityTimeComplete = at.availabilityTimeComplete, We.wallStartTime = Oe.wallStartTime, We.quality = at.index, We.index = Oe.index, We.mediaInfo = Te, We.adaptationIndex = at.adaptation.index, We.representationId = at.id, Ae(We, ke, at) ? We : void 0;
            }
            function Ne(Te, Oe, We) {
              var at = null;
              if (!Oe || !Oe.segmentInfoType) return at;
              var Se = K.getSegmentByTime(Oe, We);
              return Se && (c = Se, n.debug("Index for time " + We + " is " + Se.index), at = Q(Te, Se)), at;
            }
            function Ue(Te, Oe, We) {
              var at = null, Se = K.getSegmentByIndex(Oe, We, c ? c.mediaStartTime : -1);
              if (Se) at = Q(Te, Se), c = Se;
              else {
                if (d && !S) return n.debug(ee() + " No segment found at index: " + We + ". Wait for next loop"), null;
                S = !0;
              }
              return at;
            }
            function ze() {
              n.debug("Dynamic stream complete"), S = !0;
            }
            return h = { getCurrentIndex: function() {
              return c ? c.index : -1;
            }, getInitRequest: function(Te, Oe) {
              return Oe ? function(We, at, Se) {
                var ke = new ie.Z(), Rt = at.adaptation.period, _t = Rt.start;
                if (ke.mediaType = Se, ke.type = T.w.INIT_SEGMENT_TYPE, ke.range = at.range, ke.availabilityStartTime = ae.calcAvailabilityStartTimeFromPresentationTime(_t, at, d), ke.availabilityEndTime = ae.calcAvailabilityEndTimeFromPresentationTime(_t + Rt.duration, at, d), ke.quality = at.index, ke.mediaInfo = We, ke.representationId = at.id, Ae(ke, at.initialization, at)) return ke.url = (0, p.vi)(ke.url, "Bandwidth", at.bandwidth), ke;
              }(Te, Oe, ee()) : null;
            }, getNextSegmentRequest: function(Te, Oe) {
              return Oe && Oe.segmentInfoType ? Ue(Te, Oe, c ? c.index + 1 : 0) : null;
            }, getNextSegmentRequestIdempotent: function(Te, Oe) {
              var We = c ? c.index + 1 : 0, at = K.getSegmentByIndex(Oe, We, c ? c.mediaStartTime : -1);
              return at ? Q(Te, at) : null;
            }, getSegmentRequestForTime: Ne, getStreamId: function() {
              return M.id;
            }, getStreamInfo: function() {
              return M;
            }, getType: ee, getValidTimeAheadOfTargetTime: function(Te, Oe, We, at) {
              try {
                if (isNaN(Te) || !Oe || !We) return NaN;
                if (Te < 0 && (Te = 0), isNaN(at) && (at = 0.5), Ne(Oe, We, Te)) return Te;
                if (We.adaptation.period.start + We.adaptation.period.duration < Te) return NaN;
                for (var Se = isFinite(We.adaptation.period.duration) ? We.adaptation.period.start + We.adaptation.period.duration : Te + 30, ke = Math.min(Te + at, Se), Rt = NaN, _t = null; ke <= Se; ) {
                  var qe = null;
                  if (ke <= Se && (qe = Ne(Oe, We, ke)), qe) {
                    Rt = ke, _t = qe;
                    break;
                  }
                  ke += at;
                }
                if (_t) {
                  var it = _t.startTime + _t.duration;
                  return Te > _t.startTime && it - Te > at ? Te : !isNaN(_t.startTime) && Te < _t.startTime && Rt > _t.startTime ? _t.startTime + 1e-3 : Math.min(it - at, Rt);
                }
                return Rt;
              } catch {
                return NaN;
              }
            }, initialize: function(Te) {
              d = Te, S = !1, K.initialize(Te);
            }, isLastSegmentRequested: function(Te, Oe) {
              return !Te || !c ? !1 : S ? !0 : !isFinite(Te.adaptation.period.duration) || c.presentationStartTime + c.duration > Oe ? !1 : Te.mediaFinishedInformation && !isNaN(Te.mediaFinishedInformation.numberOfSegments) && !isNaN(c.index) && c.index >= Te.mediaFinishedInformation.numberOfSegments - 1 && (!d || Te.segmentInfoType === m.Z.SEGMENT_TEMPLATE || d && Te.segmentInfoType === m.Z.SEGMENT_LIST && Te.adaptation.period.nextPeriodId) ? !0 : !!(d && Te.adaptation.period.nextPeriodId && Te.segmentInfoType === m.Z.SEGMENT_TIMELINE && Te.mediaFinishedInformation && !isNaN(Te.mediaFinishedInformation.mediaTimeOfLastSignaledSegment) && c && !isNaN(c.mediaStartTime) && !isNaN(c.duration) && c.mediaStartTime + c.duration >= Te.mediaFinishedInformation.mediaTimeOfLastSignaledSegment - 0.05);
            }, repeatSegmentRequest: function(Te, Oe) {
              return Oe && Oe.segmentInfoType ? Ue(Te, Oe, c ? c.index : 0) : null;
            }, reset: function() {
              ue(), x.off(e.Z.DYNAMIC_TO_STATIC, ze, h);
            } }, n = B.getLogger(h), ue(), x.on(e.Z.DYNAMIC_TO_STATIC, ze, h), h;
          }
          o.__dashjs_factory_name = "DashHandler", Ee.Z = t.Z.getClassFactory(o);
        }, 1553: function(Pe, Ee) {
          function C(T, t) {
            for (var e = 0; e < t.length; e++) {
              var p = t[e];
              p.enumerable = p.enumerable || !1, p.configurable = !0, "value" in p && (p.writable = !0), Object.defineProperty(T, p.key, p);
            }
          }
          var ie = new (function() {
            function T() {
              (function(p, m) {
                if (!(p instanceof m)) throw new TypeError("Cannot call a class as a function");
              })(this, T), this.init();
            }
            var t, e;
            return t = T, (e = [{ key: "init", value: function() {
              this.BASE_URL = "BaseURL", this.SEGMENT_BASE = "SegmentBase", this.SEGMENT_TEMPLATE = "SegmentTemplate", this.SEGMENT_LIST = "SegmentList", this.SEGMENT_URL = "SegmentURL", this.SEGMENT_TIMELINE = "SegmentTimeline", this.SEGMENT_PROFILES = "segmentProfiles", this.ADAPTATION_SET = "AdaptationSet", this.REPRESENTATION = "Representation", this.REPRESENTATION_INDEX = "RepresentationIndex", this.SUB_REPRESENTATION = "SubRepresentation", this.INITIALIZATION = "Initialization", this.INITIALIZATION_MINUS = "initialization", this.MPD = "MPD", this.PERIOD = "Period", this.ASSET_IDENTIFIER = "AssetIdentifier", this.EVENT_STREAM = "EventStream", this.ID = "id", this.PROFILES = "profiles", this.SERVICE_LOCATION = "serviceLocation", this.RANGE = "range", this.INDEX = "index", this.MEDIA = "media", this.BYTE_RANGE = "byteRange", this.INDEX_RANGE = "indexRange", this.MEDIA_RANGE = "mediaRange", this.VALUE = "value", this.CONTENT_TYPE = "contentType", this.MIME_TYPE = "mimeType", this.BITSTREAM_SWITCHING = "BitstreamSwitching", this.BITSTREAM_SWITCHING_MINUS = "bitstreamSwitching", this.CODECS = "codecs", this.DEPENDENCY_ID = "dependencyId", this.MEDIA_STREAM_STRUCTURE_ID = "mediaStreamStructureId", this.METRICS = "Metrics", this.METRICS_MINUS = "metrics", this.REPORTING = "Reporting", this.WIDTH = "width", this.HEIGHT = "height", this.SAR = "sar", this.FRAMERATE = "frameRate", this.AUDIO_SAMPLING_RATE = "audioSamplingRate", this.MAXIMUM_SAP_PERIOD = "maximumSAPPeriod", this.START_WITH_SAP = "startWithSAP", this.MAX_PLAYOUT_RATE = "maxPlayoutRate", this.CODING_DEPENDENCY = "codingDependency", this.SCAN_TYPE = "scanType", this.FRAME_PACKING = "FramePacking", this.AUDIO_CHANNEL_CONFIGURATION = "AudioChannelConfiguration", this.CONTENT_PROTECTION = "ContentProtection", this.ESSENTIAL_PROPERTY = "EssentialProperty", this.ESSENTIAL_PROPERTY_ASARRAY = "EssentialProperty_asArray", this.SUPPLEMENTAL_PROPERTY = "SupplementalProperty", this.SUPPLEMENTAL_PROPERTY_ASARRAY = "SupplementalProperty_asArray", this.INBAND_EVENT_STREAM = "InbandEventStream", this.PRODUCER_REFERENCE_TIME = "ProducerReferenceTime", this.INBAND = "inband", this.TYPE = "type", this.ACCESSIBILITY = "Accessibility", this.ROLE = "Role", this.RATING = "Rating", this.CONTENT_COMPONENT = "ContentComponent", this.SUBSET = "Subset", this.LANG = "lang", this.VIEWPOINT = "Viewpoint", this.VIEWPOINT_ASARRAY = "Viewpoint_asArray", this.ROLE_ASARRAY = "Role_asArray", this.REPRESENTATION_ASARRAY = "Representation_asArray", this.PRODUCERREFERENCETIME_ASARRAY = "ProducerReferenceTime_asArray", this.ACCESSIBILITY_ASARRAY = "Accessibility_asArray", this.AUDIOCHANNELCONFIGURATION_ASARRAY = "AudioChannelConfiguration_asArray", this.CONTENTPROTECTION_ASARRAY = "ContentProtection_asArray", this.MAIN = "main", this.DYNAMIC = "dynamic", this.STATIC = "static", this.MEDIA_PRESENTATION_DURATION = "mediaPresentationDuration", this.MINIMUM_UPDATE_PERIOD = "minimumUpdatePeriod", this.CODEC_PRIVATE_DATA = "codecPrivateData", this.BANDWITH = "bandwidth", this.SOURCE_URL = "sourceURL", this.TIMESCALE = "timescale", this.DURATION = "duration", this.START_NUMBER = "startNumber", this.PRESENTATION_TIME_OFFSET = "presentationTimeOffset", this.AVAILABILITY_START_TIME = "availabilityStartTime", this.AVAILABILITY_END_TIME = "availabilityEndTime", this.TIMESHIFT_BUFFER_DEPTH = "timeShiftBufferDepth", this.MAX_SEGMENT_DURATION = "maxSegmentDuration", this.PRESENTATION_TIME = "presentationTime", this.MIN_BUFFER_TIME = "minBufferTime", this.MAX_SUBSEGMENT_DURATION = "maxSubsegmentDuration", this.START = "start", this.AVAILABILITY_TIME_OFFSET = "availabilityTimeOffset", this.AVAILABILITY_TIME_COMPLETE = "availabilityTimeComplete", this.CENC_DEFAULT_KID = "cenc:default_KID", this.DVB_PRIORITY = "dvb:priority", this.DVB_WEIGHT = "dvb:weight", this.DVB_URL = "dvb:url", this.DVB_MIMETYPE = "dvb:mimeType", this.DVB_FONTFAMILY = "dvb:fontFamily", this.SUGGESTED_PRESENTATION_DELAY = "suggestedPresentationDelay", this.SERVICE_DESCRIPTION = "ServiceDescription", this.SERVICE_DESCRIPTION_SCOPE = "Scope", this.SERVICE_DESCRIPTION_LATENCY = "Latency", this.SERVICE_DESCRIPTION_PLAYBACK_RATE = "PlaybackRate", this.SERVICE_DESCRIPTION_OPERATING_QUALITY = "OperatingQuality", this.SERVICE_DESCRIPTION_OPERATING_BANDWIDTH = "OperatingBandwidth", this.PATCH_LOCATION = "PatchLocation", this.PATCH_LOCATION_AS_ARRAY = "PatchLocation_asArray", this.LOCATION = "Location", this.LOCATION_AS_ARRAY = "Location_asArray", this.PUBLISH_TIME = "publishTime", this.ORIGINAL_PUBLISH_TIME = "originalPublishTime", this.ORIGINAL_MPD_ID = "mpdId", this.WALL_CLOCK_TIME = "wallClockTime", this.PRESENTATION_TIME = "presentationTime", this.LABEL = "Label", this.GROUP_LABEL = "GroupLabel", this.CONTENT_STEERING = "ContentSteering", this.CONTENT_STEERING_AS_ARRAY = "ContentSteering_asArray", this.DEFAULT_SERVICE_LOCATION = "defaultServiceLocation", this.QUERY_BEFORE_START = "queryBeforeStart", this.CLIENT_REQUIREMENT = "clientRequirement", this.TTL = "ttl", this.CONTENT_STEERING_RESPONSE = { VERSION: "VERSION", TTL: "TTL", RELOAD_URI: "RELOAD-URI", PATHWAY_PRIORITY: "PATHWAY-PRIORITY", PATHWAY_CLONES: "PATHWAY-CLONES", BASE_ID: "BASE-ID", ID: "ID", URI_REPLACEMENT: "URI-REPLACEMENT", HOST: "HOST", PARAMS: "PARAMS" }, this.PRODUCER_REFERENCE_TIME_TYPE = { ENCODER: "encoder", CAPTURED: "captured", APPLICATION: "application" }, this.SEGMENT_ALIGNMENT = "segmentAlignment", this.SUB_SEGMENT_ALIGNMENT = "subsegmentAlignment";
            } }]) && C(t.prototype, e), T;
          }())();
          Ee.Z = ie;
        }, 7802: function(Pe, Ee, C) {
          var ie = C(5448), T = C(1724), t = C(3636), e = C(1736), p = C(5246);
          function m(E) {
            E = E || {};
            var h, n, c = this.context, d = E.dashConstants, S = E.type, x = E.segmentBaseController;
            function B(L) {
              return L ? L.segments ? n[d.SEGMENT_BASE] : n[L.segmentInfoType] : null;
            }
            return h = { initialize: function(L) {
              n[d.SEGMENT_TIMELINE] = (0, T.Z)(c).create(E, L), n[d.SEGMENT_TEMPLATE] = (0, t.Z)(c).create(E, L), n[d.SEGMENT_LIST] = (0, e.Z)(c).create(E, L), n[d.SEGMENT_BASE] = (0, p.Z)(c).create(E, L);
            }, updateInitData: function(L, $) {
              return $ ? Promise.resolve() : x.getSegmentBaseInitSegment({ representation: L, mediaType: S });
            }, updateSegmentData: function(L, $) {
              return $ ? Promise.resolve() : x.getSegmentList({ mimeType: L.mimeType, representation: L, mediaType: S });
            }, getSegmentByIndex: function(L, $, M) {
              var K = B(L);
              return K ? K.getSegmentByIndex(L, $, M) : null;
            }, getSegmentByTime: function(L, $) {
              var M = B(L);
              return M ? M.getSegmentByTime(L, $) : null;
            }, getMediaFinishedInformation: function(L) {
              var $ = B(L);
              return $ ? $.getMediaFinishedInformation(L) : { numberOfSegments: 0, mediaTimeOfLastSignaledSegment: NaN };
            } }, n = {}, h;
          }
          m.__dashjs_factory_name = "SegmentsController";
          var o = ie.Z.getClassFactory(m);
          Ee.Z = o;
        }, 1736: function(Pe, Ee, C) {
          var ie = C(5448), T = C(3393), t = C(7387);
          function e(m, o) {
            var E = (m = m || {}).timelineConverter;
            function h() {
              if (!E || !E.hasOwnProperty("calcPeriodRelativeTimeFromMpdRelativeTime")) throw new Error(T.Z.MISSING_CONFIG_ERROR);
            }
            function n(c, d) {
              if (h(), !c) return null;
              var S = c.adaptation.period.mpd.manifest.Period_asArray[c.adaptation.period.index].AdaptationSet_asArray[c.adaptation.index].Representation_asArray[c.index].SegmentList, x = S.SegmentURL_asArray.length, B = c && !isNaN(c.startNumber) ? c.startNumber : 1, L = Math.max(B - 1, 0), $ = Math.max(d - L, 0), M = null;
              if ($ < x) {
                var K = S.SegmentURL_asArray[$];
                (M = (0, t.NF)(E, o, c, d)) && (M.replacementTime = (B + d - 1) * c.segmentDuration, M.media = K.media ? K.media : "", M.mediaRange = K.mediaRange, M.indexRange = K.indexRange);
              }
              return M;
            }
            return { getSegmentByIndex: n, getSegmentByTime: function(c, d) {
              if (h(), !c) return null;
              var S = c.segmentDuration;
              if (isNaN(S)) return null;
              var x = E.calcPeriodRelativeTimeFromMpdRelativeTime(c, d);
              return n(c, Math.floor(x / S));
            }, getMediaFinishedInformation: function(c) {
              var d = { numberOfSegments: 0, mediaTimeOfLastSignaledSegment: NaN };
              if (!c) return d;
              var S = c.adaptation.period.mpd.manifest.Period_asArray[c.adaptation.period.index].AdaptationSet_asArray[c.adaptation.index].Representation_asArray[c.index].SegmentList, x = c && !isNaN(c.startNumber) ? c.startNumber : 1, B = Math.max(x - 1, 0);
              return d.numberOfSegments = B + S.SegmentURL_asArray.length, d;
            } };
          }
          e.__dashjs_factory_name = "ListSegmentsGetter";
          var p = ie.Z.getClassFactory(e);
          Ee.Z = p;
        }, 5246: function(Pe, Ee, C) {
          var ie = C(5448), T = C(3393);
          function t(p) {
            var m = (p = p || {}).timelineConverter;
            function o() {
              if (!m || !m.hasOwnProperty("calcPeriodRelativeTimeFromMpdRelativeTime")) throw new Error(T.Z.MISSING_CONFIG_ERROR);
            }
            function E(h, n) {
              if (o(), !h) return null;
              var c, d = h.segments ? h.segments.length : -1;
              if (n < d && (c = h.segments[n]) && c.index === n) return c;
              for (var S = 0; S < d; S++) if ((c = h.segments[S]) && c.index === n) return c;
              return null;
            }
            return { getSegmentByIndex: E, getSegmentByTime: function(h, n) {
              o();
              var c = function(d, S) {
                if (!d) return -1;
                var x, B, L, $, M, K = d.segments, ae = K ? K.length : null, j = -1;
                if (K && ae > 0) {
                  for (M = 0; M < ae; M++) if (L = (B = K[M]).presentationStartTime, S + (x = ($ = B.duration) / 2) >= L && S - x < L + $) {
                    j = B.index;
                    break;
                  }
                }
                return j;
              }(h, n);
              return E(h, c);
            }, getMediaFinishedInformation: function(h) {
              var n = { numberOfSegments: 0, mediaTimeOfLastSignaledSegment: NaN };
              return h && h.segments && (n.numberOfSegments = h.segments.length), n;
            } };
          }
          t.__dashjs_factory_name = "SegmentBaseGetter";
          var e = ie.Z.getClassFactory(t);
          Ee.Z = e;
        }, 7387: function(Pe, Ee, C) {
          C.d(Ee, { Aj: function() {
            return e;
          }, NF: function() {
            return E;
          }, TJ: function() {
            return h;
          }, eR: function() {
            return t;
          }, vi: function() {
            return p;
          } });
          var ie = C(2011);
          function T(n, c) {
            for (; n.length < c; ) n = "0" + n;
            return n;
          }
          function t(n) {
            return n && n.split("$$").join("$");
          }
          function e(n, c) {
            if (!c || !n || n.indexOf("$RepresentationID$") === -1) return n;
            var d = c.toString();
            return n.split("$RepresentationID$").join(d);
          }
          function p(n, c, d) {
            var S, x, B, L, $, M, K = c.length, ae = 2;
            if (!n) return n;
            for (; ; ) {
              if ((S = n.indexOf("$" + c)) < 0 || (x = n.indexOf("$", S + K)) < 0) return n;
              if ((B = n.indexOf("%0", S + K)) > S && B < x) switch (L = n.charAt(x - 1), $ = parseInt(n.substring(B + ae, x - 1), 10), L) {
                case "d":
                case "i":
                case "u":
                  M = T(d.toString(), $);
                  break;
                case "x":
                  M = T(d.toString(16), $);
                  break;
                case "X":
                  M = T(d.toString(16), $).toUpperCase();
                  break;
                case "o":
                  M = T(d.toString(8), $);
                  break;
                default:
                  return n;
              }
              else M = d;
              n = n.substring(0, S) + M + n.substring(x + 1);
            }
          }
          function m(n, c, d, S, x, B, L, $) {
            var M, K = new ie.Z();
            return K.representation = n, K.duration = c, K.presentationStartTime = d, K.mediaStartTime = S, K.availabilityStartTime = x.calcAvailabilityStartTimeFromPresentationTime(B, n, L), K.availabilityEndTime = x.calcAvailabilityEndTimeFromPresentationTime(B + c, n, L), K.wallStartTime = x.calcWallTimeForSegment(K, L), K.replacementNumber = (M = $, K.representation.startNumber + M), K.index = $, K;
          }
          function o(n, c, d, S) {
            var x = c.adaptation.period;
            if (isFinite(x.duration) && x.start + x.duration <= d.presentationStartTime) return !1;
            if (S) {
              if (c.availabilityTimeOffset === "INF") return !0;
              var B = n.getClientReferenceTime();
              return d.availabilityStartTime.getTime() <= B && (!isFinite(d.availabilityEndTime) || d.availabilityEndTime.getTime() >= B);
            }
            return !0;
          }
          function E(n, c, d, S) {
            var x, B, L;
            x = d.segmentDuration, isNaN(x) && (x = d.adaptation.period.duration), B = parseFloat((d.adaptation.period.start + S * x).toFixed(5)), L = parseFloat((B + x).toFixed(5));
            var $ = m(d, x, B, n.calcMediaTimeFromPresentationTime(B, d), n, L, c, S);
            return o(n, d, $, c) ? $ : null;
          }
          function h(n, c, d, S, x, B, L, $, M, K) {
            var ae, j, ee = S / B, ue = x / B;
            return ae = n.calcPresentationTimeFromMediaTime(ee, d), o(n, d, j = m(d, ue, ae, ee, n, ae + ue, c, M), c) ? (j.replacementTime = K || S, L = p(L, "Number", j.replacementNumber), L = p(L, "Time", j.replacementTime), j.media = L, j.mediaRange = $, j) : null;
          }
        }, 3636: function(Pe, Ee, C) {
          var ie = C(5448), T = C(3393), t = C(7387);
          function e(m, o) {
            var E = (m = m || {}).timelineConverter;
            function h() {
              if (!E || !E.hasOwnProperty("calcPeriodRelativeTimeFromMpdRelativeTime")) throw new Error(T.Z.MISSING_CONFIG_ERROR);
            }
            function n(c, d) {
              if (h(), !c) return null;
              var S = c.adaptation.period.mpd.manifest.Period_asArray[c.adaptation.period.index].AdaptationSet_asArray[c.adaptation.index].Representation_asArray[c.index].SegmentTemplate;
              d = Math.max(d, 0);
              var x = (0, t.NF)(E, o, c, d);
              if (x) {
                x.replacementTime = Math.round((d - 1) * c.segmentDuration * c.timescale, 10);
                var B = S.media;
                B = (0, t.vi)(B, "Number", x.replacementNumber), B = (0, t.vi)(B, "Time", x.replacementTime), x.media = B;
              }
              return x;
            }
            return { getSegmentByIndex: n, getSegmentByTime: function(c, d) {
              if (h(), !c) return null;
              var S = c.segmentDuration;
              if (isNaN(S)) return null;
              var x = E.calcPeriodRelativeTimeFromMpdRelativeTime(c, d);
              return n(c, Math.floor(x / S));
            }, getMediaFinishedInformation: function(c) {
              var d = { numberOfSegments: 0, mediaTimeOfLastSignaledSegment: NaN };
              if (!c) return d;
              var S = c.segmentDuration;
              return isNaN(S) ? d.numberOfSegments = 1 : d.numberOfSegments = Math.ceil(c.adaptation.period.duration / S), d;
            } };
          }
          e.__dashjs_factory_name = "TemplateSegmentsGetter";
          var p = ie.Z.getClassFactory(e);
          Ee.Z = p;
        }, 1724: function(Pe, Ee, C) {
          var ie = C(5448), T = C(3393), t = C(7387);
          function e(m, o) {
            var E = (m = m || {}).timelineConverter, h = m.dashMetrics;
            function n() {
              if (!E) throw new Error(T.Z.MISSING_CONFIG_ERROR);
            }
            function c(S, x) {
              var B, L, $, M, K, ae, j, ee = S.adaptation.period.mpd.manifest.Period_asArray[S.adaptation.period.index].AdaptationSet_asArray[S.adaptation.index].Representation_asArray[S.index].SegmentTemplate || S.adaptation.period.mpd.manifest.Period_asArray[S.adaptation.period.index].AdaptationSet_asArray[S.adaptation.index].Representation_asArray[S.index].SegmentList, ue = ee.SegmentTimeline, Ae = ee.SegmentURL_asArray, Q = 0, Ne = -1;
              j = S.timescale;
              var Ue = !1;
              for ($ = 0, M = (B = ue.S_asArray).length; $ < M && !Ue; $++) for (ae = 0, (L = B[$]).hasOwnProperty("r") && (ae = L.r), L.hasOwnProperty("t") && (Q = L.t), ae < 0 && (ae = d(S, B[$ + 1], L, j, Q / j)), K = 0; K <= ae && !Ue; K++) (Ue = x(Q, ee, Ae, L, j, ++Ne, $)) && (S.segmentDuration = L.d / j), Q += L.d;
            }
            function d(S, x, B, L, $) {
              var M;
              if (x && x.hasOwnProperty("t")) M = x.t / L;
              else try {
                var K = 0;
                if (isNaN(S.adaptation.period.start) || isNaN(S.adaptation.period.duration) || !isFinite(S.adaptation.period.duration)) {
                  var ae = h.getCurrentDVRInfo();
                  K = isNaN(ae.end) ? 0 : ae.end;
                } else K = S.adaptation.period.start + S.adaptation.period.duration;
                M = E.calcMediaTimeFromPresentationTime(K, S), S.segmentDuration = B.d / L;
              } catch {
                M = 0;
              }
              return Math.max(Math.ceil((M - $) / (B.d / L)) - 1, 0);
            }
            return { getSegmentByIndex: function(S, x, B) {
              if (n(), !S) return null;
              var L = null, $ = !1;
              return c(S, function(M, K, ae, j, ee, ue, Ae) {
                if ($ || B < 0) {
                  var Q = K.media, Ne = j.mediaRange;
                  return ae && (Q = ae[Ae].media || "", Ne = ae[Ae].mediaRange), L = (0, t.TJ)(E, o, S, M, j.d, ee, Q, Ne, ue, j.tManifest), !0;
                }
                return M >= B * ee - 0.5 * j.d && ($ = !0), !1;
              }), L;
            }, getSegmentByTime: function(S, x) {
              if (n(), !S) return null;
              x === void 0 && (x = null);
              var B = null, L = E.calcMediaTimeFromPresentationTime(x, S);
              return c(S, function($, M, K, ae, j, ee, ue) {
                var Ae = parseFloat((L * j).toPrecision(15));
                if (Ae < $ + ae.d && Ae >= $) {
                  var Q = M.media, Ne = ae.mediaRange;
                  return K && (Q = K[ue].media || "", Ne = K[ue].mediaRange), B = (0, t.TJ)(E, o, S, $, ae.d, j, Q, Ne, ee, ae.tManifest), !0;
                }
                return !1;
              }), B;
            }, getMediaFinishedInformation: function(S) {
              if (!S) return 0;
              var x, B, L, $, M, K, ae, j = (S.adaptation.period.mpd.manifest.Period_asArray[S.adaptation.period.index].AdaptationSet_asArray[S.adaptation.index].Representation_asArray[S.index].SegmentTemplate || S.adaptation.period.mpd.manifest.Period_asArray[S.adaptation.period.index].AdaptationSet_asArray[S.adaptation.index].Representation_asArray[S.index].SegmentList).SegmentTimeline, ee = 0, ue = 0, Ae = 0;
              for (ae = S.timescale, $ = (x = j.S_asArray).length, L = 0; L < $; L++) for (K = 0, (B = x[L]).hasOwnProperty("r") && (K = B.r), B.hasOwnProperty("t") && (ue = (ee = B.t) / ae), K < 0 && (K = d(S, x[L + 1], B, ae, ue)), M = 0; M <= K; M++) Ae++, ue = (ee += B.d) / ae;
              return { numberOfSegments: Ae, mediaTimeOfLastSignaledSegment: ue };
            } };
          }
          e.__dashjs_factory_name = "TimelineSegmentsGetter";
          var p = ie.Z.getClassFactory(e);
          Ee.Z = p;
        }, 2011: function(Pe, Ee) {
          Ee.Z = function C() {
            (function(ie, T) {
              if (!(ie instanceof T)) throw new TypeError("Cannot call a class as a function");
            })(this, C), this.indexRange = null, this.index = null, this.mediaRange = null, this.media = null, this.duration = NaN, this.replacementTime = null, this.replacementNumber = NaN, this.mediaStartTime = NaN, this.presentationStartTime = NaN, this.availabilityStartTime = NaN, this.availabilityEndTime = NaN, this.wallStartTime = NaN, this.representation = null;
          };
        }, 2610: function(Pe, Ee) {
          Ee.Z = function C() {
            (function(ie, T) {
              if (!(ie instanceof T)) throw new TypeError("Cannot call a class as a function");
            })(this, C), this.schemeIdUri = "", this.value = "";
          };
        }, 1139: function(Pe, Ee, C) {
          C.d(Ee, { Z: function() {
            return Vl;
          } });
          var ie = C(452), T = C.n(ie), t = C(3393), e = C(1553), p = C(3860), m = C(5595), o = C(8512), E = C(5448), h = C(6398), n = C(8825);
          function c() {
            var i, r, l, _, R, I, y, w, F, H, G, N, U, Z, fe, te, le, ge, q, oe, V, ce, g, P, D, O = this.context, A = (0, m.Z)(O).getInstance();
            function ne() {
              k(), Z = !1, H = 0, G = 0, le = 0, g = !1, ge = !0, q = !1, P = !1, oe = NaN, te = NaN, y && (A.off(o.Z.DATA_UPDATE_COMPLETED, Ke, i), A.off(o.Z.LOADING_PROGRESS, Vt, i), A.off(o.Z.MANIFEST_UPDATED, ct, i), A.off(o.Z.STREAMS_COMPOSED, de, i), A.off(n.Z.PLAYBACK_ENDED, ht, i), A.off(n.Z.STREAM_INITIALIZING, Ye, i), A.off(n.Z.REPRESENTATION_SWITCH, Me, i), A.off(n.Z.BUFFER_LEVEL_STATE_CHANGED, gt, i), mt(), y.removeEventListener("canplay", vt), y.removeEventListener("canplaythrough", Et), y.removeEventListener("play", Wt), y.removeEventListener("waiting", zt), y.removeEventListener("playing", gn), y.removeEventListener("pause", pn), y.removeEventListener("error", kt), y.removeEventListener("seeking", je), y.removeEventListener("seeked", yt), y.removeEventListener("timeupdate", ot), y.removeEventListener("progress", It), y.removeEventListener("ratechange", Lt), y.removeEventListener("loadedmetadata", $t), y.removeEventListener("loadeddata", Qt), y.removeEventListener("stalled", Xt), y.removeEventListener("ended", en), y.removeEventListener("volumechange", on)), F = null, y = null, N = null, U = null;
            }
            function z() {
              var _e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
              return parseFloat((se(_e) - Ie()).toFixed(5));
            }
            function se(_e) {
              var Xe = _e || N;
              return Xe.start + Xe.duration;
            }
            function X() {
              var _e = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
              N && y && y.getElement() ? (_e && U && Le(Ie()), y.play()) : Z = !0;
            }
            function k() {
              N && y && y.pause();
            }
            function J(_e) {
              var Xe = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], Ct = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], xt = arguments.length > 3 && arguments[3] !== void 0 && arguments[3];
              if (N && y && y.getElement()) {
                var yn = isNaN(oe) ? y.getTime() : oe;
                _e !== yn && ((V = Ct === !0) || (oe = _e), r.info("Requesting seek to time: " + _e + (V ? " (internal)" : "")), U && xt && Le(_e), y.setCurrentTime(_e, Xe));
              }
            }
            function pe() {
              if (N && y && U) {
                var _e = l && l.hasVideoTrack() ? t.Z.VIDEO : t.Z.AUDIO, Xe = R.getCurrentDVRInfo(_e);
                return Xe && Xe.range ? Xe.range.end : 0;
              }
            }
            function Le(_e) {
              var Xe = new Date(w.getClientReferenceTime()), Ct = I.getRegularPeriods()[0], xt = w.calcPresentationTimeFromWallTime(Xe, Ct);
              H = xt - _e;
            }
            function Ie() {
              return N && y ? y.getTime() : null;
            }
            function xe() {
              return N && y ? y.isPaused() : null;
            }
            function De() {
              return N && y ? y.isSeeking() : null;
            }
            function st() {
              return N && y ? y.isStalled() : null;
            }
            function ut() {
              return N && y ? y.getPlaybackRate() : null;
            }
            function et() {
              return N && y ? y.getEnded() : null;
            }
            function tt() {
              return U;
            }
            function Ut() {
              var _e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
              if (!xe() && U && y.getReadyState() !== 0 && !De() && !g) {
                _e || (_e = l.hasVideoTrack() ? t.Z.VIDEO : t.Z.AUDIO);
                var Xe = Ie(), Ct = be(Xe, _e), xt = !isNaN(Ct) && Ct !== Xe;
                xt && !De() && (st() || ce || y.getReadyState() === 1) && (r.debug("UpdateCurrentTime: Seek to actual time: ".concat(Ct, " from currentTime: ").concat(Xe)), J(Ct, !1, !1));
              }
            }
            function be(_e, Xe) {
              var Ct = R.getCurrentDVRInfo(Xe), xt = Ct ? Ct.range : null;
              return xt ? _e > xt.end ? Math.max(xt.end - H, xt.start) : _e > 0 && _e + 0.25 < xt.start && Math.abs(_e - xt.start) < 31536e4 ? q ? Math.max(xt.end - H, xt.start) : xt.start : _e : NaN;
            }
            function Be() {
              F === null && (F = setInterval(function() {
                (function() {
                  if (A.trigger(o.Z.WALLCLOCK_TIME_UPDATED, { isDynamic: U, time: /* @__PURE__ */ new Date() }), tt()) {
                    var _e = Date.now();
                    (isNaN(te) || _e > te + D.get().streaming.liveUpdateTimeThresholdInMilliseconds) && (l.addDVRMetric(), xe() ? function() {
                      var Xe = Date.now();
                      (!fe || Xe > fe + 500) && (fe = Xe, ot());
                    }() : Ut(), te = _e);
                  }
                })();
              }, D.get().streaming.wallclockTimeUpdateInterval));
            }
            function mt() {
              clearInterval(F), F = null;
            }
            function Ke(_e) {
              var Xe = I.convertRepresentationToRepresentationInfo(_e.currentRepresentation), Ct = Xe ? Xe.mediaInfo.streamInfo : null;
              Ct !== null && N.id === Ct.id && (N = Ct);
            }
            function vt() {
              A.trigger(o.Z.CAN_PLAY);
            }
            function Et() {
              A.trigger(o.Z.CAN_PLAY_THROUGH);
            }
            function gt(_e) {
              _e.streamId === l.getActiveStreamInfo().id && (ce = _e.state === p.Z.BUFFER_EMPTY, D.get().streaming.buffer.setStallState && y.setStallState(_e.mediaType, _e.state === p.Z.BUFFER_EMPTY));
            }
            function Wt() {
              r.info("Native video element event: play"), Ut(), Be(), A.trigger(o.Z.PLAYBACK_STARTED, { startTime: Ie() });
            }
            function zt() {
              r.info("Native video element event: waiting"), A.trigger(o.Z.PLAYBACK_WAITING, { playingTime: Ie() });
            }
            function gn() {
              r.info("Native video element event: playing"), V = !1, A.trigger(o.Z.PLAYBACK_PLAYING, { playingTime: Ie() });
            }
            function pn() {
              r.info("Native video element event: pause"), A.trigger(o.Z.PLAYBACK_PAUSED, { ended: et() });
            }
            function je() {
              if (!V) {
                var _e = Ie();
                isNaN(oe) || oe === _e || (_e = oe), oe = NaN, r.info("Seeking to: " + _e), Be(), A.trigger(o.Z.PLAYBACK_SEEKING, { seekTime: _e, streamId: N.id });
              }
            }
            function yt() {
              r.info("Native video element event: seeked"), V = !1, A.trigger(o.Z.PLAYBACK_SEEKED);
            }
            function ot() {
              N && A.trigger(o.Z.PLAYBACK_TIME_UPDATED, { timeToEnd: z(), time: Ie(), streamId: N.id });
            }
            function It() {
              A.trigger(o.Z.PLAYBACK_PROGRESS, { streamId: N.id });
            }
            function Lt() {
              var _e = ut();
              r.info("Native video element event: ratechange: ", _e), A.trigger(o.Z.PLAYBACK_RATE_CHANGED, { playbackRate: _e });
            }
            function $t() {
              r.info("Native video element event: loadedmetadata"), A.trigger(o.Z.PLAYBACK_METADATA_LOADED), Be();
            }
            function Qt() {
              r.info("Native video element event: loadeddata"), A.trigger(o.Z.PLAYBACK_LOADED_DATA);
            }
            function en() {
              r.info("Native video element event: ended"), k(), mt();
              var _e = l ? l.getActiveStreamInfo() : null;
              _e && A.trigger(o.Z.PLAYBACK_ENDED, { isLast: _e.isLast });
            }
            function on() {
              A.trigger(o.Z.PLAYBACK_VOLUME_CHANGED);
            }
            function ht(_e) {
              if (F && _e.isLast) {
                r.info("onPlaybackEnded -- PLAYBACK_ENDED but native video element didn't fire ended");
                var Xe = _e.seekTime ? _e.seekTime : se();
                y.setCurrentTime(Xe), k(), mt();
              }
            }
            function kt(_e) {
              var Xe = _e.target || _e.srcElement;
              A.trigger(o.Z.PLAYBACK_ERROR, { error: Xe.error });
            }
            function Ht() {
              U = !1;
            }
            function Vt(_e) {
              if (_e.stream === !1 && q && !isNaN(_e.request.duration)) {
                var Xe = 1.2 * _e.request.duration;
                Xe > H && (r.warn("Browser does not support fetch API with StreamReader. Increasing live delay to be 20% higher than segment duration:", Xe.toFixed(2)), H = Xe, G = Xe);
              }
            }
            function Xt(_e) {
              A.trigger(o.Z.PLAYBACK_STALLED, { e: _e });
            }
            function Ye(_e) {
              var Xe;
              (Xe = _e.mediaInfo) && Xe.supplementalProperties && Xe.supplementalProperties[t.Z.SUPPLEMENTAL_PROPERTY_DVB_LL_SCHEME] && Xe.supplementalProperties[t.Z.SUPPLEMENTAL_PROPERTY_DVB_LL_SCHEME].value === "true" && (r.debug("Low Latency critical SupplementalProperty set: Enabling low Latency"), q = !0);
            }
            function Me(_e) {
              var Xe = l.getActiveStreamInfo();
              _e && Xe && _e.currentRepresentation && _e.streamId && _e.streamId === Xe.id && _e.mediaType && (_e.mediaType === t.Z.VIDEO || _e.mediaType === t.Z.AUDIO) && (ge = _e.currentRepresentation.availabilityTimeComplete, (q = !ge) && !P && (P = !0));
            }
            function ct() {
              g = !0;
            }
            function de() {
              g = !1;
            }
            return i = { initialize: function(_e, Xe) {
              N = _e, Xe !== !0 && (y.addEventListener("canplay", vt), y.addEventListener("canplaythrough", Et), y.addEventListener("play", Wt), y.addEventListener("waiting", zt), y.addEventListener("playing", gn), y.addEventListener("pause", pn), y.addEventListener("error", kt), y.addEventListener("seeking", je), y.addEventListener("seeked", yt), y.addEventListener("timeupdate", ot), y.addEventListener("progress", It), y.addEventListener("ratechange", Lt), y.addEventListener("loadedmetadata", $t), y.addEventListener("loadeddata", Qt), y.addEventListener("stalled", Xt), y.addEventListener("ended", en), y.addEventListener("volumechange", on), U = N.manifestInfo.isDynamic, ce = !1, V = !1, A.on(o.Z.DATA_UPDATE_COMPLETED, Ke, i), A.on(o.Z.LOADING_PROGRESS, Vt, i), A.on(o.Z.MANIFEST_UPDATED, ct, i), A.on(o.Z.STREAMS_COMPOSED, de, i), A.on(n.Z.PLAYBACK_ENDED, ht, i, { priority: m.Z.EVENT_PRIORITY_HIGH }), A.on(n.Z.STREAM_INITIALIZING, Ye, i), A.on(n.Z.REPRESENTATION_SWITCH, Me, i), A.on(n.Z.BUFFER_LEVEL_STATE_CHANGED, gt, i), A.on(n.Z.DYNAMIC_TO_STATIC, Ht, i), Z && (Z = !1, X()));
            }, setConfig: function(_e) {
              _e && (_e.streamController && (l = _e.streamController), _e.serviceDescriptionController && (_ = _e.serviceDescriptionController), _e.dashMetrics && (R = _e.dashMetrics), _e.adapter && (I = _e.adapter), _e.videoModel && (y = _e.videoModel), _e.timelineConverter && (w = _e.timelineConverter), _e.settings && (D = _e.settings));
            }, getTimeToStreamEnd: z, getBufferLevel: function() {
              var _e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, Xe = null;
              return l.getActiveStreamProcessors().forEach(function(Ct) {
                if (!_e || _e.length === 0 || _e.indexOf(Ct.getType()) === -1) {
                  var xt = Ct.getBufferLevel();
                  Xe = Xe === null ? xt : Math.min(Xe, xt);
                }
              }), Xe;
            }, getPlaybackStalled: function() {
              return ce;
            }, getTime: Ie, getLowLatencyModeEnabled: function() {
              return q;
            }, getInitialCatchupModeActivated: function() {
              return P;
            }, getIsManifestUpdateInProgress: function() {
              return g;
            }, getPlaybackRate: ut, getPlayedRanges: function() {
              return N && y ? y.getPlayedRanges() : null;
            }, getEnded: et, getIsDynamic: tt, getStreamController: function() {
              return l;
            }, computeAndSetLiveDelay: function(_e, Xe) {
              var Ct, xt, yn, On = !isNaN(_e) && isFinite(_e) ? _e : NaN, zn = I.getSuggestedPresentationDelay(), Nn = _.getServiceDescriptionSettings();
              return Ct = isNaN(D.get().streaming.delay.liveDelay) ? D.get().streaming.delay.liveDelayFragmentCount === null || isNaN(D.get().streaming.delay.liveDelayFragmentCount) || isNaN(On) ? Nn && !isNaN(Nn.liveDelay) && Nn.liveDelay > 0 ? Nn.liveDelay : D.get().streaming.delay.useSuggestedPresentationDelay === !0 && zn !== null && !isNaN(zn) && zn > 0 ? zn : isNaN(On) ? Xe && !isNaN(Xe.minBufferTime) ? 4 * Xe.minBufferTime : 4 * N.manifestInfo.minBufferTime : 4 * On : On * D.get().streaming.delay.liveDelayFragmentCount : D.get().streaming.delay.liveDelay, (yn = I.getAvailabilityStartTime()) !== null && (le = yn), xt = Xe && Xe.dvrWindowSize > 0 ? Math.min(Ct, Xe.dvrWindowSize) : Ct, H = xt, G = xt, xt;
            }, getLiveDelay: function() {
              return H;
            }, getOriginalLiveDelay: function() {
              return G;
            }, getCurrentLiveLatency: function() {
              if (!U || isNaN(le)) return NaN;
              var _e = Ie();
              if (isNaN(_e) || _e === 0) return 0;
              var Xe = (/* @__PURE__ */ new Date()).getTime() + 1e3 * w.getClientTimeOffset();
              return Math.max(((Xe - le - 1e3 * _e) / 1e3).toFixed(3), 0);
            }, play: X, isPaused: xe, isStalled: st, pause: k, isSeeking: De, getStreamEndTime: se, seek: J, seekToOriginalLive: function() {
              var _e = arguments.length > 0 && arguments[0] !== void 0 && arguments[0], Xe = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], Ct = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], xt = pe();
              if (xt !== 0) {
                var yn = xt - (H = G);
                J(yn, _e, Xe, Ct);
              }
            }, seekToCurrentLive: function() {
              var _e = arguments.length > 0 && arguments[0] !== void 0 && arguments[0], Xe = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], Ct = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], xt = pe();
              if (xt !== 0) {
                var yn = xt - H;
                J(yn, _e, Xe, Ct);
              }
            }, reset: ne, updateCurrentTime: Ut, getAvailabilityStartTime: function() {
              return le;
            } }, r = (0, h.Z)(O).getInstance().getLogger(i), ne(), i;
          }
          c.__dashjs_factory_name = "PlaybackController";
          var d = E.Z.getSingletonFactory(c), S = C(3186), x = "loading", B = "executed", L = "failed";
          function $(i) {
            var r, l, _, R, I = (i = i || {}).eventBus, y = i.events, w = i.dashMetrics, F = i.fragmentLoader, H = i.debug, G = i.streamInfo, N = i.type;
            function U(g) {
              var P;
              return !!g && (P = !1, _.some(function(D) {
                if (O = g, A = D, !isNaN(O.index) && O.startTime === A.startTime && O.adaptationIndex === A.adaptationIndex && O.type === A.type || function(ne, z) {
                  return isNaN(ne.index) && isNaN(z.index) && ne.quality === z.quality;
                }(g, D) || function(ne, z) {
                  return ne.action === S.Z.ACTION_COMPLETE && ne.action === z.action;
                }(g, D)) return P = !0;
                var O, A;
              }), P);
            }
            function Z(g) {
              return isNaN(g.duration) ? 0.25 : Math.min(g.duration / 8, 0.5);
            }
            function fe(g) {
              _ = _.filter(function(P) {
                var D = Z(P);
                return isNaN(P.startTime) || g !== void 0 && P.startTime >= g - D;
              });
            }
            function te(g, P) {
              P <= g + 0.5 || (_ = _.filter(function(D) {
                var O = Z(D);
                return isNaN(D.startTime) || D.startTime >= P - O || isNaN(D.duration) || D.startTime + D.duration <= g + O;
              }));
            }
            function le(g, P, D) {
              for (var O = g.length - 1; O >= 0; O--) {
                var A = g[O], ne = A.startTime, z = ne + A.duration;
                if (D = isNaN(D) ? Z(A) : D, !isNaN(ne) && !isNaN(z) && P + D >= ne && P - D < z || isNaN(ne) && isNaN(P)) return A;
              }
              return null;
            }
            function ge(g, P) {
              w.addSchedulingInfo(g, P), w.addRequestsQueue(g.mediaType, R, _);
            }
            function q(g) {
              g.sender === F && (R.splice(R.indexOf(g.request), 1), g.response && !g.error && _.push(g.request), ge(g.request, g.error ? L : B), I.trigger(y.FRAGMENT_LOADING_COMPLETED, { request: g.request, response: g.response, error: g.error, sender: this }, { streamId: G.id, mediaType: N }));
            }
            function oe(g) {
              g.sender === F && I.trigger(y.FRAGMENT_LOADING_PROGRESS, { request: g.request, response: g.response, error: g.error, sender: this }, { streamId: G.id, mediaType: N });
            }
            function V(g) {
              g.sender === F && I.trigger(y.FRAGMENT_LOADING_ABANDONED, { request: g.request }, { streamId: G.id, mediaType: N });
            }
            function ce() {
              _ = [], R = [];
            }
            return r = { getStreamId: function() {
              return G.id;
            }, getType: function() {
              return N;
            }, getRequests: function(g) {
              var P = g ? g.state instanceof Array ? g.state : [g.state] : [], D = [];
              return P.forEach(function(O) {
                var A = function(ne) {
                  var z;
                  switch (ne) {
                    case x:
                      z = R;
                      break;
                    case B:
                      z = _;
                      break;
                    default:
                      z = [];
                  }
                  return z;
                }(O);
                D = D.concat(function(ne, z) {
                  return z.hasOwnProperty("time") ? [le(ne, z.time, z.threshold)] : ne.filter(function(se) {
                    for (var X in z) if (X !== "state" && z.hasOwnProperty(X) && se[X] != z[X]) return !1;
                    return !0;
                  });
                }(A, g));
              }), D;
            }, isFragmentLoaded: U, isFragmentLoadedOrPending: function(g) {
              var P, D = !1, O = 0;
              if (!(D = U(g))) for (O = 0; O < R.length; O++) P = R[O], g.url === P.url && g.startTime === P.startTime && (D = !0);
              return D;
            }, removeExecutedRequestsBeforeTime: fe, removeExecutedRequestsAfterTime: function(g) {
              _ = _.filter(function(P) {
                return isNaN(P.startTime) || g !== void 0 && P.startTime < g;
              });
            }, syncExecutedRequestsWithBufferedRange: function(g, P) {
              if (g && g.length !== 0) {
                for (var D = 0, O = 0, A = g.length; O < A; O++) te(D, g.start(O)), D = g.end(O);
                P > 0 && te(D, P);
              } else fe();
            }, abortRequests: function() {
              l.debug("abort requests"), F.abort(), R = [];
            }, executeRequest: function(g) {
              g.action === S.Z.ACTION_DOWNLOAD ? (ge(g, x), R.push(g), function(P) {
                I.trigger(y.FRAGMENT_LOADING_STARTED, { request: P }, { streamId: G.id, mediaType: N }), F.load(P);
              }(g)) : l.warn("Unknown request action.");
            }, reset: function() {
              I.off(y.LOADING_COMPLETED, q, this), I.off(y.LOADING_DATA_PROGRESS, oe, this), I.off(y.LOADING_ABANDONED, V, this), F && F.reset(), ce();
            }, resetInitialSettings: ce, addExecutedRequest: function(g) {
              _.push(g);
            } }, l = H.getLogger(r), ce(), I.on(y.LOADING_COMPLETED, q, r), I.on(y.LOADING_DATA_PROGRESS, oe, r), I.on(y.LOADING_ABANDONED, V, r), r;
          }
          $.__dashjs_factory_name = "FragmentModel";
          var M = E.Z.getClassFactory($);
          M.FRAGMENT_MODEL_LOADING = x, M.FRAGMENT_MODEL_EXECUTED = B, M.FRAGMENT_MODEL_CANCELED = "canceled", M.FRAGMENT_MODEL_FAILED = L, E.Z.updateClassFactory($.__dashjs_factory_name, M);
          var K = M, ae = C(5459);
          function j(i) {
            return j = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
              return typeof r;
            } : function(r) {
              return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
            }, j(i);
          }
          function ee(i, r) {
            return ee = Object.setPrototypeOf || function(l, _) {
              return l.__proto__ = _, l;
            }, ee(i, r);
          }
          function ue(i, r) {
            return !r || j(r) !== "object" && typeof r != "function" ? function(l) {
              if (l === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return l;
            }(i) : r;
          }
          function Ae(i) {
            return Ae = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
              return r.__proto__ || Object.getPrototypeOf(r);
            }, Ae(i);
          }
          var Q = new (function(i) {
            (function(I, y) {
              if (typeof y != "function" && y !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(y && y.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), y && ee(I, y);
            })(R, i);
            var r, l, _ = (r = R, l = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var I, y = Ae(r);
              if (l) {
                var w = Ae(this).constructor;
                I = Reflect.construct(y, arguments, w);
              } else I = y.apply(this, arguments);
              return ue(this, I);
            });
            function R() {
              var I;
              return function(y, w) {
                if (!(y instanceof w)) throw new TypeError("Cannot call a class as a function");
              }(this, R), (I = _.call(this)).MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE = 10, I.MANIFEST_LOADER_LOADING_FAILURE_ERROR_CODE = 11, I.XLINK_LOADER_LOADING_FAILURE_ERROR_CODE = 12, I.SEGMENT_BASE_LOADER_ERROR_CODE = 15, I.TIME_SYNC_FAILED_ERROR_CODE = 16, I.FRAGMENT_LOADER_LOADING_FAILURE_ERROR_CODE = 17, I.FRAGMENT_LOADER_NULL_REQUEST_ERROR_CODE = 18, I.URL_RESOLUTION_FAILED_GENERIC_ERROR_CODE = 19, I.APPEND_ERROR_CODE = 20, I.REMOVE_ERROR_CODE = 21, I.DATA_UPDATE_FAILED_ERROR_CODE = 22, I.CAPABILITY_MEDIASOURCE_ERROR_CODE = 23, I.CAPABILITY_MEDIAKEYS_ERROR_CODE = 24, I.DOWNLOAD_ERROR_ID_MANIFEST_CODE = 25, I.DOWNLOAD_ERROR_ID_SIDX_CODE = 26, I.DOWNLOAD_ERROR_ID_CONTENT_CODE = 27, I.DOWNLOAD_ERROR_ID_INITIALIZATION_CODE = 28, I.DOWNLOAD_ERROR_ID_XLINK_CODE = 29, I.MANIFEST_ERROR_ID_PARSE_CODE = 31, I.MANIFEST_ERROR_ID_NOSTREAMS_CODE = 32, I.TIMED_TEXT_ERROR_ID_PARSE_CODE = 33, I.MANIFEST_ERROR_ID_MULTIPLEXED_CODE = 34, I.MEDIASOURCE_TYPE_UNSUPPORTED_CODE = 35, I.MANIFEST_LOADER_PARSING_FAILURE_ERROR_MESSAGE = "parsing failed for ", I.MANIFEST_LOADER_LOADING_FAILURE_ERROR_MESSAGE = "Failed loading manifest: ", I.XLINK_LOADER_LOADING_FAILURE_ERROR_MESSAGE = "Failed loading Xlink element: ", I.SEGMENTS_UPDATE_FAILED_ERROR_MESSAGE = "Segments update failed", I.SEGMENTS_UNAVAILABLE_ERROR_MESSAGE = "no segments are available yet", I.SEGMENT_BASE_LOADER_ERROR_MESSAGE = "error loading segment ranges from sidx", I.TIME_SYNC_FAILED_ERROR_MESSAGE = "Failed to synchronize client and server time", I.FRAGMENT_LOADER_NULL_REQUEST_ERROR_MESSAGE = "request is null", I.URL_RESOLUTION_FAILED_GENERIC_ERROR_MESSAGE = "Failed to resolve a valid URL", I.APPEND_ERROR_MESSAGE = "chunk is not defined", I.REMOVE_ERROR_MESSAGE = "Removing data from the SourceBuffer", I.DATA_UPDATE_FAILED_ERROR_MESSAGE = "Data update failed", I.CAPABILITY_MEDIASOURCE_ERROR_MESSAGE = "mediasource is not supported", I.CAPABILITY_MEDIAKEYS_ERROR_MESSAGE = "mediakeys is not supported", I.TIMED_TEXT_ERROR_MESSAGE_PARSE = "parsing error :", I.MEDIASOURCE_TYPE_UNSUPPORTED_MESSAGE = "Error creating source buffer of type : ", I;
            }
            return R;
          }(C(2230).Z))(), Ne = C(1264), Ue = C(7855);
          function ze(i) {
            var r, l, _, R, I, y, w = this.context, F = (0, Ne.Z)(w).getInstance(), H = i.textController, G = i.eventBus, N = [], U = [], Z = !1, fe = i.mediaSource, te = null;
            function le(A) {
              return new Promise(function(ne) {
                O(function() {
                  R.changeType && R.changeType(A), ne();
                });
              });
            }
            function ge(A) {
              return R = H.getTextSourceBuffer(A), Promise.resolve();
            }
            function q() {
              if (typeof R.addEventListener == "function") try {
                R.addEventListener("updateend", P, !1), R.addEventListener("error", D, !1), R.addEventListener("abort", D, !1);
              } catch {
                y = setInterval(P, 50);
              }
              else y = setInterval(P, 50);
            }
            function oe(A) {
              return new Promise(function(ne) {
                R && F.get().streaming.buffer.useAppendWindow ? O(function() {
                  try {
                    if (!R) return void ne();
                    var z = fe.duration, se = 0;
                    A && !isNaN(A.start) && !isNaN(A.duration) && isFinite(A.duration) && (z = A.start + A.duration), A && !isNaN(A.start) && (se = A.start), R.appendWindowEnd === z && R.appendWindowStart === se || (R.appendWindowStart = 0, R.appendWindowEnd = z + 0.01, R.appendWindowStart = Math.max(se - 0.1, 0), _.debug("Updated append window for ".concat(I.type, ". Set start to ").concat(R.appendWindowStart, " and end to ").concat(R.appendWindowEnd))), ne();
                  } catch {
                    _.warn("Failed to set append window"), ne();
                  }
                }) : ne();
              });
            }
            function V(A) {
              return new Promise(function(ne) {
                R ? O(function() {
                  try {
                    R.timestampOffset === A || isNaN(A) || (R.timestampOffset = A, _.debug("Set MSE timestamp offset to ".concat(A))), ne();
                  } catch {
                    ne();
                  }
                }) : ne();
              });
            }
            function ce() {
              if (!Z && U.length > 0) {
                Z = !0;
                var A = U[0];
                U.splice(0, 1);
                var ne = function() {
                  Z = !1, U.length > 0 && ce.call(this), A && A.data && A.data.segmentType && A.data.segmentType !== Ue.w.INIT_SEGMENT_TYPE && delete A.data.bytes, A.promise.resolve({ chunk: A.data });
                };
                try {
                  te = A.request, A.data.bytes.byteLength === 0 ? ne.call(this) : (R.appendBuffer ? R.appendBuffer(A.data.bytes) : R.append(A.data.bytes, A.data), O(ne.bind(this)));
                } catch (z) {
                  _.fatal('SourceBuffer append failed "' + z + '"'), U.length > 0 ? ce() : Z = !1, delete A.data.bytes, A.promise.reject({ chunk: A.data, error: new ae.Z(z.code, z.message) });
                }
              }
            }
            function g() {
              N.length > 0 && (R.updating || (N.shift()(), g()));
            }
            function P() {
              R.updating || g();
            }
            function D(A) {
              var ne, z, se = A.target || {};
              ne = o.Z.SOURCE_BUFFER_ERROR, z = { error: se, lastRequestAppended: te }, G.trigger(ne, z, { streamId: I.streamInfo.id, mediaType: l });
            }
            function O(A) {
              N.push(A), R.updating || g();
            }
            return r = { getType: function() {
              return l;
            }, getAllBufferRanges: function() {
              try {
                return R.buffered;
              } catch (A) {
                return _.error("getAllBufferRanges exception: " + A.message), null;
              }
            }, getBuffer: function() {
              return R;
            }, append: function(A) {
              var ne = this, z = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
              return new Promise(function(se, X) {
                A ? (U.push({ data: A, promise: { resolve: se, reject: X }, request: z }), O(ce.bind(ne))) : X({ chunk: A, error: new ae.Z(Q.APPEND_ERROR_CODE, Q.APPEND_ERROR_MESSAGE) });
              });
            }, remove: function(A) {
              return new Promise(function(ne, z) {
                var se = A.start, X = A.end;
                se >= 0 && X > se ? O(function() {
                  try {
                    R.remove(se, X), O(function() {
                      ne({ from: se, to: X, unintended: !1 }), A.resolve && A.resolve();
                    });
                  } catch (k) {
                    z({ from: se, to: X, unintended: !1, error: new ae.Z(Q.REMOVE_ERROR_CODE, Q.REMOVE_ERROR_MESSAGE) }), A.reject && A.reject(k);
                  }
                }) : ne();
              });
            }, abort: function() {
              return new Promise(function(A) {
                try {
                  U = [], fe.readyState === "open" ? O(function() {
                    try {
                      R && R.abort(), A();
                    } catch {
                      A();
                    }
                  }) : (R && R.setTextTrack && fe.readyState === "ended" && R.abort(), A());
                } catch {
                  A();
                }
              });
            }, reset: function() {
              if (R) {
                try {
                  N = [], function() {
                    try {
                      typeof R.removeEventListener == "function" && (R.removeEventListener("updateend", P, !1), R.removeEventListener("error", D, !1), R.removeEventListener("abort", D, !1)), clearInterval(y);
                    } catch (A) {
                      _.error(A);
                    }
                  }(), Z = !1, U = [], R.getClassName && R.getClassName() === "TextSourceBuffer" || (_.debug("Removing sourcebuffer from media source"), fe.removeSourceBuffer(R));
                } catch {
                }
                R = null;
              }
              te = null;
            }, updateTimestampOffset: V, initializeForStreamSwitch: function(A, ne, z) {
              l = (I = A).type;
              var se = I.codec;
              (function(k) {
                R = k.getBuffer();
              })(z), q();
              var X = [];
              return X.push(new Promise(function(k) {
                O(function() {
                  var J = R.appendWindowStart, pe = R.appendWindowEnd;
                  R && (R.abort(), R.appendWindowStart = J, R.appendWindowEnd = pe), k();
                });
              })), X.push(oe(I.streamInfo)), F.get().streaming.buffer.useChangeTypeForTrackSwitch && X.push(le(se)), ne && ne.MSETimeOffset !== void 0 && X.push(V(ne.MSETimeOffset)), Promise.all(X);
            }, initializeForFirstUse: function(A, ne, z) {
              l = (I = ne).type;
              var se = I.codec;
              try {
                if (se.match(/application\/mp4;\s*codecs="(stpp|wvtt).*"/i)) return ge(A);
                R = fe.addSourceBuffer(se), q();
                var X = [];
                return X.push(oe(I.streamInfo)), z && z.MSETimeOffset !== void 0 && X.push(V(z.MSETimeOffset)), Promise.all(X);
              } catch (k) {
                return I.type == t.Z.TEXT && !I.isFragmented || se.indexOf('codecs="stpp') !== -1 || se.indexOf('codecs="vtt') !== -1 || se.indexOf("text/vtt") !== -1 ? ge(A) : Promise.reject(k);
              }
            }, updateAppendWindow: oe, changeType: le }, _ = (0, h.Z)(w).getInstance().getLogger(r), r;
          }
          ze.__dashjs_factory_name = "SourceBufferSink";
          var Te = E.Z.getClassFactory(ze);
          function Oe(i) {
            var r, l, _, R = this.context, I = [], y = i;
            function w(F, H) {
              return I = I.filter(function(G) {
                return !((isNaN(H) || G.start < H) && (isNaN(F) || G.end > F));
              }), Promise.resolve();
            }
            return r = { getAllBufferRanges: function() {
              for (var F = [], H = 0; H < I.length; H++) {
                var G = I[H];
                F.length === 0 || G.start > F[F.length - 1].end ? F.push({ start: G.start, end: G.end }) : F[F.length - 1].end = G.end;
              }
              var N = { start: function(U) {
                return F[U].start;
              }, end: function(U) {
                return F[U].end;
              } };
              return Object.defineProperty(N, "length", { get: function() {
                return F.length;
              } }), N;
            }, append: function(F) {
              return F.segmentType !== "InitializationSegment" ? (I.push(F), I.sort(function(H, G) {
                return H.start - G.start;
              }), _ = null) : _ = F, l.debug("PreBufferSink appended chunk s: " + F.start + "; e: " + F.end), y && y({ chunk: F }), Promise.resolve();
            }, remove: w, abort: function() {
              return Promise.resolve();
            }, discharge: function(F, H) {
              var G = function(N, U) {
                return I.filter(function(Z) {
                  return (isNaN(U) || Z.start < U) && (isNaN(N) || Z.end > N);
                });
              }(F, H);
              return _ && (G.push(_), _ = null), w(F, H), G;
            }, reset: function() {
              I = [], _ = null, y = null;
            }, updateTimestampOffset: function() {
              return Promise.resolve();
            }, waitForUpdateEnd: function(F) {
              F();
            }, getBuffer: function() {
              return this;
            } }, l = (0, h.Z)(R).getInstance().getLogger(r), r;
          }
          Oe.__dashjs_factory_name = "PreBufferSink";
          var We = E.Z.getClassFactory(Oe);
          function at() {
            var i = {};
            return { save: function(r) {
              var l = r.streamId, _ = r.representationId;
              i[l] = i[l] || {}, i[l][_] = r;
            }, extract: function(r, l) {
              return i && i[r] && i[r][l] ? i[r][l] : null;
            }, reset: function() {
              i = {};
            } };
          }
          at.__dashjs_factory_name = "InitCache";
          var Se = E.Z.getSingletonFactory(at), ke = 0.01, Rt = "BufferController";
          function _t(i) {
            i = i || {};
            var r, l, _, R, I, y, w, F, H, G, N, U, Z, fe, te, le, ge, q, oe, V, ce, g = this.context, P = (0, m.Z)(g).getInstance(), D = i.errHandler, O = i.fragmentModel, A = i.representationController, ne = i.adapter, z = i.textController, se = i.abrController, X = i.playbackController, k = i.streamInfo, J = i.type, pe = i.settings;
            function Le(Me) {
              var ct = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
              return new Promise(function(de, _e) {
                y = Me, H && ct && typeof H.discharge == "function" ? (G = H, xe(ct).then(function() {
                  de();
                }).catch(function(Xe) {
                  _e(Xe);
                })) : de();
              });
            }
            function Ie(Me) {
              return ne.convertRepresentationToRepresentationInfo(A.getRepresentationForQuality(Me));
            }
            function xe(Me) {
              var ct = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
              return new Promise(function(de, _e) {
                q && Me ? y ? (N = !1, st(Me, ct).then(function(Xe) {
                  de(Xe);
                }).catch(function(Xe) {
                  _e(Xe);
                })) : (N = !0, De().then(function(Xe) {
                  de(Xe);
                }).catch(function(Xe) {
                  _e(Xe);
                })) : de(null);
              });
            }
            function De() {
              var Me = this;
              return new Promise(function(ct, de) {
                var _e = se.getQualityFor(J, k.id);
                H = We(g).create(be.bind(Me)), $t(Ie(_e)).then(function() {
                  ct(H);
                }).catch(function() {
                  de();
                });
              });
            }
            function st(Me, ct) {
              return new Promise(function(de, _e) {
                var Xe = se.getQualityFor(J, k.id);
                H = Te(g).create({ mediaSource: y, textController: z, eventBus: P }), function(Ct, xt, yn) {
                  var On = Ie(yn);
                  return xt && xt[J] && (J === t.Z.VIDEO || J === t.Z.AUDIO) ? H.initializeForStreamSwitch(Ct, On, xt[J]) : H.initializeForFirstUse(k, Ct, On);
                }(Me, ct, Xe).then(function() {
                  return $t(Ie(Xe));
                }).then(function() {
                  de(H);
                }).catch(function(Ct) {
                  l.fatal("Caught error on create SourceBuffer: " + Ct), D.error(new ae.Z(Q.MEDIASOURCE_TYPE_UNSUPPORTED_CODE, Q.MEDIASOURCE_TYPE_UNSUPPORTED_MESSAGE + J)), _e(Ct);
                });
              });
            }
            function ut(Me) {
              pe.get().streaming.cacheInitSegments && (l.info("Init fragment finished loading saving to", J + "'s init cache"), q.save(Me.chunk)), l.debug("Append Init fragment", J, " with representationId:", Me.chunk.representationId, " and quality:", Me.chunk.quality, ", data size:", Me.chunk.bytes.byteLength), tt(Me.chunk);
            }
            function et(Me) {
              tt(Me.chunk, Me.request);
            }
            function tt(Me) {
              var ct = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
              H && (H.append(Me, ct).then(function(de) {
                be(de);
              }).catch(function(de) {
                be(de);
              }), Me.mediaInfo.type === t.Z.VIDEO && Xt(o.Z.VIDEO_CHUNK_RECEIVED, { chunk: Me }));
            }
            function Ut(Me) {
              if (Me && Me.length > 0) for (var ct = 0, de = Me.length; ct < de; ct++) l.debug("Buffered range: " + Me.start(ct) + " - " + Me.end(ct) + ", currentTime = ", X.getTime());
            }
            function be(Me) {
              if (Me.error) return Me.error.code === 22 && function() {
                if (ge = !0, I = 0.8 * kt(), l.warn("Quota exceeded, Critical Buffer: " + I), I > 0) {
                  var _e = Math.max(0.2 * I, 1), Xe = I - _e, Ct = Math.min(pe.get().streaming.buffer.bufferTimeAtTopQuality, 0.9 * Xe), xt = Math.min(pe.get().streaming.buffer.bufferTimeAtTopQualityLongForm, 0.9 * Xe), yn = { streaming: { buffer: { bufferToKeep: parseFloat(_e.toFixed(5)), bufferTimeAtTopQuality: parseFloat(Ct.toFixed(5)), bufferTimeAtTopQualityLongForm: parseFloat(xt.toFixed(5)) } } };
                  pe.update(yn);
                }
              }(), void (Me.error.code !== 22 && Vt() || (l.warn("Clearing playback buffer to overcome quota exceed situation"), Xt(o.Z.QUOTA_EXCEEDED, { criticalBufferLevel: I, quotaExceededTime: Me.chunk.start }), ot(yt())));
              if (H && (Wt(), ge = !1, (fe = Me.chunk) && fe.endFragment)) {
                fe && !isNaN(fe.index) && (w = Math.max(fe.index, w), zt());
                var ct = H.getAllBufferRanges();
                fe.segmentType === Ue.w.MEDIA_SEGMENT_TYPE && (Ut(ct), Ke(), function() {
                  if (!isNaN(ce) && !N) if (J === t.Z.AUDIO || J === t.Z.VIDEO) {
                    var _e = X.getTime(), Xe = gt(_e, 0), Ct = gt(ce, 0);
                    if (Xe && Ct && Xe.start === Ct.start) ce = NaN;
                    else {
                      var xt = A.getCurrentRepresentation().segmentDuration, yn = gt(ce, xt);
                      yn && (pe.get().streaming.buffer.enableSeekDecorrelationFix && Math.abs(_e - ce) > xt ? ce <= yn.end && X.seek(Math.max(ce, yn.start), !1, !0) : _e < yn.start && X.seek(yn.start, !1, !0));
                    }
                  } else ce = NaN;
                }());
                var de = !1;
                U && (U.indexOf(fe) > 0 && (de = !0), U = null), fe && !de && Xt(o.Z.BYTES_APPENDED_END_FRAGMENT, { quality: fe.quality, startTime: fe.start, index: fe.index, bufferedRanges: ct, segmentType: fe.segmentType, mediaType: J });
              }
            }
            function Be() {
              return new Promise(function(Me, ct) {
                var de = mt();
                if (!de || de.length === 0) return Ke(), void Me();
                ot(de).then(function() {
                  Me();
                }).catch(function(_e) {
                  ct(_e);
                });
              });
            }
            function mt(Me) {
              var ct = [], de = H.getAllBufferRanges();
              if (!de || de.length === 0) return ct;
              if (!Me && Me !== 0 || isNaN(Me)) ct.push({ start: de.start(0), end: de.end(de.length - 1) + 0.5 });
              else {
                var _e = function(Ct, xt) {
                  var yn = pe.get().streaming.buffer.bufferToKeep, On = xt.start(0);
                  if (Ct - On > yn) {
                    var zn = Math.max(0, Ct - yn), Nn = O.getRequests({ state: K.FRAGMENT_MODEL_EXECUTED, time: Ct, threshold: ke })[0];
                    if (Nn && (zn = Math.min(Nn.startTime, zn)), zn > 0) return { start: On, end: zn };
                  }
                  return null;
                }(Me, de), Xe = function(Ct, xt) {
                  var yn = xt.end(xt.length - 1) + 0.5, On = Ht(Ct), zn = k.manifestInfo.duration >= pe.get().streaming.buffer.longFormContentDurationThreshold ? pe.get().streaming.buffer.bufferTimeAtTopQualityLongForm : pe.get().streaming.buffer.bufferTimeAtTopQuality, Nn = isNaN(On) ? Ct : Math.min(On, Ct + zn);
                  if (Nn >= xt.end(xt.length - 1)) return null;
                  var fr = O.getRequests({ state: K.FRAGMENT_MODEL_EXECUTED, time: Ct, threshold: ke })[0];
                  if (fr && (Nn = Math.max(fr.startTime + fr.duration, Nn)), pe.get().streaming.buffer.avoidCurrentTimeRangePruning) {
                    for (var Jn = 0; Jn < xt.length; Jn++) if (xt.start(Jn) <= Ct && Ct <= xt.end(Jn) && xt.start(Jn) <= Nn && Nn <= xt.end(Jn)) {
                      var Gr = Nn;
                      Nn = Jn + 1 < xt.length ? xt.start(Jn + 1) : xt.end(Jn) + 1, l.debug("Buffered range [" + xt.start(Jn) + ", " + xt.end(Jn) + "] overlaps with targetTime " + Ct + " and range to be pruned [" + Gr + ", " + yn + "], using [" + Nn + ", " + yn + "] instead" + (Nn < yn ? "" : " (no actual pruning)"));
                      break;
                    }
                  }
                  return Nn < xt.end(xt.length - 1) ? { start: Nn, end: yn } : null;
                }(Me, de);
                _e && ct.push(_e), Xe && ct.push(Xe);
              }
              return ct;
            }
            function Ke() {
              (!V || J === t.Z.TEXT && z.isTextEnabled()) && Wt();
            }
            function vt() {
              gn();
            }
            function Et() {
              gn(), ce = NaN;
            }
            function gt(Me, ct) {
              if (!H) return null;
              var de, _e, Xe = H.getAllBufferRanges(), Ct = 0, xt = 0, yn = null, On = null, zn = 0, Nn = isNaN(ct) ? 0.15 : ct;
              if (Xe != null) {
                for (_e = 0, de = Xe.length; _e < de; _e++) if (Ct = Xe.start(_e), xt = Xe.end(_e), yn === null) zn = Math.abs(Ct - Me), (Me >= Ct && Me < xt || zn <= Nn) && (yn = Ct, On = xt);
                else {
                  if (!((zn = Ct - On) <= Nn)) break;
                  On = xt;
                }
                if (yn !== null) return { start: yn, end: On };
              }
              return null;
            }
            function Wt() {
              if (X) {
                var Me = X.getTime() || 0;
                N && (Me = isNaN(ce) ? 0 : ce);
                var ct = pe.get().streaming.gaps.jumpGaps && !isNaN(pe.get().streaming.gaps.smallGapLimit) ? pe.get().streaming.gaps.smallGapLimit : NaN;
                R = Math.max(function(de, _e) {
                  var Xe;
                  return pe.get().streaming.gaps.jumpGaps && (_e = pe.get().streaming.gaps.smallGapLimit), (Xe = gt(de, _e)) === null ? 0 : Xe.end - de;
                }(Me, ct), 0), Xt(o.Z.BUFFER_LEVEL_UPDATED, { mediaType: J, bufferLevel: R }), gn();
              }
            }
            function zt() {
              var Me = w >= F - 1, ct = X.getTimeToStreamEnd(k) - R < 1e-5;
              !Me && !ct || _ || (ht(!0), l.debug("checkIfBufferingCompleted trigger BUFFERING_COMPLETED for stream id ".concat(k.id, " and type ").concat(J)));
            }
            function gn() {
              J !== t.Z.AUDIO && J !== t.Z.VIDEO || ((!X.getLowLatencyModeEnabled() && R < pe.get().streaming.buffer.stallThreshold || R === 0) && !_ ? pn(p.Z.BUFFER_EMPTY) : (_ || R >= pe.get().streaming.buffer.stallThreshold || X.getLowLatencyModeEnabled() && R > 0) && pn(p.Z.BUFFER_LOADED));
            }
            function pn(Me) {
              Z === Me || Me === p.Z.BUFFER_EMPTY && X.getTime() === 0 || J === t.Z.TEXT && !z.isTextEnabled() || (Z = Me, Xt(o.Z.BUFFER_LEVEL_STATE_CHANGED, { state: Me }), Xt(Me === p.Z.BUFFER_LOADED ? o.Z.BUFFER_LOADED : o.Z.BUFFER_EMPTY), l.debug(Me === p.Z.BUFFER_LOADED ? "Got enough buffer to start" : "Waiting for more buffer before starting playback"));
            }
            function je() {
              H && J !== t.Z.TEXT && (_ || ot(yt()));
            }
            function yt() {
              var Me = [], ct = H.getAllBufferRanges();
              if (!ct || ct.length === 0) return Me;
              var de = X.getTime(), _e = Math.max(0, de - pe.get().streaming.buffer.bufferToKeep), Xe = O.getRequests({ state: K.FRAGMENT_MODEL_EXECUTED, time: de, threshold: ke })[0];
              if (Xe) _e = Math.min(Xe.startTime, _e);
              else if (de === 0 && X.getIsDynamic()) return [];
              if (ct.start(0) <= _e) {
                for (var Ct = { start: 0, end: _e }, xt = 0; xt < ct.length && ct.end(xt) <= _e; xt++) Ct.end = ct.end(xt);
                Ct.start < Ct.end && Me.push(Ct);
              }
              return Me;
            }
            function ot(Me) {
              return new Promise(function(ct, de) {
                if (Me && H && Me.length !== 0) {
                  var _e = [];
                  Me.forEach(function(Xe) {
                    _e.push(function(Ct) {
                      return new Promise(function(xt, yn) {
                        Ct.resolve = xt, Ct.reject = yn, oe.push(Ct);
                      });
                    }(Xe));
                  }), le || It(), Promise.all(_e).then(function() {
                    ct();
                  }).catch(function(Xe) {
                    de(Xe);
                  });
                } else ct();
              });
            }
            function It() {
              try {
                if (oe.length === 0 || !H) return l.debug("Nothing to prune, halt pruning"), oe = [], void (le = !1);
                var Me = H.getBuffer();
                if (!Me || !Me.buffered || Me.buffered.length === 0) return l.debug("SourceBuffer is empty (or does not exist), halt pruning"), oe = [], void (le = !1);
                var ct = oe.shift();
                l.debug("".concat(J, ": Removing buffer from: ").concat(ct.start, " to ").concat(ct.end)), le = !0, X.getTime() < ct.end && ht(!1), H.remove(ct).then(function(de) {
                  Lt(de);
                }).catch(function(de) {
                  Lt(de);
                });
              } catch {
                le = !1;
              }
            }
            function Lt(Me) {
              l.debug("onRemoved buffer from:", Me.from, "to", Me.to), H && (Ut(H.getAllBufferRanges()), oe.length === 0 && (le = !1, Wt()), Me.unintended && (l.warn("Detected unintended removal from:", Me.from, "to", Me.to, "setting streamprocessor time to", Me.from), Xt(o.Z.SEEK_TARGET, { time: Me.from })), le ? It() : (V ? V = !1 : Wt(), Xt(o.Z.BUFFER_CLEARED, { from: Me.from, to: Me.to, unintended: Me.unintended, hasEnoughSpaceToAppend: Vt(), quotaExceeded: ge })));
            }
            function $t(Me) {
              return new Promise(function(ct) {
                Me && Me.MSETimeOffset !== void 0 && H && H.updateTimestampOffset ? H.updateTimestampOffset(Me.MSETimeOffset).then(function() {
                  ct();
                }).catch(function() {
                  ct();
                }) : ct();
              });
            }
            function Qt() {
              return H && !_ ? H.updateAppendWindow(k) : Promise.resolve();
            }
            function en() {
              ++te * (pe.get().streaming.wallclockTimeUpdateInterval / 1e3) >= pe.get().streaming.buffer.bufferPruningInterval && (te = 0, je());
            }
            function on() {
              gn();
            }
            function ht(Me) {
              (_ = Me) ? Xt(o.Z.BUFFERING_COMPLETED) : F = Number.POSITIVE_INFINITY;
            }
            function kt() {
              try {
                var Me, ct, de = H.getAllBufferRanges(), _e = 0;
                if (!de) return _e;
                for (ct = 0, Me = de.length; ct < Me; ct++) _e += de.end(ct) - de.start(ct);
                return _e;
              } catch {
                return 0;
              }
            }
            function Ht(Me) {
              try {
                var ct = Me, de = H.getAllBufferRanges();
                if (!de || de.length === 0) return NaN;
                for (var _e = 0; ct === Me && _e < de.length; ) {
                  var Xe = de.start(_e), Ct = de.end(_e);
                  ct >= Xe && ct <= Ct && (ct = Ct), _e += 1;
                }
                return ct === Me ? NaN : ct;
              } catch {
              }
            }
            function Vt() {
              var Me = kt();
              return isNaN(Me) || Me < I;
            }
            function Xt(Me, ct) {
              var de = ct || {};
              P.trigger(Me, de, { streamId: k.id, mediaType: J });
            }
            function Ye(Me, ct) {
              if (I = Number.POSITIVE_INFINITY, Z = void 0, F = Number.POSITIVE_INFINITY, w = 0, fe = null, _ = !1, le = !1, ge = !1, R = 0, te = 0, oe = [], ce = NaN, N = !1, H) {
                var de = H;
                H = null, Me || ct || de.abort().then(function() {
                  de.reset(ct), de = null;
                });
              }
              V = !1;
            }
            return r = { initialize: function(Me) {
              Le(Me), P.on(o.Z.INIT_FRAGMENT_LOADED, ut, r), P.on(o.Z.MEDIA_FRAGMENT_LOADED, et, r), P.on(o.Z.WALLCLOCK_TIME_UPDATED, en, r), P.on(n.Z.PLAYBACK_PLAYING, Et, r), P.on(n.Z.PLAYBACK_PROGRESS, Ke, r), P.on(n.Z.PLAYBACK_TIME_UPDATED, Ke, r), P.on(n.Z.PLAYBACK_RATE_CHANGED, on, r), P.on(n.Z.PLAYBACK_STALLED, vt, r);
            }, getStreamId: function() {
              return k.id;
            }, getType: function() {
              return J;
            }, getBufferControllerType: function() {
              return Rt;
            }, createBufferSink: xe, dischargePreBuffer: function() {
              if (H && G && typeof G.discharge == "function") {
                var Me = G.getAllBufferRanges();
                if (Me.length > 0) {
                  for (var ct = "Beginning " + J + "PreBuffer discharge, adding buffer for:", de = 0; de < Me.length; de++) ct += " start: " + Me.start(de) + ", end: " + Me.end(de) + ";";
                  l.debug(ct);
                } else l.debug("PreBuffer discharge requested, but there were no media segments in the PreBuffer.");
                U = [];
                for (var _e = G.discharge(), Xe = null, Ct = 0; Ct < _e.length; Ct++) {
                  var xt = _e[Ct];
                  if (xt.segmentType !== Ue.w.INIT_SEGMENT_TYPE) {
                    var yn = q.extract(xt.streamId, xt.representationId);
                    yn && Xe !== yn && (U.push(yn), H.append(yn), Xe = yn);
                  }
                  U.push(xt), H.append(xt);
                }
                G.reset(), G = null;
              }
            }, getBuffer: function() {
              return H;
            }, getBufferLevel: function() {
              return R;
            }, getRangeAt: gt, hasBufferAtTime: function(Me) {
              try {
                var ct = H.getAllBufferRanges();
                if (!ct || ct.length === 0) return !1;
                for (var de = 0; de < ct.length; ) {
                  var _e = ct.start(de), Xe = ct.end(de);
                  if (Me >= _e && Me <= Xe) return !0;
                  de += 1;
                }
                return !1;
              } catch (Ct) {
                return l.error(Ct), !1;
              }
            }, pruneBuffer: je, setMediaSource: Le, getMediaSource: function() {
              return y;
            }, appendInitSegmentFromCache: function(Me) {
              var ct = q.extract(k.id, Me);
              return !!ct && (l.info("Append Init fragment", J, " with representationId:", ct.representationId, " and quality:", ct.quality, ", data size:", ct.bytes.byteLength), tt(ct), !0);
            }, getIsBufferingCompleted: function() {
              return _;
            }, setIsBufferingCompleted: ht, getIsPruningInProgress: function() {
              return le;
            }, reset: function(Me, ct) {
              P.off(o.Z.INIT_FRAGMENT_LOADED, ut, this), P.off(o.Z.MEDIA_FRAGMENT_LOADED, et, this), P.off(o.Z.WALLCLOCK_TIME_UPDATED, en, this), P.off(n.Z.PLAYBACK_PLAYING, Et, this), P.off(n.Z.PLAYBACK_PROGRESS, Ke, this), P.off(n.Z.PLAYBACK_TIME_UPDATED, Ke, this), P.off(n.Z.PLAYBACK_RATE_CHANGED, on, this), P.off(n.Z.PLAYBACK_STALLED, vt, this), Ye(Me, ct);
            }, prepareForPlaybackSeek: function() {
              return _ && ht(!1), H.abort();
            }, prepareForReplacementTrackSwitch: function(Me) {
              return new Promise(function(ct, de) {
                H.abort().then(function() {
                  return Qt();
                }).then(function() {
                  return pe.get().streaming.buffer.useChangeTypeForTrackSwitch ? H.changeType(Me) : Promise.resolve();
                }).then(function() {
                  return Be();
                }).then(function() {
                  ht(!1), ct();
                }).catch(function(_e) {
                  de(_e);
                });
              });
            }, prepareForNonReplacementTrackSwitch: function(Me) {
              return new Promise(function(ct, de) {
                Qt().then(function() {
                  return pe.get().streaming.buffer.useChangeTypeForTrackSwitch ? H.changeType(Me) : Promise.resolve();
                }).then(function() {
                  ct();
                }).catch(function(_e) {
                  de(_e);
                });
              });
            }, prepareForForceReplacementQualitySwitch: function(Me) {
              return new Promise(function(ct, de) {
                H.abort().then(function() {
                  return Qt();
                }).then(function() {
                  return Be();
                }).then(function() {
                  return $t(Me);
                }).then(function() {
                  ht(!1), ct();
                }).catch(function(_e) {
                  de(_e);
                });
              });
            }, updateAppendWindow: Qt, getAllRangesWithSafetyFactor: mt, getContinuousBufferTimeForTargetTime: Ht, clearBuffers: ot, pruneAllSafely: Be, updateBufferTimestampOffset: $t, setSeekTarget: function(Me) {
              ce = Me;
            }, segmentRequestingCompleted: function(Me) {
              isNaN(Me) || (F = Me, zt());
            } }, l = (0, h.Z)(g).getInstance().getLogger(r), q = Se(g).getInstance(), Ye(), r;
          }
          _t.__dashjs_factory_name = Rt;
          var qe = E.Z.getClassFactory(_t), it = "NotFragmentedTextBufferController";
          function me(i) {
            i = i || {};
            var r, l, _, R, I, y, w = this.context, F = (0, m.Z)(w).getInstance(), H = i.textController, G = i.errHandler, N = i.streamInfo, U = i.type;
            function Z(le) {
              R = le;
            }
            function fe(le) {
              var ge, q;
              l !== le && (l = le) && (ge = o.Z.BUFFERING_COMPLETED, q = {}, F.trigger(ge, q, { streamId: N.id, mediaType: U }));
            }
            function te(le) {
              le.chunk.bytes && !l && (y.save(le.chunk), I.append(le.chunk), fe(!0));
            }
            return r = { initialize: function(le) {
              Z(le);
            }, getStreamId: function() {
              return N.id;
            }, getType: function() {
              return U;
            }, getBufferControllerType: function() {
              return it;
            }, createBufferSink: function(le) {
              return new Promise(function(ge, q) {
                try {
                  (I = Te(w).create({ mediaSource: R, textController: H, eventBus: F })).initializeForFirstUse(N, le), _ || (I.getBuffer() && typeof I.getBuffer().initialize == "function" && I.getBuffer().initialize(), _ = !0), ge(I);
                } catch (oe) {
                  G.error(new ae.Z(Q.MEDIASOURCE_TYPE_UNSUPPORTED_CODE, Q.MEDIASOURCE_TYPE_UNSUPPORTED_MESSAGE + U)), q(oe);
                }
              });
            }, dischargePreBuffer: function() {
            }, getBuffer: function() {
              return I;
            }, getBufferLevel: function() {
              return 0;
            }, getRangeAt: function() {
              return null;
            }, pruneBuffer: function() {
            }, hasBufferAtTime: function() {
              return !0;
            }, getAllRangesWithSafetyFactor: function() {
              return [];
            }, getContinuousBufferTimeForTargetTime: function() {
              return Number.POSITIVE_INFINITY;
            }, setMediaSource: Z, getMediaSource: function() {
              return R;
            }, appendInitSegmentFromCache: function(le) {
              return y.extract(N.id, le) !== null;
            }, getIsBufferingCompleted: function() {
              return l;
            }, setIsBufferingCompleted: fe, getIsPruningInProgress: function() {
              return !1;
            }, reset: function(le) {
              F.off(o.Z.INIT_FRAGMENT_LOADED, te, r), !le && I && (I.abort(), I.reset(), I = null);
            }, clearBuffers: function() {
              return Promise.resolve();
            }, prepareForPlaybackSeek: function() {
              return Promise.resolve();
            }, prepareForReplacementTrackSwitch: function() {
              return l = !1, Promise.resolve();
            }, setSeekTarget: function() {
            }, updateAppendWindow: function() {
              return Promise.resolve();
            }, pruneAllSafely: function() {
              return Promise.resolve();
            }, updateBufferTimestampOffset: function() {
              return Promise.resolve();
            }, segmentRequestingCompleted: function() {
            } }, _ = !1, R = null, l = !1, y = Se(w).getInstance(), F.on(o.Z.INIT_FRAGMENT_LOADED, te, r), r;
          }
          me.__dashjs_factory_name = it;
          var ye = E.Z.getClassFactory(me);
          function Ve(i) {
            i = i || {};
            var r, l, _, R, I, y, w, F, H, G, N, U, Z, fe = this.context, te = (0, m.Z)(fe).getInstance(), le = i.dashMetrics, ge = i.mediaPlayerModel, q = i.fragmentModel, oe = i.abrController, V = i.playbackController, ce = i.textController, g = i.type, P = i.bufferController, D = i.representationController, O = i.settings;
            function A() {
              U = !0;
            }
            function ne() {
              U = !1;
            }
            function z(st) {
              if (!P.getIsBufferingCompleted()) {
                se();
                var ut = isNaN(st) ? 0 : st;
                I = setTimeout(X, ut);
              }
            }
            function se() {
              I && (clearTimeout(I), I = null);
            }
            function X() {
              try {
                if (function() {
                  try {
                    return g === t.Z.TEXT && !ce.isTextEnabled() || V.isPaused() && (!V.getStreamController().getInitialPlayback() || !V.getStreamController().getAutoPlay()) && !O.get().streaming.scheduling.scheduleWhilePaused;
                  } catch {
                    return !1;
                  }
                }()) return void se();
                if (function() {
                  try {
                    return !!U && D.getCurrentRepresentationInfo() && (isNaN(H) || G || (et = l.id, tt = oe.getMaxAllowedIndexFor(g, et), !(!isNaN(F) && F == tt || (_.info("Top quality " + g + " index has changed from " + F + " to " + tt), F = tt, 0))) || function() {
                      var Ut = D.getCurrentRepresentationInfo();
                      return !g || !Ut || le.getCurrentBufferLevel(g) < k();
                    }());
                  } catch {
                    return !1;
                  }
                  var et, tt;
                }()) {
                  var st = !1;
                  Z && (st = oe.checkPlaybackQuality(g, l.id)), st || (ut = D.getCurrentRepresentationInfo(), N || ut.quality !== H || G ? (G ? (_.debug("Switch track for " + g + ", representation id = " + ut.id), G = !1) : _.debug("Quality has changed, get init request for representationid = " + ut.id), te.trigger(o.Z.INIT_FRAGMENT_NEEDED, { representationId: ut.id, sender: r }, { streamId: l.id, mediaType: g }), Z = !1, N = !1) : (_.debug("Media segment needed for ".concat(g, " and stream id ").concat(l.id)), te.trigger(o.Z.MEDIA_FRAGMENT_NEEDED, {}, { streamId: l.id, mediaType: g }), Z = !0));
                } else z(V.getLowLatencyModeEnabled() ? O.get().streaming.scheduling.lowLatencyTimeout : O.get().streaming.scheduling.defaultTimeout);
              } catch {
                z(V.getLowLatencyModeEnabled() ? O.get().streaming.scheduling.lowLatencyTimeout : O.get().streaming.scheduling.defaultTimeout);
              }
              var ut;
            }
            function k() {
              var st = NaN, ut = D.getCurrentRepresentationInfo();
              return g && ut && (st = g === t.Z.TEXT ? function() {
                try {
                  if (ce.isTextEnabled()) {
                    var et = D.getCurrentRepresentationInfo();
                    if (isNaN(et.fragmentDuration)) {
                      var tt = le.getCurrentSchedulingInfo(p.Z.SCHEDULING_INFO);
                      return tt ? tt.duration : 0;
                    }
                    return et.fragmentDuration;
                  }
                  return 0;
                } catch {
                  return 0;
                }
              }() : g === t.Z.AUDIO && y ? function() {
                try {
                  var et = le.getCurrentBufferLevel(t.Z.VIDEO), tt = D.getCurrentRepresentationInfo();
                  return isNaN(tt.fragmentDuration) ? et + 1 : Math.max(et + 1, tt.fragmentDuration);
                } catch {
                  return 0;
                }
              }() : function() {
                try {
                  var et = D.getCurrentRepresentationInfo().mediaInfo.streamInfo;
                  return oe.isPlayingAtTopQuality(et) ? et.manifestInfo.duration >= O.get().streaming.buffer.longFormContentDurationThreshold ? O.get().streaming.buffer.bufferTimeAtTopQualityLongForm : O.get().streaming.buffer.bufferTimeAtTopQuality : ge.getStableBufferTime();
                } catch {
                  return ge.getStableBufferTime();
                }
              }()), st;
            }
            function J() {
              pe(!0);
            }
            function pe(st) {
              if (V && q) {
                var ut = q.getRequests({ state: K.FRAGMENT_MODEL_EXECUTED, time: V.getTime(), threshold: 0 })[0];
                ut && V.getTime() >= ut.startTime && ((!w.mediaInfo || ut.mediaInfo.type === w.mediaInfo.type && ut.mediaInfo.index !== w.mediaInfo.index) && st && te.trigger(o.Z.TRACK_CHANGE_RENDERED, { mediaType: g, oldMediaInfo: w.mediaInfo, newMediaInfo: ut.mediaInfo, streamId: l.id }), ut.quality === w.quality && ut.adaptationIndex === w.adaptationIndex || !st || (_.debug("Quality change rendered for streamId ".concat(l.id, " and type ").concat(g)), te.trigger(o.Z.QUALITY_CHANGE_RENDERED, { mediaType: g, oldQuality: w.quality, newQuality: ut.quality, streamId: l.id })), w = { mediaInfo: ut.mediaInfo, quality: ut.quality, adaptationIndex: ut.adaptationIndex });
              }
            }
            function Le() {
              q.abortRequests(), se();
            }
            function Ie() {
              O.get().streaming.scheduling.scheduleWhilePaused || z();
            }
            function xe(st) {
              le.updatePlayListTraceMetrics({ playbackspeed: st.playbackRate.toString() });
            }
            function De() {
              Z = !0, R = 0, H = NaN, w = { mediaInfo: void 0, quality: NaN, adaptationIndex: NaN }, F = NaN, G = !1, N = !1, U = !0;
            }
            return r = { initialize: function(st) {
              y = st, te.on(o.Z.URL_RESOLUTION_FAILED, Le, r), te.on(n.Z.PLAYBACK_STARTED, Ie, r), te.on(n.Z.PLAYBACK_RATE_CHANGED, xe, r), te.on(n.Z.PLAYBACK_TIME_UPDATED, J, r), te.on(n.Z.MANAGED_MEDIA_SOURCE_START_STREAMING, A, r), te.on(n.Z.MANAGED_MEDIA_SOURCE_END_STREAMING, ne, r);
            }, getType: function() {
              return g;
            }, getStreamId: function() {
              return l.id;
            }, setTimeToLoadDelay: function(st) {
              R = st;
            }, getTimeToLoadDelay: function() {
              return R;
            }, setSwitchTrack: function(st) {
              G = st;
            }, getSwitchTrack: function() {
              return G;
            }, startScheduleTimer: z, clearScheduleTimer: se, reset: function() {
              te.off(o.Z.URL_RESOLUTION_FAILED, Le, r), te.off(n.Z.PLAYBACK_STARTED, Ie, r), te.off(n.Z.PLAYBACK_RATE_CHANGED, xe, r), te.off(n.Z.PLAYBACK_TIME_UPDATED, J, r), te.off(n.Z.MANAGED_MEDIA_SOURCE_START_STREAMING, A, r), te.off(n.Z.MANAGED_MEDIA_SOURCE_END_STREAMING, ne, r), se(), pe(!1), De(), l = null;
            }, getBufferTarget: k, getPlaybackController: function() {
              return V;
            }, setCheckPlaybackQuality: function(st) {
              Z = st;
            }, setInitSegmentRequired: function(st) {
              N = st;
            }, setLastInitializedQuality: function(st) {
              H = st;
            } }, _ = (0, h.Z)(fe).getInstance().getLogger(r), De(), l = i.streamInfo, r;
          }
          Ve.__dashjs_factory_name = "ScheduleController";
          var f = E.Z.getClassFactory(Ve), u = C(7387);
          function v(i) {
            var r, l, _, R, I, y, w = (i = i || {}).eventBus, F = i.events, H = i.abrController, G = i.dashMetrics, N = i.playbackController, U = i.timelineConverter, Z = i.type, fe = i.streamInfo, te = i.dashConstants, le = i.segmentsController, ge = i.isDynamic, q = i.adapter;
            function oe() {
              return Z;
            }
            function V() {
              return _;
            }
            function ce() {
              return y;
            }
            function g() {
              l = null, _ = !0, R = [], I = null;
            }
            function P(se) {
              return new Promise(function(X, k) {
                var J = se.hasInitialization(), pe = se.hasSegments(), Le = [];
                Le.push(le.updateInitData(se, J)), Le.push(le.updateSegmentData(se, pe)), Promise.all(Le).then(function(Ie) {
                  var xe;
                  Ie[0] && !Ie[0].error && (se = function(De, st) {
                    return st && !st.error && st.representation ? st.representation : De;
                  }(se, Ie[0])), Ie[1] && !Ie[1].error && (se = function(De, st) {
                    if (st && !st.error) {
                      var ut, et, tt, Ut, be = st.segments, Be = [], mt = 0;
                      for (ut = 0, et = be ? be.length : 0; ut < et; ut++) tt = be[ut], (Ut = (0, u.TJ)(U, ge, De, tt.startTime, tt.duration, tt.timescale, tt.media, tt.mediaRange, mt)) && (Be.push(Ut), Ut = null, mt++);
                      return Be.length > 0 && (De.segments = Be), De;
                    }
                  }(se, Ie[1])), (xe = se).mediaFinishedInformation = le.getMediaFinishedInformation(xe), function(De) {
                    if (V()) {
                      var st, ut, et = G.getCurrentManifestUpdate(), tt = !1;
                      if (et) {
                        for (var Ut = 0; Ut < et.representationInfo.length; Ut++) if ((st = et.representationInfo[Ut]).index === De.index && st.mediaType === oe()) {
                          tt = !0;
                          break;
                        }
                        tt || G.addManifestUpdateRepresentationInfo(De, oe());
                      }
                      if (function() {
                        for (var Be = 0, mt = R.length; Be < mt; Be++) {
                          var Ke = R[Be].segmentInfoType;
                          if (!R[Be].hasInitialization() || (Ke === te.SEGMENT_BASE || Ke === te.BASE_URL) && !R[Be].segments) return !1;
                        }
                        return !0;
                      }()) {
                        H.setPlaybackQuality(Z, fe, (ut = y, R.indexOf(ut)));
                        var be = G.getCurrentDVRInfo(Z);
                        be && G.updateManifestUpdateInfo({ latency: be.range.end - N.getTime() }), G.getCurrentRepresentationSwitch(ce().adaptation.type) || D(), A();
                      }
                    }
                  }(se), X();
                }).catch(function(Ie) {
                  k(Ie);
                });
              });
            }
            function D() {
              (function() {
                if (!(H && G && N && U)) throw new Error(t.Z.MISSING_CONFIG_ERROR);
              })();
              var se = /* @__PURE__ */ new Date(), X = ce(), k = 1e3 * N.getTime();
              X && G.addRepresentationSwitch(X.adaptation.type, se, k, X.id), w.trigger(n.Z.REPRESENTATION_SWITCH, { mediaType: Z, streamId: fe.id, currentRepresentation: X, numberOfRepresentations: R.length }, { streamId: fe.id, mediaType: Z });
            }
            function O(se) {
              return se == null || se >= R.length ? null : R[se];
            }
            function A(se) {
              _ = !1, w.trigger(F.DATA_UPDATE_COMPLETED, { data: l, currentRepresentation: y, error: se }, { streamId: fe.id, mediaType: Z });
            }
            function ne(se) {
              y = se, I = q.convertRepresentationToRepresentationInfo(y);
            }
            function z(se) {
              if (se.newDuration) {
                var X = ce();
                X && X.adaptation.period && (X.adaptation.period.duration = se.newDuration);
              }
            }
            return r = { getStreamId: function() {
              return fe.id;
            }, getType: oe, getData: function() {
              return l;
            }, isUpdating: V, updateData: function(se, X, k, J, pe) {
              return new Promise(function(Le, Ie) {
                if (_ = !0, R = X, l = se, ne(O(pe)), k !== t.Z.VIDEO && k !== t.Z.AUDIO && (k !== t.Z.TEXT || !J)) return A(), void Le();
                for (var xe = [], De = 0, st = R.length; De < st; De++) {
                  var ut = R[De];
                  xe.push(P(ut));
                }
                Promise.all(xe).then(function() {
                  ne(O(pe)), Le();
                }).catch(function(et) {
                  Ie(et);
                });
              });
            }, getCurrentRepresentation: ce, getCurrentRepresentationInfo: function() {
              return I;
            }, getRepresentationForQuality: O, prepareQualityChange: function(se) {
              ne(O(se)), D();
            }, reset: function() {
              w.off(n.Z.MANIFEST_VALIDITY_CHANGED, z, r), g();
            } }, g(), w.on(n.Z.MANIFEST_VALIDITY_CHANGED, z, r), r;
          }
          v.__dashjs_factory_name = "RepresentationController";
          var b = E.Z.getClassFactory(v), W = C(3106), Y = C(9326), Re = C(7473), Je = C(2594);
          function Ze(i, r) {
            if (!(i instanceof r)) throw new TypeError("Cannot call a class as a function");
          }
          var Fe = function i() {
            Ze(this, i), this.start = null, this.mstart = null, this.starttype = null, this.trace = [];
          };
          Fe.INITIAL_PLAYOUT_START_REASON = "initial_playout", Fe.SEEK_START_REASON = "seek", Fe.RESUME_FROM_PAUSE_START_REASON = "resume", Fe.METRICS_COLLECTION_START_REASON = "metrics_collection_start";
          var we = function i() {
            Ze(this, i), this.representationid = null, this.subreplevel = null, this.start = null, this.mstart = null, this.duration = null, this.playbackspeed = null, this.stopreason = null;
          };
          we.REPRESENTATION_SWITCH_STOP_REASON = "representation_switch", we.REBUFFERING_REASON = "rebuffering", we.USER_REQUEST_STOP_REASON = "user_request", we.END_OF_PERIOD_STOP_REASON = "end_of_period", we.END_OF_CONTENT_STOP_REASON = "end_of_content", we.METRICS_COLLECTION_STOP_REASON = "metrics_collection_end", we.FAILURE_STOP_REASON = "failure";
          var Ge = C(7802);
          function nt() {
            return { ntpToUTC: function(i) {
              var r = new Date(Date.UTC(1900, 0, 1, 0, 0, 0));
              return new Date(r.getTime() + i).getTime();
            } };
          }
          nt.__dashjs_factory_name = "TimeUtils";
          var Tt = E.Z.getSingletonFactory(nt);
          function ft(i) {
            i = i || {};
            var r, l, _, R, I, y, w, F, H, G, N, U, Z, fe, te, le = this.context, ge = (0, m.Z)(le).getInstance(), q = i.streamInfo, oe = i.type, V = i.errHandler, ce = i.mimeType, g = i.timelineConverter, P = i.adapter, D = i.manifestModel, O = i.mediaPlayerModel, A = i.fragmentModel, ne = i.abrController, z = i.playbackController, se = i.mediaController, X = i.textController, k = i.dashMetrics, J = i.settings, pe = i.boxParser, Le = i.segmentBlacklistController;
            function Ie() {
              return q.id;
            }
            function xe() {
              return oe;
            }
            function De() {
              return P.getIsTextTrack(F.getData());
            }
            function st() {
              I = [], R = null, fe = 0, H = !1, G = !1, N = !1, te = null;
            }
            function ut(Ye) {
              return !isNaN(Ye) && !isNaN(q.duration) && isFinite(q.duration) && Ye >= q.start + q.duration;
            }
            function et(Ye) {
              var Me = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
              if (Ye.sender) {
                if (z.getIsManifestUpdateInProgress()) mt();
                else if ((!De() || X.isTextEnabled()) && y && Ye.representationId && !y.appendInitSegmentFromCache(Ye.representationId)) {
                  var ct = F.getCurrentRepresentation();
                  if (ct.range === 0) return void tt();
                  var de = U ? U.getInitRequest(R, ct) : null;
                  de ? A.executeRequest(de) : Me && (w.setInitSegmentRequired(!0), mt());
                }
              }
            }
            function tt(Ye) {
              var Me = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
              if (z.getIsManifestUpdateInProgress() || y.getIsPruningInProgress()) mt();
              else {
                var ct = Be();
                ct ? (H = !1, G = !1, Ut(ct)) : be(Me);
              }
            }
            function Ut(Ye) {
              isNaN(Ye.startTime + Ye.duration) || (fe = Ye.startTime + Ye.duration), Ye.delayLoadingTime = (/* @__PURE__ */ new Date()).getTime() + w.getTimeToLoadDelay(), w.setTimeToLoadDelay(0), function(Me) {
                var ct = Me.url;
                return Me.range && (ct = ct.concat("_", Me.range)), Le.contains(ct);
              }(Ye) ? (l.warn("Fragment request url ".concat(Ye.url, " for stream id ").concat(q.id, " and media type ").concat(oe, " is on the ignore list and will be skipped")), mt()) : (l.debug("Next fragment request url for stream id ".concat(q.id, " and media type ").concat(oe, " is ").concat(Ye.url)), A.executeRequest(Ye));
            }
            function be(Ye) {
              var Me, ct = F.getCurrentRepresentation();
              if (!J.get().streaming.gaps.enableSeekFix || !H && z.getTime() !== 0 || (_ ? _ && ct.segmentInfoType === e.Z.SEGMENT_TIMELINE && (Me = U.getValidTimeAheadOfTargetTime(fe, R, ct, J.get().streaming.gaps.threshold)) : Me = U.getValidTimeAheadOfTargetTime(fe, R, ct, J.get().streaming.gaps.threshold), isNaN(Me) || Me === fe)) {
                if (U.isLastSegmentRequested(ct, fe)) {
                  var de = U.getCurrentIndex();
                  return l.debug("Segment requesting for stream ".concat(q.id, " has finished")), ge.trigger(o.Z.STREAM_REQUESTING_COMPLETED, { segmentIndex: de }, { streamId: q.id, mediaType: oe }), y.segmentRequestingCompleted(de), void w.clearScheduleTimer();
                }
                Ye && mt();
              } else z.isSeeking() || z.getTime() === 0 ? (l.warn("Adjusting playback time ".concat(Me, " because of gap in the manifest. Seeking by ").concat(Me - fe)), z.seek(Me, !1, !1)) : (l.warn("Adjusting buffering time ".concat(Me, " because of gap in the manifest. Adjusting time by ").concat(Me - fe)), Xt(Me), Ye && mt());
            }
            function Be() {
              var Ye, Me = Qt();
              if (isNaN(fe) || xe() === t.Z.TEXT && !X.isTextEnabled()) return null;
              if (U) {
                var ct = F && Me ? F.getRepresentationForQuality(Me.quality) : null;
                Ye = H ? U.getSegmentRequestForTime(R, ct, fe) : G ? U.repeatSegmentRequest(R, ct) : U.getNextSegmentRequest(R, ct);
              }
              return Ye;
            }
            function mt() {
              w.startScheduleTimer(z.getLowLatencyModeEnabled() ? J.get().streaming.scheduling.lowLatencyTimeout : J.get().streaming.scheduling.defaultTimeout);
            }
            function Ke(Ye) {
              Ye.error || y.getIsBufferingCompleted() || y.updateBufferTimestampOffset(Ye.currentRepresentation);
            }
            function vt(Ye) {
              k.addBufferState(oe, Ye.state, w.getBufferTarget()), Ye.state !== p.Z.BUFFER_EMPTY || z.isSeeking() || (l.info("Buffer is empty! Stalling!"), k.pushPlayListTraceMetrics(/* @__PURE__ */ new Date(), we.REBUFFERING_REASON));
            }
            function Et(Ye) {
              A.syncExecutedRequestsWithBufferedRange(y.getBuffer().getAllBufferRanges(), q.duration), Ye.quotaExceeded && Ye.from > z.getTime() && Xt(Ye.from), Ye.hasEnoughSpaceToAppend && Ye.quotaExceeded && w.startScheduleTimer();
            }
            function gt(Ye) {
              if (Ye && Ye.lastRequestAppended && Ye.lastRequestAppended.url) {
                var Me = Ye.lastRequestAppended.url;
                Ye.lastRequestAppended.range && (Me = Me.concat("_", Ye.lastRequestAppended.range)), l.warn("Blacklisting segment with url ".concat(Me)), Le.add(Me);
              }
            }
            function Wt(Ye) {
              if (l.debug("Appended bytes for ".concat(Ye.mediaType, " and stream id ").concat(Ye.streamId)), Ye.segmentType === Ue.w.INIT_SEGMENT_TYPE) {
                var Me = Ye.quality;
                w.setLastInitializedQuality(Me), l.info("[" + oe + "] lastInitializedRepresentationInfo changed to " + Ye.quality);
              }
              te ? zt(te) : w.startScheduleTimer(0);
            }
            function zt(Ye) {
              var Me = A.getRequests({ state: K.FRAGMENT_MODEL_LOADING });
              if (Me && Me.length > 0) return l.debug("Preparing for default quality switch: Waiting for ongoing segment request to be finished before applying switch."), void (te = Ye);
              y.updateBufferTimestampOffset(Ye).then(function() {
                w.setCheckPlaybackQuality(!1), R.segmentAlignment || R.subSegmentAlignment ? w.startScheduleTimer() : Ht(), te = null, N = !1;
              }).catch(function() {
                te = null, N = !1;
              });
            }
            function gn(Ye) {
              l.info("onFragmentLoadingAbandoned request: " + Ye.request.url + " has been aborted"), z.isSeeking() || w.getSwitchTrack() || N || (l.info("onFragmentLoadingAbandoned request: " + Ye.request.url + " has to be downloaded again, origin is not seeking process or switch track call"), Ye.request && Ye.request.isInitializationRequest() ? w.setInitSegmentRequired(!0) : Xt(Ye.request.startTime + Ye.request.duration / 2), w.startScheduleTimer(0));
            }
            function pn(Ye) {
              l.info("OnFragmentLoadingCompleted for stream id " + q.id + " and media type " + oe + " - Url:", Ye.request ? Ye.request.url : "undefined", Ye.request.range ? ", Range:" + Ye.request.range : ""), De() && w.startScheduleTimer(0), Ye.error && Ye.request.serviceLocation && function(Me) {
                l.info("Fragment loading completed with an error"), Me && Me.request && Me.request.type && (Me.request.type === Ue.w.INIT_SEGMENT_TYPE ? et({ representationId: Me.request.representationId, sender: {} }, !1) : Me.request.type === Ue.w.MEDIA_SEGMENT_TYPE && (Xt(Me.request.startTime + Me.request.duration / 2), tt({}, !1)));
              }(Ye);
            }
            function je() {
              Xt(z.getTime()), $t().startScheduleTimer();
            }
            function yt(Ye) {
              var Me = Ye.currentTrackInfo;
              if (Me) {
                var ct = I.find(function(de) {
                  return de.index === Me.index && de.lang === Me.lang;
                });
                ct && Lt(ct).then(function() {
                  y.setIsBufferingCompleted(!1), Xt(z.getTime()), w.setInitSegmentRequired(!0), w.startScheduleTimer();
                });
              }
            }
            function ot(Ye) {
              Xt(Ye.quotaExceededTime), w.clearScheduleTimer();
            }
            function It() {
              return y ? y.getBuffer() : null;
            }
            function Lt(Ye) {
              Ye === R || Ye && R && Ye.type !== R.type || (R = Ye);
              var Me = P.getRealAdaptation(q, R), ct = P.getVoRepresentations(R);
              if (F) {
                var de, _e = F.getData(), Xe = ne.getMaxAllowedIndexFor(oe, q.id), Ct = ne.getMinAllowedIndexFor(oe, q.id), xt = null;
                return _e !== null && _e.id === Me.id || oe === t.Z.TEXT ? de = ne.getQualityFor(oe, q.id) : (xt = ne.getThroughputHistory().getAverageThroughput(oe, _) || ne.getInitialBitrateFor(oe, q.id), de = ne.getQualityForBitrate(R, xt, q.id)), Ct !== void 0 && de < Ct && (de = Ct), de > Xe && (de = Xe), F.updateData(Me, ct, oe, R.isFragmented, de);
              }
              return Promise.resolve();
            }
            function $t() {
              return w;
            }
            function Qt(Ye) {
              var Me;
              return Ye !== void 0 ? ((0, W.SE)(Ye), Me = F ? F.getRepresentationForQuality(Ye) : null) : Me = F ? F.getCurrentRepresentation() : null, P.convertRepresentationToRepresentationInfo(Me);
            }
            function en() {
              return !!y && y.getIsBufferingCompleted();
            }
            function on(Ye) {
              if (J.get().streaming.enableManifestTimescaleMismatchFix) {
                var Me = Ye.chunk, ct = Me.bytes, de = Qt(Me.quality), _e = F && de ? F.getRepresentationForQuality(de.quality) : null;
                de && _e && (_e.timescale = pe.getMediaTimescaleFromMoov(ct));
              }
            }
            function ht(Ye) {
              var Me = Ye.chunk, ct = Me.bytes, de = Me.quality, _e = Qt(de), Xe = F && _e ? F.getRepresentationForQuality(_e.quality) : null;
              if (_e && Xe) {
                var Ct;
                if (J.get().streaming.parseInbandPrft && Ye.request.type === Ue.w.MEDIA_SEGMENT_TYPE) {
                  var xt = function(fr, Jn) {
                    var Gr = fr.getBoxes("prft"), zr = [];
                    return Gr.forEach(function(Wr) {
                      zr.push(function(Cr, Lr) {
                        var dr = "unknown";
                        switch (Cr.flags) {
                          case 0:
                            dr = e.Z.PRODUCER_REFERENCE_TIME_TYPE.ENCODER;
                            break;
                          case 16:
                            dr = e.Z.PRODUCER_REFERENCE_TIME_TYPE.APPLICATION;
                            break;
                          case 24:
                            dr = e.Z.PRODUCER_REFERENCE_TIME_TYPE.CAPTURED;
                        }
                        var qr = 1e3 * Cr.ntp_timestamp_sec + Cr.ntp_timestamp_frac / Math.pow(2, 32) * 1e3;
                        return { type: dr, ntpTimestamp: qr = Tt(le).getInstance().ntpToUTC(qr), mediaTime: Cr.media_time / Lr };
                      }(Wr, Jn));
                    }), zr;
                  }(Ct = Ct || pe.parse(ct), Xe.timescale);
                  xt && xt.length && ge.trigger(n.Z.INBAND_PRFT, { data: xt }, { streamId: q.id, mediaType: oe });
                }
                var yn = P.getEventsFor(_e.mediaInfo, null, q), On = P.getEventsFor(_e, Xe, q);
                if (yn && yn.length > 0 || On && On.length > 0) {
                  var zn = A.getRequests({ state: K.FRAGMENT_MODEL_EXECUTED, quality: de, index: Me.index })[0], Nn = function(fr, Jn, Gr, zr) {
                    try {
                      for (var Wr = {}, Cr = [], Lr = Gr.concat(zr), dr = 0, qr = Lr.length; dr < qr; dr++) Wr[Lr[dr].schemeIdUri + "/" + Lr[dr].value] = Lr[dr];
                      var Qr = fr.getBoxes("emsg");
                      if (!Qr || Qr.length === 0) return Cr;
                      for (var Ar = fr.getBox("sidx"), Si = !Ar || isNaN(Ar.earliest_presentation_time) || isNaN(Ar.timescale) ? Jn && !isNaN(Jn.mediaStartTime) ? Jn.mediaStartTime : 0 : Ar.earliest_presentation_time / Ar.timescale, $i = Math.max(Si, 0), Ji = F.getCurrentRepresentation(), Hr = 0, ea = Qr.length; Hr < ea; Hr++) {
                        var Xr = P.getEvent(Qr[Hr], Wr, $i, Ji);
                        Xr && Cr.push(Xr);
                      }
                      return Cr;
                    } catch {
                      return [];
                    }
                  }(Ct = Ct || pe.parse(ct), zn, yn, On);
                  ge.trigger(o.Z.INBAND_EVENTS, { events: Nn }, { streamId: q.id });
                }
              }
            }
            function kt() {
              var Ye = z.getTime();
              J.get().streaming.buffer.flushBufferAtTrackSwitch && z.seek(Ye + 1e-3, !1, !0), Xt(Ye), y.setSeekTarget(Ye), w.startScheduleTimer();
            }
            function Ht() {
              var Ye = z.getTime(), Me = y.getContinuousBufferTimeForTargetTime(Ye);
              Xt(isNaN(Me) ? Ye : Me), w.startScheduleTimer();
            }
            function Vt(Ye) {
              Ye && !isNaN(Ye.time) && (Xt(Ye.time), y.setSeekTarget(Ye.time));
            }
            function Xt(Ye) {
              fe = Ye, H = !0;
            }
            return r = { initialize: function(Ye, Me, ct) {
              Z = (0, Ge.Z)(le).create({ events: o.Z, eventBus: ge, streamInfo: q, timelineConverter: g, dashConstants: e.Z, segmentBaseController: i.segmentBaseController, type: oe }), U = (0, Y.Z)(le).create({ streamInfo: q, type: oe, timelineConverter: g, dashMetrics: k, mediaPlayerModel: O, baseURLController: i.baseURLController, errHandler: V, segmentsController: Z, settings: J, boxParser: pe, events: o.Z, eventBus: ge, errors: Q, debug: (0, h.Z)(le).getInstance(), requestModifier: (0, Re.Z)(le).getInstance(), dashConstants: e.Z, constants: t.Z, urlUtils: (0, Je.Z)(le).getInstance() }), _ = q.manifestInfo.isDynamic, U.initialize(_), ne.registerStreamType(oe, r), F = b(le).create({ streamInfo: q, type: oe, abrController: ne, dashMetrics: k, playbackController: z, timelineConverter: g, dashConstants: e.Z, events: o.Z, eventBus: ge, errors: Q, isDynamic: _, adapter: P, segmentsController: Z }), y = function(de, _e) {
                return de ? de !== t.Z.TEXT || _e ? qe(le).create({ streamInfo: q, type: de, mediaPlayerModel: O, manifestModel: D, fragmentModel: A, errHandler: V, mediaController: se, representationController: F, adapter: P, textController: X, abrController: ne, playbackController: z, settings: J }) : ye(le).create({ streamInfo: q, type: de, mimeType: ce, fragmentModel: A, textController: X, errHandler: V, settings: J }) : (V.error(new ae.Z(Q.MEDIASOURCE_TYPE_UNSUPPORTED_CODE, Q.MEDIASOURCE_TYPE_UNSUPPORTED_MESSAGE + "not properly defined")), null);
              }(oe, ct), y && y.initialize(Ye), (w = f(le).create({ streamInfo: q, type: oe, mimeType: ce, adapter: P, dashMetrics: k, mediaPlayerModel: O, fragmentModel: A, abrController: ne, playbackController: z, textController: X, mediaController: se, bufferController: y, representationController: F, settings: J })).initialize(Me), fe = 0, H = !1, G = !1;
            }, getStreamId: Ie, getType: xe, isUpdating: function() {
              return !!F && F.isUpdating();
            }, getBufferController: function() {
              return y;
            }, dischargePreBuffer: function() {
              y.dischargePreBuffer();
            }, getFragmentModel: function() {
              return A;
            }, getScheduleController: $t, getRepresentationController: function() {
              return F;
            }, getRepresentationInfo: Qt, getBufferLevel: function() {
              return y ? y.getBufferLevel() : 0;
            }, isBufferingCompleted: en, createBufferSinks: function(Ye) {
              var Me = It();
              return Me ? Promise.resolve(Me) : y ? y.createBufferSink(R, Ye) : Promise.resolve(null);
            }, updateStreamInfo: function(Ye) {
              return q = Ye, en() ? Promise.resolve() : y.updateAppendWindow();
            }, getStreamInfo: function() {
              return q;
            }, selectMediaInfo: Lt, clearMediaInfoArray: function() {
              I = [];
            }, addMediaInfo: function(Ye) {
              I.indexOf(Ye) === -1 && I.push(Ye);
            }, prepareTrackSwitch: function() {
              return new Promise(function(Ye) {
                l.debug("Preparing track switch for type ".concat(oe));
                var Me = oe === t.Z.TEXT || J.get().streaming.trackSwitchMode[oe] === t.Z.TRACK_SWITCH_MODE_ALWAYS_REPLACE && z.getTimeToStreamEnd(q) > J.get().streaming.buffer.stallThreshold;
                if (y.getIsBufferingCompleted() && !Me) return y.prepareForNonReplacementTrackSwitch(R.codec).then(function() {
                  ge.trigger(o.Z.BUFFERING_COMPLETED, {}, { streamId: q.id, mediaType: oe });
                }).catch(function() {
                  ge.trigger(o.Z.BUFFERING_COMPLETED, {}, { streamId: q.id, mediaType: oe });
                }), void Ye();
                w.clearScheduleTimer(), w.setSwitchTrack(!0), Me ? (ge.trigger(o.Z.BUFFER_REPLACEMENT_STARTED, { mediaType: oe, streamId: q.id }, { mediaType: oe, streamId: q.id }), A.abortRequests(), y.prepareForReplacementTrackSwitch(R.codec).then(function() {
                  var ct = Qt();
                  return y.updateBufferTimestampOffset(ct);
                }).then(function() {
                  kt(), Ye();
                }).catch(function() {
                  kt(), Ye();
                })) : y.prepareForNonReplacementTrackSwitch(R.codec).then(function() {
                  Ht(), Ye();
                }).catch(function() {
                  Ht(), Ye();
                });
              });
            }, prepareQualityChange: function(Ye) {
              te && l.warn("Canceling queued representation switch to ".concat(te.quality, " for ").concat(oe)), l.debug("Preparing quality switch for type ".concat(oe));
              var Me = Ye.newQuality;
              N = !0, w.clearScheduleTimer(), F.prepareQualityChange(Me);
              var ct = Qt(Me);
              Ye.reason && Ye.reason.forceReplace ? function(de) {
                A.abortRequests(), ge.trigger(o.Z.BUFFER_REPLACEMENT_STARTED, { mediaType: oe, streamId: q.id }, { mediaType: oe, streamId: q.id }), w.setCheckPlaybackQuality(!1), y.prepareForForceReplacementQualitySwitch(de).then(function() {
                  kt(), te = null, N = !1;
                }).catch(function() {
                  kt(), te = null, N = !1;
                });
              }(ct) : Ye && Ye.reason && Ye.reason.forceAbandon ? function(de) {
                y.updateBufferTimestampOffset(de).then(function() {
                  A.abortRequests(), G = !0, w.setCheckPlaybackQuality(!1), w.startScheduleTimer(), N = !1, te = null;
                }).catch(function() {
                  te = null, N = !1;
                });
              }(ct) : J.get().streaming.buffer.fastSwitchEnabled ? function(de) {
                var _e = z.getTime(), Xe = 1.5 * (isNaN(de.fragmentDuration) ? 1 : de.fragmentDuration), Ct = A.getRequests({ state: K.FRAGMENT_MODEL_EXECUTED, time: _e + Xe, threshold: 0 })[0];
                if (Ct && !De()) {
                  var xt = y.getBufferLevel(), yn = ne.getAbandonmentStateFor(q.id, oe);
                  Ct.quality < de.quality && xt >= Xe && yn !== p.Z.ABANDON_LOAD ? y.updateBufferTimestampOffset(de).then(function() {
                    A.abortRequests(), Xt(_e + Xe), w.setCheckPlaybackQuality(!1), w.startScheduleTimer(), N = !1;
                  }).catch(function() {
                    N = !1;
                  }) : zt(de);
                } else zt(de);
              }(ct) : zt(ct), k.pushPlayListTraceMetrics(/* @__PURE__ */ new Date(), we.REPRESENTATION_SWITCH_STOP_REASON), k.createPlaylistTraceMetrics(ct.id, 1e3 * z.getTime(), z.getPlaybackRate());
            }, getMediaInfo: function() {
              return R;
            }, getMediaSource: function() {
              return y.getMediaSource();
            }, setMediaSource: function(Ye) {
              return y.setMediaSource(Ye, R);
            }, getBuffer: It, setExplicitBufferingTime: Xt, finalisePlayList: function(Ye, Me) {
              k.pushPlayListTraceMetrics(Ye, Me);
            }, probeNextRequest: function() {
              var Ye = Qt(), Me = F && Ye ? F.getRepresentationForQuality(Ye.quality) : null;
              return U.getNextSegmentRequestIdempotent(R, Me);
            }, prepareInnerPeriodPlaybackSeeking: function(Ye) {
              return new Promise(function(Me) {
                if (y.hasBufferAtTime(Ye.seekTime)) return y.pruneBuffer(), ut(y.getContinuousBufferTimeForTargetTime(Ye.seekTime)) && y.setIsBufferingCompleted(!0), void Me();
                w.clearScheduleTimer(), A.abortRequests(), y.prepareForPlaybackSeek().then(function() {
                  var ct = y.getAllRangesWithSafetyFactor(Ye.seekTime);
                  return y.clearBuffers(ct);
                }).then(function() {
                  var ct = y.getContinuousBufferTimeForTargetTime(Ye.seekTime);
                  if (ut(ct)) y.setIsBufferingCompleted(!0), Me();
                  else {
                    var de = isNaN(ct) ? Ye.seekTime : ct;
                    Xt(de), y.setSeekTarget(de);
                    var _e = [];
                    _e.push(y.updateAppendWindow());
                    var Xe = Qt();
                    _e.push(y.updateBufferTimestampOffset(Xe)), Promise.all(_e).then(function() {
                      w.setInitSegmentRequired(!0), w.setCheckPlaybackQuality(!1), w.startScheduleTimer(), Me();
                    });
                  }
                }).catch(function(ct) {
                  l.error(ct);
                });
              });
            }, prepareOuterPeriodPlaybackSeeking: function() {
              return new Promise(function(Ye, Me) {
                try {
                  w.clearScheduleTimer(), A.abortRequests(), y.prepareForPlaybackSeek().then(function() {
                    return y.pruneAllSafely();
                  }).then(function() {
                    Ye();
                  });
                } catch (ct) {
                  Me(ct);
                }
              });
            }, reset: function(Ye, Me) {
              U && U.reset(), y && (y.reset(Ye, Me), y = null), w && (w.reset(), w = null), F && (F.reset(), F = null), Z && (Z = null), ne && ne.unRegisterStreamType(Ie(), oe), ge.off(o.Z.DATA_UPDATE_COMPLETED, Ke, r), ge.off(o.Z.INIT_FRAGMENT_NEEDED, et, r), ge.off(o.Z.MEDIA_FRAGMENT_NEEDED, tt, r), ge.off(o.Z.INIT_FRAGMENT_LOADED, on, r), ge.off(o.Z.MEDIA_FRAGMENT_LOADED, ht, r), ge.off(o.Z.BUFFER_LEVEL_STATE_CHANGED, vt, r), ge.off(o.Z.BUFFER_CLEARED, Et, r), ge.off(o.Z.SEEK_TARGET, Vt, r), ge.off(o.Z.FRAGMENT_LOADING_ABANDONED, gn, r), ge.off(o.Z.FRAGMENT_LOADING_COMPLETED, pn, r), ge.off(o.Z.SET_FRAGMENTED_TEXT_AFTER_DISABLED, je, r), ge.off(o.Z.SET_NON_FRAGMENTED_TEXT, yt, r), ge.off(o.Z.QUOTA_EXCEEDED, ot, r), ge.off(o.Z.SOURCE_BUFFER_ERROR, gt, r), ge.off(o.Z.BYTES_APPENDED_END_FRAGMENT, Wt, r), st(), oe = null, q = null;
            } }, l = (0, h.Z)(le).getInstance().getLogger(r), st(), ge.on(o.Z.DATA_UPDATE_COMPLETED, Ke, r, { priority: m.Z.EVENT_PRIORITY_HIGH }), ge.on(o.Z.INIT_FRAGMENT_NEEDED, et, r), ge.on(o.Z.MEDIA_FRAGMENT_NEEDED, tt, r), ge.on(o.Z.INIT_FRAGMENT_LOADED, on, r), ge.on(o.Z.MEDIA_FRAGMENT_LOADED, ht, r), ge.on(o.Z.BUFFER_LEVEL_STATE_CHANGED, vt, r), ge.on(o.Z.BUFFER_CLEARED, Et, r), ge.on(o.Z.SEEK_TARGET, Vt, r), ge.on(o.Z.FRAGMENT_LOADING_ABANDONED, gn, r), ge.on(o.Z.FRAGMENT_LOADING_COMPLETED, pn, r), ge.on(o.Z.QUOTA_EXCEEDED, ot, r), ge.on(o.Z.SET_FRAGMENTED_TEXT_AFTER_DISABLED, je, r), ge.on(o.Z.SET_NON_FRAGMENTED_TEXT, yt, r), ge.on(o.Z.SOURCE_BUFFER_ERROR, gt, r), ge.on(o.Z.BYTES_APPENDED_END_FRAGMENT, Wt, r), r;
          }
          ft.__dashjs_factory_name = "StreamProcessor";
          var Yt = E.Z.getClassFactory(ft), Ot = function i() {
            (function(r, l) {
              if (!(r instanceof l)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.streamId = null, this.mediaInfo = null, this.segmentType = null, this.quality = NaN, this.index = NaN, this.bytes = null, this.start = NaN, this.end = NaN, this.duration = NaN, this.representationId = null, this.endFragment = null;
          }, qt = C(9032);
          function Bt(i, r) {
            if (i) {
              if (typeof i == "string") return cn(i, r);
              var l = Object.prototype.toString.call(i).slice(8, -1);
              return l === "Object" && i.constructor && (l = i.constructor.name), l === "Map" || l === "Set" ? Array.from(i) : l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l) ? cn(i, r) : void 0;
            }
          }
          function cn(i, r) {
            (r == null || r > i.length) && (r = i.length);
            for (var l = 0, _ = new Array(r); l < r; l++) _[l] = i[l];
            return _;
          }
          function vn(i) {
            i = i || {};
            var r, l, _ = this.context, R = i.requestModifier, I = i.lowLatencyThroughputModel, y = i.boxParser, w = (0, Ne.Z)(_).getInstance();
            function F(N) {
              var U, Z = /* @__PURE__ */ new Date(), fe = N.request, te = new Headers();
              if (fe.range && te.append("Range", "bytes=" + fe.range), N.headers) for (var le in N.headers) {
                var ge = N.headers[le];
                ge && te.append(le, ge);
              }
              fe.requestStartDate || (fe.requestStartDate = Z), R && R.modifyRequestHeader && R.modifyRequestHeader({ setRequestHeader: function(g, P) {
                te.append(g, P);
              } }, { url: N.url }), typeof window.AbortController == "function" && (U = new AbortController(), N.abortController = U, U.signal.onabort = N.onabort);
              var q = { method: N.method, headers: te, credentials: N.withCredentials ? "include" : void 0, signal: U ? U.signal : void 0 }, oe = w.get().streaming.abr.fetchThroughputCalculationMode, V = Date.now(), ce = 0;
              new Promise(function(g) {
                if (oe === t.Z.ABR_FETCH_THROUGHPUT_CALCULATION_AAST && I && (ce = I.getThroughputCapacityDelayMS(fe, 1e3 * l.getCurrentBufferLevel(fe.mediaType)))) return setTimeout(g, ce);
                g();
              }).then(function() {
                var g = Date.now();
                fetch(N.url, q).then(function(P) {
                  N.response || (N.response = {}), N.response.status = P.status, N.response.statusText = P.statusText, N.response.responseURL = P.url, P.ok || N.onerror();
                  var D, O = "", A = function(Ke, vt) {
                    var Et;
                    if (typeof Symbol > "u" || Ke[Symbol.iterator] == null) {
                      if (Array.isArray(Ke) || (Et = Bt(Ke))) {
                        Et && (Ke = Et);
                        var gt = 0, Wt = function() {
                        };
                        return { s: Wt, n: function() {
                          return gt >= Ke.length ? { done: !0 } : { done: !1, value: Ke[gt++] };
                        }, e: function(je) {
                          throw je;
                        }, f: Wt };
                      }
                      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
                    }
                    var zt, gn = !0, pn = !1;
                    return { s: function() {
                      Et = Ke[Symbol.iterator]();
                    }, n: function() {
                      var je = Et.next();
                      return gn = je.done, je;
                    }, e: function(je) {
                      pn = !0, zt = je;
                    }, f: function() {
                      try {
                        gn || Et.return == null || Et.return();
                      } finally {
                        if (pn) throw zt;
                      }
                    } };
                  }(P.headers.keys());
                  try {
                    for (A.s(); !(D = A.n()).done; ) {
                      var ne = D.value;
                      O += ne + ": " + P.headers.get(ne) + `\r
`;
                    }
                  } catch (Ke) {
                    A.e(Ke);
                  } finally {
                    A.f();
                  }
                  if (N.response.responseHeaders = O, !P.body) return P.arrayBuffer().then(function(Ke) {
                    N.response.response = Ke;
                    var vt = { loaded: Ke.byteLength, total: Ke.byteLength, stream: !1 };
                    N.progress(vt), N.onload(), N.onend();
                  });
                  var z, se, X, k, J = parseInt(P.headers.get("Content-Length"), 10), pe = 0, Le = !1, Ie = new Uint8Array(), xe = 0;
                  if (oe === t.Z.ABR_FETCH_THROUGHPUT_CALCULATION_AAST && I) {
                    var De = g, st = 0, ut = (X = P.body.tee(), k = 2, function(Ke) {
                      if (Array.isArray(Ke)) return Ke;
                    }(X) || function(Ke, vt) {
                      if (typeof Symbol < "u" && Symbol.iterator in Object(Ke)) {
                        var Et = [], gt = !0, Wt = !1, zt = void 0;
                        try {
                          for (var gn, pn = Ke[Symbol.iterator](); !(gt = (gn = pn.next()).done) && (Et.push(gn.value), !vt || Et.length !== vt); gt = !0) ;
                        } catch (je) {
                          Wt = !0, zt = je;
                        } finally {
                          try {
                            gt || pn.return == null || pn.return();
                          } finally {
                            if (Wt) throw zt;
                          }
                        }
                        return Et;
                      }
                    }(X, k) || Bt(X, k) || function() {
                      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
                    }()), et = ut[0], tt = ut[1];
                    z = et.getReader(), se = [], z.read().then(function Ke(vt) {
                      var Et = vt.value, gt = vt.done;
                      if (st = Date.now(), Et && Et.length) {
                        var Wt = st - De, zt = Et.length;
                        se.push({ chunkDownloadTimeRelativeMS: st - g, chunkDownloadDurationMS: Wt, chunkBytes: zt, kbps: Math.round(8 * zt / (Wt / 1e3)), bufferLevel: l.getCurrentBufferLevel(fe.mediaType) });
                      }
                      if (gt) {
                        var gn = st - g, pn = se.reduce(function(je, yt) {
                          return je + yt.chunkBytes;
                        }, 0);
                        return I.addMeasurement(fe, gn, se, V, ce, O), void N.progress({ loaded: pn, total: pn, lengthComputable: !0, time: I.getEstimatedDownloadDurationMS(fe), stream: !0 });
                      }
                      return De = Date.now(), z.read().then(Ke);
                    }), N.reader = tt.getReader();
                  } else N.reader = P.body.getReader();
                  var Ut = [], be = [], Be = [], mt = !0;
                  H(N, function Ke(vt) {
                    var Et = vt.value;
                    if (vt.done) {
                      if (Ie) {
                        if (oe !== t.Z.ABR_FETCH_THROUGHPUT_CALCULATION_AAST) {
                          var gt = null, Wt = null;
                          oe === t.Z.ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING ? (gt = function(je, yt) {
                            try {
                              var ot, It;
                              ot = je.filter(function(kt, Ht) {
                                return Ht < je.length - 1;
                              }), It = yt.filter(function(kt, Ht) {
                                return Ht < yt.length - 1;
                              });
                              var Lt = [];
                              if (ot.length > 1) {
                                for (var $t = 0, Qt = 0, en = 0; en < ot.length; en++) if (ot[en] && It[en]) {
                                  var on = It[en].ts - ot[en].ts;
                                  if (on > 1) Lt.push(8 * It[en].bytes / on), Qt = 0;
                                  else {
                                    Qt === 0 && (Qt = ot[en].ts, $t = 0);
                                    var ht = It[en].ts - Qt;
                                    ht > 1 ? ($t += It[en].bytes, Lt.push(8 * $t / ht), Qt = 0) : $t += It[en].bytes;
                                  }
                                }
                                if (Lt.length > 0) return Lt.reduce(function(kt, Ht) {
                                  return kt + Ht;
                                }, 0) / Lt.length;
                              }
                              return null;
                            } catch {
                              return null;
                            }
                          }(be, Be), gt && (Wt = 8 * pe / gt)) : oe === t.Z.ABR_FETCH_THROUGHPUT_CALCULATION_DOWNLOADED_DATA && (Wt = G(Ut, pe)), N.progress({ loaded: pe, total: isNaN(J) ? pe : J, lengthComputable: !0, time: Wt, stream: !0 });
                        }
                        N.response.response = Ie.buffer;
                      }
                      return N.onload(), void N.onend();
                    }
                    if (Et && Et.length > 0) {
                      Ie = function(je, yt) {
                        if (je.length === 0) return yt;
                        var ot = new Uint8Array(je.length + yt.length);
                        return ot.set(je), ot.set(yt, je.length), ot;
                      }(Ie, Et), pe += Et.length, Ut.push({ ts: Date.now(), bytes: Et.length }), oe === t.Z.ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING && mt && y.findLastTopIsoBoxCompleted(["moof"], Ie, xe).found && (mt = !1, be.push({ ts: performance.now(), bytes: Et.length }));
                      var zt = y.findLastTopIsoBoxCompleted(["moov", "mdat"], Ie, xe);
                      if (zt.found) {
                        var gn, pn = zt.lastCompletedOffset + zt.size;
                        oe !== t.Z.ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING || mt || (mt = !0, Be.push({ ts: performance.now(), bytes: Ie.length })), pn === Ie.length ? (gn = Ie, Ie = new Uint8Array()) : (gn = new Uint8Array(Ie.subarray(0, pn)), Ie = Ie.subarray(pn)), N.progress({ data: gn.buffer, lengthComputable: !1, noTrace: !0 }), xe = 0;
                      } else xe = zt.lastCompletedOffset, Le || (N.progress({ lengthComputable: !1, noTrace: !0 }), Le = !0);
                    }
                    H(N, Ke);
                  });
                }).catch(function(P) {
                  N.onerror && N.onerror(P);
                });
              });
            }
            function H(N, U) {
              N.reader.read().then(U).catch(function(Z) {
                N.onerror && N.response.status === 200 && N.onerror(Z);
              });
            }
            function G(N, U) {
              try {
                if ((N = N.filter(function(te) {
                  return te.bytes > U / 4 / N.length;
                })).length > 1) {
                  var Z = 0, fe = (N[N.length - 1].ts - N[0].ts) / N.length;
                  return N.forEach(function(te, le) {
                    var ge = N[le + 1];
                    if (ge) {
                      var q = ge.ts - te.ts;
                      Z += q < fe ? q : 0;
                    }
                  }), Z;
                }
                return null;
              } catch {
                return null;
              }
            }
            return r = { load: function(N) {
              R && R.modifyRequest ? (0, Re.k)(N, R).then(function() {
                return F(N);
              }) : F(N);
            }, abort: function(N) {
              if (N.abortController) N.abortController.abort();
              else if (N.reader) try {
                N.reader.cancel(), N.onabort();
              } catch {
              }
            }, calculateDownloadedTime: G, setup: function(N) {
              l = N.dashMetrics;
            } }, r;
          }
          vn.__dashjs_factory_name = "FetchLoader";
          var Pn = E.Z.getClassFactory(vn), Dn = C(1180);
          function xn(i, r) {
            for (var l = 0; l < r.length; l++) {
              var _ = r[l];
              _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(i, _.key, _);
            }
          }
          var er = function() {
            function i() {
              (function(_, R) {
                if (!(_ instanceof R)) throw new TypeError("Cannot call a class as a function");
              })(this, i), this.id = null, this.index = -1, this.adaptation = null, this.segmentInfoType = null, this.initialization = null, this.codecs = null, this.mimeType = null, this.codecPrivateData = null, this.segmentDuration = NaN, this.timescale = 1, this.startNumber = 1, this.indexRange = null, this.range = null, this.presentationTimeOffset = 0, this.MSETimeOffset = NaN, this.mediaFinishedInformation = { numberOfSegments: 0, mediaTimeOfLastSignaledSegment: NaN }, this.bandwidth = NaN, this.width = NaN, this.height = NaN, this.scanType = null, this.maxPlayoutRate = NaN, this.availabilityTimeOffset = 0, this.availabilityTimeComplete = !0, this.frameRate = null;
            }
            var r, l;
            return r = i, (l = [{ key: "hasInitialization", value: function() {
              return this.initialization !== null || this.range !== null;
            } }, { key: "hasSegments", value: function() {
              return this.segmentInfoType !== e.Z.BASE_URL && this.segmentInfoType !== e.Z.SEGMENT_BASE && !this.indexRange;
            } }]) && xn(r.prototype, l), i;
          }(), In = function i() {
            (function(r, l) {
              if (!(r instanceof l)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.period = null, this.index = -1, this.type = null;
          }, cr = function i() {
            (function(r, l) {
              if (!(r instanceof l)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.id = null, this.index = -1, this.duration = NaN, this.start = NaN, this.mpd = null, this.nextPeriodId = null;
          };
          cr.DEFAULT_ID = "defaultId";
          var Yn = cr, ir = function i() {
            (function(r, l) {
              if (!(r instanceof l)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.manifest = null, this.suggestedPresentationDelay = 0, this.availabilityStartTime = null, this.availabilityEndTime = Number.POSITIVE_INFINITY, this.timeShiftBufferDepth = Number.POSITIVE_INFINITY, this.maxSegmentDuration = Number.POSITIVE_INFINITY, this.publishTime = null, this.minimumUpdatePeriod = NaN, this.mediaPresentationDuration = NaN;
          }, mr = C(2610), ar = function i() {
            (function(r, l) {
              if (!(r instanceof l)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.type = "", this.duration = NaN, this.presentationTime = NaN, this.id = NaN, this.messageData = "", this.eventStream = null, this.presentationTimeDelta = NaN;
          }, Er = function i(r, l, _, R) {
            (function(I, y) {
              if (!(I instanceof y)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.url = r || "", this.serviceLocation = l || r || "", this.dvbPriority = _ || 1, this.dvbWeight = R || 1, this.availabilityTimeOffset = 0, this.availabilityTimeComplete = !0, this.queryParams = {};
          };
          Er.DEFAULT_DVB_PRIORITY = 1, Er.DEFAULT_DVB_WEIGHT = 1;
          var vr = Er, ei = function i() {
            (function(r, l) {
              if (!(r instanceof l)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.adaptionSet = null, this.representation = null, this.period = null, this.timescale = 1, this.value = "", this.schemeIdUri = "", this.presentationTimeOffset = 0;
          }, Nt = function i() {
            (function(r, l) {
              if (!(r instanceof l)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.id = null, this.inband = !1, this.type = "encoder", this.applicationScheme = null, this.wallClockTime = null, this.presentationTime = NaN, this.UTCTiming = null;
          }, At = function i() {
            (function(r, l) {
              if (!(r instanceof l)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.defaultServiceLocation = null, this.defaultServiceLocationArray = [], this.queryBeforeStart = !1, this.serverUrl = null, this.clientRequirement = !0;
          };
          function wt(i, r) {
            for (var l = 0; l < r.length; l++) {
              var _ = r[l];
              _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(i, _.key, _);
            }
          }
          var He = function() {
            function i() {
              (function(_, R) {
                if (!(_ instanceof R)) throw new TypeError("Cannot call a class as a function");
              })(this, i), this.schemeIdUri = null, this.value = null, this.id = null;
            }
            var r, l;
            return r = i, (l = [{ key: "init", value: function(_) {
              return _ && (this.schemeIdUri = _.schemeIdUri ? _.schemeIdUri : null, this.value = _.value ? _.value : null, this.id = _.id ? _.id : null, _[e.Z.DVB_URL] && (this.dvbUrl = _[e.Z.DVB_URL]), _[e.Z.DVB_MIMETYPE] && (this.dvbMimeType = _[e.Z.DVB_MIMETYPE]), _[e.Z.DVB_FONTFAMILY] && (this.dvbFontFamily = _[e.Z.DVB_FONTFAMILY])), this;
            } }]) && wt(r.prototype, l), i;
          }(), pt = C(3101), Qe = C.n(pt);
          function dt() {
            return { areEqual: function(i, r) {
              return Qe()(i, r);
            } };
          }
          dt.__dashjs_factory_name = "ObjectUtils";
          var Zt = E.Z.getSingletonFactory(dt), Gt = C(7803), nn = function i(r, l) {
            (function(_, R) {
              if (!(_ instanceof R)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.url = r || "", this.serviceLocation = l || null, this.queryParams = {};
          }, rn = function i(r, l, _) {
            (function(R, I) {
              if (!(R instanceof I)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.url = r || "", this.serviceLocation = l || null, this.ttl = _ || NaN, this.queryParams = {};
          };
          function Kt(i, r) {
            var l = Object.keys(i);
            if (Object.getOwnPropertySymbols) {
              var _ = Object.getOwnPropertySymbols(i);
              r && (_ = _.filter(function(R) {
                return Object.getOwnPropertyDescriptor(i, R).enumerable;
              })), l.push.apply(l, _);
            }
            return l;
          }
          function St(i) {
            for (var r = 1; r < arguments.length; r++) {
              var l = arguments[r] != null ? arguments[r] : {};
              r % 2 ? Kt(Object(l), !0).forEach(function(_) {
                tn(i, _, l[_]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(l)) : Kt(Object(l)).forEach(function(_) {
                Object.defineProperty(i, _, Object.getOwnPropertyDescriptor(l, _));
              });
            }
            return i;
          }
          function tn(i, r, l) {
            return r in i ? Object.defineProperty(i, r, { value: l, enumerable: !0, configurable: !0, writable: !0 }) : i[r] = l, i;
          }
          function Jt(i, r) {
            var l;
            if (typeof Symbol > "u" || i[Symbol.iterator] == null) {
              if (Array.isArray(i) || (l = dn(i)) || r) {
                l && (i = l);
                var _ = 0, R = function() {
                };
                return { s: R, n: function() {
                  return _ >= i.length ? { done: !0 } : { done: !1, value: i[_++] };
                }, e: function(F) {
                  throw F;
                }, f: R };
              }
              throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }
            var I, y = !0, w = !1;
            return { s: function() {
              l = i[Symbol.iterator]();
            }, n: function() {
              var F = l.next();
              return y = F.done, F;
            }, e: function(F) {
              w = !0, I = F;
            }, f: function() {
              try {
                y || l.return == null || l.return();
              } finally {
                if (w) throw I;
              }
            } };
          }
          function dn(i, r) {
            if (i) {
              if (typeof i == "string") return Tn(i, r);
              var l = Object.prototype.toString.call(i).slice(8, -1);
              return l === "Object" && i.constructor && (l = i.constructor.name), l === "Map" || l === "Set" ? Array.from(i) : l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l) ? Tn(i, r) : void 0;
            }
          }
          function Tn(i, r) {
            (r == null || r > i.length) && (r = i.length);
            for (var l = 0, _ = new Array(r); l < r; l++) _[l] = i[l];
            return _;
          }
          function wn() {
            var i, r, l, _, R = this.context, I = (0, Je.Z)(R).getInstance(), y = Number.isInteger || function(g) {
              return typeof g == "number" && isFinite(g) && Math.floor(g) === g;
            };
            function w(g, P) {
              if (!g) throw new Error("adaptation is not defined");
              if (!P) throw new Error("type is not defined");
              if (g.Representation_asArray && g.Representation_asArray.length) {
                var D = le(g.Representation_asArray[0]);
                if (D && D.length > 0 && Gt.Y.indexOf(D[0].schemeIdUri) >= 0) return P === t.Z.IMAGE;
              }
              if (g.ContentComponent_asArray && g.ContentComponent_asArray.length > 0) {
                if (g.ContentComponent_asArray.length > 1) return P === t.Z.MUXED;
                if (g.ContentComponent_asArray[0].contentType === P) return !0;
              }
              var O = P === t.Z.TEXT ? new RegExp("(ttml|vtt|wvtt|stpp)") : new RegExp(P);
              if (g.Representation_asArray && g.Representation_asArray.length) {
                var A = g.Representation_asArray[0].codecs;
                if (O.test(A)) return !0;
              }
              if (g.hasOwnProperty(e.Z.MIME_TYPE)) return O.test(g.mimeType);
              if (g.Representation_asArray) {
                for (var ne, z = 0; z < g.Representation_asArray.length; z++) if ((ne = g.Representation_asArray[z]).hasOwnProperty(e.Z.MIME_TYPE)) return O.test(ne.mimeType);
              }
              return !1;
            }
            function F(g) {
              if (!g) throw new Error("adaptation is not defined");
              if (g.hasOwnProperty(e.Z.SEGMENT_TEMPLATE) || g.hasOwnProperty(e.Z.SEGMENT_TIMELINE) || g.hasOwnProperty(e.Z.SEGMENT_LIST) || g.hasOwnProperty(e.Z.SEGMENT_BASE)) return !0;
              if (g.Representation_asArray && g.Representation_asArray.length > 0) {
                var P = g.Representation_asArray[0];
                if (P.hasOwnProperty(e.Z.SEGMENT_TEMPLATE) || P.hasOwnProperty(e.Z.SEGMENT_TIMELINE) || P.hasOwnProperty(e.Z.SEGMENT_LIST) || P.hasOwnProperty(e.Z.SEGMENT_BASE)) return !0;
              }
              return !1;
            }
            function H(g) {
              return w(g, t.Z.VIDEO);
            }
            function G(g) {
              return w(g, t.Z.TEXT);
            }
            function N(g) {
              return w(g, t.Z.IMAGE);
            }
            function U(g) {
              return g && Array.isArray(g.Representation_asArray) && g.Representation_asArray.sort(function(P, D) {
                return P.bandwidth - D.bandwidth;
              }), g;
            }
            function Z(g, P) {
              return g && g.Period_asArray && y(P) && g.Period_asArray[P] ? g.Period_asArray[P].AdaptationSet_asArray : [];
            }
            function fe(g) {
              return g && g.Period_asArray ? g.Period_asArray : [];
            }
            function te(g) {
              var P = !1;
              return g && g.hasOwnProperty("type") && (P = g.type === e.Z.DYNAMIC), P;
            }
            function le(g) {
              return g && g.EssentialProperty_asArray && g.EssentialProperty_asArray.length ? g.EssentialProperty_asArray.map(function(P) {
                return { schemeIdUri: P.schemeIdUri, value: P.value };
              }) : null;
            }
            function ge(g) {
              if (!g || !g.S_asArray) return NaN;
              var P = g.S_asArray[0], D = g.S_asArray[1];
              return P.hasOwnProperty("d") ? P.d : D.t - P.t;
            }
            function q(g, P) {
              if (!g) throw new Error("Period cannot be null or undefined");
              var D = Yn.DEFAULT_ID + "_" + P;
              return g.hasOwnProperty(e.Z.ID) && g.id.length > 0 && g.id !== "__proto__" && (D = g.id), D;
            }
            function oe(g, P, D) {
              var O, A = [];
              if (!g) return A;
              for (O = 0; O < g.length; O++) {
                var ne = new ei();
                if (ne.timescale = 1, ne.representation = P, !g[O].hasOwnProperty(t.Z.SCHEME_ID_URI)) throw new Error("Invalid EventStream. SchemeIdUri has to be set");
                ne.schemeIdUri = g[O].schemeIdUri, g[O].hasOwnProperty(e.Z.TIMESCALE) && (ne.timescale = g[O].timescale), g[O].hasOwnProperty(e.Z.VALUE) && (ne.value = g[O].value), A.push(ne), ne.period = D;
              }
              return A;
            }
            function V(g) {
              var P = [], D = g.BaseURL_asArray || [g.baseUri], O = !1;
              return D.some(function(A) {
                if (A) {
                  var ne = new vr(), z = A.__text || A;
                  return I.isRelative(z) && (O = !0, g.baseUri && (z = I.resolve(z, g.baseUri))), ne.url = z, A.hasOwnProperty(e.Z.SERVICE_LOCATION) && A.serviceLocation.length ? ne.serviceLocation = A.serviceLocation : ne.serviceLocation = z, A.hasOwnProperty(e.Z.DVB_PRIORITY) && (ne.dvbPriority = A[e.Z.DVB_PRIORITY]), A.hasOwnProperty(e.Z.DVB_WEIGHT) && (ne.dvbWeight = A[e.Z.DVB_WEIGHT]), A.hasOwnProperty(e.Z.AVAILABILITY_TIME_OFFSET) && (ne.availabilityTimeOffset = A[e.Z.AVAILABILITY_TIME_OFFSET]), A.hasOwnProperty(e.Z.AVAILABILITY_TIME_COMPLETE) && (ne.availabilityTimeComplete = A[e.Z.AVAILABILITY_TIME_COMPLETE] !== "false"), P.push(ne), O;
                }
              }), P;
            }
            function ce(g) {
              var P = new At();
              return P.serverUrl = g.__text, g.hasOwnProperty(e.Z.DEFAULT_SERVICE_LOCATION) && (P.defaultServiceLocation = g[e.Z.DEFAULT_SERVICE_LOCATION], P.defaultServiceLocationArray = P.defaultServiceLocation.split(" ")), g.hasOwnProperty(e.Z.QUERY_BEFORE_START) && (P.queryBeforeStart = g[e.Z.QUERY_BEFORE_START].toLowerCase() === "true"), g.hasOwnProperty(e.Z.CLIENT_REQUIREMENT) && (P.clientRequirement = g[e.Z.CLIENT_REQUIREMENT].toLowerCase() !== "false"), P;
            }
            return i = { getIsTypeOf: w, getIsText: G, getIsFragmented: F, getProducerReferenceTimesForAdaptation: function(g) {
              var P = g && g.hasOwnProperty(e.Z.PRODUCERREFERENCETIME_ASARRAY) ? g[e.Z.PRODUCERREFERENCETIME_ASARRAY] : [];
              (g && g.hasOwnProperty(e.Z.REPRESENTATION_ASARRAY) ? g[e.Z.REPRESENTATION_ASARRAY] : []).forEach(function(O) {
                var A;
                O.hasOwnProperty(e.Z.PRODUCERREFERENCETIME_ASARRAY) && P.push.apply(P, function(ne) {
                  if (Array.isArray(ne)) return Tn(ne);
                }(A = O[e.Z.PRODUCERREFERENCETIME_ASARRAY]) || function(ne) {
                  if (typeof Symbol < "u" && Symbol.iterator in Object(ne)) return Array.from(ne);
                }(A) || dn(A) || function() {
                  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
                }());
              });
              var D = [];
              return P.forEach(function(O) {
                var A = new Nt();
                O.hasOwnProperty(e.Z.ID) && (A[e.Z.ID] = O[e.Z.ID], O.hasOwnProperty(e.Z.WALL_CLOCK_TIME) && (A[e.Z.WALL_CLOCK_TIME] = O[e.Z.WALL_CLOCK_TIME], O.hasOwnProperty(e.Z.PRESENTATION_TIME) && (A[e.Z.PRESENTATION_TIME] = O[e.Z.PRESENTATION_TIME], O.hasOwnProperty(e.Z.INBAND) && (A[e.Z.INBAND] = O[e.Z.INBAND] !== "false"), O.hasOwnProperty(e.Z.TYPE) && (A[e.Z.TYPE] = O[e.Z.TYPE]), D.push(A))));
              }), D;
            }, getLanguageForAdaptation: function(g) {
              var P = "";
              return g && g.hasOwnProperty(e.Z.LANG) && (P = g.lang), P;
            }, getViewpointForAdaptation: function(g) {
              return g && g.hasOwnProperty(e.Z.VIEWPOINT_ASARRAY) && g[e.Z.VIEWPOINT_ASARRAY].length ? g[e.Z.VIEWPOINT_ASARRAY].map(function(P) {
                return new He().init(P);
              }) : [];
            }, getRolesForAdaptation: function(g) {
              return g && g.hasOwnProperty(e.Z.ROLE_ASARRAY) && g[e.Z.ROLE_ASARRAY].length ? g[e.Z.ROLE_ASARRAY].map(function(P) {
                return new He().init(P);
              }) : [];
            }, getAccessibilityForAdaptation: function(g) {
              return g && g.hasOwnProperty(e.Z.ACCESSIBILITY_ASARRAY) && g[e.Z.ACCESSIBILITY_ASARRAY].length ? g[e.Z.ACCESSIBILITY_ASARRAY].map(function(P) {
                return new He().init(P);
              }) : [];
            }, getAudioChannelConfigurationForAdaptation: function(g) {
              return g && g.hasOwnProperty(e.Z.AUDIOCHANNELCONFIGURATION_ASARRAY) && g[e.Z.AUDIOCHANNELCONFIGURATION_ASARRAY].length ? g[e.Z.AUDIOCHANNELCONFIGURATION_ASARRAY].map(function(P) {
                return new He().init(P);
              }) : [];
            }, getAudioChannelConfigurationForRepresentation: function(g) {
              return g && g.hasOwnProperty(e.Z.AUDIOCHANNELCONFIGURATION_ASARRAY) && g[e.Z.AUDIOCHANNELCONFIGURATION_ASARRAY].length ? g[e.Z.AUDIOCHANNELCONFIGURATION_ASARRAY].map(function(P) {
                return new He().init(P);
              }) : [];
            }, getAdaptationForIndex: function(g, P, D) {
              var O = Z(P, D);
              return O.length > 0 && y(g) ? O[g] : null;
            }, getIndexForAdaptation: function(g, P, D) {
              if (!g) return -1;
              for (var O = Z(P, D), A = 0; A < O.length; A++) if (Zt(R).getInstance().areEqual(O[A], g)) return A;
              return -1;
            }, getAdaptationForId: function(g, P, D) {
              var O, A, ne = Z(P, D);
              for (O = 0, A = ne.length; O < A; O++) if (ne[O].hasOwnProperty(e.Z.ID) && ne[O].id === g) return ne[O];
              return null;
            }, getAdaptationsForType: function(g, P, D) {
              var O, A, ne = Z(g, P), z = [];
              for (O = 0, A = ne.length; O < A; O++) w(ne[O], D) && z.push(U(ne[O]));
              return z;
            }, getRealPeriods: fe, getRealPeriodForIndex: function(g, P) {
              var D = fe(P);
              return D.length > 0 && y(g) ? D[g] : null;
            }, getCodec: function(g, P, D) {
              var O = null;
              if (g && g.Representation_asArray && g.Representation_asArray.length > 0) {
                var A = y(P) && P >= 0 && P < g.Representation_asArray.length ? g.Representation_asArray[P] : g.Representation_asArray[0];
                A && (O = A.mimeType + ';codecs="' + A.codecs + '"', D && A.width !== void 0 && (O += ';width="' + A.width + '";height="' + A.height + '"'));
              }
              return O && (O = O.replace(/\sprofiles=[^;]*/g, "")), O;
            }, getSelectionPriority: function(g) {
              try {
                var P = g && g.selectionPriority !== void 0 ? parseInt(g.selectionPriority) : 1;
                return isNaN(P) ? 1 : P;
              } catch {
                return 1;
              }
            }, getMimeType: function(g) {
              return g && g.Representation_asArray && g.Representation_asArray.length > 0 ? g.Representation_asArray[0].mimeType : null;
            }, getKID: function(g) {
              return g && g.hasOwnProperty(e.Z.CENC_DEFAULT_KID) ? g[e.Z.CENC_DEFAULT_KID] : null;
            }, getLabelsForAdaptation: function(g) {
              if (!g || !Array.isArray(g.Label_asArray)) return [];
              for (var P = [], D = 0; D < g.Label_asArray.length; D++) P.push({ lang: g.Label_asArray[D].lang, text: g.Label_asArray[D].__text || g.Label_asArray[D] });
              return P;
            }, getContentProtectionData: function(g) {
              return g && g.hasOwnProperty(e.Z.CONTENTPROTECTION_ASARRAY) && g.ContentProtection_asArray.length !== 0 ? g.ContentProtection_asArray : null;
            }, getIsDynamic: te, getId: function(g) {
              return g && g[e.Z.ID] || null;
            }, hasProfile: function(g, P) {
              var D = !1;
              return g && g.profiles && g.profiles.length > 0 && (D = g.profiles.indexOf(P) !== -1), D;
            }, getDuration: function(g) {
              return g && g.hasOwnProperty(e.Z.MEDIA_PRESENTATION_DURATION) ? g.mediaPresentationDuration : g && g.type == "dynamic" ? Number.POSITIVE_INFINITY : Number.MAX_SAFE_INTEGER || Number.MAX_VALUE;
            }, getBandwidth: function(g) {
              return g && g.bandwidth ? g.bandwidth : NaN;
            }, getManifestUpdatePeriod: function(g) {
              var P = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, D = NaN;
              return g && g.hasOwnProperty(e.Z.MINIMUM_UPDATE_PERIOD) && (D = g.minimumUpdatePeriod), isNaN(D) ? D : Math.max(D - P, 1);
            }, getPublishTime: function(g) {
              return g && g.hasOwnProperty(e.Z.PUBLISH_TIME) ? new Date(g[e.Z.PUBLISH_TIME]) : null;
            }, getRepresentationCount: function(g) {
              return g && Array.isArray(g.Representation_asArray) ? g.Representation_asArray.length : 0;
            }, getBitrateListForAdaptation: function(g) {
              var P = U(g);
              return (P && Array.isArray(P.Representation_asArray) ? P.Representation_asArray : []).map(function(D) {
                return { bandwidth: D.bandwidth, width: D.width || 0, height: D.height || 0, scanType: D.scanType || null, id: D.id || null };
              });
            }, getRepresentationFor: function(g, P) {
              return P && P.Representation_asArray && P.Representation_asArray.length > 0 && y(g) ? P.Representation_asArray[g] : null;
            }, getRepresentationsForAdaptation: function(g) {
              var P, D, O, A, ne = [], z = function(Ie) {
                if (Ie && Ie.period && y(Ie.period.index)) {
                  var xe = Ie.period.mpd.manifest.Period_asArray[Ie.period.index];
                  if (xe && xe.AdaptationSet_asArray && y(Ie.index)) return U(xe.AdaptationSet_asArray[Ie.index]);
                }
              }(g);
              if (z && z.Representation_asArray) {
                if (g && g.period && y(g.period.index)) {
                  var se = V(g.period.mpd.manifest);
                  se && (D = se[0]);
                }
                for (var X = 0, k = z.Representation_asArray.length; X < k; ++X) {
                  var J = z.Representation_asArray[X], pe = new er();
                  if (pe.index = X, pe.adaptation = g, J.hasOwnProperty(e.Z.ID) && (pe.id = J.id), J.hasOwnProperty(e.Z.CODECS) && (pe.codecs = J.codecs), J.hasOwnProperty(e.Z.MIME_TYPE) && (pe.mimeType = J[e.Z.MIME_TYPE]), J.hasOwnProperty(e.Z.CODEC_PRIVATE_DATA) && (pe.codecPrivateData = J.codecPrivateData), J.hasOwnProperty(e.Z.BANDWITH) && (pe.bandwidth = J.bandwidth), J.hasOwnProperty(e.Z.WIDTH) && (pe.width = J.width), J.hasOwnProperty(e.Z.HEIGHT) && (pe.height = J.height), J.hasOwnProperty(e.Z.SCAN_TYPE) && (pe.scanType = J.scanType), J.hasOwnProperty(e.Z.MAX_PLAYOUT_RATE) && (pe.maxPlayoutRate = J.maxPlayoutRate), J.hasOwnProperty(e.Z.SEGMENT_BASE) ? (P = J.SegmentBase, pe.segmentInfoType = e.Z.SEGMENT_BASE) : J.hasOwnProperty(e.Z.SEGMENT_LIST) ? (P = J.SegmentList).hasOwnProperty(e.Z.SEGMENT_TIMELINE) ? pe.segmentInfoType = e.Z.SEGMENT_TIMELINE : pe.segmentInfoType = e.Z.SEGMENT_LIST : J.hasOwnProperty(e.Z.SEGMENT_TEMPLATE) ? ((P = J.SegmentTemplate).hasOwnProperty(e.Z.SEGMENT_TIMELINE) ? pe.segmentInfoType = e.Z.SEGMENT_TIMELINE : pe.segmentInfoType = e.Z.SEGMENT_TEMPLATE, P.hasOwnProperty(e.Z.INITIALIZATION_MINUS) && (pe.initialization = P.initialization.split("$Bandwidth$").join(J.bandwidth).split("$RepresentationID$").join(J.id))) : pe.segmentInfoType = e.Z.BASE_URL, pe.essentialProperties = le(J), P) {
                    if (P.hasOwnProperty(e.Z.INITIALIZATION)) {
                      var Le = P.Initialization;
                      Le.hasOwnProperty(e.Z.SOURCE_URL) && (pe.initialization = Le.sourceURL), Le.hasOwnProperty(e.Z.RANGE) && (pe.range = Le.range);
                    } else G(z) && F(z) && z.mimeType && z.mimeType.indexOf("application/mp4") === -1 && (pe.range = 0);
                    P.hasOwnProperty(e.Z.TIMESCALE) && (pe.timescale = P.timescale), P.hasOwnProperty(e.Z.DURATION) ? pe.segmentDuration = P.duration / pe.timescale : J.hasOwnProperty(e.Z.SEGMENT_TEMPLATE) && (P = J.SegmentTemplate).hasOwnProperty(e.Z.SEGMENT_TIMELINE) && (pe.segmentDuration = ge(P.SegmentTimeline) / pe.timescale), P.hasOwnProperty(e.Z.MEDIA) && (pe.media = P.media), P.hasOwnProperty(e.Z.START_NUMBER) && (pe.startNumber = P.startNumber), P.hasOwnProperty(e.Z.INDEX_RANGE) && (pe.indexRange = P.indexRange), P.hasOwnProperty(e.Z.PRESENTATION_TIME_OFFSET) && (pe.presentationTimeOffset = P.presentationTimeOffset / pe.timescale), P.hasOwnProperty(e.Z.AVAILABILITY_TIME_OFFSET) ? pe.availabilityTimeOffset = P.availabilityTimeOffset : D && D.availabilityTimeOffset !== void 0 && (pe.availabilityTimeOffset = D.availabilityTimeOffset), P.hasOwnProperty(e.Z.AVAILABILITY_TIME_COMPLETE) ? pe.availabilityTimeComplete = P.availabilityTimeComplete !== "false" : D && D.availabilityTimeComplete !== void 0 && (pe.availabilityTimeComplete = D.availabilityTimeComplete);
                  }
                  pe.MSETimeOffset = (A = (O = pe).presentationTimeOffset, O.adaptation.period.start - A), pe.path = [g.period.index, g.index, X], ne.push(pe);
                }
              }
              return ne;
            }, getAdaptationsForPeriod: function(g) {
              var P, D, O, A = g && y(g.index) ? g.mpd.manifest.Period_asArray[g.index] : null, ne = [];
              if (A && A.AdaptationSet_asArray) for (O = 0; O < A.AdaptationSet_asArray.length; O++) D = A.AdaptationSet_asArray[O], P = new In(), D.hasOwnProperty(e.Z.ID) && (P.id = D.id), P.index = O, P.period = g, w(D, t.Z.MUXED) ? P.type = t.Z.MUXED : w(D, t.Z.AUDIO) ? P.type = t.Z.AUDIO : H(D) ? P.type = t.Z.VIDEO : G(D) ? P.type = t.Z.TEXT : N(D) ? P.type = t.Z.IMAGE : r.warn("Unknown Adaptation stream type"), ne.push(P);
              return ne;
            }, getRegularPeriods: function(g) {
              var P, D, O = !!g && te(g.manifest), A = [], ne = null, z = null, se = null, X = null;
              for (D = 0, P = g && g.manifest && g.manifest.Period_asArray ? g.manifest.Period_asArray.length : 0; D < P; D++) (z = g.manifest.Period_asArray[D]).hasOwnProperty(e.Z.START) ? (X = new Yn()).start = z.start : ne !== null && ne.hasOwnProperty(e.Z.DURATION) && se !== null ? (X = new Yn()).start = parseFloat((se.start + se.duration).toFixed(5)) : D !== 0 || O || ((X = new Yn()).start = 0), se !== null && isNaN(se.duration) && (X !== null ? se.duration = parseFloat((X.start - se.start).toFixed(5)) : r.warn("First period duration could not be calculated because lack of start and duration period properties. This will cause timing issues during playback")), X !== null && (X.id = q(z, D), X.index = D, X.mpd = g, z.hasOwnProperty(e.Z.DURATION) && (X.duration = z.duration), se && (se.nextPeriodId = X.id), A.push(X), ne = z, se = X), z = null, X = null;
              return A.length === 0 || se !== null && isNaN(se.duration) && (se.duration = parseFloat((function(k) {
                (function() {
                  if (!l || !l.hasOwnProperty("error")) throw new Error(t.Z.MISSING_CONFIG_ERROR);
                })();
                var J, pe = te(k.mpd.manifest);
                return k.mpd.manifest.mediaPresentationDuration ? J = k.mpd.manifest.mediaPresentationDuration : k.duration ? J = k.duration : pe ? J = Number.POSITIVE_INFINITY : l.error(new ae.Z(Q.MANIFEST_ERROR_ID_PARSE_CODE, "Must have @mediaPresentationDuration on MPD or an explicit @duration on the last period.", k)), J;
              }(se) - se.start).toFixed(5))), A;
            }, getMpd: function(g) {
              var P = new ir();
              return g && (P.manifest = g, g.hasOwnProperty(e.Z.AVAILABILITY_START_TIME) ? P.availabilityStartTime = new Date(g.availabilityStartTime.getTime()) : g.loadedTime && (P.availabilityStartTime = new Date(g.loadedTime.getTime())), g.hasOwnProperty(e.Z.AVAILABILITY_END_TIME) && (P.availabilityEndTime = new Date(g.availabilityEndTime.getTime())), g.hasOwnProperty(e.Z.MINIMUM_UPDATE_PERIOD) && (P.minimumUpdatePeriod = g.minimumUpdatePeriod), g.hasOwnProperty(e.Z.MEDIA_PRESENTATION_DURATION) && (P.mediaPresentationDuration = g.mediaPresentationDuration), g.hasOwnProperty(e.Z.SUGGESTED_PRESENTATION_DELAY) && (P.suggestedPresentationDelay = g.suggestedPresentationDelay), g.hasOwnProperty(e.Z.TIMESHIFT_BUFFER_DEPTH) && (P.timeShiftBufferDepth = g.timeShiftBufferDepth), g.hasOwnProperty(e.Z.MAX_SEGMENT_DURATION) && (P.maxSegmentDuration = g.maxSegmentDuration), g.hasOwnProperty(e.Z.PUBLISH_TIME) && (P.publishTime = new Date(g.publishTime))), P;
            }, getEventsForPeriod: function(g) {
              var P, D, O = g && g.mpd && g.mpd.manifest ? g.mpd.manifest : null, A = O ? O.Period_asArray : null, ne = A && g && y(g.index) ? A[g.index].EventStream_asArray : null, z = [];
              if (ne) for (P = 0; P < ne.length; P++) {
                var se = new ei();
                if (se.period = g, se.timescale = 1, !ne[P].hasOwnProperty(t.Z.SCHEME_ID_URI)) throw new Error("Invalid EventStream. SchemeIdUri has to be set");
                for (se.schemeIdUri = ne[P][t.Z.SCHEME_ID_URI], ne[P].hasOwnProperty(e.Z.TIMESCALE) && (se.timescale = ne[P][e.Z.TIMESCALE]), ne[P].hasOwnProperty(e.Z.VALUE) && (se.value = ne[P][e.Z.VALUE]), ne[P].hasOwnProperty(e.Z.PRESENTATION_TIME_OFFSET) && (se.presentationTimeOffset = ne[P][e.Z.PRESENTATION_TIME_OFFSET]), D = 0; ne[P].Event_asArray && D < ne[P].Event_asArray.length; D++) {
                  var X = ne[P].Event_asArray[D], k = new ar();
                  k.presentationTime = 0, k.eventStream = se, X.hasOwnProperty(e.Z.PRESENTATION_TIME) && (k.presentationTime = X.presentationTime);
                  var J = se.presentationTimeOffset ? se.presentationTimeOffset / se.timescale : 0;
                  k.calculatedPresentationTime = k.presentationTime / se.timescale + g.start - J, X.hasOwnProperty(e.Z.DURATION) && (k.duration = X.duration / se.timescale), X.hasOwnProperty(e.Z.ID) ? k.id = X.id : k.id = null, X.Signal && X.Signal.Binary ? k.messageData = _.decodeArray(X.Signal.Binary.toString()) : k.messageData = X.messageData || X.__cdata || X.__text, z.push(k);
                }
              }
              return z;
            }, getEssentialPropertiesForAdaptation: function(g) {
              var P = {};
              if (g && g.hasOwnProperty(e.Z.ESSENTIAL_PROPERTY_ASARRAY)) {
                var D, O = Jt(g.EssentialProperty_asArray);
                try {
                  for (O.s(); !(D = O.n()).done; ) {
                    var A = D.value;
                    A.hasOwnProperty(t.Z.SCHEME_ID_URI) && (P[A[t.Z.SCHEME_ID_URI]] = St({}, A));
                  }
                } catch (ne) {
                  O.e(ne);
                } finally {
                  O.f();
                }
              }
              return P;
            }, getEssentialPropertiesAsArrayForAdaptation: function(g) {
              return g && g.hasOwnProperty(e.Z.ESSENTIAL_PROPERTY_ASARRAY) && g.EssentialProperty_asArray.length ? g.EssentialProperty_asArray.map(function(P) {
                return new He().init(P);
              }) : [];
            }, getEssentialPropertiesForRepresentation: le, getEventStreamForAdaptationSet: function(g, P, D) {
              var O, A, ne;
              return g && g.Period_asArray && P && P.period && y(P.period.index) && (A = g.Period_asArray[P.period.index]) && A.AdaptationSet_asArray && y(P.index) && (ne = A.AdaptationSet_asArray[P.index]) && (O = ne.InbandEventStream_asArray), oe(O, null, D);
            }, getEventStreamForRepresentation: function(g, P, D) {
              var O, A, ne, z;
              return g && g.Period_asArray && P && P.adaptation && P.adaptation.period && y(P.adaptation.period.index) && (A = g.Period_asArray[P.adaptation.period.index]) && A.AdaptationSet_asArray && y(P.adaptation.index) && (ne = A.AdaptationSet_asArray[P.adaptation.index]) && ne.Representation_asArray && y(P.index) && (z = ne.Representation_asArray[P.index]) && (O = z.InbandEventStream_asArray), oe(O, P, D);
            }, getUTCTimingSources: function(g) {
              var P = te(g), D = !!g && g.hasOwnProperty(e.Z.AVAILABILITY_START_TIME), O = g ? g.UTCTiming_asArray : null, A = [];
              return (P || D) && O && O.forEach(function(ne) {
                var z = new mr.Z();
                ne.hasOwnProperty(t.Z.SCHEME_ID_URI) && (z.schemeIdUri = ne.schemeIdUri, ne.hasOwnProperty(e.Z.VALUE) && (z.value = ne.value.toString(), A.push(z)));
              }), A;
            }, getBaseURLsFromElement: V, getRepresentationSortFunction: function() {
              return function(g, P) {
                return g.bandwidth - P.bandwidth;
              };
            }, getContentSteering: function(g) {
              if (g && g.hasOwnProperty(e.Z.CONTENT_STEERING_AS_ARRAY)) return ce(g[e.Z.CONTENT_STEERING_AS_ARRAY][0]);
            }, getLocation: function(g) {
              return g && g.hasOwnProperty(e.Z.LOCATION_AS_ARRAY) ? g[e.Z.LOCATION_AS_ARRAY].map(function(P) {
                var D = P.__text || P, O = P.hasOwnProperty(e.Z.SERVICE_LOCATION) ? P[e.Z.SERVICE_LOCATION] : null;
                return new nn(D, O);
              }) : [];
            }, getPatchLocation: function(g) {
              return g && g.hasOwnProperty(e.Z.PATCH_LOCATION_AS_ARRAY) ? g[e.Z.PATCH_LOCATION_AS_ARRAY].map(function(P) {
                var D = P.__text || P, O = P.hasOwnProperty(e.Z.SERVICE_LOCATION) ? P[e.Z.SERVICE_LOCATION] : null, A = P.hasOwnProperty(e.Z.TTL) ? 1e3 * parseFloat(P[e.Z.TTL]) : NaN;
                return new rn(D, O, A);
              }) : [];
            }, getSuggestedPresentationDelay: function(g) {
              return g && g.hasOwnProperty(e.Z.SUGGESTED_PRESENTATION_DELAY) ? g.suggestedPresentationDelay : null;
            }, getAvailabilityStartTime: function(g) {
              return g && g.hasOwnProperty(e.Z.AVAILABILITY_START_TIME) && g.availabilityStartTime !== null ? g.availabilityStartTime.getTime() : null;
            }, getServiceDescriptions: function(g) {
              var P = [];
              if (g && g.hasOwnProperty(e.Z.SERVICE_DESCRIPTION)) {
                var D, O = Jt(g.ServiceDescription_asArray);
                try {
                  for (O.s(); !(D = O.n()).done; ) {
                    var A = D.value, ne = null, z = null, se = null, X = null, k = null, J = null, pe = null;
                    for (var Le in A) A.hasOwnProperty(Le) && (Le === e.Z.ID ? ne = A[Le] : Le === e.Z.SERVICE_DESCRIPTION_SCOPE ? z = A[Le].schemeIdUri : Le === e.Z.SERVICE_DESCRIPTION_LATENCY ? se = { target: parseInt(A[Le].target), max: parseInt(A[Le].max), min: parseInt(A[Le].min), referenceId: parseInt(A[Le].referenceId) } : Le === e.Z.SERVICE_DESCRIPTION_PLAYBACK_RATE ? X = { max: parseFloat(A[Le].max), min: parseFloat(A[Le].min) } : Le === e.Z.SERVICE_DESCRIPTION_OPERATING_QUALITY ? k = { mediaType: A[Le].mediaType, max: parseInt(A[Le].max), min: parseInt(A[Le].min), target: parseInt(A[Le].target), type: A[Le].type, maxQualityDifference: parseInt(A[Le].maxQualityDifference) } : Le === e.Z.SERVICE_DESCRIPTION_OPERATING_BANDWIDTH ? J = { mediaType: A[Le].mediaType, max: parseInt(A[Le].max), min: parseInt(A[Le].min), target: parseInt(A[Le].target) } : Le === e.Z.CONTENT_STEERING && (pe = ce(A[Le])));
                    P.push({ id: ne, schemeIdUri: z, latency: se, playbackRate: X, operatingQuality: k, operatingBandwidth: J, contentSteering: pe });
                  }
                } catch (Ie) {
                  O.e(Ie);
                } finally {
                  O.f();
                }
              }
              return P;
            }, getSegmentAlignment: function(g) {
              return !(!g || !g.hasOwnProperty(e.Z.SEGMENT_ALIGNMENT)) && g[e.Z.SEGMENT_ALIGNMENT] === "true";
            }, getSubSegmentAlignment: function(g) {
              return !(!g || !g.hasOwnProperty(e.Z.SUB_SEGMENT_ALIGNMENT)) && g[e.Z.SUB_SEGMENT_ALIGNMENT] === "true";
            }, getSupplementalPropertiesForAdaptation: function(g) {
              var P = {};
              if (g && g.hasOwnProperty(e.Z.SUPPLEMENTAL_PROPERTY_ASARRAY)) {
                var D, O = Jt(g.SupplementalProperty_asArray);
                try {
                  for (O.s(); !(D = O.n()).done; ) {
                    var A = D.value;
                    A.hasOwnProperty(t.Z.SCHEME_ID_URI) && (P[A[t.Z.SCHEME_ID_URI]] = St({}, A));
                  }
                } catch (ne) {
                  O.e(ne);
                } finally {
                  O.f();
                }
              }
              return P;
            }, getSupplementalPropertiesAsArrayForAdaptation: function(g) {
              return g && g.hasOwnProperty(e.Z.SUPPLEMENTAL_PROPERTY_ASARRAY) && g.SupplementalProperty_asArray.length ? g.SupplementalProperty_asArray.map(function(P) {
                return new He().init(P);
              }) : [];
            }, getSupplementalPropertiesForRepresentation: function(g) {
              var P = {};
              if (g && g.hasOwnProperty(e.Z.SUPPLEMENTAL_PROPERTY_ASARRAY)) {
                var D, O = Jt(g.SupplementalProperty_asArray);
                try {
                  for (O.s(); !(D = O.n()).done; ) {
                    var A = D.value;
                    A.hasOwnProperty(t.Z.SCHEME_ID_URI) && (P[A[t.Z.SCHEME_ID_URI]] = St({}, A));
                  }
                } catch (ne) {
                  O.e(ne);
                } finally {
                  O.f();
                }
              }
              return P;
            }, getSupplementalPropertiesAsArrayForRepresentation: function(g) {
              return g && g.hasOwnProperty(e.Z.SUPPLEMENTAL_PROPERTY_ASARRAY) && g.SupplementalProperty_asArray.length ? g.SupplementalProperty_asArray.map(function(P) {
                return new He().init(P);
              }) : [];
            }, setConfig: function(g) {
              g && (g.errHandler && (l = g.errHandler), g.BASE64 && (_ = g.BASE64));
            } }, r = (0, h.Z)(R).getInstance().getLogger(i), i;
          }
          wn.__dashjs_factory_name = "DashManifestModel";
          var sn = E.Z.getSingletonFactory(wn), bt = C(703);
          function Dt(i, r) {
            var l;
            if (typeof Symbol > "u" || i[Symbol.iterator] == null) {
              if (Array.isArray(i) || (l = function(F, H) {
                if (F) {
                  if (typeof F == "string") return jt(F, H);
                  var G = Object.prototype.toString.call(F).slice(8, -1);
                  return G === "Object" && F.constructor && (G = F.constructor.name), G === "Map" || G === "Set" ? Array.from(F) : G === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(G) ? jt(F, H) : void 0;
                }
              }(i)) || r) {
                l && (i = l);
                var _ = 0, R = function() {
                };
                return { s: R, n: function() {
                  return _ >= i.length ? { done: !0 } : { done: !1, value: i[_++] };
                }, e: function(F) {
                  throw F;
                }, f: R };
              }
              throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }
            var I, y = !0, w = !1;
            return { s: function() {
              l = i[Symbol.iterator]();
            }, n: function() {
              var F = l.next();
              return y = F.done, F;
            }, e: function(F) {
              w = !0, I = F;
            }, f: function() {
              try {
                y || l.return == null || l.return();
              } finally {
                if (w) throw I;
              }
            } };
          }
          function jt(i, r) {
            (r == null || r > i.length) && (r = i.length);
            for (var l = 0, _ = new Array(r); l < r; l++) _[l] = i[l];
            return _;
          }
          function fn() {
            var i, r, l, _, R, I, y, w, F, H, G = this.context, N = (0, m.Z)(G).getInstance(), U = (0, Ne.Z)(G).getInstance();
            function Z() {
              l = { pr: 1, nor: null, st: null, sf: null, sid: "".concat(bt.Z.generateUuid()), cid: null }, F = {}, w = {}, H = {}, te();
            }
            function fe() {
              te();
            }
            function te() {
              if (I) {
                var A = I.getStreamController();
                if (A && typeof A.getActiveStream == "function") {
                  var ne = A.getActiveStream();
                  ne && (y = ne.getProcessors());
                }
              }
            }
            function le(A, ne) {
              var z, se = {}, X = Dt(ne);
              try {
                for (X.s(); !(z = X.n()).done; ) {
                  var k = z.value;
                  A[k] && (se[k] = A[k]);
                }
              } catch (J) {
                X.e(J);
              } finally {
                X.f();
              }
              return se;
            }
            function ge(A) {
              var ne = U.get().streaming.cmcd.enabledKeys;
              return A.filter(function(z) {
                return ne.includes(z);
              });
            }
            function q(A) {
              try {
                return A.type === Ue.w.MPD_TYPE ? ((z = oe()).ot = "m", z) : A.type === Ue.w.MEDIA_SEGMENT_TYPE ? (ne = A.mediaType, H.hasOwnProperty(ne) || (H[ne] = !1), w.hasOwnProperty(ne) || (w[ne] = !1), F.hasOwnProperty(ne) || (F[ne] = !1), function(se) {
                  var X, k = oe(), J = function(tt) {
                    try {
                      var Ut = tt.quality, be = tt.mediaInfo.bitrateList;
                      return parseInt(be[Ut].bandwidth / 1e3);
                    } catch {
                      return null;
                    }
                  }(se), pe = function(tt) {
                    try {
                      return isNaN(tt.duration) ? NaN : Math.round(1e3 * tt.duration);
                    } catch {
                      return null;
                    }
                  }(se), Le = function(tt) {
                    try {
                      return 100 * parseInt(_.getThroughputHistory().getSafeAverageThroughput(tt) / 100);
                    } catch {
                      return null;
                    }
                  }(se.mediaType), Ie = function(tt) {
                    try {
                      var Ut = l.pr, be = R.getCurrentBufferLevel(tt);
                      return isNaN(Ut) || isNaN(be) ? null : 100 * parseInt(be / Ut * 10);
                    } catch {
                      return null;
                    }
                  }(se.mediaType), xe = V(se.mediaType), De = function(tt) {
                    try {
                      var Ut = _.getTopBitrateInfoFor(tt);
                      return Math.round(Ut.bitrate / 1e3);
                    } catch {
                      return null;
                    }
                  }(se.mediaType), st = l.pr, ut = function(tt) {
                    if (y && y.length !== 0) {
                      var Ut, be = Dt(y);
                      try {
                        for (be.s(); !(Ut = be.n()).done; ) {
                          var Be = Ut.value;
                          if (Be.getType() === tt) return Be.probeNextRequest();
                        }
                      } catch (mt) {
                        be.e(mt);
                      } finally {
                        be.f();
                      }
                    }
                  }(se.mediaType);
                  se.mediaType === t.Z.VIDEO && (X = "v"), se.mediaType === t.Z.AUDIO && (X = "a"), se.mediaType === t.Z.TEXT && (X = se.mediaInfo.mimeType === "application/mp4" ? "tt" : "c");
                  var et = U.get().streaming.cmcd.rtp;
                  return et || (et = function(tt) {
                    try {
                      var Ut = I.getPlaybackRate();
                      Ut || (Ut = 1);
                      var be = tt.quality, Be = tt.mediaType, mt = tt.mediaInfo, Ke = tt.duration;
                      if (!mt) return NaN;
                      var vt = V(Be);
                      vt === 0 && (vt = 500);
                      var Et = mt.bitrateList[be].bandwidth * Ke / 1e3 / (vt / Ut / 1e3), gt = U.get().streaming.cmcd.rtpSafetyFactor && !isNaN(U.get().streaming.cmcd.rtpSafetyFactor) ? U.get().streaming.cmcd.rtpSafetyFactor : 5;
                      return 100 * (parseInt(Et * gt / 100) + 1);
                    } catch {
                      return NaN;
                    }
                  }(se)), isNaN(et) || (k.rtp = et), ut && (se.url !== ut.url ? k.nor = encodeURIComponent(bt.Z.getRelativeUrl(se.url, ut.url)) : ut.range && (k.nrr = ut.range)), J && (k.br = J), X && (k.ot = X), isNaN(pe) || (k.d = pe), isNaN(Le) || (k.mtp = Le), isNaN(Ie) || (k.dl = Ie), isNaN(xe) || (k.bl = xe), isNaN(De) || (k.tb = De), isNaN(st) || st === 1 || (k.pr = st), F[se.mediaType] && (k.bs = !0, F[se.mediaType] = !1), !w[se.mediaType] && H[se.mediaType] || (k.su = !0, w[se.mediaType] = !1, H[se.mediaType] = !0), k;
                }(A)) : A.type === Ue.w.INIT_SEGMENT_TYPE ? function() {
                  var se = oe();
                  return se.ot = "i", se.su = !0, se;
                }() : A.type === Ue.w.OTHER_TYPE || A.type === Ue.w.XLINK_EXPANSION_TYPE ? function() {
                  var se = oe();
                  return se.ot = "o", se;
                }() : A.type === Ue.w.LICENSE ? function(se) {
                  var X = oe();
                  return X.ot = "k", X;
                }() : null;
              } catch {
                return null;
              }
              var ne, z;
            }
            function oe() {
              var A = {}, ne = U.get().streaming.cmcd.cid ? U.get().streaming.cmcd.cid : l.cid;
              return A.v = 1, A.sid = U.get().streaming.cmcd.sid ? U.get().streaming.cmcd.sid : l.sid, A.sid = "".concat(A.sid), ne && (A.cid = "".concat(ne)), isNaN(l.pr) || l.pr === 1 || l.pr === null || (A.pr = l.pr), l.st && (A.st = l.st), l.sf && (A.sf = l.sf), A;
            }
            function V(A) {
              try {
                var ne = R.getCurrentBufferLevel(A);
                return isNaN(ne) ? null : 100 * parseInt(10 * ne);
              } catch {
                return null;
              }
            }
            function ce(A) {
              try {
                l.pr = A.playbackRate;
              } catch {
              }
            }
            function g(A) {
              try {
                var ne = i.getIsDynamic(A.data) ? "l" : "v", z = A.protocol && A.protocol === "MSS" ? "s" : "d";
                l.st = "".concat(ne), l.sf = "".concat(z);
              } catch {
              }
            }
            function P(A) {
              try {
                A.state && A.mediaType && A.state === n.Z.BUFFER_EMPTY && (F[A.mediaType] || (F[A.mediaType] = !0), w[A.mediaType] || (w[A.mediaType] = !0));
              } catch {
              }
            }
            function D() {
              for (var A in F) F.hasOwnProperty(A) && (F[A] = !0);
              for (var ne in w) w.hasOwnProperty(ne) && (w[ne] = !0);
            }
            function O(A) {
              try {
                if (!A) return null;
                var ne = Object.keys(A).sort(function(X, k) {
                  return X.localeCompare(k);
                }), z = ne.length, se = ne.reduce(function(X, k, J) {
                  return k === "v" && A[k] === 1 || (typeof A[k] == "string" && k !== "ot" && k !== "sf" && k !== "st" ? X += "".concat(k, "=").concat(JSON.stringify(A[k])) : X += "".concat(k, "=").concat(A[k]), J < z - 1 && (X += ",")), X;
                }, "");
                return (se = se.replace(/=true/g, "")).replace(/,\s*$/, "");
              } catch {
                return null;
              }
            }
            return r = { getQueryParameter: function(A) {
              try {
                if (U.get().streaming.cmcd && U.get().streaming.cmcd.enabled) {
                  var ne = q(A), z = function(X) {
                    try {
                      var k = U.get().streaming.cmcd.enabledKeys;
                      return Object.keys(X).filter(function(J) {
                        return k.includes(J);
                      }).reduce(function(J, pe) {
                        return J[pe] = X[pe], J;
                      }, {});
                    } catch {
                      return X;
                    }
                  }(ne), se = O(z);
                  return N.trigger(Dn.Z.CMCD_DATA_GENERATED, { url: A.url, mediaType: A.mediaType, cmcdData: ne, cmcdString: se }), { key: "CMCD", value: se };
                }
                return null;
              } catch {
                return null;
              }
            }, getHeaderParameters: function(A) {
              try {
                if (U.get().streaming.cmcd && U.get().streaming.cmcd.enabled) {
                  var ne = q(A), z = le(ne, ge(["br", "d", "ot", "tb"])), se = le(ne, ge(["bl", "dl", "mtp", "nor", "nrr", "su"])), X = le(ne, ge(["bs", "rtp"])), k = le(ne, ge(["cid", "pr", "sf", "sid", "st", "v"])), J = { "CMCD-Object": O(z), "CMCD-Request": O(se), "CMCD-Status": O(X), "CMCD-Session": O(k) };
                  return N.trigger(Dn.Z.CMCD_DATA_GENERATED, { url: A.url, mediaType: A.mediaType, cmcdData: ne, headers: J }), J;
                }
                return null;
              } catch {
                return null;
              }
            }, setConfig: function(A) {
              A && (A.abrController && (_ = A.abrController), A.dashMetrics && (R = A.dashMetrics), A.playbackController && (I = A.playbackController));
            }, reset: function() {
              N.off(n.Z.PLAYBACK_RATE_CHANGED, ce, this), N.off(n.Z.MANIFEST_LOADED, g, this), N.off(n.Z.BUFFER_LEVEL_STATE_CHANGED, P, r), N.off(n.Z.PLAYBACK_SEEKED, D, r), Z();
            }, initialize: function() {
              N.on(n.Z.PLAYBACK_RATE_CHANGED, ce, r), N.on(n.Z.MANIFEST_LOADED, g, r), N.on(n.Z.BUFFER_LEVEL_STATE_CHANGED, P, r), N.on(n.Z.PLAYBACK_SEEKED, D, r), N.on(n.Z.PERIOD_SWITCH_COMPLETED, fe, r);
            } }, i = sn(G).getInstance(), Z(), r;
          }
          fn.__dashjs_factory_name = "CmcdModel";
          var mn = E.Z.getSingletonFactory(fn);
          function An(i) {
            return An = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
              return typeof r;
            } : function(r) {
              return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
            }, An(i);
          }
          function Rn(i, r) {
            Rn = function(w, F) {
              return new I(w, void 0, F);
            };
            var l = nr(RegExp), _ = RegExp.prototype, R = /* @__PURE__ */ new WeakMap();
            function I(w, F, H) {
              var G = l.call(this, w, F);
              return R.set(G, H || R.get(w)), G;
            }
            function y(w, F) {
              var H = R.get(F);
              return Object.keys(H).reduce(function(G, N) {
                return G[N] = w[H[N]], G;
              }, /* @__PURE__ */ Object.create(null));
            }
            return tr(I, l), I.prototype.exec = function(w) {
              var F = _.exec.call(this, w);
              return F && (F.groups = y(F, this)), F;
            }, I.prototype[Symbol.replace] = function(w, F) {
              if (typeof F == "string") {
                var H = R.get(this);
                return _[Symbol.replace].call(this, w, F.replace(/\$<([^>]+)>/g, function(N, U) {
                  return "$" + H[U];
                }));
              }
              if (typeof F == "function") {
                var G = this;
                return _[Symbol.replace].call(this, w, function() {
                  var N = [];
                  return N.push.apply(N, arguments), An(N[N.length - 1]) !== "object" && N.push(y(N, G)), F.apply(this, N);
                });
              }
              return _[Symbol.replace].call(this, w, F);
            }, Rn.apply(this, arguments);
          }
          function tr(i, r) {
            if (typeof r != "function" && r !== null) throw new TypeError("Super expression must either be null or a function");
            i.prototype = Object.create(r && r.prototype, { constructor: { value: i, writable: !0, configurable: !0 } }), r && Vn(i, r);
          }
          function nr(i) {
            var r = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
            return nr = function(l) {
              if (l === null || (_ = l, Function.toString.call(_).indexOf("[native code]") === -1)) return l;
              var _;
              if (typeof l != "function") throw new TypeError("Super expression must either be null or a function");
              if (r !== void 0) {
                if (r.has(l)) return r.get(l);
                r.set(l, R);
              }
              function R() {
                return Un(l, arguments, rr(this).constructor);
              }
              return R.prototype = Object.create(l.prototype, { constructor: { value: R, enumerable: !1, writable: !0, configurable: !0 } }), Vn(R, l);
            }, nr(i);
          }
          function Un(i, r, l) {
            return Un = Qn() ? Reflect.construct : function(_, R, I) {
              var y = [null];
              y.push.apply(y, R);
              var w = new (Function.bind.apply(_, y))();
              return I && Vn(w, I.prototype), w;
            }, Un.apply(null, arguments);
          }
          function Qn() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }
          function Vn(i, r) {
            return Vn = Object.setPrototypeOf || function(l, _) {
              return l.__proto__ = _, l;
            }, Vn(i, r);
          }
          function rr(i) {
            return rr = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
              return r.__proto__ || Object.getPrototypeOf(r);
            }, rr(i);
          }
          var Zr = "static", Tr = "dynamic", Ir = "cmsd-", or = Ir + Zr, Ri = Ir + Tr, ti = "stream", wi = ["mb", "st", "sf", "v"], Ci = { video: "v", audio: "a", text: "tt", stream: ti }, Ni = /^[-0-9]/;
          function ni() {
            var i, r, l, _, R = this.context, I = (0, m.Z)(R).getInstance();
            function y() {
              l = {}, _ = {};
            }
            function w(Z) {
              Z && Object.keys(Z).forEach(function(fe) {
                wi.includes(fe) || delete Z[fe];
              });
            }
            function F(Z) {
              return !Z || Z.toLowerCase() !== "false" && (Ni.test(Z) ? parseInt(Z, 10) : Z.replace(/["]+/g, ""));
            }
            function H(Z) {
              try {
                for (var fe = {}, te = Z.split(","), le = 0; le < te.length; le++) {
                  var ge = te[le].split("="), q = ge[0], oe = F(ge[1]);
                  fe[q] = oe;
                }
                return fe;
              } catch (V) {
                r.error("Failed to parse CMSD-Static response header value:", V);
              }
            }
            function G(Z) {
              try {
                for (var fe = {}, te = Z.split(","), le = te[te.length - 1].split(";"), ge = 1; ge < le.length; ge++) {
                  var q = le[ge].split("="), oe = q[0], V = F(q[1]);
                  fe[oe] = V;
                }
                return fe;
              } catch (ce) {
                return r.error("Failed to parse CMSD-Dynamic response header value:", ce), [];
              }
            }
            function N(Z) {
              return Ci[Z] || "o";
            }
            function U(Z, fe, te) {
              var le = Z === Zr ? l : _, ge = le[fe] || {}, q = le[ti] || {};
              return ge[te] || q[te];
            }
            return i = { setConfig: function() {
            }, initialize: function() {
            }, reset: function() {
              y();
            }, parseResponseHeaders: function(Z, fe) {
              for (var te = null, le = null, ge = Z.split(`\r
`), q = ge.length - 1; q >= 0; q--) {
                var oe = ge[q].match(Rn(/^((?:(?!:)[\s\S])*):[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*(.*)$/, { key: 1, value: 2 }));
                if (oe && oe.groups) {
                  var V = oe.groups.key.toLowerCase(), ce = oe.groups.value;
                  switch (V) {
                    case or:
                      te = H(ce), I.trigger(o.Z.CMSD_STATIC_HEADER, te);
                      break;
                    case Ri:
                      le || (le = G(ce));
                  }
                }
              }
              var g = ti;
              return te && te.ot ? g = te.ot : fe && (g = N(fe)), w(l[g]), w(_[g]), te && (l[g] = Object.assign(l[g] || {}, te)), le && (_[g] = Object.assign(_[g] || {}, le)), { static: te, dynamic: le };
            }, getMaxBitrate: function(Z) {
              var fe = N(Z);
              return U(Tr, fe, "mb") || -1;
            }, getEstimatedThroughput: function(Z) {
              var fe = N(Z);
              return U(Tr, fe, "etp") || null;
            }, getResponseDelay: function(Z) {
              var fe = N(Z);
              return U(Tr, fe, "rd") || null;
            }, getRoundTripTime: function(Z) {
              var fe = N(Z);
              return U(Tr, fe, "rtt") || null;
            } }, r = (0, h.Z)(R).getInstance().getLogger(i), y(), i;
          }
          ni.__dashjs_factory_name = "CmsdModel";
          var Ft = E.Z.getSingletonFactory(ni);
          function un() {
            var i, r, l = this.context, _ = {};
            function R() {
              r = (0, h.Z)(l).getInstance().getLogger(i);
            }
            function I(w) {
              for (var F = {}, H = 0, G = 0, N = 0, U = 0, Z = w.length, fe = 0; fe < Z; ++fe) H += w[fe].chunkDownloadTimeRelativeMS, G += w[fe].bufferLevel, N += w[fe].chunkDownloadTimeRelativeMS * w[fe].bufferLevel, U += w[fe].chunkDownloadTimeRelativeMS * w[fe].chunkDownloadTimeRelativeMS;
              return F.m = (N - H * G / Z) / (U - H * H / Z), F.b = G / Z - F.m * H / Z, function(te) {
                return F.m * te + F.b;
              };
            }
            function y(w) {
              var F, H = !0, G = w.reduce(function(N, U) {
                return N + U.bufferLevelAtSegmentEnd;
              }, 0) / w.length;
              return w.forEach(function(N) {
                Math.abs(N.bufferLevelAtSegmentEnd / N.bufferLevelAtSegmentStart) < 0.95 && (H = !1), N.bufferLevelAtSegmentEnd / G < 0.8 && (H = !1), F ? F > N.bitrate && (H = !1) : F = N.bitrate;
              }), H;
            }
            return i = { setup: R, addMeasurement: function(w, F, H, G, N) {
              w && w.mediaType && !_[w.mediaType] && (_[w.mediaType] = []);
              var U = w.mediaInfo.bitrateList.find(function(Z) {
                return Z.id === w.representationId;
              });
              _[w.mediaType].push({ index: w.index, repId: w.representationId, mediaType: w.mediaType, requestTimeMS: G, adjustedAvailabilityStartTimeMS: w.availabilityStartTime.getTime(), segDurationMS: 1e3 * w.duration, chunksDurationMS: H.reduce(function(Z, fe) {
                return Z + fe.chunkDownloadDurationMS;
              }, 0), segmentBytes: H.reduce(function(Z, fe) {
                return Z + fe.chunkBytes;
              }, 0), bitrate: U && U.bandwidth, bitrateList: w.mediaInfo.bitrateList, chunkMeasurements: H, fetchDownloadDurationMS: F, throughputCapacityDelayMS: N, getEstimatedBufferLevel: I(H.slice(1)) }), _[w.mediaType].length > 10 && _[w.mediaType].shift();
            }, getThroughputCapacityDelayMS: function(w, F) {
              var H = _[w.mediaType] && _[w.mediaType].slice(-3);
              return !H || H.length < 3 ? 0 : y(H) ? F / 4 > 250 ? 250 : F / 4 : 0;
            }, getEstimatedDownloadDurationMS: function(w) {
              var F = _[w.mediaType].slice(-1).pop(), H = _[w.mediaType].slice(-3), G = F.chunkMeasurements.slice(-1).pop().chunkDownloadTimeRelativeMS;
              F.bufferLevelAtSegmentStart = F.getEstimatedBufferLevel(G / 2), F.bufferLevelAtSegmentEnd = F.getEstimatedBufferLevel(G);
              var N = y(H), U = N ? 0.6 : 0.8;
              if (F.isBufferStable && 1.05 * F.segDurationMS < F.fetchDownloadDurationMS) return F.fetchDownloadDurationMS;
              if (!N || F.segDurationMS < F.fetchDownloadDurationMS || F.adjustedAvailabilityStartTimeMS <= F.requestTimeMS + F.throughputCapacityDelayMS - F.segDurationMS) return 0.8 * F.fetchDownloadDurationMS;
              for (var Z = F.requestTimeMS + F.throughputCapacityDelayMS - F.adjustedAvailabilityStartTimeMS, fe = 0, te = 0, le = 0, ge = 0; ge < F.chunkMeasurements.length; ge++) {
                var q = F.chunkMeasurements[ge];
                if (Z < te + q.chunkDownloadDurationMS) break;
                te += q.chunkDownloadDurationMS, fe += q.chunkBytes, le++;
              }
              if (Z < 0 && r.warn("request time was before adjusted availibitly start time"), fe && te && le > 0.2 * F.chunkMeasurements.length) {
                var oe = fe / te, V = F.segmentBytes / oe;
                return F.fetchDownloadDurationMS < V ? F.fetchDownloadDurationMS * U : V * U;
              }
              var ce = F.bitrate;
              return F.bitrateList.some(function(g) {
                if (g.bandwidth > F.bitrate) return ce = g.bandwidth, !0;
              }), ce === F.bitrate ? F.fetchDownloadDurationMS * U : U * F.segmentBytes * 8 * 1e3 / ce;
            } }, R(), i;
          }
          un.__dashjs_factory_name = "LowLatencyThroughputModel";
          var En = E.Z.getSingletonFactory(un), jn = C(5717);
          function Cn(i, r, l) {
            return r in i ? Object.defineProperty(i, r, { value: l, enumerable: !0, configurable: !0, writable: !0 }) : i[r] = l, i;
          }
          function Xn(i) {
            i = i || {};
            var r, l, _, R, I, y, w, F, H, G, N, U = this.context, Z = i.errHandler, fe = i.dashMetrics, te = i.mediaPlayerModel, le = i.requestModifier, ge = i.boxParser, q = i.errors, oe = i.requestTimeout || 0, V = (0, m.Z)(U).getInstance(), ce = (0, Ne.Z)(U).getInstance();
            function g(P, D) {
              var O, A = P.request, ne = [], z = !0, se = !0, X = /* @__PURE__ */ new Date(), k = X, J = 0, pe = null, Le = null;
              if (!le || !fe || !Z) throw new Error("config object is not correct or missing");
              var Ie, xe = function(vt) {
                A.requestStartDate = X, A.requestEndDate = /* @__PURE__ */ new Date(), A.firstByteDate = A.firstByteDate || X, A.fileLoaderType = Le;
                var Et = O.response ? O.response.responseURL : null, gt = O.response ? O.response.status : null, Wt = O.response && O.response.getAllResponseHeaders ? O.response.getAllResponseHeaders() : O.response ? O.response.responseHeaders : null, zt = Wt && ce.get().streaming.cmsd && ce.get().streaming.cmsd.enabled ? w.parseResponseHeaders(Wt, A.mediaType) : null;
                fe.addHttpRequest(A, Et, gt, Wt, vt ? ne : null, zt);
              }, De = function(vt) {
                se = !1, xe(vt), A.type === Ue.w.MPD_TYPE && (fe.addManifestUpdate(A), V.trigger(o.Z.MANIFEST_LOADING_FINISHED, { request: A }));
              }, st = function() {
                if (pe && (clearTimeout(pe), pe = null), l.indexOf(O) !== -1 && (l.splice(l.indexOf(O), 1), se)) if (De(!1), D > 0) {
                  try {
                    ce.get().streaming.utcSynchronization.enableBackgroundSyncAfterSegmentDownloadError && A.type === Ue.w.MEDIA_SEGMENT_TYPE && te.getRetryAttemptsForType(Ue.w.MEDIA_SEGMENT_TYPE) === D && V.trigger(o.Z.ATTEMPT_BACKGROUND_SYNC);
                  } catch {
                  }
                  D--;
                  var vt = { config: P };
                  R.push(vt), vt.timeout = setTimeout(function() {
                    R.indexOf(vt) !== -1 && (R.splice(R.indexOf(vt), 1), g(P, D));
                  }, te.getRetryIntervalsForType(A.type));
                } else {
                  if (A.type === Ue.w.MSS_FRAGMENT_INFO_SEGMENT_TYPE) return;
                  Z.error(new ae.Z(I[A.type], A.url + " is not available", { request: A, response: O.response })), P.error && P.error(A, "error", O.response.statusText, O.response), P.complete && P.complete(A, O.response.statusText);
                }
              };
              A.hasOwnProperty("availabilityTimeComplete") && A.availabilityTimeComplete === !1 && window.fetch && A.responseType === "arraybuffer" && A.type === Ue.w.MEDIA_SEGMENT_TYPE ? ((Ie = Pn(U).create({ requestModifier: le, lowLatencyThroughputModel: H, boxParser: ge })).setup({ dashMetrics: fe }), Le = t.Z.FILE_LOADER_TYPES.FETCH) : (Ie = (0, qt.Z)(U).create({ requestModifier: le }), Le = t.Z.FILE_LOADER_TYPES.XHR);
              var ut = null, et = le.modifyRequestURL ? le.modifyRequestURL(A.url) : A.url;
              if (ce.get().streaming.cmcd && ce.get().streaming.cmcd.enabled) {
                var tt = ce.get().streaming.cmcd.mode;
                if (tt === t.Z.CMCD_MODE_QUERY) {
                  var Ut = function(vt) {
                    try {
                      var Et = [], gt = y.getQueryParameter(vt);
                      return gt && Et.push(gt), Et;
                    } catch {
                      return [];
                    }
                  }(A);
                  et = bt.Z.addAditionalQueryParameterToUrl(et, Ut);
                } else tt === t.Z.CMCD_MODE_HEADER && (ut = y.getHeaderParameters(A));
              }
              var be = F.getXHRWithCredentialsForType(A.type);
              if (A.queryParams) {
                var Be = Object.keys(A.queryParams).map(function(vt) {
                  return { key: vt, value: A.queryParams[vt] };
                });
                et = bt.Z.addAditionalQueryParameterToUrl(et, Be);
              }
              A.url = et, O = { url: et, method: Ue.w.GET, withCredentials: be, request: A, onload: function() {
                O.response.status >= 200 && O.response.status <= 299 && (De(!0), P.success && P.success(O.response.response, O.response.statusText, O.response.responseURL), P.complete && P.complete(A, O.response.statusText));
              }, onend: st, onerror: st, progress: function(vt) {
                var Et = /* @__PURE__ */ new Date();
                z && (z = !1, (!vt.lengthComputable || vt.lengthComputable && vt.total !== vt.loaded) && (A.firstByteDate = Et)), vt.lengthComputable && (A.bytesLoaded = vt.loaded, A.bytesTotal = vt.total), vt.noTrace || (ne.push({ s: k, d: vt.time ? vt.time : Et.getTime() - k.getTime(), b: [vt.loaded ? vt.loaded - J : 0] }), k = Et, J = vt.loaded), pe && (clearTimeout(pe), pe = null), ce.get().streaming.fragmentRequestProgressTimeout > 0 && (pe = setTimeout(function() {
                  G.warn("Abort request " + O.url + " due to progress timeout"), O.response.onabort = null, O.loader.abort(O), st();
                }, ce.get().streaming.fragmentRequestProgressTimeout)), P.progress && vt && P.progress(vt);
              }, onabort: function() {
                xe(!0), pe && (clearTimeout(pe), pe = null), P.abort && P.abort(A);
              }, ontimeout: function(vt) {
                var Et;
                if (vt.lengthComputable) {
                  var gt = vt.loaded / vt.total * 100;
                  Et = "Request timeout: loaded: " + vt.loaded + ", out of: " + vt.total + " : " + gt.toFixed(3) + "% Completed";
                } else Et = "Request timeout: non-computable download size";
                G.warn(Et);
              }, loader: Ie, timeout: oe, headers: ut };
              var mt = (/* @__PURE__ */ new Date()).getTime();
              if (isNaN(A.delayLoadingTime) || mt >= A.delayLoadingTime) l.push(O), Ie.load(O);
              else {
                var Ke = { httpRequest: O };
                _.push(Ke), Ke.delayTimeout = setTimeout(function() {
                  if (_.indexOf(Ke) !== -1) {
                    _.splice(_.indexOf(Ke), 1);
                    try {
                      X = /* @__PURE__ */ new Date(), k = X, l.push(Ke.httpRequest), Ie.load(Ke.httpRequest);
                    } catch {
                      Ke.httpRequest.onerror();
                    }
                  }
                }, A.delayLoadingTime - mt);
              }
            }
            return r = { load: function(P) {
              P.request ? g(P, te.getRetryAttemptsForType(P.request.type)) : P.error && P.error(P.request, "error");
            }, abort: function() {
              R.forEach(function(P) {
                clearTimeout(P.timeout), P.config.request && P.config.abort && P.config.abort(P.config.request);
              }), R = [], _.forEach(function(P) {
                return clearTimeout(P.delayTimeout);
              }), _ = [], l.forEach(function(P) {
                P.request.type !== Ue.w.MSS_FRAGMENT_INFO_SEGMENT_TYPE && (P.onloadend = P.onerror = P.onprogress = void 0, P.loader.abort(P));
              }), l = [];
            } }, G = (0, h.Z)(U).getInstance().getLogger(r), l = [], _ = [], R = [], y = mn(U).getInstance(), w = Ft(U).getInstance(), H = En(U).getInstance(), F = (0, jn.Z)(U).getInstance(), Cn(N = {}, Ue.w.MPD_TYPE, q.DOWNLOAD_ERROR_ID_MANIFEST_CODE), Cn(N, Ue.w.XLINK_EXPANSION_TYPE, q.DOWNLOAD_ERROR_ID_XLINK_CODE), Cn(N, Ue.w.INIT_SEGMENT_TYPE, q.DOWNLOAD_ERROR_ID_INITIALIZATION_CODE), Cn(N, Ue.w.MEDIA_SEGMENT_TYPE, q.DOWNLOAD_ERROR_ID_CONTENT_CODE), Cn(N, Ue.w.INDEX_SEGMENT_TYPE, q.DOWNLOAD_ERROR_ID_CONTENT_CODE), Cn(N, Ue.w.BITSTREAM_SWITCHING_SEGMENT_TYPE, q.DOWNLOAD_ERROR_ID_CONTENT_CODE), Cn(N, Ue.w.OTHER_TYPE, q.DOWNLOAD_ERROR_ID_CONTENT_CODE), I = N, r;
          }
          Xn.__dashjs_factory_name = "HTTPLoader";
          var Fn = E.Z.getClassFactory(Xn);
          function pr() {
            var i;
            function r() {
              i = {};
            }
            function l() {
              r();
            }
            return l(), { getLoader: function(_) {
              for (var R in i) if (i.hasOwnProperty(R) && _.startsWith(R)) return i[R];
              return Fn;
            }, registerLoader: function(_, R) {
              i[_] = R;
            }, unregisterLoader: function(_) {
              i[_] && delete i[_];
            }, unregisterAllLoader: r, reset: l };
          }
          pr.__dashjs_factory_name = "SchemeLoaderFactory";
          var Kn = E.Z.getSingletonFactory(pr);
          function Bn(i) {
            i = i || {};
            var r, l, _ = this.context;
            return r = Kn(_).getInstance(), { load: function(R) {
              if (!l) {
                var I = r.getLoader(R && R.request ? R.request.url : null);
                l = I(_).create({ errHandler: i.errHandler, mediaPlayerModel: i.mediaPlayerModel, requestModifier: i.requestModifier, dashMetrics: i.dashMetrics, boxParser: i.boxParser ? i.boxParser : null, constants: i.constants ? i.constants : null, dashConstants: i.dashConstants ? i.dashConstants : null, urlUtils: i.urlUtils ? i.urlUtils : null, requestTimeout: isNaN(i.requestTimeout) ? 0 : i.requestTimeout, errors: i.errors });
              }
              l.load(R);
            }, abort: function() {
              l && l.abort();
            } };
          }
          Bn.__dashjs_factory_name = "URLLoader";
          var sr = E.Z.getClassFactory(Bn);
          function ur(i) {
            return ur = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
              return typeof r;
            } : function(r) {
              return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
            }, ur(i);
          }
          function Rr(i, r) {
            return Rr = Object.setPrototypeOf || function(l, _) {
              return l.__proto__ = _, l;
            }, Rr(i, r);
          }
          function br(i, r) {
            return !r || ur(r) !== "object" && typeof r != "function" ? function(l) {
              if (l === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return l;
            }(i) : r;
          }
          function wr(i) {
            return wr = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
              return r.__proto__ || Object.getPrototypeOf(r);
            }, wr(i);
          }
          var Ur = function(i) {
            (function(I, y) {
              if (typeof y != "function" && y !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(y && y.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), y && Rr(I, y);
            })(R, i);
            var r, l, _ = (r = R, l = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var I, y = wr(r);
              if (l) {
                var w = wr(this).constructor;
                I = Reflect.construct(y, arguments, w);
              } else I = y.apply(this, arguments);
              return br(this, I);
            });
            function R(I) {
              var y;
              return function(w, F) {
                if (!(w instanceof F)) throw new TypeError("Cannot call a class as a function");
              }(this, R), (y = _.call(this, I)).checkForExistenceOnly = !0, y;
            }
            return R;
          }(S.Z);
          function _i(i) {
            i = i || {};
            var r, l, _ = this.context, R = i.eventBus, I = i.events, y = i.urlUtils, w = i.errors, F = i.streamId;
            return r = { checkForExistence: function(H) {
              var G = function(U) {
                R.trigger(I.CHECK_FOR_EXISTENCE_COMPLETED, { request: H, exists: U });
              };
              if (H) {
                var N = new Ur(H.url);
                l.load({ request: N, success: function() {
                  G(!0);
                }, error: function() {
                  G(!1);
                } });
              } else G(!1);
            }, load: function(H) {
              var G = function(N, U) {
                R.trigger(I.LOADING_COMPLETED, { request: H, response: N || null, error: U || null, sender: r });
              };
              H ? l.load({ request: H, progress: function(N) {
                R.trigger(I.LOADING_PROGRESS, { request: H, stream: N.stream, streamId: F }), N.data && R.trigger(I.LOADING_DATA_PROGRESS, { request: H, response: N.data || null, error: null, sender: r });
              }, success: function(N) {
                G(N);
              }, error: function(N, U, Z) {
                G(void 0, new ae.Z(w.FRAGMENT_LOADER_LOADING_FAILURE_ERROR_CODE, Z, U));
              }, abort: function(N) {
                N && R.trigger(I.LOADING_ABANDONED, { mediaType: N.mediaType, request: N, sender: r });
              } }) : G(void 0, new ae.Z(w.FRAGMENT_LOADER_NULL_REQUEST_ERROR_CODE, w.FRAGMENT_LOADER_NULL_REQUEST_ERROR_MESSAGE));
            }, abort: function() {
              l && l.abort();
            }, reset: function() {
              l && (l.abort(), l = null);
            } }, l = sr(_).create({ errHandler: i.errHandler, errors: w, dashMetrics: i.dashMetrics, mediaPlayerModel: i.mediaPlayerModel, requestModifier: i.requestModifier, urlUtils: y, constants: t.Z, boxParser: i.boxParser, dashConstants: i.dashConstants, requestTimeout: i.settings.get().streaming.fragmentRequestTimeout }), r;
          }
          _i.__dashjs_factory_name = "FragmentLoader";
          var ri = E.Z.getClassFactory(_i);
          function ii() {
            return { modifyResponseAsync: function(i) {
              return Promise.resolve(i);
            } };
          }
          ii.__dashjs_factory_name = "SegmentResponseModifier";
          var Di = E.Z.getSingletonFactory(ii);
          function Oi(i) {
            i = i || {};
            var r, l, _, R = this.context, I = (0, m.Z)(R).getInstance(), y = i.errHandler, w = i.mediaPlayerModel, F = i.dashMetrics, H = (0, h.Z)(R).getInstance(), G = Di(R).getInstance(), N = i.streamInfo;
            function U() {
              return N.id;
            }
            function Z() {
              for (var te in _) _[te].reset();
              _ = {};
            }
            function fe(te) {
              if (te.sender) {
                var le = te.request, ge = te.response, q = le.isInitializationRequest(), oe = le.mediaInfo.streamInfo;
                if (te.error && (le.mediaType === t.Z.AUDIO || le.mediaType === t.Z.VIDEO || le.mediaType === t.Z.TEXT && le.mediaInfo.isFragmented) && I.trigger(o.Z.SERVICE_LOCATION_BASE_URL_BLACKLIST_ADD, { entry: te.request.serviceLocation }), ge && oe) {
                  var V = function(ce, g, P, D) {
                    var O = new Ot();
                    return O.streamId = P, O.mediaInfo = g.mediaInfo, O.segmentType = g.type, O.start = g.startTime, O.duration = g.duration, O.end = O.start + O.duration, O.bytes = ce, O.index = g.index, O.quality = g.quality, O.representationId = g.representationId, O.endFragment = D, O;
                  }(ge, le, N.id, te.type !== o.Z.FRAGMENT_LOADING_PROGRESS);
                  G.modifyResponseAsync(V).then(function(ce) {
                    I.trigger(q ? o.Z.INIT_FRAGMENT_LOADED : o.Z.MEDIA_FRAGMENT_LOADED, { chunk: ce, request: le }, { streamId: oe.id, mediaType: le.mediaType });
                  }).catch(function(ce) {
                    l.error(ce), I.trigger(q ? o.Z.INIT_FRAGMENT_LOADED : o.Z.MEDIA_FRAGMENT_LOADED, { chunk: V, request: le }, { streamId: oe.id, mediaType: le.mediaType });
                  });
                } else l.warn("No " + le.mediaType + " bytes to push or stream is inactive.");
              }
            }
            return r = { getStreamId: U, getModel: function(te) {
              var le = _[te];
              return le || (le = K(R).create({ streamInfo: N, type: te, dashMetrics: F, fragmentLoader: ri(R).create({ dashMetrics: F, mediaPlayerModel: w, errHandler: y, requestModifier: (0, Re.Z)(R).getInstance(), settings: i.settings, boxParser: i.boxParser, eventBus: I, events: o.Z, errors: Q, dashConstants: i.dashConstants, urlUtils: i.urlUtils, streamId: U() }), debug: H, eventBus: I, events: o.Z }), _[te] = le), le;
            }, reset: function() {
              I.off(n.Z.FRAGMENT_LOADING_COMPLETED, fe, this), I.off(n.Z.FRAGMENT_LOADING_PROGRESS, fe, this), Z();
            } }, l = H.getLogger(r), Z(), I.on(n.Z.FRAGMENT_LOADING_COMPLETED, fe, r), I.on(n.Z.FRAGMENT_LOADING_PROGRESS, fe, r), r;
          }
          Oi.__dashjs_factory_name = "FragmentController";
          var ca = E.Z.getClassFactory(Oi), fa = function i() {
            (function(r, l) {
              if (!(r instanceof l)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.url = null, this.width = null, this.height = null, this.x = null, this.y = null;
          }, Mi = function i() {
            (function(r, l) {
              if (!(r instanceof l)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.mediaType = null, this.bitrate = null, this.width = null, this.height = null, this.scanType = null, this.qualityIndex = NaN;
          };
          function Pi(i) {
            var r, l, _ = this.context, R = i.streamInfo;
            function I(w) {
              l.setTrackByIndex(w);
            }
            function y() {
              l && l.reset();
            }
            return r = { getStreamId: function() {
              return R.id;
            }, initialize: function() {
              l.addTracks();
              var w = l.getTracks();
              w && w.length > 0 && I(0);
            }, provide: function(w, F) {
              if (typeof F == "function") {
                var H, G, N = l.getCurrentTrack();
                if (!N || N.segmentDuration <= 0 || w == null) F(null);
                else {
                  (G = l.getThumbnailRequestForTime(w)) && (N.segmentDuration = G.duration), H = w % N.segmentDuration;
                  var U = Math.floor(H * N.tilesHor * N.tilesVert / N.segmentDuration), Z = new fa();
                  if (Z.width = Math.floor(N.widthPerTile), Z.height = Math.floor(N.heightPerTile), Z.x = Math.floor(U % N.tilesHor) * N.widthPerTile, Z.y = Math.floor(U / N.tilesHor) * N.heightPerTile, "readThumbnail" in N) return N.readThumbnail(w, function(te) {
                    Z.url = te, F(Z);
                  });
                  if (G) Z.url = G.url, N.segmentDuration = NaN;
                  else {
                    var fe = Math.floor(w / N.segmentDuration);
                    Z.url = function(te, le) {
                      var ge = le + te.startNumber, q = (0, u.vi)(te.templateUrl, "Number", ge);
                      return q = (0, u.vi)(q, "Time", (ge - 1) * te.segmentDuration * te.timescale), q = (0, u.vi)(q, "Bandwidth", te.bandwidth), (0, u.eR)(q);
                    }(N, fe);
                  }
                  F(Z);
                }
              }
            }, setTrackByIndex: I, getCurrentTrackIndex: function() {
              return l.getCurrentTrackIndex();
            }, getBitrateList: function() {
              var w = l.getTracks(), F = 0;
              return w.map(function(H) {
                var G = new Mi();
                return G.mediaType = t.Z.IMAGE, G.qualityIndex = F++, G.bitrate = H.bitrate, G.width = H.width, G.height = H.height, G;
              });
            }, reset: y }, y(), l = (0, Gt.Z)(_).create({ streamInfo: R, adapter: i.adapter, baseURLController: i.baseURLController, timelineConverter: i.timelineConverter, debug: i.debug, eventBus: i.eventBus, events: i.events, dashConstants: i.dashConstants, dashMetrics: i.dashMetrics, segmentBaseController: i.segmentBaseController }), r;
          }
          Pi.__dashjs_factory_name = "ThumbnailController";
          var da = E.Z.getClassFactory(Pi), Ei = C(7417);
          function Li(i) {
            var r;
            i = i || {};
            var l = [], _ = (0, m.Z)(this.context).getInstance(), R = i.updateEventName, I = i.addBlacklistEventName;
            function y(w) {
              l.indexOf(w) === -1 && (l.push(w), _.trigger(R, { entry: w }));
            }
            return r = { add: y, contains: function(w) {
              return !!(l.length && w && w.length) && l.indexOf(w) !== -1;
            }, reset: function() {
              l = [];
            } }, I && _.on(I, function(w) {
              y(w.entry);
            }, r), r;
          }
          Li.__dashjs_factory_name = "BlackListController";
          var ai = E.Z.getClassFactory(Li), ga = [t.Z.VIDEO, t.Z.AUDIO, t.Z.TEXT, t.Z.MUXED, t.Z.IMAGE];
          function kn(i) {
            i = i || {};
            var r, l, _, R, I, y, w, F, H, G, N, U, Z, fe, te, le, ge, q, oe = this.context, V = (0, m.Z)(oe).getInstance(), ce = (0, Je.Z)(oe).getInstance(), g = i.manifestModel, P = i.mediaPlayerModel, D = i.dashMetrics, O = i.manifestUpdater, A = i.adapter, ne = i.timelineConverter, z = i.capabilities, se = i.errHandler, X = i.abrController, k = i.playbackController, J = i.eventController, pe = i.mediaController, Le = i.protectionController, Ie = i.textController, xe = i.videoModel, De = i.streamInfo, st = i.settings;
            function ut(ht, kt) {
              return new Promise(function(Ht, Vt) {
                Et(), G = !0, Wt();
                var Xt = xe.getElement(), Ye = [];
                ga.forEach(function(Me) {
                  (Me !== t.Z.TEXT || ht) && (Me !== t.Z.VIDEO || !Xt || Xt && /^VIDEO$/i.test(Xt.nodeName)) && Ye.push(et(Me, ht));
                }), Promise.all(Ye).then(function() {
                  return Me = kt, new Promise(function(ct) {
                    var de = {}, _e = _.map(function(Xe) {
                      return Xe.createBufferSinks(Me);
                    });
                    Promise.all(_e).then(function(Xe) {
                      Xe.forEach(function(Ct) {
                        Ct && (de[Ct.getType()] = Ct);
                      }), ct(de);
                    }).catch(function() {
                      ct(de);
                    });
                  });
                  var Me;
                }).then(function(Me) {
                  if (G = !1, _.length === 0) {
                    var ct = "No streams to play.";
                    se.error(new ae.Z(Q.MANIFEST_ERROR_ID_NOSTREAMS_CODE, ct, g.getValue())), l.fatal(ct);
                  } else zt();
                  ht && Ie.createTracks(De), Ht(Me);
                }).catch(function(Me) {
                  Vt(Me);
                });
              });
            }
            function et(ht, kt) {
              var Ht, Vt = A.getAllMediaInfoForType(De, ht), Xt = [], Ye = null;
              if (!Vt || Vt.length === 0) return l.info("No " + ht + " data."), Promise.resolve();
              ht === t.Z.VIDEO && (w = !0), ht === t.Z.AUDIO && (F = !0);
              for (var Me = 0, ct = Vt.length; Me < ct; Me++) Ye = Vt[Me], ht === t.Z.TEXT && Ye.isEmbedded && (Ie.addEmbeddedTrack(De, Ye), Xt.push(Ye)), tt(Ye) && pe.addTrack(Ye);
              if (Xt.length > 0 && (pe.setInitialMediaSettingsForType(ht, De), Ie.addMediaInfosToBuffer(De, ht, Xt)), Vt = Vt.filter(function(_e) {
                return !_e.isEmbedded;
              }), Vt.length === 0) return Promise.resolve();
              if (ht === t.Z.IMAGE) return (U = da(oe).create({ streamInfo: De, adapter: A, baseURLController: i.baseURLController, timelineConverter: i.timelineConverter, debug: le, eventBus: V, events: o.Z, dashConstants: e.Z, dashMetrics: i.dashMetrics, segmentBaseController: i.segmentBaseController })).initialize(), Promise.resolve();
              V.trigger(o.Z.STREAM_INITIALIZING, { streamInfo: De, mediaInfo: Ye }), pe.setInitialMediaSettingsForType(ht, De);
              var de = function(_e, Xe) {
                var Ct = _e && _e.length > 0 ? _e[0] : null, xt = N.getModel(Ct ? Ct.type : null), yn = Ct ? Ct.type : null, On = Ct ? Ct.mimeType : null, zn = Ct ? Ct.isFragmented : null, Nn = Yt(oe).create({ streamInfo: De, type: yn, mimeType: On, timelineConverter: ne, adapter: A, manifestModel: g, mediaPlayerModel: P, fragmentModel: xt, dashMetrics: i.dashMetrics, baseURLController: i.baseURLController, segmentBaseController: i.segmentBaseController, abrController: X, playbackController: k, mediaController: pe, textController: Ie, errHandler: se, settings: st, boxParser: te, segmentBlacklistController: Z });
                Nn.initialize(Xe, w, zn), _.push(Nn);
                for (var fr = 0; fr < _e.length; fr++) Nn.addMediaInfo(_e[fr]);
                return yn === t.Z.TEXT && Ie.addMediaInfosToBuffer(De, yn, _e, xt), Nn;
              }(Vt, kt);
              return (Ht = pe.getCurrentTrackFor(ht, De.id)) ? (X.updateTopQualityIndex(Ht), de.selectMediaInfo(ht === t.Z.TEXT && Ht.isEmbedded ? Vt[0] : Ht)) : Promise.resolve();
            }
            function tt(ht) {
              var kt, Ht = ht ? ht.type : null;
              return Ht === t.Z.MUXED ? (kt = "Multiplexed representations are intentionally not supported, as they are not compliant with the DASH-AVC/264 guidelines", l.fatal(kt), se.error(new ae.Z(Q.MANIFEST_ERROR_ID_MULTIPLEXED_CODE, kt, g.getValue())), !1) : !(Ht !== t.Z.TEXT && Ht !== t.Z.IMAGE && ht.contentProtection && !z.supportsEncryptedMedia() && (se.error(new ae.Z(Q.CAPABILITY_MEDIAKEYS_ERROR_CODE, Q.CAPABILITY_MEDIAKEYS_ERROR_MESSAGE)), 1));
            }
            function Ut(ht) {
              for (var kt = _ ? _.length : 0, Ht = 0; Ht < kt; Ht++) {
                var Vt = _[Ht].getFragmentModel();
                Vt.abortRequests(), Vt.resetInitialSettings(), _[Ht].reset(!1, ht);
              }
              Ie && Ie.deactivateStream(De), _ = [], I = !1, y = !1, en(!1), Be(!1), V.trigger(o.Z.STREAM_DEACTIVATED, { streamInfo: De });
            }
            function be(ht) {
              Ut(ht), R = !1, w = !1, F = !1, H = {}, G = !1, ge = !1, q = [];
            }
            function Be(ht) {
              ge = ht;
            }
            function mt() {
              return De ? De.start : NaN;
            }
            function Ke() {
              return De ? De.id : null;
            }
            function vt() {
              return De;
            }
            function Et() {
              if (!xe || !X) throw new Error(t.Z.MISSING_CONFIG_ERROR);
            }
            function gt(ht) {
              ht.error && (se.error(ht.error), l.fatal(ht.error.message));
            }
            function Wt() {
              if (J) {
                var ht = A.getEventsFor(De);
                ht && ht.length > 0 && J.addInlineEvents(ht, De.id);
              }
            }
            function zt() {
              for (var ht = _.length, kt = H.audio || H.video ? new ae.Z(Q.DATA_UPDATE_FAILED_ERROR_CODE, Q.DATA_UPDATE_FAILED_ERROR_MESSAGE) : null, Ht = 0; Ht < ht; Ht++) if (_[Ht].isUpdating() || G) return;
              if (Le) {
                Le.clearMediaInfoArray();
                for (var Vt = 0; Vt < ht && _[Vt]; Vt++) {
                  var Xt = _[Vt].getType(), Ye = _[Vt].getMediaInfo();
                  if (Xt === t.Z.AUDIO || Xt === t.Z.VIDEO || Xt === t.Z.TEXT && Ye.isFragmented) {
                    var Me = _[Vt].getMediaInfo();
                    Me && Le.initializeForMedia(Me);
                  }
                }
                Le.handleKeySystemFromManifest();
              }
              kt ? se.error(kt) : R || (R = !0, xe.waitForReadyState(t.Z.VIDEO_ELEMENT_READY_STATES.HAVE_METADATA, function() {
                V.trigger(o.Z.STREAM_INITIALIZED, { streamInfo: De });
              }));
            }
            function gn() {
              var ht = It(), kt = ht.length;
              if (kt !== 0) {
                for (var Ht = 0; Ht < kt; Ht++) if (!ht[Ht].isBufferingCompleted() && (ht[Ht].getType() === t.Z.AUDIO || ht[Ht].getType() === t.Z.VIDEO)) return void l.debug("onBufferingCompleted - One streamProcessor has finished but", ht[Ht].getType(), "one is not buffering completed");
                l.debug("onBufferingCompleted - trigger STREAM_BUFFERING_COMPLETED"), y = !0, V.trigger(o.Z.STREAM_BUFFERING_COMPLETED, { streamInfo: De }, { streamInfo: De });
              } else l.warn("onBufferingCompleted - can't trigger STREAM_BUFFERING_COMPLETED because no streamProcessor is defined");
            }
            function pn(ht) {
              H[ht.mediaType] = ht.error, zt();
            }
            function je(ht) {
              J && J.addInbandEvents(ht.events, De.id);
            }
            function yt(ht) {
              return ht && ht.type ? ot(ht.type) : null;
            }
            function ot(ht) {
              return ht ? It().filter(function(kt) {
                return kt.getType() === ht;
              })[0] : null;
            }
            function It() {
              for (var ht, kt, Ht = [], Vt = 0; Vt < _.length; Vt++) (ht = (kt = _[Vt]).getType()) !== t.Z.AUDIO && ht !== t.Z.VIDEO && ht !== t.Z.TEXT || Ht.push(kt);
              return Ht;
            }
            function Lt(ht, kt) {
              var Ht = vt(), Vt = kt.getStreamInfo();
              if (!Vt || !Ht) return !0;
              var Xt = A.getAdaptationForType(Vt.index, ht, Vt), Ye = A.getAdaptationForType(Ht.index, ht, Ht);
              return Xt && Ye ? !(!$t(Ye) && $t(Xt)) : !Xt && !Ye;
            }
            function $t(ht) {
              return !!ht && !!(ht.ContentProtection || ht.Representation_asArray && ht.Representation_asArray.length > 0 && ht.Representation_asArray[0].ContentProtection);
            }
            function Qt(ht, kt) {
              var Ht = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
              if (!ht || !ht.hasOwnProperty("getStreamInfo")) return !1;
              var Vt = ht.getStreamInfo(), Xt = Ht ? Ht.getStreamInfo() : vt();
              if (!Vt || !Xt) return !1;
              var Ye = A.getAdaptationForType(Vt.index, kt, Vt), Me = A.getAdaptationForType(Xt.index, kt, Xt);
              if (!Ye || !Me) return !Ye && !Me;
              var ct = Ye && Me && Ye.mimeType === Me.mimeType, de = Me.Representation_asArray.map(function(xt) {
                return xt.codecs;
              }), _e = Ye.Representation_asArray.map(function(xt) {
                return xt.codecs;
              }), Xe = _e.some(function(xt) {
                return de.indexOf(xt) > -1;
              }), Ct = _e.some(function(xt) {
                return de.some(function(yn) {
                  return z.codecRootCompatibleWithCodec(yn, xt);
                });
              });
              return Xe || Ct && ct;
            }
            function en(ht) {
              fe = ht;
            }
            function on() {
              return fe;
            }
            return r = { initialize: function() {
              V.on(o.Z.BUFFERING_COMPLETED, gn, r), V.on(o.Z.DATA_UPDATE_COMPLETED, pn, r), V.on(o.Z.INBAND_EVENTS, je, r), Le && (V.on(o.Z.KEY_ERROR, gt, r), V.on(o.Z.SERVER_CERTIFICATE_UPDATED, gt, r), V.on(o.Z.LICENSE_REQUEST_COMPLETE, gt, r), V.on(o.Z.KEY_SYSTEM_SELECTED, gt, r), V.on(o.Z.KEY_SESSION_CREATED, gt, r), V.on(o.Z.KEY_STATUSES_CHANGED, gt, r)), Ie.initializeForStream(De), V.trigger(o.Z.STREAM_UPDATED, { streamInfo: De });
            }, getStreamId: function() {
              return De ? De.id : null;
            }, activate: function(ht, kt) {
              return new Promise(function(Ht, Vt) {
                if (!I) return on() ? (I = !0, V.trigger(o.Z.STREAM_ACTIVATED, { streamInfo: De }), void Ht(kt)) : void function(Xt, Ye) {
                  return ut(Xt, Ye);
                }(ht, kt).then(function(Xt) {
                  I = !0, V.trigger(o.Z.STREAM_ACTIVATED, { streamInfo: De }), Ht(Xt);
                }).catch(function(Xt) {
                  Vt(Xt);
                });
                Ht(kt);
              });
            }, deactivate: Ut, getIsActive: function() {
              return I;
            }, getDuration: function() {
              return De ? De.duration : NaN;
            }, getStartTime: mt, getId: Ke, getStreamInfo: vt, getHasAudioTrack: function() {
              return F;
            }, getHasVideoTrack: function() {
              return w;
            }, startPreloading: function(ht, kt) {
              return new Promise(function(Ht, Vt) {
                on() ? Vt() : (l.info("[startPreloading] Preloading next stream with id ".concat(Ke())), en(!0), ut(ht, kt).then(function() {
                  for (var Xt = 0; Xt < _.length && _[Xt]; Xt++) _[Xt].setExplicitBufferingTime(mt()), _[Xt].getScheduleController().startScheduleTimer();
                  Ht();
                }).catch(function() {
                  en(!1), Vt();
                }));
              });
            }, initializeForTextWithMediaSource: function(ht) {
              return new Promise(function(kt, Ht) {
                et(t.Z.TEXT, ht).then(function() {
                  return (Vt = ot(t.Z.TEXT)) ? Vt.createBufferSinks() : Promise.resolve();
                  var Vt;
                }).then(function() {
                  Ie.createTracks(De), kt();
                }).catch(function(Vt) {
                  Ht(Vt);
                });
              });
            }, getThumbnailController: function() {
              return U;
            }, getBitrateListFor: function(ht) {
              if (Et(), ht === t.Z.IMAGE) return U ? U.getBitrateList() : [];
              var kt = function(Ht) {
                for (var Vt = null, Xt = 0; Xt < _.length; Xt++) if ((Vt = _[Xt]).getType() === Ht) return Vt.getMediaInfo();
                return null;
              }(ht);
              return X.getBitrateList(kt);
            }, updateData: function(ht) {
              return new Promise(function(kt) {
                G = !0, De = ht, J && Wt();
                for (var Ht = [], Vt = 0, Xt = _.length; Vt < Xt; Vt++) {
                  var Ye = _[Vt], Me = Ye.getMediaInfo();
                  Ht.push(Ye.updateStreamInfo(De));
                  var ct = A.getAllMediaInfoForType(De, Ye.getType());
                  if (ct = ct.filter(function(Xe) {
                    return !Xe.isEmbedded;
                  })) {
                    Ye.clearMediaInfoArray();
                    for (var de = 0; de < ct.length; de++) {
                      var _e = ct[de];
                      Ye.addMediaInfo(ct[de]), A.areMediaInfosEqual(Me, _e) && (X.updateTopQualityIndex(_e), Ht.push(Ye.selectMediaInfo(_e)));
                    }
                  }
                }
                Promise.all(Ht).then(function() {
                  for (Ht = []; q.length > 0; ) {
                    var Xe = q.pop(), Ct = Xe.newMediaInfo, xt = yt(Xe.oldMediaInfo);
                    if (!xt) return;
                    Ht.push(xt.prepareTrackSwitch()), Ht.push(xt.selectMediaInfo(Ct));
                  }
                  return Promise.all(Ht);
                }).then(function() {
                  G = !1, zt(), V.trigger(o.Z.STREAM_UPDATED, { streamInfo: De }), kt();
                });
              });
            }, reset: function(ht) {
              N && (N.reset(), N = null), X && De && X.clearDataForStream(De.id), Z && (Z.reset(), Z = null), be(ht), De = null, V.off(o.Z.DATA_UPDATE_COMPLETED, pn, r), V.off(o.Z.BUFFERING_COMPLETED, gn, r), V.off(o.Z.INBAND_EVENTS, je, r), Le && (V.off(o.Z.KEY_ERROR, gt, r), V.off(o.Z.SERVER_CERTIFICATE_UPDATED, gt, r), V.off(o.Z.LICENSE_REQUEST_COMPLETE, gt, r), V.off(o.Z.KEY_SYSTEM_SELECTED, gt, r), V.off(o.Z.KEY_SESSION_CREATED, gt, r), V.off(o.Z.KEY_STATUSES_CHANGED, gt, r));
            }, getProcessors: It, setMediaSource: function(ht) {
              return new Promise(function(kt, Ht) {
                for (var Vt = [], Xt = 0; Xt < _.length; ) tt(_[Xt].getMediaInfo()) ? (Vt.push(_[Xt].setMediaSource(ht)), Xt++) : (_[Xt].reset(), _.splice(Xt, 1));
                Promise.all(Vt).then(function() {
                  for (var Ye = 0; Ye < _.length; Ye++) _[Ye].dischargePreBuffer();
                  if (_.length === 0) {
                    var Me = "No streams to play.";
                    se.error(new ae.Z(Q.MANIFEST_ERROR_ID_NOSTREAMS_CODE, Me + "nostreams", g.getValue())), l.fatal(Me);
                  }
                  kt();
                }).catch(function(Ye) {
                  l.error(Ye), Ht(Ye);
                });
              });
            }, isMediaCodecCompatible: function(ht) {
              var kt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
              return Qt(ht, t.Z.VIDEO, kt) && Qt(ht, t.Z.AUDIO, kt);
            }, isProtectionCompatible: function(ht) {
              return !ht || Lt(t.Z.VIDEO, ht) && Lt(t.Z.AUDIO, ht);
            }, getPreloaded: on, getIsEndedEventSignaled: function() {
              return ge;
            }, setIsEndedEventSignaled: Be, getAdapter: function() {
              return A;
            }, getHasFinishedBuffering: function() {
              return y;
            }, setPreloaded: en, startScheduleControllers: function() {
              for (var ht = _.length, kt = 0; kt < ht && _[kt]; kt++) _[kt].getScheduleController().startScheduleTimer();
            }, prepareTrackChange: function(ht) {
              if (I && De) {
                y = !1;
                var kt = ht.newMediaInfo, Ht = g.getValue();
                A.setCurrentMediaInfo(De.id, kt.type, kt);
                var Vt = yt(kt);
                if (Vt) {
                  var Xt = k.getTime();
                  l.info("Stream -  Process track changed at current time " + Xt), Ht.refreshManifestOnSwitchTrack ? (q.push(ht), O.getIsUpdating() || (l.debug("Stream -  Refreshing manifest for switch track"), O.refreshManifest())) : Vt.selectMediaInfo(kt).then(function() {
                    kt.type !== t.Z.VIDEO && kt.type !== t.Z.AUDIO || X.updateTopQualityIndex(kt), Vt.prepareTrackSwitch();
                  });
                }
              }
            }, prepareQualityChange: function(ht) {
              var kt = ot(ht.mediaType);
              kt && kt.prepareQualityChange(ht);
            } }, function() {
              try {
                le = (0, h.Z)(oe).getInstance(), l = le.getLogger(r), be(), te = (0, Ei.Z)(oe).getInstance(), Z = ai(oe).create({ updateEventName: o.Z.SEGMENT_LOCATION_BLACKLIST_CHANGED, addBlacklistEventName: o.Z.SEGMENT_LOCATION_BLACKLIST_ADD }), N = ca(oe).create({ streamInfo: De, mediaPlayerModel: P, dashMetrics: D, errHandler: se, settings: st, boxParser: te, dashConstants: e.Z, urlUtils: ce });
              } catch (ht) {
                throw ht;
              }
            }(), r;
          }
          kn.__dashjs_factory_name = "Stream";
          var Yr = E.Z.getClassFactory(kn), oi = function i(r) {
            (function(l, _) {
              if (!(l instanceof _)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.url = r || null, this.type = Ue.w.CONTENT_STEERING_TYPE, this.responseType = "json";
          }, Kr = function i() {
            (function(r, l) {
              if (!(r instanceof l)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.version = null, this.ttl = 300, this.reloadUri = null, this.pathwayPriority = [], this.pathwayClones = [];
          };
          function xi() {
            var i, r, l, _, R, I, y, w, F, H, G, N, U, Z, fe, te = this.context, le = (0, Je.Z)(te).getInstance();
            function ge(X) {
              g(X, "baseUrl");
            }
            function q(X) {
              g(X, "location");
            }
            function oe(X) {
              if (X && X.request && X.request.serviceLocation && X.request.requestStartDate && X.request.requestEndDate && !isNaN(X.request.bytesTotal)) {
                var k = X.request.serviceLocation, J = X.request.requestEndDate.getTime() - X.request.requestStartDate.getTime();
                ce(k, parseInt(8 * X.request.bytesTotal / J * 1e3));
              }
            }
            function V(X) {
              X && X.httpRequest && X.httpRequest._serviceLocation && !isNaN(X.throughput) && ce(X.httpRequest._serviceLocation, 1e3 * X.throughput);
            }
            function ce(X, k) {
              R[X] || (R[X] = []), R[X].push(k), R[X].length > 4 && R[X].shift();
            }
            function g(X, k) {
              if (X && X.request && X.request.serviceLocation) {
                var J = X.request.serviceLocation;
                _[k].all.indexOf(J) === -1 && _[k].all.push(J), _[k].current = J;
              }
            }
            function P() {
              var X = G.getValue(), k = fe.getContentSteering(X);
              return k || (k = U.getServiceDescriptionSettings().contentSteering), k;
            }
            function D() {
              return new Promise(function(X) {
                try {
                  var k = P();
                  if (!k || !k.serverUrl) return void X();
                  var J = function(Le) {
                    var Ie = Le.serverUrl;
                    l && l.reloadUri && (Ie = le.isRelative(l.reloadUri) ? le.resolve(l.reloadUri, Le.serverUrl) : l.reloadUri);
                    var xe = [], De = _.baseUrl.all.concat(_.location.all);
                    if (De.length > 0) {
                      var st = De.map(function(tt) {
                        var Ut = function(be) {
                          if (!be || !R[be] || R[be].length === 0) return -1;
                          var Be = R[be].reduce(function(mt, Ke) {
                            return mt + Ke;
                          }) / R[be].length;
                          return parseInt(Be);
                        }(tt);
                        return { serviceLocation: tt, throughput: Ut };
                      });
                      st.sort(function(tt, Ut) {
                        return Ut.throughput - tt.throughput;
                      });
                      var ut = "", et = "";
                      st.forEach(function(tt, Ut) {
                        Ut !== 0 && (ut = "".concat(ut, ","), tt.throughput > -1 && (et = "".concat(et, ","))), ut = "".concat(ut).concat(tt.serviceLocation), tt.throughput > -1 && (et = "".concat(et).concat(tt.throughput));
                      }), xe.push({ key: "_DASH_pathway", value: '"'.concat(ut, '"') }), xe.push({ key: "_DASH_throughput", value: et });
                    }
                    return Ie = bt.Z.addAditionalQueryParameterToUrl(Ie, xe);
                  }(k), pe = new oi(J);
                  y.load({ request: pe, success: function(Le) {
                    (function(Ie) {
                      Ie && Ie[e.Z.CONTENT_STEERING_RESPONSE.VERSION] && parseInt(Ie[e.Z.CONTENT_STEERING_RESPONSE.VERSION]) === 1 && ((l = new Kr()).version = Ie[e.Z.CONTENT_STEERING_RESPONSE.VERSION], Ie[e.Z.CONTENT_STEERING_RESPONSE.TTL] && !isNaN(Ie[e.Z.CONTENT_STEERING_RESPONSE.TTL]) && (l.ttl = Ie[e.Z.CONTENT_STEERING_RESPONSE.TTL]), Ie[e.Z.CONTENT_STEERING_RESPONSE.RELOAD_URI] && (l.reloadUri = Ie[e.Z.CONTENT_STEERING_RESPONSE.RELOAD_URI]), Ie[e.Z.CONTENT_STEERING_RESPONSE.PATHWAY_PRIORITY] && (l.pathwayPriority = Ie[e.Z.CONTENT_STEERING_RESPONSE.PATHWAY_PRIORITY]), Ie[e.Z.CONTENT_STEERING_RESPONSE.PATHWAY_CLONES] && (l.pathwayClones = Ie[e.Z.CONTENT_STEERING_RESPONSE.PATHWAY_CLONES], l.pathwayClones = l.pathwayClones.filter(function(xe) {
                        return function(De) {
                          return De[e.Z.CONTENT_STEERING_RESPONSE.BASE_ID] && De[e.Z.CONTENT_STEERING_RESPONSE.ID] && De[e.Z.CONTENT_STEERING_RESPONSE.URI_REPLACEMENT] && De[e.Z.CONTENT_STEERING_RESPONSE.URI_REPLACEMENT][e.Z.CONTENT_STEERING_RESPONSE.HOST];
                        }(xe);
                      })), ne());
                    })(Le), Z.trigger(n.Z.CONTENT_STEERING_REQUEST_COMPLETED, { currentSteeringResponseData: l, url: J }), X();
                  }, error: function(Le, Ie, xe, De) {
                    (function(st, ut) {
                      try {
                        switch (r.warn("Error fetching data from content steering server", st), ut.status) {
                          case 410:
                            break;
                          case 429:
                            var et = ut && ut.getResponseHeader ? ut.getResponseHeader("retry-after") : null;
                            et !== null && (l || (l = {}), l.ttl = parseInt(et)), ne();
                            break;
                          default:
                            ne();
                        }
                      } catch (tt) {
                        r.error(tt);
                      }
                    })(Le, De), X(Le);
                  }, complete: function() {
                    _.baseUrl.all = O(_.baseUrl), _.location.all = O(_.location);
                  } });
                } catch (Le) {
                  X(Le);
                }
              });
            }
            function O(X) {
              return X.all && X.all.length !== 0 && X.current ? X.all.filter(function(k) {
                return k === X.current;
              }) : [];
            }
            function A(X) {
              try {
                var k = [];
                return X && X.length !== 0 && l && l.pathwayClones && l.pathwayClones.length !== 0 && l.pathwayClones.forEach(function(J) {
                  var pe = X.filter(function(st) {
                    return J[e.Z.CONTENT_STEERING_RESPONSE.BASE_ID] === st.serviceLocation;
                  }), Le = null;
                  if (pe && pe.length > 0 && (Le = pe[0]), Le) {
                    var Ie = new URL(Le.url), xe = J[e.Z.CONTENT_STEERING_RESPONSE.URI_REPLACEMENT][e.Z.CONTENT_STEERING_RESPONSE.HOST];
                    xe = bt.Z.stringHasProtocol(xe) ? xe : "".concat(Ie.protocol, "//").concat(xe);
                    var De = { synthesizedUrl: "".concat(xe).concat(Ie.pathname), serviceLocation: J[e.Z.CONTENT_STEERING_RESPONSE.ID], queryParams: J[e.Z.CONTENT_STEERING_RESPONSE.URI_REPLACEMENT][e.Z.CONTENT_STEERING_RESPONSE.PARAMS], reference: Le };
                    k.push(De);
                  }
                }), k;
              } catch (J) {
                return r.error(J), [];
              }
            }
            function ne() {
              l && l.ttl && !isNaN(l.ttl) && (I && clearTimeout(I), I = setTimeout(function() {
                D();
              }, 1e3 * l.ttl));
            }
            function z() {
              I && clearTimeout(I), I = null;
            }
            function se() {
              l = null, R = {}, _ = { baseUrl: { current: null, all: [] }, location: { current: null, all: [] } }, z();
            }
            return i = { reset: function() {
              se(), Z.off(n.Z.FRAGMENT_LOADING_STARTED, ge, i), Z.off(n.Z.MANIFEST_LOADING_STARTED, q, i), Z.off(n.Z.MANIFEST_LOADING_FINISHED, oe, i), Z.off(n.Z.THROUGHPUT_MEASUREMENT_STORED, V, i);
            }, setConfig: function(X) {
              X && (X.adapter && (fe = X.adapter), X.errHandler && (w = X.errHandler), X.dashMetrics && (F = X.dashMetrics), X.mediaPlayerModel && (H = X.mediaPlayerModel), X.requestModifier && (N = X.requestModifier), X.manifestModel && (G = X.manifestModel), X.serviceDescriptionController && (U = X.serviceDescriptionController), X.eventBus && (Z = X.eventBus));
            }, loadSteeringData: D, getCurrentSteeringResponseData: function() {
              return l;
            }, shouldQueryBeforeStart: function() {
              var X = P();
              return !!X && X.queryBeforeStart;
            }, getSteeringDataFromManifest: P, stopSteeringRequestTimer: z, getSynthesizedBaseUrlElements: function(X) {
              try {
                return A(X).map(function(k) {
                  var J = new vr(k.synthesizedUrl, k.serviceLocation);
                  return J.queryParams = k.queryParams, J.dvbPriority = k.reference.dvbPriority, J.dvbWeight = k.reference.dvbWeight, J.availabilityTimeOffset = k.reference.availabilityTimeOffset, J.availabilityTimeComplete = k.reference.availabilityTimeComplete, J;
                });
              } catch (k) {
                return r.error(k), [];
              }
            }, getSynthesizedLocationElements: function(X) {
              try {
                return A(X).map(function(k) {
                  var J = new nn(k.synthesizedUrl, k.serviceLocation);
                  return J.queryParams = k.queryParams, J;
                });
              } catch (k) {
                return r.error(k), [];
              }
            }, initialize: function() {
              y = sr(te).create({ errHandler: w, dashMetrics: F, mediaPlayerModel: H, requestModifier: N, errors: Q }), Z.on(n.Z.FRAGMENT_LOADING_STARTED, ge, i), Z.on(n.Z.MANIFEST_LOADING_STARTED, q, i), Z.on(n.Z.MANIFEST_LOADING_FINISHED, oe, i), Z.on(n.Z.THROUGHPUT_MEASUREMENT_STORED, V, i);
            } }, r = (0, h.Z)(te).getInstance().getLogger(i), se(), i;
          }
          xi.__dashjs_factory_name = "ContentSteeringController";
          var Sr = E.Z.getSingletonFactory(xi);
          function Fi() {
            var i, r, l, _ = this.context, R = (0, Ne.Z)(_).getInstance();
            return i = { select: function(I) {
              if (!I || I.length === 0) return null;
              var y = null;
              return R.get().streaming.applyContentSteering && (y = function(w) {
                var F = l.getCurrentSteeringResponseData();
                return F && F.pathwayPriority && F.pathwayPriority.length > 0 ? function() {
                  for (var H = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], G = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], N = 0, U = null, Z = function() {
                    var fe = H[N], te = G.findIndex(function(le) {
                      return le.serviceLocation && le.serviceLocation === fe;
                    });
                    if (te !== -1 && !r.contains(G[te].serviceLocation)) return U = G[te], "break";
                    N += 1;
                  }; N < H.length && Z() !== "break"; ) ;
                  return U;
                }(F.pathwayPriority, w) : null;
              }(I)), y || (y = function(w) {
                return w[0];
              }(I)), y;
            }, setConfig: function(I) {
              I.blacklistController && (r = I.blacklistController), I.contentSteeringController && (l = I.contentSteeringController);
            }, reset: function() {
              r.reset();
            } }, r = ai(_).create({ updateEventName: o.Z.SERVICE_LOCATION_LOCATION_BLACKLIST_CHANGED, addBlacklistEventName: o.Z.SERVICE_LOCATION_LOCATION_BLACKLIST_ADD }), l = Sr(_).getInstance(), i;
          }
          Fi.__dashjs_factory_name = "LocationSelector";
          var Br = E.Z.getClassFactory(Fi);
          function ki() {
            var i, r, l, _, R, I, y, w, F, H, G, N, U, Z, fe = this.context, te = (0, m.Z)(fe).getInstance(), le = (0, Je.Z)(fe).getInstance();
            function ge() {
              l = NaN, y = !1, R = !0, I = !1, q();
            }
            function q() {
              _ !== null && (clearTimeout(_), _ = null);
            }
            function oe(z) {
              q(), I || (isNaN(z) && !isNaN(l) && (z = 1e3 * l), isNaN(z) || (r.debug("Refresh manifest in " + z + " milliseconds."), _ = setTimeout(P, z)));
            }
            function V() {
              var z = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
              y = !0;
              var se = F.getValue(), X = se.url, k = null, J = G.getPatchLocation(se), pe = H.select(J), Le = null;
              if (pe && !z) X = pe.url, k = pe.serviceLocation, Le = pe.queryParams;
              else {
                var Ie = ce(se), xe = H.select(Ie);
                xe && (X = xe.url, k = xe.serviceLocation, Le = xe.queryParams);
              }
              le.isRelative(X) && (X = le.resolve(X, se.url)), w.load(X, k, Le);
            }
            function ce(z) {
              var se = G.getLocation(z), X = U.getSynthesizedLocationElements(se);
              return se.concat(X);
            }
            function g(z) {
              if (z) {
                if (G.getIsPatch(z)) {
                  var se = z;
                  z = F.getValue();
                  var X = G.isPatchValid(z, se), k = X;
                  if (X) {
                    var J = G.getPublishTime(z);
                    k = G.applyPatchToManifest(z, se);
                    var pe = G.getPublishTime(z);
                    k = J.getTime() != pe.getTime();
                  }
                  if (!k) return r.debug("Patch provided is invalid, performing full manifest refresh"), void V(!0);
                  z.loadedTime = /* @__PURE__ */ new Date();
                }
              } else (z = F.getValue()).loadedTime = /* @__PURE__ */ new Date();
              if (F.getValue() && F.getValue().type === e.Z.DYNAMIC && z.type === e.Z.STATIC) return te.trigger(o.Z.DYNAMIC_TO_STATIC), y = !1, void (I = !0);
              F.setValue(z);
              var Le = /* @__PURE__ */ new Date(), Ie = (Le.getTime() - z.loadedTime.getTime()) / 1e3;
              1e3 * (l = G.getManifestUpdatePeriod(z, Ie)) > 2147483647 && (l = 2147483647e-3), te.trigger(o.Z.MANIFEST_UPDATED, { manifest: z }), r.info("Manifest has been refreshed at " + Le + "[" + Le.getTime() / 1e3 + "] "), R || oe();
            }
            function P() {
              R || (y ? oe(Z.get().streaming.manifestUpdateRetryInterval) : V());
            }
            function D(z) {
              z.error ? z.error.code === Q.MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE && N.error(z.error) : g(z.manifest);
            }
            function O() {
              R = !1, oe();
            }
            function A() {
              (R = !Z.get().streaming.scheduling.scheduleWhilePaused) && q();
            }
            function ne() {
              y = !1;
            }
            return i = { initialize: function() {
              ge(), te.on(o.Z.STREAMS_COMPOSED, ne, this), te.on(n.Z.PLAYBACK_STARTED, O, this), te.on(n.Z.PLAYBACK_PAUSED, A, this), te.on(o.Z.INTERNAL_MANIFEST_LOADED, D, this);
            }, setManifest: function(z) {
              g(z);
            }, refreshManifest: V, getIsUpdating: function() {
              return y;
            }, setConfig: function(z) {
              z && (z.manifestModel && (F = z.manifestModel), z.adapter && (G = z.adapter), z.manifestLoader && (w = z.manifestLoader), z.errHandler && (N = z.errHandler), z.locationSelector && (H = z.locationSelector), z.settings && (Z = z.settings), z.contentSteeringController && (U = z.contentSteeringController));
            }, reset: function() {
              te.off(n.Z.PLAYBACK_STARTED, O, this), te.off(n.Z.PLAYBACK_PAUSED, A, this), te.off(o.Z.STREAMS_COMPOSED, ne, this), te.off(o.Z.INTERNAL_MANIFEST_LOADED, D, this), ge();
            } }, r = (0, h.Z)(fe).getInstance().getLogger(i), H = Br(fe).create(), i;
          }
          ki.__dashjs_factory_name = "ManifestUpdater";
          var lo = E.Z.getClassFactory(ki);
          function ha() {
            var i, r, l, _, R, I, y, w, F, H, G, N, U, Z, fe, te, le = this.context, ge = (0, m.Z)(le).getInstance(), q = (0, Je.Z)(le).getInstance();
            function oe() {
              w = [], F = [], H = null, G = null, U = null, N = NaN, l = !1, _ = !1, Z = R.get().streaming.utcSynchronization.timeBetweenSyncAttempts;
            }
            function V() {
              R.get().streaming.utcSynchronization.enabled && !l && !_ && U && U.value && U.schemeIdUri && !isNaN(N) && !isNaN(R.get().streaming.utcSynchronization.backgroundAttempts) && (G && (Date.now() - G) / 1e3 < 30 || (w = [], _ = !0, ce(isNaN(R.get().streaming.utcSynchronization.backgroundAttempts) ? 2 : R.get().streaming.utcSynchronization.backgroundAttempts)));
            }
            function ce(xe) {
              try {
                if (xe <= 0) return void Le();
                var De = Date.now();
                I[U.schemeIdUri](U.value, function(st) {
                  var ut = Date.now(), et = P(De, ut, st);
                  w.push(et), ce(xe - 1);
                }, function() {
                  Le();
                });
              } catch {
                Le();
              }
            }
            function g() {
              var xe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, De = xe || 0;
              if (!F || F.length === 0 || De >= F.length) D();
              else {
                var st = F[De];
                if (st) if (I.hasOwnProperty(st.schemeIdUri)) {
                  var ut = (/* @__PURE__ */ new Date()).getTime();
                  I[st.schemeIdUri](st.value, function(et) {
                    var tt = (/* @__PURE__ */ new Date()).getTime(), Ut = P(ut, tt, et);
                    U = st, D(Ut);
                  }, function() {
                    g(De + 1);
                  });
                } else g(De + 1);
                else D();
              }
            }
            function P(xe, De, st) {
              return st - (De - (De - xe) / 2);
            }
            function D() {
              var xe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : NaN, De = isNaN(xe);
              De && R.get().streaming.utcSynchronization.useManifestDateHeaderTimeSource ? J() : pe(De, xe);
            }
            function O(xe) {
              var De = Date.parse(xe);
              return isNaN(De) && (De = function(st) {
                var ut, et, tt = /^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2})(?::([0-9]*)(\.[0-9]*)?)?(?:([+\-])([0-9]{2})([0-9]{2}))?/.exec(st);
                return ut = Date.UTC(parseInt(tt[1], 10), parseInt(tt[2], 10) - 1, parseInt(tt[3], 10), parseInt(tt[4], 10), parseInt(tt[5], 10), tt[6] && (parseInt(tt[6], 10) || 0), tt[7] && 1e3 * parseFloat(tt[7]) || 0), tt[9] && tt[10] && (et = 60 * parseInt(tt[9], 10) + parseInt(tt[10], 10), ut += (tt[8] === "+" ? -1 : 1) * et * 60 * 1e3), new Date(ut).getTime();
              }(xe)), De;
            }
            function A(xe) {
              return Date.parse(xe);
            }
            function ne(xe) {
              return Date.parse(xe);
            }
            function z(xe, De, st) {
              st();
            }
            function se(xe, De, st) {
              var ut = O(xe);
              isNaN(ut) ? st() : De(ut);
            }
            function X(xe, De, st, ut, et) {
              var tt, Ut, be = !1, Be = new XMLHttpRequest(), mt = et ? Ue.w.HEAD : Ue.w.GET, Ke = De.match(/\S+/g);
              if (De = Ke.shift(), tt = function() {
                be || (be = !0, Ke.length ? X(xe, Ke.join(" "), st, ut, et) : ut());
              }, Ut = function() {
                var Et, gt;
                Be.status === 200 && (Et = et ? Be.getResponseHeader("Date") : Be.response, gt = xe(Et), isNaN(gt) || (st(gt), be = !0));
              }, q.isRelative(De)) {
                var vt = te.resolve();
                vt && (De = q.resolve(De, vt.url));
              }
              Be.open(mt, De), Be.timeout = 5e3, Be.onload = Ut, Be.onloadend = tt, Be.send();
            }
            function k(xe, De, st) {
              X(ne, xe, De, st, !0);
            }
            function J() {
              var xe = y.getLatestMPDRequestHeaderValueByID("Date"), De = xe !== null ? new Date(xe).getTime() : Number.NaN;
              isNaN(De) ? pe(!0) : pe(!1, De - Date.now());
            }
            function pe(xe, De) {
              if (isNaN(N) || isNaN(De) || xe || function(ut) {
                try {
                  var et, tt = Ie(ut), Ut = isNaN(Z) ? 30 : Z, be = isNaN(R.get().streaming.utcSynchronization.timeBetweenSyncAttemptsAdjustmentFactor) ? 2 : R.get().streaming.utcSynchronization.timeBetweenSyncAttemptsAdjustmentFactor, Be = isNaN(R.get().streaming.utcSynchronization.maximumTimeBetweenSyncAttempts) ? 600 : R.get().streaming.utcSynchronization.maximumTimeBetweenSyncAttempts, mt = isNaN(R.get().streaming.utcSynchronization.minimumTimeBetweenSyncAttempts) ? 2 : R.get().streaming.utcSynchronization.minimumTimeBetweenSyncAttempts;
                  tt ? (et = Math.min(Ut * be, Be), r.debug("Increasing timeBetweenSyncAttempts to ".concat(et))) : (et = Math.max(Ut / be, mt), r.debug("Decreasing timeBetweenSyncAttempts to ".concat(et))), Z = et;
                } catch {
                }
              }(De), !xe && !isNaN(De)) {
                H = Date.now(), l = !1;
                var st = isNaN(N);
                N = De, st && V(), r.debug("Completed UTC sync. Setting client - server offset to ".concat(De));
              }
              xe && (U = null, l = !1, fe.error(new ae.Z(Q.TIME_SYNC_FAILED_ERROR_CODE, Q.TIME_SYNC_FAILED_ERROR_MESSAGE))), ge.trigger(o.Z.UPDATE_TIME_SYNC_OFFSET, { offset: De }), ge.trigger(o.Z.TIME_SYNCHRONIZATION_COMPLETED);
            }
            function Le() {
              if (w && w.length !== 0) {
                var xe = w.reduce(function(De, st) {
                  return De + st;
                }, 0) / w.length;
                Ie(xe) ? r.debug("Completed background UTC sync. Offset is within allowed threshold and is not adjusted.") : (r.debug("Completed background UTC sync. Setting client - server offset to ".concat(xe)), N = xe, ge.trigger(o.Z.UPDATE_TIME_SYNC_OFFSET, { offset: N })), _ = !1, G = Date.now();
              }
            }
            function Ie(xe) {
              try {
                if (isNaN(N)) return !0;
                var De = R.get().streaming.utcSynchronization.maximumAllowedDrift && !isNaN(R.get().streaming.utcSynchronization.maximumAllowedDrift) ? R.get().streaming.utcSynchronization.maximumAllowedDrift : 100;
                return xe >= N - De && xe <= N + De;
              } catch {
                return !0;
              }
            }
            return i = { initialize: function() {
              oe(), I = { "urn:mpeg:dash:utc:http-head:2014": k, "urn:mpeg:dash:utc:http-xsdate:2014": X.bind(null, O), "urn:mpeg:dash:utc:http-iso:2014": X.bind(null, A), "urn:mpeg:dash:utc:direct:2014": se, "urn:mpeg:dash:utc:http-head:2012": k, "urn:mpeg:dash:utc:http-xsdate:2012": X.bind(null, O), "urn:mpeg:dash:utc:http-iso:2012": X.bind(null, A), "urn:mpeg:dash:utc:direct:2012": se, "urn:mpeg:dash:utc:http-ntp:2014": z, "urn:mpeg:dash:utc:ntp:2014": z, "urn:mpeg:dash:utc:sntp:2014": z };
            }, attemptSync: function(xe, De) {
              F = xe, l || (function(st) {
                try {
                  if (!st || !R.get().streaming.utcSynchronization.enabled) return !1;
                  var ut = isNaN(Z) ? 30 : Z;
                  return !(H && ut && !isNaN(ut)) || (Date.now() - H) / 1e3 >= ut;
                } catch {
                  return !0;
                }
              }(De) ? (l = !0, g()) : ge.trigger(o.Z.TIME_SYNCHRONIZATION_COMPLETED));
            }, setConfig: function(xe) {
              xe && (xe.dashMetrics && (y = xe.dashMetrics), xe.baseURLController && (te = xe.baseURLController), xe.errHandler && (fe = xe.errHandler), xe.settings && (R = xe.settings));
            }, reset: function() {
              oe(), ge.off(o.Z.ATTEMPT_BACKGROUND_SYNC, V, i);
            } }, r = (0, h.Z)(le).getInstance().getLogger(i), ge.on(o.Z.ATTEMPT_BACKGROUND_SYNC, V, i), i;
          }
          ha.__dashjs_factory_name = "TimeSyncController";
          var ma = E.Z.getSingletonFactory(ha);
          ma.HTTP_TIMEOUT_MS = 5e3, E.Z.updateSingletonFactory(ha.__dashjs_factory_name, ma);
          var ru = ma;
          function co() {
            var i, r, l, _, R, I = this.context, y = (0, m.Z)(I).getInstance();
            return i = { attachMediaSource: function(w) {
              var F = window.URL.createObjectURL(r);
              return w.setSource(F), _ === "managedMediaSource" && (w.setDisableRemotePlayback(!0), r.addEventListener("startstreaming", function() {
                y.trigger(n.Z.MANAGED_MEDIA_SOURCE_START_STREAMING);
              }), r.addEventListener("endstreaming", function() {
                y.trigger(n.Z.MANAGED_MEDIA_SOURCE_END_STREAMING);
              })), F;
            }, createMediaSource: function() {
              var w = "WebKitMediaSource" in window, F = "MediaSource" in window;
              return "ManagedMediaSource" in window ? (r = new ManagedMediaSource(), _ = "managedMediaSource", R.info("Created ManagedMediaSource")) : F ? (r = new MediaSource(), _ = "mediaSource", R.info("Created MediaSource")) : w && (r = new WebKitMediaSource(), R.info("Created WebkitMediaSource")), r;
            }, detachMediaSource: function(w) {
              w.setSource(null);
            }, setConfig: function(w) {
              w && w.settings && (l = w.settings);
            }, setDuration: function w(F) {
              r && r.readyState === "open" && (F === null && isNaN(F) || r.duration !== F && (F !== 1 / 0 || l.get().streaming.buffer.mediaSourceDurationInfinity || (F = Math.pow(2, 32)), function(H) {
                for (var G = H.sourceBuffers, N = 0; N < G.length; N++) if (G[N].updating) return !0;
                return !1;
              }(r) ? setTimeout(w.bind(null, F), 50) : (R.info("Set MediaSource duration:" + F), r.duration = F)));
            }, setSeekable: function(w, F) {
              r && typeof r.setLiveSeekableRange == "function" && typeof r.clearLiveSeekableRange == "function" && r.readyState === "open" && w >= 0 && w < F && (r.clearLiveSeekableRange(), r.setLiveSeekableRange(w, F));
            }, signalEndOfStream: function(w) {
              if (w && w.readyState === "open") {
                for (var F = w.sourceBuffers, H = 0; H < F.length; H++)
                  if (F[H].updating || F[H].buffered.length === 0) return;
                R.info("call to mediaSource endOfStream"), w.endOfStream();
              }
            } }, R = (0, h.Z)(I).getInstance().getLogger(i), i;
          }
          co.__dashjs_factory_name = "MediaSourceController";
          var iu = E.Z.getSingletonFactory(co);
          function fo() {
            var i, r, l, _, R, I, y, w, F, H, G, N = "urn:mpeg:dash:event:2012", U = "discarded", Z = "updated", fe = "added", te = this.context, le = (0, m.Z)(te).getInstance();
            function ge() {
              if (!y || !w) throw new Error("setConfig function has to be called previously");
            }
            function q() {
              G = !1, l = {}, _ = {}, R = null, H = !1, I = Date.now() / 1e3;
            }
            function oe() {
              try {
                if (!H) {
                  H = !0;
                  var z = w.getTime(), se = z - I;
                  se = I > 0 ? Math.max(0, se) : 0, V(_, se, z), V(l, se, z), ce(_), ce(l), I = z, H = !1;
                }
              } catch (X) {
                H = !1, r.error(X);
              }
            }
            function V(z, se, X) {
              try {
                O(z, function(k) {
                  if (k !== void 0) {
                    var J = isNaN(k.duration) ? 0 : k.duration;
                    k.calculatedPresentationTime <= X && k.calculatedPresentationTime + se + J >= X ? ne(k, n.Z.EVENT_MODE_ON_START) : (A(X, J + se, k.calculatedPresentationTime) || function(pe) {
                      try {
                        var Le = pe.eventStream.period.start + pe.eventStream.period.duration;
                        return pe.calculatedPresentationTime > Le;
                      } catch (Ie) {
                        return r.error(Ie), !1;
                      }
                    }(k)) && (r.debug("Removing event ".concat(k.id, " from period ").concat(k.eventStream.period.id, " as it is expired or invalid")), function(pe, Le) {
                      try {
                        var Ie = Le.eventStream.schemeIdUri, xe = Le.eventStream.period.id, De = Le.eventStream.value, st = Le.id;
                        pe[xe][Ie] = pe[xe][Ie].filter(function(ut) {
                          return De && ut.eventStream.value && ut.eventStream.value !== De || ut.id !== st;
                        }), pe[xe][Ie].length === 0 && delete pe[xe][Ie];
                      } catch (ut) {
                        r.error(ut);
                      }
                    }(z, k));
                  }
                });
              } catch (k) {
                r.error(k);
              }
            }
            function ce(z) {
              try {
                for (var se in z) z.hasOwnProperty(se) && Object.keys(z[se]).length === 0 && delete z[se];
              } catch (X) {
                r.error(X);
              }
            }
            function g(z, se) {
              var X = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], k = z.eventStream.schemeIdUri, J = z.eventStream.value, pe = z.id, Le = U;
              se[k] || (se[k] = []);
              var Ie = se[k].findIndex(function(De) {
                return (!J || De.eventStream.value && De.eventStream.value === J) && De.id === pe;
              });
              if (Ie === -1) se[k].push(z), z.triggeredReceivedEvent = !1, z.triggeredStartEvent = !1, Le = fe;
              else if (X) {
                var xe = se[k][Ie];
                z.triggeredReceivedEvent = xe.triggeredReceivedEvent, z.triggeredStartEvent = xe.triggeredStartEvent, se[k][Ie] = z, Le = Z;
              }
              return Le;
            }
            function P(z) {
              try {
                if (z.eventStream.value == 1) {
                  var se, X = z.calculatedPresentationTime;
                  se = z.calculatedPresentationTime == 4294967295 ? NaN : z.calculatedPresentationTime + z.duration, le.trigger(n.Z.MANIFEST_VALIDITY_CHANGED, { id: z.id, validUntil: X, newDuration: se, newManifestValidAfter: NaN }, { mode: n.Z.EVENT_MODE_ON_START });
                }
              } catch (k) {
                r.error(k);
              }
            }
            function D(z) {
              try {
                var se = w.getTime();
                O(z, function(X) {
                  var k = X.eventStream && X.eventStream.period && !isNaN(X.eventStream.period.duration) ? X.eventStream.period.duration : NaN, J = X.eventStream && X.eventStream.period && !isNaN(X.eventStream.period.start) ? X.eventStream.period.start : NaN;
                  if (!isNaN(k) && !isNaN(J)) {
                    var pe = X.calculatedPresentationTime;
                    Math.abs(pe - se) < 300 && ne(X, n.Z.EVENT_MODE_ON_START);
                  }
                });
              } catch (X) {
                r.error(X);
              }
            }
            function O(z, se) {
              try {
                if (z) for (var X = Object.keys(z), k = 0; k < X.length; k++) for (var J = z[X[k]], pe = Object.keys(J), Le = 0; Le < pe.length; Le++) J[pe[Le]].forEach(function(Ie) {
                  Ie !== void 0 && se(Ie);
                });
              } catch (Ie) {
                r.error(Ie);
              }
            }
            function A(z, se, X) {
              try {
                return z - se > X;
              } catch (k) {
                return r.error(k), !1;
              }
            }
            function ne(z, se) {
              try {
                var X = w.getTime(), k = z.id;
                if (se === n.Z.EVENT_MODE_ON_RECEIVE && !z.triggeredReceivedEvent) return r.debug("Received event ".concat(k)), z.triggeredReceivedEvent = !0, void le.trigger(z.eventStream.schemeIdUri, { event: z }, { mode: se });
                z.triggeredStartEvent || (z.eventStream.schemeIdUri === N && z.eventStream.value == 1 ? z.duration === 0 && z.presentationTimeDelta === 0 || (r.debug("Starting manifest refresh event ".concat(k, " at ").concat(X)), function() {
                  try {
                    ge(), y.refreshManifest();
                  } catch (J) {
                    r.error(J);
                  }
                }()) : z.eventStream.schemeIdUri === "urn:mpeg:dash:event:callback:2015" && z.eventStream.value == 1 ? (r.debug("Starting callback event ".concat(k, " at ").concat(X)), function(J) {
                  try {
                    (0, qt.Z)(te).create({}).load({ method: "get", url: J, request: { responseType: "arraybuffer" } });
                  } catch (pe) {
                    r.error(pe);
                  }
                }(z.messageData)) : (r.debug("Starting event ".concat(k, " from period ").concat(z.eventStream.period.id, " at ").concat(X)), le.trigger(z.eventStream.schemeIdUri, { event: z }, { mode: se })), z.triggeredStartEvent = !0);
              } catch (J) {
                r.error(J);
              }
            }
            return i = { addInlineEvents: function(z, se) {
              try {
                if (ge(), l[se] || (l[se] = {}), z) for (var X = 0; X < z.length; X++) {
                  var k = z[X];
                  if (!A(w.getTime(), isNaN(k.duration) ? 0 : k.duration, k.calculatedPresentationTime)) {
                    var J = g(k, l[se], !0);
                    J === fe ? (r.debug("Added inline event with id ".concat(k.id, " from period ").concat(se)), ne(k, n.Z.EVENT_MODE_ON_RECEIVE)) : J === Z && r.debug("Updated inline event with id ".concat(k.id, " from period ").concat(se));
                  }
                }
              } catch (pe) {
                throw pe;
              }
            }, addInbandEvents: function(z, se) {
              try {
                ge(), _[se] || (_[se] = {});
                for (var X = 0; X < z.length; X++) {
                  var k = z[X];
                  A(w.getTime(), isNaN(k.duration) ? 0 : k.duration, k.calculatedPresentationTime) || (g(k, _[se], !1) === fe ? (k.eventStream.schemeIdUri === N && P(k), r.debug("Added inband event with id ".concat(k.id, " from period ").concat(se)), ne(k, n.Z.EVENT_MODE_ON_RECEIVE)) : r.debug("Inband event with scheme_id_uri ".concat(k.eventStream.schemeIdUri, ", value ").concat(k.eventStream.value, ", period id ").concat(se, " and event id ").concat(k.id, " was ignored because it has been added before.")));
                }
                oe();
              } catch (J) {
                throw J;
              }
            }, getInbandEvents: function() {
              return _;
            }, getInlineEvents: function() {
              return l;
            }, start: function() {
              try {
                ge(), r.debug("Start Event Controller");
                var z = F.get().streaming.eventControllerRefreshDelay;
                G || isNaN(z) || (G = !0, R = setInterval(oe, z));
              } catch (se) {
                throw se;
              }
            }, setConfig: function(z) {
              try {
                if (!z) return;
                z.manifestUpdater && (y = z.manifestUpdater), z.playbackController && (w = z.playbackController), z.settings && (F = z.settings);
              } catch (se) {
                throw se;
              }
            }, reset: function() {
              (function() {
                try {
                  R !== null && G && (clearInterval(R), R = null, G = !1, function() {
                    try {
                      D(_), D(l);
                    } catch (z) {
                      r.error(z);
                    }
                  }());
                } catch (z) {
                  throw z;
                }
              })(), q();
            } }, r = (0, h.Z)(te).getInstance().getLogger(i), q(), i;
          }
          fo.__dashjs_factory_name = "EventController";
          var au = E.Z.getSingletonFactory(fo), si = { LEVELS: { SUGGESTION: "Suggestion", WARNING: "Warning", ERROR: "Error" }, EVENTS: { NO_UTC_TIMING_ELEMENT: { key: "NO_UTC_TIMING_ELEMENT", message: "No UTCTiming element is present in the manifest. You may experience playback failures. For a detailed validation use https://conformance.dashif.org/" }, NON_COMPLIANT_SMPTE_IMAGE_ATTRIBUTE: { key: "NON_COMPLIANT_SMPTE_IMAGE_ATTRIBUTE", message: 'SMPTE 2052-1:2013 defines the attribute name as "imageType" and does not define "imagetype"' }, INVALID_DVR_WINDOW: { key: "INVALID_DVR_WINDOW", message: "No valid segment found when applying a specification compliant DVR window calculation. Using SegmentTimeline entries as a fallback." } } };
          function pa(i, r) {
            (r == null || r > i.length) && (r = i.length);
            for (var l = 0, _ = new Array(r); l < r; l++) _[l] = i[l];
            return _;
          }
          function go() {
            var i, r, l, _, R, I, y, w, F, H, G, N, U, Z, fe, te, le, ge, q, oe, V, ce, g, P, D, O, A, ne, z, se, X, k, J, pe, Le, Ie, xe, De, st, ut, et, tt, Ut, be, Be, mt, Ke, vt, Et = this.context, gt = (0, m.Z)(Et).getInstance();
            function Wt() {
              if (!(I && I.hasOwnProperty("load") && V && V.hasOwnProperty("initialize") && V.hasOwnProperty("reset") && V.hasOwnProperty("getClientTimeOffset") && y && oe && F && J)) throw new Error(t.Z.MISSING_CONFIG_ERROR);
            }
            function zt() {
              if (!R || !R.hasOwnProperty("setManifest")) throw new Error("initialize function has to be called previously");
            }
            function gn() {
              (function() {
                try {
                  var $e = w.getStreamsInfo();
                  if (!g && $e.length === 0) throw new Error("There are no periods in the MPD");
                  g && $e.length > 0 && F.updateManifestUpdateInfo({ currentTime: J.getTime(), buffered: k.getBufferRange(), presentationStartTime: $e[0].start, clientTimeOffset: V.getClientTimeOffset() }), ce.length > 0 && function(Sn) {
                    Sn.length !== 0 ? ce = ce.filter(function(_n) {
                      var qn = Sn.filter(function(Ln) {
                        return Ln.id === _n.getId();
                      }).length > 0 || _n.getId() === g.getId();
                      return qn || (r.debug("Removing stream ".concat(_n.getId())), _n.reset(!0)), qn;
                    }) : r.warn("No periods included in the current manifest. Skipping the filtering of outdated stream objects.");
                  }($e);
                  for (var Pt = [], an = 0, hn = $e.length; an < hn; an++) {
                    var bn = $e[an];
                    Pt.push(je(bn)), F.addManifestUpdateStreamInfo(bn);
                  }
                  Promise.all(Pt).then(function() {
                    return new Promise(function(Sn, _n) {
                      g ? Sn() : yt($e, Sn, _n);
                    });
                  }).then(function() {
                    gt.trigger(o.Z.STREAMS_COMPOSED), xt();
                  }).catch(function(Sn) {
                    throw Sn;
                  });
                } catch (Sn) {
                  oe.error(new ae.Z(Q.MANIFEST_ERROR_ID_NOSTREAMS_CODE, Sn.message + " nostreamscomposed", y.getValue())), se = !0, Hr();
                }
              })();
            }
            function pn() {
              Be = !0;
            }
            function je($e) {
              var Pt = Si($e.id);
              return Pt ? Pt.updateData($e) : (Pt = Yr(Et).create({ manifestModel: y, mediaPlayerModel: Le, dashMetrics: F, manifestUpdater: R, adapter: w, timelineConverter: V, capabilities: l, capabilitiesFilter: _, errHandler: oe, baseURLController: U, segmentBaseController: Z, textController: D, abrController: te, playbackController: J, eventController: ge, mediaController: le, protectionController: P, videoModel: k, streamInfo: $e, settings: be }), ce.push(Pt), Pt.initialize(), Promise.resolve());
            }
            function yt($e, Pt, an) {
              try {
                Xt();
                var hn = F.getCurrentDVRInfo().range;
                if (hn.end < hn.start) {
                  mt && clearTimeout(mt);
                  var bn = Math.min(1e3 * (-1 * (hn.end - hn.start) + 2), 2147483647);
                  return r.debug("Waiting for ".concat(bn, " ms before playback can start")), gt.trigger(o.Z.AST_IN_FUTURE, { delay: bn }), void (mt = setTimeout(function() {
                    yt($e, Pt, an);
                  }, bn));
                }
                be.get().streaming.applyProducerReferenceTime && pe.calculateProducerReferenceTimeOffsets($e);
                var Sn = $e[0].manifestInfo;
                if (be.get().streaming.applyServiceDescription && pe.applyServiceDescription(Sn), w.getIsDynamic()) {
                  var _n = zr($e, Sn);
                  J.computeAndSetLiveDelay(_n, Sn);
                }
                (be.get().streaming.applyContentSteering && N.shouldQueryBeforeStart() ? N.loadSteeringData() : Promise.resolve()).then(function() {
                  var qn = y.getValue();
                  qn && U.update(qn), ot(), Pt();
                }).catch(function(qn) {
                  r.error(qn), ot(), Pt();
                });
              } catch (qn) {
                an(qn);
              }
            }
            function ot() {
              var $e = function() {
                var hn;
                if (w.getIsDynamic()) {
                  var bn = F.getCurrentDVRInfo();
                  hn = (bn && bn.range ? bn.range.end : 0) - J.getOriginalLiveDelay();
                  var Sn = bn ? bn.range : null;
                  if (Sn) {
                    if (isNaN(Ke) && Ke.toString().indexOf("posix:") === -1) {
                      var _n = fr(!0);
                      isNaN(_n) || (r.info("Start time from URI parameters: ".concat(_n)), hn = Math.min(hn, _n));
                    } else {
                      r.info("Start time provided by the app: ".concat(Ke));
                      var qn = Jn(!0, Ke);
                      isNaN(qn) || (hn = Math.min(hn, qn));
                    }
                    var Ln = be.get().streaming.timeShiftBuffer.calcFromSegmentTimeline ? 0.1 : 0;
                    hn = Math.max(hn, Sn.start + Ln);
                  }
                } else if (hn = Xr()[0].getStreamInfo().start, isNaN(Ke)) {
                  var xr = fr(!1);
                  isNaN(xr) || (r.info("Start time from URI parameters: ".concat(xr)), hn = Math.max(hn, xr));
                } else {
                  r.info("Start time provided by the app: ".concat(Ke));
                  var fi = Jn(!1, Ke);
                  isNaN(fi) || (hn = Math.max(hn, fi));
                }
                return hn;
              }(), Pt = Vt($e), an = Pt !== null ? Pt : ce[0];
              gt.trigger(o.Z.INITIAL_STREAM_SWITCH, { startTime: $e }), It(an, null, $e), ut || (ut = setInterval(function() {
                !ne && J.getTimeToStreamEnd() <= 0 && !J.isSeeking() && gt.trigger(o.Z.PLAYBACK_ENDED, { isLast: Ar().isLast });
              }, 200));
            }
            function It($e, Pt, an) {
              try {
                if (ne || !$e || Pt === $e && $e.getIsActive()) return;
                ne = !0, gt.trigger(o.Z.PERIOD_SWITCH_STARTED, { fromStreamInfo: Pt ? Pt.getStreamInfo() : null, toStreamInfo: $e.getStreamInfo() });
                var hn = !1;
                g = $e, Pt && (hn = kt($e, Pt), Pt.deactivate(hn)), an = isNaN(an) ? !hn && Pt ? $e.getStreamInfo().start : NaN : an, r.info("Switch to stream ".concat($e.getId(), ". Seektime is ").concat(an, ", current playback time is ").concat(J.getTime(), ". Seamless period switch is set to ").concat(hn)), tt = tt.filter(function(bn) {
                  return bn.getId() !== g.getId();
                }), J.initialize(Ar(), !!Pt), k.getElement() ? Lt(an, hn, !1) : $t(an, hn);
              } catch {
                ne = !1;
              }
            }
            function Lt($e, Pt) {
              var an, hn = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
              function bn() {
                if (X && X.readyState === "open") {
                  r.debug("MediaSource is open!"), window.URL.revokeObjectURL(an), X.removeEventListener("sourceopen", bn), X.removeEventListener("webkitsourceopen", bn), Nn();
                  var _n = F.getCurrentDVRInfo();
                  H.setSeekable(_n.range.start, _n.range.end), hn ? (isNaN($e) || J.seek($e, !0, !0), g.setMediaSource(X).then(function() {
                    g.initializeForTextWithMediaSource(X);
                  })) : $t($e, Pt);
                }
              }
              function Sn() {
                X.addEventListener("sourceopen", bn, !1), X.addEventListener("webkitsourceopen", bn, !1), an = H.attachMediaSource(k), r.debug("MediaSource attached to element.  Waiting on open...");
              }
              X ? Pt ? $t($e, Pt) : (H.detachMediaSource(k), Sn()) : (X = H.createMediaSource(), Sn());
            }
            function $t($e, Pt) {
              g.activate(X, Pt ? et : void 0, $e).then(function(an) {
                if (an) {
                  var hn = Object.keys(an);
                  hn.length > 0 && an[hn[0]].getBuffer().changeType && (Ut = !0), et = an;
                }
                isNaN($e) || (gt.trigger(o.Z.SEEK_TARGET, { time: $e }, { streamId: g.getId() }), J.seek($e, !1, !0), g.startScheduleControllers()), ne = !1, gt.trigger(o.Z.PERIOD_SWITCH_COMPLETED, { toStreamInfo: Ar() });
              });
            }
            function Qt($e) {
              var Pt = Vt($e.seekTime);
              Pt && Pt !== g ? Pt && Pt !== g && (en(), function(an, hn) {
                var bn = an && !isNaN(an.seekTime) ? an.seekTime : NaN, Sn = g.getProcessors().map(function(_n) {
                  return _n.prepareOuterPeriodPlaybackSeeking(an);
                });
                Promise.all(Sn).then(function() {
                  It(hn, g, bn);
                }).catch(function(_n) {
                  oe.error(_n);
                });
              }($e, Pt)) : (en(), function(an) {
                g.getProcessors().forEach(function(hn) {
                  return hn.prepareInnerPeriodPlaybackSeeking(an);
                }), dr(we.USER_REQUEST_STOP_REASON);
              }($e)), qr(Fe.SEEK_START_REASON);
            }
            function en() {
              on();
            }
            function on() {
              tt && tt.length > 0 && (tt.forEach(function($e) {
                $e.deactivate(!0);
              }), tt = []);
            }
            function ht($e) {
              if ($e.newMediaInfo.streamInfo.id === g.getId()) {
                if (on(), be.get().streaming.buffer.resetSourceBuffersForTrackSwitch && $e.oldMediaInfo && $e.oldMediaInfo.codec !== $e.newMediaInfo.codec) {
                  var Pt = J.getTime();
                  return g.deactivate(!1), void Lt(Pt, !1, !1);
                }
                g.prepareTrackChange($e);
              }
            }
            function kt($e, Pt) {
              try {
                return be.get().streaming.buffer.reuseExistingSourceBuffers && (Pt.isProtectionCompatible($e) || Be) && (Ut && be.get().streaming.buffer.useChangeTypeForTrackSwitch || Pt.isMediaCodecCompatible($e, Pt));
              } catch {
                return !1;
              }
            }
            function Ht($e) {
              var Pt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
              if (X && !$e.getPreloaded()) {
                var an = kt($e, Pt);
                an && $e.startPreloading(X, et).then(function() {
                  tt.push($e);
                });
              }
            }
            function Vt($e) {
              if (isNaN($e)) return null;
              for (var Pt = ce.length, an = 0; an < Pt; an++) {
                var hn = ce[an];
                if ($e < parseFloat((hn.getStartTime() + hn.getDuration()).toFixed(5))) return hn;
              }
              return null;
            }
            function Xt() {
              try {
                var $e = w.getIsDynamic(), Pt = w.getStreamsInfo()[0].manifestInfo, an = J.getTime(), hn = V.calcTimeShiftBufferWindow(ce, $e), bn = On();
                if (hn.start === void 0 || hn.end === void 0) return;
                bn && bn.length !== 0 ? bn.forEach(function(Sn) {
                  F.addDVRInfo(Sn.getType(), an, Pt, hn);
                }) : F.addDVRInfo(t.Z.VIDEO, an, Pt, hn);
              } catch {
              }
            }
            function Ye($e) {
              if (De && A) {
                var Pt = Le.getInitialBufferLevel(), an = [t.Z.TEXT];
                (isNaN(Pt) || Pt <= J.getBufferLevel(an) || w.getIsDynamic() && Pt > J.getLiveDelay()) && (De = !1, qr(Fe.INITIAL_PLAYOUT_START_REASON), J.play());
              }
              $e && $e.mediaType && F.addBufferLevel($e.mediaType, /* @__PURE__ */ new Date(), 1e3 * $e.bufferLevel);
            }
            function Me($e) {
              $e.streamInfo.id === g.getId() && $e.reason && $e.reason.forceReplace && on(), Si($e.streamInfo.id).prepareQualityChange($e);
            }
            function ct() {
              if (w.getIsDynamic() && J.getOriginalLiveDelay() !== 0 && g) {
                var $e = w.getStreamsInfo();
                if ($e.length > 0) {
                  var Pt = $e[0].manifestInfo, an = zr($e, Pt);
                  J.computeAndSetLiveDelay(an, Pt);
                }
              }
            }
            function de() {
              if (Cr()) {
                var $e = k.getPlaybackQuality();
                $e && F.addDroppedFrames($e);
              }
            }
            function _e() {
              r.debug("[onPlaybackStarted]"), !De && xe && qr(Fe.RESUME_FROM_PAUSE_START_REASON), De && (De = !1), st && (st = !1, be.get().streaming.applyContentSteering && !N.shouldQueryBeforeStart() && N.loadSteeringData()), xe = !1;
            }
            function Xe($e) {
              r.debug("[onPlaybackPaused]"), $e.ended || (xe = !0, dr(we.USER_REQUEST_STOP_REASON));
            }
            function Ct($e) {
              r.debug("Stream with id ".concat($e.streamInfo.id, " finished buffering"));
              var Pt = $e.streamInfo.isLast;
              X && Pt ? (r.info("[onStreamBufferingCompleted] calls signalEndOfStream of mediaSourceController."), H.signalEndOfStream(X)) : xt();
            }
            function xt() {
              if (g && g.getHasFinishedBuffering()) for (var $e = function() {
                var bn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                try {
                  var Sn = bn || g || null;
                  if (Sn) {
                    var _n = Sn.getStreamInfo();
                    return ce.filter(function(qn) {
                      var Ln = qn.getStreamInfo();
                      return Ln.start > _n.start && _n.id !== Ln.id;
                    });
                  }
                } catch {
                  return [];
                }
              }(g), Pt = 0; Pt < $e.length; ) {
                var an = $e[Pt], hn = Pt === 0 ? g : $e[Pt - 1];
                !an.getPreloaded() && hn.getHasFinishedBuffering() && X && Ht(an, hn), Pt += 1;
              }
            }
            function yn() {
              ut && (clearInterval(ut), ut = null);
            }
            function On() {
              return g ? g.getProcessors() : [];
            }
            function zn($e) {
              if (g && !g.getIsEndedEventSignaled()) {
                g.setIsEndedEventSignaled(!0);
                var Pt = function() {
                  var an = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, hn = an || g || null;
                  if (!hn) return null;
                  for (var bn = hn.getStreamInfo(), Sn = bn.start, _n = 0, qn = -1, Ln = NaN; _n < ce.length; ) {
                    var xr = ce[_n].getStreamInfo(), fi = xr.start - Sn;
                    fi > 0 && (isNaN(Ln) || fi < Ln) && bn.id !== xr.id && (Ln = fi, qn = _n), _n += 1;
                  }
                  return qn >= 0 ? ce[qn] : null;
                }();
                Pt ? (r.debug("StreamController onEnded, found next stream with id ".concat(Pt.getStreamInfo().id, ". Switching from ").concat(g.getStreamInfo().id, " to ").concat(Pt.getStreamInfo().id)), It(Pt, g, NaN)) : (r.debug("StreamController no next stream found"), g.setIsEndedEventSignaled(!1)), dr(Pt ? we.END_OF_PERIOD_STOP_REASON : we.END_OF_CONTENT_STOP_REASON);
              }
              $e && $e.isLast && (yn(), N.stopSteeringRequestTimer());
            }
            function Nn($e) {
              var Pt = $e || Ar().manifestInfo.duration;
              H.setDuration(Pt);
            }
            function fr($e) {
              var Pt = fe.getURIFragmentData();
              if (!Pt || !Pt.t) return NaN;
              var an = Xr()[0].getStreamInfo().start;
              return Pt.t = Pt.t.split(",")[0], Gr($e, Pt.t, an);
            }
            function Jn($e, Pt) {
              var an = 0;
              return $e || (an = Xr()[0].getStreamInfo().start), Gr($e, Pt, an);
            }
            function Gr($e, Pt, an) {
              var hn = w.getRegularPeriods()[0], bn = Pt.toString(), Sn = bn.indexOf("posix:") !== -1 ? bn.substring(6) === "now" ? Date.now() / 1e3 : parseFloat(bn.substring(6)) : NaN;
              return $e && !isNaN(Sn) ? V.calcPresentationTimeFromWallTime(new Date(1e3 * Sn), hn) : parseFloat(bn) + an;
            }
            function zr($e, Pt) {
              try {
                var an = NaN;
                if (Pt && !isNaN(Pt.maxFragmentDuration) && isFinite(Pt.maxFragmentDuration)) return Pt.maxFragmentDuration;
                if ($e && $e.length === 1) {
                  var hn = $e[0], bn = [t.Z.VIDEO, t.Z.AUDIO, t.Z.TEXT].reduce(function(_n, qn) {
                    var Ln = w.getMediaInfoForType(hn, qn);
                    return Ln && Ln.isFragmented !== !1 && _n.push(Ln), _n;
                  }, []).reduce(function(_n, qn) {
                    var Ln = w.getVoRepresentations(qn);
                    return Ln && Ln.length > 0 && Ln.forEach(function(xr) {
                      xr && _n.push(xr);
                    }), _n;
                  }, []).reduce(function(_n, qn) {
                    var Ln = w.convertRepresentationToRepresentationInfo(qn);
                    return Ln && Ln.fragmentDuration && !isNaN(Ln.fragmentDuration) && _n.push(Ln.fragmentDuration), _n;
                  }, []);
                  an = Math.max.apply(Math, function(_n) {
                    if (Array.isArray(_n)) return pa(_n);
                  }(Sn = bn) || function(_n) {
                    if (typeof Symbol < "u" && Symbol.iterator in Object(_n)) return Array.from(_n);
                  }(Sn) || function(_n, qn) {
                    if (_n) {
                      if (typeof _n == "string") return pa(_n, qn);
                      var Ln = Object.prototype.toString.call(_n).slice(8, -1);
                      return Ln === "Object" && _n.constructor && (Ln = _n.constructor.name), Ln === "Map" || Ln === "Set" ? Array.from(_n) : Ln === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Ln) ? pa(_n, qn) : void 0;
                    }
                  }(Sn) || function() {
                    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
                  }());
                }
                return isFinite(an) ? an : NaN;
              } catch {
                return NaN;
              }
              var Sn;
            }
            function Wr($e) {
              if ($e.error) se = !0, Hr();
              else {
                r.info("Manifest updated... updating data system wide.");
                var Pt = $e.manifest;
                w.updatePeriods(Pt);
                var an = w.getUTCTimingSources();
                !w.getIsDynamic() || an && an.length !== 0 || gt.trigger(n.Z.CONFORMANCE_VIOLATION, { level: si.LEVELS.WARNING, event: si.EVENTS.NO_UTC_TIMING_ELEMENT });
                var hn = w.getIsDynamic() ? an.concat(Ie.getUTCTimingSources()) : an;
                _.filterUnsupportedFeatures(Pt).then(function() {
                  U.initialize(Pt), G.attemptSync(hn, w.getIsDynamic());
                });
              }
            }
            function Cr() {
              return !!g && g.getHasVideoTrack();
            }
            function Lr() {
              return !!g && g.getHasAudioTrack();
            }
            function dr($e, Pt) {
              Pt = Pt || /* @__PURE__ */ new Date(), On().forEach(function(an) {
                an.finalisePlayList(Pt, $e);
              }), F.addPlayList();
            }
            function qr($e) {
              F.createPlaylistMetrics(1e3 * J.getTime(), $e);
            }
            function Qr($e) {
              if ($e.error) {
                var Pt = "";
                switch ($e.error.code) {
                  case 1:
                    Pt = "MEDIA_ERR_ABORTED";
                    break;
                  case 2:
                    Pt = "MEDIA_ERR_NETWORK";
                    break;
                  case 3:
                    Pt = "MEDIA_ERR_DECODE", vt.counts.mediaErrorDecode += 1;
                    break;
                  case 4:
                    Pt = "MEDIA_ERR_SRC_NOT_SUPPORTED";
                    break;
                  case 5:
                    Pt = "MEDIA_ERR_ENCRYPTED";
                    break;
                  default:
                    Pt = "UNKNOWN";
                }
                Pt === "MEDIA_ERR_DECODE" && be.get().errors.recoverAttempts.mediaErrorDecode >= vt.counts.mediaErrorDecode ? function() {
                  r.warn("A MEDIA_ERR_DECODE occured: Resetting the MediaSource");
                  var an = J.getTime();
                  g.deactivate(!1), r.warn("MediaSource has been resetted. Resuming playback from time ".concat(an)), Lt(an, !1, !1);
                }() : (z = !0, $e.error.message && (Pt += " (" + $e.error.message + ")"), $e.error.msExtendedCode && (Pt += " (0x" + ($e.error.msExtendedCode >>> 0).toString(16).toUpperCase() + ")"), r.fatal("Video Element Error: " + Pt), $e.error && r.fatal($e.error), oe.error(new ae.Z($e.error.code, Pt)), Hr());
              }
            }
            function Ar() {
              return g ? g.getStreamInfo() : null;
            }
            function Si($e) {
              for (var Pt = 0, an = ce.length; Pt < an; Pt++) if (ce[Pt].getId() === $e) return ce[Pt];
              return null;
            }
            function $i($e) {
              isNaN($e.newDuration) || Nn($e.newDuration);
            }
            function Ji() {
              ce = [], Ke = NaN, P = null, ne = !1, g = null, z = !1, se = !1, De = !0, st = !0, xe = !1, A = !0, ut = null, Be = !1, Ut = !1, tt = [], mt = null, vt = { counts: { mediaErrorDecode: 0 } };
            }
            function Hr() {
              Wt(), G.reset(), dr(z || se ? we.FAILURE_STOP_REASON : we.USER_REQUEST_STOP_REASON);
              for (var $e = 0, Pt = ce ? ce.length : 0; $e < Pt; $e++) ce[$e].reset(z);
              gt.off(n.Z.PLAYBACK_TIME_UPDATED, de, i), gt.off(n.Z.PLAYBACK_SEEKING, Qt, i), gt.off(n.Z.PLAYBACK_ERROR, Qr, i), gt.off(n.Z.PLAYBACK_STARTED, _e, i), gt.off(n.Z.PLAYBACK_PAUSED, Xe, i), gt.off(n.Z.PLAYBACK_ENDED, zn, i), gt.off(n.Z.METRIC_ADDED, ea, i), gt.off(n.Z.MANIFEST_VALIDITY_CHANGED, $i, i), gt.off(n.Z.BUFFER_LEVEL_UPDATED, Ye, i), gt.off(n.Z.QUALITY_CHANGE_REQUESTED, Me, i), o.Z.KEY_SESSION_UPDATED && gt.off(o.Z.KEY_SESSION_UPDATED, pn, i), gt.off(o.Z.MANIFEST_UPDATED, Wr, i), gt.off(o.Z.STREAM_BUFFERING_COMPLETED, Ct, i), gt.off(o.Z.TIME_SYNCHRONIZATION_COMPLETED, gn, i), gt.off(o.Z.CURRENT_TRACK_CHANGED, ht, i), gt.off(o.Z.SETTING_UPDATED_LIVE_DELAY, ct, i), gt.off(o.Z.SETTING_UPDATED_LIVE_DELAY_FRAGMENT_COUNT, ct, i), U.reset(), R.reset(), ge.reset(), F.clearAllCurrentMetrics(), y.setValue(null), I.reset(), V.reset(), q.reset(), X && (H.detachMediaSource(k), X = null), k = null, P && (P = null, O = null, y.getValue() && gt.trigger(o.Z.PROTECTION_DESTROYED, { data: y.getValue().url })), yn(), gt.trigger(o.Z.STREAM_TEARDOWN_COMPLETE), Ji();
            }
            function ea($e) {
              if ($e.metric === p.Z.DVR_INFO) {
                var Pt = Lr() ? t.Z.AUDIO : t.Z.VIDEO;
                $e.mediaType === Pt && H.setSeekable($e.value.range.start, $e.value.range.end);
              }
            }
            function Xr() {
              return ce;
            }
            return i = { initialize: function($e, Pt) {
              Wt(), A = $e, O = Pt, V.initialize(), (R = lo(Et).create()).setConfig({ manifestModel: y, adapter: w, manifestLoader: I, errHandler: oe, settings: be, contentSteeringController: N }), R.initialize(), (ge = au(Et).getInstance()).setConfig({ manifestUpdater: R, playbackController: J, settings: be }), ge.start(), G.setConfig({ dashMetrics: F, baseURLController: U, errHandler: oe, settings: be }), G.initialize(), H.setConfig({ settings: be }), P && (gt.trigger(o.Z.PROTECTION_CREATED, { controller: P }), P.setMediaElement(k.getElement()), O && P.setProtectionData(O)), gt.on(n.Z.PLAYBACK_TIME_UPDATED, de, i), gt.on(n.Z.PLAYBACK_SEEKING, Qt, i), gt.on(n.Z.PLAYBACK_ERROR, Qr, i), gt.on(n.Z.PLAYBACK_STARTED, _e, i), gt.on(n.Z.PLAYBACK_PAUSED, Xe, i), gt.on(n.Z.PLAYBACK_ENDED, zn, i), gt.on(n.Z.METRIC_ADDED, ea, i), gt.on(n.Z.MANIFEST_VALIDITY_CHANGED, $i, i), gt.on(n.Z.BUFFER_LEVEL_UPDATED, Ye, i), gt.on(n.Z.QUALITY_CHANGE_REQUESTED, Me, i), o.Z.KEY_SESSION_UPDATED && gt.on(o.Z.KEY_SESSION_UPDATED, pn, i), gt.on(o.Z.MANIFEST_UPDATED, Wr, i), gt.on(o.Z.STREAM_BUFFERING_COMPLETED, Ct, i), gt.on(o.Z.TIME_SYNCHRONIZATION_COMPLETED, gn, i), gt.on(o.Z.CURRENT_TRACK_CHANGED, ht, i), gt.on(o.Z.SETTING_UPDATED_LIVE_DELAY, ct, i), gt.on(o.Z.SETTING_UPDATED_LIVE_DELAY_FRAGMENT_COUNT, ct, i);
            }, getActiveStreamInfo: Ar, addDVRMetric: Xt, hasVideoTrack: Cr, hasAudioTrack: Lr, getStreamById: Si, getStreamForTime: Vt, getTimeRelativeToStreamId: function($e, Pt) {
              for (var an = null, hn = 0, bn = 0, Sn = null, _n = 0; _n < ce.length; _n++) {
                if (bn = (an = ce[_n]).getStartTime(), Sn = an.getDuration(), Number.isFinite(bn) && (hn = bn), an.getId() === Pt) return $e - hn;
                Number.isFinite(Sn) && (hn += Sn);
              }
              return null;
            }, load: function($e) {
              var Pt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : NaN;
              Wt(), Ke = Pt, I.load($e);
            }, loadWithManifest: function($e) {
              var Pt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : NaN;
              zt(), Ke = Pt, R.setManifest($e);
            }, getActiveStreamProcessors: On, setConfig: function($e) {
              $e && ($e.capabilities && (l = $e.capabilities), $e.capabilitiesFilter && (_ = $e.capabilitiesFilter), $e.manifestLoader && (I = $e.manifestLoader), $e.manifestModel && (y = $e.manifestModel), $e.mediaPlayerModel && (Le = $e.mediaPlayerModel), $e.customParametersModel && (Ie = $e.customParametersModel), $e.protectionController && (P = $e.protectionController), $e.adapter && (w = $e.adapter), $e.dashMetrics && (F = $e.dashMetrics), $e.errHandler && (oe = $e.errHandler), $e.timelineConverter && (V = $e.timelineConverter), $e.videoModel && (k = $e.videoModel), $e.playbackController && (J = $e.playbackController), $e.serviceDescriptionController && (pe = $e.serviceDescriptionController), $e.contentSteeringController && (N = $e.contentSteeringController), $e.textController && (D = $e.textController), $e.abrController && (te = $e.abrController), $e.mediaController && (le = $e.mediaController), $e.settings && (be = $e.settings), $e.baseURLController && (U = $e.baseURLController), $e.uriFragmentModel && (fe = $e.uriFragmentModel), $e.segmentBaseController && (Z = $e.segmentBaseController), $e.manifestUpdater && (R = $e.manifestUpdater));
            }, setProtectionData: function($e) {
              O = $e, P && P.setProtectionData(O);
            }, getIsStreamSwitchInProgress: function() {
              return ne;
            }, switchToVideoElement: function($e) {
              g && (J.initialize(Ar()), Lt($e, !1, !0));
            }, getHasMediaOrInitialisationError: function() {
              return z || se;
            }, getStreams: Xr, getActiveStream: function() {
              return g;
            }, getInitialPlayback: function() {
              return De;
            }, getAutoPlay: function() {
              return A;
            }, refreshManifest: function() {
              R.getIsUpdating() || R.refreshManifest();
            }, reset: Hr }, r = (0, h.Z)(Et).getInstance().getLogger(i), G = ru(Et).getInstance(), H = iu(Et).getInstance(), q = Se(Et).getInstance(), Ji(), i;
          }
          go.__dashjs_factory_name = "StreamController";
          var ho = E.Z.getSingletonFactory(go);
          function mo() {
            var i, r, l, _, R, I, y, w, F, H, G, N, U = this.context, Z = (0, m.Z)(U).getInstance();
            function fe() {
              N.debug("Stopping the gap controller"), R && (clearInterval(R), R = null), function() {
                Z.off(o.Z.WALLCLOCK_TIME_UPDATED, oe, this), Z.off(o.Z.INITIAL_STREAM_SWITCH, q, this), Z.off(o.Z.PLAYBACK_SEEKING, te, this), Z.off(o.Z.BUFFER_REPLACEMENT_STARTED, le, i), Z.off(o.Z.TRACK_CHANGE_RENDERED, ge, i);
              }(), R = null, I = NaN, _ = 0, H = null, G = {};
            }
            function te() {
              H && (clearTimeout(H), H = null);
            }
            function le(O) {
              try {
                if (O.streamId !== w.getActiveStreamInfo().id || O.mediaType !== t.Z.VIDEO && O.mediaType !== t.Z.AUDIO) return;
                O.streamId === w.getActiveStreamInfo().id && (G[O.mediaType] = !0);
              } catch (A) {
                N.error(A);
              }
            }
            function ge(O) {
              O && O.mediaType && (G[O.mediaType] = !1);
            }
            function q() {
              R || function() {
                try {
                  R || (N.debug("Starting the gap controller"), R = setInterval(function() {
                    V() && D(y.getTime());
                  }, 100));
                } catch {
                }
              }();
            }
            function oe() {
              if (V(l.get().streaming.gaps.enableSeekFix) && ++_ >= 10) {
                var O = y.getTime();
                r === O ? D(O, !0) : (r = O, I = NaN), _ = 0;
              }
            }
            function V() {
              var O = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
              if (!w.getActiveStream()) return !1;
              var A = Object.keys(G).some(function(z) {
                return G[z];
              }), ne = !!O && ce();
              return !A && l.get().streaming.gaps.jumpGaps && w.getActiveStreamProcessors().length > 0 && (!y.isSeeking() || ne) && !y.isPaused() && !w.getIsStreamSwitchInProgress() && !w.getHasMediaOrInitialisationError();
            }
            function ce() {
              var O = w.getActiveStream(), A = parseFloat((O.getStartTime() + O.getDuration()).toFixed(5));
              return y.getTime() + l.get().streaming.gaps.threshold >= A;
            }
            function g(O, A) {
              try {
                if (!O || O.length <= 1 && A > 0) return NaN;
                for (var ne = NaN, z = 0; isNaN(ne) && z < O.length; ) {
                  var se = z > 0 ? O.end(z - 1) : 0;
                  A < O.start(z) && se - A < l.get().streaming.gaps.threshold && (ne = z), z += 1;
                }
                return ne;
              } catch {
                return null;
              }
            }
            function P(O, A) {
              for (var ne = 0, z = O.length; ne < z; ne++) if (A >= O.start(ne) && A <= O.end(ne)) return !0;
              return !1;
            }
            function D(O) {
              var A, ne = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], z = l.get().streaming.gaps.enableStallFix, se = l.get().streaming.gaps.stallSeek, X = l.get().streaming.gaps.smallGapLimit, k = l.get().streaming.gaps.jumpLargeGaps, J = F.getBufferRange(), pe = NaN, Le = !1;
              if (A = g(J, O), !isNaN(A)) {
                var Ie = J.start(A), xe = Ie - O;
                xe > 0 && (xe <= X || k) && (pe = Ie);
              }
              var De = y.getTimeToStreamEnd();
              if (isNaN(pe) && ne && isFinite(De) && !isNaN(De) && De < X && (pe = parseFloat(y.getStreamEndTime().toFixed(5)), Le = !0), z && isNaN(pe) && ne && isNaN(A) && P(J, O) && (se === 0 ? (N.warn("Toggle play pause to break stall"), F.pause(), F.play()) : (N.warn("Jumping ".concat(se, "s to break stall")), pe = O + se)), pe > 0 && I !== pe && pe > O && !H) {
                var st = pe - O;
                if (Le) {
                  var ut = w.getStreamForTime(pe), et = ut && !!ut.getPreloaded();
                  N.warn("Jumping to end of stream because of gap from ".concat(O, " to ").concat(pe, ". Gap duration: ").concat(st)), y.seek(pe, !0, et);
                } else {
                  var tt = y.getIsDynamic(), Ut = A > 0 ? J.end(A - 1) : O, be = tt ? 1e3 * Math.max(0, st - 0.1) : 0;
                  H = window.setTimeout(function() {
                    y.seek(pe, !0, !0), N.warn("Jumping gap occuring in period ".concat(w.getActiveStream().getStreamId(), " starting at ").concat(Ut, " and ending at ").concat(pe, ". Jumping by: ").concat(pe - Ut)), H = null;
                  }, be);
                }
                I = pe;
              }
            }
            return i = { reset: fe, setConfig: function(O) {
              O && (O.settings && (l = O.settings), O.playbackController && (y = O.playbackController), O.streamController && (w = O.streamController), O.videoModel && (F = O.videoModel));
            }, initialize: function() {
              (function() {
                Z.on(o.Z.WALLCLOCK_TIME_UPDATED, oe, this), Z.on(o.Z.INITIAL_STREAM_SWITCH, q, this), Z.on(o.Z.PLAYBACK_SEEKING, te, this), Z.on(o.Z.BUFFER_REPLACEMENT_STARTED, le, i), Z.on(o.Z.TRACK_CHANGE_RENDERED, ge, i);
              })();
            } }, N = (0, h.Z)(U).getInstance().getLogger(i), fe(), i;
          }
          mo.__dashjs_factory_name = "GapController";
          var ou = E.Z.getSingletonFactory(mo);
          function po() {
            var i, r, l, _, R, I, y, w, F, H, G = this.context, N = (0, m.Z)(G).getInstance();
            function U() {
              r = !1;
              var ce = bt.Z.parseUserAgent();
              l = ce && ce.browser && ce.browser.name && ce.browser.name.toLowerCase() === "safari";
            }
            function Z() {
              r = !1;
            }
            function fe(ce) {
              if (ce.streamId === I.getActiveStreamInfo().id && F) {
                var g = y.getLiveDelay();
                y.getBufferLevel() > g / 2 && (F = !1);
              }
            }
            function te(ce) {
              ce.streamId === I.getActiveStreamInfo().id && (F = ce.state === p.Z.BUFFER_EMPTY);
            }
            function le() {
              w.getCatchupModeEnabled() || _.setPlaybackRate(1);
            }
            function ge() {
              y.getIsDynamic() && w.getCatchupModeEnabled() && (w.getCatchupPlaybackRates().max > 0 || w.getCatchupPlaybackRates().min < 0) && !y.isPaused() && !y.isSeeking() && function() {
                try {
                  return !(!y.getTime() > 0 || r) && (oe() === t.Z.LIVE_CATCHUP_MODE_LOLP ? function(ce, g) {
                    try {
                      return Math.abs(q()) > 0 || ce < g;
                    } catch {
                      return !1;
                    }
                  }(y.getBufferLevel(), R.get().streaming.liveCatchup.playbackBufferMin) : function() {
                    try {
                      return Math.abs(q()) > 0;
                    } catch {
                      return !1;
                    }
                  }());
                } catch {
                  return !1;
                }
              }() && function() {
                if (!r && _) {
                  var ce, g = _.getPlaybackRate(), P = w.getCatchupPlaybackRates(), D = y.getBufferLevel(), O = q(), A = w.getCatchupMaxDrift();
                  if (!isNaN(A) && A > 0 && O > A) H.info("[CatchupController]: Low Latency catchup mechanism. Latency too high, doing a seek to live point"), r = !0, y.seekToCurrentLive(!0, !1);
                  else {
                    var ne = y.getCurrentLiveLatency(), z = y.getLiveDelay();
                    ce = oe() === t.Z.LIVE_CATCHUP_MODE_LOLP ? function(X, k, J, pe, Le) {
                      var Ie;
                      if (Le < pe) {
                        var xe = Math.abs(X.min), De = 5 * (Le - pe);
                        Ie = 1 - xe + 2 * xe / (1 + Math.pow(Math.E, -De)), H.debug("[LoL+ playback control_buffer-based] bufferLevel: " + Le + ", newRate: " + Ie);
                      } else {
                        if (Math.abs(k - J) <= 0.02 * J) Ie = 1;
                        else {
                          var st = k - J, ut = st < 0 ? Math.abs(X.min) : X.max, et = 5 * st;
                          Ie = 1 - ut + 2 * ut / (1 + Math.pow(Math.E, -et));
                        }
                        H.debug("[LoL+ playback control_latency-based] latency: " + k + ", newRate: " + Ie);
                      }
                      return Ie;
                    }(P, ne, z, R.get().streaming.liveCatchup.playbackBufferMin, D) : function(X, k, J, pe) {
                      if (F) return 1;
                      var Le = k - J, Ie = Le < 0 ? Math.abs(X.min) : X.max, xe = 5 * Le, De = 1 - Ie + 2 * Ie / (1 + Math.pow(Math.E, -xe));
                      return y.getPlaybackStalled() && pe <= J / 2 && Le > 0 && (De = 1), De;
                    }(P, ne, z, D);
                    var se = l ? 0.25 : 0.02 / (0.5 / P.max);
                    ce && Math.abs(g - ce) >= se && (H.debug("[CatchupController]: Setting playback rate to ".concat(ce)), _.setPlaybackRate(ce));
                  }
                }
              }();
            }
            function q() {
              return y.getCurrentLiveLatency() - y.getLiveDelay();
            }
            function oe() {
              var ce = R.get().streaming.liveCatchup.playbackBufferMin;
              return R.get().streaming.liveCatchup.mode !== t.Z.LIVE_CATCHUP_MODE_LOLP || ce === null || isNaN(ce) ? t.Z.LIVE_CATCHUP_MODE_DEFAULT : t.Z.LIVE_CATCHUP_MODE_LOLP;
            }
            function V() {
              w.getCatchupPlaybackRates(!0);
            }
            return i = { reset: function() {
              N.off(n.Z.BUFFER_LEVEL_UPDATED, fe, i), N.off(n.Z.BUFFER_LEVEL_STATE_CHANGED, te, i), N.off(n.Z.PLAYBACK_PROGRESS, ge, i), N.off(n.Z.PLAYBACK_TIME_UPDATED, ge, i), N.off(n.Z.PLAYBACK_SEEKED, Z, i), N.off(o.Z.SETTING_UPDATED_CATCHUP_ENABLED, le, i), N.off(o.Z.SETTING_UPDATED_PLAYBACK_RATE_MIN, V, i), N.off(o.Z.SETTING_UPDATED_PLAYBACK_RATE_MAX, V, i), N.off(n.Z.STREAM_INITIALIZED, V, i), U(), _.setPlaybackRate(1, !0);
            }, setConfig: function(ce) {
              ce && (ce.settings && (R = ce.settings), ce.videoModel && (_ = ce.videoModel), ce.streamController && (I = ce.streamController), ce.playbackController && (y = ce.playbackController), ce.mediaPlayerModel && (w = ce.mediaPlayerModel));
            }, initialize: function() {
              N.on(n.Z.BUFFER_LEVEL_UPDATED, fe, i), N.on(n.Z.BUFFER_LEVEL_STATE_CHANGED, te, i), N.on(n.Z.PLAYBACK_PROGRESS, ge, i), N.on(n.Z.PLAYBACK_TIME_UPDATED, ge, i), N.on(n.Z.PLAYBACK_SEEKED, Z, i), N.on(o.Z.SETTING_UPDATED_CATCHUP_ENABLED, le, i), N.on(o.Z.SETTING_UPDATED_PLAYBACK_RATE_MIN, V, i), N.on(o.Z.SETTING_UPDATED_PLAYBACK_RATE_MAX, V, i), N.on(n.Z.STREAM_INITIALIZED, V, i), V();
            } }, H = (0, h.Z)(G).getInstance().getLogger(i), U(), i;
          }
          po.__dashjs_factory_name = "CatchupController";
          var su = E.Z.getSingletonFactory(po), uu = [t.Z.SERVICE_DESCRIPTION_DVB_LL_SCHEME], yo = "video", _o = "audio";
          function Eo() {
            var i, r, l, _, R, I = this.context;
            function y() {
              r = { liveDelay: NaN, liveCatchup: { maxDrift: NaN, playbackRate: { min: NaN, max: NaN } }, minBitrate: {}, maxBitrate: {}, initialBitrate: {}, contentSteering: null }, l = [];
            }
            function w(F, H, G) {
              try {
                r[F][H] = G / 1e3;
              } catch (N) {
                _.error(N);
              }
            }
            return i = { getServiceDescriptionSettings: function() {
              return r;
            }, getProducerReferenceTimeOffsets: function() {
              return l;
            }, calculateProducerReferenceTimeOffsets: function(F) {
              try {
                var H = [];
                if (F && F.length > 0) {
                  var G = [t.Z.VIDEO, t.Z.AUDIO, t.Z.TEXT], N = R.getAvailabilityStartTime() / 1e3;
                  F.forEach(function(U) {
                    var Z = G.reduce(function(fe, te) {
                      return fe.concat(R.getAllMediaInfoForType(U, te));
                    }, []).reduce(function(fe, te) {
                      return R.getProducerReferenceTimes(U, te).forEach(function(le) {
                        var ge = R.getVoRepresentations(te);
                        if (ge && ge.length > 0 && ge[0].adaptation && ge[0].segmentInfoType === e.Z.SEGMENT_TEMPLATE) {
                          var q = ge[0], oe = new Date(le[e.Z.WALL_CLOCK_TIME]).getTime() / 1e3 - (le[e.Z.PRESENTATION_TIME] / q[e.Z.TIMESCALE] - q[e.Z.PRESENTATION_TIME_OFFSET] + U.start), V = N - oe;
                          fe.push({ id: le[e.Z.ID], to: V });
                        }
                      }), fe;
                    }, []);
                    H = H.concat(Z);
                  });
                }
                l = H;
              } catch (U) {
                _.error(U), l = [];
              }
            }, applyServiceDescription: function(F) {
              if (F && F.serviceDescriptions) {
                var H = F.serviceDescriptions.filter(function(U) {
                  return uu.includes(U.schemeIdUri);
                }), G = F.serviceDescriptions.filter(function(U) {
                  return U.schemeIdUri == null;
                }), N = H.length > 0 ? H[H.length - 1] : G[G.length - 1];
                N && (N.latency && N.latency.target > 0 && function(U) {
                  var Z;
                  if (U.schemeIdUri, t.Z.SERVICE_DESCRIPTION_DVB_LL_SCHEME, Z = function(ge) {
                    return { liveDelay: ge.latency.target / 1e3, maxDrift: !isNaN(ge.latency.max) && ge.latency.max > ge.latency.target ? (ge.latency.max - ge.latency.target + 500) / 1e3 : NaN, referenceId: ge.latency.referenceId || NaN };
                  }(U), l.length > 0) {
                    var fe = function(ge) {
                      var q, oe = 0, V = l.filter(function(ce) {
                        return ce.id === ge.referenceId;
                      });
                      return V.length === 0 ? (oe = l.length > 0 ? l[0].to : 0, q = l[0].id || NaN) : (oe = V[0].to || 0, q = V[0].id || NaN), { to: oe, id: q };
                    }(Z), te = fe.to, le = fe.id;
                    r.liveDelay = Z.liveDelay - te, r.liveCatchup.maxDrift = Z.maxDrift, _.debug(`
                Found latency properties coming from service description. Applied time offset of `.concat(te, " from ProducerReferenceTime element with id ").concat(le, `.
                Live Delay: `).concat(Z.liveDelay - te, ", Live catchup max drift: ").concat(Z.maxDrift, `
            `));
                  } else r.liveDelay = Z.liveDelay, r.liveCatchup.maxDrift = Z.maxDrift, _.debug("Found latency properties coming from service description: Live Delay: ".concat(Z.liveDelay, ", Live catchup max drift: ").concat(Z.maxDrift));
                }(N), N.playbackRate && function(U) {
                  var Z = U.playbackRate.min ? Math.round(1e3 * (U.playbackRate.min - 1)) / 1e3 : NaN, fe = U.playbackRate.max ? Math.round(1e3 * (U.playbackRate.max - 1)) / 1e3 : NaN;
                  r.liveCatchup.playbackRate.min = Z, r.liveCatchup.playbackRate.max = fe, _.debug("Found latency properties coming from service description: Live catchup min playback rate: ".concat(Z)), _.debug("Found latency properties coming from service description: Live catchup max playback rate: ".concat(fe));
                }(N), N.operatingQuality, N.operatingBandwidth && function(U) {
                  if (U && U.operatingBandwidth && U.operatingBandwidth.mediaType && U.operatingBandwidth.mediaType !== "all") {
                    var Z = {};
                    Z.minBandwidth = U.operatingBandwidth.min, Z.maxBandwidth = U.operatingBandwidth.max, Z.targetBandwidth = U.operatingBandwidth.target;
                    var fe = [];
                    U.operatingBandwidth.mediaType === yo || U.operatingBandwidth.mediaType === _o ? fe.push(U.operatingBandwidth.mediaType) : U.operatingBandwidth.mediaType === "any" && (fe.push(_o), fe.push(yo)), fe.forEach(function(te) {
                      isNaN(Z.minBandwidth) || w("minBitrate", te, Z.minBandwidth), isNaN(Z.maxBandwidth) || w("maxBitrate", te, Z.maxBandwidth), isNaN(Z.targetBandwidth) || w("initialBitrate", te, Z.targetBandwidth);
                    });
                  }
                }(N), N.contentSteering && function(U) {
                  r.contentSteering = U.contentSteering;
                }(N));
              }
            }, reset: function() {
              y();
            }, setConfig: function(F) {
              F && F.adapter && (R = F.adapter);
            } }, _ = (0, h.Z)(I).getInstance().getLogger(i), y(), i;
          }
          Eo.__dashjs_factory_name = "ServiceDescriptionController";
          var lu = E.Z.getSingletonFactory(Eo), cu = C(3973), Zi = C.n(cu), vo = C(3039);
          function ya() {
            var i, r, l, _, R, I, y, w, F = this.context, H = (0, m.Z)(F).getInstance();
            function G(k, J) {
              return k && l[J] && l[J][k] ? l[J][k].list : [];
            }
            function N(k, J) {
              return k && l[J] && l[J][k] ? l[J][k].current : null;
            }
            function U(k) {
              var J = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
              if (k && k.streamInfo) {
                var pe = k.type, Le = k.streamInfo, Ie = Le.id, xe = N(pe, Ie);
                if (l[Ie] && l[Ie][pe] && (l[Ie][pe].current = k, l[Ie][pe].current && (pe !== t.Z.TEXT && !te(k, xe) || pe === t.Z.TEXT && k.isFragmented) && H.trigger(o.Z.CURRENT_TRACK_CHANGED, { oldMediaInfo: xe, newMediaInfo: k, switchMode: _.get().streaming.trackSwitchMode[pe] }, { streamId: Ie }), !J)) {
                  var De = ge(k);
                  if (!De || !l[Ie][pe].storeLastSettings) return;
                  De.roles && (De.role = De.roles[0], delete De.roles), De.accessibility && (De.accessibility = De.accessibility[0]), De.audioChannelConfiguration && (De.audioChannelConfiguration = De.audioChannelConfiguration[0]), I[pe] = De, w.setSavedMediaSettings(pe, De);
                }
              }
            }
            function Z(k, J) {
              k && J && (R[k] = J);
            }
            function fe(k) {
              return k ? R[k] : null;
            }
            function te(k, J) {
              if (!k && !J) return !0;
              if (!k || !J) return !1;
              var pe = k.id === J.id, Le = k.viewpoint === J.viewpoint, Ie = JSON.stringify(k.viewpointsWithSchemeIdUri) === JSON.stringify(J.viewpointsWithSchemeIdUri), xe = k.lang === J.lang, De = k.codec === J.codec, st = k.roles.toString() === J.roles.toString(), ut = JSON.stringify(k.rolesWithSchemeIdUri) === JSON.stringify(J.rolesWithSchemeIdUri), et = k.accessibility.toString() === J.accessibility.toString(), tt = JSON.stringify(k.accessibilitiesWithSchemeIdUri) === JSON.stringify(J.accessibilitiesWithSchemeIdUri), Ut = k.audioChannelConfiguration.toString() === J.audioChannelConfiguration.toString(), be = JSON.stringify(k.audioChannelConfigurationsWithSchemeIdUri) === JSON.stringify(J.audioChannelConfigurationsWithSchemeIdUri);
              return pe && De && Le && Ie && xe && st && ut && et && tt && Ut && be;
            }
            function le() {
              l = {}, I = {}, R = { audio: null, video: null, text: null };
            }
            function ge(k) {
              var J = { lang: k.lang, viewpoint: k.viewpoint, roles: k.roles, accessibility: k.accessibility, audioChannelConfiguration: k.audioChannelConfiguration, codec: k.codec };
              return J.lang || J.viewpoint || J.role && J.role.length > 0 || J.accessibility && J.accessibility.length > 0 || J.audioChannelConfiguration && J.audioChannelConfiguration.length > 0 ? J : null;
            }
            function q(k, J, pe) {
              var Le = [];
              return k.forEach(function(Ie) {
                J(pe, Ie) && Le.push(Ie);
              }), Le.length !== 0 ? Le : k;
            }
            function oe(k, J) {
              try {
                return !k.lang || k.lang instanceof RegExp ? J.lang.match(k.lang) : J.lang !== "" && (0, vo.extendedFilter)(J.lang, Zi()(k.lang)).length > 0;
              } catch {
                return !1;
              }
            }
            function V(k, J) {
              return k.index === void 0 || k.index === null || J.index === k.index;
            }
            function ce(k, J) {
              return !k.viewpoint || k.viewpoint === J.viewpoint;
            }
            function g(k, J) {
              var pe = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], Le = !k.role || !!J.roles.filter(function(Ie) {
                return Ie === k.role;
              })[0];
              return Le || J.type === t.Z.AUDIO && pe;
            }
            function P(k, J) {
              return k.accessibility ? !!J.accessibility.filter(function(pe) {
                return pe === k.accessibility;
              })[0] : !J.accessibility.length;
            }
            function D(k, J) {
              return !k.audioChannelConfiguration || !!J.audioChannelConfiguration.filter(function(pe) {
                return pe === k.audioChannelConfiguration;
              })[0];
            }
            function O(k, J) {
              return !k.codec || k.codec === J.codec;
            }
            function A(k) {
              var J, pe = 0, Le = [];
              return k.forEach(function(Ie) {
                (J = Math.max.apply(Math, Ie.bitrateList.map(function(xe) {
                  return xe.bandwidth;
                }))) > pe ? (pe = J, Le = [Ie]) : J === pe && Le.push(Ie);
              }), Le;
            }
            function ne(k) {
              var J, pe = 1 / 0, Le = [];
              return k.forEach(function(Ie) {
                var xe = Ie.bitrateList.reduce(function(De, st) {
                  var ut = Math.max(1, st.width * st.height);
                  return De + st.bandwidth / ut;
                }, 0);
                (J = xe / Ie.bitrateList.length) < pe ? (pe = J, Le = [Ie]) : J === pe && Le.push(Ie);
              }), Le;
            }
            function z(k) {
              var J, pe = 0, Le = [];
              return k.forEach(function(Ie) {
                (J = Ie.representationCount) > pe ? (pe = J, Le = [Ie]) : J === pe && Le.push(Ie);
              }), Le;
            }
            function se(k, J) {
              if (k === t.Z.TEXT) return J[0];
              var pe, Le = _.get().streaming.selectionModeForInitialTrack, Ie = y.getCustomInitialTrackSelectionFunction();
              if (Ie && typeof Ie == "function") pe = Ie(J);
              else switch (Le) {
                case t.Z.TRACK_SELECTION_MODE_HIGHEST_SELECTION_PRIORITY:
                  pe = function(xe) {
                    var De, st, ut = (De = 0, st = [], xe.forEach(function(et) {
                      isNaN(et.selectionPriority) || (et.selectionPriority > De ? (De = et.selectionPriority, st = [et]) : et.selectionPriority === De && st.push(et));
                    }), st);
                    return ut.length > 1 && (ut = A(ut)), ut.length > 1 && (ut = z(ut)), ut;
                  }(J);
                  break;
                case t.Z.TRACK_SELECTION_MODE_HIGHEST_BITRATE:
                  pe = function(xe) {
                    var De = A(xe);
                    return De.length > 1 && (De = z(De)), De;
                  }(J);
                  break;
                case t.Z.TRACK_SELECTION_MODE_FIRST_TRACK:
                  pe = X(J);
                  break;
                case t.Z.TRACK_SELECTION_MODE_HIGHEST_EFFICIENCY:
                  pe = function(xe) {
                    var De = ne(xe);
                    return De.length > 1 && (De = A(De)), De;
                  }(J);
                  break;
                case t.Z.TRACK_SELECTION_MODE_WIDEST_RANGE:
                  pe = function(xe) {
                    var De = z(xe);
                    return De.length > 1 && (De = A(xe)), De;
                  }(J);
                  break;
                default:
                  r.warn("Track selection mode ".concat(Le, " is not supported. Falling back to TRACK_SELECTION_MODE_FIRST_TRACK")), pe = X(J);
              }
              return pe.length > 0 ? pe[0] : J[0];
            }
            function X(k) {
              return k[0];
            }
            return i = { setInitialMediaSettingsForType: function(k, J) {
              var pe = I[k] || fe(k), Le = G(k, J.id), Ie = [];
              pe || ((pe = w.getSavedMediaSettings(k)) && delete pe.codec, Z(k, pe)), Le && Le.length !== 0 && (pe && (Ie = q(Ie = Array.from(Le), oe, pe), Ie = q(Ie, V, pe), Ie = q(Ie, ce, pe), k === t.Z.AUDIO && I[k] || (Ie = q(Ie, g, pe)), Ie = q(Ie, P, pe), Ie = q(Ie, D, pe), Ie = q(Ie, O, pe)), Ie.length === 0 ? U(se(k, Le), !0) : Ie.length > 1 ? U(se(k, Ie)) : U(Ie[0]));
            }, addTrack: function(k) {
              if (k) {
                var J = k.type;
                if ((pe = J) === t.Z.AUDIO || pe === t.Z.VIDEO || pe === t.Z.TEXT || pe === t.Z.IMAGE) {
                  var pe, Le, Ie = k.streamInfo.id;
                  l[Ie] || (l[Ie] = { audio: { list: [], storeLastSettings: Le = _.get().streaming.saveLastMediaSettingsForCurrentStreamingSession, current: null }, video: { list: [], storeLastSettings: Le, current: null }, text: { list: [], storeLastSettings: Le, current: null }, image: { list: [], storeLastSettings: Le, current: null } });
                  for (var xe = l[Ie][J].list, De = 0, st = xe.length; De < st; ++De) if (te(xe[De], k)) return;
                  xe.push(k);
                }
              }
            }, getTracksFor: G, getCurrentTrackFor: N, isCurrentTrack: function(k) {
              if (!k) return !1;
              var J = k.type, pe = k.streamInfo.id;
              return l[pe] && l[pe][J] && te(l[pe][J].current, k);
            }, setTrack: U, selectInitialTrack: se, setInitialSettings: Z, getInitialSettings: fe, getTracksWithHighestBitrate: A, getTracksWithHighestEfficiency: ne, getTracksWithWidestRange: z, isTracksEqual: te, matchSettings: function(k, J) {
              var pe = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
              try {
                var Le = !1;
                if (k.lang) {
                  if (k.lang instanceof RegExp) Le = J.lang.match(k.lang);
                  else if (J.lang !== "") {
                    var Ie = Zi()(k.lang);
                    Ie && (Le = (0, vo.extendedFilter)(J.lang, Ie).length > 0);
                  }
                } else Le = !0;
                var xe = k.index === void 0 || k.index === null || J.index === k.index, De = !k.viewpoint || k.viewpoint === J.viewpoint, st = !k.role || !!J.roles.filter(function(tt) {
                  return tt === k.role;
                })[0], ut = !k.accessibility || !!J.accessibility.filter(function(tt) {
                  return tt === k.accessibility;
                })[0], et = !k.audioChannelConfiguration || !!J.audioChannelConfiguration.filter(function(tt) {
                  return tt === k.audioChannelConfiguration;
                })[0];
                return Le && xe && De && (st || J.type === t.Z.AUDIO && pe) && ut && et;
              } catch {
                return !1;
              }
            }, matchSettingsLang: oe, matchSettingsIndex: V, matchSettingsViewPoint: ce, matchSettingsRole: g, matchSettingsAccessibility: P, matchSettingsAudioChannelConfig: D, saveTextSettingsDisabled: function() {
              w.setSavedMediaSettings(t.Z.TEXT, null);
            }, setConfig: function(k) {
              k && (k.domStorage && (w = k.domStorage), k.settings && (_ = k.settings), k.customParametersModel && (y = k.customParametersModel));
            }, reset: le }, r = (0, h.Z)(F).getInstance().getLogger(i), le(), i;
          }
          ya.__dashjs_factory_name = "MediaController";
          var To = E.Z.getSingletonFactory(ya);
          E.Z.updateSingletonFactory(ya.__dashjs_factory_name, To);
          var fu = To, Ui = NaN, bo = function i(r, l) {
            (function(_, R) {
              if (!(_ instanceof R)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.data = { baseUrls: r || null, selectedIdx: l || Ui }, this.children = [];
          };
          function So() {
            var i, r, l, _, R = this.context, I = Zt(R).getInstance();
            function y(G, N, U) {
              var Z = w(U);
              G[N] ? I.areEqual(Z, G[N].data.baseUrls) || (G[N].data.baseUrls = Z, G[N].data.selectedIdx = Ui) : G[N] = new bo(Z);
            }
            function w(G) {
              var N = l.getBaseURLsFromElement(G), U = _.getSynthesizedBaseUrlElements(N);
              return U && U.length > 0 && (N = N.concat(U)), N;
            }
            function F(G, N) {
              var U = N || r;
              G(U.data), U.children && U.children.forEach(function(Z) {
                return F(G, Z);
              });
            }
            function H() {
              r = new bo();
            }
            return i = { reset: H, update: function(G) {
              (function(N) {
                (function() {
                  if (!l || !l.hasOwnProperty("getBaseURLsFromElement") || !l.hasOwnProperty("getRepresentationSortFunction")) throw new Error("setConfig function has to be called previously");
                })();
                var U = w(N);
                I.areEqual(U, r.data.baseUrls) || (r.data.baseUrls = U, r.data.selectedIdx = Ui), N && N.Period_asArray && N.Period_asArray.forEach(function(Z, fe) {
                  y(r.children, fe, Z), Z.AdaptationSet_asArray && Z.AdaptationSet_asArray.forEach(function(te, le) {
                    y(r.children[fe].children, le, te), te.Representation_asArray && te.Representation_asArray.sort(l.getRepresentationSortFunction()).forEach(function(ge, q) {
                      y(r.children[fe].children[le].children, q, ge);
                    });
                  });
                });
              })(G);
            }, getForPath: function(G) {
              var N = r, U = [N.data];
              return G && G.forEach(function(Z) {
                (N = N.children[Z]) && U.push(N.data);
              }), U.filter(function(Z) {
                return Z.baseUrls.length;
              });
            }, invalidateSelectedIndexes: function(G) {
              F(function(N) {
                isNaN(N.selectedIdx) || G === N.baseUrls[N.selectedIdx].serviceLocation && (N.selectedIdx = Ui);
              });
            }, setConfig: function(G) {
              G.adapter && (l = G.adapter), G.contentSteeringController && (_ = G.contentSteeringController);
            }, getBaseUrls: function(G) {
              return w(G);
            } }, H(), i;
          }
          So.__dashjs_factory_name = "BaseURLTreeModel";
          var du = E.Z.getClassFactory(So);
          function Ao(i) {
            var r = (i = i || {}).blacklistController;
            return { select: function(l) {
              return l && function(R) {
                var I, y, w = 0, F = [], H = 0;
                if ((y = R.sort(function(G, N) {
                  var U = G.dvbPriority - N.dvbPriority;
                  return isNaN(U) ? 0 : U;
                }).filter(function(G, N, U) {
                  return !N || U[0].dvbPriority && G.dvbPriority && U[0].dvbPriority === G.dvbPriority;
                })).length) return y.length > 1 && (y.forEach(function(G) {
                  w += G.dvbWeight, F.push(w);
                }), I = Math.floor(Math.random() * (w - 1)), F.every(function(G, N) {
                  return H = N, !(I < G);
                })), y[H];
              }((_ = [], l.filter(function(R) {
                return !r.contains(R.serviceLocation) || (R.dvbPriority && _.push(R.dvbPriority), !1);
              }).filter(function(R) {
                return !_.length || !R.dvbPriority || _.indexOf(R.dvbPriority) === -1;
              })));
              var _;
            } };
          }
          Ao.__dashjs_factory_name = "DVBSelector";
          var gu = E.Z.getClassFactory(Ao);
          function Io(i) {
            var r = (i = i || {}).blacklistController;
            return { select: function(l) {
              var _, R = 0;
              return l && l.some(function(I, y) {
                return R = y, !r.contains(I.serviceLocation);
              }) && (_ = l[R]), _;
            } };
          }
          Io.__dashjs_factory_name = "BasicSelector";
          var hu = E.Z.getClassFactory(Io);
          function Ro() {
            var i, r, l, _ = this.context;
            function R() {
              for (var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], w = 0, F = NaN, H = function() {
                var N = I[w], U = y.findIndex(function(Z) {
                  return Z.serviceLocation && Z.serviceLocation === N;
                });
                if (U !== -1 && !l.contains(y[U].serviceLocation)) return F = U, "break";
                w += 1;
              }; w < I.length; ) {
                var G = H();
                if (G === "break") break;
              }
              return F;
            }
            return i = { selectBaseUrlIndex: function(I) {
              var y = NaN;
              if (isNaN(I.selectedIdx)) {
                var w = r.getSteeringDataFromManifest();
                w && w.defaultServiceLocationArray.length > 0 && (y = R(w.defaultServiceLocationArray, I.baseUrls));
              }
              var F = r.getCurrentSteeringResponseData();
              return I.baseUrls && I.baseUrls.length && F && F.pathwayPriority && F.pathwayPriority.length && (y = R(F.pathwayPriority, I.baseUrls)), y;
            }, setConfig: function(I) {
              I.blacklistController && (l = I.blacklistController), I.contentSteeringController && (r = I.contentSteeringController);
            } }, r = Sr(_).getInstance(), i;
          }
          Ro.__dashjs_factory_name = "ContentSteeringSelector";
          var mu = E.Z.getClassFactory(Ro);
          function wo() {
            var i, r, l, _, R, I, y = this.context, w = (0, m.Z)(y).getInstance(), F = (0, Ne.Z)(y).getInstance();
            function H() {
              r.reset();
            }
            return i = { chooseSelector: function(G) {
              (0, W.PS)(G, "boolean"), I = G ? _ : l;
            }, select: function(G) {
              if (G) {
                if (F.get().streaming.applyContentSteering) {
                  var N = R.selectBaseUrlIndex(G);
                  isNaN(N) || N === -1 || (G.selectedIdx = N);
                }
                if (!isNaN(G.selectedIdx)) return G.baseUrls[G.selectedIdx];
                var U = I.select(G.baseUrls);
                return U ? (G.selectedIdx = G.baseUrls.indexOf(U), U) : (w.trigger(o.Z.URL_RESOLUTION_FAILED, { error: new ae.Z(Q.URL_RESOLUTION_FAILED_GENERIC_ERROR_CODE, Q.URL_RESOLUTION_FAILED_GENERIC_ERROR_MESSAGE) }), void (I === l && H()));
              }
            }, reset: H, setConfig: function(G) {
              G.selector && (I = G.selector), G.contentSteeringSelector && (R = G.contentSteeringSelector);
            } }, r = ai(y).create({ updateEventName: o.Z.SERVICE_LOCATION_BASE_URL_BLACKLIST_CHANGED, addBlacklistEventName: o.Z.SERVICE_LOCATION_BASE_URL_BLACKLIST_ADD }), l = hu(y).create({ blacklistController: r }), _ = gu(y).create({ blacklistController: r }), (R = mu(y).create()).setConfig({ blacklistController: r }), I = l, i;
          }
          wo.__dashjs_factory_name = "BaseURLSelector";
          var pu = E.Z.getClassFactory(wo);
          function Co() {
            var i, r, l, _, R, I = this.context, y = (0, m.Z)(I).getInstance(), w = (0, Je.Z)(I).getInstance();
            function F(G) {
              l.update(G), _.chooseSelector(r.getIsDVB(G)), y.trigger(n.Z.BASE_URLS_UPDATED, { baseUrls: H(G) });
            }
            function H(G) {
              return l.getBaseUrls(G);
            }
            return i = { reset: function() {
              l.reset(), _.reset();
            }, initialize: function(G) {
              l.setConfig({ adapter: r, contentSteeringController: R }), F(G);
            }, resolve: function(G) {
              var N = l.getForPath(G).reduce(function(U, Z) {
                var fe = _.select(Z);
                return fe ? (w.isRelative(fe.url) ? U.url = w.resolve(fe.url, U.url) : (U.url = fe.url, U.serviceLocation = fe.serviceLocation), U.availabilityTimeOffset = fe.availabilityTimeOffset, U.availabilityTimeComplete = fe.availabilityTimeComplete, U.queryParams = fe.queryParams, U) : new vr();
              }, new vr());
              if (!w.isRelative(N.url)) return N;
            }, setConfig: function(G) {
              G.baseURLTreeModel && (l = G.baseURLTreeModel), G.baseURLSelector && (_ = G.baseURLSelector), G.adapter && (r = G.adapter), G.contentSteeringController && (R = G.contentSteeringController);
            }, getBaseUrls: H, update: F }, l = du(I).create(), _ = pu(I).create(), y.on(o.Z.SERVICE_LOCATION_BASE_URL_BLACKLIST_CHANGED, function(G) {
              l.invalidateSelectedIndexes(G.entry);
            }, i), i;
          }
          Co.__dashjs_factory_name = "BaseURLController";
          var yu = E.Z.getClassFactory(Co);
          function _a(i) {
            return _a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
              return typeof r;
            } : function(r) {
              return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
            }, _a(i);
          }
          function Ea(i, r) {
            return Ea = Object.setPrototypeOf || function(l, _) {
              return l.__proto__ = _, l;
            }, Ea(i, r);
          }
          function _u(i, r) {
            return !r || _a(r) !== "object" && typeof r != "function" ? function(l) {
              if (l === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return l;
            }(i) : r;
          }
          function Bi(i) {
            return Bi = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
              return r.__proto__ || Object.getPrototypeOf(r);
            }, Bi(i);
          }
          var No = function(i) {
            (function(I, y) {
              if (typeof y != "function" && y !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(y && y.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), y && Ea(I, y);
            })(R, i);
            var r, l, _ = (r = R, l = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var I, y = Bi(r);
              if (l) {
                var w = Bi(this).constructor;
                I = Reflect.construct(y, arguments, w);
              } else I = y.apply(this, arguments);
              return _u(this, I);
            });
            function R(I, y) {
              var w;
              return function(F, H) {
                if (!(F instanceof H)) throw new TypeError("Cannot call a class as a function");
              }(this, R), (w = _.call(this)).url = I || null, w.type = y || null, w.mediaType = t.Z.STREAM, w.responseType = "", w;
            }
            return R;
          }(S.Z);
          function Do(i) {
            i = i || {};
            var r = this.context, l = (0, m.Z)(r).getInstance(), _ = sr(r).create({ errHandler: i.errHandler, dashMetrics: i.dashMetrics, mediaPlayerModel: i.mediaPlayerModel, requestModifier: i.requestModifier, errors: Q });
            return { load: function(R, I, y) {
              var w = function(H, G) {
                I.resolved = !0, I.resolvedContent = H || null, l.trigger(o.Z.XLINK_ELEMENT_LOADED, { element: I, resolveObject: y, error: H || G ? null : new ae.Z(Q.XLINK_LOADER_LOADING_FAILURE_ERROR_CODE, Q.XLINK_LOADER_LOADING_FAILURE_ERROR_MESSAGE + R) });
              };
              if (R === "urn:mpeg:dash:resolve-to-zero:2013") w(null, !0);
              else {
                var F = new No(R, Ue.w.XLINK_EXPANSION_TYPE);
                _.load({ request: F, success: function(H) {
                  w(H);
                }, error: function() {
                  w(null);
                } });
              }
            }, reset: function() {
              _ && (_.abort(), _ = null);
            } };
          }
          Do.__dashjs_factory_name = "XlinkLoader";
          var Eu = E.Z.getClassFactory(Do), Oo = function(i) {
            (i = i || {}).escapeMode === void 0 && (i.escapeMode = !0), i.attributePrefix === void 0 && (i.attributePrefix = "_"), i.arrayAccessForm = i.arrayAccessForm || "none", i.emptyNodeForm = i.emptyNodeForm || "text", i.enableToStringFunc === void 0 && (i.enableToStringFunc = !0), i.arrayAccessFormPaths = i.arrayAccessFormPaths || [], i.skipEmptyTextNodesForObj === void 0 && (i.skipEmptyTextNodesForObj = !0), i.stripWhitespaces === void 0 && (i.stripWhitespaces = !0), i.datetimeAccessFormPaths = i.datetimeAccessFormPaths || [], i.useDoubleQuotes === void 0 && (i.useDoubleQuotes = !1), i.xmlElementsFilter = i.xmlElementsFilter || [], i.jsonPropertiesFilter = i.jsonPropertiesFilter || [], i.keepCData === void 0 && (i.keepCData = !1), i.ignoreRoot === void 0 && (i.ignoreRoot = !1);
            function r(q) {
              var oe = q.localName;
              return oe == null && (oe = q.baseName), oe != null && oe != "" || (oe = q.nodeName), oe;
            }
            function l(q) {
              return typeof q == "string" ? q.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;") : q;
            }
            function _(q, oe, V, ce) {
              for (var g = 0; g < q.length; g++) {
                var P = q[g];
                if (typeof P == "string") {
                  if (P == ce) break;
                } else if (P instanceof RegExp) {
                  if (P.test(ce)) break;
                } else if (typeof P == "function" && P(oe, V, ce)) break;
              }
              return g != q.length;
            }
            function R(q, oe, V) {
              i.arrayAccessForm === "property" && (q[oe] instanceof Array ? q[oe + "_asArray"] = q[oe] : q[oe + "_asArray"] = [q[oe]]), !(q[oe] instanceof Array) && i.arrayAccessFormPaths.length > 0 && _(i.arrayAccessFormPaths, q, oe, V) && (q[oe] = [q[oe]]);
            }
            function I(q) {
              var oe = q.split(/[-T:+Z]/g), V = new Date(oe[0], oe[1] - 1, oe[2]), ce = oe[5].split(".");
              if (V.setHours(oe[3], oe[4], ce[0]), ce.length > 1 && V.setMilliseconds(ce[1]), oe[6] && oe[7]) {
                var g = 60 * oe[6] + Number(oe[7]);
                g = 0 + ((/\d\d-\d\d:\d\d$/.test(q) ? "-" : "+") == "-" ? -1 * g : g), V.setMinutes(V.getMinutes() - g - V.getTimezoneOffset());
              } else q.indexOf("Z", q.length - 1) !== -1 && (V = new Date(Date.UTC(V.getFullYear(), V.getMonth(), V.getDate(), V.getHours(), V.getMinutes(), V.getSeconds(), V.getMilliseconds())));
              return V;
            }
            function y(q, oe, V, ce) {
              return !(oe == 1 && i.xmlElementsFilter.length > 0) || _(i.xmlElementsFilter, q, V, ce);
            }
            function w(q, oe) {
              if (q.nodeType == 9) {
                for (var V = new Object(), ce = q.childNodes, g = 0; g < ce.length; g++) (D = ce[g]).nodeType == 1 && (i.ignoreRoot ? V = w(D) : (V = {})[O = r(D)] = w(D));
                return V;
              }
              if (q.nodeType == 1) {
                (V = new Object()).__cnt = 0;
                var P = [];
                for (ce = q.childNodes, g = 0; g < ce.length; g++) {
                  var D, O = r(D = ce[g]);
                  if (D.nodeType != 8) {
                    var A = oe + "." + O;
                    if (y(V, D.nodeType, O, A)) if (V.__cnt++, V[O] == null) {
                      var ne = w(D, A);
                      (O != "#text" || /[^\s]/.test(ne)) && ((z = {})[O] = ne, P.push(z)), V[O] = ne, R(V, O, A);
                    } else {
                      var z;
                      V[O] != null && (V[O] instanceof Array || (V[O] = [V[O]], R(V, O, A))), ne = w(D, A), (O != "#text" || /[^\s]/.test(ne)) && ((z = {})[O] = ne, P.push(z)), V[O][V[O].length] = ne;
                    }
                  }
                }
                V.__children = P;
                for (var se = r(q), X = 0; X < q.attributes.length; X++) {
                  var k = q.attributes[X];
                  V.__cnt++;
                  for (var J = k.value, pe = 0, Le = i.matchers.length; pe < Le; pe++) {
                    var Ie = i.matchers[pe];
                    Ie.test(k, se) && (J = Ie.converter(k.value));
                  }
                  V[i.attributePrefix + k.name] = J;
                }
                var xe = function(De) {
                  return De.prefix;
                }(q);
                return xe != null && xe != "" && (V.__cnt++, V.__prefix = xe), V["#text"] != null && (V.__text = V["#text"], V.__text instanceof Array && (V.__text = V.__text.join(`
`)), i.stripWhitespaces && (V.__text = V.__text.trim()), delete V["#text"], i.arrayAccessForm == "property" && delete V["#text_asArray"], V.__text = function(De, st, ut) {
                  if (i.datetimeAccessFormPaths.length > 0) {
                    var et = ut.split(".#")[0];
                    return _(i.datetimeAccessFormPaths, De, st, et) ? I(De) : De;
                  }
                  return De;
                }(V.__text, O, oe + "." + O)), V["#cdata-section"] != null && (V.__cdata = V["#cdata-section"], delete V["#cdata-section"], i.arrayAccessForm == "property" && delete V["#cdata-section_asArray"]), V.__cnt == 0 && i.emptyNodeForm == "text" ? V = "" : V.__cnt == 1 && V.__text != null ? V = V.__text : V.__cnt != 1 || V.__cdata == null || i.keepCData ? V.__cnt > 1 && V.__text != null && i.skipEmptyTextNodesForObj && (i.stripWhitespaces && V.__text == "" || V.__text.trim() == "") && delete V.__text : V = V.__cdata, delete V.__cnt, !i.enableToStringFunc || V.__text == null && V.__cdata == null || (V.toString = function() {
                  return (this.__text != null ? this.__text : "") + (this.__cdata != null ? this.__cdata : "");
                }), V;
              }
              if (q.nodeType == 3 || q.nodeType == 4) return q.nodeValue;
            }
            function F(q, oe, V, ce) {
              var g = "<" + (q != null && q.__prefix != null ? q.__prefix + ":" : "") + oe;
              if (V != null) for (var P = 0; P < V.length; P++) {
                var D = V[P], O = q[D];
                i.escapeMode && (O = l(O)), g += " " + D.substr(i.attributePrefix.length) + "=", i.useDoubleQuotes ? g += '"' + O + '"' : g += "'" + O + "'";
              }
              return g + (ce ? "/>" : ">");
            }
            function H(q, oe) {
              return "</" + (q.__prefix != null ? q.__prefix + ":" : "") + oe + ">";
            }
            function G(q, oe) {
              return i.arrayAccessForm == "property" && (ce = "_asArray", (V = oe.toString()).indexOf(ce, V.length - ce.length) !== -1) || oe.toString().indexOf(i.attributePrefix) == 0 || oe.toString().indexOf("__") == 0 || q[oe] instanceof Function;
              var V, ce;
            }
            function N(q) {
              var oe = 0;
              if (q instanceof Object) for (var V in q) G(q, V) || oe++;
              return oe;
            }
            function U(q, oe, V) {
              return i.jsonPropertiesFilter.length == 0 || V == "" || _(i.jsonPropertiesFilter, q, oe, V);
            }
            function Z(q) {
              var oe = [];
              if (q instanceof Object) for (var V in q) V.toString().indexOf("__") == -1 && V.toString().indexOf(i.attributePrefix) == 0 && oe.push(V);
              return oe;
            }
            function fe(q) {
              var oe = "";
              return q instanceof Object ? oe += function(V) {
                var ce = "";
                return V.__cdata != null && (ce += "<![CDATA[" + V.__cdata + "]]>"), V.__text != null && (i.escapeMode ? ce += l(V.__text) : ce += V.__text), ce;
              }(q) : q != null && (i.escapeMode ? oe += l(q) : oe += q), oe;
            }
            function te(q, oe) {
              return q === "" ? oe : q + "." + oe;
            }
            function le(q, oe, V, ce) {
              var g = "";
              if (q.length == 0) g += F(q, oe, V, !0);
              else for (var P = 0; P < q.length; P++) g += F(q[P], oe, Z(q[P]), !1), g += ge(q[P], te(ce, oe)), g += H(q[P], oe);
              return g;
            }
            function ge(q, oe) {
              var V = "";
              if (N(q) > 0) {
                for (var ce in q) if (!G(q, ce) && (oe == "" || U(q, ce, te(oe, ce)))) {
                  var g = q[ce], P = Z(g);
                  g == null || g == null ? V += F(g, ce, P, !0) : g instanceof Object ? g instanceof Array ? V += le(g, ce, P, oe) : g instanceof Date ? (V += F(g, ce, P, !1), V += g.toISOString(), V += H(g, ce)) : N(g) > 0 || g.__text != null || g.__cdata != null ? (V += F(g, ce, P, !1), V += ge(g, te(oe, ce)), V += H(g, ce)) : V += F(g, ce, P, !0) : (V += F(g, ce, P, !1), V += fe(g), V += H(g, ce));
                }
              }
              return V + fe(q);
            }
            this.parseXmlString = function(q) {
              var oe;
              if (q === void 0) return null;
              if (window.DOMParser) {
                var V = new window.DOMParser();
                try {
                  (oe = V.parseFromString(q, "text/xml")).getElementsByTagNameNS("*", "parsererror").length > 0 && (oe = null);
                } catch {
                  oe = null;
                }
              } else q.indexOf("<?") == 0 && (q = q.substr(q.indexOf("?>") + 2)), (oe = new ActiveXObject("Microsoft.XMLDOM")).async = "false", oe.loadXML(q);
              return oe;
            }, this.asArray = function(q) {
              return q === void 0 || q == null ? [] : q instanceof Array ? q : [q];
            }, this.toXmlDateTime = function(q) {
              return q instanceof Date ? q.toISOString() : typeof q == "number" ? new Date(q).toISOString() : null;
            }, this.asDateTime = function(q) {
              return typeof q == "string" ? I(q) : q;
            }, this.xml2json = function(q) {
              return w(q);
            }, this.xml_str2json = function(q) {
              var oe = this.parseXmlString(q);
              return oe != null ? this.xml2json(oe) : null;
            }, this.json2xml_str = function(q) {
              return ge(q, "");
            }, this.json2xml = function(q) {
              var oe = this.json2xml_str(q);
              return this.parseXmlString(oe);
            }, this.getVersion = function() {
              return "1.2.0";
            };
          }, ui = "onLoad";
          function Mo(i) {
            i = i || {};
            var r, l, _, R, I, y, w = this.context, F = (0, m.Z)(w).getInstance(), H = (0, Je.Z)(w).getInstance();
            function G(te, le, ge) {
              var q, oe, V = {};
              V.elements = te, V.type = le, V.resolveType = ge, V.elements.length === 0 && U(V);
              for (var ce = 0; ce < V.elements.length; ce++) q = V.elements[ce], oe = H.isHTTPURL(q.url) ? q.url : q.originalContent.BaseURL + q.url, y.load(oe, q, V);
            }
            function N(te) {
              var le, ge, q = "";
              if (le = te.element, ge = te.resolveObject, le.resolvedContent) {
                var oe = 0;
                le.resolvedContent.indexOf("<?xml") === 0 && (oe = le.resolvedContent.indexOf("?>") + 2), q = le.resolvedContent.substr(0, oe) + "<response>" + le.resolvedContent.substr(oe) + "</response>", le.resolvedContent = I.xml_str2json(q);
              }
              (function(V) {
                var ce;
                for (ce = 0; ce < V.elements.length; ce++) if (V.elements[ce].resolved === !1) return !1;
                return !0;
              })(ge) && U(ge);
            }
            function U(te) {
              var le, ge, q = [];
              if (function(oe) {
                var V, ce, g, P, D, O, A = [];
                for (P = oe.elements.length - 1; P >= 0; P--) {
                  if (ce = (V = oe.elements[P]).type + "_asArray", V.resolvedContent) {
                    if (V.resolvedContent) for (D = 0; D < V.resolvedContent[ce].length; D++) g = V.resolvedContent[ce][D], A.push(g);
                  } else delete V.originalContent["xlink:actuate"], delete V.originalContent["xlink:href"], A.push(V.originalContent);
                  for (V.parentElement[ce].splice(V.index, 1), O = 0; O < A.length; O++) V.parentElement[ce].splice(V.index + O, 0, A[O]);
                  A = [];
                }
                oe.elements.length > 0 && _.run(R);
              }(te), te.resolveType === "onActuate" && F.trigger(o.Z.XLINK_READY, { manifest: R }), te.resolveType === ui) switch (te.type) {
                case e.Z.PERIOD:
                  for (le = 0; le < R[e.Z.PERIOD + "_asArray"].length; le++) (ge = R[e.Z.PERIOD + "_asArray"][le]).hasOwnProperty(e.Z.ADAPTATION_SET + "_asArray") && (q = q.concat(Z(ge[e.Z.ADAPTATION_SET + "_asArray"], ge, e.Z.ADAPTATION_SET, ui))), ge.hasOwnProperty(e.Z.EVENT_STREAM + "_asArray") && (q = q.concat(Z(ge[e.Z.EVENT_STREAM + "_asArray"], ge, e.Z.EVENT_STREAM, ui)));
                  G(q, e.Z.ADAPTATION_SET, ui);
                  break;
                case e.Z.ADAPTATION_SET:
                  F.trigger(o.Z.XLINK_READY, { manifest: R });
              }
            }
            function Z(te, le, ge, q) {
              var oe, V, ce, g = [];
              for (V = te.length - 1; V >= 0; V--) (oe = te[V]).hasOwnProperty("xlink:href") && oe["xlink:href"] === "urn:mpeg:dash:resolve-to-zero:2013" && te.splice(V, 1);
              for (V = 0; V < te.length; V++) (oe = te[V]).hasOwnProperty("xlink:href") && oe.hasOwnProperty("xlink:actuate") && oe["xlink:actuate"] === q && (ce = fe(oe["xlink:href"], le, ge, V, q, oe), g.push(ce));
              return g;
            }
            function fe(te, le, ge, q, oe, V) {
              return { url: te, parentElement: le, type: ge, index: q, resolveType: oe, originalContent: V, resolvedContent: null, resolved: !1 };
            }
            return r = { resolveManifestOnLoad: function(te) {
              I = new Oo({ escapeMode: !1, attributePrefix: "", arrayAccessForm: "property", emptyNodeForm: "object", stripWhitespaces: !1, enableToStringFunc: !1, ignoreRoot: !0, matchers: l }), (R = te).Period_asArray ? G(Z(R.Period_asArray, R, e.Z.PERIOD, ui), e.Z.PERIOD, ui) : F.trigger(o.Z.XLINK_READY, { manifest: R });
            }, setMatchers: function(te) {
              te && (l = te);
            }, setIron: function(te) {
              te && (_ = te);
            }, reset: function() {
              F.off(o.Z.XLINK_ELEMENT_LOADED, N, r), y && (y.reset(), y = null);
            } }, F.on(o.Z.XLINK_ELEMENT_LOADED, N, r), y = Eu(w).create({ errHandler: i.errHandler, dashMetrics: i.dashMetrics, mediaPlayerModel: i.mediaPlayerModel, requestModifier: i.requestModifier, settings: i.settings }), r;
          }
          Mo.__dashjs_factory_name = "XlinkController";
          var vu = E.Z.getClassFactory(Mo);
          function vi(i) {
            return vi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
              return typeof r;
            } : function(r) {
              return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
            }, vi(i);
          }
          function Po(i) {
            function r(R, I) {
              for (var y in R) I.hasOwnProperty(y) || (I[y] = R[y]);
            }
            function l(R, I, y) {
              for (var w = 0, F = R.length; w < F; ++w) {
                var H = R[w];
                if (I[H.name]) if (y[H.name]) {
                  if (H.merge) {
                    var G = I[H.name], N = y[H.name];
                    vi(G) === "object" && vi(N) === "object" ? r(G, N) : y[H.name] = G + N;
                  }
                } else y[H.name] = I[H.name];
              }
            }
            function _(R, I) {
              for (var y = 0, w = R.children.length; y < w; ++y) {
                var F = R.children[y], H = I[F.name + "_asArray"];
                if (H) for (var G = 0, N = H.length; G < N; ++G) {
                  var U = H[G];
                  l(R.properties, I, U), _(F, U);
                }
              }
            }
            return { run: function(R) {
              if (R === null || vi(R) !== "object") return R;
              if (R.Period_asArray && "period" in i) for (var I = i.period, y = R.Period_asArray, w = 0, F = y.length; w < F; ++w) {
                var H = y[w];
                if (_(I, H), "adaptationset" in i) {
                  var G = H.AdaptationSet_asArray;
                  if (G) for (var N = i.adaptationset, U = 0, Z = G.length; U < Z; ++U) _(N, G[U]);
                }
              }
              return R;
            } };
          }
          Po.__dashjs_factory_name = "ObjectIron";
          var Tu = E.Z.getClassFactory(Po);
          function bu(i, r) {
            for (var l = 0; l < r.length; l++) {
              var _ = r[l];
              _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(i, _.key, _);
            }
          }
          var Ti = function() {
            function i(_, R) {
              (function(I, y) {
                if (!(I instanceof y)) throw new TypeError("Cannot call a class as a function");
              })(this, i), this._test = _, this._converter = R;
            }
            var r, l;
            return r = i, (l = [{ key: "test", get: function() {
              return this._test;
            } }, { key: "converter", get: function() {
              return this._converter;
            } }]) && bu(r.prototype, l), i;
          }();
          function va(i) {
            return va = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
              return typeof r;
            } : function(r) {
              return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
            }, va(i);
          }
          function Gn(i, r, l) {
            return r in i ? Object.defineProperty(i, r, { value: l, enumerable: !0, configurable: !0, writable: !0 }) : i[r] = l, i;
          }
          function Ta(i, r) {
            return Ta = Object.setPrototypeOf || function(l, _) {
              return l.__proto__ = _, l;
            }, Ta(i, r);
          }
          function Su(i, r) {
            return !r || va(r) !== "object" && typeof r != "function" ? function(l) {
              if (l === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return l;
            }(i) : r;
          }
          function Gi(i) {
            return Gi = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
              return r.__proto__ || Object.getPrototypeOf(r);
            }, Gi(i);
          }
          var Au = function(i) {
            (function(I, y) {
              if (typeof y != "function" && y !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(y.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), Ta(I, y);
            })(R, i);
            var r, l, _ = (r = R, l = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var I, y = Gi(r);
              if (l) {
                var w = Gi(this).constructor;
                I = Reflect.construct(y, arguments, w);
              } else I = y.apply(this, arguments);
              return Su(this, I);
            });
            function R() {
              return function(I, y) {
                if (!(I instanceof y)) throw new TypeError("Cannot call a class as a function");
              }(this, R), _.call(this, function(I, y) {
                var w, F = (Gn(w = {}, e.Z.MPD, [e.Z.ID, e.Z.PROFILES]), Gn(w, e.Z.PERIOD, [e.Z.ID]), Gn(w, e.Z.BASE_URL, [e.Z.SERVICE_LOCATION, e.Z.BYTE_RANGE]), Gn(w, e.Z.SEGMENT_BASE, [e.Z.INDEX_RANGE]), Gn(w, e.Z.INITIALIZATION, [e.Z.RANGE]), Gn(w, e.Z.REPRESENTATION_INDEX, [e.Z.RANGE]), Gn(w, e.Z.SEGMENT_LIST, [e.Z.INDEX_RANGE]), Gn(w, e.Z.BITSTREAM_SWITCHING, [e.Z.RANGE]), Gn(w, e.Z.SEGMENT_URL, [e.Z.MEDIA_RANGE, e.Z.INDEX_RANGE]), Gn(w, e.Z.SEGMENT_TEMPLATE, [e.Z.INDEX_RANGE, e.Z.MEDIA, e.Z.INDEX, e.Z.INITIALIZATION_MINUS, e.Z.BITSTREAM_SWITCHING_MINUS]), Gn(w, e.Z.ASSET_IDENTIFIER, [e.Z.VALUE, e.Z.ID]), Gn(w, e.Z.EVENT_STREAM, [e.Z.VALUE]), Gn(w, e.Z.ADAPTATION_SET, [e.Z.PROFILES, e.Z.MIME_TYPE, e.Z.SEGMENT_PROFILES, e.Z.CODECS, e.Z.CONTENT_TYPE]), Gn(w, e.Z.FRAME_PACKING, [e.Z.VALUE, e.Z.ID]), Gn(w, e.Z.AUDIO_CHANNEL_CONFIGURATION, [e.Z.VALUE, e.Z.ID]), Gn(w, e.Z.CONTENT_PROTECTION, [e.Z.VALUE, e.Z.ID]), Gn(w, e.Z.ESSENTIAL_PROPERTY, [e.Z.VALUE, e.Z.ID]), Gn(w, e.Z.SUPPLEMENTAL_PROPERTY, [e.Z.VALUE, e.Z.ID]), Gn(w, e.Z.INBAND_EVENT_STREAM, [e.Z.VALUE, e.Z.ID]), Gn(w, e.Z.ACCESSIBILITY, [e.Z.VALUE, e.Z.ID]), Gn(w, e.Z.ROLE, [e.Z.VALUE, e.Z.ID]), Gn(w, e.Z.RATING, [e.Z.VALUE, e.Z.ID]), Gn(w, e.Z.VIEWPOINT, [e.Z.VALUE, e.Z.ID]), Gn(w, e.Z.CONTENT_COMPONENT, [e.Z.CONTENT_TYPE]), Gn(w, e.Z.REPRESENTATION, [e.Z.ID, e.Z.DEPENDENCY_ID, e.Z.MEDIA_STREAM_STRUCTURE_ID]), Gn(w, e.Z.SUBSET, [e.Z.ID]), Gn(w, e.Z.METRICS, [e.Z.METRICS_MINUS]), Gn(w, e.Z.REPORTING, [e.Z.VALUE, e.Z.ID]), w);
                if (F.hasOwnProperty(y)) {
                  var H = F[y];
                  return H !== void 0 && H.indexOf(I.name) >= 0;
                }
                return !1;
              }, function(I) {
                return String(I);
              });
            }
            return R;
          }(Ti);
          function ba(i) {
            return ba = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
              return typeof r;
            } : function(r) {
              return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
            }, ba(i);
          }
          function Sa(i, r) {
            return Sa = Object.setPrototypeOf || function(l, _) {
              return l.__proto__ = _, l;
            }, Sa(i, r);
          }
          function Iu(i, r) {
            return !r || ba(r) !== "object" && typeof r != "function" ? function(l) {
              if (l === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return l;
            }(i) : r;
          }
          function qi(i) {
            return qi = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
              return r.__proto__ || Object.getPrototypeOf(r);
            }, qi(i);
          }
          var Lo = /^([-])?P(([\d.]*)Y)?(([\d.]*)M)?(([\d.]*)D)?T?(([\d.]*)H)?(([\d.]*)M)?(([\d.]*)S)?/, Ru = function(i) {
            (function(I, y) {
              if (typeof y != "function" && y !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(y.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), Sa(I, y);
            })(R, i);
            var r, l, _ = (r = R, l = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var I, y = qi(r);
              if (l) {
                var w = qi(this).constructor;
                I = Reflect.construct(y, arguments, w);
              } else I = y.apply(this, arguments);
              return Iu(this, I);
            });
            function R() {
              return function(I, y) {
                if (!(I instanceof y)) throw new TypeError("Cannot call a class as a function");
              }(this, R), _.call(this, function(I) {
                for (var y = [e.Z.MIN_BUFFER_TIME, e.Z.MEDIA_PRESENTATION_DURATION, e.Z.MINIMUM_UPDATE_PERIOD, e.Z.TIMESHIFT_BUFFER_DEPTH, e.Z.MAX_SEGMENT_DURATION, e.Z.MAX_SUBSEGMENT_DURATION, e.Z.SUGGESTED_PRESENTATION_DELAY, e.Z.START, t.Z.START_TIME, e.Z.DURATION], w = y.length, F = 0; F < w; F++) if (I.nodeName === y[F]) return Lo.test(I.value);
                return !1;
              }, function(I) {
                var y = Lo.exec(I), w = 31536e3 * parseFloat(y[3] || 0) + 2592e3 * parseFloat(y[5] || 0) + 86400 * parseFloat(y[7] || 0) + 3600 * parseFloat(y[9] || 0) + 60 * parseFloat(y[11] || 0) + parseFloat(y[13] || 0);
                return y[1] !== void 0 && (w = -w), w;
              });
            }
            return R;
          }(Ti);
          function Aa(i) {
            return Aa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
              return typeof r;
            } : function(r) {
              return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
            }, Aa(i);
          }
          function Ia(i, r) {
            return Ia = Object.setPrototypeOf || function(l, _) {
              return l.__proto__ = _, l;
            }, Ia(i, r);
          }
          function wu(i, r) {
            return !r || Aa(r) !== "object" && typeof r != "function" ? function(l) {
              if (l === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return l;
            }(i) : r;
          }
          function Hi(i) {
            return Hi = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
              return r.__proto__ || Object.getPrototypeOf(r);
            }, Hi(i);
          }
          var xo = /^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2})(?::([0-9]*)(\.[0-9]*)?)?(?:([+-])([0-9]{2})(?::?)([0-9]{2}))?/, Cu = function(i) {
            (function(I, y) {
              if (typeof y != "function" && y !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(y.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), Ia(I, y);
            })(R, i);
            var r, l, _ = (r = R, l = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var I, y = Hi(r);
              if (l) {
                var w = Hi(this).constructor;
                I = Reflect.construct(y, arguments, w);
              } else I = y.apply(this, arguments);
              return wu(this, I);
            });
            function R() {
              return function(I, y) {
                if (!(I instanceof y)) throw new TypeError("Cannot call a class as a function");
              }(this, R), _.call(this, function(I) {
                return xo.test(I.value);
              }, function(I) {
                var y, w = xo.exec(I);
                if (y = Date.UTC(parseInt(w[1], 10), parseInt(w[2], 10) - 1, parseInt(w[3], 10), parseInt(w[4], 10), parseInt(w[5], 10), w[6] && parseInt(w[6], 10) || 0, w[7] && 1e3 * parseFloat(w[7]) || 0), w[9] && w[10]) {
                  var F = 60 * parseInt(w[9], 10) + parseInt(w[10], 10);
                  y += (w[8] === "+" ? -1 : 1) * F * 60 * 1e3;
                }
                return new Date(y);
              });
            }
            return R;
          }(Ti);
          function Ra(i) {
            return Ra = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
              return typeof r;
            } : function(r) {
              return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
            }, Ra(i);
          }
          function wa(i, r) {
            return wa = Object.setPrototypeOf || function(l, _) {
              return l.__proto__ = _, l;
            }, wa(i, r);
          }
          function Nu(i, r) {
            return !r || Ra(r) !== "object" && typeof r != "function" ? function(l) {
              if (l === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return l;
            }(i) : r;
          }
          function Vi(i) {
            return Vi = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
              return r.__proto__ || Object.getPrototypeOf(r);
            }, Vi(i);
          }
          var Du = /^[-+]?[0-9]+[.]?[0-9]*([eE][-+]?[0-9]+)?$/, Ou = function(i) {
            (function(I, y) {
              if (typeof y != "function" && y !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(y.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), wa(I, y);
            })(R, i);
            var r, l, _ = (r = R, l = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var I, y = Vi(r);
              if (l) {
                var w = Vi(this).constructor;
                I = Reflect.construct(y, arguments, w);
              } else I = y.apply(this, arguments);
              return Nu(this, I);
            });
            function R() {
              return function(I, y) {
                if (!(I instanceof y)) throw new TypeError("Cannot call a class as a function");
              }(this, R), _.call(this, function(I) {
                return Du.test(I.value);
              }, function(I) {
                return parseFloat(I);
              });
            }
            return R;
          }(Ti);
          function Ca(i) {
            return Ca = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
              return typeof r;
            } : function(r) {
              return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
            }, Ca(i);
          }
          function bi(i, r, l) {
            return r in i ? Object.defineProperty(i, r, { value: l, enumerable: !0, configurable: !0, writable: !0 }) : i[r] = l, i;
          }
          function Na(i, r) {
            return Na = Object.setPrototypeOf || function(l, _) {
              return l.__proto__ = _, l;
            }, Na(i, r);
          }
          function Mu(i, r) {
            return !r || Ca(r) !== "object" && typeof r != "function" ? function(l) {
              if (l === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return l;
            }(i) : r;
          }
          function ji(i) {
            return ji = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
              return r.__proto__ || Object.getPrototypeOf(r);
            }, ji(i);
          }
          var Pu = function(i) {
            (function(I, y) {
              if (typeof y != "function" && y !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(y.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), Na(I, y);
            })(R, i);
            var r, l, _ = (r = R, l = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var I, y = ji(r);
              if (l) {
                var w = ji(this).constructor;
                I = Reflect.construct(y, arguments, w);
              } else I = y.apply(this, arguments);
              return Mu(this, I);
            });
            function R() {
              return function(I, y) {
                if (!(I instanceof y)) throw new TypeError("Cannot call a class as a function");
              }(this, R), _.call(this, function(I, y) {
                var w, F = (bi(w = {}, e.Z.ADAPTATION_SET, [e.Z.LANG]), bi(w, e.Z.REPRESENTATION, [e.Z.LANG]), bi(w, e.Z.CONTENT_COMPONENT, [e.Z.LANG]), bi(w, e.Z.LABEL, [e.Z.LANG]), bi(w, e.Z.GROUP_LABEL, [e.Z.LANG]), w);
                if (F.hasOwnProperty(y)) {
                  var H = F[y];
                  return H !== void 0 && H.indexOf(I.name) >= 0;
                }
                return !1;
              }, function(I) {
                return Zi()(I) || String(I);
              });
            }
            return R;
          }(Ti);
          function Lu(i, r) {
            for (var l = 0; l < r.length; l++) {
              var _ = r[l];
              _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(i, _.key, _);
            }
          }
          var xu = function() {
            function i(_) {
              var R;
              (function(I, y) {
                if (!(I instanceof y)) throw new TypeError("Cannot call a class as a function");
              })(this, i), this._name = _, this._merge = (R = _) && R.length && R.charAt(0) === R.charAt(0).toUpperCase();
            }
            var r, l;
            return r = i, (l = [{ key: "name", get: function() {
              return this._name;
            } }, { key: "merge", get: function() {
              return this._merge;
            } }]) && Lu(r.prototype, l), i;
          }();
          function Fu(i, r) {
            for (var l = 0; l < r.length; l++) {
              var _ = r[l];
              _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(i, _.key, _);
            }
          }
          var li = function() {
            function i(_, R, I) {
              var y = this;
              (function(w, F) {
                if (!(w instanceof F)) throw new TypeError("Cannot call a class as a function");
              })(this, i), this._name = _ || "", this._properties = [], this._children = I || [], Array.isArray(R) && R.forEach(function(w) {
                y._properties.push(new xu(w));
              });
            }
            var r, l;
            return r = i, (l = [{ key: "name", get: function() {
              return this._name;
            } }, { key: "children", get: function() {
              return this._children;
            } }, { key: "properties", get: function() {
              return this._properties;
            } }]) && Fu(r.prototype, l), i;
          }();
          function Da(i) {
            return Da = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
              return typeof r;
            } : function(r) {
              return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
            }, Da(i);
          }
          function Oa(i, r) {
            return Oa = Object.setPrototypeOf || function(l, _) {
              return l.__proto__ = _, l;
            }, Oa(i, r);
          }
          function ku(i, r) {
            return !r || Da(r) !== "object" && typeof r != "function" ? function(l) {
              if (l === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return l;
            }(i) : r;
          }
          function Yi(i) {
            return Yi = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
              return r.__proto__ || Object.getPrototypeOf(r);
            }, Yi(i);
          }
          var Zu = function(i) {
            (function(I, y) {
              if (typeof y != "function" && y !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(y.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), Oa(I, y);
            })(R, i);
            var r, l, _ = (r = R, l = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var I, y = Yi(r);
              if (l) {
                var w = Yi(this).constructor;
                I = Reflect.construct(y, arguments, w);
              } else I = y.apply(this, arguments);
              return ku(this, I);
            });
            function R() {
              (function(y, w) {
                if (!(y instanceof w)) throw new TypeError("Cannot call a class as a function");
              })(this, R);
              var I = [e.Z.PROFILES, e.Z.WIDTH, e.Z.HEIGHT, e.Z.SAR, e.Z.FRAMERATE, e.Z.AUDIO_SAMPLING_RATE, e.Z.MIME_TYPE, e.Z.SEGMENT_PROFILES, e.Z.CODECS, e.Z.MAXIMUM_SAP_PERIOD, e.Z.START_WITH_SAP, e.Z.MAX_PLAYOUT_RATE, e.Z.CODING_DEPENDENCY, e.Z.SCAN_TYPE, e.Z.FRAME_PACKING, e.Z.AUDIO_CHANNEL_CONFIGURATION, e.Z.CONTENT_PROTECTION, e.Z.ESSENTIAL_PROPERTY, e.Z.ESSENTIAL_PROPERTY + "_asArray", e.Z.SUPPLEMENTAL_PROPERTY, e.Z.INBAND_EVENT_STREAM];
              return _.call(this, e.Z.ADAPTATION_SET, I, [new li(e.Z.REPRESENTATION, I, [new li(e.Z.SUB_REPRESENTATION, I)])]);
            }
            return R;
          }(li);
          function Ma(i) {
            return Ma = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
              return typeof r;
            } : function(r) {
              return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
            }, Ma(i);
          }
          function Pa(i, r) {
            return Pa = Object.setPrototypeOf || function(l, _) {
              return l.__proto__ = _, l;
            }, Pa(i, r);
          }
          function Uu(i, r) {
            return !r || Ma(r) !== "object" && typeof r != "function" ? function(l) {
              if (l === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return l;
            }(i) : r;
          }
          function Ki(i) {
            return Ki = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
              return r.__proto__ || Object.getPrototypeOf(r);
            }, Ki(i);
          }
          var Bu = function(i) {
            (function(I, y) {
              if (typeof y != "function" && y !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(y.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), Pa(I, y);
            })(R, i);
            var r, l, _ = (r = R, l = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var I, y = Ki(r);
              if (l) {
                var w = Ki(this).constructor;
                I = Reflect.construct(y, arguments, w);
              } else I = y.apply(this, arguments);
              return Uu(this, I);
            });
            function R() {
              (function(y, w) {
                if (!(y instanceof w)) throw new TypeError("Cannot call a class as a function");
              })(this, R);
              var I = [e.Z.SEGMENT_BASE, e.Z.SEGMENT_TEMPLATE, e.Z.SEGMENT_LIST];
              return _.call(this, e.Z.PERIOD, I, [new li(e.Z.ADAPTATION_SET, I, [new li(e.Z.REPRESENTATION, I)])]);
            }
            return R;
          }(li);
          function Fo(i) {
            i = i || {};
            var r, l, _, R, I, y = this.context, w = i.debug;
            return r = { parse: function(F) {
              var H, G = window.performance.now();
              if (!(H = R.xml_str2json(F))) throw new Error("parsing the manifest failed");
              var N = window.performance.now();
              H.Patch ? ((H = H.Patch).add_asArray && H.add_asArray.forEach(function(Z) {
                return I.run(Z);
              }), H.replace_asArray && H.replace_asArray.forEach(function(Z) {
                return I.run(Z);
              })) : (H = H.MPD, I.run(H));
              var U = window.performance.now();
              return l.info("Parsing complete: ( xml2json: " + (N - G).toPrecision(3) + "ms, objectiron: " + (U - N).toPrecision(3) + "ms, total: " + ((U - G) / 1e3).toPrecision(3) + "s)"), H.protocol = "DASH", H;
            }, getMatchers: function() {
              return _;
            }, getIron: function() {
              return I;
            } }, l = w.getLogger(r), _ = [new Ru(), new Cu(), new Ou(), new Pu(), new Au()], R = new Oo({ escapeMode: !1, attributePrefix: "", arrayAccessForm: "property", emptyNodeForm: "object", stripWhitespaces: !1, enableToStringFunc: !0, ignoreRoot: !1, matchers: _ }), I = Tu(y).create({ adaptationset: new Zu(), period: new Bu() }), r;
          }
          Fo.__dashjs_factory_name = "DashParser";
          var Gu = E.Z.getClassFactory(Fo);
          function ko(i) {
            i = i || {};
            var r, l, _, R, I, y = this.context, w = i.debug, F = i.settings, H = (0, m.Z)(y).getInstance(), G = (0, Je.Z)(y).getInstance(), N = i.mssHandler, U = i.errHandler;
            function Z(te) {
              H.trigger(o.Z.INTERNAL_MANIFEST_LOADED, { manifest: te.manifest });
            }
            function fe(te) {
              var le = null;
              return te.indexOf("SmoothStreamingMedia") > -1 ? (N && (le = N.createMssParser(), N.createMssFragmentProcessor(), N.registerEvents()), le) : te.indexOf("MPD") > -1 || te.indexOf("Patch") > -1 ? Gu(y).create({ debug: w }) : le;
            }
            return r = { load: function(te) {
              var le = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, ge = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, q = /* @__PURE__ */ new Date(), oe = new No(te, Ue.w.MPD_TYPE);
              le && (oe.serviceLocation = le), ge && (oe.queryParams = ge), oe.requestStartDate || (oe.requestStartDate = q), H.trigger(o.Z.MANIFEST_LOADING_STARTED, { request: oe }), _.load({ request: oe, success: function(V, ce, g) {
                var P, D, O;
                if (R) if (g && g !== te ? (D = G.parseBaseUrl(g), P = g) : (G.isRelative(te) && (te = G.resolve(te, window.location.href)), D = G.parseBaseUrl(te)), ce != "No Content") if (I === null && (I = fe(V)), I !== null) {
                  R.setMatchers(I.getMatchers()), R.setIron(I.getIron());
                  try {
                    O = I.parse(V);
                  } catch {
                    return void H.trigger(o.Z.INTERNAL_MANIFEST_LOADED, { manifest: null, error: new ae.Z(Q.MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE, Q.MANIFEST_LOADER_PARSING_FAILURE_ERROR_MESSAGE + "".concat(te)) });
                  }
                  if (O) {
                    if (O.url = P || te, O.originalUrl || (O.originalUrl = O.url), F && F.get().streaming.enableManifestDurationMismatchFix && O.mediaPresentationDuration && O.Period_asArray.length > 1) {
                      var A = O.Period_asArray.reduce(function(ne, z) {
                        return ne + z.duration;
                      }, 0);
                      !isNaN(A) && O.mediaPresentationDuration > A && (l.warn("Media presentation duration greater than duration of all periods. Setting duration to total period duration"), O.mediaPresentationDuration = A);
                    }
                    O.baseUri = D, O.loadedTime = /* @__PURE__ */ new Date(), R.resolveManifestOnLoad(O), H.trigger(o.Z.ORIGINAL_MANIFEST_LOADED, { originalManifest: V });
                  } else H.trigger(o.Z.INTERNAL_MANIFEST_LOADED, { manifest: null, error: new ae.Z(Q.MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE, Q.MANIFEST_LOADER_PARSING_FAILURE_ERROR_MESSAGE + "".concat(te)) });
                } else H.trigger(o.Z.INTERNAL_MANIFEST_LOADED, { manifest: null, error: new ae.Z(Q.MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE, Q.MANIFEST_LOADER_PARSING_FAILURE_ERROR_MESSAGE + "".concat(te)) });
                else H.trigger(o.Z.INTERNAL_MANIFEST_LOADED, { manifest: null });
              }, error: function(V, ce, g) {
                H.trigger(o.Z.INTERNAL_MANIFEST_LOADED, { manifest: null, error: new ae.Z(Q.MANIFEST_LOADER_LOADING_FAILURE_ERROR_CODE, Q.MANIFEST_LOADER_LOADING_FAILURE_ERROR_MESSAGE + "".concat(te, ", ").concat(g)) });
              } });
            }, reset: function() {
              H.off(o.Z.XLINK_READY, Z, r), N && N.reset(), R && (R.reset(), R = null), _ && (_.abort(), _ = null);
            } }, l = w.getLogger(r), H.on(o.Z.XLINK_READY, Z, r), _ = sr(y).create({ errHandler: i.errHandler, dashMetrics: i.dashMetrics, mediaPlayerModel: i.mediaPlayerModel, requestModifier: i.requestModifier, urlUtils: G, constants: t.Z, dashConstants: e.Z, errors: Q, requestTimeout: i.settings.get().streaming.manifestRequestTimeout }), R = vu(y).create({ errHandler: U, dashMetrics: i.dashMetrics, mediaPlayerModel: i.mediaPlayerModel, requestModifier: i.requestModifier, settings: i.settings }), I = null, r;
          }
          ko.__dashjs_factory_name = "ManifestLoader";
          var qu = E.Z.getClassFactory(ko);
          function Zo() {
            var i = this.context, r = (0, m.Z)(i).getInstance();
            return { error: function(l) {
              r.trigger(o.Z.ERROR, { error: l });
            } };
          }
          Zo.__dashjs_factory_name = "ErrorHandler";
          var Hu = E.Z.getSingletonFactory(Zo), Uo = C(1715);
          function Bo() {
            var i, r, l, _, R, I, y = this.context, w = (0, m.Z)(y).getInstance();
            function F(H, G) {
              if (!G || !G.Period_asArray || G.Period_asArray.length === 0) return Promise.resolve();
              var N = [];
              return G.Period_asArray.forEach(function(U) {
                N.push(function(Z, fe) {
                  return new Promise(function(te) {
                    if (Z && Z.AdaptationSet_asArray && Z.AdaptationSet_asArray.length !== 0) {
                      var le = [];
                      Z.AdaptationSet_asArray.forEach(function(ge) {
                        r.getIsTypeOf(ge, fe) && le.push(function(q, oe) {
                          return new Promise(function(V) {
                            if (q.Representation_asArray && q.Representation_asArray.length !== 0) {
                              var ce = [], g = [];
                              q.Representation_asArray.forEach(function(P, D) {
                                var O = r.getCodec(q, D, !1), A = function(ne, z, se) {
                                  switch (ne) {
                                    case t.Z.VIDEO:
                                      return function(X, k) {
                                        return { codec: k, width: X.width || null, height: X.height || null, framerate: X.frameRate || null, bitrate: X.bandwidth || null };
                                      }(z, se);
                                    case t.Z.AUDIO:
                                      return function(X, k) {
                                        var J = X.audioSamplingRate || null;
                                        return { codec: k, bitrate: X.bandwidth || null, samplerate: J };
                                      }(z, se);
                                    default:
                                      return null;
                                  }
                                }(oe, P, O);
                                g.push(A), ce.push(l.supportsCodec(A, oe));
                              }), Promise.all(ce).then(function(P) {
                                q.Representation_asArray = q.Representation_asArray.filter(function(D, O) {
                                  return P[O] || I.debug("[Stream] Codec ".concat(g[O].codec, " not supported ")), P[O];
                                }), V();
                              }).catch(function() {
                                V();
                              });
                            } else V();
                          });
                        }(ge, fe));
                      }), Promise.all(le).then(function() {
                        Z.AdaptationSet_asArray = Z.AdaptationSet_asArray.filter(function(ge) {
                          var q = ge.Representation_asArray && ge.Representation_asArray.length > 0;
                          return q || (w.trigger(o.Z.ADAPTATION_SET_REMOVED_NO_CAPABILITIES, { adaptationSet: ge }), I.warn("AdaptationSet has been removed because of no supported Representation")), q;
                        }), te();
                      }).catch(function() {
                        te();
                      });
                    } else te();
                  });
                }(U, H));
              }), Promise.all(N);
            }
            return i = { setConfig: function(H) {
              H && (H.adapter && (r = H.adapter), H.capabilities && (l = H.capabilities), H.settings && (_ = H.settings), H.customParametersModel && (R = H.customParametersModel));
            }, filterUnsupportedFeatures: function(H) {
              return new Promise(function(G) {
                var N = [];
                N.push(F(t.Z.VIDEO, H)), N.push(F(t.Z.AUDIO, H)), Promise.all(N).then(function() {
                  _.get().streaming.capabilities.filterUnsupportedEssentialProperties && function(U) {
                    U && U.Period_asArray && U.Period_asArray.length !== 0 && U.Period_asArray.forEach(function(Z) {
                      Z.AdaptationSet_asArray = Z.AdaptationSet_asArray.filter(function(fe) {
                        return !fe.Representation_asArray || fe.Representation_asArray.length === 0 || (fe.Representation_asArray = fe.Representation_asArray.filter(function(te) {
                          var le = r.getEssentialPropertiesForRepresentation(te);
                          if (le && le.length > 0) for (var ge = 0; ge < le.length; ) {
                            if (!l.supportsEssentialProperty(le[ge])) return I.debug("[Stream] EssentialProperty not supported: " + le[ge].schemeIdUri), !1;
                            ge += 1;
                          }
                          return !0;
                        }), fe.Representation_asArray && fe.Representation_asArray.length > 0);
                      });
                    });
                  }(H), function(U) {
                    var Z = R.getCustomCapabilitiesFilters();
                    Z && Z.length !== 0 && U && U.Period_asArray && U.Period_asArray.length !== 0 && U.Period_asArray.forEach(function(fe) {
                      fe.AdaptationSet_asArray = fe.AdaptationSet_asArray.filter(function(te) {
                        return !te.Representation_asArray || te.Representation_asArray.length === 0 || (te.Representation_asArray = te.Representation_asArray.filter(function(le) {
                          return !Z.some(function(ge) {
                            return !ge(le);
                          });
                        }), te.Representation_asArray && te.Representation_asArray.length > 0);
                      });
                    });
                  }(H), G();
                }).catch(function() {
                  G();
                });
              });
            } }, I = (0, h.Z)(y).getInstance().getLogger(i), i;
          }
          Bo.__dashjs_factory_name = "CapabilitiesFilter";
          var Vu = E.Z.getSingletonFactory(Bo), ju = function i() {
            (function(r, l) {
              if (!(r instanceof l)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.t = null, this.xywh = null, this.track = null, this.id = null, this.s = null, this.r = null;
          };
          function Go() {
            var i;
            return { initialize: function(r) {
              if (i = new ju(), !r) return null;
              var l = r.indexOf("#");
              if (l !== -1) for (var _ = r.substr(l + 1).split("&"), R = 0, I = _.length; R < I; ++R) {
                var y = _[R], w = y.indexOf("=");
                if (w !== -1) {
                  var F = y.substring(0, w);
                  i.hasOwnProperty(F) && (i[F] = y.substr(w + 1));
                }
              }
            }, getURIFragmentData: function() {
              return i;
            } };
          }
          Go.__dashjs_factory_name = "URIFragmentModel";
          var Yu = E.Z.getSingletonFactory(Go);
          function qo() {
            var i, r = this.context, l = (0, m.Z)(r).getInstance();
            return { getValue: function() {
              return i;
            }, setValue: function(_) {
              i = _, _ && l.trigger(o.Z.MANIFEST_LOADED, { data: _ });
            } };
          }
          qo.__dashjs_factory_name = "ManifestModel";
          var Ku = E.Z.getSingletonFactory(qo), La = -0.5;
          function Ho() {
            var i, r, l, _, R = this.context, I = (0, Ne.Z)(R).getInstance();
            function y(H, G) {
              return isNaN(H) ? 0 : H > 0 ? (G && r.warn("Supplied minimum playback rate is a positive value when it should be negative or 0. The supplied rate will not be applied and set to 0: 100% playback speed."), 0) : H < La ? (G && r.warn("Supplied minimum playback rate is out of range and will be limited to ".concat(La, ": ").concat(-50, "% playback speed.")), La) : H;
            }
            function w(H, G) {
              return isNaN(H) ? 0 : H < 0 ? (G && r.warn("Supplied maximum playback rate is a negative value when it should be negative or 0. The supplied rate will not be applied and set to 0: 100% playback speed."), 0) : H > 1 ? (G && r.warn("Supplied maximum playback rate is out of range and will be limited to ".concat(1, ": ").concat(200, "% playback speed.")), 1) : H;
            }
            function F() {
              var H = I.get().streaming.buffer.stableBufferTime > 0 ? I.get().streaming.buffer.stableBufferTime : I.get().streaming.buffer.fastSwitchEnabled ? 20 : 12, G = l.getLiveDelay();
              return !isNaN(G) && G > 0 ? Math.min(H, G) : H;
            }
            return i = { getCatchupMaxDrift: function() {
              if (!isNaN(I.get().streaming.liveCatchup.maxDrift) && I.get().streaming.liveCatchup.maxDrift > 0) return I.get().streaming.liveCatchup.maxDrift;
              var H = _.getServiceDescriptionSettings();
              return H && H.liveCatchup && !isNaN(H.liveCatchup.maxDrift) && H.liveCatchup.maxDrift > 0 ? H.liveCatchup.maxDrift : 12;
            }, getCatchupModeEnabled: function() {
              return I.get().streaming.liveCatchup.enabled !== null ? I.get().streaming.liveCatchup.enabled : l.getInitialCatchupModeActivated();
            }, getStableBufferTime: F, getInitialBufferLevel: function() {
              var H = I.get().streaming.buffer.initialBufferLevel;
              return isNaN(H) || H < 0 ? 0 : Math.min(F(), H);
            }, getRetryAttemptsForType: function(H) {
              var G = isNaN(I.get().streaming.retryAttempts.lowLatencyMultiplyFactor) ? 5 : I.get().streaming.retryAttempts.lowLatencyMultiplyFactor;
              return l.getLowLatencyModeEnabled() ? I.get().streaming.retryAttempts[H] * G : I.get().streaming.retryAttempts[H];
            }, getRetryIntervalsForType: function(H) {
              var G = isNaN(I.get().streaming.retryIntervals.lowLatencyReductionFactor) ? 10 : I.get().streaming.retryIntervals.lowLatencyReductionFactor;
              return l.getLowLatencyModeEnabled() ? I.get().streaming.retryIntervals[H] / G : I.get().streaming.retryIntervals[H];
            }, getCatchupPlaybackRates: function(H) {
              var G = I.get().streaming.liveCatchup.playbackRate;
              if (!isNaN(G.min) || !isNaN(G.max)) return { min: y(G.min, H), max: w(G.max, H) };
              var N = _.getServiceDescriptionSettings();
              if (N && N.liveCatchup && (!isNaN(N.liveCatchup.playbackRate.min) || !isNaN(N.liveCatchup.playbackRate.max))) {
                var U = N.liveCatchup.playbackRate;
                return { min: y(U.min, H), max: w(U.max, H) };
              }
              return { min: -0.5, max: 0.5 };
            }, getAbrBitrateParameter: function(H, G) {
              try {
                var N = I.get().streaming.abr[H][G];
                if (!isNaN(N) && N !== -1) return N;
                var U = _.getServiceDescriptionSettings();
                return U && U[H] && !isNaN(U[H][G]) ? U[H][G] : -1;
              } catch {
                return -1;
              }
            }, setConfig: function(H) {
              H.playbackController && (l = H.playbackController), H.serviceDescriptionController && (_ = H.serviceDescriptionController);
            }, reset: function() {
            } }, r = (0, h.Z)(R).getInstance().getLogger(i), i;
          }
          Ho.__dashjs_factory_name = "MediaPlayerModel";
          var zu = E.Z.getSingletonFactory(Ho), Wu = C(1767);
          function Vo(i) {
            var r = (i = i || {}).abrController, l = i.switchHistory, _ = i.droppedFramesHistory, R = i.currentRequest, I = i.useBufferOccupancyABR, y = i.useL2AABR, w = i.useLoLPABR, F = i.streamProcessor ? i.streamProcessor.getScheduleController() : null, H = i.streamProcessor ? i.streamProcessor.getRepresentationInfo() : null, G = i.videoModel ? i.videoModel : null;
            function N() {
              return H ? H.mediaInfo : null;
            }
            return { getMediaType: function() {
              var U = N();
              return U ? U.type : null;
            }, getMediaInfo: N, getDroppedFramesHistory: function() {
              return _;
            }, getCurrentRequest: function() {
              return R;
            }, getSwitchHistory: function() {
              return l;
            }, getStreamInfo: function() {
              var U = N();
              return U ? U.streamInfo : null;
            }, getScheduleController: function() {
              return F;
            }, getAbrController: function() {
              return r;
            }, getRepresentationInfo: function() {
              return H;
            }, useBufferOccupancyABR: function() {
              return I;
            }, useL2AABR: function() {
              return y;
            }, useLoLPABR: function() {
              return w;
            }, getVideoModel: function() {
              return G;
            } };
          }
          Vo.__dashjs_factory_name = "RulesContext";
          var jo = E.Z.getClassFactory(Vo), zi = C(2068);
          function Yo() {
            var i = [], r = [];
            return { push: function(l) {
              l.newValue === zi.Z.NO_CHANGE && (l.newValue = l.oldValue), i[l.oldValue] || (i[l.oldValue] = { noDrops: 0, drops: 0, dropSize: 0 });
              var _ = l.newValue - l.oldValue, R = _ < 0 ? 1 : 0, I = R ? -_ : 0, y = R ? 0 : 1;
              if (i[l.oldValue].drops += R, i[l.oldValue].dropSize += I, i[l.oldValue].noDrops += y, r.push({ idx: l.oldValue, noDrop: y, drop: R, dropSize: I }), r.length > 8) {
                var w = r.shift();
                i[w.idx].drops -= w.drop, i[w.idx].dropSize -= w.dropSize, i[w.idx].noDrops -= w.noDrop;
              }
            }, getSwitchRequests: function() {
              return i;
            }, reset: function() {
              i = [], r = [];
            } };
          }
          Yo.__dashjs_factory_name = "SwitchRequestHistory";
          var Qu = E.Z.getClassFactory(Yo);
          function Ko() {
            var i = {}, r = {}, l = {};
            return { push: function(_, R, I) {
              if (R) {
                i[_] || (i[_] = [], r[_] = 0, l[_] = 0);
                var y = I && I.droppedVideoFrames ? I.droppedVideoFrames : 0, w = I && I.totalVideoFrames ? I.totalVideoFrames : 0, F = y - r[_];
                r[_] = y;
                var H = w - l[_];
                l[_] = w;
                var G = i[_];
                isNaN(R) || (G[R] ? (G[R].droppedVideoFrames += F, G[R].totalVideoFrames += H) : G[R] = { droppedVideoFrames: F, totalVideoFrames: H });
              }
            }, getFrameHistory: function(_) {
              return i[_];
            }, clearForStream: function(_) {
              try {
                delete i[_], delete r[_], delete l[_];
              } catch {
              }
            }, reset: function() {
              i = {}, r = {}, l = {};
            } };
          }
          Ko.__dashjs_factory_name = "DroppedFramesHistory";
          var Xu = E.Z.getClassFactory(Ko);
          function zo(i) {
            var r, l, _, R, I, y = this.context, w = (i = i || {}).settings, F = (0, m.Z)(y).getInstance();
            function H(te, le, ge, q) {
              var oe = Math.pow(0.5, ge / q.fast);
              te.fastEstimate = (1 - oe) * le + oe * te.fastEstimate;
              var V = Math.pow(0.5, ge / q.slow);
              te.slowEstimate = (1 - V) * le + V * te.slowEstimate, te.totalWeight += ge;
            }
            function G(te, le, ge) {
              return w.get().streaming.abr.movingAverageMethod !== t.Z.MOVING_AVERAGE_SLIDING_WINDOW ? function(q, oe) {
                var V = q ? I.throughputHalfLife : I.latencyHalfLife, ce = q ? _[oe] : R[oe];
                if (!ce || ce.totalWeight <= 0) return NaN;
                var g = ce.fastEstimate / (1 - Math.pow(0.5, ce.totalWeight / V.fast)), P = ce.slowEstimate / (1 - Math.pow(0.5, ce.totalWeight / V.slow));
                return q ? Math.min(g, P) : Math.max(g, P);
              }(te, le) : function(q, oe, V) {
                var ce = function(P, D, O) {
                  var A, ne;
                  if (P ? (A = r[D], ne = O ? 3 : 4) : (A = l[D], ne = 4), A) {
                    if (ne >= A.length) ne = A.length;
                    else if (P) for (var z = 1; z < ne; ++z) {
                      var se = A[A.length - z] / A[A.length - z - 1];
                      if ((se >= 1.3 || se <= 0.7692307692307692) && (ne += 1) === A.length) break;
                    }
                  } else ne = 0;
                  return ne;
                }(q, oe, V), g = (q ? r : l)[oe];
                return ce !== 0 && g && g.length !== 0 ? (g = g.slice(-ce)).reduce(function(P, D) {
                  return P + D;
                }) / g.length : NaN;
              }(te, le, ge);
            }
            function N(te, le) {
              return G(!0, te, le);
            }
            function U(te) {
              r[te] = r[te] || [], l[te] = l[te] || [], _[te] = _[te] || { fastEstimate: 0, slowEstimate: 0, totalWeight: 0 }, R[te] = R[te] || { fastEstimate: 0, slowEstimate: 0, totalWeight: 0 };
            }
            function Z() {
              r = {}, l = {}, _ = {}, R = {};
            }
            var fe = { push: function(te, le, ge) {
              if (le.trace && le.trace.length) {
                var q, oe = le.tresponse.getTime() - le.trequest.getTime() || 1, V = le._tfinish.getTime() - le.tresponse.getTime() || 1, ce = le.trace.reduce(function(O, A) {
                  return O + A.b[0];
                }, 0), g = 0;
                if ((q = le._fileLoaderType && le._fileLoaderType === t.Z.FILE_LOADER_TYPES.FETCH ? le.trace.reduce(function(O, A) {
                  return O + A.d;
                }, 0) : ge ? V : oe + V) !== 0 && (g = Math.round(8 * ce / q)), le.cmsd) {
                  var P = le.cmsd.dynamic && le.cmsd.dynamic.etp ? le.cmsd.dynamic.etp : null;
                  if (P) {
                    var D = w.get().streaming.cmsd.abr.etpWeightRatio;
                    D > 0 && D <= 1 && (g = g * (1 - D) + P * D);
                  }
                }
                if (U(te), function(O, A, ne) {
                  return O === t.Z.VIDEO ? ne < w.get().streaming.cacheLoadThresholds[t.Z.VIDEO] : O === t.Z.AUDIO ? ne < w.get().streaming.cacheLoadThresholds[t.Z.AUDIO] : void 0;
                }(te, 0, V)) {
                  if (r[te].length > 0 && !r[te].hasCachedEntries) return;
                  r[te].hasCachedEntries = !0;
                } else r[te] && r[te].hasCachedEntries && function(O) {
                  delete r[O], delete l[O], delete _[O], delete R[O], U(O);
                }(te);
                r[te].push(g), F.trigger(n.Z.THROUGHPUT_MEASUREMENT_STORED, { throughput: g, mediaType: te, httpRequest: le }), r[te].length > 20 && r[te].shift(), l[te].push(oe), l[te].length > 20 && l[te].shift(), H(_[te], g, 1e-3 * V, I.throughputHalfLife), H(R[te], oe, 1, I.latencyHalfLife);
              }
            }, getAverageThroughput: N, getSafeAverageThroughput: function(te, le) {
              var ge = N(te, le);
              return isNaN(ge) || (ge *= w.get().streaming.abr.bandwidthSafetyFactor), ge;
            }, getAverageLatency: function(te) {
              return G(!1, te);
            }, reset: Z };
            return I = { throughputHalfLife: { fast: 3, slow: 8 }, latencyHalfLife: { fast: 1, slow: 2 } }, Z(), fe;
          }
          zo.__dashjs_factory_name = "ThroughputHistory";
          var $u = E.Z.getClassFactory(zo);
          function xa() {
            var i, r, l, _, R, I, y, w, F, H, G, N, U, Z, fe, te, le, ge, q, oe, V, ce, g, P, D, O, A, ne = this.context, z = (0, h.Z)(ne).getInstance(), se = (0, m.Z)(ne).getInstance();
            function X() {
              R = {}, I = {}, w = {}, y = {}, oe = {}, g = {}, P = {}, D = {}, H === void 0 && (H = !1), V && V.reset(), q = void 0, V = void 0, ce = void 0, clearTimeout(F), F = null;
            }
            function k(be) {
              var Be = be.request.mediaType, mt = be.streamId;
              if (Be && mt && y[mt] && A.get().streaming.abr.autoSwitchBitrate[Be]) {
                var Ke = y[mt][Be];
                if (Ke) {
                  var vt = jo(ne).create({ abrController: i, streamProcessor: Ke, currentRequest: be.request, useBufferOccupancyABR: g[Be], useL2AABR: P[Be], useLoLPABR: D[Be], videoModel: Z }), Et = l.shouldAbandonFragment(vt, mt);
                  Et.quality > zi.Z.NO_CHANGE && Ke.getFragmentModel().getRequests({ state: K.FRAGMENT_MODEL_LOADING, index: be.request.index })[0] && (w[mt][Be].state = p.Z.ABANDON_LOAD, oe[mt][Be].reset(), oe[mt][Be].push({ oldValue: xe(Be, mt), newValue: Et.quality, confidence: 1, reason: Et.reason }), De(Be, _.getActiveStreamInfo(), Et.quality, Et.reason), clearTimeout(F), F = setTimeout(function() {
                    w[mt][Be].state = p.Z.ALLOW_LOAD, F = null;
                  }, A.get().streaming.abandonLoadTimeout));
                }
              }
            }
            function J(be) {
              be.mediaType === t.Z.VIDEO && (q !== void 0 && V.push(be.streamId, q, Z.getPlaybackQuality()), q = be.newQuality);
            }
            function pe(be) {
              var Be, mt;
              be.metric !== p.Z.HTTP_REQUEST || !be.value || be.value.type !== Ue.w.MEDIA_SEGMENT_TYPE || be.mediaType !== t.Z.AUDIO && be.mediaType !== t.Z.VIDEO || ce.push(be.mediaType, be.value, A.get().streaming.abr.useDeadTimeLatency), be.metric !== p.Z.BUFFER_LEVEL || be.mediaType !== t.Z.AUDIO && be.mediaType !== t.Z.VIDEO || (Be = be.mediaType, mt = 1e-3 * be.value.level, A.get().streaming.abr.ABRStrategy === t.Z.ABR_STRATEGY_DYNAMIC && function(Ke, vt) {
                try {
                  var Et = fe.getStableBufferTime(), gt = Et, Wt = 0.5 * Et, zt = g[Ke], gn = vt > (zt ? Wt : gt);
                  g[Ke] = gn, gn !== zt && (gn ? r.info("[" + Ke + "] switching from throughput to buffer occupancy ABR rule (buffer: " + vt.toFixed(3) + ").") : r.info("[" + Ke + "] switching from buffer occupancy to throughput ABR rule (buffer: " + vt.toFixed(3) + ")."));
                } catch (pn) {
                  r.error(pn);
                }
              }(Be, mt));
            }
            function Le(be, Be) {
              try {
                var mt;
                return R[Be] = R[Be] || {}, R[Be].hasOwnProperty(be) || (R[Be][be] = 0), mt = function(Ke, vt) {
                  var Et = R[vt][Ke], gt = Et;
                  if (!y[vt] || !y[vt][Ke]) return gt;
                  var Wt = Ie(Ke, vt);
                  Wt !== void 0 && (gt = Math.max(Et, Wt));
                  var zt = function(gn, pn) {
                    try {
                      var je = fe.getAbrBitrateParameter("maxBitrate", gn);
                      return je > -1 ? et(y[pn][gn].getMediaInfo(), je, pn) : void 0;
                    } catch {
                      return;
                    }
                  }(Ke, vt);
                  return zt !== void 0 && (gt = Math.min(gt, zt)), gt;
                }(be, Be), mt = function(Ke, vt, Et) {
                  var gt = R[Et][vt], Wt = A.get().streaming.abr.maxRepresentationRatio[vt];
                  return isNaN(Wt) || Wt >= 1 || Wt < 0 ? Ke : Math.min(Ke, Math.round(gt * Wt));
                }(mt, be, Be), mt = function(Ke, vt, Et) {
                  if (vt !== t.Z.VIDEO || !A.get().streaming.abr.limitBitrateByPortal || !y[Et] || !y[Et][vt]) return Ke;
                  H || Ut();
                  var gt = y[Et][vt].getStreamInfo(), Wt = U.getAdaptationForType(gt.index, vt, gt).Representation_asArray, zt = Ke;
                  if (G > 0 && N > 0) {
                    for (; zt > 0 && Wt[zt] && G < Wt[zt].width && G - Wt[zt - 1].width < Wt[zt].width - G; ) zt -= 1;
                    for (; zt < Wt.length - 1 && Wt[zt].width === Wt[zt + 1].width; ) zt += 1;
                  }
                  return zt;
                }(mt, be, Be), A.get().streaming.cmsd.enabled && A.get().streaming.cmsd.abr.applyMb && (mt = function(Ke, vt, Et) {
                  if (vt !== "video") return Ke;
                  var gt = le.getMaxBitrate(vt);
                  if (gt < 0) return Ke;
                  var Wt = ut(Et, "audio", xe("audio", Et));
                  gt -= Wt ? Wt.bitrate / 1e3 : 0;
                  var zt = et(y[Et][vt].getMediaInfo(), gt, Et);
                  return r.debug("Stream ID: " + Et + " [" + vt + "] Apply max bit rate from CMSD: " + gt), Math.min(Ke, zt);
                }(mt, be, Be)), mt;
              } catch {
                return;
              }
            }
            function Ie(be, Be) {
              try {
                return function(mt, Ke) {
                  try {
                    var vt = fe.getAbrBitrateParameter("minBitrate", mt);
                    if (vt > -1) {
                      var Et = y[Ke][mt].getMediaInfo(), gt = tt(Et), Wt = et(Et, vt, Ke);
                      return gt[Wt] && Wt < gt.length - 1 && gt[Wt].bitrate < 1e3 * vt && Wt++, Wt;
                    }
                    return;
                  } catch {
                    return;
                  }
                }(be, Be);
              } catch {
                return;
              }
            }
            function xe(be) {
              var Be = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
              try {
                return Be || (Be = _.getActiveStreamInfo().id), be && y[Be] && y[Be][be] && Be ? (I[Be] = I[Be] || {}, I[Be].hasOwnProperty(be) || (I[Be][be] = 0), I[Be][be]) : 0;
              } catch {
                return 0;
              }
            }
            function De(be, Be, mt) {
              var Ke = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
              if (Be && Be.id && be) {
                var vt = Be.id, Et = xe(be, vt);
                (0, W.SE)(mt);
                var gt = Le(be, vt);
                mt !== Et && mt >= 0 && mt <= gt && st(be, Et, mt, gt, Ke, vt);
              }
            }
            function st(be, Be, mt, Ke, vt, Et) {
              if (be && y[Et] && y[Et][be]) {
                var gt = y[Et][be].getStreamInfo(), Wt = gt && gt.manifestInfo && gt.manifestInfo.isDynamic, zt = O.getCurrentBufferLevel(be);
                r.info("Stream ID: " + Et + " [" + be + "] switch from " + Be + " to " + mt + "/" + Ke + " (buffer: " + zt + ") " + (vt ? JSON.stringify(vt) : ".")), I[Et] = I[Et] || {}, I[Et][be] = mt;
                var gn = ut(Et, be, mt);
                se.trigger(o.Z.QUALITY_CHANGE_REQUESTED, { oldQuality: Be, newQuality: mt, reason: vt, streamInfo: gt, bitrateInfo: gn, maxIdx: Ke, mediaType: be }, { streamId: gt.id, mediaType: be });
                var pn = ce.getAverageThroughput(be, Wt);
                isNaN(pn) || ge.setSavedBitrateSettings(be, pn);
              }
            }
            function ut(be, Be, mt) {
              if (Be && y && y[be] && y[be][Be]) {
                var Ke = tt(y[be][Be].getMediaInfo());
                return Ke[mt] ? Ke[mt] : null;
              }
              return null;
            }
            function et(be, Be, mt) {
              var Ke = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, vt = be && be.type ? y[mt][be.type].getRepresentationInfo() : null;
              if (A.get().streaming.abr.useDeadTimeLatency && Ke && vt && vt.fragmentDuration) {
                Ke /= 1e3;
                var Et = vt.fragmentDuration;
                if (Ke > Et) return 0;
                var gt = Ke / Et;
                Be *= 1 - gt;
              }
              for (var Wt = tt(be), zt = Wt.length - 1; zt >= 0; zt--) {
                var gn = Wt[zt];
                if (1e3 * Be >= gn.bitrate) return zt;
              }
              return 0;
            }
            function tt(be) {
              var Be = [];
              if (!be || !be.bitrateList) return Be;
              for (var mt, Ke = be.bitrateList, vt = be.type, Et = 0, gt = Ke.length; Et < gt; Et++) (mt = new Mi()).mediaType = vt, mt.qualityIndex = Et, mt.bitrate = Ke[Et].bandwidth, mt.width = Ke[Et].width, mt.height = Ke[Et].height, mt.scanType = Ke[Et].scanType, Be.push(mt);
              return Be;
            }
            function Ut() {
              if (Z) {
                var be = A.get().streaming.abr.usePixelRatioInLimitBitrateByPortal && window.hasOwnProperty("devicePixelRatio") ? window.devicePixelRatio : 1;
                G = Z.getClientWidth() * be, N = Z.getClientHeight() * be;
              }
            }
            return i = { initialize: function() {
              V = Xu(ne).create(), ce = $u(ne).create({ settings: A }), (l = (0, Wu.Z)(ne).create({ dashMetrics: O, customParametersModel: te, mediaPlayerModel: fe, settings: A })).initialize(), se.on(n.Z.QUALITY_CHANGE_RENDERED, J, i), se.on(n.Z.METRIC_ADDED, pe, i), se.on(o.Z.LOADING_PROGRESS, k, i);
            }, isPlayingAtTopQuality: function(be) {
              var Be = be ? be.id : null, mt = xe(t.Z.AUDIO, Be), Ke = xe(t.Z.VIDEO, Be);
              return mt === Le(t.Z.AUDIO, Be) && Ke === Le(t.Z.VIDEO, Be);
            }, updateTopQualityIndex: function(be) {
              var Be = be.type, mt = be.streamInfo.id, Ke = be.representationCount - 1;
              return R[mt] = R[mt] || {}, R[mt][Be] = Ke, Ke;
            }, clearDataForStream: function(be) {
              V && V.clearForStream(be), y[be] && delete y[be], oe[be] && delete oe[be], w[be] && delete w[be];
            }, getThroughputHistory: function() {
              return ce;
            }, getBitrateList: tt, getQualityForBitrate: et, getTopBitrateInfoFor: function(be) {
              var Be = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
              if (Be || (Be = _.getActiveStreamInfo().id), be && y && y[Be] && y[Be][be]) {
                var mt = Le(be, Be), Ke = tt(y[Be][be].getMediaInfo());
                return Ke[mt] ? Ke[mt] : null;
              }
              return null;
            }, getMinAllowedIndexFor: Ie, getMaxAllowedIndexFor: Le, getInitialBitrateFor: function(be, Be) {
              if (function() {
                if (!ge || !ge.hasOwnProperty("getSavedBitrateSettings")) throw new Error(t.Z.MISSING_CONFIG_ERROR);
              }(), be === t.Z.TEXT) return NaN;
              var mt = ge.getSavedBitrateSettings(be), Ke = fe.getAbrBitrateParameter("initialBitrate", be), vt = A.get().streaming.abr.initialRepresentationRatio[be];
              if (Ke === -1) if (vt > -1) {
                var Et = y[Be][be].getStreamInfo(), gt = U.getAdaptationForType(Et.index, be, Et).Representation_asArray;
                Ke = Array.isArray(gt) ? gt[Math.max(Math.round(gt.length * vt) - 1, 0)].bandwidth / 1e3 : 0;
              } else Ke = isNaN(mt) ? be === t.Z.VIDEO ? 1e3 : 100 : mt;
              return Ke;
            }, getQualityFor: xe, getAbandonmentStateFor: function(be, Be) {
              return w[be] && w[be][Be] ? w[be][Be].state : null;
            }, setPlaybackQuality: De, checkPlaybackQuality: function(be, Be) {
              try {
                if (!(be && y && y[Be] && y[Be][be])) return !1;
                if (V) {
                  var mt = Z.getPlaybackQuality();
                  mt && V.push(Be, q, mt);
                }
                if (!A.get().streaming.abr.autoSwitchBitrate[be]) return !1;
                var Ke = xe(be, Be), vt = jo(ne).create({ abrController: i, switchHistory: oe[Be][be], droppedFramesHistory: V, streamProcessor: y[Be][be], currentValue: Ke, useBufferOccupancyABR: g[be], useL2AABR: P[be], useLoLPABR: D[be], videoModel: Z }), Et = Ie(be, Be), gt = Le(be, Be), Wt = l.getMaxQuality(vt), zt = Wt.quality;
                return Et !== void 0 && (zt > zi.Z.NO_CHANGE ? zt : Ke) < Et && (zt = Et), zt > gt && (zt = gt), oe[Be][be].push({ oldValue: Ke, newValue: zt }), zt > zi.Z.NO_CHANGE && zt !== Ke && (w[Be][be].state === p.Z.ALLOW_LOAD || zt < Ke) && (st(be, Ke, zt, gt, Wt.reason, Be), !0);
              } catch {
                return !1;
              }
            }, setElementSize: Ut, setWindowResizeEventCalled: function(be) {
              H = be;
            }, registerStreamType: function(be, Be) {
              var mt = Be.getStreamInfo().id;
              y[mt] || (y[mt] = {}), oe[mt] || (oe[mt] = {}), w[mt] || (w[mt] = {}), oe[mt][be] = Qu(ne).create(), y[mt][be] = Be, w[mt][be] = {}, w[mt][be].state = p.Z.ALLOW_LOAD, function(Ke) {
                var vt = A.get().streaming.abr.ABRStrategy;
                vt === t.Z.ABR_STRATEGY_L2A ? (g[Ke] = !1, D[Ke] = !1, P[Ke] = !0) : vt === t.Z.ABR_STRATEGY_LoLP ? (g[Ke] = !1, D[Ke] = !0, P[Ke] = !1) : vt === t.Z.ABR_STRATEGY_BOLA ? (g[Ke] = !0, D[Ke] = !1, P[Ke] = !1) : vt === t.Z.ABR_STRATEGY_THROUGHPUT ? (g[Ke] = !1, D[Ke] = !1, P[Ke] = !1) : vt === t.Z.ABR_STRATEGY_DYNAMIC && (g[Ke] = !(!g || !g[Ke]) && g[Ke], D[Ke] = !1, P[Ke] = !1);
              }(be), be === t.Z.VIDEO && Ut();
            }, unRegisterStreamType: function(be, Be) {
              try {
                y[be] && y[be][Be] && delete y[be][Be], oe[be] && oe[be][Be] && delete oe[be][Be], w[be] && w[be][Be] && delete w[be][Be];
              } catch {
              }
            }, setConfig: function(be) {
              be && (be.streamController && (_ = be.streamController), be.domStorage && (ge = be.domStorage), be.mediaPlayerModel && (fe = be.mediaPlayerModel), be.customParametersModel && (te = be.customParametersModel), be.cmsdModel && (le = be.cmsdModel), be.dashMetrics && (O = be.dashMetrics), be.adapter && (U = be.adapter), be.videoModel && (Z = be.videoModel), be.settings && (A = be.settings));
            }, reset: function() {
              X(), se.off(o.Z.LOADING_PROGRESS, k, i), se.off(n.Z.QUALITY_CHANGE_RENDERED, J, i), se.off(n.Z.METRIC_ADDED, pe, i), l && l.reset();
            } }, r = z.getLogger(i), X(), i;
          }
          xa.__dashjs_factory_name = "AbrController";
          var Fa = E.Z.getSingletonFactory(xa);
          Fa.QUALITY_DEFAULT = 0, E.Z.updateSingletonFactory(xa.__dashjs_factory_name, Fa);
          var Ju = Fa, el = /* @__PURE__ */ new Map([[t.Z.VIDEO_ELEMENT_READY_STATES.HAVE_METADATA, "loadedmetadata"], [t.Z.VIDEO_ELEMENT_READY_STATES.HAVE_CURRENT_DATA, "loadeddata"], [t.Z.VIDEO_ELEMENT_READY_STATES.HAVE_FUTURE_DATA, "canplay"], [t.Z.VIDEO_ELEMENT_READY_STATES.HAVE_ENOUGH_DATA, "canplaythrough"]]);
          function Wo() {
            var i, r, l, _, R, I, y, w, F = this.context, H = (0, m.Z)(F).getInstance(), G = [];
            function N() {
              l && (l.playbackRate = 1, l.removeEventListener("canplay", N));
            }
            function U() {
              return G.length > 0;
            }
            function Z() {
              if (l && U() && l.playbackRate === 0) {
                var V = document.createEvent("Event");
                V.initEvent("waiting", !0, !1), l.dispatchEvent(V);
              }
            }
            function fe(V, ce) {
              l && l.addEventListener(V, ce);
            }
            function te(V, ce) {
              l && l.removeEventListener(V, ce);
            }
            function le() {
              return l ? l.readyState : NaN;
            }
            function ge() {
              return l ? l.buffered : null;
            }
            function q(V, ce, g, P, D) {
              if (l) {
                for (var O = 0; O < l.textTracks.length; O++) if (l.textTracks[O].kind === V && (!ce || l.textTracks[O].label == ce) && l.textTracks[O].language === g && l.textTracks[O].isTTML === P && l.textTracks[O].isEmbedded === D) return l.textTracks[O];
              }
              return null;
            }
            function oe(V, ce) {
              return V === t.Z.VIDEO_ELEMENT_READY_STATES.HAVE_NOTHING || le() >= V ? (ce(), null) : function(g, P) {
                var D = function O() {
                  te(g, O), P(g);
                };
                return fe(g, D), { func: D, event: g };
              }(el.get(V), ce);
            }
            return i = { addEventListener: fe, addTextTrack: function(V, ce, g, P, D) {
              if (!l) return null;
              var O = q(V, ce, g, P, D);
              return O || ((O = l.addTextTrack(V, ce, g)).isEmbedded = D, O.isTTML = P), O;
            }, appendChild: function(V) {
              l && (l.appendChild(V), V.isTTML !== void 0 && (l.textTracks[l.textTracks.length - 1].isTTML = V.isTTML, l.textTracks[l.textTracks.length - 1].isEmbedded = V.isEmbedded));
            }, getBufferRange: ge, getClientHeight: function() {
              return l ? l.clientHeight : NaN;
            }, getClientWidth: function() {
              return l ? l.clientWidth : NaN;
            }, getElement: function() {
              return l;
            }, getEnded: function() {
              return l ? l.ended : null;
            }, getPlaybackQuality: function() {
              if (!l) return null;
              var V = "webkitDroppedFrameCount" in l && "webkitDecodedFrameCount" in l, ce = null;
              return "getVideoPlaybackQuality" in l ? ce = l.getVideoPlaybackQuality() : V && (ce = { droppedVideoFrames: l.webkitDroppedFrameCount, totalVideoFrames: l.webkitDroppedFrameCount + l.webkitDecodedFrameCount, creationTime: /* @__PURE__ */ new Date() }), ce;
            }, getPlaybackRate: function() {
              return l ? l.playbackRate : null;
            }, getPlayedRanges: function() {
              return l ? l.played : null;
            }, getReadyState: le, getSource: function() {
              return l ? l.src : null;
            }, getTTMLRenderingDiv: function() {
              return I;
            }, getTextTrack: q, getTextTracks: function() {
              return l ? l.textTracks : [];
            }, getTime: function() {
              return l ? isNaN(_) ? l.currentTime : _ : null;
            }, getVideoHeight: function() {
              return l ? l.videoHeight : NaN;
            }, getVideoRelativeOffsetLeft: function() {
              if (l) {
                var V = l.parentNode.host || l.parentNode;
                return V ? l.getBoundingClientRect().left - V.getBoundingClientRect().left : NaN;
              }
              return NaN;
            }, getVideoRelativeOffsetTop: function() {
              if (l) {
                var V = l.parentNode.host || l.parentNode;
                return V ? l.getBoundingClientRect().top - V.getBoundingClientRect().top : NaN;
              }
              return NaN;
            }, getVideoWidth: function() {
              return l ? l.videoWidth : NaN;
            }, getVttRenderingDiv: function() {
              return y;
            }, initialize: function() {
              H.on(o.Z.PLAYBACK_PLAYING, Z, this);
            }, isPaused: function() {
              return l ? l.paused : null;
            }, isSeeking: function() {
              return l ? l.seeking || !isNaN(_) : null;
            }, isStalled: U, pause: function() {
              l && (l.pause(), l.autoplay = !1);
            }, play: function() {
              if (l) {
                l.autoplay = !0;
                var V = l.play();
                V && V.catch && typeof Promise < "u" && V.catch(function(ce) {
                  ce.name === "NotAllowedError" && H.trigger(o.Z.PLAYBACK_NOT_ALLOWED), r.warn("Caught pending play exception - continuing (".concat(ce, ")"));
                });
              }
            }, removeChild: function(V) {
              l && l.removeChild(V);
            }, removeEventListener: te, reset: function() {
              clearTimeout(w), H.off(o.Z.PLAYBACK_PLAYING, Z, this);
            }, setCurrentTime: function(V, ce) {
              l && (R && R.func && R.event && te(R.event, R.func), _ = V, R = oe(t.Z.VIDEO_ELEMENT_READY_STATES.HAVE_METADATA, function() {
                if (l) if (l.currentTime !== _) try {
                  _ = ce ? function(g) {
                    var P = ge(), D = g, O = 9999999999;
                    if (P) for (var A = 0; A < P.length; A++) {
                      var ne = P.start(A), z = P.end(A), se = Math.abs(ne - g), X = Math.abs(z - g);
                      if (g >= ne && g <= z) return g;
                      se < O && (O = se, D = ne), X < O && (O = X, D = z);
                    }
                    return D;
                  }(_) : _, isNaN(_) || (l.currentTime = _), _ = NaN;
                } catch (g) {
                  l.readyState === 0 && g.code === g.INVALID_STATE_ERR && (w = setTimeout(function() {
                    l.currentTime = _, _ = NaN;
                  }, 400));
                }
                else _ = NaN;
              }));
            }, setElement: function(V) {
              if (!(V == null || V && /^(VIDEO|AUDIO)$/i.test(V.nodeName))) throw "element is not video or audio DOM type!";
              (l = V) && (l.preload = "auto");
            }, setPlaybackRate: function(V) {
              var ce = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
              l && (!ce && l.readyState <= 2 && V > 0 ? l.addEventListener("canplay", N) : l.playbackRate = V);
            }, setSource: function(V) {
              l && (V ? l.src = V : (l.removeAttribute("src"), l.load()));
            }, setStallState: function(V, ce) {
              (function(g, P) {
                P ? function(D) {
                  D !== null && l && !l.seeking && G.indexOf(D) === -1 && G.push(D);
                }(g) : function(D) {
                  var O = G.indexOf(D);
                  D !== null && O !== -1 && G.splice(O, 1);
                }(g);
              })(V, ce);
            }, setTTMLRenderingDiv: function(V) {
              (I = V).style.position = "absolute", I.style.display = "flex", I.style.overflow = "hidden", I.style.pointerEvents = "none", I.style.top = 0, I.style.left = 0;
            }, setVttRenderingDiv: function(V) {
              y = V;
            }, waitForReadyState: oe, setDisableRemotePlayback: function(V) {
              l && (l.disableRemotePlayback = V);
            } }, r = (0, h.Z)(F).getInstance().getLogger(i), _ = NaN, i;
          }
          Wo.__dashjs_factory_name = "VideoModel";
          var tl = E.Z.getSingletonFactory(Wo), nl = [{ oldKey: "dashjs_vbitrate", newKey: "dashjs_video_bitrate" }, { oldKey: "dashjs_abitrate", newKey: "dashjs_audio_bitrate" }, { oldKey: "dashjs_vsettings", newKey: "dashjs_video_settings" }, { oldKey: "dashjs_asettings", newKey: "dashjs_audio_settings" }], Qo = "dashjs_?_bitrate", Xo = "dashjs_?_settings", ci = "localStorage", $o = "lastBitrate", Jo = "lastMediaSettings";
          function es(i) {
            i = i || {};
            var r, l, _, R = this.context, I = i.settings;
            function y(G) {
              if (_ !== void 0) return _;
              var N;
              _ = !1;
              try {
                typeof window < "u" && (N = window[G]);
              } catch (U) {
                return l.warn("DOMStorage access denied: " + U.message), _;
              }
              if (!N || G !== ci) return _;
              try {
                N.setItem("1", "1"), N.removeItem("1"), _ = !0;
              } catch (U) {
                l.warn("DOMStorage is supported, but cannot be used: " + U.message);
              }
              return _;
            }
            function w() {
              var G = 6e5;
              return Math.round((/* @__PURE__ */ new Date()).getTime() / G) * G;
            }
            function F(G, N) {
              return y(G) && I.get().streaming[N + "CachingInfo"].enabled;
            }
            function H() {
              if (!I) throw new Error(t.Z.MISSING_CONFIG_ERROR);
            }
            return r = { getSavedBitrateSettings: function(G) {
              if (H(), !I.get().streaming.lastBitrateCachingInfo.enabled) return NaN;
              var N = NaN;
              if (F(ci, $o)) {
                var U = Qo.replace(/\?/, G);
                try {
                  var Z = JSON.parse(localStorage.getItem(U)) || {}, fe = (/* @__PURE__ */ new Date()).getTime() - parseInt(Z.timestamp, 10) >= I.get().streaming.lastBitrateCachingInfo.ttl || !1, te = parseFloat(Z.bitrate);
                  isNaN(te) || fe ? fe && localStorage.removeItem(U) : (N = te, l.debug("Last saved bitrate for " + G + " was " + te));
                } catch {
                  return null;
                }
              }
              return N;
            }, setSavedBitrateSettings: function(G, N) {
              if (F(ci, $o) && N) {
                var U = Qo.replace(/\?/, G);
                try {
                  localStorage.setItem(U, JSON.stringify({ bitrate: N.toFixed(3), timestamp: w() }));
                } catch (Z) {
                  l.error(Z.message);
                }
              }
            }, getSavedMediaSettings: function(G) {
              if (H(), !I.get().streaming.lastMediaSettingsCachingInfo.enabled) return null;
              var N = null;
              if (F(ci, Jo)) {
                var U = Xo.replace(/\?/, G);
                try {
                  var Z = JSON.parse(localStorage.getItem(U)) || {}, fe = (/* @__PURE__ */ new Date()).getTime() - parseInt(Z.timestamp, 10) >= I.get().streaming.lastMediaSettingsCachingInfo.ttl || !1;
                  N = Z.settings, fe && (localStorage.removeItem(U), N = null);
                } catch {
                  return null;
                }
              }
              return N;
            }, setSavedMediaSettings: function(G, N) {
              if (F(ci, Jo)) {
                var U = Xo.replace(/\?/, G);
                try {
                  localStorage.setItem(U, JSON.stringify({ settings: N, timestamp: w() }));
                } catch (Z) {
                  l.error(Z.message);
                }
              }
            } }, l = (0, h.Z)(R).getInstance().getLogger(r), y(ci) && nl.forEach(function(G) {
              var N = localStorage.getItem(G.oldKey);
              if (N) {
                localStorage.removeItem(G.oldKey);
                try {
                  localStorage.setItem(G.newKey, N);
                } catch (U) {
                  l.error(U.message);
                }
              }
            }), r;
          }
          es.__dashjs_factory_name = "DOMStorage";
          var rl = E.Z.getSingletonFactory(es), il = C(2032), ts = C(2011);
          function ns() {
            var i, r, l, _, R, I, y, w, F, H, G, N, U, Z = this.context;
            function fe(q, oe, V, ce) {
              var g = null, P = q ? U.resolve(q.path) : null, D = ce || { init: !0, url: P ? P.url : void 0, range: { start: 0, end: 1500 }, searching: !1, bytesLoaded: 0, bytesToLoad: 1500, mediaType: oe };
              r.debug("Start searching for initialization.");
              var O = ge(D);
              w.load({ request: O, success: function(A) {
                if (D.bytesLoaded = D.range.end, !(g = _.findInitRange(A))) return D.range.end = D.bytesLoaded + D.bytesToLoad, fe(q, oe, V, D);
                q.range = g, V(q);
              }, error: function() {
                V(q);
              } }), r.debug("Perform init search: " + D.url);
            }
            function te(q, oe, V, ce, g, P) {
              if (V && (V.start === void 0 || V.end === void 0)) {
                var D = V ? V.toString().split("-") : null;
                V = D ? { start: parseFloat(D[0]), end: parseFloat(D[1]) } : null;
              }
              g = g || le;
              var O = null, A = null, ne = !!V, z = q ? U.resolve(q.path) : null, se = { init: !1, url: z ? z.url : void 0, range: ne ? V : { start: 0, end: 1500 }, searching: !ne, bytesLoaded: P ? P.bytesLoaded : 0, bytesToLoad: 1500, mediaType: oe }, X = ge(se);
              w.load({ request: X, success: function(k) {
                var J = se.bytesToLoad, pe = k.byteLength;
                if (se.bytesLoaded = se.range.end - se.range.start, O = _.parse(k), (A = O.getBox("sidx")) && A.isComplete) {
                  var Le, Ie, xe = A.references;
                  if (xe != null && xe.length > 0 && (Le = xe[0].reference_type === 1), Le) {
                    var De, st, ut, et;
                    r.debug("Initiate multiple SIDX load."), se.range.end = se.range.start + A.size;
                    var tt = [], Ut = 0, be = (A.offset || se.range.start) + A.size, Be = function(Ke) {
                      Ke ? (tt = tt.concat(Ke), ++Ut >= st && (tt.sort(function(vt, Et) {
                        return vt.startTime - Et.startTime < 0 ? -1 : 0;
                      }), g(tt, q, ce))) : g(null, q, ce);
                    };
                    for (De = 0, st = xe.length; De < st; De++) ut = be, et = be + xe[De].referenced_size - 1, be += xe[De].referenced_size, te(q, oe, { start: ut, end: et }, ce, Be, se);
                  } else r.debug("Parsing segments from SIDX. representation " + oe + " - id: " + q.id + " for range : " + se.range.start + " - " + se.range.end), Ie = function(Ke, vt) {
                    for (var Et, gt, Wt, zt, gn = Ke.references, pn = gn.length, je = Ke.timescale, yt = Ke.earliest_presentation_time, ot = vt.range.start + Ke.offset + Ke.first_offset + Ke.size, It = [], Lt = 0; Lt < pn; Lt++) Wt = gn[Lt].subsegment_duration, zt = gn[Lt].referenced_size, (Et = new ts.Z()).duration = Wt, Et.startTime = yt, Et.timescale = je, gt = ot + zt - 1, Et.mediaRange = ot + "-" + gt, It.push(Et), yt += Wt, ot += zt;
                    return It;
                  }(A, se), g(Ie, q, ce);
                } else {
                  if (A) se.range.start = A.offset || se.range.start, se.range.end = se.range.start + (A.size || J);
                  else {
                    if (pe < se.bytesLoaded) return void g(null, q, ce);
                    var mt = O.getLastBox();
                    mt && mt.size ? (se.range.start = mt.offset + mt.size, se.range.end = se.range.start + J) : se.range.end += J;
                  }
                  te(q, oe, se.range, ce, null, se);
                }
              }, error: function() {
                g(null, q, ce);
              } }), r.debug("Perform SIDX load for type ".concat(oe, " : ").concat(se.url, " with range ").concat(se.range.start, " - ").concat(se.range.end));
            }
            function le(q, oe, V) {
              V({ segments: q, representation: oe, error: q ? void 0 : new ae.Z(F.SEGMENT_BASE_LOADER_ERROR_CODE, F.SEGMENT_BASE_LOADER_ERROR_MESSAGE) });
            }
            function ge(q) {
              if (q.url) {
                var oe = new S.Z();
                return oe.setInfo(q), oe;
              }
            }
            return i = { setConfig: function(q) {
              q.baseURLController && (U = q.baseURLController), q.dashMetrics && (I = q.dashMetrics), q.mediaPlayerModel && (y = q.mediaPlayerModel), q.errHandler && (l = q.errHandler), q.boxParser && (_ = q.boxParser), q.debug && (r = q.debug.getLogger(i)), q.requestModifier && (R = q.requestModifier), q.errors && (F = q.errors), q.urlUtils && (N = q.urlUtils), q.constants && (H = q.constants), q.dashConstants && (G = q.dashConstants);
            }, initialize: function() {
              w = sr(Z).create({ errHandler: l, dashMetrics: I, mediaPlayerModel: y, requestModifier: R, boxParser: _, errors: F, urlUtils: N, constants: H, dashConstants: G });
            }, loadInitialization: function(q, oe) {
              return new Promise(function(V) {
                fe(q, oe, V);
              });
            }, loadSegments: function(q, oe, V) {
              return new Promise(function(ce) {
                te(q, oe, V, ce);
              });
            }, reset: function() {
              w && (w.abort(), w = null);
            } };
          }
          ns.__dashjs_factory_name = "SegmentBaseLoader";
          var al = E.Z.getSingletonFactory(ns);
          function rs(i) {
            var r;
            i = i || {};
            var l = new DataView(i.data), _ = 0;
            function R(y, w) {
              var F = !0, H = 0;
              if (w === void 0 && (w = !1), y.tag > 16777215 ? (l.getUint32(_) !== y.tag && (F = !1), H = 4) : y.tag > 65535 ? (256 * l.getUint16(_) + l.getUint8(_ + 2) !== y.tag && (F = !1), H = 3) : y.tag > 255 ? (l.getUint16(_) !== y.tag && (F = !1), H = 2) : (l.getUint8(_) !== y.tag && (F = !1), H = 1), !F && y.required && !w) throw new Error("required tag not found");
              return F && (_ += H), F;
            }
            function I(y) {
              var w = 1, F = 128, H = -1, G = 0, N = l.getUint8(_), U = 0;
              for (U = 0; U < 8; U += 1) {
                if ((N & F) === F) {
                  G = y === void 0 ? N & ~F : N, H = U;
                  break;
                }
                F >>= 1;
              }
              for (U = 0; U < H; U += 1, w += 1) G = G << 8 | 255 & l.getUint8(_ + w);
              return _ += w, G;
            }
            return r = { getPos: function() {
              return _;
            }, setPos: function(y) {
              _ = y;
            }, consumeTag: R, consumeTagAndSize: function(y, w) {
              var F = R(y, w);
              return F && I(), F;
            }, parseTag: function(y) {
              var w;
              return R(y), w = I(), r[y.parse](w);
            }, skipOverElement: function(y, w) {
              var F, H = R(y, w);
              return H && (F = I(), _ += F), H;
            }, getMatroskaCodedNum: I, getMatroskaFloat: function(y) {
              var w;
              switch (y) {
                case 4:
                  w = l.getFloat32(_), _ += 4;
                  break;
                case 8:
                  w = l.getFloat64(_), _ += 8;
              }
              return w;
            }, getMatroskaUint: function(y) {
              if (y > 4) return function(H) {
                for (var G = Math.floor(Number.MAX_SAFE_INTEGER / 256), N = 0, U = 0; U < H; U += 1) {
                  if (N > G) throw new Error("Value exceeds safe integer limit");
                  N *= 256;
                  var Z = l.getUint8(_ + U);
                  if (N > Number.MAX_SAFE_INTEGER - Z) throw new Error("Value exceeds safe integer limit");
                  N += Z;
                }
                return _ += H, N;
              }(y);
              for (var w = 0, F = 0; F < y; F += 1) w <<= 8, w |= 255 & l.getUint8(_ + F);
              return _ += y, w >>> 0;
            }, moreData: function() {
              return _ < l.byteLength;
            } };
          }
          rs.__dashjs_factory_name = "EBMLParser";
          var is = E.Z.getClassFactory(rs);
          function as() {
            var i, r, l, _, R, I, y, w, F, H, G = this.context;
            function N(U) {
              var Z = new S.Z();
              return Z.setInfo(U), Z;
            }
            return i = { setConfig: function(U) {
              if (!(U.baseURLController && U.dashMetrics && U.mediaPlayerModel && U.errHandler)) throw new Error(t.Z.MISSING_CONFIG_ERROR);
              H = U.baseURLController, I = U.dashMetrics, y = U.mediaPlayerModel, _ = U.errHandler, F = U.errors, r = U.debug.getLogger(i), R = U.requestModifier;
            }, initialize: function() {
              w = sr(G).create({ errHandler: _, dashMetrics: I, mediaPlayerModel: y, requestModifier: R, errors: F });
            }, loadInitialization: function(U, Z) {
              return new Promise(function(fe) {
                var te = null, le = U ? H.resolve(U.path) : null, ge = U ? U.range.split("-") : null, q = { range: { start: ge ? parseFloat(ge[0]) : null, end: ge ? parseFloat(ge[1]) : null }, request: te, url: le ? le.url : void 0, init: !0, mediaType: Z };
                r.info("Start loading initialization."), te = N(q), w.load({ request: te, success: function() {
                  fe(U);
                }, error: function() {
                  fe(U);
                } }), r.debug("Perform init load: " + q.url);
              });
            }, loadSegments: function(U, Z, fe) {
              return new Promise(function(te) {
                var le = null, ge = U ? H.resolve(U.path) : null, q = ge ? ge.url : void 0;
                le = N({ bytesLoaded: 0, bytesToLoad: 8192, range: { start: 0, end: 8192 }, request: le, url: q, init: !1, mediaType: Z }), r.debug("Parsing ebml header"), w.load({ request: le, success: function(oe) {
                  (function(V, ce, g, P) {
                    if (V && V.byteLength !== 0) {
                      var D, O, A, ne, z = is(G).create({ data: V }), se = g ? g.split("-") : null, X = null, k = { url: ce, range: { start: se ? parseFloat(se[0]) : null, end: se ? parseFloat(se[1]) : null }, request: X };
                      for (r.debug("Parse EBML header: " + k.url), z.skipOverElement(l.EBML), z.consumeTag(l.Segment), A = z.getMatroskaCodedNum(), A += z.getPos(), ne = z.getPos(); z.moreData() && !z.consumeTagAndSize(l.Segment.Info, !0); ) if (!(z.skipOverElement(l.Segment.SeekHead, !0) || z.skipOverElement(l.Segment.Tracks, !0) || z.skipOverElement(l.Segment.Cues, !0) || z.skipOverElement(l.Void, !0))) throw new Error("no valid top level element found");
                      for (; D === void 0; ) {
                        var J = z.getMatroskaCodedNum(!0), pe = z.getMatroskaCodedNum();
                        J === l.Segment.Info.Duration.tag ? D = z[l.Segment.Info.Duration.parse](pe) : z.setPos(z.getPos() + pe);
                      }
                      X = N(k), w.load({ request: X, success: function(Le) {
                        O = function(Ie, xe, De, st) {
                          var ut, et, tt, Ut, be, Be, mt, Ke;
                          for (tt = [], be = 0, Be = (et = function(vt) {
                            var Et, gt, Wt = [], zt = is(G).create({ data: vt });
                            for (zt.consumeTagAndSize(l.Segment.Cues); zt.moreData() && zt.consumeTagAndSize(l.Segment.Cues.CuePoint, !0); ) {
                              for ((Et = {}).CueTime = zt.parseTag(l.Segment.Cues.CuePoint.CueTime), Et.CueTracks = []; zt.moreData() && zt.consumeTag(l.Segment.Cues.CuePoint.CueTrackPositions, !0); ) {
                                var gn = zt.getMatroskaCodedNum(), pn = zt.getPos();
                                if ((gt = {}).Track = zt.parseTag(l.Segment.Cues.CuePoint.CueTrackPositions.CueTrack), gt.Track === 0) throw new Error("Cue track cannot be 0");
                                gt.ClusterPosition = zt.parseTag(l.Segment.Cues.CuePoint.CueTrackPositions.CueClusterPosition), Et.CueTracks.push(gt), zt.setPos(pn + gn);
                              }
                              if (Et.CueTracks.length === 0) throw new Error("Mandatory cuetrack not found");
                              Wt.push(Et);
                            }
                            if (Wt.length === 0) throw new Error("mandatory cuepoint not found");
                            return Wt;
                          }(Ie)).length; be < Be; be += 1) Ut = new ts.Z(), ut = be < et.length - 1 ? et[be + 1].CueTime - et[be].CueTime : st - et[be].CueTime, Ut.duration = ut, Ut.startTime = et[be].CueTime, Ut.timescale = 1e3, mt = et[be].CueTracks[0].ClusterPosition + xe, Ke = be < et.length - 1 ? et[be + 1].CueTracks[0].ClusterPosition + xe - 1 : De - 1, Ut.mediaRange = mt + "-" + Ke, tt.push(Ut);
                          return r.debug("Parsed cues: " + tt.length + " cues."), tt;
                        }(Le, ne, A, D), P(O);
                      }, error: function() {
                        r.error("Download Error: Cues " + k.url), P(null);
                      } }), r.debug("Perform cues load: " + k.url + " bytes=" + k.range.start + "-" + k.range.end);
                    } else P(null);
                  })(oe, q, fe, function(V) {
                    te({ segments: V, representation: U, error: V ? void 0 : new ae.Z(F.SEGMENT_BASE_LOADER_ERROR_CODE, F.SEGMENT_BASE_LOADER_ERROR_MESSAGE) });
                  });
                }, error: function() {
                  te({ representation: U, error: new ae.Z(F.SEGMENT_BASE_LOADER_ERROR_CODE, F.SEGMENT_BASE_LOADER_ERROR_MESSAGE) });
                } });
              });
            }, reset: function() {
              w && (w.abort(), w = null);
            } }, l = { EBML: { tag: 440786851, required: !0 }, Segment: { tag: 408125543, required: !0, SeekHead: { tag: 290298740, required: !0 }, Info: { tag: 357149030, required: !0, TimecodeScale: { tag: 2807729, required: !0, parse: "getMatroskaUint" }, Duration: { tag: 17545, required: !0, parse: "getMatroskaFloat" } }, Tracks: { tag: 374648427, required: !0 }, Cues: { tag: 475249515, required: !0, CuePoint: { tag: 187, required: !0, CueTime: { tag: 179, required: !0, parse: "getMatroskaUint" }, CueTrackPositions: { tag: 183, required: !0, CueTrack: { tag: 247, required: !0, parse: "getMatroskaUint" }, CueClusterPosition: { tag: 241, required: !0, parse: "getMatroskaUint" } } } } }, Void: { tag: 236, required: !0 } }, i;
          }
          as.__dashjs_factory_name = "WebmSegmentBaseLoader";
          var ol = E.Z.getSingletonFactory(as);
          function os(i) {
            i = i || {};
            var r, l, _, R = this.context, I = i.eventBus, y = i.events, w = i.dashMetrics, F = i.mediaPlayerModel, H = i.errHandler, G = i.baseURLController, N = i.debug, U = i.boxParser, Z = i.requestModifier, fe = i.errors;
            function te(le) {
              return (le ? le.split("/")[1] : "").toLowerCase() === "webm";
            }
            return r = { initialize: function() {
              l.initialize(), _.initialize();
            }, getSegmentBaseInitSegment: function(le) {
              return te(le.representation.mimeType) ? _.loadInitialization(le.representation, le.mediaType) : l.loadInitialization(le.representation, le.mediaType);
            }, getSegmentList: function(le) {
              return te(le.mimeType) ? _.loadSegments(le.representation, le.mediaType, le.representation ? le.representation.indexRange : null) : l.loadSegments(le.representation, le.mediaType, le.representation ? le.representation.indexRange : null);
            }, reset: function() {
              l.reset(), _.reset();
            } }, l = al(R).getInstance(), _ = ol(R).getInstance(), l.setConfig({ baseURLController: G, dashMetrics: w, mediaPlayerModel: F, errHandler: H, eventBus: I, events: y, errors: fe, debug: N, boxParser: U, requestModifier: Z }), _.setConfig({ baseURLController: G, dashMetrics: w, mediaPlayerModel: F, errHandler: H, eventBus: I, events: y, errors: fe, debug: N, requestModifier: Z }), r;
          }
          os.__dashjs_factory_name = "SegmentBaseController";
          var sl = E.Z.getSingletonFactory(os), ss = function i() {
            (function(r, l) {
              if (!(r instanceof l)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.id = null, this.quality = null, this.fragmentDuration = null, this.mediaInfo = null, this.MSETimeOffset = null;
          }, ka = function i() {
            (function(r, l) {
              if (!(r instanceof l)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.id = null, this.index = null, this.type = null, this.streamInfo = null, this.representationCount = 0, this.labels = null, this.lang = null, this.viewpoint = null, this.viewpointsWithSchemeIdUri = null, this.accessibility = null, this.accessibilitiesWithSchemeIdUri = null, this.audioChannelConfiguration = null, this.audioChannelConfigurationsWithSchemeIdUri = null, this.roles = null, this.rolesWithSchemeIdUri = null, this.codec = null, this.mimeType = null, this.contentProtection = null, this.isText = !1, this.KID = null, this.bitrateList = null, this.isFragmented = null, this.isEmbedded = null, this.selectionPriority = 1, this.supplementalProperties = {}, this.supplementalPropertiesAsArray = [], this.essentialProperties = {}, this.essentialPropertiesAsArray = [], this.segmentAlignment = !1, this.subSegmentAlignment = !1;
          }, us = function i() {
            (function(r, l) {
              if (!(r instanceof l)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.id = null, this.index = null, this.start = NaN, this.duration = NaN, this.manifestInfo = null, this.isLast = !0;
          }, ul = function i() {
            (function(r, l) {
              if (!(r instanceof l)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.dvrWindowSize = NaN, this.loadedTime = null, this.availableFrom = null, this.minBufferTime = NaN, this.duration = NaN, this.isDynamic = !1, this.maxFragmentDuration = null, this.serviceDescriptions = [], this.protocol = null;
          };
          function ll(i, r) {
            for (var l = 0; l < r.length; l++) {
              var _ = r[l];
              _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(i, _.key, _);
            }
          }
          var cl = function() {
            function i(_) {
              var R = this;
              (function(I, y) {
                if (!(I instanceof y)) throw new TypeError("Cannot call a class as a function");
              })(this, i), this.valid = _[0] == "/", this.path = _.split("/").filter(function(I) {
                return I.length !== 0;
              }).map(function(I) {
                var y = { name: I }, w = I.indexOf("[");
                if (w != -1) {
                  y.name = I.substring(0, w);
                  var F = I.substring(w + 1, I.length - 1);
                  R.valid = R.valid && F.indexOf("[") == -1;
                  var H = F.indexOf("=");
                  H != -1 ? (y.attribute = { name: F.substring(1, H), value: F.substring(H + 1) }, ["'", '"'].indexOf(y.attribute.value[0]) != -1 && (y.attribute.value = y.attribute.value.substring(1, y.attribute.value.length - 1))) : y.position = parseInt(F, 10) - 1;
                }
                return y;
              });
            }
            var r, l;
            return r = i, (l = [{ key: "isValid", value: function() {
              return this.valid;
            } }, { key: "findsElement", value: function() {
              return !this.findsAttribute();
            } }, { key: "findsAttribute", value: function() {
              return this.path[this.path.length - 1].name.startsWith("@");
            } }, { key: "findsTextReplace", value: function() {
              return this.path[this.path.length - 1].name === "text()";
            } }, { key: "getMpdTarget", value: function(_, R) {
              for (var I = null, y = _, w = 1, F = "MPD"; w < this.path.length && y !== null; ) {
                I = y;
                var H = this.path[w];
                if (F = H.name, w !== this.path.length - 1 || !F.startsWith("@") && F !== "text()") {
                  var G = I[F + "_asArray"] || [];
                  G.length === 0 && I[F] && G.push(I[F]), H.position ? y = G[H.position] || null : H.attribute ? function() {
                    var N = H.attribute;
                    y = G.filter(function(U) {
                      return U[N.name] == N.value;
                    })[0] || null;
                  }() : y = G[0] || null;
                }
                w++;
              }
              return y === null ? null : F.startsWith("@") ? { name: F.substring(1), leaf: y, target: y } : F === "text()" ? { name: "__text", leaf: y, target: y } : { name: F, leaf: y, target: R ? I : y };
            } }]) && ll(r.prototype, l), i;
          }();
          function fl(i, r) {
            for (var l = 0; l < r.length; l++) {
              var _ = r[l];
              _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(i, _.key, _);
            }
          }
          var dl = function() {
            function i(_, R, I) {
              (function(y, w) {
                if (!(y instanceof w)) throw new TypeError("Cannot call a class as a function");
              })(this, i), this.action = _, this.xpath = R, this.value = I, this.position = null;
            }
            var r, l;
            return r = i, (l = [{ key: "getMpdTarget", value: function(_) {
              var R = this.action === "remove" || this.action === "replace" || this.position === "before" || this.position === "after";
              return this.xpath.getMpdTarget(_, R);
            } }]) && fl(r.prototype, l), i;
          }();
          function ls() {
            var i, r, l = this.context;
            return i = { getIsPatch: function(_) {
              return _ && _.hasOwnProperty(e.Z.ORIGINAL_MPD_ID) || !1;
            }, getPublishTime: function(_) {
              return _ && _.hasOwnProperty(e.Z.PUBLISH_TIME) ? new Date(_[e.Z.PUBLISH_TIME]) : null;
            }, getOriginalPublishTime: function(_) {
              return _ && _.hasOwnProperty(e.Z.ORIGINAL_PUBLISH_TIME) ? new Date(_[e.Z.ORIGINAL_PUBLISH_TIME]) : null;
            }, getMpdId: function(_) {
              return _ && _[e.Z.ORIGINAL_MPD_ID] || null;
            }, getPatchOperations: function(_) {
              return _ ? (_.__children || []).map(function(R) {
                var I = Object.keys(R)[0];
                if (I !== "add" && I !== "remove" && I !== "replace") return r.warn("Ignoring node of invalid action: ".concat(I)), null;
                var y = R[I], w = y.sel;
                if (I === "add" && y.type) {
                  if (!y.type.startsWith("@")) return r.warn("Ignoring add action for prefixed namespace declaration: ".concat(y.type, "=").concat(y.__text)), null;
                  w = "".concat(w, "/").concat(y.type);
                }
                var F = new cl(w);
                if (!F.isValid()) return r.warn("Ignoring action with invalid selector: ".concat(I, " - ").concat(w)), null;
                var H = null;
                F.findsAttribute() || F.findsTextReplace() ? H = y.__text || "" : I !== "remove" && (H = y.__children.reduce(function(N, U) {
                  var Z = Object.keys(U)[0];
                  return Z !== "#text" && (N[Z] = N[Z] || [], N[Z].push(U[Z])), N;
                }, {}));
                var G = new dl(I, F, H);
                return I === "add" && (G.position = y.pos), G;
              }).filter(function(R) {
                return !!R;
              }) : [];
            } }, r = (0, h.Z)(l).getInstance().getLogger(i), i;
          }
          ls.__dashjs_factory_name = "PatchManifestModel";
          var gl = E.Z.getSingletonFactory(ls);
          function cs() {
            var i, r, l, _, R, I, y, w = this.context;
            function F(D, O, A) {
              var ne, z = r.getAdaptationsForType(_[0].mpd.manifest, D, O);
              if (!z || z.length === 0) return null;
              if (z.length > 1 && A) {
                var se = N(A, O);
                if (R[A.id] && R[A.id][O]) {
                  for (var X = 0, k = z.length; X < k; X++) if (H(R[A.id][O], se[X])) return z[X];
                }
                for (var J = 0, pe = z.length; J < pe; J++) if (ne = z[J], r.getRolesForAdaptation(ne).filter(function(Le) {
                  return Le.value === e.Z.MAIN;
                })[0]) return z[J];
              }
              return z[0];
            }
            function H(D, O) {
              if (!D || !O) return !1;
              var A = D.id === O.id, ne = D.codec === O.codec, z = D.viewpoint === O.viewpoint, se = JSON.stringify(D.viewpointsWithSchemeIdUri) === JSON.stringify(O.viewpointsWithSchemeIdUri), X = D.lang === O.lang, k = D.roles.toString() === O.roles.toString(), J = JSON.stringify(D.rolesWithSchemeIdUri) === JSON.stringify(O.rolesWithSchemeIdUri), pe = D.accessibility.toString() === O.accessibility.toString(), Le = JSON.stringify(D.accessibilitiesWithSchemeIdUri) === JSON.stringify(O.accessibilitiesWithSchemeIdUri), Ie = D.audioChannelConfiguration.toString() === O.audioChannelConfiguration.toString(), xe = JSON.stringify(D.audioChannelConfigurationsWithSchemeIdUri) === JSON.stringify(O.audioChannelConfigurationsWithSchemeIdUri);
              return A && ne && z && se && X && k && J && pe && Le && Ie && xe;
            }
            function G(D, O, A, ne, z, se) {
              var X, k, J, pe, Le, Ie, xe = [];
              if (!ne || ne.length === 0) return [];
              var De = r.getAdaptationsForPeriod(O);
              for (pe = 0, Ie = ne.length; pe < Ie; pe++) if (X = ne[pe], k = q(De[J = r.getIndexForAdaptation(X, D, A.index)]), se) {
                var st = k.accessibility.length;
                for (Le = 0; Le < st; Le++) if (k) {
                  var ut = k.accessibility[Le];
                  if (ut.indexOf("cea-608:") === 0) {
                    var et = ut.substring(8).split(";");
                    if (et[0].substring(0, 2) === "CC") for (Le = 0; Le < et.length; Le++) k || (k = q.call(this, De[J])), oe(k, et[Le].substring(0, 3), et[Le].substring(4)), xe.push(k), k = null;
                    else for (Le = 0; Le < et.length; Le++) k || (k = q.call(this, De[J])), oe(k, "CC" + (Le + 1), et[Le]), xe.push(k), k = null;
                  } else ut.indexOf("cea-608") === 0 && (oe(k, I.CC1, "eng"), xe.push(k), k = null);
                }
              } else z === I.IMAGE ? (k.type = I.IMAGE, xe.push(k), k = null) : k && xe.push(k);
              return xe;
            }
            function N(D, O, A) {
              var ne = _, z = A, se = [];
              if (z) ce(), ne = U(z);
              else {
                if (!(_.length > 0)) return se;
                z = _[0].mpd.manifest;
              }
              var X = ge(D, ne), k = r.getAdaptationsForType(z, D ? D.index : null, O);
              return se = G(z, X, D, k, O), O === I.TEXT && (k = r.getAdaptationsForType(z, D ? D.index : null, I.VIDEO), se = se.concat(G(z, X, D, k, O, !0))), se;
            }
            function U(D) {
              var O = Z(D);
              return r.getRegularPeriods(O);
            }
            function Z(D) {
              var O = te(D);
              return r.getMpd(O);
            }
            function fe() {
              _ = [], R = {};
            }
            function te(D) {
              return D || (_.length > 0 ? _[0].mpd.manifest : null);
            }
            function le(D) {
              try {
                var O = ge(D.streamInfo, _), A = r.getAdaptationsForPeriod(O);
                return D && D.streamInfo && D.streamInfo.id !== void 0 && A ? A[D.index] : null;
              } catch {
                return null;
              }
            }
            function ge(D, O) {
              for (var A = O.length, ne = 0; ne < A; ne++) {
                var z = O[ne];
                if (D && D.id === z.id) return z;
              }
              return null;
            }
            function q(D) {
              if (!D) return null;
              var O, A, ne, z, se, X = new ka(), k = D.period.mpd.manifest.Period_asArray[D.period.index].AdaptationSet_asArray[D.index];
              if (X.id = D.id, X.index = D.index, X.type = D.type, X.streamInfo = V(D.period), X.representationCount = r.getRepresentationCount(k), X.labels = r.getLabelsForAdaptation(k), X.lang = r.getLanguageForAdaptation(k), X.segmentAlignment = r.getSegmentAlignment(k), X.subSegmentAlignment = r.getSubSegmentAlignment(k), O = r.getViewpointForAdaptation(k), X.viewpoint = O.length ? O[0].value : void 0, X.viewpointsWithSchemeIdUri = O, se = r.getAccessibilityForAdaptation(k), X.accessibility = se.map(function(xe) {
                var De = xe.value, st = De;
                return xe.schemeIdUri && xe.schemeIdUri.search("cea-608") >= 0 && y !== void 0 && (st = De ? "cea-608:" + De : "cea-608", X.embeddedCaptions = !0), st;
              }), X.accessibilitiesWithSchemeIdUri = se, A = r.getAudioChannelConfigurationForAdaptation(k), X.audioChannelConfiguration = A.map(function(xe) {
                return xe.value;
              }), X.audioChannelConfigurationsWithSchemeIdUri = A, X.audioChannelConfiguration.length === 0 && Array.isArray(k.Representation_asArray) && k.Representation_asArray.length > 0 && (ne = r.getAudioChannelConfigurationForRepresentation(k.Representation_asArray[0]), X.audioChannelConfiguration = ne.map(function(xe) {
                return xe.value;
              }), X.audioChannelConfigurationsWithSchemeIdUri = ne), z = r.getRolesForAdaptation(k), X.roles = z.map(function(xe) {
                return xe.value;
              }), X.rolesWithSchemeIdUri = z, X.codec = r.getCodec(k), X.mimeType = r.getMimeType(k), X.contentProtection = r.getContentProtectionData(k), X.bitrateList = r.getBitrateListForAdaptation(k), X.selectionPriority = r.getSelectionPriority(k), X.contentProtection) {
                var J = X.contentProtection.map(function(xe) {
                  return r.getKID(xe);
                }).filter(function(xe) {
                  return xe !== null;
                });
                if (J.length) {
                  var pe = J[0];
                  X.contentProtection.forEach(function(xe) {
                    xe.keyId = pe;
                  });
                }
              }
              if (X.isText = r.getIsText(k), X.supplementalProperties = r.getSupplementalPropertiesForAdaptation(k), (!X.supplementalProperties || Object.keys(X.supplementalProperties).length === 0) && Array.isArray(k.Representation_asArray) && k.Representation_asArray.length > 0) {
                var Le = k.Representation_asArray.map(function(xe) {
                  return r.getSupplementalPropertiesForRepresentation(xe);
                });
                Le.every(function(xe) {
                  return JSON.stringify(xe) === JSON.stringify(Le[0]);
                }) && (X.supplementalProperties = Le[0]);
              }
              if (X.supplementalPropertiesAsArray = r.getSupplementalPropertiesAsArrayForAdaptation(k), (!X.supplementalPropertiesAsArray || X.supplementalPropertiesAsArray.length === 0) && Array.isArray(k.Representation_asArray) && k.Representation_asArray.length > 0) {
                var Ie = k.Representation_asArray.map(function(xe) {
                  return r.getSupplementalPropertiesAsArrayForRepresentation(xe);
                });
                Ie.every(function(xe) {
                  return JSON.stringify(xe) === JSON.stringify(Ie[0]);
                }) && (X.supplementalPropertiesAsArray = Ie[0]);
              }
              return X.essentialProperties = r.getEssentialPropertiesForAdaptation(k), X.essentialPropertiesAsArray = r.getEssentialPropertiesAsArrayForAdaptation(k), X.isFragmented = r.getIsFragmented(k), X.isEmbedded = !1, X;
            }
            function oe(D, O, A) {
              D.id = O, D.index = 100 + parseInt(O.substring(2, 3)), D.type = I.TEXT, D.codec = "cea-608-in-SEI", D.isEmbedded = !0, D.isFragmented = !1;
              var ne = Zi()(A);
              D.lang = ne || A, D.roles = ["caption"], D.rolesWithSchemeIdUri = [{ schemeIdUri: "urn:mpeg:dash:role:2011", value: "caption" }];
            }
            function V(D) {
              var O, A, ne = new us();
              return ne.id = D.id, ne.index = D.index, ne.start = D.start, ne.duration = D.duration, ne.manifestInfo = (O = D.mpd, (A = new ul()).dvrWindowSize = O.timeShiftBufferDepth, A.loadedTime = O.manifest.loadedTime, A.availableFrom = O.availabilityStartTime, A.minBufferTime = O.manifest.minBufferTime, A.maxFragmentDuration = O.maxSegmentDuration, A.duration = r.getDuration(O.manifest), A.isDynamic = r.getIsDynamic(O.manifest), A.serviceDescriptions = r.getServiceDescriptions(O.manifest), A.protocol = O.manifest.protocol, A), ne.isLast = D.mpd.manifest.Period_asArray.length === 1 || Math.abs(ne.start + ne.duration - ne.manifestInfo.duration) < 1, ne;
            }
            function ce() {
              if (!I) throw new Error("setConfig function has to be called previously");
            }
            function g(D) {
              return _.length > 0 ? _[0].mpd.manifest.Period_asArray[D] : null;
            }
            function P(D, O, A) {
              var ne, z, se, X, k;
              if (D) {
                for (ne = D.AdaptationSet_asArray, X = 0; X < ne.length; X += 1) for (se = ne[X].Representation_asArray, k = 0; k < se.length; k += 1) if (O === (z = se[k]).id) return A ? k : z;
              }
              return null;
            }
            return i = { getBandwidthForRepresentation: function(D, O) {
              var A;
              return (A = P(g(O), D)) ? A.bandwidth : null;
            }, getIndexForRepresentation: function(D, O) {
              return function(A, ne) {
                var z = P(A, ne, !0);
                return z !== null ? z : -1;
              }(g(O), D);
            }, getMaxIndexForBufferType: function(D, O) {
              return function(A, ne) {
                var z, se, X, k;
                if (!A || !ne) return -1;
                for (se = A.AdaptationSet_asArray, k = 0; k < se.length; k += 1) if (X = (z = se[k]).Representation_asArray, r.getIsTypeOf(z, ne)) return X.length;
                return -1;
              }(g(O), D);
            }, convertRepresentationToRepresentationInfo: function(D) {
              if (D) {
                var O = new ss(), A = D.adaptation.period.mpd.manifest.Period_asArray[D.adaptation.period.index].AdaptationSet_asArray[D.adaptation.index], ne = r.getRepresentationFor(D.index, A);
                return O.id = D.id, O.quality = D.index, O.bandwidth = r.getBandwidth(ne), O.fragmentDuration = D.segmentDuration || (D.segments && D.segments.length > 0 ? D.segments[0].duration : NaN), O.MSETimeOffset = D.MSETimeOffset, O.mediaInfo = q(D.adaptation), O;
              }
              return null;
            }, getStreamsInfo: function(D, O) {
              var A = [], ne = _;
              if (D && (ce(), ne = U(D)), ne.length > 0) {
                (!O || O > ne.length) && (O = ne.length);
                for (var z = 0; z < O; z++) A.push(V(ne[z]));
              }
              return A;
            }, getMediaInfoForType: function(D, O) {
              if (_.length === 0 || !D) return null;
              var A = ge(D, _);
              if (!A) return null;
              var ne = r.getAdaptationsForPeriod(A), z = F(D.index, O, D);
              return z ? q(ne[r.getIndexForAdaptation(z, _[0].mpd.manifest, D.index)]) : null;
            }, getAllMediaInfoForType: N, getAdaptationForType: F, getRealAdaptation: function(D, O) {
              var A, ne, z = ge(D, _);
              return A = O ? O.id : null, _.length > 0 && z && (ne = A ? r.getAdaptationForId(A, _[0].mpd.manifest, z.index) : r.getAdaptationForIndex(O ? O.index : null, _[0].mpd.manifest, z.index)), ne;
            }, getProducerReferenceTimes: function(D, O) {
              var A, ne, z = ge(D, _);
              return A = O ? O.id : null, _.length > 0 && z && (ne = A ? r.getAdaptationForId(A, _[0].mpd.manifest, z.index) : r.getAdaptationForIndex(O ? O.index : null, _[0].mpd.manifest, z.index)), ne ? r.getProducerReferenceTimesForAdaptation(ne) : [];
            }, getRealPeriodByIndex: function(D) {
              return r.getRealPeriodForIndex(D, _[0].mpd.manifest);
            }, getEssentialPropertiesForRepresentation: function(D) {
              try {
                return r.getEssentialPropertiesForRepresentation(D);
              } catch {
                return [];
              }
            }, getVoRepresentations: function(D) {
              var O = le(D);
              return r.getRepresentationsForAdaptation(O);
            }, getEventsFor: function(D, O, A) {
              var ne = [];
              if (_.length > 0) {
                var z = _[0].mpd.manifest;
                if (D instanceof us) {
                  var se = ge(D, _);
                  ne = r.getEventsForPeriod(se);
                } else if (D instanceof ka) {
                  var X = ge(A, _);
                  ne = r.getEventStreamForAdaptationSet(z, le(D), X);
                } else if (D instanceof ss) {
                  var k = ge(A, _);
                  ne = r.getEventStreamForRepresentation(z, O, k);
                }
              }
              return ne;
            }, getEvent: function(D, O, A, ne) {
              try {
                if (!D || !O || isNaN(A) || !ne) return null;
                var z = D.scheme_id_uri, se = D.value;
                if (!O[z + "/" + se]) return null;
                var X, k = new ar(), J = D.timescale || 1, pe = ne.adaptation.period.start, Le = O[z + "/" + se], Ie = isNaN(ne.presentationTimeOffset) ? isNaN(Le.presentationTimeOffset) ? 0 : Le.presentationTimeOffset : ne.presentationTimeOffset, xe = D.presentation_time_delta / J;
                X = D.version === 0 ? pe + A - Ie + xe : pe - Ie + xe;
                var De = D.event_duration / J, st = D.id, ut = D.message_data;
                return k.eventStream = Le, k.eventStream.value = se, k.eventStream.timescale = J, k.duration = De, k.id = st, k.calculatedPresentationTime = X, k.messageData = ut, k.presentationTimeDelta = xe, k;
              } catch {
                return null;
              }
            }, getMpd: Z, setConfig: function(D) {
              D && (D.constants && (I = D.constants), D.cea608parser && (y = D.cea608parser), D.errHandler && r.setConfig({ errHandler: D.errHandler }), D.BASE64 && r.setConfig({ BASE64: D.BASE64 }));
            }, updatePeriods: function(D) {
              if (!D) return null;
              ce(), _ = U(D);
            }, getIsTextTrack: function(D) {
              return r.getIsText(D);
            }, getUTCTimingSources: function() {
              var D = te();
              return r.getUTCTimingSources(D);
            }, getSuggestedPresentationDelay: function() {
              var D = _.length > 0 ? _[0].mpd : null;
              return r.getSuggestedPresentationDelay(D);
            }, getAvailabilityStartTime: function(D) {
              var O = Z(D);
              return r.getAvailabilityStartTime(O);
            }, getIsTypeOf: function(D, O) {
              return r.getIsTypeOf(D, O);
            }, getIsDynamic: function(D) {
              var O = te(D);
              return r.getIsDynamic(O);
            }, getDuration: function(D) {
              var O = te(D);
              return r.getDuration(O);
            }, getRegularPeriods: U, getContentSteering: function(D) {
              return r.getContentSteering(D);
            }, getLocation: function(D) {
              return r.getLocation(D);
            }, getPatchLocation: function(D) {
              var O = r.getPatchLocation(D), A = r.getPublishTime(D);
              return O && O.length !== 0 && A ? O.filter(function(ne) {
                return isNaN(ne.ttl) || A.getTime() + ne.ttl > (/* @__PURE__ */ new Date()).getTime();
              }) : [];
            }, getManifestUpdatePeriod: function(D) {
              var O = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
              return r.getManifestUpdatePeriod(D, O);
            }, getPublishTime: function(D) {
              return r.getPublishTime(D);
            }, getIsDVB: function(D) {
              return r.hasProfile(D, "urn:dvb:dash:profile:dvb-dash:2014");
            }, getIsPatch: function(D) {
              return l.getIsPatch(D);
            }, getBaseURLsFromElement: function(D) {
              return r.getBaseURLsFromElement(D);
            }, getRepresentationSortFunction: function() {
              return r.getRepresentationSortFunction();
            }, getCodec: function(D, O, A) {
              return r.getCodec(D, O, A);
            }, getPeriodById: function(D) {
              if (!D || _.length === 0) return null;
              var O = _.filter(function(A) {
                return A.id === D;
              });
              return O && O.length > 0 ? O[0] : null;
            }, setCurrentMediaInfo: function(D, O, A) {
              R[D] = R[D] || {}, R[D][O] = R[D][O] || {}, R[D][O] = A;
            }, isPatchValid: function(D, O) {
              var A = r.getId(D), ne = l.getMpdId(O), z = r.getPublishTime(D), se = l.getPublishTime(O), X = l.getOriginalPublishTime(O);
              return !!(A && ne && A == ne && z && X && z.getTime() == X.getTime() && se && z.getTime() < se.getTime());
            }, applyPatchToManifest: function(D, O) {
              l.getPatchOperations(O).forEach(function(A) {
                var ne = A.getMpdTarget(D);
                if (ne !== null) {
                  var z = ne.name, se = ne.target, X = ne.leaf;
                  if (A.xpath.findsAttribute() || z === "__text") switch (A.action) {
                    case "add":
                    case "replace":
                      se[z] = A.value;
                      break;
                    case "remove":
                      delete se[z];
                  }
                  else {
                    var k = (se[z + "_asArray"] || []).indexOf(X), J = A.position === "prepend" || A.position === "before";
                    if ((A.action === "remove" || A.action === "replace") && (delete se[z], k != -1)) {
                      var pe = se[z + "_asArray"];
                      pe.splice(k, 1), pe.length > 1 ? se[z] = pe : pe.length == 1 ? se[z] = pe[0] : delete se[z + "_asArray"];
                    }
                    A.action !== "add" && A.action !== "replace" || Object.keys(A.value).forEach(function(Le) {
                      var Ie = A.value[Le], xe = se[Le + "_asArray"] || [];
                      if (xe.length === 0 && se[Le] && xe.push(se[Le]), xe.length === 0) xe = Ie;
                      else {
                        var De = xe.length;
                        De = Le == z && k != -1 ? k + (J ? 0 : 1) + (A.action == "replace" ? -1 : 0) : J ? 0 : xe.length, xe.splice.apply(xe, [De, 0].concat(Ie));
                      }
                      se[Le + "_asArray"] = xe, se[Le] = xe.length == 1 ? xe[0] : xe;
                    });
                  }
                }
              });
            }, areMediaInfosEqual: H, reset: fe }, r = sn(w).getInstance(), l = gl(w).getInstance(), fe(), i;
          }
          cs.__dashjs_factory_name = "DashAdapter";
          var hl = E.Z.getSingletonFactory(cs);
          function ml(i, r) {
            for (var l = 0; l < r.length; l++) {
              var _ = r[l];
              _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(i, _.key, _);
            }
          }
          var pl = function() {
            function i() {
              (function(_, R) {
                if (!(_ instanceof R)) throw new TypeError("Cannot call a class as a function");
              })(this, i);
            }
            var r, l;
            return r = i, l = [{ key: "round10", value: function(_, R) {
              return function(I, y, w) {
                return w === void 0 || +w == 0 ? Math[I](y) : (w = +w, (y = +y) === null || isNaN(y) || typeof w != "number" || w % 1 != 0 ? NaN : (y = y.toString().split("e"), +((y = (y = Math[I](+(y[0] + "e" + (y[1] ? +y[1] - w : -w)))).toString().split("e"))[0] + "e" + (y[1] ? +y[1] + w : w))));
              }("round", _, R);
            } }], l && ml(r, l), i;
          }(), yl = function i() {
            (function(r, l) {
              if (!(r instanceof l)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.TcpList = [], this.HttpList = [], this.RepSwitchList = [], this.BufferLevel = [], this.BufferState = [], this.PlayList = [], this.DroppedFrames = [], this.SchedulingInfo = [], this.DVRInfo = [], this.ManifestUpdate = [], this.RequestsQueue = null, this.DVBErrors = [];
          }, _l = function i() {
            (function(r, l) {
              if (!(r instanceof l)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.t = null, this.mt = null, this.to = null, this.lto = null;
          }, El = function i() {
            (function(r, l) {
              if (!(r instanceof l)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.t = null, this.level = null;
          }, vl = function i() {
            (function(r, l) {
              if (!(r instanceof l)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.target = null, this.state = p.Z.BUFFER_EMPTY;
          }, Tl = function i() {
            (function(r, l) {
              if (!(r instanceof l)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.time = null, this.range = null, this.manifestInfo = null;
          }, bl = function i() {
            (function(r, l) {
              if (!(r instanceof l)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.time = null, this.droppedFrames = null;
          };
          function Za(i, r) {
            if (!(i instanceof r)) throw new TypeError("Cannot call a class as a function");
          }
          var Sl = function i() {
            Za(this, i), this.mediaType = null, this.type = null, this.requestTime = null, this.fetchTime = null, this.availabilityStartTime = null, this.presentationStartTime = 0, this.clientTimeOffset = 0, this.currentTime = null, this.buffered = null, this.latency = 0, this.streamInfo = [], this.representationInfo = [];
          }, Al = function i() {
            Za(this, i), this.id = null, this.index = null, this.start = null, this.duration = null;
          }, Il = function i() {
            Za(this, i), this.id = null, this.index = null, this.mediaType = null, this.streamIndex = null, this.presentationTimeOffset = null, this.startNumber = null, this.fragmentInfoType = null;
          }, Rl = function i() {
            (function(r, l) {
              if (!(r instanceof l)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.mediaType = null, this.t = null, this.type = null, this.startTime = null, this.availabilityStartTime = null, this.duration = null, this.quality = null, this.range = null, this.state = null;
          }, wl = function i() {
            (function(r, l) {
              if (!(r instanceof l)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.loadingRequests = [], this.executedRequests = [];
          };
          function fs(i) {
            var r, l, _ = (i = i || {}).settings, R = this.context, I = (0, m.Z)(R).getInstance();
            function y() {
              I.trigger(o.Z.METRICS_CHANGED);
            }
            function w(Z) {
              I.trigger(o.Z.METRIC_CHANGED, { mediaType: Z }), y();
            }
            function F(Z, fe, te) {
              I.trigger(o.Z.METRIC_UPDATED, { mediaType: Z, metric: fe, value: te }), w(Z);
            }
            function H(Z, fe, te) {
              I.trigger(o.Z.METRIC_ADDED, { mediaType: Z, metric: fe, value: te }), w(Z);
            }
            function G(Z, fe) {
              var te = null;
              return Z && (l.hasOwnProperty(Z) ? te = l[Z] : fe || (te = new yl(), l[Z] = te)), te;
            }
            function N(Z, fe, te) {
              var le = G(Z);
              le !== null && (le[fe].push(te), le[fe].length > _.get().streaming.metrics.maxListDepth && le[fe].shift());
            }
            function U(Z, fe, te) {
              N(Z, fe, te), H(Z, fe, te);
            }
            return r = { clearCurrentMetricsForType: function(Z) {
              delete l[Z], w(Z);
            }, clearAllCurrentMetrics: function() {
              l = {}, y();
            }, getMetricsFor: G, addHttpRequest: function Z(fe, te, le, ge, q, oe, V, ce, g, P, D, O, A, ne, z, se, X) {
              var k = new Ue.w();
              oe != null && oe !== ge && (Z(fe, null, le, ge, q, null, null, ce, g, null, null, null, A, null, null, se, X), k.actualurl = oe), k.tcpid = te, k.type = le, k.url = ge, k.range = ce, k.trequest = g, k.tresponse = P, k.responsecode = O, k.cmsd = X, k._tfinish = D, k._stream = fe, k._mediaduration = A, k._quality = q, k._responseHeaders = ne, k._serviceLocation = V, k._fileLoaderType = se, z ? z.forEach(function(J) {
                (function(pe, Le, Ie, xe) {
                  var De = new Ue.O();
                  De.s = Le, De.d = Ie, De.b = xe, pe.trace.push(De), pe.interval || (pe.interval = 0), pe.interval += Ie;
                })(k, J.s, J.d, J.b);
              }) : (delete k.interval, delete k.trace), U(fe, p.Z.HTTP_REQUEST, k);
            }, addRepresentationSwitch: function(Z, fe, te, le, ge) {
              var q = new _l();
              q.t = fe, q.mt = te, q.to = le, ge ? q.lto = ge : delete q.lto, U(Z, p.Z.TRACK_SWITCH, q);
            }, addBufferLevel: function(Z, fe, te) {
              var le = new El();
              le.t = fe, le.level = te, U(Z, p.Z.BUFFER_LEVEL, le);
            }, addBufferState: function(Z, fe, te) {
              var le = new vl();
              le.target = te, le.state = fe, U(Z, p.Z.BUFFER_STATE, le);
            }, addDVRInfo: function(Z, fe, te, le) {
              var ge = new Tl();
              ge.time = fe, ge.range = le, ge.manifestInfo = te, U(Z, p.Z.DVR_INFO, ge);
            }, addDroppedFrames: function(Z, fe) {
              var te = new bl(), le = G(Z).DroppedFrames;
              fe && (te.time = fe.creationTime, te.droppedFrames = fe.droppedVideoFrames, le.length > 0 && le[le.length - 1] == te || U(Z, p.Z.DROPPED_FRAMES, te));
            }, addSchedulingInfo: function(Z, fe, te, le, ge, q, oe, V, ce) {
              var g = new Rl();
              g.mediaType = Z, g.t = fe, g.type = te, g.startTime = le, g.availabilityStartTime = ge, g.duration = q, g.quality = oe, g.range = V, g.state = ce, U(Z, p.Z.SCHEDULING_INFO, g);
            }, addRequestsQueue: function(Z, fe, te) {
              var le = new wl();
              le.loadingRequests = fe, le.executedRequests = te, G(Z).RequestsQueue = le, H(Z, p.Z.REQUESTS_QUEUE, le);
            }, addManifestUpdate: function(Z, fe, te, le, ge, q, oe, V, ce, g) {
              var P = new Sl();
              P.mediaType = Z, P.type = fe, P.requestTime = te, P.fetchTime = le, P.availabilityStartTime = ge, P.presentationStartTime = q, P.clientTimeOffset = oe, P.currentTime = V, P.buffered = ce, P.latency = g, N(t.Z.STREAM, p.Z.MANIFEST_UPDATE, P), H(Z, p.Z.MANIFEST_UPDATE, P);
            }, updateManifestUpdateInfo: function(Z, fe) {
              if (Z) {
                for (var te in fe) Z[te] = fe[te];
                F(Z.mediaType, p.Z.MANIFEST_UPDATE, Z);
              }
            }, addManifestUpdateStreamInfo: function(Z, fe, te, le, ge) {
              if (Z) {
                var q = new Al();
                q.id = fe, q.index = te, q.start = le, q.duration = ge, Z.streamInfo.push(q), F(Z.mediaType, p.Z.MANIFEST_UPDATE_STREAM_INFO, Z);
              }
            }, addManifestUpdateRepresentationInfo: function(Z, fe, te, le, ge, q, oe, V) {
              if (Z && Z.representationInfo) {
                var ce = new Il();
                ce.id = fe, ce.index = te, ce.streamIndex = le, ce.mediaType = ge, ce.startNumber = oe, ce.fragmentInfoType = V, ce.presentationTimeOffset = q, Z.representationInfo.push(ce), F(Z.mediaType, p.Z.MANIFEST_UPDATE_TRACK_INFO, Z);
              }
            }, addPlayList: function(Z) {
              Z.trace && Array.isArray(Z.trace) ? Z.trace.forEach(function(fe) {
                fe.hasOwnProperty("subreplevel") && !fe.subreplevel && delete fe.subreplevel;
              }) : delete Z.trace, U(t.Z.STREAM, p.Z.PLAY_LIST, Z);
            }, addDVBErrors: function(Z) {
              U(t.Z.STREAM, p.Z.DVB_ERRORS, Z);
            } }, l = {}, r;
          }
          fs.__dashjs_factory_name = "MetricsModel";
          var Cl = E.Z.getSingletonFactory(fs);
          function ds(i) {
            i = i || {};
            var r, l, _, R, I = this.context, y = i.metricsModel;
            function w(G) {
              var N = y.getMetricsFor(G, !0);
              if (!N) return null;
              var U, Z = N.HttpList, fe = null;
              if (!Z || Z.length <= 0) return null;
              for (U = Z.length - 1; U >= 0; ) {
                if (Z[U].responsecode) {
                  fe = Z[U];
                  break;
                }
                U--;
              }
              return fe;
            }
            function F(G) {
              var N = y.getMetricsFor(G, !0);
              return N && N.HttpList ? N.HttpList : [];
            }
            function H(G, N) {
              if (!G) return null;
              var U = G[N];
              return U && U.length !== 0 ? U[U.length - 1] : null;
            }
            return r = { getCurrentRepresentationSwitch: function(G) {
              return H(y.getMetricsFor(G, !0), p.Z.TRACK_SWITCH);
            }, getCurrentBufferState: function(G) {
              return H(y.getMetricsFor(G, !0), p.Z.BUFFER_STATE);
            }, getCurrentBufferLevel: function(G) {
              var N = H(y.getMetricsFor(G, !0), p.Z.BUFFER_LEVEL);
              return N ? pl.round10(N.level / 1e3, -3) : 0;
            }, getCurrentHttpRequest: w, getHttpRequests: F, getCurrentDroppedFrames: function() {
              return H(y.getMetricsFor(t.Z.VIDEO, !0), p.Z.DROPPED_FRAMES);
            }, getCurrentSchedulingInfo: function(G) {
              return H(y.getMetricsFor(G, !0), p.Z.SCHEDULING_INFO);
            }, getCurrentDVRInfo: function(G) {
              return H(G ? y.getMetricsFor(G, !0) : y.getMetricsFor(t.Z.VIDEO, !0) || y.getMetricsFor(t.Z.AUDIO, !0), p.Z.DVR_INFO);
            }, getCurrentManifestUpdate: function() {
              return H(y.getMetricsFor(t.Z.STREAM), p.Z.MANIFEST_UPDATE);
            }, getLatestFragmentRequestHeaderValueByID: function(G, N) {
              if (!N) return null;
              var U = {}, Z = w(G);
              Z && (U = bt.Z.parseHttpHeaders(Z._responseHeaders));
              var fe = U[N.toLowerCase()];
              return fe === void 0 ? null : fe;
            }, getLatestMPDRequestHeaderValueByID: function(G) {
              if (!G) return null;
              var N, U, Z, fe = {};
              for (Z = (N = F(t.Z.STREAM)).length - 1; Z >= 0; Z--) if ((U = N[Z]).type === Ue.w.MPD_TYPE) {
                fe = bt.Z.parseHttpHeaders(U._responseHeaders);
                break;
              }
              var te = fe[G.toLowerCase()];
              return te === void 0 ? null : te;
            }, addRepresentationSwitch: function(G, N, U, Z, fe) {
              y.addRepresentationSwitch(G, N, U, Z, fe);
            }, addDVRInfo: function(G, N, U, Z) {
              y.addDVRInfo(G, N, U, Z);
            }, updateManifestUpdateInfo: function(G) {
              var N = this.getCurrentManifestUpdate();
              y.updateManifestUpdateInfo(N, G);
            }, addManifestUpdateStreamInfo: function(G) {
              if (G) {
                var N = this.getCurrentManifestUpdate();
                y.addManifestUpdateStreamInfo(N, G.id, G.index, G.start, G.duration);
              }
            }, addManifestUpdateRepresentationInfo: function(G, N) {
              if (G) {
                var U = this.getCurrentManifestUpdate();
                y.addManifestUpdateRepresentationInfo(U, G.id, G.index, G.streamIndex, N, G.presentationTimeOffset, G.startNumber, G.fragmentInfoType);
              }
            }, addManifestUpdate: function(G) {
              y.addManifestUpdate(t.Z.STREAM, G.type, G.requestStartDate, G.requestEndDate);
            }, addHttpRequest: function(G, N, U, Z, fe, te) {
              y.addHttpRequest(G.mediaType, null, G.type, G.url, G.quality, N, G.serviceLocation || null, G.range || null, G.requestStartDate, G.firstByteDate, G.requestEndDate, U, G.duration, Z, fe, G.fileLoaderType, te);
            }, addSchedulingInfo: function(G, N) {
              y.addSchedulingInfo(G.mediaType, /* @__PURE__ */ new Date(), G.type, G.startTime, G.availabilityStartTime, G.duration, G.quality, G.range, N);
            }, addRequestsQueue: function(G, N, U) {
              y.addRequestsQueue(G, N, U);
            }, addBufferLevel: function(G, N, U) {
              y.addBufferLevel(G, N, U);
            }, addBufferState: function(G, N, U) {
              y.addBufferState(G, N, U);
            }, addDroppedFrames: function(G) {
              y.addDroppedFrames(t.Z.VIDEO, G);
            }, addPlayList: function() {
              R && (y.addPlayList(R), R = null);
            }, addDVBErrors: function(G) {
              y.addDVBErrors(G);
            }, createPlaylistMetrics: function(G, N) {
              (R = new Fe()).start = /* @__PURE__ */ new Date(), R.mstart = G, R.starttype = N;
            }, createPlaylistTraceMetrics: function(G, N, U) {
              l === !0 && (l = !1, (_ = new we()).representationid = G, _.start = /* @__PURE__ */ new Date(), _.mstart = N, _.playbackspeed = U !== null ? U.toString() : null);
            }, updatePlayListTraceMetrics: function(G) {
              if (_) for (var N in _) _[N] = G[N];
            }, pushPlayListTraceMetrics: function(G, N) {
              if (l === !1 && R && _ && _.start) {
                var U = _.start, Z = G.getTime() - U.getTime();
                _.duration = Z, _.stopreason = N, R.trace.push(_), l = !0;
              }
            }, clearAllCurrentMetrics: function() {
              y.clearAllCurrentMetrics();
            } }, y = y || Cl(I).getInstance({ settings: i.settings }), l = !0, _ = null, R = null, r;
          }
          ds.__dashjs_factory_name = "DashMetrics";
          var Nl = E.Z.getSingletonFactory(ds);
          function gs() {
            var i, r, l, _, R = this.context, I = (0, m.Z)(R).getInstance(), y = (0, Ne.Z)(R).getInstance();
            function w(ge) {
              _ = ge;
            }
            function F(ge, q, oe, V) {
              var ce, g = q.adaptation.period.mpd, P = g.availabilityStartTime;
              if (V) ce = oe && g.timeShiftBufferDepth !== Number.POSITIVE_INFINITY ? new Date(P.getTime() + 1e3 * (ge + g.timeShiftBufferDepth)) : g.availabilityEndTime;
              else if (oe) {
                var D = q.availabilityTimeOffset;
                ce = new Date(P.getTime() + 1e3 * (ge - D));
              } else ce = P;
              return ce;
            }
            function H(ge, q) {
              return (ge.getTime() - q.mpd.availabilityStartTime.getTime() + 1e3 * _) / 1e3;
            }
            function G(ge, q) {
              return ge + (q.adaptation.period.start - q.presentationTimeOffset);
            }
            function N(ge) {
              var q = { start: NaN, end: NaN }, oe = ge[0].getAdapter().getRegularPeriods()[0], V = H(/* @__PURE__ */ new Date(), oe);
              if (!ge || ge.length === 0) return { range: q, now: V };
              ge.forEach(function(g) {
                var P = g.getAdapter(), D = P.getMediaInfoForType(g.getStreamInfo(), t.Z.VIDEO) || P.getMediaInfoForType(g.getStreamInfo(), t.Z.AUDIO), O = P.getVoRepresentations(D)[0], A = { start: NaN, end: NaN };
                if (O) if (O.segmentInfoType === e.Z.SEGMENT_TIMELINE) A = function(z) {
                  var se, X, k, J, pe = z.adaptation.period.mpd.manifest.Period_asArray[z.adaptation.period.index].AdaptationSet_asArray[z.adaptation.index], Le = r.getRepresentationFor(z.index, pe), Ie = Le.SegmentTemplate || Le.SegmentList, xe = Ie.SegmentTimeline, De = Ie.timescale, st = xe.S_asArray, ut = { start: 0, end: 0 }, et = st[0].t, tt = !isNaN(et), Ut = tt ? et : 0, be = 0;
                  for (tt && (ut.start = G(Ut / De, z)), k = 0, J = st.length; k < J; k++) X = 0, (se = st[k]).hasOwnProperty("r") && (X = se.r), be += se.d * (1 + X);
                  return ut.end = G((Ut + be) / De, z), ut;
                }(O);
                else {
                  var ne = O.adaptation.period;
                  A.start = ne.start, A.end = Math.max(V, ne.start + ne.duration);
                }
                !isNaN(A.start) && (isNaN(q.start) || q.start > A.start) && (q.start = A.start), !isNaN(A.end) && (isNaN(q.end) || q.end < A.end) && (q.end = A.end);
              }), q.end = Math.min(V, q.end);
              var ce = Z(ge, q.end, !0);
              return q.end = isNaN(ce) ? q.end : ce, q.start = oe && oe.mpd && oe.mpd.timeShiftBufferDepth && !isNaN(oe.mpd.timeShiftBufferDepth) && !isNaN(q.end) ? Math.max(q.end - oe.mpd.timeShiftBufferDepth, q.start) : q.start, q.start = Z(ge, q.start), { range: q, now: V };
            }
            function U(ge, q) {
              l = ge - q.end;
            }
            function Z(ge, q) {
              var oe = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
              try {
                for (var V = 0, ce = !1, g = NaN; !ce && V < ge.length; ) {
                  var P = ge[V].getStreamInfo();
                  P.start <= q && (!isFinite(P.duration) || P.start + P.duration >= q) ? (g = q, ce = !0) : !oe && P.start > q && (isNaN(g) || P.start < g) ? g = P.start : oe && P.start + P.duration < q && (isNaN(g) || P.start + P.duration > g) && (g = P.start + P.duration), V += 1;
                }
                return g;
              } catch {
                return q;
              }
            }
            function fe(ge) {
              ge.offset === void 0 || isNaN(ge.offset) || w(ge.offset / 1e3);
            }
            function te() {
              _ = 0, l = 0;
            }
            function le() {
              I.off(o.Z.UPDATE_TIME_SYNC_OFFSET, fe, this), te();
            }
            return i = { initialize: function() {
              te(), I.on(o.Z.UPDATE_TIME_SYNC_OFFSET, fe, this);
            }, getClientTimeOffset: function() {
              return _;
            }, setClientTimeOffset: w, getClientReferenceTime: function() {
              return Date.now() - 1e3 * l + 1e3 * _;
            }, calcAvailabilityStartTimeFromPresentationTime: function(ge, q, oe) {
              return F(ge, q, oe);
            }, calcAvailabilityEndTimeFromPresentationTime: function(ge, q, oe) {
              return F(ge, q, oe, !0);
            }, calcPresentationTimeFromWallTime: H, calcPresentationTimeFromMediaTime: G, calcPeriodRelativeTimeFromMpdRelativeTime: function(ge, q) {
              return q - ge.adaptation.period.start;
            }, calcMediaTimeFromPresentationTime: function(ge, q) {
              return ge - q.adaptation.period.start + q.presentationTimeOffset;
            }, calcWallTimeForSegment: function(ge, q) {
              var oe, V, ce;
              return q && (oe = ge.representation.adaptation.period.mpd.suggestedPresentationDelay, V = ge.presentationStartTime + oe, ce = new Date(ge.availabilityStartTime.getTime() + 1e3 * V)), ce;
            }, calcTimeShiftBufferWindow: function(ge, q) {
              if (!q) return function(V) {
                var ce = { start: NaN, end: NaN }, g = 0, P = NaN;
                return V.forEach(function(D) {
                  var O = D.getStreamInfo();
                  g += O.duration, (isNaN(P) || O.start < P) && (P = O.start);
                }), ce.start = P, ce.end = P + g, ce;
              }(ge);
              if (y.get().streaming.timeShiftBuffer.calcFromSegmentTimeline) {
                var oe = N(ge);
                return U(oe.now, oe.range), oe.range;
              }
              return function(V) {
                var ce = { start: NaN, end: NaN };
                if (!V || V.length === 0) return ce;
                var g = V[0].getAdapter().getRegularPeriods()[0], P = H(/* @__PURE__ */ new Date(), g), D = g.mpd.timeShiftBufferDepth, O = isNaN(D) ? 0 : P - D;
                if (ce.start = Z(V, O), ce.end = !isNaN(ce.start) && P < ce.start ? P : Z(V, P, !0), !isNaN(D) && ce.end < P - D && (ce.end = NaN), y.get().streaming.timeShiftBuffer.fallbackToSegmentTimeline) {
                  var A = N(V);
                  if (A.range.end < ce.start) return I.trigger(n.Z.CONFORMANCE_VIOLATION, { level: si.LEVELS.WARNING, event: si.EVENTS.INVALID_DVR_WINDOW }), U(A.now, A.range), A.range;
                }
                return ce;
              }(ge);
            }, reset: le }, r = sn(R).getInstance(), le(), i;
          }
          gs.__dashjs_factory_name = "TimelineConverter";
          var Dl = E.Z.getSingletonFactory(gs), Ua = C(4593), Wi = C(6934);
          function Ba(i) {
            return Ba = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
              return typeof r;
            } : function(r) {
              return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
            }, Ba(i);
          }
          function Ga(i, r) {
            return Ga = Object.setPrototypeOf || function(l, _) {
              return l.__proto__ = _, l;
            }, Ga(i, r);
          }
          function Ol(i, r) {
            return !r || Ba(r) !== "object" && typeof r != "function" ? function(l) {
              if (l === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return l;
            }(i) : r;
          }
          function Qi(i) {
            return Qi = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
              return r.__proto__ || Object.getPrototypeOf(r);
            }, Qi(i);
          }
          var Ml = function(i) {
            (function(I, y) {
              if (typeof y != "function" && y !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(y.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), Ga(I, y);
            })(R, i);
            var r, l, _ = (r = R, l = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var I, y = Qi(r);
              if (l) {
                var w = Qi(this).constructor;
                I = Reflect.construct(y, arguments, w);
              } else I = y.apply(this, arguments);
              return Ol(this, I);
            });
            function R() {
              var I;
              return function(y, w) {
                if (!(y instanceof w)) throw new TypeError("Cannot call a class as a function");
              }(this, R), (I = _.call(this)).captionData = null, I.label = null, I.defaultTrack = !1, I.kind = null, I.isFragmented = !1, I.isEmbedded = !1, I.isTTML = null, I;
            }
            return R;
          }(ka), Pl = C(2295);
          function hs() {
            var i = 0;
            function r(w) {
              for (var F = "", H = 0; H < w.length; ++H) F += w[H].uchar;
              return F.length - F.replace(/^\s+/, "").length;
            }
            function l(w) {
              return "left: " + 3.125 * w.x + "%; top: " + 6.66 * w.y1 + "%; width: " + (100 - 3.125 * w.x) + "%; height: " + 6.66 * Math.max(w.y2 - 1 - w.y1, 1) + "%; align-items: flex-start; overflow: visible; -webkit-writing-mode: horizontal-tb;";
            }
            function _(w) {
              return w === "red" ? "rgb(255, 0, 0)" : w === "green" ? "rgb(0, 255, 0)" : w === "blue" ? "rgb(0, 0, 255)" : w === "cyan" ? "rgb(0, 255, 255)" : w === "magenta" ? "rgb(255, 0, 255)" : w === "yellow" ? "rgb(255, 255, 0)" : w === "white" ? "rgb(255, 255, 255)" : w === "black" ? "rgb(0, 0, 0)" : w;
            }
            function R(w, F) {
              var H = w.videoHeight / 15;
              return F ? "font-size: " + H + "px; font-family: Menlo, Consolas, 'Cutive Mono', monospace; color: " + (F.foreground ? _(F.foreground) : "rgb(255, 255, 255)") + "; font-style: " + (F.italics ? "italic" : "normal") + "; text-decoration: " + (F.underline ? "underline" : "none") + "; white-space: pre; background-color: " + (F.background ? _(F.background) : "transparent") + ";" : "font-size: " + H + "px; font-family: Menlo, Consolas, 'Cutive Mono', monospace; justify-content: flex-start; text-align: left; color: rgb(255, 255, 255); font-style: normal; white-space: pre; line-height: normal; font-weight: normal; text-decoration: none; width: 100%; display: flex;";
            }
            function I(w) {
              return w.replace(/^\s+/g, "");
            }
            function y(w) {
              return w.replace(/\s+$/g, "");
            }
            return { createHTMLCaptionsFromScreen: function(w, F, H, G) {
              var N, U, Z = null, fe = !1, te = -1, le = { start: F, end: H, spans: [] }, ge = "style_cea608_white_black", q = {}, oe = {}, V = [];
              for (N = 0; N < 15; ++N) {
                var ce = G.rows[N], g = "", P = null;
                if (ce.isEmpty() === !1) {
                  var D = r(ce.chars);
                  Z === null && (Z = { x: D, y1: N, y2: N + 1, p: [] }), D !== te && fe && (Z.p.push(le), le = { start: F, end: H, spans: [] }, Z.y2 = N, Z.name = "region_" + Z.x + "_" + Z.y1 + "_" + Z.y2, q.hasOwnProperty(Z.name) === !1 ? (V.push(Z), q[Z.name] = Z) : q[Z.name].p.contat(Z.p), Z = { x: D, y1: N, y2: N + 1, p: [] });
                  for (var O = 0; O < ce.chars.length; ++O) {
                    var A = ce.chars[O], ne = A.penState;
                    if (P === null || !ne.equals(P)) {
                      g.trim().length > 0 && (le.spans.push({ name: ge, line: g, row: N }), g = "");
                      var z = "style_cea608_" + ne.foreground + "_" + ne.background;
                      ne.underline && (z += "_underline"), ne.italics && (z += "_italics"), oe.hasOwnProperty(z) || (oe[z] = JSON.parse(JSON.stringify(ne))), P = ne, ge = z;
                    }
                    g += A.uchar;
                  }
                  g.trim().length > 0 && le.spans.push({ name: ge, line: g, row: N }), fe = !0, te = D;
                } else fe = !1, te = -1, Z && (Z.p.push(le), le = { start: F, end: H, spans: [] }, Z.y2 = N, Z.name = "region_" + Z.x + "_" + Z.y1 + "_" + Z.y2, q.hasOwnProperty(Z.name) === !1 ? (V.push(Z), q[Z.name] = Z) : q[Z.name].p.contat(Z.p), Z = null);
              }
              Z && (Z.p.push(le), Z.y2 = N + 1, Z.name = "region_" + Z.x + "_" + Z.y1 + "_" + Z.y2, q.hasOwnProperty(Z.name) === !1 ? (V.push(Z), q[Z.name] = Z) : q[Z.name].p.contat(Z.p), Z = null);
              var se = [];
              for (N = 0; N < V.length; ++N) {
                var X = V[N], k = "sub_cea608_" + i++, J = document.createElement("div");
                J.id = k;
                var pe = l(X);
                J.style.cssText = "position: absolute; margin: 0; display: flex; box-sizing: border-box; pointer-events: none;" + pe;
                var Le = document.createElement("div");
                Le.className = "paragraph bodyStyle", Le.style.cssText = R(w);
                var Ie = document.createElement("div");
                Ie.className = "cueUniWrapper", Ie.style.cssText = "unicode-bidi: normal; direction: ltr;";
                for (var xe = 0; xe < X.p.length; ++xe) {
                  var De = X.p[xe], st = 0;
                  for (U = 0; U < De.spans.length; ++U) {
                    var ut = De.spans[U];
                    if (ut.line.length > 0) {
                      if (U !== 0 && st != ut.row) {
                        var et = document.createElement("br");
                        et.className = "lineBreak", Ie.appendChild(et);
                      }
                      var tt = !1;
                      st === ut.row && (tt = !0), st = ut.row;
                      var Ut = oe[ut.name], be = document.createElement("span");
                      be.className = "spanPadding " + ut.name + " customSpanColor", be.style.cssText = R(w, Ut), U !== 0 && tt ? U === De.spans.length - 1 ? be.textContent = y(ut.line) : be.textContent = ut.line : De.spans.length > 1 && U < De.spans.length - 1 && ut.row === De.spans[U + 1].row ? be.textContent = I(ut.line) : be.textContent = ut.line.trim(), Ie.appendChild(be);
                    }
                  }
                }
                Le.appendChild(Ie), J.appendChild(Le);
                var Be = { bodyStyle: ["%", 90] };
                for (var mt in oe) oe.hasOwnProperty(mt) && (Be[mt] = ["%", 90]);
                se.push({ type: "html", start: F, end: H, cueHTMLElement: J, cueID: k, cellResolution: [32, 15], isFromCEA608: !0, fontSize: Be, lineHeight: {}, linePadding: {} });
              }
              return se;
            } };
          }
          hs.__dashjs_factory_name = "EmbeddedTextHtmlRender";
          var Ll = E.Z.getSingletonFactory(hs);
          function ms(i) {
            var r, l, _, R, I, y, w, F, H, G, N, U, Z, fe, te, le, ge, q = i.errHandler, oe = i.manifestModel, V = i.mediaController, ce = i.videoModel, g = i.textTracks, P = i.vttParser, D = i.vttCustomRenderingParser, O = i.ttmlParser, A = i.streamInfo, ne = i.settings, z = this.context, se = (0, m.Z)(z).getInstance(), X = !1;
            function k() {
              y = null, F = NaN, H = [], G = null, w = !1, I = [], R = null;
            }
            function J(et) {
              var tt = new Ml();
              for (var Ut in et) tt[Ut] = et[Ut];
              tt.labels = et.labels, tt.defaultTrack = function(be) {
                var Be = !1;
                return U.length > 1 && be.isEmbedded ? Be = be.id && be.id === t.Z.CC1 : U.length === 1 ? be.id && typeof be.id == "string" && be.id.substring(0, 2) === "CC" && (Be = !0) : U.length === 0 && (Be = be.index === I[0].index), Be;
              }(et), tt.isFragmented = et.isFragmented, tt.isEmbedded = !!et.isEmbedded, tt.isTTML = function(be) {
                return be.codec && be.codec.search(t.Z.STPP) >= 0 || be.mimeType && be.mimeType.search(t.Z.TTML) >= 0;
              }(et), tt.kind = function(be, Be) {
                var mt = be.roles && be.roles.length > 0 ? Be[be.roles[0]] : Be.caption;
                return mt = mt === Be.caption || mt === Be.subtitle ? mt : Be.caption;
              }(et, { subtitle: "subtitles", caption: "captions" }), g.addTextTrack(tt);
            }
            function pe(et) {
              var tt = et.chunk;
              tt.mediaInfo.embeddedCaptions && Ie(tt.bytes, tt);
            }
            function Le(et) {
              N = et;
            }
            function Ie(et, tt) {
              var Ut = tt.mediaInfo, be = Ut.type, Be = Ut.mimeType, mt = Ut.codec || Be;
              mt ? Ut.codec.indexOf("application/mp4") !== -1 ? function(Ke, vt, Et) {
                var gt;
                if (vt.segmentType === "InitializationSegment") w = !0, F = _.getMediaTimescaleFromMoov(Ke);
                else {
                  if (!w) return;
                  (gt = _.getSamplesInfo(Ke).sampleList).length > 0 && (G = gt[0].cts - vt.start * F), Et.search(t.Z.STPP) >= 0 ? function(Wt, zt, gn) {
                    var pn, je;
                    for (R = R !== null ? R : st(gn), pn = 0; pn < zt.length; pn++) {
                      var yt = zt[pn], ot = yt.cts, It = De(), Lt = It + ot / F, $t = Lt + yt.duration / F;
                      r.buffered.add(Lt, $t);
                      var Qt = new DataView(Wt, yt.offset, yt.subSizes[0]), en = Wi.Utils.dataViewToString(Qt, t.Z.UTF8), on = [], ht = yt.offset + yt.subSizes[0];
                      for (je = 1; je < yt.subSizes.length; je++) {
                        var kt = new Uint8Array(Wt, ht, yt.subSizes[je]), Ht = String.fromCharCode.apply(null, kt);
                        on.push(Ht), ht += yt.subSizes[je];
                      }
                      try {
                        var Vt = oe.getValue().ttmlTimeIsRelative ? ot / F : 0, Xt = R.parse(en, Vt, ot / F, (ot + yt.duration) / F, on);
                        g.addCaptions(N, It, Xt);
                      } catch (Ye) {
                        y.removeExecutedRequestsBeforeTime(), this.remove(), l.error("TTML parser error: " + Ye.message);
                      }
                    }
                  }(Ke, gt, Et) : function(Wt, zt) {
                    var gn, pn, je, yt = [];
                    for (gn = 0; gn < zt.length; gn++) {
                      var ot = zt[gn];
                      ot.cts -= G;
                      var It = De() + ot.cts / F, Lt = It + ot.duration / F;
                      r.buffered.add(It, Lt);
                      var $t = Wt.slice(ot.offset, ot.offset + ot.size), Qt = Wi.parseBuffer($t);
                      for (pn = 0; pn < Qt.boxes.length; pn++) {
                        var en = Qt.boxes[pn];
                        if (l.debug("VTT box1: " + en.type), en.type !== "vtte" && en.type === "vttc") {
                          l.debug("VTT vttc boxes.length = " + en.boxes.length);
                          var on = { styles: {} };
                          for (je = 0; je < en.boxes.length; je++) {
                            var ht = en.boxes[je];
                            if (l.debug("VTT box2: " + ht.type), ht.type === "payl") on.start = ot.cts / F, on.end = (ot.cts + ot.duration) / F, on.data = ht.cue_text;
                            else if (ht.type === "sttg" && ht.settings && ht.settings !== "") try {
                              var kt = ht.settings.split(" ");
                              on.styles = P.getCaptionStyles(kt);
                            } catch {
                            }
                          }
                          on && on.data && (yt.push(on), l.debug("VTT  ".concat(on.start, " - ").concat(on.end, " :  ").concat(on.data)));
                        }
                      }
                    }
                    yt.length > 0 && g.addCaptions(N, 0, yt);
                  }(Ke, gt);
                }
              }(et, tt, mt) : be === t.Z.VIDEO ? function(Ke, vt) {
                var Et, gt;
                if (vt.segmentType === Ue.w.INIT_SEGMENT_TYPE) Z === 0 && (Z = _.getMediaTimescaleFromMoov(Ke));
                else if (vt.segmentType === Ue.w.MEDIA_SEGMENT_TYPE) {
                  if (Z === 0) return void l.warn("CEA-608: No timescale for embeddedTextTrack yet");
                  var Wt = (gt = _.getSamplesInfo(Ke)).lastSequenceNumber, zt = Math.trunc(vt.start), gn = Math.trunc(vt.end);
                  if (le[0] || le[1] || function() {
                    for (var It, Lt = 0; Lt < U.length; Lt++) {
                      if ((It = g.getTrackIdxForId(U[Lt].id)) === -1) return void l.warn("CEA-608: data before track is ready.");
                      var $t = xe(It);
                      le[Lt] = new (T()).Cea608Parser(Lt + 1, { newCue: $t }, null);
                    }
                  }(), Z) {
                    if (function(It, Lt, $t, Qt, en) {
                      return It !== null && Lt !== null && Qt !== null && en !== null && (Lt === It ? Qt !== en : Lt !== It + $t);
                    }(fe, Wt, gt.numSequences, te, zt)) for (Et = 0; Et < le.length; Et++) le[Et] && le[Et].reset();
                    for (var pn = function(It, Lt) {
                      if (Lt.length === 0) return null;
                      for (var $t = { splits: [], fields: [[], []] }, Qt = new DataView(It), en = 0; en < Lt.length; en++) for (var on = Lt[en], ht = T().findCea608Nalus(Qt, on.offset, on.size), kt = null, Ht = 0, Vt = 0; Vt < ht.length; Vt++) for (var Xt = T().extractCea608DataFromRange(Qt, ht[Vt]), Ye = 0; Ye < 2; Ye++) if (Xt[Ye].length > 0) {
                        on.cts !== kt ? Ht = 0 : Ht += 1;
                        var Me = De();
                        $t.fields[Ye].push([on.cts + Me * Z, Xt[Ye], Ht]), kt = on.cts;
                      }
                      return $t.fields.forEach(function(ct) {
                        ct.sort(function(de, _e) {
                          return de[0] === _e[0] ? de[2] - _e[2] : de[0] - _e[0];
                        });
                      }), $t;
                    }(Ke, gt.sampleList), je = 0; je < le.length; je++) {
                      var yt = pn.fields[je], ot = le[je];
                      if (ot) for (Et = 0; Et < yt.length; Et++) ot.addData(yt[Et][0] / Z, yt[Et][1]);
                    }
                    fe = Wt, te = gn;
                  }
                }
              }(et, tt) : function(Ke, vt, Et) {
                var gt, Wt, zt = new DataView(Ke, 0, Ke.byteLength);
                Wt = Wi.Utils.dataViewToString(zt, t.Z.UTF8);
                try {
                  gt = st(Et).parse(Wt, 0), g.addCaptions(g.getCurrentTrackIdx(), 0, gt), r.buffered && r.buffered.add(vt.start, vt.end);
                } catch (gn) {
                  q.error(new ae.Z(Q.TIMED_TEXT_ERROR_ID_PARSE_CODE, Q.TIMED_TEXT_ERROR_MESSAGE_PARSE + gn.message, Wt));
                }
              }(et, tt, mt) : l.error("No text type defined");
            }
            function xe(et) {
              return function(tt, Ut, be) {
                var Be;
                (Be = ce.getTTMLRenderingDiv() ? ge.createHTMLCaptionsFromScreen(ce.getElement(), tt, Ut, be) : [{ start: tt, end: Ut, data: be.getDisplayText(), styles: {} }]) && g.addCaptions(et, 0, Be);
              };
            }
            function De() {
              return isNaN(r.timestampOffset) ? 0 : r.timestampOffset;
            }
            function st(et) {
              var tt;
              return et.search(t.Z.VTT) >= 0 ? tt = ne.get().streaming.text.webvtt.customRenderingEnabled && D ? D : P : (et.search(t.Z.TTML) >= 0 || et.search(t.Z.STPP) >= 0) && (tt = O), tt;
            }
            function ut(et) {
              U.forEach(function(tt) {
                var Ut = g.getTrackIdxForId(tt.id);
                Ut >= 0 && g.deleteCuesFromTrackIdx(Ut, et.from, et.to);
              });
            }
            return r = { initialize: function() {
              X || (U = [], N = null, Z = 0, le = [], fe = null, te = null, X = !0, ge = Ll(z).getInstance(), se.on(o.Z.VIDEO_CHUNK_RECEIVED, pe, r), se.on(o.Z.BUFFER_CLEARED, ut, r));
            }, addMediaInfos: function(et, tt, Ut) {
              if (I = I.concat(tt), et === t.Z.TEXT && tt[0].isFragmented && !tt[0].isEmbedded) {
                y = Ut, r.buffered = (0, Pl.Z)(z).create(), H = V.getTracksFor(t.Z.TEXT, A.id).filter(function(Ke) {
                  return Ke.isFragmented;
                });
                for (var be = V.getCurrentTrackFor(t.Z.TEXT, A.id), Be = 0; Be < H.length; Be++) if (H[Be] === be) {
                  Le(Be);
                  break;
                }
              }
              for (var mt = 0; mt < tt.length; mt++) J(tt[mt]);
            }, resetMediaInfos: function() {
              I = [];
            }, getStreamId: function() {
              return A.id;
            }, append: Ie, abort: function() {
            }, addEmbeddedTrack: function(et) {
              if (X && et) if (et.id === t.Z.CC1 || et.id === t.Z.CC3) {
                for (var tt = 0; tt < U.length; tt++) if (U[tt].id === et.id) return;
                U.push(et);
              } else l.warn("Embedded track " + et.id + " not supported!");
            }, resetEmbedded: function() {
              se.off(o.Z.VIDEO_CHUNK_RECEIVED, pe, r), se.off(o.Z.BUFFER_CLEARED, ut, r), g && g.deleteAllTextTracks(), X = !1, U = [], le = [null, null], fe = null, te = null;
            }, getConfig: function() {
              return { fragmentModel: y, fragmentedTracks: H, videoModel: ce };
            }, setCurrentFragmentedTrackIdx: Le, remove: function(et, tt) {
              et === void 0 && et === tt && (et = r.buffered.start(0), tt = r.buffered.end(r.buffered.length - 1)), r.buffered.remove(et, tt), g.deleteCuesFromTrackIdx(N, et, tt);
            }, reset: function() {
              k(), I = [], _ = null;
            } }, l = (0, h.Z)(z).getInstance().getLogger(r), _ = (0, Ei.Z)(z).getInstance(), k(), r;
          }
          ms.__dashjs_factory_name = "TextSourceBuffer";
          var xl = E.Z.getClassFactory(ms), qa = C(4403);
          function ps(i, r) {
            (r == null || r > i.length) && (r = i.length);
            for (var l = 0, _ = new Array(r); l < r; l++) _[l] = i[l];
            return _;
          }
          var Fl = ["text", "align", "fontSize", "id", "isd", "line", "lineAlign", "lineHeight", "linePadding", "position", "positionAlign", "region", "size", "snapToLines", "vertical"];
          function ys(i) {
            var r, l, _, R, I, y, w, F, H, G, N, U, Z, fe, te, le, ge, q, oe, V, ce = this.context, g = (0, m.Z)(ce).getInstance(), P = i.videoModel, D = i.streamInfo, O = i.settings;
            function A(je, yt, ot, It, Lt, $t) {
              var Qt = 0, en = 0;
              je / yt > ot / It ? Qt = (en = yt) / It * ot : en = (Qt = je) / ot * It;
              var on, ht, kt = 0, Ht = 0;
              return Qt / en > Lt ? (Ht = en, kt = en * Lt) : (kt = Qt, Ht = Qt / Lt), on = (je - kt) / 2, ht = (yt - Ht) / 2, $t ? { x: on + 0.1 * kt, y: ht + 0.1 * Ht, w: 0.8 * kt, h: 0.8 * Ht } : { x: on, y: ht, w: kt, h: Ht };
            }
            function ne(je, yt) {
              var ot = P.getClientWidth(), It = P.getClientHeight(), Lt = P.getVideoWidth(), $t = P.getVideoHeight(), Qt = P.getVideoRelativeOffsetTop(), en = P.getVideoRelativeOffsetLeft();
              if (Lt !== 0 && $t !== 0) {
                var on = Lt / $t, ht = !1;
                je.isFromCEA608 && (on = 1.1666666666666667, ht = !0);
                var kt = A.call(this, ot, It, Lt, $t, on, ht), Ht = kt.w, Vt = kt.h, Xt = kt.x, Ye = kt.y;
                if (Ht != H || Vt != G || Xt != w || Ye != F || yt) {
                  if (w = Xt + en, F = Ye + Qt, H = Ht, G = Vt, N) {
                    var Me = N.style;
                    Me && (Me.left = w + "px", Me.top = F + "px", Me.width = H + "px", Me.height = G + "px", Me.zIndex = fe && document[fe] || te ? ge : null, g.trigger(n.Z.CAPTION_CONTAINER_RESIZE));
                  }
                  var ct = je.activeCues;
                  if (ct) for (var de = ct.length, _e = 0; _e < de; ++_e) {
                    var Xe = ct[_e];
                    Xe.scaleCue(Xe);
                  }
                }
              }
            }
            function z(je) {
              var yt, ot, It, Lt, $t, Qt = H, en = G;
              if (je.cellResolution) {
                var on = [Qt / je.cellResolution[0], en / je.cellResolution[1]];
                if (je.linePadding) {
                  for (yt in je.linePadding) if (je.linePadding.hasOwnProperty(yt)) {
                    ot = (je.linePadding[yt] * on[0]).toString();
                    for (var ht = document.getElementsByClassName("spanPadding"), kt = 0; kt < ht.length; kt++) ht[kt].style.cssText = ht[kt].style.cssText.replace(/(padding-left\s*:\s*)[\d.,]+(?=\s*px)/gi, "$1" + ot), ht[kt].style.cssText = ht[kt].style.cssText.replace(/(padding-right\s*:\s*)[\d.,]+(?=\s*px)/gi, "$1" + ot);
                  }
                }
                if (je.fontSize) {
                  for (yt in je.fontSize) if (je.fontSize.hasOwnProperty(yt)) {
                    je.fontSize[yt][0] === "%" ? It = je.fontSize[yt][1] / 100 : je.fontSize[yt][0] === "c" && (It = je.fontSize[yt][1]), ot = (It * on[1]).toString(), $t = yt !== "defaultFontSize" ? document.getElementsByClassName(yt) : document.getElementsByClassName("paragraph");
                    for (var Ht = 0; Ht < $t.length; Ht++) $t[Ht].style.cssText = $t[Ht].style.cssText.replace(/(font-size\s*:\s*)[\d.,]+(?=\s*px)/gi, "$1" + ot);
                  }
                  if (je.lineHeight) {
                    for (yt in je.lineHeight) if (je.lineHeight.hasOwnProperty(yt)) {
                      je.lineHeight[yt][0] === "%" ? Lt = je.lineHeight[yt][1] / 100 : je.fontSize[yt][0] === "c" && (Lt = je.lineHeight[yt][1]), ot = (Lt * on[1]).toString(), $t = document.getElementsByClassName(yt);
                      for (var Vt = 0; Vt < $t.length; Vt++) $t[Vt].style.cssText = $t[Vt].style.cssText.replace(/(line-height\s*:\s*)[\d.,]+(?=\s*px)/gi, "$1" + ot);
                    }
                  }
                }
              }
              if (je.isd) {
                var Xt = document.getElementById(je.cueID);
                Xt && N.removeChild(Xt), X(je);
              }
            }
            function se(je, yt) {
              var ot = /^(urn:)(mpeg:[a-z0-9][a-z0-9-]{0,31}:)(subs:)([0-9]+)$/, It = /^#(.*)$/;
              if (ot.test(yt)) {
                var Lt = ot.exec(yt), $t = parseInt(Lt[4], 10) - 1;
                return "data:image/png;base64," + btoa(je.images[$t]);
              }
              if (It.test(yt)) {
                var Qt = It.exec(yt)[1];
                return "data:image/png;base64," + je.embeddedImages[Qt];
              }
              return yt;
            }
            function X(je) {
              if (N) {
                pn.call(this);
                var yt = document.createElement("div");
                N.appendChild(yt), le = (0, qa.renderHTML)(je.isd, yt, function(ot) {
                  return se(je, ot);
                }, N.clientHeight, N.clientWidth, O.get().streaming.text.imsc.displayForcedOnlyMode, function(ot) {
                  l.info("renderCaption :", ot);
                }, le, O.get().streaming.text.imsc.enableRollUp), yt.id = je.cueID, g.trigger(n.Z.CAPTION_RENDERED, { captionDiv: yt, currentTrackIdx: y });
              }
            }
            function k(je, yt) {
              return !!yt && yt.endTime >= je.startTime;
            }
            function J(je, yt) {
              return !!O.get().streaming.text.extendSegmentedCues && !!function(ot, It, Lt) {
                for (var $t = 0; $t < Lt.length; $t++) {
                  var Qt = Lt[$t];
                  if (JSON.stringify(ot[Qt]) !== JSON.stringify(It[Qt])) return !1;
                }
                return !0;
              }(yt, je, Fl) && (yt.endTime = Math.max(yt.endTime, je.endTime), !0);
            }
            function pe(je, yt) {
              yt && yt.forEach(function(ot) {
                ot.kind && ot.kind === "image" && (ot.src = se(je, ot.src)), pe(je, ot.contents);
              });
            }
            function Le(je, yt, ot) {
              var It = Be(je), Lt = O.get().streaming.text.dispatchForManualRendering;
              if (It && Array.isArray(ot) && ot.length !== 0) for (var $t = 0; $t < ot.length; $t++) {
                var Qt = null, en = ot[$t];
                It.cellResolution = en.cellResolution, It.isFromCEA608 = en.isFromCEA608, isNaN(en.start) || isNaN(en.end) || (Lt ? Qt = Ie(en, yt) : et(en) && N ? Qt = st(en, yt, It) : en.data && (Qt = ut(en, yt, It)));
                try {
                  if (Qt) {
                    if (!vt(It, Qt)) if (O.get().streaming.text.webvtt.customRenderingEnabled) It.manualCueList || (It.manualCueList = []), It.manualCueList.push(Qt);
                    else {
                      var on = void 0;
                      It.cues && It.cues.length !== 0 && (on = It.cues[It.cues.length - 1]), k(Qt, on) ? J(Qt, on) || (on.isd && (on.onexit = function() {
                      }), It.mode !== t.Z.TEXT_DISABLED && It.addCue(Qt)) : It.mode !== t.Z.TEXT_DISABLED && It.addCue(Qt);
                    }
                    var ht = O.get().streaming.buffer.bufferToKeep;
                    gt(It, 0, P.getTime() - ht);
                  } else l.error("Impossible to display subtitles. You might have missed setting a TTML rendering div via player.attachTTMLRenderingDiv(TTMLRenderingDiv)");
                } catch (kt) {
                  throw Wt(It), It.addCue(Qt), kt;
                }
              }
            }
            function Ie(je, yt) {
              var ot = tt(je, yt);
              return ot.onenter = function() {
                et(je) && V && V.cueID !== ot.cueID && De(V), delete ot.type, V = ot, xe(ot);
              }, ot.onexit = function() {
                De(ot), V = null;
              }, ot;
            }
            function xe(je) {
              g.trigger(n.Z.CUE_ENTER, je);
            }
            function De(je) {
              g.trigger(n.Z.CUE_EXIT, { cueID: je.cueID });
            }
            function st(je, yt, ot) {
              var It = this, Lt = tt(je, yt);
              return N.style.left = w + "px", N.style.top = F + "px", N.style.width = H + "px", N.style.height = G + "px", Lt.onenter = function() {
                var $t = this;
                ot.mode === t.Z.TEXT_SHOWING && (this.isd ? (oe ? requestAnimationFrame(function() {
                  return X($t);
                }) : X(this), l.debug("Cue enter id:" + this.cueID)) : (N.appendChild(this.cueHTMLElement), z.call(It, this), g.trigger(n.Z.CAPTION_RENDERED, { captionDiv: this.cueHTMLElement, currentTrackIdx: y })));
              }, Lt.onexit = function() {
                if (N) for (var $t = N.childNodes, Qt = 0; Qt < $t.length; ++Qt) $t[Qt].id === this.cueID && (l.debug("Cue exit id:" + $t[Qt].id), N.removeChild($t[Qt]), --Qt);
              }, Lt;
            }
            function ut(je, yt, ot) {
              var It = tt(je, yt);
              if (It.isActive = !1, je.styles) try {
                je.styles.align !== void 0 && "align" in It && (It.align = je.styles.align), je.styles.line !== void 0 && "line" in It && (It.line = je.styles.line), je.styles.snapToLines !== void 0 && "snapToLines" in It && (It.snapToLines = je.styles.snapToLines), je.styles.position !== void 0 && "position" in It && (It.position = je.styles.position), je.styles.size !== void 0 && "size" in It && (It.size = je.styles.size);
              } catch (Lt) {
                l.error(Lt);
              }
              return It.onenter = function() {
                ot.mode === t.Z.TEXT_SHOWING && g.trigger(n.Z.CAPTION_RENDERED, { currentTrackIdx: y });
              }, It;
            }
            function et(je) {
              return je.type === "html";
            }
            function tt(je, yt) {
              return et(je) ? function(ot, It) {
                var Lt = new _(ot.start + It, ot.end + It, "");
                return Lt.cueHTMLElement = ot.cueHTMLElement, Lt.isd = ot.isd, Lt.images = ot.images, Lt.embeddedImages = ot.embeddedImages, Lt.cueID = ot.cueID, Lt.scaleCue = z.bind(self), Lt.cellResolution = ot.cellResolution, Lt.lineHeight = ot.lineHeight, Lt.linePadding = ot.linePadding, Lt.fontSize = ot.fontSize, Lt.isd && pe(Lt, Lt.isd.contents), Lt;
              }(je, yt) : function(ot, It) {
                var Lt = new _(ot.start - It, ot.end - It, ot.data);
                return Lt.cueID = "".concat(Lt.startTime, "_").concat(Lt.endTime), Lt;
              }(je, yt);
            }
            function Ut(je) {
              if (U) for (var yt = U.childNodes, ot = 0; ot < yt.length; ++ot) yt[ot].id === je.cueID && (U.removeChild(yt[ot]), --ot);
            }
            function be() {
              var je, yt = [], ot = function(Lt, $t) {
                var Qt;
                if (typeof Symbol > "u" || Lt[Symbol.iterator] == null) {
                  if (Array.isArray(Lt) || (Qt = function(Vt, Xt) {
                    if (Vt) {
                      if (typeof Vt == "string") return ps(Vt, Xt);
                      var Ye = Object.prototype.toString.call(Vt).slice(8, -1);
                      return Ye === "Object" && Vt.constructor && (Ye = Vt.constructor.name), Ye === "Map" || Ye === "Set" ? Array.from(Vt) : Ye === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Ye) ? ps(Vt, Xt) : void 0;
                    }
                  }(Lt)) || $t) {
                    Qt && (Lt = Qt);
                    var en = 0, on = function() {
                    };
                    return { s: on, n: function() {
                      return en >= Lt.length ? { done: !0 } : { done: !1, value: Lt[en++] };
                    }, e: function(Vt) {
                      throw Vt;
                    }, f: on };
                  }
                  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
                }
                var ht, kt = !0, Ht = !1;
                return { s: function() {
                  Qt = Lt[Symbol.iterator]();
                }, n: function() {
                  var Vt = Qt.next();
                  return kt = Vt.done, Vt;
                }, e: function(Vt) {
                  Ht = !0, ht = Vt;
                }, f: function() {
                  try {
                    kt || Qt.return == null || Qt.return();
                  } finally {
                    if (Ht) throw ht;
                  }
                } };
              }(P.getTextTracks());
              try {
                for (ot.s(); !(je = ot.n()).done; ) {
                  var It = je.value;
                  It.manualMode === t.Z.TEXT_SHOWING && yt.push(It);
                }
              } catch (Lt) {
                ot.e(Lt);
              } finally {
                ot.f();
              }
              return yt;
            }
            function Be(je) {
              return je >= 0 && R[je] ? P.getTextTrack(R[je].kind, R[je].id, R[je].lang, R[je].isTTML, R[je].isEmbedded) : null;
            }
            function mt(je) {
              var yt = this;
              if (je !== y) {
                var ot = Be(y = je);
                Ke.call(this, ot), Z && (clearInterval(Z), Z = null), ot && ot.renderingType === "html" && (ne.call(this, ot, !0), window.ResizeObserver ? (q = new window.ResizeObserver(function() {
                  ne.call(yt, ot, !0);
                })).observe(P.getElement()) : Z = setInterval(ne.bind(this, ot), 500));
              }
            }
            function Ke(je) {
              pn.call(this), je && je.renderingType === "html" ? zt.call(this) : gn.call(this);
            }
            function vt(je, yt) {
              if (!je.cues) return !1;
              for (var ot = 0; ot < je.cues.length; ot++) if (je.cues[ot].startTime === yt.startTime && je.cues[ot].endTime === yt.endTime) return !0;
              return !1;
            }
            function Et(je, yt, ot) {
              var It = !(arguments.length > 3 && arguments[3] !== void 0) || arguments[3];
              return !!je && (isNaN(yt) || (It ? je.startTime : je.endTime) >= yt) && (isNaN(ot) || (It ? je.endTime : je.startTime) <= ot);
            }
            function gt(je, yt, ot) {
              var It, Lt;
              if (!(ot < yt) && je && (je.cues || je.manualCueList)) {
                var $t = je.cues && je.cues.length > 0 ? "native" : "custom", Qt = $t === "native" ? je.cues : je.manualCueList;
                if (!Qt || Qt.length === 0) return;
                for (var en = Qt.length - 1; en >= 0; en--) !Et(Qt[en], yt, ot, !0) || (It = Qt[en], Lt = P.getTime(), It.startTime >= Lt && It.endTime <= Lt) || ($t === "native" ? je.removeCue(Qt[en]) : (Ut(Qt[en]), delete je.manualCueList[en]));
              }
            }
            function Wt(je, yt, ot) {
              var It = !(arguments.length > 3 && arguments[3] !== void 0) || arguments[3];
              if (je && (je.cues || je.manualCueList)) {
                var Lt = je.cues && je.cues.length > 0 ? "native" : "custom", $t = Lt === "native" ? je.cues : je.manualCueList;
                if (!$t || $t.length === 0) return;
                for (var Qt = $t.length - 1, en = Qt; en >= 0; en--) Et($t[en], yt, ot, It) && (Lt === "native" ? ($t[en].onexit && $t[en].onexit(), je.removeCue($t[en])) : (Ut($t[en]), delete je.manualCueList[en]));
              }
            }
            function zt() {
              var je = document.getElementById("native-cue-style");
              if (!je) {
                (je = document.createElement("style")).id = "native-cue-style", document.head.appendChild(je);
                var yt = je.sheet, ot = P.getElement();
                try {
                  ot && (ot.id ? yt.insertRule("#" + ot.id + "::cue {background: transparent}", 0) : ot.classList.length !== 0 ? yt.insertRule("." + ot.className + "::cue {background: transparent}", 0) : yt.insertRule("video::cue {background: transparent}", 0));
                } catch (It) {
                  l.info("" + It.message);
                }
              }
            }
            function gn() {
              var je = document.getElementById("native-cue-style");
              je && document.head.removeChild(je);
            }
            function pn() {
              if (N) for (; N.firstChild; ) N.removeChild(N.firstChild);
            }
            return r = { initialize: function() {
              typeof window < "u" && typeof navigator < "u" && (_ = window.VTTCue || window.TextTrackCue, R = [], I = [], y = -1, w = 0, F = 0, H = 0, G = 0, N = null, U = null, Z = null, te = !1, ge = 2147483647, le = null, oe = "requestAnimationFrame" in window, document.fullscreenElement !== void 0 ? fe = "fullscreenElement" : document.webkitIsFullScreen !== void 0 ? fe = "webkitIsFullScreen" : document.msFullscreenElement ? fe = "msFullscreenElement" : document.mozFullScreen && (fe = "mozFullScreen"));
            }, getStreamId: function() {
              return D.id;
            }, addTextTrack: function(je) {
              R.push(je);
            }, addCaptions: Le, createTracks: function() {
              var je = O.get().streaming.text.dispatchForManualRendering;
              R.sort(function(Xt, Ye) {
                return Xt.index - Ye.index;
              }), N = P.getTTMLRenderingDiv(), U = P.getVttRenderingDiv();
              for (var yt, ot, It, Lt, $t, Qt, en = -1, on = 0; on < R.length; on++) {
                var ht = (ot = (yt = R[on]).kind, It = yt.id !== void 0 ? yt.id : yt.lang, Lt = yt.lang, $t = yt.isTTML, Qt = yt.isEmbedded, P.addTextTrack(ot, It, Lt, $t, Qt));
                I.push(ht), R[on].defaultTrack && (ht.default = !0, en = on);
                var kt = Be(on);
                kt && (kt.mode = t.Z.TEXT_SHOWING, N && (R[on].isTTML || R[on].isEmbedded) ? kt.renderingType = "html" : kt.renderingType = "default"), Le(on, 0, R[on].captionData), g.trigger(n.Z.TEXT_TRACK_ADDED);
              }
              if (mt.call(this, en), en >= 0) {
                g.on(n.Z.PLAYBACK_METADATA_LOADED, function Xt() {
                  var Ye = Be(en);
                  Ye && Ye.renderingType === "html" && ne.call(this, Ye, !0), g.off(n.Z.PLAYBACK_METADATA_LOADED, Xt, this);
                }, this);
                for (var Ht = 0; Ht < R.length; Ht++) {
                  var Vt = Be(Ht);
                  Vt && (Vt.mode = Ht !== en || je ? t.Z.TEXT_HIDDEN : t.Z.TEXT_SHOWING, Vt.manualMode = Ht === en ? t.Z.TEXT_SHOWING : t.Z.TEXT_HIDDEN);
                }
              }
              g.trigger(o.Z.TEXT_TRACKS_QUEUE_INITIALIZED, { index: y, tracks: R, streamId: D.id });
            }, getCurrentTrackIdx: function() {
              return y;
            }, setCurrentTrackIdx: mt, getTrackIdxForId: function(je) {
              for (var yt = -1, ot = 0; ot < R.length; ot++) if (R[ot].id === je) {
                yt = ot;
                break;
              }
              return yt;
            }, getCurrentTrackInfo: function() {
              return R[y];
            }, setModeForTrackIdx: function(je, yt) {
              var ot = Be(je);
              ot && ot.mode !== yt && (ot.mode = yt), ot && ot.manualMode !== yt && (ot.manualMode = yt);
            }, deleteCuesFromTrackIdx: function(je, yt, ot) {
              var It = Be(je);
              It && Wt(It, yt, ot);
            }, deleteAllTextTracks: function() {
              for (var je = I ? I.length : 0, yt = 0; yt < je; yt++) {
                var ot = Be(yt);
                ot && Wt.call(this, ot, D.start, D.start + D.duration, !1);
              }
              I = [], R = [], Z && (clearInterval(Z), Z = null), q && P && (q.unobserve(P.getElement()), q = null), y = -1, pn.call(this);
            }, manualCueProcessing: function(je) {
              var yt = be();
              if (yt.length > 0) {
                var ot = yt[0].manualCueList;
                ot && ot.length > 0 && ot.forEach(function(It) {
                  It.startTime <= je && It.endTime >= je && !It.isActive ? (It.isActive = !0, O.get().streaming.text.dispatchForManualRendering ? xe(It) : WebVTT.processCues(window, [It], U, It.cueID)) : It.isActive && (It.startTime > je || It.endTime < je) && (It.isActive = !1, O.get().streaming.text.dispatchForManualRendering ? De(It) : Ut(It));
                });
              }
            }, disableManualTracks: function() {
              var je = be();
              if (je.length > 0) {
                var yt = je[0].manualCueList;
                yt && yt.length > 0 && yt.forEach(function(ot) {
                  if (ot.isActive) {
                    if (ot.isActive = !1, O.get().streaming.text.dispatchForManualRendering) De(ot);
                    else if (U) for (var It = U.childNodes, Lt = 0; Lt < It.length; ++Lt) It[Lt].id === ot.cueID && (U.removeChild(It[Lt]), --Lt);
                  }
                });
              }
            } }, l = (0, h.Z)(ce).getInstance().getLogger(r), r;
          }
          ys.__dashjs_factory_name = "TextTracks";
          var kl = E.Z.getClassFactory(ys);
          function _s() {
            var i, r, l, _, R, I, y = this.context;
            function w(N) {
              var U = N.split(":"), Z = U.length - 1;
              return N = 60 * parseInt(U[Z - 1], 10) + parseFloat(U[Z]), Z === 2 && (N += 3600 * parseInt(U[0], 10)), N;
            }
            function F(N) {
              var U = N.split(_), Z = U[1].split(I);
              return Z.shift(), U[1] = Z[0], Z.shift(), { cuePoints: U, styles: H(Z) };
            }
            function H(N) {
              var U = {};
              return N.forEach(function(Z) {
                if (Z.split(/:/).length > 1) {
                  var fe = Z.split(/:/)[1], te = !1;
                  fe && fe.search(/%/) != -1 && (te = !0, fe = parseInt(fe.replace(/%/, ""), 10)), (Z.match(/align/) || Z.match(/A/)) && (U.align = fe), (Z.match(/line/) || Z.match(/L/)) && (U.line = fe === "auto" ? fe : parseInt(fe, 10), te && (U.snapToLines = !1)), (Z.match(/position/) || Z.match(/P/)) && (U.position = fe), (Z.match(/size/) || Z.match(/S/)) && (U.size = fe);
                }
              }), U;
            }
            function G(N, U) {
              for (var Z, fe = U, te = "", le = ""; N[fe] !== "" && fe < N.length; ) fe++;
              if ((Z = fe - U) > 1) for (var ge = 0; ge < Z; ge++) {
                if ((le = N[U + ge]).match(_)) {
                  te = "";
                  break;
                }
                te += le, ge !== Z - 1 && (te += `
`);
              }
              else (le = N[U]).match(_) || (te = le);
              return te;
            }
            return i = { parse: function(N) {
              var U, Z, fe = [];
              if (!N) return fe;
              U = (N = N.split(l)).length, Z = -1;
              for (var te = 0; te < U; te++) {
                var le = N[te];
                if (le.length > 0 && le !== "WEBVTT" && le.match(_)) {
                  var ge = F(le), q = ge.cuePoints, oe = ge.styles, V = G(N, te + 1), ce = w(q[0].replace(R, "")), g = w(q[1].replace(R, ""));
                  !isNaN(ce) && !isNaN(g) && ce >= Z && g > ce ? V !== "" ? (Z = ce, fe.push({ start: ce, end: g, data: V, styles: oe })) : r.error("Skipping cue due to empty/malformed cue text") : r.error("Skipping cue due to incorrect cue timing");
                }
              }
              return fe;
            }, getCaptionStyles: H }, r = (0, h.Z)(y).getInstance().getLogger(i), l = /(?:\r\n|\r|\n)/gm, _ = /-->/, R = /(^[\s]+|[\s]+$)/g, I = /\s\b/g, i;
          }
          _s.__dashjs_factory_name = "VTTParser";
          var Zl = E.Z.getSingletonFactory(_s);
          function Es() {
            var i, r;
            return i = { parse: function(l) {
              var _ = [];
              return r.oncue = function(R) {
                R.start = R.startTime, R.end = R.endTime, R.data = R.text, R.styles = { align: R.align, line: R.line, position: R.position, size: R.size }, _.push(R);
              }, r.parse(l), _;
            } }, function() {
              try {
                window && window.WebVTT && window.WebVTT.Parser && (r = new window.WebVTT.Parser(window, window.vttjs, window.WebVTT.StringDecoder()));
              } catch {
              }
            }(), i;
          }
          Es.__dashjs_factory_name = "VttCustomRenderingParser";
          var Ul = E.Z.getSingletonFactory(Es);
          function vs() {
            var i, r, l = this.context, _ = (0, m.Z)(l).getInstance(), R = 0;
            return i = { parse: function(I, y, w, F, H) {
              var G, N, U, Z = "", fe = [], te = {}, le = {}, ge = "", q = "", oe = { onOpenTag: function(D, O, A) {
                if (A[" imagetype"] && !A[" imageType"] && (_.trigger(n.Z.CONFORMANCE_VIOLATION, { level: si.LEVELS.ERROR, event: si.EVENTS.NON_COMPLIANT_SMPTE_IMAGE_ATTRIBUTE }), A[" imageType"] = A[" imagetype"]), O === "image" && (D === "http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt" || D === "http://www.smpte-ra.org/schemas/2052-1/2013/smpte-tt")) {
                  if (!A[" imageType"] || A[" imageType"].value !== "PNG") return void r.warn("smpte-tt imageType != PNG. Discarded");
                  ge = A["http://www.w3.org/XML/1998/namespace id"].value;
                }
              }, onCloseTag: function() {
                ge && (le[ge] = q.trim()), q = "", ge = "";
              }, onText: function(D) {
                ge && (q += D);
              } };
              if (!I) throw Z = "no ttml data to parse", new Error(Z);
              te.data = I, _.trigger(o.Z.TTML_TO_PARSE, te);
              var V = (0, qa.fromXML)(te.data, function(D) {
                Z = D;
              }, oe);
              _.trigger(o.Z.TTML_PARSED, { ttmlString: te.data, ttmlDoc: V });
              var ce, g = V.getMediaTimeEvents();
              for (U = 0; U < g.length; U++) {
                var P = (0, qa.generateISD)(V, g[U], function(D) {
                  Z = D;
                });
                P.contents.some(function(D) {
                  return D.contents.length;
                }) && (G = g[U] + y) < (N = g[U + 1] + y) && fe.push({ start: G, end: N, type: "html", cueID: (ce = "cue_TTML_" + R, R++, ce), isd: P, images: H, embeddedImages: le });
              }
              if (Z !== "") throw r.error(Z), new Error(Z);
              return fe;
            } }, r = (0, h.Z)(l).getInstance().getLogger(i), i;
          }
          vs.__dashjs_factory_name = "TTMLParser";
          var Bl = E.Z.getSingletonFactory(vs);
          function Ts(i, r) {
            var l = Object.keys(i);
            if (Object.getOwnPropertySymbols) {
              var _ = Object.getOwnPropertySymbols(i);
              r && (_ = _.filter(function(R) {
                return Object.getOwnPropertyDescriptor(i, R).enumerable;
              })), l.push.apply(l, _);
            }
            return l;
          }
          function bs(i) {
            for (var r = 1; r < arguments.length; r++) {
              var l = arguments[r] != null ? arguments[r] : {};
              r % 2 ? Ts(Object(l), !0).forEach(function(_) {
                Gl(i, _, l[_]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(l)) : Ts(Object(l)).forEach(function(_) {
                Object.defineProperty(i, _, Object.getOwnPropertyDescriptor(l, _));
              });
            }
            return i;
          }
          function Gl(i, r, l) {
            return r in i ? Object.defineProperty(i, r, { value: l, enumerable: !0, configurable: !0, writable: !0 }) : i[r] = l, i;
          }
          function Ss(i, r) {
            (r == null || r > i.length) && (r = i.length);
            for (var l = 0, _ = new Array(r); l < r; l++) _[l] = i[l];
            return _;
          }
          function As(i) {
            var r, l, _, R = this.context, I = (0, m.Z)(R).getInstance(), y = (0, Je.Z)(R).getInstance(), w = i.adapter, F = i.baseURLController;
            function H(U, Z) {
              var fe, te, le = !1;
              if (F.resolve()) {
                var ge = w.getVoRepresentations(U);
                ge && ge.length > 0 && (fe = F.resolve(ge[0].path).url);
              }
              var q = U.essentialPropertiesAsArray.filter(function(V) {
                return V.schemeIdUri && V.schemeIdUri === t.Z.FONT_DOWNLOAD_DVB_SCHEME;
              }), oe = U.supplementalPropertiesAsArray.filter(function(V) {
                return V.schemeIdUri && V.schemeIdUri === t.Z.FONT_DOWNLOAD_DVB_SCHEME;
              });
              q.length > 0 ? (le = !0, te = q) : te = oe, te.forEach(function(V) {
                if (function(D) {
                  return !(!(D.value && D.value === "1" && D.dvbUrl && D.dvbUrl.length > 0 && D.dvbFontFamily && D.dvbFontFamily.length > 0 && D.dvbMimeType) || D.dvbMimeType !== t.Z.OFF_MIMETYPE && D.dvbMimeType !== t.Z.WOFF_MIMETYPE);
                }(V)) {
                  var ce = (g = V.dvbUrl, P = fe, y.isPathAbsolute(g) ? g : y.isRelative(g) ? P ? y.resolve(g, P) : y.resolve(g) : g);
                  _.push({ fontFamily: V.dvbFontFamily, url: ce, mimeType: V.dvbMimeType, trackId: U.id, streamId: Z, isEssential: le, status: "unloaded", fontFace: new FontFace(V.dvbFontFamily, "url(".concat(ce, ")"), { display: "swap" }) });
                }
                var g, P;
              });
            }
            function G(U, Z) {
              var fe = _[U];
              _[U] = bs(bs({}, fe), {}, { status: Z });
            }
            function N() {
              _ = [];
            }
            return r = { addFontsFromTracks: function(U, Z) {
              if (U && Array.isArray(U) && Z) for (var fe = 0; fe < U.length; fe++) H(U[fe], Z);
            }, downloadFonts: function() {
              for (var U = function(fe) {
                var te = _[fe];
                document.fonts.add(te.fontFace), I.trigger(n.Z.DVB_FONT_DOWNLOAD_ADDED, te), te.fontFace.load().then(function() {
                  G(fe, "loaded"), I.trigger(n.Z.DVB_FONT_DOWNLOAD_COMPLETE, te);
                }, function(le) {
                  G(fe, "error"), l.debug("Font download error: ", le), I.trigger(n.Z.DVB_FONT_DOWNLOAD_FAILED, te);
                });
              }, Z = 0; Z < _.length; Z++) U(Z);
            }, getFonts: function() {
              return _;
            }, getFontsForTrackId: function(U) {
              return _.filter(function(Z) {
                return Z.trackId && Z.trackId === U;
              });
            }, reset: function() {
              (function() {
                var U, Z = function(le, ge) {
                  var q;
                  if (typeof Symbol > "u" || le[Symbol.iterator] == null) {
                    if (Array.isArray(le) || (q = function(D, O) {
                      if (D) {
                        if (typeof D == "string") return Ss(D, O);
                        var A = Object.prototype.toString.call(D).slice(8, -1);
                        return A === "Object" && D.constructor && (A = D.constructor.name), A === "Map" || A === "Set" ? Array.from(D) : A === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(A) ? Ss(D, O) : void 0;
                      }
                    }(le)) || ge) {
                      q && (le = q);
                      var oe = 0, V = function() {
                      };
                      return { s: V, n: function() {
                        return oe >= le.length ? { done: !0 } : { done: !1, value: le[oe++] };
                      }, e: function(D) {
                        throw D;
                      }, f: V };
                    }
                    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
                  }
                  var ce, g = !0, P = !1;
                  return { s: function() {
                    q = le[Symbol.iterator]();
                  }, n: function() {
                    var D = q.next();
                    return g = D.done, D;
                  }, e: function(D) {
                    P = !0, ce = D;
                  }, f: function() {
                    try {
                      g || q.return == null || q.return();
                    } finally {
                      if (P) throw ce;
                    }
                  } };
                }(_);
                try {
                  for (Z.s(); !(U = Z.n()).done; ) {
                    var fe = U.value, te = document.fonts.delete(fe.fontFace);
                    l.debug("Removal of fontFamily: ".concat(fe.fontFamily, " was ").concat(te ? "successful" : "unsuccessful"));
                  }
                } catch (le) {
                  Z.e(le);
                } finally {
                  Z.f();
                }
              })(), N();
            } }, l = (0, h.Z)(R).getInstance().getLogger(r), N(), r;
          }
          As.__dashjs_factory_name = "DVBFonts";
          var ql = E.Z.getClassFactory(As);
          function Is(i) {
            var r, l, _, R, I, y, w, F, H, G, N, U, Z, fe, te = this.context, le = i.adapter, ge = i.errHandler, q = i.manifestModel, oe = i.mediaController, V = i.baseURLController, ce = i.videoModel, g = i.settings;
            function P(J) {
              if (fe.error("Could not download ".concat(J.isEssential ? "an essential" : "a", " font - fontFamily: ").concat(J.fontFamily, ", url: ").concat(J.url)), J.isEssential) {
                var pe = R[J.streamId].getTrackIdxForId(J.trackId);
                R[J.streamId].setModeForTrackIdx(pe, t.Z.TEXT_DISABLED);
              }
            }
            function D(J) {
              if (fe.debug("Successfully downloaded ".concat(J.isEssential ? "an essential" : "a", " font - fontFamily: ").concat(J.fontFamily, ", url: ").concat(J.url)), J.isEssential) {
                var pe = R[J.streamId].getTrackIdxForId(J.trackId);
                pe === R[J.streamId].getCurrentTrackIdx() ? R[J.streamId].setModeForTrackIdx(pe, t.Z.TEXT_SHOWING) : R[J.streamId].setModeForTrackIdx(pe, t.Z.TEXT_HIDDEN);
              }
            }
            function O(J) {
              var pe = J.tracks, Le = J.index, Ie = J.streamId;
              if (g.get().streaming.text.defaultEnabled === !1 && !z() || U) se(Ie, -1);
              else {
                var xe = oe.getCurrentTrackFor(t.Z.TEXT, Ie);
                if (xe) {
                  var De = { lang: xe.lang, role: xe.roles[0], index: xe.index, codec: xe.codec, accessibility: xe.accessibility[0] };
                  pe.some(function(st, ut) {
                    if (oe.matchSettings(De, st)) return se(Ie, ut), Le = ut, !0;
                  });
                }
                H = !1;
              }
              l[Ie].lastEnabledIndex = Le, F.trigger(n.Z.TEXT_TRACKS_ADDED, { enabled: z(), index: Le, tracks: pe, streamId: Ie }), N = !0, Z.addFontsFromTracks(pe, Ie), Z.getFonts().forEach(function(st) {
                if (st.isEssential) {
                  var ut = R[st.streamId].getTrackIdxForId(st.trackId);
                  R[st.streamId].setModeForTrackIdx(ut, t.Z.TEXT_DISABLED);
                }
              }), Z.downloadFonts();
            }
            function A(J) {
              try {
                var pe = J.streamId;
                if (!R[pe] || isNaN(J.time)) return;
                R[pe].manualCueProcessing(J.time);
              } catch {
              }
            }
            function ne(J) {
              try {
                var pe = J.streamId;
                if (!R[pe]) return;
                R[pe].disableManualTracks();
              } catch {
              }
            }
            function z() {
              var J = !0;
              return H && !G && (J = !1), J;
            }
            function se(J, pe) {
              (H = pe === -1) && oe && oe.saveTextSettingsDisabled();
              var Le = X(J);
              if (Le !== pe && R[J]) {
                R[J].disableManualTracks();
                var Ie = R[J].getCurrentTrackInfo(), xe = Ie ? ce.getTextTrack(Ie.kind, Ie.id, Ie.lang, Ie.isTTML, Ie.isEmbedded) : null;
                xe && xe.mode !== t.Z.TEXT_DISABLED && R[J].setModeForTrackIdx(Le, t.Z.TEXT_HIDDEN), R[J].setCurrentTrackIdx(pe), Ie = R[J].getCurrentTrackInfo();
                var De = g.get().streaming.text.dispatchForManualRendering;
                Ie && !De && Ie.mode !== t.Z.TEXT_DISABLED && R[J].setModeForTrackIdx(pe, t.Z.TEXT_SHOWING), Ie && Ie.isFragmented && !Ie.isEmbedded ? function(st, ut, et) {
                  if (_[st]) for (var tt = _[st].getConfig().fragmentedTracks, Ut = 0; Ut < tt.length; Ut++) {
                    var be = tt[Ut];
                    if (ut.lang === be.lang && (be.id ? ut.id === be.id : ut.index === be.index)) {
                      var Be = oe.getCurrentTrackFor(t.Z.TEXT, st);
                      (be.id ? Be.id !== be.id : Be.index !== be.index) ? (R[st].deleteCuesFromTrackIdx(et), _[st].setCurrentFragmentedTrackIdx(Ut)) : et === -1 && F.trigger(o.Z.SET_FRAGMENTED_TEXT_AFTER_DISABLED, {}, { streamId: st, mediaType: t.Z.TEXT });
                    }
                  }
                }(J, Ie, Le) : Ie && !Ie.isFragmented && function(st, ut) {
                  F.trigger(o.Z.SET_NON_FRAGMENTED_TEXT, { currentTrackInfo: ut }, { streamId: st, mediaType: t.Z.TEXT });
                }(J, Ie), oe.setTrack(Ie);
              }
            }
            function X(J) {
              return R[J].getCurrentTrackIdx();
            }
            function k() {
              _ = {}, R = {}, l = {}, H = !0, N = !1, U = !1;
            }
            return r = { deactivateStream: function(J) {
              if (J) {
                var pe = J.id;
                _[pe] && _[pe].resetMediaInfos(), R[pe] && R[pe].deleteAllTextTracks();
              }
            }, initialize: function() {
              Z = ql(te).create({ adapter: le, baseURLController: V }), F.on(o.Z.TEXT_TRACKS_QUEUE_INITIALIZED, O, r), F.on(o.Z.DVB_FONT_DOWNLOAD_FAILED, P, r), F.on(o.Z.DVB_FONT_DOWNLOAD_COMPLETE, D, r), g.get().streaming.text.webvtt.customRenderingEnabled && (F.on(o.Z.PLAYBACK_TIME_UPDATED, A, r), F.on(o.Z.PLAYBACK_SEEKING, ne, r));
            }, initializeForStream: function(J) {
              var pe = J.id, Le = kl(te).create({ videoModel: ce, settings: g, streamInfo: J });
              Le.initialize(), R[pe] = Le;
              var Ie = xl(te).create({ errHandler: ge, adapter: le, dvbFonts: Z, manifestModel: q, mediaController: oe, videoModel: ce, textTracks: Le, vttParser: I, vttCustomRenderingParser: y, ttmlParser: w, streamInfo: J, settings: g });
              Ie.initialize(), _[pe] = Ie, l[pe] = {}, l[pe].lastEnabledIndex = -1;
            }, createTracks: function(J) {
              var pe = J.id;
              R[pe] && R[pe].createTracks();
            }, getTextSourceBuffer: function(J) {
              var pe = J.id;
              if (_ && _[pe]) return _[pe];
            }, getAllTracksAreDisabled: function() {
              return H;
            }, addEmbeddedTrack: function(J, pe) {
              var Le = J.id;
              _[Le] && _[Le].addEmbeddedTrack(pe);
            }, enableText: function(J, pe) {
              return (0, W.PS)(pe, "boolean"), z() !== pe && (pe && se(J, l[J].lastEnabledIndex), pe || (l[J].lastEnabledIndex = X(J), N ? se(J, -1) : U = !0)), !0;
            }, isTextEnabled: z, setTextTrack: se, getCurrentTrackIdx: X, enableForcedTextStreaming: function(J) {
              return (0, W.PS)(J, "boolean"), G = J, !0;
            }, addMediaInfosToBuffer: function(J, pe, Le) {
              var Ie = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, xe = J.id;
              _[xe] && _[xe].addMediaInfos(pe, Le, Ie);
            }, reset: function() {
              Z.reset(), k(), F.off(o.Z.TEXT_TRACKS_QUEUE_INITIALIZED, O, r), F.off(o.Z.DVB_FONT_DOWNLOAD_FAILED, P, r), F.off(o.Z.DVB_FONT_DOWNLOAD_COMPLETE, D, r), g.get().streaming.text.webvtt.customRenderingEnabled && (F.off(o.Z.PLAYBACK_TIME_UPDATED, A, r), F.off(o.Z.PLAYBACK_SEEKING, ne, r)), Object.keys(_).forEach(function(J) {
                _[J].resetEmbedded(), _[J].reset();
              });
            } }, G = !1, N = !1, U = !1, I = Zl(te).getInstance(), y = Ul(te).getInstance(), w = Bl(te).getInstance(), F = (0, m.Z)(te).getInstance(), fe = (0, h.Z)(te).getInstance().getLogger(r), k(), r;
          }
          Is.__dashjs_factory_name = "TextController";
          var Hl = E.Z.getClassFactory(Is);
          function Ha() {
            var i, r, l, _, R, I, y, w, F, H, G, N, U, Z, fe, te, le, ge, q, oe, V, ce, g, P, D, O, A, ne, z, se, X, k, J, pe, Le, Ie, xe, De, st, ut = "You must first call initialize() and set a source before calling this method", et = "You must first call initialize() and set a valid source and view before calling this method", tt = "You must first call attachView() to set the video element before calling this method", Ut = "You must first call attachSource() with a valid source before calling this method", be = "MediaPlayer not initialized!", Be = this.context, mt = (0, m.Z)(Be).getInstance(), Ke = (0, Ne.Z)(Be).getInstance(), vt = (0, h.Z)(Be).getInstance({ settings: Ke });
            function Et() {
              on(null), Qt(null), _ = null, Z && (Z.reset(), Z = null), fe && (fe.reset(), fe = null), oe && oe.reset(), Ke.reset(), le && (le.reset(), le = null);
            }
            function gt() {
              return !!l && !!Ie.getElement();
            }
            function Wt() {
              return (0, il.e)();
            }
            function zt() {
              if (!y) throw et;
              return ne.isPaused();
            }
            function gn() {
              if (!y) throw et;
              return ne.getIsDynamic();
            }
            function pn(de) {
              var _e = D && D.hasVideoTrack() ? t.Z.VIDEO : t.Z.AUDIO, Xe = k.getCurrentDVRInfo(_e);
              if (!Xe) return 0;
              var Ct = ne.getOriginalLiveDelay(), xt = Xe.range.start + de;
              return xt > Xe.range.end - Ct && (xt = Xe.range.end - Ct), xt;
            }
            function je(de) {
              if (!y) throw et;
              var _e = $t().currentTime;
              if (de !== void 0) _e = D.getTimeRelativeToStreamId(_e, de);
              else if (ne.getIsDynamic()) {
                var Xe = D && D.hasVideoTrack() ? t.Z.VIDEO : t.Z.AUDIO, Ct = k.getCurrentDVRInfo(Xe);
                _e = Ct === null || _e === 0 ? 0 : Math.max(0, _e - Ct.range.start);
              }
              return _e;
            }
            function yt() {
              if (!y) throw et;
              var de = $t().duration;
              if (ne.getIsDynamic()) {
                var _e = D && D.hasVideoTrack() ? t.Z.VIDEO : t.Z.AUDIO, Xe = k.getCurrentDVRInfo(_e);
                de = Xe ? Xe.range.end - Xe.range.start : 0;
              }
              return de;
            }
            function ot(de) {
              (0, W.PS)(de, "boolean"), w = de;
            }
            function It() {
              oe.restoreDefaultUTCTimingSources();
            }
            function Lt() {
              return k;
            }
            function $t() {
              if (!Ie.getElement()) throw tt;
              return Ie.getElement();
            }
            function Qt(de) {
              if (!R) throw be;
              Ie.setElement(de), de && (Xt(), function() {
                if (!fe) {
                  var _e = dashjs.MetricsReporting;
                  if (typeof _e == "function") {
                    var Xe = _e(Be).create();
                    fe = Xe.createMetricsReporting({ debug: vt, eventBus: mt, mediaElement: $t(), adapter: ge, dashMetrics: k, mediaPlayerModel: q, events: o.Z, constants: t.Z, metricsConstants: p.Z });
                  }
                }
              }(), function() {
                if (!te) {
                  var _e = dashjs.MssHandler;
                  typeof _e == "function" && (Q.extend(_e.errors), te = _e(Be).create({ eventBus: mt, mediaPlayerModel: q, dashMetrics: k, manifestModel: J, playbackController: ne, streamController: D, protectionController: Z, baseURLController: ce, errHandler: V, events: o.Z, constants: t.Z, debug: vt, initSegmentType: Ue.w.INIT_SEGMENT_TYPE, BASE64: Ua, ISOBoxer: Wi, settings: Ke }));
                }
              }(), D && D.switchToVideoElement(F)), y && kt(), ct(F);
            }
            function en(de) {
              if (!I) throw ut;
              var _e = D.getActiveStreamInfo();
              return _e ? U.getTracksFor(de, _e.id) : [];
            }
            function on(de) {
              var _e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : NaN;
              if (!R) throw be;
              typeof de == "string" && xe.initialize(de), _e == null && (_e = NaN), isNaN(_e) || (_e = Math.max(0, _e)), F = _e, l = de, (I || y) && kt(), gt() && ct(F);
            }
            function ht() {
              if (!I) throw ut;
              var de = D.getActiveStreamInfo();
              return de ? D.getStreamById(de.id) : null;
            }
            function kt() {
              y = !1, I = !1, ge.reset(), D.reset(), A.reset(), X.reset(), ne.reset(), z.reset(), se.reset(), H.reset(), U.reset(), st.reset(), Z && (Ke.get().streaming.protection.keepProtectionMediaKeys ? Z.stop() : (Z.reset(), Z = null, Xt())), O.reset(), pe.reset(), Le.reset();
            }
            function Ht() {
              var de = Vt();
              D || (D = ho(Be).getInstance()), O || (O = Hl(Be).create({ errHandler: V, manifestModel: J, adapter: ge, mediaController: U, baseURLController: ce, videoModel: Ie, settings: Ke })), P.setConfig({ capabilities: g, customParametersModel: oe, adapter: ge, settings: Ke, manifestModel: J, errHandler: V }), D.setConfig({ capabilities: g, capabilitiesFilter: P, manifestLoader: de, manifestModel: J, mediaPlayerModel: q, customParametersModel: oe, protectionController: Z, textController: O, adapter: ge, dashMetrics: k, errHandler: V, timelineConverter: N, videoModel: Ie, playbackController: ne, serviceDescriptionController: z, contentSteeringController: se, abrController: H, mediaController: U, settings: Ke, baseURLController: ce, uriFragmentModel: xe, segmentBaseController: st }), A.setConfig({ settings: Ke, playbackController: ne, streamController: D, videoModel: Ie, timelineConverter: N, adapter: ge }), ne.setConfig({ streamController: D, serviceDescriptionController: z, dashMetrics: k, adapter: ge, videoModel: Ie, timelineConverter: N, settings: Ke }), X.setConfig({ streamController: D, playbackController: ne, mediaPlayerModel: q, videoModel: Ie, settings: Ke }), H.setConfig({ streamController: D, domStorage: De, mediaPlayerModel: q, customParametersModel: oe, cmsdModel: Le, dashMetrics: k, adapter: ge, videoModel: Ie, settings: Ke }), pe.setConfig({ abrController: H, dashMetrics: k, playbackController: ne }), Le.setConfig({}), H.initialize(), D.initialize(w, _), O.initialize(), A.initialize(), X.initialize(), pe.initialize(), Le.initialize(), se.initialize(), st.initialize();
            }
            function Vt() {
              return qu(Be).create({ debug: vt, errHandler: V, dashMetrics: k, mediaPlayerModel: q, requestModifier: (0, Re.Z)(Be).getInstance(), mssHandler: te, settings: Ke });
            }
            function Xt() {
              if (Z) return Z;
              var de = dashjs.Protection;
              if (typeof de == "function") {
                var _e = de(Be).create();
                return o.Z.extend(de.events), n.Z.extend(de.events, { publicOnly: !0 }), Q.extend(de.errors), g || (g = (0, Uo.Z)(Be).getInstance()), Z = _e.createProtectionSystem({ debug: vt, errHandler: V, videoModel: Ie, customParametersModel: oe, capabilities: g, eventBus: mt, events: o.Z, BASE64: Ua, constants: t.Z, cmcdModel: pe, settings: Ke });
              }
              return null;
            }
            function Ye() {
              if (!R) throw be;
              if (le) return le;
              var de = dashjs.OfflineController;
              if (typeof de == "function") {
                o.Z.extend(de.events), n.Z.extend(de.events, { publicOnly: !0 }), Q.extend(de.errors);
                var _e = Vt(), Xe = lo(Be).create();
                return Xe.setConfig({ manifestModel: J, adapter: ge, manifestLoader: _e, errHandler: V, contentSteeringController: se }), le = de(Be).create({ debug: vt, manifestUpdater: Xe, baseURLController: ce, manifestLoader: _e, manifestModel: J, mediaPlayerModel: q, abrController: H, playbackController: ne, adapter: ge, errHandler: V, dashMetrics: k, timelineConverter: N, segmentBaseController: st, schemeLoaderFactory: G, eventBus: mt, events: o.Z, errors: Q, constants: t.Z, settings: Ke, dashConstants: e.Z, urlUtils: (0, Je.Z)(Be).getInstance() });
              }
              return null;
            }
            function Me(de) {
              var _e = D && D.hasVideoTrack() ? t.Z.VIDEO : t.Z.AUDIO, Xe = k.getCurrentDVRInfo(_e);
              return Xe ? de + (Xe.manifestInfo.availableFrom.getTime() / 1e3 + Xe.range.start) : 0;
            }
            function ct() {
              var de = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : NaN;
              le && le.resetRecords(), !I && l && (I = !0, r.info("Streaming Initialized"), Ht(), typeof l == "string" ? D.load(l, de) : D.loadWithManifest(l, de)), !y && gt() && (y = !0, r.info("Playback Initialized"));
            }
            return i = { initialize: function(de, _e, Xe) {
              var Ct = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : NaN;
              g || (g = (0, Uo.Z)(Be).getInstance()).setConfig({ settings: Ke }), V || (V = Hu(Be).getInstance()), g.supportsMediaSource() ? (R || (R = !0, N = Dl(Be).getInstance(), H || (H = Ju(Be).getInstance()).setConfig({ settings: Ke }), G || (G = Kn(Be).getInstance()), ne || (ne = d(Be).getInstance()), U || (U = fu(Be).getInstance()), D || (D = ho(Be).getInstance()), A || (A = ou(Be).getInstance()), X || (X = su(Be).getInstance()), z || (z = lu(Be).getInstance()), se || (se = Sr(Be).getInstance()), P || (P = Vu(Be).getInstance()), ge = hl(Be).getInstance(), J = Ku(Be).getInstance(), pe = mn(Be).getInstance(), Le = Ft(Be).getInstance(), k = Nl(Be).getInstance({ settings: Ke }), De = rl(Be).getInstance({ settings: Ke }), ge.setConfig({ constants: t.Z, cea608parser: T(), errHandler: V, BASE64: Ua }), ce || (ce = yu(Be).create()), ce.setConfig({ adapter: ge, contentSteeringController: se }), z.setConfig({ adapter: ge }), st || (st = sl(Be).getInstance({ dashMetrics: k, mediaPlayerModel: q, errHandler: V, baseURLController: ce, events: o.Z, eventBus: mt, debug: vt, boxParser: (0, Ei.Z)(Be).getInstance(), requestModifier: (0, Re.Z)(Be).getInstance(), errors: Q })), U.setConfig({ domStorage: De, settings: Ke, customParametersModel: oe }), q.setConfig({ playbackController: ne, serviceDescriptionController: z }), se.setConfig({ adapter: ge, errHandler: V, dashMetrics: k, mediaPlayerModel: q, manifestModel: J, serviceDescriptionController: z, eventBus: mt, requestModifier: (0, Re.Z)(Be).getInstance() }), It(), ot(Xe === void 0 || Xe), Ye()), de && Qt(de), _e && on(_e, Ct), r.info("[dash.js " + Wt() + "] MediaPlayer has been initialized")) : V.error(new ae.Z(Q.CAPABILITY_MEDIASOURCE_ERROR_CODE, Q.CAPABILITY_MEDIASOURCE_ERROR_MESSAGE));
            }, setConfig: function(de) {
              de && (de.capabilities && (g = de.capabilities), de.capabilitiesFilter && (P = de.capabilitiesFilter), de.streamController && (D = de.streamController), de.textController && (O = de.textController), de.gapController && (A = de.gapController), de.playbackController && (ne = de.playbackController), de.serviceDescriptionController && (z = de.serviceDescriptionController), de.contentSteeringController && (se = de.contentSteeringController), de.catchupController && (X = de.catchupController), de.mediaPlayerModel && (q = de.mediaPlayerModel), de.customParametersModel && (oe = de.customParametersModel), de.abrController && (H = de.abrController), de.schemeLoaderFactory && (G = de.schemeLoaderFactory), de.mediaController && (U = de.mediaController), de.settings && (Ke = de.settings));
            }, on: function(de, _e, Xe, Ct) {
              mt.on(de, _e, Xe, Ct);
            }, off: function(de, _e, Xe) {
              mt.off(de, _e, Xe);
            }, extend: function(de, _e, Xe) {
              E.Z.extend(de, _e, Xe, Be);
            }, attachView: Qt, attachSource: on, refreshManifest: function(de) {
              if (!R) throw be;
              if (!gt()) return de(null, Ut);
              var _e = this;
              typeof de == "function" && mt.on(o.Z.INTERNAL_MANIFEST_LOADED, function Xe(Ct) {
                mt.off(o.Z.INTERNAL_MANIFEST_LOADED, Xe, _e), Ct.error ? de(null, Ct.error) : de(Ct.manifest);
              }, _e), D.refreshManifest();
            }, isReady: gt, preload: function() {
              if (!Ie.getElement() && !I) {
                if (!l) throw Ut;
                ct(F);
              }
            }, play: function() {
              if (!y) throw et;
              (!w || zt() && y) && ne.play(!0);
            }, isPaused: zt, pause: function() {
              if (!y) throw et;
              ne.pause();
            }, isSeeking: function() {
              if (!y) throw et;
              return ne.isSeeking();
            }, isDynamic: gn, getLowLatencyModeEnabled: function() {
              if (!y) throw et;
              return ne.getLowLatencyModeEnabled();
            }, seek: function(de) {
              if (!y) throw et;
              if ((0, W.PS)(de, "number"), isNaN(de)) throw t.Z.BAD_ARGUMENT_ERROR;
              de < 0 && (de = 0);
              var _e = ne.getIsDynamic() ? pn(de) : de, Xe = $t();
              !ne.getIsDynamic() && Xe.duration && (_e = Math.min(Xe.duration, _e)), ne.seek(_e, !1, !1, !0);
            }, seekToOriginalLive: function() {
              y && gn() && ne.seekToOriginalLive();
            }, setPlaybackRate: function(de) {
              $t().playbackRate = de;
            }, getPlaybackRate: function() {
              return $t().playbackRate;
            }, setMute: function(de) {
              (0, W.PS)(de, "boolean"), $t().muted = de;
            }, isMuted: function() {
              return $t().muted;
            }, setVolume: function(de) {
              if (typeof de != "number" || isNaN(de) || de < 0 || de > 1) throw t.Z.BAD_ARGUMENT_ERROR;
              $t().volume = de;
            }, getVolume: function() {
              return $t().volume;
            }, time: je, duration: yt, timeAsUTC: function() {
              if (!y) throw et;
              return je() < 0 ? NaN : Me(je());
            }, durationAsUTC: function() {
              if (!y) throw et;
              return Me(yt());
            }, getActiveStream: ht, getDVRWindowSize: function() {
              var de = D && D.hasVideoTrack() ? t.Z.VIDEO : t.Z.AUDIO, _e = k.getCurrentDVRInfo(de);
              return _e ? _e.manifestInfo.dvrWindowSize : 0;
            }, getDVRSeekOffset: pn, getAvailableBaseUrls: function() {
              var de = J.getValue();
              return de ? ce.getBaseUrls(de) : [];
            }, getAvailableLocations: function() {
              var de = J.getValue();
              if (!de) return [];
              var _e = ge.getLocation(de), Xe = se.getSynthesizedLocationElements(_e);
              return _e.concat(Xe);
            }, getTargetLiveDelay: function() {
              if (!y) throw et;
              return ne.getOriginalLiveDelay();
            }, convertToTimeCode: function(de) {
              de = Math.max(de, 0);
              var _e = Math.floor(de / 3600), Xe = Math.floor(de % 3600 / 60), Ct = Math.floor(de % 3600 % 60);
              return (_e === 0 ? "" : _e < 10 ? "0" + _e.toString() + ":" : _e.toString() + ":") + (Xe < 10 ? "0" + Xe.toString() : Xe.toString()) + ":" + (Ct < 10 ? "0" + Ct.toString() : Ct.toString());
            }, formatUTC: function(de, _e, Xe) {
              var Ct = arguments.length > 3 && arguments[3] !== void 0 && arguments[3], xt = new Date(1e3 * de), yn = xt.toLocaleDateString(_e), On = xt.toLocaleTimeString(_e, { hour12: Xe });
              return Ct ? On + " " + yn : On;
            }, getVersion: Wt, getDebug: function() {
              return vt;
            }, getBufferLength: function(de) {
              var _e = [t.Z.VIDEO, t.Z.AUDIO, t.Z.TEXT];
              if (de) return _e.indexOf(de) !== -1 ? Lt().getCurrentBufferLevel(de) || NaN : (r.warn("getBufferLength requested for invalid type"), NaN);
              var Xe = _e.map(function(Ct) {
                return en(Ct).length > 0 ? Lt().getCurrentBufferLevel(Ct) : Number.MAX_VALUE;
              }).reduce(function(Ct, xt) {
                return Math.min(Ct, xt);
              });
              return Xe === Number.MAX_VALUE ? NaN : Xe;
            }, getTTMLRenderingDiv: function() {
              return Ie ? Ie.getTTMLRenderingDiv() : null;
            }, getVideoElement: $t, getSource: function() {
              if (!l) throw Ut;
              return l;
            }, updateSource: function(de) {
              l = de, D.load(l);
            }, getCurrentLiveLatency: function() {
              if (!R) throw be;
              return y ? ne.getCurrentLiveLatency() : NaN;
            }, getTopBitrateInfoFor: function(de) {
              if (!I) throw ut;
              return H.getTopBitrateInfoFor(de);
            }, setAutoPlay: ot, getAutoPlay: function() {
              return w;
            }, getDashMetrics: Lt, getQualityFor: function(de) {
              if (!I) throw ut;
              if (de === t.Z.IMAGE) {
                var _e = ht();
                if (!_e) return -1;
                var Xe = _e.getThumbnailController();
                return Xe ? Xe.getCurrentTrackIndex() : -1;
              }
              return H.getQualityFor(de);
            }, setQualityFor: function(de, _e) {
              var Xe = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
              if (!I) throw ut;
              if (de === t.Z.IMAGE) {
                var Ct = ht();
                if (!Ct) return;
                var xt = Ct.getThumbnailController();
                xt && xt.setTrackByIndex(_e);
              }
              H.setPlaybackQuality(de, D.getActiveStreamInfo(), _e, { forceReplace: Xe });
            }, updatePortalSize: function() {
              H.setElementSize(), H.setWindowResizeEventCalled(!0);
            }, enableText: function(de) {
              var _e = D.getActiveStreamInfo();
              return !(!_e || !O) && O.enableText(_e.id, de);
            }, enableForcedTextStreaming: function(de) {
              return !(!D.getActiveStreamInfo() || !O) && O.enableForcedTextStreaming(de);
            }, isTextEnabled: function() {
              var de = D.getActiveStreamInfo();
              return !(!de || !O) && O.isTextEnabled(de);
            }, setTextTrack: function(de) {
              if (!y) throw et;
              var _e = D.getActiveStreamInfo();
              _e && O && O.setTextTrack(_e.id, de);
            }, getBitrateInfoListFor: function(de) {
              if (!I) throw ut;
              var _e = ht();
              return _e ? _e.getBitrateListFor(de) : [];
            }, getStreamsFromManifest: function(de) {
              if (!I) throw ut;
              return ge.getStreamsInfo(de);
            }, getTracksFor: en, getTracksForTypeFromManifest: function(de, _e, Xe) {
              if (!I) throw ut;
              return (Xe = Xe || ge.getStreamsInfo(_e, 1)[0]) ? ge.getAllMediaInfoForType(Xe, de, _e) : [];
            }, getCurrentTrackFor: function(de) {
              if (!I) throw ut;
              var _e = D.getActiveStreamInfo();
              return U.getCurrentTrackFor(de, _e.id);
            }, setInitialMediaSettingsFor: function(de, _e) {
              if (!R) throw be;
              U.setInitialSettings(de, _e);
            }, getInitialMediaSettingsFor: function(de) {
              if (!R) throw be;
              return U.getInitialSettings(de);
            }, setCurrentTrack: function(de) {
              var _e = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
              if (!I) throw ut;
              U.setTrack(de, _e);
            }, addABRCustomRule: function(de, _e, Xe) {
              oe.addAbrCustomRule(de, _e, Xe);
            }, removeABRCustomRule: function(de) {
              oe.removeAbrCustomRule(de);
            }, removeAllABRCustomRule: function() {
              oe.removeAllAbrCustomRule();
            }, getABRCustomRules: function() {
              return oe.getAbrCustomRules();
            }, getAverageThroughput: function(de) {
              var _e = H.getThroughputHistory(), Xe = ne.getIsDynamic();
              return _e ? _e.getAverageThroughput(de, Xe) : 0;
            }, retrieveManifest: function(de, _e) {
              var Xe = Vt(), Ct = this;
              mt.on(o.Z.INTERNAL_MANIFEST_LOADED, function xt(yn) {
                yn.error ? _e(null, yn.error) : _e(yn.manifest), mt.off(o.Z.INTERNAL_MANIFEST_LOADED, xt, Ct), Xe.reset();
              }, Ct), xe.initialize(de), Xe.load(de);
            }, addUTCTimingSource: function(de, _e) {
              oe.addUTCTimingSource(de, _e);
            }, removeUTCTimingSource: function(de, _e) {
              oe.removeUTCTimingSource(de, _e);
            }, clearDefaultUTCTimingSources: function() {
              oe.clearDefaultUTCTimingSources();
            }, restoreDefaultUTCTimingSources: It, setXHRWithCredentialsForType: function(de, _e) {
              oe.setXHRWithCredentialsForType(de, _e);
            }, getXHRWithCredentialsForType: function(de) {
              return oe.getXHRWithCredentialsForType(de);
            }, getProtectionController: function() {
              return Xt();
            }, attachProtectionController: function(de) {
              Z = de;
            }, setProtectionData: function(de) {
              _ = de, D && D.setProtectionData(_);
            }, registerLicenseRequestFilter: function(de) {
              oe.registerLicenseRequestFilter(de);
            }, registerLicenseResponseFilter: function(de) {
              oe.registerLicenseResponseFilter(de);
            }, unregisterLicenseRequestFilter: function(de) {
              oe.unregisterLicenseRequestFilter(de);
            }, unregisterLicenseResponseFilter: function(de) {
              oe.unregisterLicenseResponseFilter(de);
            }, registerCustomCapabilitiesFilter: function(de) {
              oe.registerCustomCapabilitiesFilter(de);
            }, unregisterCustomCapabilitiesFilter: function(de) {
              oe.unregisterCustomCapabilitiesFilter(de);
            }, setCustomInitialTrackSelectionFunction: function(de) {
              oe.setCustomInitialTrackSelectionFunction(de);
            }, resetCustomInitialTrackSelectionFunction: function() {
              oe.resetCustomInitialTrackSelectionFunction(null);
            }, attachTTMLRenderingDiv: function(de) {
              if (!Ie.getElement()) throw tt;
              Ie.setTTMLRenderingDiv(de);
            }, attachVttRenderingDiv: function(de) {
              if (!Ie.getElement()) throw tt;
              Ie.setVttRenderingDiv(de);
            }, getCurrentTextTrackIndex: function() {
              var de = D.getActiveStreamInfo();
              if (de && O) return O.getCurrentTrackIdx(de.id);
            }, provideThumbnail: function(de, _e) {
              if (typeof _e == "function") if (de < 0) _e(null);
              else {
                var Xe = ne.getIsDynamic() ? pn(de) : de, Ct = D.getStreamForTime(Xe);
                if (Ct !== null) {
                  var xt = Ct.getThumbnailController();
                  if (xt) return xt.provide(Xe, _e);
                  _e(null);
                } else _e(null);
              }
            }, getDashAdapter: function() {
              return ge;
            }, getOfflineController: function() {
              return Ye();
            }, triggerSteeringRequest: function() {
              if (se) return se.loadSteeringData();
            }, getCurrentSteeringResponseData: function() {
              if (se) return se.getCurrentSteeringResponseData();
            }, getSettings: function() {
              return Ke.get();
            }, updateSettings: function(de) {
              Ke.update(de);
            }, resetSettings: function() {
              Ke.reset();
            }, reset: Et, destroy: function() {
              Et(), E.Z.deleteSingletonInstances(Be);
            } }, r = vt.getLogger(i), R = !1, y = !1, I = !1, w = !0, F = NaN, Z = null, le = null, _ = null, ge = null, st = null, o.Z.extend(n.Z), q = zu(Be).getInstance(), oe = (0, jn.Z)(Be).getInstance(), Ie = tl(Be).getInstance(), xe = Yu(Be).getInstance(), i;
          }
          Ha.__dashjs_factory_name = "MediaPlayer";
          var Xi = E.Z.getClassFactory(Ha);
          Xi.events = n.Z, Xi.errors = Q, E.Z.updateClassFactory(Ha.__dashjs_factory_name, Xi);
          var Vl = Xi;
        }, 8825: function(Pe, Ee, C) {
          function ie(m) {
            return ie = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
              return typeof o;
            } : function(o) {
              return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
            }, ie(m);
          }
          function T(m, o) {
            return T = Object.setPrototypeOf || function(E, h) {
              return E.__proto__ = h, E;
            }, T(m, o);
          }
          function t(m, o) {
            return !o || ie(o) !== "object" && typeof o != "function" ? function(E) {
              if (E === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return E;
            }(m) : o;
          }
          function e(m) {
            return e = Object.setPrototypeOf ? Object.getPrototypeOf : function(o) {
              return o.__proto__ || Object.getPrototypeOf(o);
            }, e(m);
          }
          var p = new (function(m) {
            (function(c, d) {
              if (typeof d != "function" && d !== null) throw new TypeError("Super expression must either be null or a function");
              c.prototype = Object.create(d && d.prototype, { constructor: { value: c, writable: !0, configurable: !0 } }), d && T(c, d);
            })(n, m);
            var o, E, h = (o = n, E = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var c, d = e(o);
              if (E) {
                var S = e(this).constructor;
                c = Reflect.construct(d, arguments, S);
              } else c = d.apply(this, arguments);
              return t(this, c);
            });
            function n() {
              var c;
              return function(d, S) {
                if (!(d instanceof S)) throw new TypeError("Cannot call a class as a function");
              }(this, n), (c = h.call(this)).AST_IN_FUTURE = "astInFuture", c.BASE_URLS_UPDATED = "baseUrlsUpdated", c.BUFFER_EMPTY = "bufferStalled", c.BUFFER_LOADED = "bufferLoaded", c.BUFFER_LEVEL_STATE_CHANGED = "bufferStateChanged", c.BUFFER_LEVEL_UPDATED = "bufferLevelUpdated", c.DVB_FONT_DOWNLOAD_ADDED = "dvbFontDownloadAdded", c.DVB_FONT_DOWNLOAD_COMPLETE = "dvbFontDownloadComplete", c.DVB_FONT_DOWNLOAD_FAILED = "dvbFontDownloadFailed", c.DYNAMIC_TO_STATIC = "dynamicToStatic", c.ERROR = "error", c.FRAGMENT_LOADING_COMPLETED = "fragmentLoadingCompleted", c.FRAGMENT_LOADING_PROGRESS = "fragmentLoadingProgress", c.FRAGMENT_LOADING_STARTED = "fragmentLoadingStarted", c.FRAGMENT_LOADING_ABANDONED = "fragmentLoadingAbandoned", c.LOG = "log", c.MANIFEST_LOADING_STARTED = "manifestLoadingStarted", c.MANIFEST_LOADING_FINISHED = "manifestLoadingFinished", c.MANIFEST_LOADED = "manifestLoaded", c.METRICS_CHANGED = "metricsChanged", c.METRIC_CHANGED = "metricChanged", c.METRIC_ADDED = "metricAdded", c.METRIC_UPDATED = "metricUpdated", c.PERIOD_SWITCH_STARTED = "periodSwitchStarted", c.PERIOD_SWITCH_COMPLETED = "periodSwitchCompleted", c.QUALITY_CHANGE_REQUESTED = "qualityChangeRequested", c.QUALITY_CHANGE_RENDERED = "qualityChangeRendered", c.TRACK_CHANGE_RENDERED = "trackChangeRendered", c.STREAM_INITIALIZING = "streamInitializing", c.STREAM_UPDATED = "streamUpdated", c.STREAM_ACTIVATED = "streamActivated", c.STREAM_DEACTIVATED = "streamDeactivated", c.STREAM_INITIALIZED = "streamInitialized", c.STREAM_TEARDOWN_COMPLETE = "streamTeardownComplete", c.TEXT_TRACKS_ADDED = "allTextTracksAdded", c.TEXT_TRACK_ADDED = "textTrackAdded", c.CUE_ENTER = "cueEnter", c.CUE_EXIT = "cueExit", c.THROUGHPUT_MEASUREMENT_STORED = "throughputMeasurementStored", c.TTML_PARSED = "ttmlParsed", c.TTML_TO_PARSE = "ttmlToParse", c.CAPTION_RENDERED = "captionRendered", c.CAPTION_CONTAINER_RESIZE = "captionContainerResize", c.CAN_PLAY = "canPlay", c.CAN_PLAY_THROUGH = "canPlayThrough", c.PLAYBACK_ENDED = "playbackEnded", c.PLAYBACK_ERROR = "playbackError", c.PLAYBACK_NOT_ALLOWED = "playbackNotAllowed", c.PLAYBACK_METADATA_LOADED = "playbackMetaDataLoaded", c.PLAYBACK_LOADED_DATA = "playbackLoadedData", c.PLAYBACK_PAUSED = "playbackPaused", c.PLAYBACK_PLAYING = "playbackPlaying", c.PLAYBACK_PROGRESS = "playbackProgress", c.PLAYBACK_RATE_CHANGED = "playbackRateChanged", c.PLAYBACK_SEEKED = "playbackSeeked", c.PLAYBACK_SEEKING = "playbackSeeking", c.PLAYBACK_STALLED = "playbackStalled", c.PLAYBACK_STARTED = "playbackStarted", c.PLAYBACK_TIME_UPDATED = "playbackTimeUpdated", c.PLAYBACK_VOLUME_CHANGED = "playbackVolumeChanged", c.PLAYBACK_WAITING = "playbackWaiting", c.MANIFEST_VALIDITY_CHANGED = "manifestValidityChanged", c.EVENT_MODE_ON_START = "eventModeOnStart", c.EVENT_MODE_ON_RECEIVE = "eventModeOnReceive", c.CONFORMANCE_VIOLATION = "conformanceViolation", c.REPRESENTATION_SWITCH = "representationSwitch", c.ADAPTATION_SET_REMOVED_NO_CAPABILITIES = "adaptationSetRemovedNoCapabilities", c.CONTENT_STEERING_REQUEST_COMPLETED = "contentSteeringRequestCompleted", c.INBAND_PRFT = "inbandPrft", c.MANAGED_MEDIA_SOURCE_START_STREAMING = "managedMediaSourceStartStreaming", c.MANAGED_MEDIA_SOURCE_END_STREAMING = "managedMediaSourceEndStreaming", c;
            }
            return n;
          }(C(8342).Z))();
          Ee.Z = p;
        }, 3393: function(Pe, Ee) {
          function C(T, t) {
            for (var e = 0; e < t.length; e++) {
              var p = t[e];
              p.enumerable = p.enumerable || !1, p.configurable = !0, "value" in p && (p.writable = !0), Object.defineProperty(T, p.key, p);
            }
          }
          var ie = new (function() {
            function T() {
              (function(p, m) {
                if (!(p instanceof m)) throw new TypeError("Cannot call a class as a function");
              })(this, T), this.init();
            }
            var t, e;
            return t = T, (e = [{ key: "init", value: function() {
              this.STREAM = "stream", this.VIDEO = "video", this.AUDIO = "audio", this.TEXT = "text", this.MUXED = "muxed", this.IMAGE = "image", this.STPP = "stpp", this.TTML = "ttml", this.VTT = "vtt", this.WVTT = "wvtt", this.CONTENT_STEERING = "contentSteering", this.ABR_STRATEGY_DYNAMIC = "abrDynamic", this.ABR_STRATEGY_BOLA = "abrBola", this.ABR_STRATEGY_L2A = "abrL2A", this.ABR_STRATEGY_LoLP = "abrLoLP", this.ABR_STRATEGY_THROUGHPUT = "abrThroughput", this.ABR_FETCH_THROUGHPUT_CALCULATION_DOWNLOADED_DATA = "abrFetchThroughputCalculationDownloadedData", this.ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING = "abrFetchThroughputCalculationMoofParsing", this.ABR_FETCH_THROUGHPUT_CALCULATION_AAST = "abrFetchThroughputCalculationAAST", this.LIVE_CATCHUP_MODE_DEFAULT = "liveCatchupModeDefault", this.LIVE_CATCHUP_MODE_LOLP = "liveCatchupModeLoLP", this.MOVING_AVERAGE_SLIDING_WINDOW = "slidingWindow", this.MOVING_AVERAGE_EWMA = "ewma", this.BAD_ARGUMENT_ERROR = "Invalid Arguments", this.MISSING_CONFIG_ERROR = "Missing config parameter(s)", this.TRACK_SWITCH_MODE_ALWAYS_REPLACE = "alwaysReplace", this.TRACK_SWITCH_MODE_NEVER_REPLACE = "neverReplace", this.TRACK_SELECTION_MODE_FIRST_TRACK = "firstTrack", this.TRACK_SELECTION_MODE_HIGHEST_BITRATE = "highestBitrate", this.TRACK_SELECTION_MODE_HIGHEST_EFFICIENCY = "highestEfficiency", this.TRACK_SELECTION_MODE_WIDEST_RANGE = "widestRange", this.TRACK_SELECTION_MODE_HIGHEST_SELECTION_PRIORITY = "highestSelectionPriority", this.CMCD_MODE_QUERY = "query", this.CMCD_MODE_HEADER = "header", this.INITIALIZE = "initialize", this.TEXT_SHOWING = "showing", this.TEXT_HIDDEN = "hidden", this.TEXT_DISABLED = "disabled", this.CC1 = "CC1", this.CC3 = "CC3", this.UTF8 = "utf-8", this.SCHEME_ID_URI = "schemeIdUri", this.START_TIME = "starttime", this.SERVICE_DESCRIPTION_DVB_LL_SCHEME = "urn:dvb:dash:lowlatency:scope:2019", this.SUPPLEMENTAL_PROPERTY_DVB_LL_SCHEME = "urn:dvb:dash:lowlatency:critical:2019", this.FONT_DOWNLOAD_DVB_SCHEME = "urn:dvb:dash:fontdownload:2014", this.XML = "XML", this.ARRAY_BUFFER = "ArrayBuffer", this.DVB_REPORTING_URL = "dvb:reportingUrl", this.DVB_PROBABILITY = "dvb:probability", this.OFF_MIMETYPE = "application/font-sfnt", this.WOFF_MIMETYPE = "application/font-woff", this.VIDEO_ELEMENT_READY_STATES = { HAVE_NOTHING: 0, HAVE_METADATA: 1, HAVE_CURRENT_DATA: 2, HAVE_FUTURE_DATA: 3, HAVE_ENOUGH_DATA: 4 }, this.FILE_LOADER_TYPES = { FETCH: "fetch_loader", XHR: "xhr_loader" };
            } }]) && C(t.prototype, e), T;
          }())();
          Ee.Z = ie;
        }, 3860: function(Pe, Ee) {
          function C(T, t) {
            for (var e = 0; e < t.length; e++) {
              var p = t[e];
              p.enumerable = p.enumerable || !1, p.configurable = !0, "value" in p && (p.writable = !0), Object.defineProperty(T, p.key, p);
            }
          }
          var ie = new (function() {
            function T() {
              (function(p, m) {
                if (!(p instanceof m)) throw new TypeError("Cannot call a class as a function");
              })(this, T), this.init();
            }
            var t, e;
            return t = T, (e = [{ key: "init", value: function() {
              this.TCP_CONNECTION = "TcpList", this.HTTP_REQUEST = "HttpList", this.TRACK_SWITCH = "RepSwitchList", this.BUFFER_LEVEL = "BufferLevel", this.BUFFER_LOADED = "bufferLoaded", this.ABANDON_LOAD = "abandonload", this.ALLOW_LOAD = "allowload", this.BUFFER_EMPTY = "bufferStalled", this.BUFFER_STATE = "BufferState", this.DVR_INFO = "DVRInfo", this.DROPPED_FRAMES = "DroppedFrames", this.SCHEDULING_INFO = "SchedulingInfo", this.REQUESTS_QUEUE = "RequestsQueue", this.MANIFEST_UPDATE = "ManifestUpdate", this.MANIFEST_UPDATE_STREAM_INFO = "ManifestUpdatePeriodInfo", this.MANIFEST_UPDATE_TRACK_INFO = "ManifestUpdateRepresentationInfo", this.PLAY_LIST = "PlayList", this.DVB_ERRORS = "DVBErrors", this.HTTP_REQUEST_DVB_REPORTING_TYPE = "DVBReporting";
            } }]) && C(t.prototype, e), T;
          }())();
          Ee.Z = ie;
        }, 8080: function(Pe, Ee, C) {
          C.d(Ee, { default: function() {
            return v;
          } });
          var ie = function b() {
            (function(W, Y) {
              if (!(W instanceof Y)) throw new TypeError("Cannot call a class as a function");
            })(this, b), this.mpdurl = null, this.errorcode = null, this.terror = null, this.url = null, this.ipaddress = null, this.servicelocation = null;
          };
          ie.SSL_CONNECTION_FAILED_PREFIX = "SSL", ie.DNS_RESOLUTION_FAILED = "C00", ie.HOST_UNREACHABLE = "C01", ie.CONNECTION_REFUSED = "C02", ie.CONNECTION_ERROR = "C03", ie.CORRUPT_MEDIA_ISOBMFF = "M00", ie.CORRUPT_MEDIA_OTHER = "M01", ie.BASE_URL_CHANGED = "F00", ie.BECAME_REPORTER = "S00";
          var T = ie, t = C(1180);
          function e(b) {
            var W, Y, Re = (b = b || {}).eventBus, Je = b.dashMetrics, Ze = b.metricsConstants, Fe = b.events;
            function we(Ot) {
              var qt = new T();
              if (Y) {
                for (var Bt in Ot) Ot.hasOwnProperty(Bt) && (qt[Bt] = Ot[Bt]);
                qt.mpdurl || (qt.mpdurl = Y.originalUrl || Y.url), qt.terror || (qt.terror = /* @__PURE__ */ new Date()), Je.addDVBErrors(qt);
              }
            }
            function Ge(Ot) {
              Ot.error || (Y = Ot.manifest);
            }
            function nt(Ot) {
              we({ errorcode: T.BASE_URL_CHANGED, servicelocation: Ot.entry });
            }
            function Tt() {
              we({ errorcode: T.BECAME_REPORTER });
            }
            function ft(Ot) {
              var qt;
              Ot.metric === Ze.HTTP_REQUEST && ((qt = Ot.value).responsecode === 0 || qt.responsecode == null || qt.responsecode >= 400 || qt.responsecode < 100 || qt.responsecode >= 600) && we({ errorcode: qt.responsecode || T.CONNECTION_ERROR, url: qt.url, terror: qt.tresponse, servicelocation: qt._serviceLocation });
            }
            function Yt(Ot) {
              var qt;
              switch (Ot.error ? Ot.error.code : 0) {
                case MediaError.MEDIA_ERR_NETWORK:
                  qt = T.CONNECTION_ERROR;
                  break;
                case MediaError.MEDIA_ERR_DECODE:
                  qt = T.CORRUPT_MEDIA_OTHER;
                  break;
                default:
                  return;
              }
              we({ errorcode: qt });
            }
            return W = { initialize: function() {
              Re.on(Fe.MANIFEST_UPDATED, Ge, W), Re.on(Fe.SERVICE_LOCATION_BASE_URL_BLACKLIST_CHANGED, nt, W), Re.on(Fe.METRIC_ADDED, ft, W), Re.on(Fe.METRIC_UPDATED, ft, W), Re.on(Fe.PLAYBACK_ERROR, Yt, W), Re.on(t.Z.BECAME_REPORTING_PLAYER, Tt, W);
            }, reset: function() {
              Re.off(Fe.MANIFEST_UPDATED, Ge, W), Re.off(Fe.SERVICE_LOCATION_BASE_URL_BLACKLIST_CHANGED, nt, W), Re.off(Fe.METRIC_ADDED, ft, W), Re.off(Fe.METRIC_UPDATED, ft, W), Re.off(Fe.PLAYBACK_ERROR, Yt, W), Re.off(t.Z.BECAME_REPORTING_PLAYER, Tt, W);
            } };
          }
          e.__dashjs_factory_name = "DVBErrorsTranslator";
          var p = dashjs.FactoryMaker.getSingletonFactory(e), m = C(2295);
          function o(b) {
            b = b || {};
            var W, Y, Re = !1, Je = this.context, Ze = b.mediaElement;
            return W = { initialize: function(Fe) {
              Fe && Fe.length && (Fe.forEach(function(we) {
                var Ge = we.starttime, nt = Ge + we.duration;
                Y.add(Ge, nt);
              }), Re = !!Fe[0]._useWallClockTime);
            }, reset: function() {
              Y.clear();
            }, isEnabled: function() {
              var Fe, we = Y.length;
              if (!we) return !0;
              Fe = Re ? (/* @__PURE__ */ new Date()).getTime() / 1e3 : Ze.currentTime;
              for (var Ge = 0; Ge < we; Ge += 1) {
                var nt = Y.start(Ge), Tt = Y.end(Ge);
                if (nt <= Fe && Fe < Tt) return !0;
              }
              return !1;
            } }, Y = (0, m.Z)(Je).create(), W;
          }
          o.__dashjs_factory_name = "RangeController";
          var E = dashjs.FactoryMaker.getClassFactory(o);
          function h() {
            return { serialise: function b(W) {
              var Y, Re, Je = [], Ze = [];
              for (Y in W) if (W.hasOwnProperty(Y) && Y.indexOf("_") !== 0) {
                if ((Re = W[Y]) == null && (Re = ""), Array.isArray(Re)) {
                  if (!Re.length) continue;
                  Ze = [], Re.forEach(function(Fe) {
                    var we = Object.prototype.toString.call(Fe).slice(8, -1) !== "Object";
                    Ze.push(we ? Fe : b(Fe));
                  }), Re = Ze.map(encodeURIComponent).join(",");
                } else typeof Re == "string" ? Re = encodeURIComponent(Re) : Re instanceof Date ? Re = Re.toISOString() : typeof Re == "number" && (Re = Math.round(Re));
                Je.push(Y + "=" + Re);
              }
              return Je.join("&");
            } };
          }
          h.__dashjs_factory_name = "MetricSerialiser";
          var n = dashjs.FactoryMaker.getSingletonFactory(h);
          function c() {
            var b, W, Y, Re = window.crypto || window.msCrypto, Je = Uint32Array, Ze = Math.pow(2, 8 * Je.BYTES_PER_ELEMENT) - 1;
            function Fe() {
              Re && (b || (b = new Je(10)), Re.getRandomValues(b), W = 0);
            }
            return Y = { random: function(we, Ge) {
              var nt;
              return we || (we = 0), Ge || (Ge = 1), Re ? (W === b.length && Fe(), nt = b[W] / Ze, W += 1) : nt = Math.random(), nt * (Ge - we) + we;
            } }, Fe(), Y;
          }
          c.__dashjs_factory_name = "RNG";
          var d = dashjs.FactoryMaker.getSingletonFactory(c), S = C(5717);
          function x(b) {
            var W;
            b = b || {};
            var Y, Re, Je, Ze, Fe, we, Ge, nt = this.context, Tt = [], ft = b.metricsConstants;
            function Yt() {
              Ze = !1, Fe = !1, we = null, Ge = null;
            }
            return W = { report: function(Ot, qt) {
              Array.isArray(qt) || (qt = [qt]), Fe && Ge.isEnabled() && qt.forEach(function(Bt) {
                var cn = Y.serialise(Bt);
                Ot !== ft.DVB_ERRORS && (cn = "metricname=".concat(Ot, "&").concat(cn)), function(vn, Pn, Dn) {
                  var xn = new XMLHttpRequest();
                  xn.withCredentials = Re.getXHRWithCredentialsForType(ft.HTTP_REQUEST_DVB_REPORTING_TYPE);
                  var er = function() {
                    var In = Tt.indexOf(xn);
                    In !== -1 && (Tt.splice(In, 1), !(xn.status >= 200 && xn.status < 300) && Dn());
                  };
                  Tt.push(xn);
                  try {
                    xn.open("GET", vn), xn.onloadend = er, xn.onerror = er, xn.send();
                  } catch {
                    xn.onerror();
                  }
                }(cn = "".concat(we, "?").concat(cn), 0, function() {
                  Fe = !1;
                });
              });
            }, initialize: function(Ot, qt) {
              var Bt;
              if (Ge = qt, !(we = Ot.dvbReportingUrl)) throw new Error("required parameter missing (dvb:reportingUrl)");
              Ze || ((Bt = Ot.dvbProbability) && (Bt === 1e3 || Bt / 1e3 >= Je.random()) && (Fe = !0), Ze = !0);
            }, reset: function() {
              Yt();
            } }, Y = n(nt).getInstance(), Je = d(nt).getInstance(), Re = (0, S.Z)(nt).getInstance(), Yt(), W;
          }
          x.__dashjs_factory_name = "DVBReporting";
          var B = dashjs.FactoryMaker.getClassFactory(x);
          function L(b) {
            b = b || {};
            var W, Y = { "urn:dvb:dash:reporting:2014": B }, Re = this.context, Je = b.debug ? b.debug.getLogger(W) : {}, Ze = b.metricsConstants, Fe = b.mediaPlayerModel || {};
            return { create: function(we, Ge) {
              var nt;
              try {
                (nt = Y[we.schemeIdUri](Re).create({ metricsConstants: Ze, mediaPlayerModel: Fe })).initialize(we, Ge);
              } catch (Tt) {
                nt = null, Je.error("ReportingFactory: could not create Reporting with schemeIdUri ".concat(we.schemeIdUri, " (").concat(Tt.message, ")"));
              }
              return nt;
            }, register: function(we, Ge) {
              Y[we] = Ge;
            }, unregister: function(we) {
              delete Y[we];
            } };
          }
          L.__dashjs_factory_name = "ReportingFactory";
          var $ = dashjs.FactoryMaker.getSingletonFactory(L);
          function M(b) {
            var W = [], Y = $(this.context).getInstance(b);
            return { initialize: function(Re, Je) {
              Re.some(function(Ze) {
                var Fe = Y.create(Ze, Je);
                if (Fe) return W.push(Fe), !0;
              });
            }, reset: function() {
              W.forEach(function(Re) {
                return Re.reset();
              }), W = [];
            }, report: function(Re, Je) {
              W.forEach(function(Ze) {
                return Ze.report(Re, Je);
              });
            } };
          }
          M.__dashjs_factory_name = "ReportingController";
          var K = dashjs.FactoryMaker.getClassFactory(M);
          function ae() {
            return { reconstructFullMetricName: function(b, W, Y) {
              var Re = b;
              return W && (Re += "(" + W, Y && Y.length && (Re += "," + Y), Re += ")"), Re;
            }, validateN: function(b) {
              if (!b) throw new Error("missing n");
              if (isNaN(b)) throw new Error("n is NaN");
              if (b < 0) throw new Error("n must be positive");
              return b;
            } };
          }
          ae.__dashjs_factory_name = "HandlerHelpers";
          var j = dashjs.FactoryMaker.getSingletonFactory(ae);
          function ee(b) {
            var W, Y, Re, Je, Ze;
            b = b || {};
            var Fe = this.context, we = j(Fe).getInstance(), Ge = [], nt = b.metricsConstants;
            function Tt() {
              var ft = function() {
                try {
                  return Object.keys(Ge).map(function(Yt) {
                    return Ge[Yt];
                  }).reduce(function(Yt, Ot) {
                    return Yt.level < Ot.level ? Yt : Ot;
                  });
                } catch {
                  return;
                }
              }();
              ft && Ze !== ft.t && (Ze = ft.t, W.report(Re, ft));
            }
            return { initialize: function(ft, Yt, Ot) {
              Yt && (Y = we.validateN(Ot), W = Yt, Re = we.reconstructFullMetricName(ft, Ot), Je = setInterval(Tt, Y));
            }, reset: function() {
              clearInterval(Je), Je = null, Y = 0, W = null, Ze = null;
            }, handleNewMetric: function(ft, Yt, Ot) {
              ft === nt.BUFFER_LEVEL && (Ge[Ot] = Yt);
            } };
          }
          ee.__dashjs_factory_name = "BufferLevelHandler";
          var ue = dashjs.FactoryMaker.getClassFactory(ee), Ae = dashjs.FactoryMaker.getClassFactory(function(b) {
            var W, Y = (b = b || {}).eventBus, Re = b.metricsConstants;
            function Je() {
              Y.off(t.Z.METRICS_INITIALISATION_COMPLETE, Je, this), Y.trigger(t.Z.BECAME_REPORTING_PLAYER);
            }
            return { initialize: function(Ze, Fe) {
              Fe && (W = Fe, Y.on(t.Z.METRICS_INITIALISATION_COMPLETE, Je, this));
            }, reset: function() {
              W = null;
            }, handleNewMetric: function(Ze, Fe) {
              Ze === Re.DVB_ERRORS && W && W.report(Ze, Fe);
            } };
          });
          function Q(b) {
            var W, Y, Re, Je, Ze;
            b = b || {};
            var Fe = [], we = j(this.context).getInstance(), Ge = b.metricsConstants;
            function nt() {
              var Tt = Fe;
              Tt.length && W && W.report(Je, Tt), Fe = [];
            }
            return { initialize: function(Tt, ft, Yt, Ot) {
              ft && (Y = we.validateN(Yt), W = ft, Ot && Ot.length && (Re = Ot), Je = we.reconstructFullMetricName(Tt, Yt, Ot), Ze = setInterval(nt, Y));
            }, reset: function() {
              clearInterval(Ze), Ze = null, Y = null, Re = null, Fe = [], W = null;
            }, handleNewMetric: function(Tt, ft) {
              Tt === Ge.HTTP_REQUEST && (Re && Re !== ft.type || Fe.push(ft));
            } };
          }
          Q.__dashjs_factory_name = "HttpListHandler";
          var Ne = dashjs.FactoryMaker.getClassFactory(Q);
          function Ue() {
            var b, W;
            return { initialize: function(Y, Re) {
              b = Y, W = Re;
            }, reset: function() {
              W = null, b = void 0;
            }, handleNewMetric: function(Y, Re) {
              Y === b && W && W.report(b, Re);
            } };
          }
          Ue.__dashjs_factory_name = "GenericMetricHandler";
          var ze = dashjs.FactoryMaker.getClassFactory(Ue);
          function Te(b) {
            var W, Y = (b = b || {}).debug ? b.debug.getLogger(W) : {}, Re = /([a-zA-Z]*)(\(([0-9]*)(\,\s*([a-zA-Z]*))?\))?/, Je = this.context, Ze = { BufferLevel: ue, DVBErrors: Ae, HttpList: Ne, PlayList: ze, RepSwitchList: ze, TcpList: ze };
            return { create: function(Fe, we) {
              var Ge, nt = Fe.match(Re);
              if (nt) {
                try {
                  (Ge = Ze[nt[1]](Je).create({ eventBus: b.eventBus, metricsConstants: b.metricsConstants })).initialize(nt[1], we, nt[3], nt[5]);
                } catch (Tt) {
                  Ge = null, Y.error("MetricsHandlerFactory: Could not create handler for type ".concat(nt[1], " with args ").concat(nt[3], ", ").concat(nt[5], " (").concat(Tt.message, ")"));
                }
                return Ge;
              }
            }, register: function(Fe, we) {
              Ze[Fe] = we;
            }, unregister: function(Fe) {
              delete Ze[Fe];
            } };
          }
          Te.__dashjs_factory_name = "MetricsHandlerFactory";
          var Oe = dashjs.FactoryMaker.getSingletonFactory(Te);
          function We(b) {
            b = b || {};
            var W, Y = [], Re = this.context, Je = b.eventBus, Ze = b.events, Fe = Oe(Re).getInstance({ debug: b.debug, eventBus: b.eventBus, metricsConstants: b.metricsConstants });
            function we(Ge) {
              Y.forEach(function(nt) {
                nt.handleNewMetric(Ge.metric, Ge.value, Ge.mediaType);
              });
            }
            return W = { initialize: function(Ge, nt) {
              Ge.split(",").forEach(function(Tt, ft, Yt) {
                var Ot;
                if (Tt.indexOf("(") !== -1 && Tt.indexOf(")") === -1) {
                  var qt = Yt[ft + 1];
                  qt && qt.indexOf("(") === -1 && qt.indexOf(")") !== -1 && (Tt += "," + qt, delete Yt[ft + 1]);
                }
                (Ot = Fe.create(Tt, nt)) && Y.push(Ot);
              }), Je.on(Ze.METRIC_ADDED, we, W), Je.on(Ze.METRIC_UPDATED, we, W);
            }, reset: function() {
              Je.off(Ze.METRIC_ADDED, we, W), Je.off(Ze.METRIC_UPDATED, we, W), Y.forEach(function(Ge) {
                return Ge.reset();
              }), Y = [];
            } };
          }
          We.__dashjs_factory_name = "MetricsHandlersController";
          var at = dashjs.FactoryMaker.getClassFactory(We);
          function Se(b) {
            var W, Y, Re;
            b = b || {};
            var Je = this.context;
            function Ze() {
              W && W.reset(), Y && Y.reset(), Re && Re.reset();
            }
            return { initialize: function(Fe) {
              try {
                (Re = E(Je).create({ mediaElement: b.mediaElement })).initialize(Fe.Range), (Y = K(Je).create({ debug: b.debug, metricsConstants: b.metricsConstants, mediaPlayerModel: b.mediaPlayerModel })).initialize(Fe.Reporting, Re), (W = at(Je).create({ debug: b.debug, eventBus: b.eventBus, metricsConstants: b.metricsConstants, events: b.events })).initialize(Fe.metrics, Y);
              } catch (we) {
                throw Ze(), we;
              }
            }, reset: Ze };
          }
          Se.__dashjs_factory_name = "MetricsController";
          var ke = dashjs.FactoryMaker.getClassFactory(Se), Rt = function b() {
            (function(W, Y) {
              if (!(W instanceof Y)) throw new TypeError("Cannot call a class as a function");
            })(this, b), this.metrics = "", this.Range = [], this.Reporting = [];
          }, _t = function b() {
            (function(W, Y) {
              if (!(W instanceof Y)) throw new TypeError("Cannot call a class as a function");
            })(this, b), this.starttime = 0, this.duration = 1 / 0, this._useWallClockTime = !1;
          }, qe = function b() {
            (function(W, Y) {
              if (!(W instanceof Y)) throw new TypeError("Cannot call a class as a function");
            })(this, b), this.schemeIdUri = "", this.value = "", this.dvbReportingUrl = "", this.dvbProbability = 1e3;
          };
          function it(b) {
            var W = (b = b || {}).adapter, Y = b.constants;
            return { getMetrics: function(Re) {
              var Je = [];
              return Re && Re.Metrics_asArray && Re.Metrics_asArray.forEach(function(Ze) {
                var Fe = new Rt(), we = W.getIsDynamic(Re);
                Ze.hasOwnProperty("metrics") && (Fe.metrics = Ze.metrics, Ze.Range_asArray && Ze.Range_asArray.forEach(function(Ge) {
                  var nt = new _t();
                  nt.starttime = function(Tt, ft, Yt) {
                    var Ot, qt, Bt = 0;
                    return ft ? Bt = W.getAvailabilityStartTime(Tt) / 1e3 : (Ot = W.getRegularPeriods(Tt)).length && (Bt = Ot[0].start), qt = Bt, Yt && Yt.hasOwnProperty(Y.START_TIME) && (qt += Yt.starttime), qt;
                  }(Re, we, Ge), Ge.hasOwnProperty("duration") ? nt.duration = Ge.duration : nt.duration = W.getDuration(Re), nt._useWallClockTime = we, Fe.Range.push(nt);
                }), Ze.Reporting_asArray && (Ze.Reporting_asArray.forEach(function(Ge) {
                  var nt = new qe();
                  Ge.hasOwnProperty(Y.SCHEME_ID_URI) && (nt.schemeIdUri = Ge.schemeIdUri, Ge.hasOwnProperty("value") && (nt.value = Ge.value), Ge.hasOwnProperty(Y.DVB_REPORTING_URL) && (nt.dvbReportingUrl = Ge[Y.DVB_REPORTING_URL]), Ge.hasOwnProperty(Y.DVB_PROBABILITY) && (nt.dvbProbability = Ge[Y.DVB_PROBABILITY]), Fe.Reporting.push(nt));
                }), Je.push(Fe)));
              }), Je;
            } };
          }
          it.__dashjs_factory_name = "ManifestParsing";
          var me = dashjs.FactoryMaker.getSingletonFactory(it);
          function ye(b) {
            var W;
            b = b || {};
            var Y = {}, Re = this.context, Je = b.eventBus, Ze = b.events;
            function Fe(Ge) {
              if (!Ge.error) {
                var nt = Object.keys(Y);
                me(Re).getInstance({ adapter: b.adapter, constants: b.constants }).getMetrics(Ge.manifest).forEach(function(Tt) {
                  var ft = JSON.stringify(Tt);
                  if (Y.hasOwnProperty(ft)) nt.splice(ft, 1);
                  else try {
                    var Yt = ke(Re).create(b);
                    Yt.initialize(Tt), Y[ft] = Yt;
                  } catch {
                  }
                }), nt.forEach(function(Tt) {
                  Y[Tt].reset(), delete Y[Tt];
                }), Je.trigger(t.Z.METRICS_INITIALISATION_COMPLETE);
              }
            }
            function we() {
              Object.keys(Y).forEach(function(Ge) {
                Y[Ge].reset();
              }), Y = {};
            }
            return W = { reset: function() {
              Je.off(Ze.MANIFEST_UPDATED, Fe, W), Je.off(Ze.STREAM_TEARDOWN_COMPLETE, we, W);
            } }, Je.on(Ze.MANIFEST_UPDATED, Fe, W), Je.on(Ze.STREAM_TEARDOWN_COMPLETE, we, W), W;
          }
          ye.__dashjs_factory_name = "MetricsCollectionController";
          var Ve = dashjs.FactoryMaker.getClassFactory(ye);
          function f() {
            var b = this.context;
            return { createMetricsReporting: function(W) {
              return p(b).getInstance({ eventBus: W.eventBus, dashMetrics: W.dashMetrics, metricsConstants: W.metricsConstants, events: W.events }).initialize(), Ve(b).create(W);
            }, getReportingFactory: function() {
              return $(b).getInstance();
            }, getMetricsHandlerFactory: function() {
              return Oe(b).getInstance();
            } };
          }
          f.__dashjs_factory_name = "MetricsReporting";
          var u = dashjs.FactoryMaker.getClassFactory(f);
          u.events = t.Z, dashjs.FactoryMaker.updateClassFactory(f.__dashjs_factory_name, u);
          var v = u;
        }, 1180: function(Pe, Ee, C) {
          function ie(m) {
            return ie = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
              return typeof o;
            } : function(o) {
              return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
            }, ie(m);
          }
          function T(m, o) {
            return T = Object.setPrototypeOf || function(E, h) {
              return E.__proto__ = h, E;
            }, T(m, o);
          }
          function t(m, o) {
            return !o || ie(o) !== "object" && typeof o != "function" ? function(E) {
              if (E === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return E;
            }(m) : o;
          }
          function e(m) {
            return e = Object.setPrototypeOf ? Object.getPrototypeOf : function(o) {
              return o.__proto__ || Object.getPrototypeOf(o);
            }, e(m);
          }
          var p = new (function(m) {
            (function(c, d) {
              if (typeof d != "function" && d !== null) throw new TypeError("Super expression must either be null or a function");
              c.prototype = Object.create(d && d.prototype, { constructor: { value: c, writable: !0, configurable: !0 } }), d && T(c, d);
            })(n, m);
            var o, E, h = (o = n, E = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var c, d = e(o);
              if (E) {
                var S = e(this).constructor;
                c = Reflect.construct(d, arguments, S);
              } else c = d.apply(this, arguments);
              return t(this, c);
            });
            function n() {
              var c;
              return function(d, S) {
                if (!(d instanceof S)) throw new TypeError("Cannot call a class as a function");
              }(this, n), (c = h.call(this)).METRICS_INITIALISATION_COMPLETE = "internal_metricsReportingInitialized", c.BECAME_REPORTING_PLAYER = "internal_becameReportingPlayer", c.CMCD_DATA_GENERATED = "cmcdDataGenerated", c;
            }
            return n;
          }(C(8342).Z))();
          Ee.Z = p;
        }, 5717: function(Pe, Ee, C) {
          var ie = C(2610), T = C(5448), t = C(1264), e = C(3106), p = C(1767), m = C(3393);
          function o() {
            var E, h, n, c, d, S, x, B, L = this.context, $ = (0, t.Z)(L).getInstance();
            function M() {
              c = [], d = [], S = [], B = [], x = null, h = [];
            }
            function K(ue, Ae) {
              var Q = -1;
              ue.some(function(Ne, Ue) {
                if (Ne === Ae) return Q = Ue, !0;
              }), Q < 0 || ue.splice(Q, 1);
            }
            function ae(ue) {
              var Ae;
              for (Ae = 0; Ae < B.length; Ae++) if (B[Ae].rulename === ue) return Ae;
              return -1;
            }
            function j(ue, Ae) {
              ee(ue, Ae);
              var Q = new ie.Z();
              Q.schemeIdUri = ue, Q.value = Ae, h.push(Q);
            }
            function ee(ue, Ae) {
              (0, e.PS)(ue, "string"), (0, e.PS)(Ae, "string"), h.forEach(function(Q, Ne) {
                Q.schemeIdUri === ue && Q.value === Ae && h.splice(Ne, 1);
              });
            }
            return E = { getCustomInitialTrackSelectionFunction: function() {
              return x;
            }, setCustomInitialTrackSelectionFunction: function(ue) {
              x = ue;
            }, resetCustomInitialTrackSelectionFunction: function() {
              x = null;
            }, getLicenseResponseFilters: function() {
              return d;
            }, getLicenseRequestFilters: function() {
              return c;
            }, getCustomCapabilitiesFilters: function() {
              return S;
            }, registerCustomCapabilitiesFilter: function(ue) {
              S.push(ue);
            }, registerLicenseResponseFilter: function(ue) {
              d.push(ue);
            }, registerLicenseRequestFilter: function(ue) {
              c.push(ue);
            }, unregisterCustomCapabilitiesFilter: function(ue) {
              K(S, ue);
            }, unregisterLicenseResponseFilter: function(ue) {
              K(d, ue);
            }, unregisterLicenseRequestFilter: function(ue) {
              K(c, ue);
            }, addAbrCustomRule: function(ue, Ae, Q) {
              if (typeof ue != "string" || ue !== p.Z.ABANDON_FRAGMENT_RULES && ue !== p.Z.QUALITY_SWITCH_RULES || typeof Ae != "string") throw m.Z.BAD_ARGUMENT_ERROR;
              var Ne = ae(Ae);
              Ne === -1 ? B.push({ type: ue, rulename: Ae, rule: Q }) : (B[Ne].type = ue, B[Ne].rule = Q);
            }, removeAllAbrCustomRule: function() {
              B = [];
            }, removeAbrCustomRule: function(ue) {
              if (ue) {
                var Ae = ae(ue);
                Ae !== -1 && B.splice(Ae, 1);
              } else B = [];
            }, getAbrCustomRules: function() {
              return B;
            }, addUTCTimingSource: j, removeUTCTimingSource: ee, getUTCTimingSources: function() {
              return h;
            }, clearDefaultUTCTimingSources: function() {
              h = [];
            }, restoreDefaultUTCTimingSources: function() {
              var ue = $.get().streaming.utcSynchronization.defaultTimingSource;
              j(ue.scheme, ue.value);
            }, setXHRWithCredentialsForType: function ue(Ae, Q) {
              Ae ? n[Ae] = !!Q : Object.keys(n).forEach(function(Ne) {
                ue(Ne, Q);
              });
            }, getXHRWithCredentialsForType: function(ue) {
              var Ae = n[ue];
              return Ae === void 0 ? n.default : Ae;
            }, setConfig: function() {
            }, reset: function() {
              M();
            } }, n = { default: !1 }, M(), E;
          }
          o.__dashjs_factory_name = "CustomParametersModel", Ee.Z = T.Z.getSingletonFactory(o);
        }, 9032: function(Pe, Ee, C) {
          var ie = C(5448), T = C(7473);
          function t(p) {
            var m = (p = p || {}).requestModifier;
            function o(E) {
              var h = /* @__PURE__ */ new Date(), n = E.request, c = new XMLHttpRequest();
              if (c.open(E.method, E.url, !0), n.responseType && (c.responseType = n.responseType), n.range && c.setRequestHeader("Range", "bytes=" + n.range), n.requestStartDate || (n.requestStartDate = h), m && m.modifyRequestHeader && (c = m.modifyRequestHeader(c, { url: E.url })), E.headers) for (var d in E.headers) {
                var S = E.headers[d];
                S && c.setRequestHeader(d, S);
              }
              c.withCredentials = E.withCredentials, c.onload = E.onload, c.onloadend = E.onend, c.onerror = E.onerror, c.onprogress = E.progress, c.onabort = E.onabort, c.ontimeout = E.ontimeout, c.timeout = E.timeout, c.send(), E.response = c;
            }
            return { load: function(E) {
              m && m.modifyRequest ? (0, T.k)(E, m).then(function() {
                return o(E);
              }) : o(E);
            }, abort: function(E) {
              var h = E.response;
              h.onloadend = h.onerror = h.onprogress = void 0, h.abort();
            } };
          }
          t.__dashjs_factory_name = "XHRLoader";
          var e = ie.Z.getClassFactory(t);
          Ee.Z = e;
        }, 1737: function(Pe, Ee, C) {
          function ie(Nt, At) {
            for (var wt = 0; wt < At.length; wt++) {
              var He = At[wt];
              He.enumerable = He.enumerable || !1, He.configurable = !0, "value" in He && (He.writable = !0), Object.defineProperty(Nt, He.key, He);
            }
          }
          C.d(Ee, { default: function() {
            return ei;
          } });
          var T = { attributes: ["Laurl", "laurl"], prefixes: ["clearkey", "dashif"] }, t = function() {
            function Nt() {
              (function(He, pt) {
                if (!(He instanceof pt)) throw new TypeError("Cannot call a class as a function");
              })(this, Nt);
            }
            var At, wt;
            return At = Nt, wt = [{ key: "findCencContentProtection", value: function(He) {
              for (var pt = null, Qe = 0; Qe < He.length; ++Qe) {
                var dt = He[Qe];
                dt.schemeIdUri.toLowerCase() !== "urn:mpeg:dash:mp4protection:2011" || dt.value.toLowerCase() !== "cenc" && dt.value.toLowerCase() !== "cbcs" || (pt = dt);
              }
              return pt;
            } }, { key: "getPSSHData", value: function(He) {
              var pt = 8, Qe = new DataView(He), dt = Qe.getUint8(pt);
              return pt += 20, dt > 0 && (pt += 4 + 16 * Qe.getUint32(pt)), pt += 4, He.slice(pt);
            } }, { key: "getPSSHForKeySystem", value: function(He, pt) {
              var Qe = Nt.parsePSSHList(pt);
              return He && Qe.hasOwnProperty(He.uuid.toLowerCase()) ? Qe[He.uuid.toLowerCase()] : null;
            } }, { key: "parseInitDataFromContentProtection", value: function(He, pt) {
              return "pssh" in He ? (He.pssh.__text = He.pssh.__text.replace(/\r?\n|\r/g, "").replace(/\s+/g, ""), pt.decodeArray(He.pssh.__text).buffer) : null;
            } }, { key: "parsePSSHList", value: function(He) {
              if (He == null) return [];
              for (var pt = new DataView(He.buffer || He), Qe = {}, dt = 0; ; ) {
                var Zt, Gt, nn = void 0, rn = dt;
                if (dt >= pt.buffer.byteLength) break;
                if (Zt = dt + pt.getUint32(dt), dt += 4, pt.getUint32(dt) === 1886614376) if (dt += 4, (Gt = pt.getUint8(dt)) === 0 || Gt === 1) {
                  dt++, dt += 3, nn = "";
                  var Kt = void 0, St = void 0;
                  for (Kt = 0; Kt < 4; Kt++) nn += (St = pt.getUint8(dt + Kt).toString(16)).length === 1 ? "0" + St : St;
                  for (dt += 4, nn += "-", Kt = 0; Kt < 2; Kt++) nn += (St = pt.getUint8(dt + Kt).toString(16)).length === 1 ? "0" + St : St;
                  for (dt += 2, nn += "-", Kt = 0; Kt < 2; Kt++) nn += (St = pt.getUint8(dt + Kt).toString(16)).length === 1 ? "0" + St : St;
                  for (dt += 2, nn += "-", Kt = 0; Kt < 2; Kt++) nn += (St = pt.getUint8(dt + Kt).toString(16)).length === 1 ? "0" + St : St;
                  for (dt += 2, nn += "-", Kt = 0; Kt < 6; Kt++) nn += (St = pt.getUint8(dt + Kt).toString(16)).length === 1 ? "0" + St : St;
                  dt += 6, dt += 4, Qe[nn = nn.toLowerCase()] = pt.buffer.slice(rn, Zt), dt = Zt;
                } else dt = Zt;
                else dt = Zt;
              }
              return Qe;
            } }, { key: "getLicenseServerUrlFromMediaInfo", value: function(He, pt) {
              try {
                if (!He || He.length === 0) return null;
                for (var Qe = 0, dt = null; Qe < He.length && !dt; ) {
                  var Zt = He[Qe];
                  if (Zt && Zt.contentProtection && Zt.contentProtection.length > 0) {
                    var Gt = Zt.contentProtection.filter(function(dn) {
                      return dn.schemeIdUri && dn.schemeIdUri === pt;
                    });
                    if (Gt && Gt.length > 0) for (var nn = 0; nn < Gt.length && !dt; ) {
                      for (var rn = Gt[nn], Kt = 0; Kt < T.attributes.length && !dt; ) {
                        for (var St = 0, tn = T.attributes[Kt]; St < T.prefixes.length && !dt; ) {
                          var Jt = T.prefixes[St];
                          rn[tn] && rn[tn].__prefix && rn[tn].__prefix === Jt && rn[tn].__text && (dt = rn[tn].__text), St += 1;
                        }
                        Kt += 1;
                      }
                      nn += 1;
                    }
                  }
                  Qe += 1;
                }
                return dt;
              } catch {
                return null;
              }
            } }], wt && ie(At, wt), Nt;
          }(), e = function Nt(At, wt) {
            (function(He, pt) {
              if (!(He instanceof pt)) throw new TypeError("Cannot call a class as a function");
            })(this, Nt), this.contentType = At, this.robustness = wt;
          }, p = function Nt(At, wt, He, pt, Qe) {
            (function(dt, Zt) {
              if (!(dt instanceof Zt)) throw new TypeError("Cannot call a class as a function");
            })(this, Nt), this.initDataTypes = ["cenc"], At && At.length && (this.audioCapabilities = At), wt && wt.length && (this.videoCapabilities = wt), this.distinctiveIdentifier = He, this.persistentState = pt, this.sessionTypes = Qe;
          };
          function m(Nt) {
            return m = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(At) {
              return typeof At;
            } : function(At) {
              return At && typeof Symbol == "function" && At.constructor === Symbol && At !== Symbol.prototype ? "symbol" : typeof At;
            }, m(Nt);
          }
          function o(Nt, At) {
            return o = Object.setPrototypeOf || function(wt, He) {
              return wt.__proto__ = He, wt;
            }, o(Nt, At);
          }
          function E(Nt, At) {
            return !At || m(At) !== "object" && typeof At != "function" ? function(wt) {
              if (wt === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return wt;
            }(Nt) : At;
          }
          function h(Nt) {
            return h = Object.setPrototypeOf ? Object.getPrototypeOf : function(At) {
              return At.__proto__ || Object.getPrototypeOf(At);
            }, h(Nt);
          }
          var n = new (function(Nt) {
            (function(Qe, dt) {
              if (typeof dt != "function" && dt !== null) throw new TypeError("Super expression must either be null or a function");
              Qe.prototype = Object.create(dt && dt.prototype, { constructor: { value: Qe, writable: !0, configurable: !0 } }), dt && o(Qe, dt);
            })(pt, Nt);
            var At, wt, He = (At = pt, wt = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var Qe, dt = h(At);
              if (wt) {
                var Zt = h(this).constructor;
                Qe = Reflect.construct(dt, arguments, Zt);
              } else Qe = dt.apply(this, arguments);
              return E(this, Qe);
            });
            function pt() {
              var Qe;
              return function(dt, Zt) {
                if (!(dt instanceof Zt)) throw new TypeError("Cannot call a class as a function");
              }(this, pt), (Qe = He.call(this)).MEDIA_KEYERR_CODE = 100, Qe.MEDIA_KEYERR_UNKNOWN_CODE = 101, Qe.MEDIA_KEYERR_CLIENT_CODE = 102, Qe.MEDIA_KEYERR_SERVICE_CODE = 103, Qe.MEDIA_KEYERR_OUTPUT_CODE = 104, Qe.MEDIA_KEYERR_HARDWARECHANGE_CODE = 105, Qe.MEDIA_KEYERR_DOMAIN_CODE = 106, Qe.MEDIA_KEY_MESSAGE_ERROR_CODE = 107, Qe.MEDIA_KEY_MESSAGE_NO_CHALLENGE_ERROR_CODE = 108, Qe.SERVER_CERTIFICATE_UPDATED_ERROR_CODE = 109, Qe.KEY_STATUS_CHANGED_EXPIRED_ERROR_CODE = 110, Qe.MEDIA_KEY_MESSAGE_NO_LICENSE_SERVER_URL_ERROR_CODE = 111, Qe.KEY_SYSTEM_ACCESS_DENIED_ERROR_CODE = 112, Qe.KEY_SESSION_CREATED_ERROR_CODE = 113, Qe.MEDIA_KEY_MESSAGE_LICENSER_ERROR_CODE = 114, Qe.MEDIA_KEYERR_UNKNOWN_MESSAGE = "An unspecified error occurred. This value is used for errors that don't match any of the other codes.", Qe.MEDIA_KEYERR_CLIENT_MESSAGE = "The Key System could not be installed or updated.", Qe.MEDIA_KEYERR_SERVICE_MESSAGE = "The message passed into update indicated an error from the license service.", Qe.MEDIA_KEYERR_OUTPUT_MESSAGE = "There is no available output device with the required characteristics for the content protection system.", Qe.MEDIA_KEYERR_HARDWARECHANGE_MESSAGE = "A hardware configuration change caused a content protection error.", Qe.MEDIA_KEYERR_DOMAIN_MESSAGE = "An error occurred in a multi-device domain licensing configuration. The most common error is a failure to join the domain.", Qe.MEDIA_KEY_MESSAGE_ERROR_MESSAGE = "Multiple key sessions were creates with a user-agent that does not support sessionIDs!! Unpredictable behavior ahead!", Qe.MEDIA_KEY_MESSAGE_NO_CHALLENGE_ERROR_MESSAGE = "DRM: Empty key message from CDM", Qe.SERVER_CERTIFICATE_UPDATED_ERROR_MESSAGE = "Error updating server certificate -- ", Qe.KEY_STATUS_CHANGED_EXPIRED_ERROR_MESSAGE = "DRM: KeyStatusChange error! -- License has expired", Qe.MEDIA_KEY_MESSAGE_NO_LICENSE_SERVER_URL_ERROR_MESSAGE = "DRM: No license server URL specified!", Qe.KEY_SYSTEM_ACCESS_DENIED_ERROR_MESSAGE = "DRM: KeySystem Access Denied! -- ", Qe.KEY_SESSION_CREATED_ERROR_MESSAGE = "DRM: unable to create session! --", Qe.MEDIA_KEY_MESSAGE_LICENSER_ERROR_MESSAGE = "DRM: licenser error! --", Qe;
            }
            return pt;
          }(C(2230).Z))(), c = C(5459), d = function Nt(At, wt, He, pt, Qe, dt, Zt, Gt) {
            (function(nn, rn) {
              if (!(nn instanceof rn)) throw new TypeError("Cannot call a class as a function");
            })(this, Nt), this.url = At, this.method = wt, this.responseType = He, this.headers = pt, this.withCredentials = Qe, this.messageType = dt, this.sessionId = Zt, this.data = Gt;
          }, S = function Nt(At, wt, He) {
            (function(pt, Qe) {
              if (!(pt instanceof Qe)) throw new TypeError("Cannot call a class as a function");
            })(this, Nt), this.url = At, this.headers = wt, this.data = He;
          }, x = C(7855), B = C(703), L = C(3393), $ = C(5448);
          function M(Nt) {
            return M = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(At) {
              return typeof At;
            } : function(At) {
              return At && typeof Symbol == "function" && At.constructor === Symbol && At !== Symbol.prototype ? "symbol" : typeof At;
            }, M(Nt);
          }
          function K(Nt) {
            var At, wt, He, pt, Qe, dt, Zt, Gt, nn, rn, Kt, St = (Nt = Nt || {}).protectionKeyController, tn = Nt.protectionModel, Jt = Nt.eventBus, dn = Nt.events, Tn = Nt.debug, wn = Nt.BASE64, sn = Nt.constants, bt = [], Dt = Nt.cmcdModel, jt = Nt.settings, fn = Nt.customParametersModel;
            function mn() {
              if (!(Jt && Jt.hasOwnProperty("on") && St && St.hasOwnProperty("getSupportedKeySystemsFromContentProtection"))) throw new Error("Missing config parameter(s)");
            }
            function An(Ft, un) {
              Gt || nn ? Gt && Rn() : function(En, jn) {
                if (!nn) {
                  nn = !0;
                  var Cn, Xn = [];
                  En = En.sort(function(Kn, Bn) {
                    return (Qe && Qe[Kn.ks.systemString] && Qe[Kn.ks.systemString].priority >= 0 ? Qe[Kn.ks.systemString].priority : En.length) - (Qe && Qe[Bn.ks.systemString] && Qe[Bn.ks.systemString].priority >= 0 ? Qe[Bn.ks.systemString].priority : En.length);
                  });
                  for (var Fn = 0; Fn < En.length; Fn++) {
                    var pr = Zr(En[Fn]);
                    Xn.push({ ks: En[Fn].ks, configs: [pr], protData: En[Fn].protData });
                  }
                  tn.requestKeySystemAccess(Xn).then(function(Kn) {
                    var Bn = (Cn = Kn.data).mksa && Cn.mksa.selectedSystemString ? Cn.mksa.selectedSystemString : Cn.keySystem.systemString;
                    return wt.info("DRM: KeySystem Access Granted for system string (" + Bn + ")!  Selecting key system..."), tn.selectKeySystem(Cn);
                  }).then(function(Kn) {
                    if (Gt = Kn, nn = !1, tn) {
                      Jt.trigger(dn.KEY_SYSTEM_SELECTED, { data: Cn });
                      var Bn = Qn(Gt);
                      Bn && Bn.serverCertificate && Bn.serverCertificate.length > 0 && tn.setServerCertificate(wn.decodeArray(Bn.serverCertificate).buffer), Rn();
                    }
                  }).catch(function(Kn) {
                    Gt = null, nn = !1, jn || Jt.trigger(dn.KEY_SYSTEM_SELECTED, { data: null, error: new c.Z(n.KEY_SYSTEM_ACCESS_DENIED_ERROR_CODE, n.KEY_SYSTEM_ACCESS_DENIED_ERROR_MESSAGE + "Error selecting key system! -- " + Kn.error) });
                  });
                }
              }(Ft, un);
            }
            function Rn() {
              for (var Ft, un = 0; un < He.length; un++) for (Ft = 0; Ft < He[un].length; Ft++) if (Gt === He[un][Ft].ks) {
                tr(He[un][Ft]);
                break;
              }
              He = [];
            }
            function tr(Ft) {
              if (St.isClearKey(Gt) && Ft.protData && Ft.protData.hasOwnProperty("clearkeys") && Object.keys(Ft.protData.clearkeys).length !== 0) {
                var un = { kids: Object.keys(Ft.protData.clearkeys) };
                Ft.initData = new TextEncoder().encode(JSON.stringify(un));
              }
              Ft.sessionId ? nr(Ft) : Ft.initData !== null && Un(Ft);
            }
            function nr(Ft) {
              mn(), tn.loadKeySession(Ft);
            }
            function Un(Ft) {
              var un = t.getPSSHForKeySystem(Gt, Ft ? Ft.initData : null);
              if (un) {
                if (function(En) {
                  if (!En) return !1;
                  try {
                    for (var jn = tn.getSessions(), Cn = 0; Cn < jn.length; Cn++) if (jn[Cn].getKeyId() === En) return !0;
                    return !1;
                  } catch {
                    return !1;
                  }
                }(Ft.keyId) || Vn(un)) return;
                try {
                  Ft.initData = un, tn.createKeySession(Ft);
                } catch (En) {
                  Jt.trigger(dn.KEY_SESSION_CREATED, { data: null, error: new c.Z(n.KEY_SESSION_CREATED_ERROR_CODE, n.KEY_SESSION_CREATED_ERROR_MESSAGE + En.message) });
                }
              } else Ft && Ft.initData ? tn.createKeySession(Ft) : Jt.trigger(dn.KEY_SESSION_CREATED, { data: null, error: new c.Z(n.KEY_SESSION_CREATED_ERROR_CODE, n.KEY_SESSION_CREATED_ERROR_MESSAGE + "Selected key system is " + (Gt ? Gt.systemString : null) + ".  needkey/encrypted event contains no initData corresponding to that key system!") });
            }
            function Qn(Ft) {
              if (Ft) {
                var un = Ft.systemString;
                if (Qe) return un in Qe ? Qe[un] : null;
              }
              return null;
            }
            function Vn(Ft) {
              if (!Ft) return !1;
              try {
                for (var un = tn.getAllInitData(), En = 0; En < un.length; En++) if (St.initDataEquals(Ft, un[En])) return wt.debug("DRM: Ignoring initData because we have already seen it!"), !0;
                return !1;
              } catch {
                return !1;
              }
            }
            function rr(Ft) {
              mn(), Ft ? (tn.setMediaElement(Ft), Jt.on(dn.NEED_KEY, ni, At)) : Ft === null && (tn.setMediaElement(Ft), Jt.off(dn.NEED_KEY, ni, At));
            }
            function Zr(Ft) {
              var un = Ft.protData, En = [], jn = [], Cn = un && un.audioRobustness && un.audioRobustness.length > 0 ? un.audioRobustness : Zt, Xn = un && un.videoRobustness && un.videoRobustness.length > 0 ? un.videoRobustness : Zt, Fn = Ft.sessionType, pr = un && un.distinctiveIdentifier ? un.distinctiveIdentifier : "optional", Kn = un && un.persistentState ? un.persistentState : Fn === "temporary" ? "optional" : "required";
              return pt.forEach(function(Bn) {
                Bn.type === sn.AUDIO ? En.push(new e(Bn.codec, Cn)) : Bn.type === sn.VIDEO && jn.push(new e(Bn.codec, Xn));
              }), new p(En, jn, pr, Kn, [Fn]);
            }
            function Tr(Ft) {
              Ft.error ? Jt.trigger(dn.KEY_STATUSES_CHANGED, { data: null, error: Ft.error }) : wt.debug("DRM: key status = " + Ft.status);
            }
            function Ir(Ft) {
              wt.debug("DRM: onKeyMessage");
              var un = Ft.data;
              Jt.trigger(dn.KEY_MESSAGE, { data: un });
              var En = un.messageType ? un.messageType : "license-request", jn = un.message, Cn = un.sessionToken, Xn = Qn(Gt), Fn = St.getLicenseServerModelInstance(Gt, Xn, En), pr = { sessionToken: Cn, messageType: En };
              if (jn && jn.byteLength !== 0) {
                if (!Fn) return wt.debug("DRM: License server request not required for this message (type = " + Ft.data.messageType + ").  Session ID = " + Cn.getSessionId()), void or(pr);
                if (St.isClearKey(Gt)) {
                  var Kn = St.processClearKeyLicenseRequest(Gt, Xn, jn);
                  if (Kn && Kn.keyPairs && Kn.keyPairs.length > 0) return wt.debug("DRM: ClearKey license request handled by application!"), or(pr), void tn.updateKeySession(Cn, Kn);
                }
                (function(Bn, sr, ur) {
                  var Rr = Bn.sessionToken, br = Bn.messageType ? Bn.messageType : "license-request", wr = { sessionToken: Rr, messageType: br }, Ur = Gt ? Gt.systemString : null, _i = function(kn, Yr, oi, Kr, xi) {
                    var Sr = null, Fi = Kr.message;
                    if (kn && kn.serverURL) {
                      var Br = kn.serverURL;
                      typeof Br == "string" && Br !== "" ? Sr = Br : M(Br) === "object" && Br.hasOwnProperty(Yr) && (Sr = Br[Yr]);
                    } else if (kn && kn.laURL && kn.laURL !== "") Sr = kn.laURL;
                    else if (!(Sr = t.getLicenseServerUrlFromMediaInfo(pt, Gt.schemeIdURI)) && !St.isClearKey(Gt)) {
                      var ki = t.getPSSHData(oi.initData);
                      (Sr = Gt.getLicenseServerURLFromInitData(ki)) || (Sr = Kr.laURL);
                    }
                    return Sr = xi.getServerURLFromMessage(Sr, Fi, Yr);
                  }(ur, br, Rr, Bn, sr);
                  if (_i) {
                    var ri = {}, ii = !1;
                    ur && wi(ri, ur.httpRequestHeaders);
                    var Di = Bn.message;
                    wi(ri, Gt.getRequestHeadersFromMessage(Di)), Object.keys(ri).forEach(function(kn) {
                      kn.toLowerCase() === "authorization" && (ii = !0);
                    }), ur && typeof ur.withCredentials == "boolean" && (ii = ur.withCredentials);
                    var Oi = function(kn) {
                      if (tn) if (kn.status >= 200 && kn.status <= 299) {
                        var Yr = B.Z.parseHttpHeaders(kn.getAllResponseHeaders ? kn.getAllResponseHeaders() : null), oi = new S(kn.responseURL, Yr, kn.response);
                        Ni(fn.getLicenseResponseFilters(), oi).then(function() {
                          var Kr = sr.getLicenseMessage(oi.data, Ur, br);
                          Kr !== null ? (or(wr), tn.updateKeySession(Rr, Kr)) : Ci(kn, wr, Ur, br, sr);
                        });
                      } else Ci(kn, wr, Ur, br, sr);
                    }, ca = function(kn) {
                      or(wr, new c.Z(n.MEDIA_KEY_MESSAGE_LICENSER_ERROR_CODE, n.MEDIA_KEY_MESSAGE_LICENSER_ERROR_MESSAGE + Ur + ' update, XHR aborted. status is "' + kn.statusText + '" (' + kn.status + "), readyState is " + kn.readyState));
                    }, fa = function(kn) {
                      or(wr, new c.Z(n.MEDIA_KEY_MESSAGE_LICENSER_ERROR_CODE, n.MEDIA_KEY_MESSAGE_LICENSER_ERROR_MESSAGE + Ur + ' update, XHR error. status is "' + kn.statusText + '" (' + kn.status + "), readyState is " + kn.readyState));
                    }, Mi = Gt.getLicenseRequestFromMessage(Di), Pi = sr.getHTTPMethod(br), da = sr.getResponseType(Ur, br), Ei = ur && !isNaN(ur.httpTimeout) ? ur.httpTimeout : 8e3, Li = Rr.getSessionId() || null, ai = new d(_i, Pi, da, ri, ii, br, Li, Mi), ga = isNaN(jt.get().streaming.retryAttempts[x.w.LICENSE]) ? 3 : jt.get().streaming.retryAttempts[x.w.LICENSE];
                    Ni(fn.getLicenseRequestFilters(), ai).then(function() {
                      Ri(ai, ga, Ei, Oi, ca, fa);
                    });
                  } else or(wr, new c.Z(n.MEDIA_KEY_MESSAGE_NO_LICENSE_SERVER_URL_ERROR_CODE, n.MEDIA_KEY_MESSAGE_NO_LICENSE_SERVER_URL_ERROR_MESSAGE));
                })(un, Fn, Xn);
              } else or(pr, new c.Z(n.MEDIA_KEY_MESSAGE_NO_CHALLENGE_ERROR_CODE, n.MEDIA_KEY_MESSAGE_NO_CHALLENGE_ERROR_MESSAGE));
            }
            function or(Ft, un) {
              Jt.trigger(dn.LICENSE_REQUEST_COMPLETE, { data: Ft, error: un });
            }
            function Ri(Ft, un, En, jn, Cn, Xn) {
              var Fn = new XMLHttpRequest();
              if (jt.get().streaming.cmcd && jt.get().streaming.cmcd.enabled && jt.get().streaming.cmcd.mode === L.Z.CMCD_MODE_QUERY) {
                var pr = Dt.getQueryParameter({ url: Ft.url, type: x.w.LICENSE });
                pr && (Ft.url = B.Z.addAditionalQueryParameterToUrl(Ft.url, [pr]));
              }
              for (var Kn in Fn.open(Ft.method, Ft.url, !0), Fn.responseType = Ft.responseType, Fn.withCredentials = Ft.withCredentials, En > 0 && (Fn.timeout = En), Ft.headers) Fn.setRequestHeader(Kn, Ft.headers[Kn]);
              if (jt.get().streaming.cmcd && jt.get().streaming.cmcd.enabled && jt.get().streaming.cmcd.mode === L.Z.CMCD_MODE_HEADER) {
                var Bn = Dt.getHeaderParameters({ url: Ft.url, type: x.w.LICENSE });
                if (Bn) for (var sr in Bn) {
                  var ur = Bn[sr];
                  ur && Fn.setRequestHeader(sr, ur);
                }
              }
              var Rr = function() {
                un--;
                var br = isNaN(jt.get().streaming.retryIntervals[x.w.LICENSE]) ? 1e3 : jt.get().streaming.retryIntervals[x.w.LICENSE];
                Kt = setTimeout(function() {
                  Ri(Ft, un, En, jn, Cn, Xn);
                }, br);
              };
              Fn.onload = function() {
                rn = null, this.status >= 200 && this.status <= 299 || un <= 0 ? jn(this) : (wt.warn("License request failed (" + this.status + "). Retrying it... Pending retries: " + un), Rr());
              }, Fn.ontimeout = Fn.onerror = function() {
                rn = null, un <= 0 ? Xn(this) : (wt.warn("License request network request failed . Retrying it... Pending retries: " + un), Rr());
              }, Fn.onabort = function() {
                Cn(this);
              }, Jt.trigger(dn.LICENSE_REQUEST_SENDING, { url: Ft.url, headers: Ft.headers, payload: Ft.data, sessionId: Ft.sessionId }), rn = Fn, Fn.send(Ft.data);
            }
            function ti() {
              rn && (rn.onloadend = rn.onerror = rn.onprogress = void 0, rn.abort(), rn = null), Kt && (clearTimeout(Kt), Kt = null);
            }
            function wi(Ft, un) {
              if (un) for (var En in un) Ft[En] = un[En];
            }
            function Ci(Ft, un, En, jn, Cn) {
              var Xn = "NONE", Fn = null;
              Ft.response && (Xn = Cn.getErrorResponse(Ft.response, En, jn), Fn = { serverResponse: Ft.response || null, responseCode: Ft.status || null, responseText: Ft.statusText || null }), or(un, new c.Z(n.MEDIA_KEY_MESSAGE_LICENSER_ERROR_CODE, n.MEDIA_KEY_MESSAGE_LICENSER_ERROR_MESSAGE + En + ' update, XHR complete. status is "' + Ft.statusText + '" (' + Ft.status + "), readyState is " + Ft.readyState + ".  Response is " + Xn, Fn));
            }
            function Ni(Ft, un) {
              return Ft ? Ft.reduce(function(En, jn) {
                return En.then(function() {
                  return jn(un);
                });
              }, Promise.resolve()) : Promise.resolve();
            }
            function ni(Ft, un) {
              if (!jt.get().streaming.protection.ignoreEmeEncryptedEvent) {
                if (wt.debug("DRM: onNeedKey"), Ft.key.initDataType !== "cenc") return void wt.warn("DRM:  Only 'cenc' initData is supported!  Ignoring initData of type: " + Ft.key.initDataType);
                if (pt.length === 0 && (wt.warn("DRM: onNeedKey called before initializeForMedia, wait until initialized"), (un = un === void 0 ? 1 : un + 1) < 5)) return void bt.push(setTimeout(function() {
                  ni(Ft, un);
                }, 500));
                var En = Ft.key.initData;
                if (ArrayBuffer.isView(En) && (En = En.buffer), Gt) {
                  var jn = t.getPSSHForKeySystem(Gt, En);
                  if (jn && Vn(jn)) return;
                }
                wt.debug("DRM: initData:", String.fromCharCode.apply(null, new Uint8Array(En)));
                var Cn = St.getSupportedKeySystemsFromSegmentPssh(En, Qe, dt);
                if (Cn.length === 0) return void wt.debug("DRM: Received needkey event with initData, but we don't support any of the key systems!");
                (function(Xn) {
                  He.push(Xn), An(Xn, !1);
                })(Cn);
              }
            }
            return At = { initializeForMedia: function(Ft) {
              if (!Ft) throw new Error("mediaInfo can not be null or undefined");
              mn(), pt.push(Ft);
            }, clearMediaInfoArray: function() {
              pt = [];
            }, handleKeySystemFromManifest: function() {
              if (pt && pt.length !== 0) {
                var Ft = [];
                pt.forEach(function(un) {
                  var En = St.getSupportedKeySystemsFromContentProtection(un.contentProtection, Qe, dt);
                  En.length > 0 && (Ft.length === 0 && (Ft = En), He.push(En));
                }), Ft && Ft.length > 0 && An(Ft, !0);
              }
            }, createKeySession: Un, loadKeySession: nr, removeKeySession: function(Ft) {
              mn(), tn.removeKeySession(Ft);
            }, closeKeySession: function(Ft) {
              mn(), tn.closeKeySession(Ft);
            }, setServerCertificate: function(Ft) {
              mn(), tn.setServerCertificate(Ft);
            }, setMediaElement: rr, setSessionType: function(Ft) {
              dt = Ft;
            }, setRobustnessLevel: function(Ft) {
              Zt = Ft;
            }, setProtectionData: function(Ft) {
              Qe = Ft, St.setProtectionData(Ft);
            }, getSupportedKeySystemsFromContentProtection: function(Ft) {
              return mn(), St.getSupportedKeySystemsFromContentProtection(Ft, Qe, dt);
            }, getKeySystems: function() {
              return St ? St.getKeySystems() : [];
            }, setKeySystems: function(Ft) {
              St && St.setKeySystems(Ft);
            }, stop: function() {
              ti(), tn && tn.stop();
            }, reset: function() {
              Jt.off(dn.INTERNAL_KEY_MESSAGE, Ir, At), Jt.off(dn.INTERNAL_KEY_STATUS_CHANGED, Tr, At), mn(), ti(), rr(null), Gt = null, nn = !1, tn && (tn.reset(), tn = null), bt.forEach(function(Ft) {
                return clearTimeout(Ft);
              }), bt = [], pt = [], He = [];
            } }, wt = Tn.getLogger(At), He = [], pt = [], dt = "temporary", Zt = "", rn = null, Kt = null, Jt.on(dn.INTERNAL_KEY_MESSAGE, Ir, At), Jt.on(dn.INTERNAL_KEY_STATUS_CHANGED, Tr, At), At;
          }
          K.__dashjs_factory_name = "ProtectionController";
          var ae = $.Z.getClassFactory(K), j = function Nt(At, wt) {
            (function(He, pt) {
              if (!(He instanceof pt)) throw new TypeError("Cannot call a class as a function");
            })(this, Nt), this.keyID = At, this.key = wt;
          };
          function ee(Nt, At) {
            for (var wt = 0; wt < At.length; wt++) {
              var He = At[wt];
              He.enumerable = He.enumerable || !1, He.configurable = !0, "value" in He && (He.writable = !0), Object.defineProperty(Nt, He.key, He);
            }
          }
          var ue = function() {
            function Nt(He, pt) {
              if (function(Qe, dt) {
                if (!(Qe instanceof dt)) throw new TypeError("Cannot call a class as a function");
              }(this, Nt), pt && pt !== "persistent" && pt !== "temporary") throw new Error("Invalid ClearKey key set type!  Must be one of 'persistent' or 'temporary'");
              this.keyPairs = He, this.type = pt;
            }
            var At, wt;
            return At = Nt, (wt = [{ key: "toJWK", value: function() {
              var He, pt = this.keyPairs.length, Qe = { keys: [] };
              for (He = 0; He < pt; He++) {
                var dt = { kty: "oct", alg: "A128KW", kid: this.keyPairs[He].keyID, k: this.keyPairs[He].key };
                Qe.keys.push(dt);
              }
              this.type && (Qe.type = this.type);
              var Zt = JSON.stringify(Qe), Gt = Zt.length, nn = new ArrayBuffer(Gt), rn = new Uint8Array(nn);
              for (He = 0; He < Gt; He++) rn[He] = Zt.charCodeAt(He);
              return nn;
            } }]) && ee(At.prototype, wt), Nt;
          }();
          function Ae(Nt, At) {
            for (var wt = 0; wt < At.length; wt++) {
              var He = At[wt];
              He.enumerable = He.enumerable || !1, He.configurable = !0, "value" in He && (He.writable = !0), Object.defineProperty(Nt, He.key, He);
            }
          }
          var Q = new (function() {
            function Nt() {
              (function(He, pt) {
                if (!(He instanceof pt)) throw new TypeError("Cannot call a class as a function");
              })(this, Nt), this.init();
            }
            var At, wt;
            return At = Nt, (wt = [{ key: "init", value: function() {
              this.CLEARKEY_KEYSTEM_STRING = "org.w3.clearkey", this.WIDEVINE_KEYSTEM_STRING = "com.widevine.alpha", this.PLAYREADY_KEYSTEM_STRING = "com.microsoft.playready", this.PLAYREADY_RECOMMENDATION_KEYSTEM_STRING = "com.microsoft.playready.recommendation", this.INITIALIZATION_DATA_TYPE_CENC = "cenc", this.INITIALIZATION_DATA_TYPE_KEYIDS = "keyids", this.INITIALIZATION_DATA_TYPE_WEBM = "webm";
            } }]) && Ae(At.prototype, wt), Nt;
          }())(), Ne = "e2719d58-a985-b3c9-781a-b030af78d30e", Ue = Q.CLEARKEY_KEYSTEM_STRING, ze = "urn:uuid:" + Ne;
          function Te(Nt) {
            var At = (Nt = Nt || {}).BASE64;
            return { uuid: Ne, schemeIdURI: ze, systemString: Ue, getInitData: function(wt, He) {
              try {
                var pt = t.parseInitDataFromContentProtection(wt, At);
                if (!pt && He) {
                  var Qe = { kids: [function(dt) {
                    try {
                      var Zt = dt.replace(/-/g, "");
                      return (Zt = btoa(Zt.match(/\w{2}/g).map(function(Gt) {
                        return String.fromCharCode(parseInt(Gt, 16));
                      }).join(""))).replace(/=/g, "").replace(/\//g, "_").replace(/\+/g, "-");
                    } catch {
                      return null;
                    }
                  }(He["cenc:default_KID"])] };
                  pt = new TextEncoder().encode(JSON.stringify(Qe));
                }
                return pt;
              } catch {
                return null;
              }
            }, getRequestHeadersFromMessage: function() {
              return { "Content-Type": "application/json" };
            }, getLicenseRequestFromMessage: function(wt) {
              return JSON.stringify(JSON.parse(String.fromCharCode.apply(null, new Uint8Array(wt))));
            }, getLicenseServerURLFromInitData: function() {
              return null;
            }, getCDMData: function() {
              return null;
            }, getClearKeysFromProtectionData: function(wt, He) {
              var pt = null;
              if (wt) {
                for (var Qe = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(He))), dt = [], Zt = 0; Zt < Qe.kids.length; Zt++) {
                  var Gt = Qe.kids[Zt], nn = wt.clearkeys && wt.clearkeys.hasOwnProperty(Gt) ? wt.clearkeys[Gt] : null;
                  if (!nn) throw new Error("DRM: ClearKey keyID (" + Gt + ") is not known!");
                  dt.push(new j(Gt, nn));
                }
                pt = new ue(dt);
              }
              return pt;
            } };
          }
          Te.__dashjs_factory_name = "KeySystemClearKey";
          var Oe = dashjs.FactoryMaker.getSingletonFactory(Te), We = "1077efec-c0b2-4d02-ace3-3c1e52e2fb4b", at = Q.CLEARKEY_KEYSTEM_STRING, Se = "urn:uuid:" + We;
          function ke(Nt) {
            var At, wt = Nt.BASE64, He = Nt.debug.getLogger(At);
            return { uuid: We, schemeIdURI: Se, systemString: at, getInitData: function(pt) {
              return t.parseInitDataFromContentProtection(pt, wt);
            }, getRequestHeadersFromMessage: function() {
              return null;
            }, getLicenseRequestFromMessage: function(pt) {
              return new Uint8Array(pt);
            }, getLicenseServerURLFromInitData: function() {
              return null;
            }, getCDMData: function() {
              return null;
            }, getClearKeysFromProtectionData: function(pt, Qe) {
              var dt = null;
              if (pt) {
                for (var Zt = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(Qe))), Gt = [], nn = 0; nn < Zt.kids.length; nn++) {
                  var rn = Zt.kids[nn], Kt = pt.clearkeys && pt.clearkeys.hasOwnProperty(rn) ? pt.clearkeys[rn] : null;
                  if (!Kt) throw new Error("DRM: ClearKey keyID (" + rn + ") is not known!");
                  Gt.push(new j(rn, Kt));
                }
                dt = new ue(Gt), He.warn("ClearKey schemeIdURI is using W3C Common PSSH systemID (1077efec-c0b2-4d02-ace3-3c1e52e2fb4b) in Content Protection. See DASH-IF IOP v4.1 section 7.6.2.4");
              }
              return dt;
            } };
          }
          ke.__dashjs_factory_name = "KeySystemW3CClearKey";
          var Rt = dashjs.FactoryMaker.getSingletonFactory(ke), _t = "edef8ba9-79d6-4ace-a3c8-27dcd51d21ed", qe = Q.WIDEVINE_KEYSTEM_STRING, it = "urn:uuid:" + _t;
          function me(Nt) {
            var At = (Nt = Nt || {}).BASE64;
            return { uuid: _t, schemeIdURI: it, systemString: qe, getInitData: function(wt) {
              return t.parseInitDataFromContentProtection(wt, At);
            }, getRequestHeadersFromMessage: function() {
              return null;
            }, getLicenseRequestFromMessage: function(wt) {
              return new Uint8Array(wt);
            }, getLicenseServerURLFromInitData: function() {
              return null;
            }, getCDMData: function() {
              return null;
            } };
          }
          me.__dashjs_factory_name = "KeySystemWidevine";
          var ye = dashjs.FactoryMaker.getSingletonFactory(me), Ve = "9a04f079-9840-4286-ab92-e65be0885f95", f = Q.PLAYREADY_KEYSTEM_STRING, u = "urn:uuid:" + Ve;
          function v(Nt) {
            var At = "utf-16", wt = (Nt = Nt || {}).BASE64, He = Nt.settings;
            function pt() {
              if (!wt || !wt.hasOwnProperty("decodeArray") || !wt.hasOwnProperty("decodeArray")) throw new Error("Missing config parameter(s)");
            }
            return { uuid: Ve, schemeIdURI: u, systemString: f, getInitData: function(Qe) {
              var dt, Zt, Gt, nn, rn, Kt = new Uint8Array([112, 115, 115, 104, 0, 0, 0, 0]), St = new Uint8Array([154, 4, 240, 121, 152, 64, 66, 134, 171, 146, 230, 91, 224, 136, 95, 149]), tn = 0, Jt = null;
              if (pt(), !Qe) return null;
              if ("pssh" in Qe) return t.parseInitDataFromContentProtection(Qe, wt);
              if ("pro" in Qe) Jt = wt.decodeArray(Qe.pro.__text);
              else {
                if (!("prheader" in Qe)) return null;
                Jt = wt.decodeArray(Qe.prheader.__text);
              }
              return dt = Jt.length, Zt = 4 + Kt.length + St.length + 4 + dt, Gt = new ArrayBuffer(Zt), nn = new Uint8Array(Gt), (rn = new DataView(Gt)).setUint32(tn, Zt), tn += 4, nn.set(Kt, tn), tn += Kt.length, nn.set(St, tn), tn += St.length, rn.setUint32(tn, dt), tn += 4, nn.set(Jt, tn), tn += dt, nn.buffer;
            }, getRequestHeadersFromMessage: function(Qe) {
              var dt, Zt, Gt = {}, nn = new DOMParser();
              if (He && He.get().streaming.protection.detectPlayreadyMessageFormat && At === "utf-16" && Qe && Qe.byteLength % 2 == 1) return Gt["Content-Type"] = "text/xml; charset=utf-8", Gt;
              var rn = At === "utf-16" ? new Uint16Array(Qe) : new Uint8Array(Qe);
              dt = String.fromCharCode.apply(null, rn);
              for (var Kt = (Zt = nn.parseFromString(dt, "application/xml")).getElementsByTagName("name"), St = Zt.getElementsByTagName("value"), tn = 0; tn < Kt.length; tn++) Gt[Kt[tn].childNodes[0].nodeValue] = St[tn].childNodes[0].nodeValue;
              return Gt.hasOwnProperty("Content") && (Gt["Content-Type"] = Gt.Content, delete Gt.Content), Gt.hasOwnProperty("Content-Type") || (Gt["Content-Type"] = "text/xml; charset=utf-8"), Gt;
            }, getLicenseRequestFromMessage: function(Qe) {
              var dt = null, Zt = new DOMParser();
              if (He && He.get().streaming.protection.detectPlayreadyMessageFormat && At === "utf-16" && Qe && Qe.byteLength % 2 == 1) return Qe;
              var Gt = At === "utf-16" ? new Uint16Array(Qe) : new Uint8Array(Qe);
              pt();
              var nn = String.fromCharCode.apply(null, Gt), rn = Zt.parseFromString(nn, "application/xml");
              if (!rn.getElementsByTagName("PlayReadyKeyMessage")[0]) return Qe;
              var Kt = rn.getElementsByTagName("Challenge")[0].childNodes[0].nodeValue;
              return Kt && (dt = wt.decode(Kt)), dt;
            }, getLicenseServerURLFromInitData: function(Qe) {
              if (Qe) for (var dt = new DataView(Qe), Zt = dt.getUint16(4, !0), Gt = 6, nn = new DOMParser(), rn = 0; rn < Zt; rn++) {
                var Kt = dt.getUint16(Gt, !0);
                Gt += 2;
                var St = dt.getUint16(Gt, !0);
                if (Gt += 2, Kt === 1) {
                  var tn = Qe.slice(Gt, Gt + St), Jt = String.fromCharCode.apply(null, new Uint16Array(tn)), dn = nn.parseFromString(Jt, "application/xml");
                  if (dn.getElementsByTagName("LA_URL")[0]) {
                    var Tn = dn.getElementsByTagName("LA_URL")[0].childNodes[0].nodeValue;
                    if (Tn) return Tn;
                  }
                  if (dn.getElementsByTagName("LUI_URL")[0]) {
                    var wn = dn.getElementsByTagName("LUI_URL")[0].childNodes[0].nodeValue;
                    if (wn) return wn;
                  }
                } else Gt += St;
              }
              return null;
            }, getCDMData: function(Qe) {
              var dt, Zt, Gt, nn;
              if (pt(), !Qe) return null;
              for (dt = [], nn = 0; nn < Qe.length; ++nn) dt.push(Qe.charCodeAt(nn)), dt.push(0);
              for (dt = String.fromCharCode.apply(null, dt), dt = wt.encode(dt), Zt = '<PlayReadyCDMData type="LicenseAcquisition"><LicenseAcquisition version="1.0" Proactive="false"><CustomData encoding="base64encoded">%CUSTOMDATA%</CustomData></LicenseAcquisition></PlayReadyCDMData>'.replace("%CUSTOMDATA%", dt), Gt = [], nn = 0; nn < Zt.length; ++nn) Gt.push(Zt.charCodeAt(nn)), Gt.push(0);
              return new Uint8Array(Gt).buffer;
            }, setPlayReadyMessageFormat: function(Qe) {
              if (Qe !== "utf-8" && Qe !== "utf-16") throw new Error('Specified message format is not one of "utf-8" or "utf-16"');
              At = Qe;
            } };
          }
          v.__dashjs_factory_name = "KeySystemPlayReady";
          var b = dashjs.FactoryMaker.getSingletonFactory(v);
          function W(Nt) {
            var At = (Nt = Nt || {}).BASE64, wt = {};
            return wt[Q.WIDEVINE_KEYSTEM_STRING] = { responseType: "json", getLicenseMessage: function(He) {
              return At.decodeArray(He.license);
            }, getErrorResponse: function(He) {
              return He;
            } }, wt[Q.PLAYREADY_KEYSTEM_STRING] = { responseType: "arraybuffer", getLicenseMessage: function(He) {
              return He;
            }, getErrorResponse: function(He) {
              return String.fromCharCode.apply(null, new Uint8Array(He));
            } }, { getServerURLFromMessage: function(He) {
              return He;
            }, getHTTPMethod: function() {
              return "POST";
            }, getResponseType: function(He) {
              return wt[He].responseType;
            }, getLicenseMessage: function(He, pt) {
              return function() {
                if (!At || !At.hasOwnProperty("decodeArray")) throw new Error("Missing config parameter(s)");
              }(), wt[pt].getLicenseMessage(He);
            }, getErrorResponse: function(He, pt) {
              return wt[pt].getErrorResponse(He);
            } };
          }
          W.__dashjs_factory_name = "DRMToday";
          var Y = dashjs.FactoryMaker.getSingletonFactory(W);
          function Re() {
            var Nt = "http://schemas.xmlsoap.org/soap/envelope/";
            function At(pt) {
              var Qe = String.fromCharCode.apply(null, new Uint8Array(pt));
              return decodeURIComponent(escape(Qe));
            }
            function wt(pt) {
              if (window.DOMParser) {
                var Qe = At(pt), dt = new window.DOMParser().parseFromString(Qe, "text/xml"), Zt = dt ? dt.getElementsByTagNameNS(Nt, "Envelope")[0] : null, Gt = Zt ? Zt.getElementsByTagNameNS(Nt, "Body")[0] : null;
                if (Gt && Gt.getElementsByTagNameNS(Nt, "Fault")[0]) return null;
              }
              return pt;
            }
            function He(pt) {
              var Qe = "", dt = "", Zt = "", Gt = -1, nn = -1;
              if (window.DOMParser) {
                var rn = At(pt), Kt = new window.DOMParser().parseFromString(rn, "text/xml"), St = Kt ? Kt.getElementsByTagNameNS(Nt, "Envelope")[0] : null, tn = St ? St.getElementsByTagNameNS(Nt, "Body")[0] : null, Jt = tn ? tn.getElementsByTagNameNS(Nt, "Fault")[0] : null, dn = Jt ? Jt.getElementsByTagName("detail")[0] : null, Tn = dn ? dn.getElementsByTagName("Exception")[0] : null, wn = null;
                if (Jt === null) return rn;
                Qe = (wn = Jt.getElementsByTagName("faultstring")[0].firstChild) ? wn.nodeValue : null, Tn !== null && (dt = (wn = Tn.getElementsByTagName("StatusCode")[0]) ? wn.firstChild.nodeValue : null, Gt = (Zt = (wn = Tn.getElementsByTagName("Message")[0]) ? wn.firstChild.nodeValue : null) ? Zt.lastIndexOf("[") + 1 : -1, nn = Zt ? Zt.indexOf("]") : -1, Zt = Zt ? Zt.substring(Gt, nn) : "");
              }
              var sn = "code: ".concat(dt, ", name: ").concat(Qe);
              return Zt && (sn += ", message: ".concat(Zt)), sn;
            }
            return { getServerURLFromMessage: function(pt) {
              return pt;
            }, getHTTPMethod: function() {
              return "POST";
            }, getResponseType: function() {
              return "arraybuffer";
            }, getLicenseMessage: function(pt) {
              return wt.call(this, pt);
            }, getErrorResponse: function(pt) {
              return He.call(this, pt);
            } };
          }
          Re.__dashjs_factory_name = "PlayReady";
          var Je = $.Z.getSingletonFactory(Re);
          function Ze() {
            return { getServerURLFromMessage: function(Nt) {
              return Nt;
            }, getHTTPMethod: function() {
              return "POST";
            }, getResponseType: function() {
              return "arraybuffer";
            }, getLicenseMessage: function(Nt) {
              return Nt;
            }, getErrorResponse: function(Nt) {
              return String.fromCharCode.apply(null, new Uint8Array(Nt));
            } };
          }
          Ze.__dashjs_factory_name = "Widevine";
          var Fe = dashjs.FactoryMaker.getSingletonFactory(Ze);
          function we() {
            return { getServerURLFromMessage: function(Nt) {
              return Nt;
            }, getHTTPMethod: function() {
              return "POST";
            }, getResponseType: function() {
              return "json";
            }, getLicenseMessage: function(Nt) {
              if (!Nt.hasOwnProperty("keys")) return null;
              for (var At = [], wt = 0; wt < Nt.keys.length; wt++) {
                var He = Nt.keys[wt], pt = He.kid.replace(/=/g, ""), Qe = He.k.replace(/=/g, "");
                At.push(new j(pt, Qe));
              }
              return new ue(At);
            }, getErrorResponse: function(Nt) {
              return String.fromCharCode.apply(null, new Uint8Array(Nt));
            } };
          }
          we.__dashjs_factory_name = "ClearKey";
          var Ge = dashjs.FactoryMaker.getSingletonFactory(we);
          function nt() {
            var Nt, At, wt, He, pt, Qe, dt, Zt, Gt = this.context;
            function nn(St, tn) {
              return tn && St in tn ? tn[St] : null;
            }
            function rn(St, tn) {
              return St && St.sessionId ? St.sessionId : tn && tn.sessionId ? tn.sessionId : null;
            }
            function Kt(St, tn) {
              return St && St.sessionType ? St.sessionType : tn;
            }
            return Nt = { initialize: function() {
              var St;
              He = [], St = b(Gt).getInstance({ BASE64: pt, settings: Qe }), He.push(St), St = ye(Gt).getInstance({ BASE64: pt }), He.push(St), St = Oe(Gt).getInstance({ BASE64: pt }), He.push(St), dt = St, St = Rt(Gt).getInstance({ BASE64: pt, debug: At }), He.push(St), Zt = St;
            }, setProtectionData: function(St) {
              for (var tn, Jt, dn = 0; dn < He.length; dn++) {
                var Tn = He[dn];
                Tn.hasOwnProperty("init") && Tn.init((tn = Tn.systemString, Jt = void 0, Jt = null, St && (Jt = tn in St ? St[tn] : null), Jt));
              }
            }, isClearKey: function(St) {
              return St === dt || St === Zt;
            }, initDataEquals: function(St, tn) {
              if (St.byteLength === tn.byteLength) {
                for (var Jt = new Uint8Array(St), dn = new Uint8Array(tn), Tn = 0; Tn < Jt.length; Tn++) if (Jt[Tn] !== dn[Tn]) return !1;
                return !0;
              }
              return !1;
            }, getKeySystems: function() {
              return He;
            }, setKeySystems: function(St) {
              He = St;
            }, getKeySystemBySystemString: function(St) {
              for (var tn = 0; tn < He.length; tn++) if (He[tn].systemString === St) return He[tn];
              return null;
            }, getSupportedKeySystemsFromContentProtection: function(St, tn, Jt) {
              var dn, Tn, wn, sn, bt = [];
              if (St) {
                var Dt = t.findCencContentProtection(St);
                for (wn = 0; wn < He.length; ++wn) {
                  var jt = nn((Tn = He[wn]).systemString, tn);
                  for (sn = 0; sn < St.length; ++sn) if ((dn = St[sn]).schemeIdUri.toLowerCase() === Tn.schemeIdURI) {
                    var fn = Tn.getInitData(dn, Dt);
                    bt.push({ ks: He[wn], keyId: dn.keyId, initData: fn, protData: jt, cdmData: Tn.getCDMData(jt ? jt.cdmData : null), sessionId: rn(jt, dn), sessionType: Kt(jt, Jt) });
                  }
                }
              }
              return bt;
            }, getSupportedKeySystemsFromSegmentPssh: function(St, tn, Jt) {
              for (var dn, Tn = [], wn = t.parsePSSHList(St), sn = 0; sn < He.length; ++sn) {
                var bt = nn((dn = He[sn]).systemString, tn);
                dn.uuid in wn && Tn.push({ ks: dn, initData: wn[dn.uuid], protData: bt, cdmData: dn.getCDMData(bt ? bt.cdmData : null), sessionId: rn(bt), sessionType: Kt(bt, Jt) });
              }
              return Tn;
            }, getLicenseServerModelInstance: function(St, tn, Jt) {
              if (Jt === "license-release" || Jt === "individualization-request") return null;
              var dn = null;
              return tn && tn.hasOwnProperty("drmtoday") ? dn = Y(Gt).getInstance({ BASE64: pt }) : St.systemString === Q.WIDEVINE_KEYSTEM_STRING ? dn = Fe(Gt).getInstance() : St.systemString === Q.PLAYREADY_KEYSTEM_STRING ? dn = Je(Gt).getInstance() : St.systemString === Q.CLEARKEY_KEYSTEM_STRING && (dn = Ge(Gt).getInstance()), dn;
            }, processClearKeyLicenseRequest: function(St, tn, Jt) {
              try {
                return St.getClearKeysFromProtectionData(tn, Jt);
              } catch {
                return wt.error("Failed to retrieve clearkeys from ProtectionData"), null;
              }
            }, setConfig: function(St) {
              St && (St.debug && (At = St.debug, wt = At.getLogger(Nt)), St.BASE64 && (pt = St.BASE64), St.settings && (Qe = St.settings));
            } }, Nt;
          }
          nt.__dashjs_factory_name = "ProtectionKeyController";
          var Tt = dashjs.FactoryMaker.getSingletonFactory(nt);
          function ft(Nt) {
            return ft = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(At) {
              return typeof At;
            } : function(At) {
              return At && typeof Symbol == "function" && At.constructor === Symbol && At !== Symbol.prototype ? "symbol" : typeof At;
            }, ft(Nt);
          }
          function Yt(Nt, At) {
            return Yt = Object.setPrototypeOf || function(wt, He) {
              return wt.__proto__ = He, wt;
            }, Yt(Nt, At);
          }
          function Ot(Nt, At) {
            return !At || ft(At) !== "object" && typeof At != "function" ? function(wt) {
              if (wt === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return wt;
            }(Nt) : At;
          }
          function qt(Nt) {
            return qt = Object.setPrototypeOf ? Object.getPrototypeOf : function(At) {
              return At.__proto__ || Object.getPrototypeOf(At);
            }, qt(Nt);
          }
          var Bt = new (function(Nt) {
            (function(Qe, dt) {
              if (typeof dt != "function" && dt !== null) throw new TypeError("Super expression must either be null or a function");
              Qe.prototype = Object.create(dt && dt.prototype, { constructor: { value: Qe, writable: !0, configurable: !0 } }), dt && Yt(Qe, dt);
            })(pt, Nt);
            var At, wt, He = (At = pt, wt = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var Qe, dt = qt(At);
              if (wt) {
                var Zt = qt(this).constructor;
                Qe = Reflect.construct(dt, arguments, Zt);
              } else Qe = dt.apply(this, arguments);
              return Ot(this, Qe);
            });
            function pt() {
              var Qe;
              return function(dt, Zt) {
                if (!(dt instanceof Zt)) throw new TypeError("Cannot call a class as a function");
              }(this, pt), (Qe = He.call(this)).INTERNAL_KEY_MESSAGE = "internalKeyMessage", Qe.INTERNAL_KEY_STATUS_CHANGED = "internalkeyStatusChanged", Qe.KEY_ADDED = "public_keyAdded", Qe.KEY_ERROR = "public_keyError", Qe.KEY_MESSAGE = "public_keyMessage", Qe.KEY_SESSION_CLOSED = "public_keySessionClosed", Qe.KEY_SESSION_CREATED = "public_keySessionCreated", Qe.KEY_SESSION_REMOVED = "public_keySessionRemoved", Qe.KEY_STATUSES_CHANGED = "public_keyStatusesChanged", Qe.KEY_SYSTEM_ACCESS_COMPLETE = "public_keySystemAccessComplete", Qe.KEY_SYSTEM_SELECTED = "public_keySystemSelected", Qe.LICENSE_REQUEST_COMPLETE = "public_licenseRequestComplete", Qe.LICENSE_REQUEST_SENDING = "public_licenseRequestSending", Qe.NEED_KEY = "needkey", Qe.PROTECTION_CREATED = "public_protectioncreated", Qe.PROTECTION_DESTROYED = "public_protectiondestroyed", Qe.SERVER_CERTIFICATE_UPDATED = "serverCertificateUpdated", Qe.TEARDOWN_COMPLETE = "protectionTeardownComplete", Qe.VIDEO_ELEMENT_SELECTED = "videoElementSelected", Qe.KEY_SESSION_UPDATED = "public_keySessionUpdated", Qe;
            }
            return pt;
          }(C(8342).Z))(), cn = function Nt(At, wt) {
            (function(He, pt) {
              if (!(He instanceof pt)) throw new TypeError("Cannot call a class as a function");
            })(this, Nt), this.initData = At, this.initDataType = wt;
          }, vn = function Nt(At, wt, He, pt) {
            (function(Qe, dt) {
              if (!(Qe instanceof dt)) throw new TypeError("Cannot call a class as a function");
            })(this, Nt), this.sessionToken = At, this.message = wt, this.defaultURL = He, this.messageType = pt || "license-request";
          }, Pn = function Nt(At, wt) {
            (function(He, pt) {
              if (!(He instanceof pt)) throw new TypeError("Cannot call a class as a function");
            })(this, Nt), this.keySystem = At, this.ksConfiguration = wt;
          }, Dn = {};
          function xn(Nt) {
            Nt = Nt || {};
            var At, wt, He, pt, Qe, dt, Zt, Gt, nn = this.context, rn = Nt.eventBus, Kt = Nt.events, St = Nt.debug;
            function tn(bt, Dt, jt, fn) {
              if (navigator.requestMediaKeySystemAccess === void 0 || typeof navigator.requestMediaKeySystemAccess != "function") {
                var mn = "Insecure origins are not allowed";
                return rn.trigger(Kt.KEY_SYSTEM_ACCESS_COMPLETE, { error: mn }), void fn({ error: mn });
              }
              var An = bt[Dt].protData && bt[Dt].protData.systemStringPriority ? bt[Dt].protData.systemStringPriority : null, Rn = bt[Dt].configs, tr = bt[Dt].ks, nr = tr.systemString;
              (function(Un, Qn) {
                return new Promise(function(Vn, rr) {
                  Jt(Un, Qn, 0, Vn, rr);
                });
              })(An || (Dn[nr] ? Dn[nr] : [nr]), Rn).then(function(Un) {
                var Qn = typeof Un.getConfiguration == "function" ? Un.getConfiguration() : null, Vn = new Pn(tr, Qn);
                Vn.mksa = Un, rn.trigger(Kt.KEY_SYSTEM_ACCESS_COMPLETE, { data: Vn }), jt({ data: Vn });
              }).catch(function(Un) {
                if (Dt + 1 < bt.length) tn(bt, Dt + 1, jt, fn);
                else {
                  var Qn = "Key system access denied! ";
                  rn.trigger(Kt.KEY_SYSTEM_ACCESS_COMPLETE, { error: Qn + Un.message }), fn({ error: Qn + Un.message });
                }
              });
            }
            function Jt(bt, Dt, jt, fn, mn) {
              var An = bt[jt];
              wt.debug("Requesting key system access for system string ".concat(An)), navigator.requestMediaKeySystemAccess(An, Dt).then(function(Rn) {
                Rn.selectedSystemString = An, fn(Rn);
              }).catch(function(Rn) {
                jt + 1 < bt.length ? Jt(bt, Dt, jt + 1, fn, mn) : mn(Rn);
              });
            }
            function dn(bt) {
              if (!bt || !bt.session) return Promise.resolve;
              var Dt = bt.session;
              return Dt.removeEventListener("keystatuseschange", bt), Dt.removeEventListener("message", bt), Dt.close();
            }
            function Tn(bt) {
              for (var Dt = 0; Dt < dt.length; Dt++) if (dt[Dt] === bt) {
                dt.splice(Dt, 1);
                break;
              }
            }
            function wn(bt) {
              var Dt, jt;
              return bt && bt.length > 0 && (bt[0] && (typeof bt[0] == "string" ? Dt = bt[0] : jt = bt[0]), bt[1] && (typeof bt[1] == "string" ? Dt = bt[1] : jt = bt[1])), { status: Dt, keyId: jt };
            }
            function sn(bt, Dt) {
              var jt = { session: bt, keyId: Dt.keyId, initData: Dt.initData, sessionId: Dt.sessionId, sessionType: Dt.sessionType, handleEvent: function(fn) {
                switch (fn.type) {
                  case "keystatuseschange":
                    rn.trigger(Kt.KEY_STATUSES_CHANGED, { data: this }), fn.target.keyStatuses.forEach(function() {
                      var An = wn(arguments);
                      An.status === "expired" ? rn.trigger(Kt.INTERNAL_KEY_STATUS_CHANGED, { error: new c.Z(n.KEY_STATUS_CHANGED_EXPIRED_ERROR_CODE, n.KEY_STATUS_CHANGED_EXPIRED_ERROR_MESSAGE) }) : rn.trigger(Kt.INTERNAL_KEY_STATUS_CHANGED, An);
                    });
                    break;
                  case "message":
                    var mn = ArrayBuffer.isView(fn.message) ? fn.message.buffer : fn.message;
                    rn.trigger(Kt.INTERNAL_KEY_MESSAGE, { data: new vn(this, mn, void 0, fn.messageType) });
                }
              }, getKeyId: function() {
                return this.keyId;
              }, getSessionId: function() {
                return bt.sessionId;
              }, getSessionType: function() {
                return this.sessionType;
              }, getExpirationTime: function() {
                return bt.expiration;
              }, getKeyStatuses: function() {
                return bt.keyStatuses;
              }, getUsable: function() {
                var fn = !1;
                return bt.keyStatuses.forEach(function() {
                  var mn = wn(arguments);
                  mn.status === "usable" && (fn = !0);
                }), fn;
              } };
              return bt.addEventListener("keystatuseschange", jt), bt.addEventListener("message", jt), bt.closed.then(function() {
                Tn(jt), wt.debug("DRM: Session closed.  SessionID = " + jt.getSessionId()), rn.trigger(Kt.KEY_SESSION_CLOSED, { data: jt.getSessionId() });
              }), dt.push(jt), jt;
            }
            return At = { getAllInitData: function() {
              for (var bt = [], Dt = 0; Dt < dt.length; Dt++) dt[Dt].initData && bt.push(dt[Dt].initData);
              return bt;
            }, getSessions: function() {
              return dt;
            }, requestKeySystemAccess: function(bt) {
              return new Promise(function(Dt, jt) {
                tn(bt, 0, Dt, jt);
              });
            }, selectKeySystem: function(bt) {
              return new Promise(function(Dt, jt) {
                bt.mksa.createMediaKeys().then(function(fn) {
                  return He = bt.keySystem, Qe = fn, pt ? pt.setMediaKeys(Qe) : Promise.resolve();
                }).then(function() {
                  Dt(He);
                }).catch(function() {
                  jt({ error: "Error selecting keys system (" + bt.keySystem.systemString + ")! Could not create MediaKeys -- TODO" });
                });
              });
            }, setMediaElement: function(bt) {
              pt !== bt && (pt && (pt.removeEventListener("encrypted", Zt), pt.setMediaKeys && pt.setMediaKeys(null)), (pt = bt) && (pt.addEventListener("encrypted", Zt), pt.setMediaKeys && Qe && pt.setMediaKeys(Qe)));
            }, setServerCertificate: function(bt) {
              if (!He || !Qe) throw new Error("Can not set server certificate until you have selected a key system");
              Qe.setServerCertificate(bt).then(function() {
                wt.info("DRM: License server certificate successfully updated."), rn.trigger(Kt.SERVER_CERTIFICATE_UPDATED);
              }).catch(function(Dt) {
                rn.trigger(Kt.SERVER_CERTIFICATE_UPDATED, { error: new c.Z(n.SERVER_CERTIFICATE_UPDATED_ERROR_CODE, n.SERVER_CERTIFICATE_UPDATED_ERROR_MESSAGE + Dt.name) });
              });
            }, createKeySession: function(bt) {
              if (!He || !Qe) throw new Error("Can not create sessions until you have selected a key system");
              var Dt = Qe.createSession(bt.sessionType), jt = sn(Dt, bt), fn = He.systemString === Q.CLEARKEY_KEYSTEM_STRING && (bt.initData || bt.protData && bt.protData.clearkeys) ? Q.INITIALIZATION_DATA_TYPE_KEYIDS : Q.INITIALIZATION_DATA_TYPE_CENC;
              Dt.generateRequest(fn, bt.initData).then(function() {
                wt.debug("DRM: Session created.  SessionID = " + jt.getSessionId()), rn.trigger(Kt.KEY_SESSION_CREATED, { data: jt });
              }).catch(function(mn) {
                Tn(jt), rn.trigger(Kt.KEY_SESSION_CREATED, { data: null, error: new c.Z(n.KEY_SESSION_CREATED_ERROR_CODE, n.KEY_SESSION_CREATED_ERROR_MESSAGE + "Error generating key request -- " + mn.name) });
              });
            }, updateKeySession: function(bt, Dt) {
              var jt = bt.session;
              Gt.isClearKey(He) && (Dt = Dt.toJWK()), jt.update(Dt).then(function() {
                rn.trigger(Kt.KEY_SESSION_UPDATED);
              }).catch(function(fn) {
                rn.trigger(Kt.KEY_ERROR, { error: new c.Z(n.MEDIA_KEYERR_CODE, "Error sending update() message! " + fn.name, bt) });
              });
            }, loadKeySession: function(bt) {
              if (!He || !Qe) throw new Error("Can not load sessions until you have selected a key system");
              for (var Dt = bt.sessionId, jt = 0; jt < dt.length; jt++) if (Dt === dt[jt].sessionId) return void wt.warn("DRM: Ignoring session ID because we have already seen it!");
              var fn = Qe.createSession(bt.sessionType), mn = sn(fn, bt);
              fn.load(Dt).then(function(An) {
                An ? (wt.debug("DRM: Session loaded.  SessionID = " + mn.getSessionId()), rn.trigger(Kt.KEY_SESSION_CREATED, { data: mn })) : (Tn(mn), rn.trigger(Kt.KEY_SESSION_CREATED, { data: null, error: new c.Z(n.KEY_SESSION_CREATED_ERROR_CODE, n.KEY_SESSION_CREATED_ERROR_MESSAGE + "Could not load session! Invalid Session ID (" + Dt + ")") }));
              }).catch(function(An) {
                Tn(mn), rn.trigger(Kt.KEY_SESSION_CREATED, { data: null, error: new c.Z(n.KEY_SESSION_CREATED_ERROR_CODE, n.KEY_SESSION_CREATED_ERROR_MESSAGE + "Could not load session (" + Dt + ")! " + An.name) });
              });
            }, removeKeySession: function(bt) {
              bt.session.remove().then(function() {
                wt.debug("DRM: Session removed.  SessionID = " + bt.getSessionId()), rn.trigger(Kt.KEY_SESSION_REMOVED, { data: bt.getSessionId() });
              }, function(Dt) {
                rn.trigger(Kt.KEY_SESSION_REMOVED, { data: null, error: "Error removing session (" + bt.getSessionId() + "). " + Dt.name });
              });
            }, closeKeySession: function(bt) {
              dn(bt).catch(function(Dt) {
                Tn(bt), rn.trigger(Kt.KEY_SESSION_CLOSED, { data: null, error: "Error closing session (" + bt.getSessionId() + ") " + Dt.name });
              });
            }, stop: function() {
              for (var bt, Dt = 0; Dt < dt.length; Dt++) (bt = dt[Dt]).getUsable() || (dn(bt), Tn(bt));
            }, reset: function() {
              var bt, Dt = dt.length;
              Dt !== 0 ? function() {
                for (var jt = function(mn) {
                  Tn(mn), dt.length === 0 && (pt ? (pt.removeEventListener("encrypted", Zt), pt.setMediaKeys(null).then(function() {
                    rn.trigger(Kt.TEARDOWN_COMPLETE);
                  })) : rn.trigger(Kt.TEARDOWN_COMPLETE));
                }, fn = 0; fn < Dt; fn++) (function(mn) {
                  dn(bt), jt(mn);
                })(bt = dt[fn]);
              }() : rn.trigger(Kt.TEARDOWN_COMPLETE);
            } }, wt = St.getLogger(At), He = null, pt = null, Qe = null, dt = [], Gt = Tt(nn).getInstance(), Zt = { handleEvent: function(bt) {
              if (bt.type === "encrypted" && bt.initData) {
                var Dt = ArrayBuffer.isView(bt.initData) ? bt.initData.buffer : bt.initData;
                rn.trigger(Kt.NEED_KEY, { key: new cn(Dt, bt.initDataType) });
              }
            } }, At;
          }
          Dn[Q.PLAYREADY_KEYSTEM_STRING] = [Q.PLAYREADY_KEYSTEM_STRING, Q.PLAYREADY_RECOMMENDATION_KEYSTEM_STRING], Dn[Q.WIDEVINE_KEYSTEM_STRING] = [Q.WIDEVINE_KEYSTEM_STRING], Dn[Q.CLEARKEY_KEYSTEM_STRING] = [Q.CLEARKEY_KEYSTEM_STRING], xn.__dashjs_factory_name = "ProtectionModel_21Jan2015";
          var er = dashjs.FactoryMaker.getClassFactory(xn);
          function In(Nt) {
            Nt = Nt || {};
            var At, wt, He, pt, Qe, dt, Zt, Gt, nn, rn = this.context, Kt = Nt.eventBus, St = Nt.events, tn = Nt.debug, Jt = Nt.api;
            function dn() {
              try {
                for (var sn = 0; sn < Zt.length; sn++) Tn(Zt[sn]);
                He && He.removeEventListener(Jt.needkey, Gt), Kt.trigger(St.TEARDOWN_COMPLETE);
              } catch (bt) {
                Kt.trigger(St.TEARDOWN_COMPLETE, { error: "Error tearing down key sessions and MediaKeys! -- " + bt.message });
              }
            }
            function Tn(sn) {
              var bt = sn.session;
              bt.removeEventListener(Jt.error, sn), bt.removeEventListener(Jt.message, sn), bt.removeEventListener(Jt.ready, sn), bt.removeEventListener(Jt.close, sn);
              for (var Dt = 0; Dt < Zt.length; Dt++) if (Zt[Dt] === sn) {
                Zt.splice(Dt, 1);
                break;
              }
              bt[Jt.release]();
            }
            function wn() {
              var sn = null, bt = function() {
                He.removeEventListener("loadedmetadata", sn), He[Jt.setMediaKeys](Qe), Kt.trigger(St.VIDEO_ELEMENT_SELECTED);
              };
              He.readyState >= 1 ? bt() : (sn = bt.bind(this), He.addEventListener("loadedmetadata", sn));
            }
            return At = { getAllInitData: function() {
              for (var sn = [], bt = 0; bt < Zt.length; bt++) sn.push(Zt[bt].initData);
              return sn;
            }, getSessions: function() {
              return Zt;
            }, requestKeySystemAccess: function(sn) {
              return new Promise(function(bt, Dt) {
                for (var jt = !1, fn = 0; fn < sn.length; fn++) for (var mn = sn[fn].ks.systemString, An = sn[fn].configs, Rn = null, tr = null, nr = 0; nr < An.length; nr++) {
                  var Un = An[nr].audioCapabilities, Qn = An[nr].videoCapabilities;
                  if (Un && Un.length !== 0) {
                    Rn = [];
                    for (var Vn = 0; Vn < Un.length; Vn++) window[Jt.MediaKeys].isTypeSupported(mn, Un[Vn].contentType) && Rn.push(Un[Vn]);
                  }
                  if (Qn && Qn.length !== 0) {
                    tr = [];
                    for (var rr = 0; rr < Qn.length; rr++) window[Jt.MediaKeys].isTypeSupported(mn, Qn[rr].contentType) && tr.push(Qn[rr]);
                  }
                  if (!(!Rn && !tr || Rn && Rn.length === 0 || tr && tr.length === 0)) {
                    jt = !0;
                    var Zr = new p(Rn, tr), Tr = nn.getKeySystemBySystemString(mn), Ir = new Pn(Tr, Zr);
                    Kt.trigger(St.KEY_SYSTEM_ACCESS_COMPLETE, { data: Ir }), bt({ data: Ir });
                    break;
                  }
                }
                if (!jt) {
                  var or = "Key system access denied! -- No valid audio/video content configurations detected!";
                  Kt.trigger(St.KEY_SYSTEM_ACCESS_COMPLETE, { error: or }), Dt({ error: or });
                }
              });
            }, selectKeySystem: function(sn) {
              return new Promise(function(bt, Dt) {
                try {
                  Qe = sn.mediaKeys = new window[Jt.MediaKeys](sn.keySystem.systemString), pt = sn.keySystem, dt = sn, He && wn(), bt(pt);
                } catch {
                  Dt({ error: "Error selecting keys system (" + pt.systemString + ")! Could not create MediaKeys -- TODO" });
                }
              });
            }, setMediaElement: function(sn) {
              He !== sn && (He && He.removeEventListener(Jt.needkey, Gt), (He = sn) && (He.addEventListener(Jt.needkey, Gt), Qe && wn()));
            }, createKeySession: function(sn) {
              if (!pt || !Qe || !dt) throw new Error("Can not create sessions until you have selected a key system");
              var bt = null;
              if (dt.ksConfiguration.videoCapabilities && dt.ksConfiguration.videoCapabilities.length > 0 && (bt = dt.ksConfiguration.videoCapabilities[0]), bt === null && dt.ksConfiguration.audioCapabilities && dt.ksConfiguration.audioCapabilities.length > 0 && (bt = dt.ksConfiguration.audioCapabilities[0]), bt === null) throw new Error("Can not create sessions for unknown content types.");
              var Dt = bt.contentType, jt = Qe.createSession(Dt, new Uint8Array(sn.initData), sn.cdmData ? new Uint8Array(sn.cdmData) : null), fn = function(mn, An) {
                return { session: mn, keyId: An.keyId, initData: An.initData, getKeyId: function() {
                  return this.keyId;
                }, getSessionId: function() {
                  return this.session.sessionId;
                }, getExpirationTime: function() {
                  return NaN;
                }, getSessionType: function() {
                  return "temporary";
                }, handleEvent: function(Rn) {
                  switch (Rn.type) {
                    case Jt.error:
                      Kt.trigger(St.KEY_ERROR, { error: new c.Z(n.MEDIA_KEYERR_CODE, "KeyError", this) });
                      break;
                    case Jt.message:
                      var tr = ArrayBuffer.isView(Rn.message) ? Rn.message.buffer : Rn.message;
                      Kt.trigger(St.INTERNAL_KEY_MESSAGE, { data: new vn(this, tr, Rn.destinationURL) });
                      break;
                    case Jt.ready:
                      wt.debug("DRM: Key added."), Kt.trigger(St.KEY_ADDED);
                      break;
                    case Jt.close:
                      wt.debug("DRM: Session closed.  SessionID = " + this.getSessionId()), Kt.trigger(St.KEY_SESSION_CLOSED, { data: this.getSessionId() });
                  }
                } };
              }(jt, sn);
              jt.addEventListener(Jt.error, fn), jt.addEventListener(Jt.message, fn), jt.addEventListener(Jt.ready, fn), jt.addEventListener(Jt.close, fn), Zt.push(fn), wt.debug("DRM: Session created.  SessionID = " + fn.getSessionId()), Kt.trigger(St.KEY_SESSION_CREATED, { data: fn });
            }, updateKeySession: function(sn, bt) {
              var Dt = sn.session;
              nn.isClearKey(pt) ? Dt.update(new Uint8Array(bt.toJWK())) : Dt.update(new Uint8Array(bt)), Kt.trigger(St.KEY_SESSION_UPDATED);
            }, closeKeySession: Tn, setServerCertificate: function() {
            }, loadKeySession: function() {
            }, removeKeySession: function() {
            }, stop: dn, reset: dn }, wt = tn.getLogger(At), He = null, pt = null, Qe = null, dt = null, Zt = [], nn = Tt(rn).getInstance(), Gt = { handleEvent: function(sn) {
              if (sn.type === Jt.needkey && sn.initData) {
                var bt = ArrayBuffer.isView(sn.initData) ? sn.initData.buffer : sn.initData;
                Kt.trigger(St.NEED_KEY, { key: new cn(bt, "cenc") });
              }
            } }, At;
          }
          In.__dashjs_factory_name = "ProtectionModel_3Feb2014";
          var cr = dashjs.FactoryMaker.getClassFactory(In);
          function Yn(Nt) {
            Nt = Nt || {};
            var At, wt, He, pt, Qe, dt, Zt, Gt, nn, rn = this.context, Kt = Nt.eventBus, St = Nt.events, tn = Nt.debug, Jt = Nt.api, dn = Nt.errHandler;
            function Tn() {
              He && bt();
              for (var Dt = 0; Dt < Zt.length; Dt++) wn(Zt[Dt]);
              Kt.trigger(St.TEARDOWN_COMPLETE);
            }
            function wn(Dt) {
              try {
                He[Jt.cancelKeyRequest](pt.systemString, Dt.sessionId);
              } catch (jt) {
                Kt.trigger(St.KEY_SESSION_CLOSED, { data: null, error: "Error closing session (" + Dt.sessionId + ") " + jt.message });
              }
            }
            function sn(Dt, jt) {
              if (jt && Dt) {
                for (var fn = Dt.length, mn = 0; mn < fn; mn++) if (Dt[mn].sessionId == jt) return Dt[mn];
                return null;
              }
              return null;
            }
            function bt() {
              He.removeEventListener(Jt.keyerror, nn), He.removeEventListener(Jt.needkey, nn), He.removeEventListener(Jt.keymessage, nn), He.removeEventListener(Jt.keyadded, nn);
            }
            return At = { getAllInitData: function() {
              for (var Dt = [], jt = 0; jt < dt.length; jt++) Dt.push(dt[jt].initData);
              for (var fn = 0; fn < Zt.length; fn++) Dt.push(Zt[fn].initData);
              return Dt;
            }, getSessions: function() {
              return Zt.concat(dt);
            }, requestKeySystemAccess: function(Dt) {
              return new Promise(function(jt, fn) {
                var mn = He;
                mn || (mn = document.createElement("video"));
                for (var An = !1, Rn = 0; Rn < Dt.length; Rn++) for (var tr = Dt[Rn].ks.systemString, nr = Dt[Rn].configs, Un = null, Qn = 0; Qn < nr.length; Qn++) {
                  var Vn = nr[Qn].videoCapabilities;
                  if (Vn && Vn.length !== 0) {
                    Un = [];
                    for (var rr = 0; rr < Vn.length; rr++) mn.canPlayType(Vn[rr].contentType, tr) !== "" && Un.push(Vn[rr]);
                  }
                  if (Un && (!Un || Un.length !== 0)) {
                    An = !0;
                    var Zr = new p(null, Un), Tr = Qe.getKeySystemBySystemString(tr), Ir = new Pn(Tr, Zr);
                    Kt.trigger(St.KEY_SYSTEM_ACCESS_COMPLETE, { data: Ir }), jt({ data: Ir });
                    break;
                  }
                }
                if (!An) {
                  var or = "Key system access denied! -- No valid audio/video content configurations detected!";
                  Kt.trigger(St.KEY_SYSTEM_ACCESS_COMPLETE, { error: or }), fn({ error: or });
                }
              });
            }, selectKeySystem: function(Dt) {
              return pt = Dt.keySystem, Promise.resolve(pt);
            }, setMediaElement: function(Dt) {
              if (He !== Dt) {
                if (He) {
                  bt();
                  for (var jt = 0; jt < Zt.length; jt++) wn(Zt[jt]);
                  Zt = [];
                }
                (He = Dt) && (He.addEventListener(Jt.keyerror, nn), He.addEventListener(Jt.needkey, nn), He.addEventListener(Jt.keymessage, nn), He.addEventListener(Jt.keyadded, nn), Kt.trigger(St.VIDEO_ELEMENT_SELECTED));
              }
            }, createKeySession: function(Dt) {
              if (!pt) throw new Error("Can not create sessions until you have selected a key system");
              if (Gt || Zt.length === 0) {
                var jt = { sessionId: null, keyId: Dt.keyId, initData: Dt.initData, getKeyId: function() {
                  return this.keyId;
                }, getSessionId: function() {
                  return this.sessionId;
                }, getExpirationTime: function() {
                  return NaN;
                }, getSessionType: function() {
                  return "temporary";
                } };
                return dt.push(jt), He[Jt.generateKeyRequest](pt.systemString, new Uint8Array(Dt.initData)), jt;
              }
              throw new Error("Multiple sessions not allowed!");
            }, updateKeySession: function(Dt, jt) {
              var fn = Dt.sessionId;
              if (Qe.isClearKey(pt)) for (var mn = 0; mn < jt.keyPairs.length; mn++) He[Jt.addKey](pt.systemString, jt.keyPairs[mn].key, jt.keyPairs[mn].keyID, fn);
              else He[Jt.addKey](pt.systemString, new Uint8Array(jt), new Uint8Array(Dt.initData), fn);
              Kt.trigger(St.KEY_SESSION_UPDATED);
            }, closeKeySession: wn, setServerCertificate: function() {
            }, loadKeySession: function() {
            }, removeKeySession: function() {
            }, stop: Tn, reset: Tn }, wt = tn.getLogger(At), He = null, pt = null, dt = [], Zt = [], Qe = Tt(rn).getInstance(), nn = { handleEvent: function(Dt) {
              var jt = null;
              switch (Dt.type) {
                case Jt.needkey:
                  var fn = ArrayBuffer.isView(Dt.initData) ? Dt.initData.buffer : Dt.initData;
                  Kt.trigger(St.NEED_KEY, { key: new cn(fn, "cenc") });
                  break;
                case Jt.keyerror:
                  if ((jt = sn(Zt, Dt.sessionId)) || (jt = sn(dt, Dt.sessionId)), jt) {
                    var mn = n.MEDIA_KEYERR_CODE, An = "";
                    switch (Dt.errorCode.code) {
                      case 1:
                        mn = n.MEDIA_KEYERR_UNKNOWN_CODE, An += "MEDIA_KEYERR_UNKNOWN - " + n.MEDIA_KEYERR_UNKNOWN_MESSAGE;
                        break;
                      case 2:
                        mn = n.MEDIA_KEYERR_CLIENT_CODE, An += "MEDIA_KEYERR_CLIENT - " + n.MEDIA_KEYERR_CLIENT_MESSAGE;
                        break;
                      case 3:
                        mn = n.MEDIA_KEYERR_SERVICE_CODE, An += "MEDIA_KEYERR_SERVICE - " + n.MEDIA_KEYERR_SERVICE_MESSAGE;
                        break;
                      case 4:
                        mn = n.MEDIA_KEYERR_OUTPUT_CODE, An += "MEDIA_KEYERR_OUTPUT - " + n.MEDIA_KEYERR_OUTPUT_MESSAGE;
                        break;
                      case 5:
                        mn = n.MEDIA_KEYERR_HARDWARECHANGE_CODE, An += "MEDIA_KEYERR_HARDWARECHANGE - " + n.MEDIA_KEYERR_HARDWARECHANGE_MESSAGE;
                        break;
                      case 6:
                        mn = n.MEDIA_KEYERR_DOMAIN_CODE, An += "MEDIA_KEYERR_DOMAIN - " + n.MEDIA_KEYERR_DOMAIN_MESSAGE;
                    }
                    An += "  System Code = " + Dt.systemCode, Kt.trigger(St.KEY_ERROR, { error: new c.Z(mn, An, jt) });
                  } else wt.error("No session token found for key error");
                  break;
                case Jt.keyadded:
                  (jt = sn(Zt, Dt.sessionId)) || (jt = sn(dt, Dt.sessionId)), jt ? (wt.debug("DRM: Key added."), Kt.trigger(St.KEY_ADDED, { data: jt })) : wt.debug("No session token found for key added");
                  break;
                case Jt.keymessage:
                  if ((Gt = Dt.sessionId !== null && Dt.sessionId !== void 0) ? !(jt = sn(Zt, Dt.sessionId)) && dt.length > 0 && (jt = dt.shift(), Zt.push(jt), jt.sessionId = Dt.sessionId, Kt.trigger(St.KEY_SESSION_CREATED, { data: jt })) : dt.length > 0 && (jt = dt.shift(), Zt.push(jt), dt.length !== 0 && dn.error(new c.Z(n.MEDIA_KEY_MESSAGE_ERROR_CODE, n.MEDIA_KEY_MESSAGE_ERROR_MESSAGE))), jt) {
                    var Rn = ArrayBuffer.isView(Dt.message) ? Dt.message.buffer : Dt.message;
                    jt.keyMessage = Rn, Kt.trigger(St.INTERNAL_KEY_MESSAGE, { data: new vn(jt, Rn, Dt.defaultURL) });
                  } else wt.warn("No session token found for key message");
              }
            } }, At;
          }
          Yn.__dashjs_factory_name = "ProtectionModel_01b";
          var ir = dashjs.FactoryMaker.getClassFactory(Yn), mr = [{ generateKeyRequest: "generateKeyRequest", addKey: "addKey", cancelKeyRequest: "cancelKeyRequest", needkey: "needkey", keyerror: "keyerror", keyadded: "keyadded", keymessage: "keymessage" }, { generateKeyRequest: "webkitGenerateKeyRequest", addKey: "webkitAddKey", cancelKeyRequest: "webkitCancelKeyRequest", needkey: "webkitneedkey", keyerror: "webkitkeyerror", keyadded: "webkitkeyadded", keymessage: "webkitkeymessage" }], ar = [{ setMediaKeys: "setMediaKeys", MediaKeys: "MediaKeys", release: "close", needkey: "needkey", error: "keyerror", message: "keymessage", ready: "keyadded", close: "keyclose" }, { setMediaKeys: "msSetMediaKeys", MediaKeys: "MSMediaKeys", release: "close", needkey: "msneedkey", error: "mskeyerror", message: "mskeymessage", ready: "mskeyadded", close: "mskeyclose" }];
          function Er() {
            var Nt, At = this.context;
            function wt(He, pt) {
              for (var Qe = 0; Qe < pt.length; Qe++) {
                var dt = pt[Qe];
                if (typeof He[dt[Object.keys(dt)[0]]] == "function") return dt;
              }
              return null;
            }
            return Nt = { createProtectionSystem: function(He) {
              var pt = null, Qe = Tt(At).getInstance();
              Qe.setConfig({ debug: He.debug, BASE64: He.BASE64, settings: He.settings }), Qe.initialize();
              var dt = function(Zt) {
                var Gt = Zt.debug, nn = Gt.getLogger(Nt), rn = Zt.eventBus, Kt = Zt.errHandler, St = Zt.videoModel ? Zt.videoModel.getElement() : null;
                return St && St.onencrypted === void 0 || St && St.mediaKeys === void 0 ? wt(St, ar) ? (nn.info("EME detected on this user agent! (ProtectionModel_3Feb2014)"), cr(At).create({ debug: Gt, eventBus: rn, events: Zt.events, api: wt(St, ar) })) : wt(St, mr) ? (nn.info("EME detected on this user agent! (ProtectionModel_01b)"), ir(At).create({ debug: Gt, eventBus: rn, errHandler: Kt, events: Zt.events, api: wt(St, mr) })) : (nn.warn("No supported version of EME detected on this user agent! - Attempts to play encrypted content will fail!"), null) : (nn.info("EME detected on this user agent! (ProtectionModel_21Jan2015)"), er(At).create({ debug: Gt, eventBus: rn, events: Zt.events }));
              }(He);
              return !pt && dt && (pt = ae(At).create({ protectionModel: dt, protectionKeyController: Qe, eventBus: He.eventBus, debug: He.debug, events: He.events, BASE64: He.BASE64, constants: He.constants, cmcdModel: He.cmcdModel, customParametersModel: He.customParametersModel, settings: He.settings }), He.capabilities.setEncryptedMediaSupported(!0)), pt;
            } };
          }
          Er.__dashjs_factory_name = "Protection";
          var vr = dashjs.FactoryMaker.getClassFactory(Er);
          vr.events = Bt, vr.errors = n, dashjs.FactoryMaker.updateClassFactory(Er.__dashjs_factory_name, vr);
          var ei = vr;
        }, 2068: function(Pe, Ee, C) {
          var ie = C(5448), T = { DEFAULT: 0.5, STRONG: 1, WEAK: 0 };
          function t(p, m, o) {
            var E, h;
            return E = p === void 0 ? -1 : p, h = function(n) {
              var c = T.DEFAULT;
              return n !== T.DEFAULT && n !== T.STRONG && n !== T.WEAK || (c = n), c;
            }(o), { quality: E, reason: m === void 0 ? null : m, priority: h };
          }
          t.__dashjs_factory_name = "SwitchRequest";
          var e = ie.Z.getClassFactory(t);
          e.NO_CHANGE = -1, e.PRIORITY = T, ie.Z.updateClassFactory(t.__dashjs_factory_name, e), Ee.Z = e;
        }, 1767: function(Pe, Ee, C) {
          var ie = C(5628), T = C(6535), t = C(7423), e = C(895), p = C(6070), m = C(3112), o = C(1914), E = C(5435), h = C(5448), n = C(2068), c = C(3393), d = "qualitySwitchRules", S = "abandonFragmentRules";
          function x(L) {
            L = L || {};
            var $, M, K = this.context, ae = L.mediaPlayerModel, j = L.customParametersModel, ee = L.dashMetrics, ue = L.settings;
            function Ae(Ne) {
              return Ne.filter(function(Ue) {
                return Ue.quality > n.Z.NO_CHANGE;
              });
            }
            function Q(Ne) {
              var Ue, ze, Te, Oe, We, at = {}, Se = null;
              if (Ne.length !== 0) {
                for (at[n.Z.PRIORITY.STRONG] = { quality: n.Z.NO_CHANGE, reason: null }, at[n.Z.PRIORITY.WEAK] = { quality: n.Z.NO_CHANGE, reason: null }, at[n.Z.PRIORITY.DEFAULT] = { quality: n.Z.NO_CHANGE, reason: null }, Ue = 0, ze = Ne.length; Ue < ze; Ue += 1) (Te = Ne[Ue]).quality !== n.Z.NO_CHANGE && (at[Te.priority].quality === n.Z.NO_CHANGE || at[Te.priority].quality > Te.quality) && (at[Te.priority].quality = Te.quality, at[Te.priority].reason = Te.reason || null);
                return at[n.Z.PRIORITY.WEAK].quality !== n.Z.NO_CHANGE && (Se = at[n.Z.PRIORITY.WEAK]), at[n.Z.PRIORITY.DEFAULT].quality !== n.Z.NO_CHANGE && (Se = at[n.Z.PRIORITY.DEFAULT]), at[n.Z.PRIORITY.STRONG].quality !== n.Z.NO_CHANGE && (Se = at[n.Z.PRIORITY.STRONG]), Se && (Oe = Se.quality, We = Se.reason), (0, n.Z)(K).create(Oe, We);
              }
            }
            return { initialize: function() {
              $ = [], M = [], ue.get().streaming.abr.useDefaultABRRules && (ue.get().streaming.abr.ABRStrategy === c.Z.ABR_STRATEGY_L2A ? $.push((0, o.Z)(K).create({ dashMetrics: ee, settings: ue })) : ue.get().streaming.abr.ABRStrategy === c.Z.ABR_STRATEGY_LoLP ? $.push((0, E.Z)(K).create({ dashMetrics: ee })) : ($.push((0, m.Z)(K).create({ dashMetrics: ee, mediaPlayerModel: ae, settings: ue })), $.push((0, ie.Z)(K).create({ dashMetrics: ee })), ue.get().streaming.abr.additionalAbrRules.insufficientBufferRule && $.push((0, T.Z)(K).create({ dashMetrics: ee, settings: ue })), ue.get().streaming.abr.additionalAbrRules.switchHistoryRule && $.push((0, p.Z)(K).create()), ue.get().streaming.abr.additionalAbrRules.droppedFramesRule && $.push((0, e.Z)(K).create()), ue.get().streaming.abr.additionalAbrRules.abandonRequestsRule && M.push((0, t.Z)(K).create({ dashMetrics: ee, mediaPlayerModel: ae, settings: ue })))), j.getAbrCustomRules().forEach(function(Ne) {
                Ne.type === d && $.push(Ne.rule(K).create()), Ne.type === S && M.push(Ne.rule(K).create());
              });
            }, reset: function() {
              [$, M].forEach(function(Ne) {
                Ne && Ne.length && Ne.forEach(function(Ue) {
                  return Ue.reset && Ue.reset();
                });
              }), $ = [], M = [];
            }, getMaxQuality: function(Ne) {
              return Q(Ae($.map(function(Ue) {
                return Ue.getMaxIndex(Ne);
              }))) || (0, n.Z)(K).create();
            }, getMinSwitchRequest: Q, shouldAbandonFragment: function(Ne, Ue) {
              var ze = Q(Ae(M.map(function(Te) {
                return Te.shouldAbandon(Ne, Ue);
              })));
              return ze && (ze.reason.forceAbandon = !0), ze || (0, n.Z)(K).create();
            }, getQualitySwitchRules: function() {
              return $;
            } };
          }
          x.__dashjs_factory_name = "ABRRulesCollection";
          var B = h.Z.getClassFactory(x);
          B.QUALITY_SWITCH_RULES = d, B.ABANDON_FRAGMENT_RULES = S, h.Z.updateSingletonFactory(x.__dashjs_factory_name, B), Ee.Z = B;
        }, 7423: function(Pe, Ee, C) {
          var ie = C(2068), T = C(5448), t = C(6398);
          function e(p) {
            p = p || {};
            var m, o, E, h, n, c = this.context, d = p.mediaPlayerModel, S = p.dashMetrics, x = p.settings;
            function B() {
              E = {}, h = {}, n = [];
            }
            return m = { shouldAbandon: function(L) {
              var $ = (0, ie.Z)(c).create(ie.Z.NO_CHANGE, { name: e.__dashjs_factory_name });
              if (!(L && L.hasOwnProperty("getMediaInfo") && L.hasOwnProperty("getMediaType") && L.hasOwnProperty("getCurrentRequest") && L.hasOwnProperty("getRepresentationInfo") && L.hasOwnProperty("getAbrController"))) return $;
              var M, K, ae = L.getMediaInfo(), j = L.getMediaType(), ee = L.getStreamInfo(), ue = ee ? ee.id : null, Ae = L.getCurrentRequest();
              if (!isNaN(Ae.index)) {
                M = j, K = Ae.index, E[M] = E[M] || {}, E[M][K] = E[M][K] || {};
                var Q = d.getStableBufferTime();
                if (S.getCurrentBufferLevel(j) > Q) return $;
                var Ne = E[j][Ae.index];
                if (Ne === null || Ae.firstByteDate === null || h.hasOwnProperty(Ne.id)) return $;
                if (Ne.firstByteTime === void 0 && (n[j] = [], Ne.firstByteTime = Ae.firstByteDate.getTime(), Ne.segmentDuration = Ae.duration, Ne.bytesTotal = Ae.bytesTotal, Ne.id = Ae.index), Ne.bytesLoaded = Ae.bytesLoaded, Ne.elapsedTime = (/* @__PURE__ */ new Date()).getTime() - Ne.firstByteTime, Ne.bytesLoaded > 0 && Ne.elapsedTime > 0 && function(ke, Rt) {
                  n[ke] = n[ke] || [], n[ke].push(Rt);
                }(j, Math.round(8 * Ne.bytesLoaded / Ne.elapsedTime)), n[j].length >= x.get().streaming.abr.abrRulesParameters.abandonRequestsRule.minLengthToAverage && Ne.elapsedTime > x.get().streaming.abr.abrRulesParameters.abandonRequestsRule.graceTimeThreshold && Ne.bytesLoaded < Ne.bytesTotal) {
                  var Ue = n[j].reduce(function(ke, Rt) {
                    return ke + Rt;
                  }, 0);
                  if (Ne.measuredBandwidthInKbps = Math.round(Ue / n[j].length), Ne.estimatedTimeOfDownload = +(8 * Ne.bytesTotal / Ne.measuredBandwidthInKbps / 1e3).toFixed(2), Ne.estimatedTimeOfDownload < Ne.segmentDuration * x.get().streaming.abr.abrRulesParameters.abandonRequestsRule.abandonMultiplier || L.getRepresentationInfo().quality === 0) return $;
                  if (!h.hasOwnProperty(Ne.id)) {
                    var ze = L.getAbrController(), Te = Ne.bytesTotal - Ne.bytesLoaded, Oe = ze.getBitrateList(ae), We = ze.getQualityForBitrate(ae, Ne.measuredBandwidthInKbps * x.get().streaming.abr.bandwidthSafetyFactor, ue), at = ze.getMinAllowedIndexFor(j, ue), Se = at !== void 0 ? Math.max(at, We) : We;
                    Te > Ne.bytesTotal * Oe[Se].bitrate / Oe[ze.getQualityFor(j, ue)].bitrate && ($.quality = Se, $.reason.throughput = Ne.measuredBandwidthInKbps, $.reason.fragmentID = Ne.id, $.reason.rule = this.getClassName(), h[Ne.id] = Ne, o.debug("[" + j + "] frag id", Ne.id, " is asking to abandon and switch to quality to ", Se, " measured bandwidth was", Ne.measuredBandwidthInKbps), delete E[j][Ne.id]);
                  }
                } else Ne.bytesLoaded === Ne.bytesTotal && delete E[j][Ne.id];
              }
              return $;
            }, reset: B }, o = (0, t.Z)(c).getInstance().getLogger(m), B(), m;
          }
          e.__dashjs_factory_name = "AbandonRequestsRule", Ee.Z = T.Z.getClassFactory(e);
        }, 3112: function(Pe, Ee, C) {
          var ie = C(3860), T = C(2068), t = C(5448), e = C(7855), p = C(5595), m = C(8512), o = C(6398), E = C(8825), h = C(3393), n = 10;
          function c(d) {
            d = d || {};
            var S, x, B, L = this.context, $ = d.dashMetrics, M = d.mediaPlayerModel, K = (0, p.Z)(L).getInstance();
            function ae(Se, ke, Rt) {
              var _t = Rt.reduce(function(me, ye, Ve) {
                return ye > Rt[me] ? Ve : me;
              }, 0);
              if (_t === 0) return null;
              var qe = Math.max(Se, n + 2 * ke.length), it = (Rt[_t] - 1) / (qe / n - 1);
              return { gp: it, Vp: n / it };
            }
            function j(Se) {
              Se.placeholderBuffer = 0, Se.mostAdvancedSegmentStart = NaN, Se.lastSegmentWasReplacement = !1, Se.lastSegmentStart = NaN, Se.lastSegmentDurationS = NaN, Se.lastSegmentRequestTimeMs = NaN, Se.lastSegmentFinishTimeMs = NaN;
            }
            function ee(Se, ke) {
              var Rt = M.getStableBufferTime();
              if (Se.stableBufferTime !== Rt) {
                var _t = ae(Rt, Se.bitrates, Se.utilities);
                if (_t.Vp !== Se.Vp || _t.gp !== Se.gp) {
                  var qe = $.getCurrentBufferLevel(ke), it = qe + Se.placeholderBuffer;
                  it -= n, it *= _t.Vp / Se.Vp, it += n, Se.stableBufferTime = Rt, Se.Vp = _t.Vp, Se.gp = _t.gp, Se.placeholderBuffer = Math.max(0, it - qe);
                }
              }
            }
            function ue(Se, ke) {
              return Se.Vp * (Se.utilities[ke] + Se.gp);
            }
            function Ae(Se, ke) {
              for (var Rt = Se.bitrates[ke], _t = Se.utilities[ke], qe = 0, it = ke - 1; it >= 0; --it) if (Se.utilities[it] < Se.utilities[ke]) {
                var me = Se.bitrates[it], ye = Se.utilities[it], Ve = Se.Vp * (Se.gp + (Rt * ye - me * _t) / (Rt - me));
                qe = Math.max(qe, Ve);
              }
              return qe;
            }
            function Q(Se) {
              var ke = Se.mediaType === h.Z.AUDIO ? [h.Z.AUDIO] : B;
              for (var Rt in ke) B.hasOwnProperty(Rt) && B[Rt].state === 2 && (B[Rt].placeholderBuffer = 0);
            }
            function Ne() {
              for (var Se in B) if (B.hasOwnProperty(Se)) {
                var ke = B[Se];
                ke.state !== 0 && (ke.state = 1, j(ke));
              }
            }
            function Ue(Se) {
              if (Se && Se.chunk && Se.chunk.mediaInfo) {
                var ke = B[Se.chunk.mediaInfo.type];
                if (ke && ke.state !== 0) {
                  var Rt = Se.chunk.start;
                  isNaN(ke.mostAdvancedSegmentStart) || Rt > ke.mostAdvancedSegmentStart ? (ke.mostAdvancedSegmentStart = Rt, ke.lastSegmentWasReplacement = !1) : ke.lastSegmentWasReplacement = !0, ke.lastSegmentStart = Rt, ke.lastSegmentDurationS = Se.chunk.duration, ke.lastQuality = Se.chunk.quality, Te(ke, Se.chunk.mediaInfo.type);
                }
              }
            }
            function ze(Se) {
              if (Se && Se.metric === ie.Z.HTTP_REQUEST && Se.value && Se.value.type === e.w.MEDIA_SEGMENT_TYPE && Se.value.trace && Se.value.trace.length) {
                var ke = B[Se.mediaType];
                ke && ke.state !== 0 && (ke.lastSegmentRequestTimeMs = Se.value.trequest.getTime(), ke.lastSegmentFinishTimeMs = Se.value._tfinish.getTime(), Te(ke, Se.mediaType));
              }
            }
            function Te(Se, ke) {
              if (!isNaN(Se.lastSegmentStart) && !isNaN(Se.lastSegmentRequestTimeMs) && !isNaN(Se.placeholderBuffer)) {
                if (Se.placeholderBuffer *= 0.99, !isNaN(Se.lastSegmentFinishTimeMs)) {
                  var Rt = $.getCurrentBufferLevel(ke) + 1e-3 * (Se.lastSegmentFinishTimeMs - Se.lastSegmentRequestTimeMs), _t = ue(Se, Se.lastQuality), qe = Math.max(0, _t - Rt);
                  Se.placeholderBuffer = Math.min(qe, Se.placeholderBuffer);
                }
                Se.lastSegmentWasReplacement && !isNaN(Se.lastSegmentDurationS) && (Se.placeholderBuffer += Se.lastSegmentDurationS), Se.lastSegmentStart = NaN, Se.lastSegmentRequestTimeMs = NaN;
              }
            }
            function Oe(Se) {
              if (Se) {
                var ke = B[Se.mediaType];
                ke && ke.state !== 0 && (ke.abrQuality = Se.newQuality);
              }
            }
            function We(Se) {
              if (Se) {
                var ke = B[Se.mediaType];
                if (ke && ke.state !== 0) {
                  var Rt, _t = $.getCurrentBufferLevel(Se.mediaType);
                  Rt = ke.abrQuality > 0 ? Ae(ke, ke.abrQuality) : n;
                  var qe = Math.max(0, Rt - _t);
                  ke.placeholderBuffer = Math.min(ke.placeholderBuffer, qe);
                }
              }
            }
            function at() {
              B = {};
            }
            return S = { getMaxIndex: function(Se) {
              var ke = (0, T.Z)(L).create();
              if (!(Se && Se.hasOwnProperty("getMediaInfo") && Se.hasOwnProperty("getMediaType") && Se.hasOwnProperty("getScheduleController") && Se.hasOwnProperty("getStreamInfo") && Se.hasOwnProperty("getAbrController") && Se.hasOwnProperty("useBufferOccupancyABR"))) return ke;
              var Rt = Se.getMediaInfo(), _t = Se.getMediaType(), qe = Se.getScheduleController(), it = Se.getStreamInfo(), me = Se.getAbrController(), ye = me.getThroughputHistory(), Ve = it ? it.id : null, f = it && it.manifestInfo && it.manifestInfo.isDynamic, u = Se.useBufferOccupancyABR();
              if (ke.reason = ke.reason || {}, !u) return ke;
              qe.setTimeToLoadDelay(0);
              var v = function(we) {
                var Ge = we.getMediaType(), nt = B[Ge];
                return nt ? nt.state !== 0 && ee(nt, Ge) : (nt = function(Tt) {
                  var ft = {}, Yt = Tt.getMediaInfo().bitrateList.map(function(cn) {
                    return cn.bandwidth;
                  }), Ot = function(cn) {
                    return cn.map(function(vn) {
                      return Math.log(vn);
                    });
                  }(Yt);
                  Ot = Ot.map(function(cn) {
                    return cn - Ot[0] + 1;
                  });
                  var qt = M.getStableBufferTime(), Bt = ae(qt, Yt, Ot);
                  return Bt ? (ft.state = 1, ft.bitrates = Yt, ft.utilities = Ot, ft.stableBufferTime = qt, ft.Vp = Bt.Vp, ft.gp = Bt.gp, ft.lastQuality = 0, j(ft)) : ft.state = 0, ft;
                }(we), B[Ge] = nt), nt;
              }(Se);
              if (v.state === 0) return ke;
              var b, W = $.getCurrentBufferLevel(_t), Y = ye.getAverageThroughput(_t, f), Re = ye.getSafeAverageThroughput(_t, f), Je = ye.getAverageLatency(_t);
              if (ke.reason.state = v.state, ke.reason.throughput = Y, ke.reason.latency = Je, isNaN(Y)) return ke;
              switch (v.state) {
                case 1:
                  b = me.getQualityForBitrate(Rt, Re, Ve, Je), ke.quality = b, ke.reason.throughput = Re, v.placeholderBuffer = Math.max(0, Ae(v, b) - W), v.lastQuality = b, !isNaN(v.lastSegmentDurationS) && W >= v.lastSegmentDurationS && (v.state = 2);
                  break;
                case 2:
                  (function(we, Ge) {
                    var nt = Date.now();
                    if (isNaN(we.lastSegmentFinishTimeMs)) {
                      if (!isNaN(we.lastCallTimeMs)) {
                        var Tt = 1e-3 * (nt - we.lastCallTimeMs);
                        we.placeholderBuffer += Math.max(0, Tt);
                      }
                    } else {
                      var ft = 1e-3 * (nt - we.lastSegmentFinishTimeMs);
                      we.placeholderBuffer += Math.max(0, ft);
                    }
                    we.lastCallTimeMs = nt, we.lastSegmentStart = NaN, we.lastSegmentRequestTimeMs = NaN, we.lastSegmentFinishTimeMs = NaN, ee(we, Ge);
                  })(v, _t), b = function(we, Ge) {
                    for (var nt = we.bitrates.length, Tt = NaN, ft = NaN, Yt = 0; Yt < nt; ++Yt) {
                      var Ot = (we.Vp * (we.utilities[Yt] + we.gp) - Ge) / we.bitrates[Yt];
                      (isNaN(ft) || Ot >= ft) && (ft = Ot, Tt = Yt);
                    }
                    return Tt;
                  }(v, W + v.placeholderBuffer);
                  var Ze = me.getQualityForBitrate(Rt, Re, Ve, Je);
                  b > v.lastQuality && b > Ze && (b = Math.max(Ze, v.lastQuality));
                  var Fe = Math.max(0, W + v.placeholderBuffer - ue(v, b));
                  Fe <= v.placeholderBuffer ? (v.placeholderBuffer -= Fe, Fe = 0) : (Fe -= v.placeholderBuffer, v.placeholderBuffer = 0, b < me.getMaxAllowedIndexFor(_t, Ve) ? qe.setTimeToLoadDelay(1e3 * Fe) : Fe = 0), ke.quality = b, ke.reason.throughput = Y, ke.reason.latency = Je, ke.reason.bufferLevel = W, ke.reason.placeholderBuffer = v.placeholderBuffer, ke.reason.delay = Fe, v.lastQuality = b;
                  break;
                default:
                  x.debug("BOLA ABR rule invoked in bad state."), ke.quality = me.getQualityForBitrate(Rt, Re, Ve, Je), ke.reason.state = v.state, ke.reason.throughput = Re, ke.reason.latency = Je, v.state = 1, j(v);
              }
              return ke;
            }, reset: function() {
              at(), K.off(E.Z.BUFFER_EMPTY, Q, S), K.off(E.Z.PLAYBACK_SEEKING, Ne, S), K.off(E.Z.METRIC_ADDED, ze, S), K.off(E.Z.QUALITY_CHANGE_REQUESTED, Oe, S), K.off(E.Z.FRAGMENT_LOADING_ABANDONED, We, S), K.off(m.Z.MEDIA_FRAGMENT_LOADED, Ue, S);
            } }, x = (0, o.Z)(L).getInstance().getLogger(S), at(), K.on(E.Z.BUFFER_EMPTY, Q, S), K.on(E.Z.PLAYBACK_SEEKING, Ne, S), K.on(E.Z.METRIC_ADDED, ze, S), K.on(E.Z.QUALITY_CHANGE_REQUESTED, Oe, S), K.on(E.Z.FRAGMENT_LOADING_ABANDONED, We, S), K.on(m.Z.MEDIA_FRAGMENT_LOADED, Ue, S), S;
          }
          c.__dashjs_factory_name = "BolaRule", Ee.Z = t.Z.getClassFactory(c);
        }, 895: function(Pe, Ee, C) {
          var ie = C(5448), T = C(2068), t = C(6398);
          function e() {
            var p, m, o = this.context;
            return p = { getMaxIndex: function(E) {
              var h = (0, T.Z)(o).create();
              if (!E || !E.hasOwnProperty("getDroppedFramesHistory")) return h;
              var n = E.getDroppedFramesHistory(), c = E.getStreamInfo().id;
              if (n) {
                var d = n.getFrameHistory(c);
                if (!d || d.length === 0) return h;
                for (var S = 0, x = 0, B = T.Z.NO_CHANGE, L = 1; L < d.length; L++) if (d[L] && (S = d[L].droppedVideoFrames, (x = d[L].totalVideoFrames) > 375 && S / x > 0.15)) {
                  B = L - 1, m.debug("index: " + B + " Dropped Frames: " + S + " Total Frames: " + x);
                  break;
                }
                return (0, T.Z)(o).create(B, { droppedFrames: S });
              }
              return h;
            } }, m = (0, t.Z)(o).getInstance().getLogger(p), p;
          }
          e.__dashjs_factory_name = "DroppedFramesRule", Ee.Z = ie.Z.getClassFactory(e);
        }, 6535: function(Pe, Ee, C) {
          var ie = C(5595), T = C(8512), t = C(5448), e = C(6398), p = C(2068), m = C(3393), o = C(3860), E = C(8825);
          function h(n) {
            n = n || {};
            var c, d, S, x = this.context, B = (0, ie.Z)(x).getInstance(), L = n.dashMetrics;
            function $() {
              (S = {})[m.Z.VIDEO] = { ignoreCount: 2 }, S[m.Z.AUDIO] = { ignoreCount: 2 };
            }
            function M() {
              $();
            }
            function K(ae) {
              isNaN(ae.startTime) || ae.mediaType !== m.Z.AUDIO && ae.mediaType !== m.Z.VIDEO || S[ae.mediaType].ignoreCount > 0 && S[ae.mediaType].ignoreCount--;
            }
            return c = { getMaxIndex: function(ae) {
              var j = (0, p.Z)(x).create();
              if (!ae || !ae.hasOwnProperty("getMediaType")) return j;
              (function() {
                if (!L || !L.hasOwnProperty("getCurrentBufferLevel") || !L.hasOwnProperty("getCurrentBufferState")) throw new Error(m.Z.MISSING_CONFIG_ERROR);
              })();
              var ee = ae.getMediaType(), ue = L.getCurrentBufferState(ee), Ae = ae.getRepresentationInfo().fragmentDuration, Q = ae.getStreamInfo(), Ne = Q ? Q.id : null, Ue = ae.getScheduleController(), ze = Q && Q.manifestInfo && Q.manifestInfo.isDynamic;
              if (function(_t, qe) {
                return !_t && S[qe].ignoreCount > 0;
              }(Ue.getPlaybackController().getLowLatencyModeEnabled(), ee) || !Ae) return j;
              if (ue && ue.state === o.Z.BUFFER_EMPTY) d.debug("[" + ee + "] Switch to index 0; buffer is empty."), j.quality = 0, j.reason = "InsufficientBufferRule: Buffer is empty";
              else {
                var Te = ae.getMediaInfo(), Oe = ae.getAbrController(), We = Oe.getThroughputHistory(), at = L.getCurrentBufferLevel(ee), Se = We.getAverageThroughput(ee, ze), ke = We.getAverageLatency(ee), Rt = Se * (at / Ae) * 0.5;
                j.quality = Oe.getQualityForBitrate(Te, Rt, Ne, ke), j.reason = "InsufficientBufferRule: being conservative to avoid immediate rebuffering";
              }
              return j;
            }, reset: function() {
              $(), B.off(E.Z.PLAYBACK_SEEKING, M, c), B.off(T.Z.BYTES_APPENDED_END_FRAGMENT, K, c);
            } }, d = (0, e.Z)(x).getInstance().getLogger(c), $(), B.on(E.Z.PLAYBACK_SEEKING, M, c), B.on(T.Z.BYTES_APPENDED_END_FRAGMENT, K, c), c;
          }
          h.__dashjs_factory_name = "InsufficientBufferRule", Ee.Z = t.Z.getClassFactory(h);
        }, 1914: function(Pe, Ee, C) {
          var ie = C(3860), T = C(2068), t = C(5448), e = C(7855), p = C(5595), m = C(8512), o = C(6398), E = C(3393);
          function h(n) {
            n = n || {};
            var c, d, S, x, B = this.context, L = n.dashMetrics, $ = (0, p.Z)(B).getInstance();
            function M(Ne) {
              Ne.placeholderBuffer = 0, Ne.mostAdvancedSegmentStart = NaN, Ne.lastSegmentWasReplacement = !1, Ne.lastSegmentStart = NaN, Ne.lastSegmentDurationS = NaN, Ne.lastSegmentRequestTimeMs = NaN, Ne.lastSegmentFinishTimeMs = NaN, Ne.lastSegmentUrl = "";
            }
            function K() {
              for (var Ne in d) if (d.hasOwnProperty(Ne)) {
                var Ue = d[Ne];
                Ue.state !== 0 && (Ue.state = 1, M(Ue));
              }
            }
            function ae(Ne) {
              if (Ne && Ne.chunk && Ne.chunk.mediaInfo) {
                var Ue = d[Ne.chunk.mediaInfo.type], ze = S[Ne.chunk.mediaInfo.type];
                if (Ue && Ue.state !== 0) {
                  var Te = Ne.chunk.start;
                  isNaN(Ue.mostAdvancedSegmentStart) || Te > Ue.mostAdvancedSegmentStart ? (Ue.mostAdvancedSegmentStart = Te, Ue.lastSegmentWasReplacement = !1) : Ue.lastSegmentWasReplacement = !0, Ue.lastSegmentStart = Te, Ue.lastSegmentDurationS = Ne.chunk.duration, Ue.lastQuality = Ne.chunk.quality, ee(Ue, ze);
                }
              }
            }
            function j(Ne) {
              if (Ne && Ne.metric === ie.Z.HTTP_REQUEST && Ne.value && Ne.value.type === e.w.MEDIA_SEGMENT_TYPE && Ne.value.trace && Ne.value.trace.length) {
                var Ue = d[Ne.mediaType], ze = S[Ne.mediaType];
                Ue && Ue.state !== 0 && (Ue.lastSegmentRequestTimeMs = Ne.value.trequest.getTime(), Ue.lastSegmentFinishTimeMs = Ne.value._tfinish.getTime(), ee(Ue, ze));
              }
            }
            function ee(Ne, Ue) {
              isNaN(Ne.lastSegmentStart) || isNaN(Ne.lastSegmentRequestTimeMs) || (Ue.segment_request_start_s = 1e-3 * Ne.lastSegmentRequestTimeMs, Ue.segment_download_finish_s = 1e-3 * Ne.lastSegmentFinishTimeMs, Ne.lastSegmentStart = NaN, Ne.lastSegmentRequestTimeMs = NaN);
            }
            function ue(Ne) {
              if (Ne && Ne.mediaType) {
                var Ue = d[Ne.mediaType];
                Ue && Ue.state !== 0 && (Ue.abrQuality = Ne.newQuality);
              }
            }
            function Ae(Ne, Ue) {
              if (Ne.length !== Ue.length) return -1;
              for (var ze = 0, Te = 0; Te < Ne.length; Te++) ze += Ne[Te] * Ue[Te];
              return ze;
            }
            function Q() {
              d = {}, S = {};
            }
            return c = { getMaxIndex: function(Ne) {
              var Ue, ze = (0, T.Z)(B).create(), Te = Math.pow(4, 0.99), Oe = Math.max(Math.pow(4, 1), Te * Math.sqrt(4)), We = Ne.getMediaInfo(), at = Ne.getMediaType(), Se = We.bitrateList.map(function(Bt) {
                return Bt.bandwidth;
              }), ke = Se.length, Rt = Ne.getScheduleController(), _t = Ne.getStreamInfo(), qe = Ne.getAbrController(), it = qe.getThroughputHistory(), me = _t && _t.manifestInfo && _t.manifestInfo.isDynamic, ye = Ne.useL2AABR(), Ve = L.getCurrentBufferLevel(at, !0), f = it.getSafeAverageThroughput(at, me), u = it.getAverageThroughput(at, me), v = it.getAverageLatency(at), b = Ne.getVideoModel().getPlaybackRate();
              if (!(Ne && Ne.hasOwnProperty("getMediaInfo") && Ne.hasOwnProperty("getMediaType") && Ne.hasOwnProperty("getScheduleController") && Ne.hasOwnProperty("getStreamInfo") && Ne.hasOwnProperty("getAbrController") && Ne.hasOwnProperty("useL2AABR")) || (ze.reason = ze.reason || {}, !ye || at === E.Z.AUDIO)) return ze;
              Rt.setTimeToLoadDelay(0);
              var W = function(Bt) {
                var cn = Bt.getMediaType(), vn = d[cn];
                return vn || (vn = function(Pn) {
                  var Dn = {}, xn = Pn.getMediaInfo(), er = xn.bitrateList.map(function(In) {
                    return In.bandwidth / 1e3;
                  });
                  return Dn.state = 1, Dn.bitrates = er, Dn.lastQuality = 0, function(In) {
                    In && In.type && (S[In.type] = {}, S[In.type].w = [], S[In.type].prev_w = [], S[In.type].Q = 0, S[In.type].segment_request_start_s = 0, S[In.type].segment_download_finish_s = 0, S[In.type].B_target = 1.5);
                  }(xn), M(Dn), Dn;
                }(Bt), d[cn] = vn), vn;
              }(Ne);
              if (W.state === 0) return ze;
              var Y = S[at];
              if (!Y || (ze.reason.state = W.state, ze.reason.throughput = u, ze.reason.latency = v, isNaN(u))) return ze;
              switch (W.state) {
                case 1:
                  if (Ue = qe.getQualityForBitrate(We, f, _t.id, v), ze.quality = Ue, ze.reason.throughput = f, W.lastQuality = Ue, !isNaN(W.lastSegmentDurationS) && Ve >= Y.B_target) {
                    W.state = 2, Y.Q = Te;
                    for (var Re = 0; Re < ke; ++Re) Re === W.lastQuality ? Y.prev_w[Re] = 1 : Y.prev_w[Re] = 0;
                  }
                  break;
                case 2:
                  var Je = [], Ze = L.getCurrentHttpRequest(at).trace.reduce(function(Bt, cn) {
                    return Bt + cn.d;
                  }, 0), Fe = L.getCurrentHttpRequest(at).trace.reduce(function(Bt, cn) {
                    return Bt + cn.b[0];
                  }, 0), we = Math.round(8 * Fe / Ze), Ge = L.getCurrentHttpRequest(at);
                  if (we < 1 && (we = 1), Ge.url === W.lastSegmentUrl || Ge.type === e.w.INIT_SEGMENT_TYPE) Ue = W.lastQuality;
                  else {
                    for (var nt = W.lastSegmentDurationS, Tt = 1, ft = 0; ft < ke; ++ft) Se[ft] = Se[ft] / 1e3, b * Se[ft] > we && (Tt = -1), Y.w[ft] = Y.prev_w[ft] + Tt * (nt / (2 * Oe)) * ((Y.Q + Te) * (b * Se[ft] / we));
                    Y.w = function(Bt) {
                      for (var cn = Bt.length, vn = !1, Pn = [], Dn = 0; Dn < cn; ++Dn) Pn[Dn] = Bt[Dn];
                      for (var xn = Bt.sort(function(mr, ar) {
                        return ar - mr;
                      }), er = 0, In = 0, cr = [], Yn = 0; Yn < cn - 1; ++Yn) if ((In = ((er += xn[Yn]) - 1) / (Yn + 1)) >= xn[Yn + 1]) {
                        vn = !0;
                        break;
                      }
                      vn || (In = (er + xn[cn - 1] - 1) / cn);
                      for (var ir = 0; ir < cn; ++ir) cr[ir] = Math.max(Pn[ir] - In, 0);
                      return cr;
                    }(Y.w);
                    for (var Yt = 0; Yt < ke; ++Yt) Je[Yt] = Y.w[Yt] - Y.prev_w[Yt], Y.prev_w[Yt] = Y.w[Yt];
                    Y.Q = Math.max(0, Y.Q - nt + nt * b * ((Ae(Se, Y.prev_w) + Ae(Se, Je)) / we));
                    for (var Ot = [], qt = 0; qt < ke; ++qt) Ot[qt] = Math.abs(Se[qt] - Ae(Y.w, Se));
                    (Ue = Ot.indexOf(Math.min.apply(Math, Ot))) > W.lastQuality && Se[W.lastQuality + 1] <= we && (Ue = W.lastQuality + 1), Se[Ue] >= we && (Y.Q = 2 * Math.max(Te, Y.Q)), W.lastSegmentUrl = Ge.url;
                  }
                  ze.quality = Ue, ze.reason.throughput = u, ze.reason.latency = v, ze.reason.bufferLevel = Ve, W.lastQuality = ze.quality;
                  break;
                default:
                  x.debug("L2A ABR rule invoked in bad state."), ze.quality = qe.getQualityForBitrate(We, f, _t.id, v), ze.reason.state = W.state, ze.reason.throughput = f, ze.reason.latency = v, W.state = 1, M(W);
              }
              return ze;
            }, reset: function() {
              Q(), $.off(m.Z.PLAYBACK_SEEKING, K, c), $.off(m.Z.MEDIA_FRAGMENT_LOADED, ae, c), $.off(m.Z.METRIC_ADDED, j, c), $.off(m.Z.QUALITY_CHANGE_REQUESTED, ue, c);
            } }, x = (0, o.Z)(B).getInstance().getLogger(c), Q(), $.on(m.Z.PLAYBACK_SEEKING, K, c), $.on(m.Z.MEDIA_FRAGMENT_LOADED, ae, c), $.on(m.Z.METRIC_ADDED, j, c), $.on(m.Z.QUALITY_CHANGE_REQUESTED, ue, c), c;
          }
          h.__dashjs_factory_name = "L2ARule", Ee.Z = t.Z.getClassFactory(h);
        }, 6070: function(Pe, Ee, C) {
          var ie = C(5448), T = C(6398), t = C(2068);
          function e() {
            var p, m, o = this.context;
            return p = { getMaxIndex: function(E) {
              for (var h = E ? E.getSwitchHistory() : null, n = h ? h.getSwitchRequests() : [], c = 0, d = 0, S = 0, x = (0, t.Z)(o).create(), B = 0; B < n.length; B++) if (n[B] !== void 0 && (c += n[B].drops, d += n[B].noDrops, S += n[B].dropSize, c + d >= 6 && c / d > 0.075)) {
                x.quality = B > 0 && n[B].drops > 0 ? B - 1 : B, x.reason = { index: x.quality, drops: c, noDrops: d, dropSize: S }, m.debug("Switch history rule index: " + x.quality + " samples: " + (c + d) + " drops: " + c);
                break;
              }
              return x;
            } }, m = (0, T.Z)(o).getInstance().getLogger(p), p;
          }
          e.__dashjs_factory_name = "SwitchHistoryRule", Ee.Z = ie.Z.getClassFactory(e);
        }, 5628: function(Pe, Ee, C) {
          var ie = C(5448), T = C(2068), t = C(3393), e = C(3860);
          function p(m) {
            m = m || {};
            var o = this.context, E = m.dashMetrics;
            return { getMaxIndex: function(h) {
              var n = (0, T.Z)(o).create();
              if (!(h && h.hasOwnProperty("getMediaInfo") && h.hasOwnProperty("getMediaType") && h.hasOwnProperty("useBufferOccupancyABR") && h.hasOwnProperty("getAbrController") && h.hasOwnProperty("getScheduleController"))) return n;
              (function() {
                if (!E || !E.hasOwnProperty("getCurrentBufferState")) throw new Error(t.Z.MISSING_CONFIG_ERROR);
              })();
              var c = h.getMediaInfo(), d = h.getMediaType(), S = E.getCurrentBufferState(d), x = h.getScheduleController(), B = h.getAbrController(), L = h.getStreamInfo(), $ = L ? L.id : null, M = L && L.manifestInfo ? L.manifestInfo.isDynamic : null, K = B.getThroughputHistory(), ae = K.getSafeAverageThroughput(d, M), j = K.getAverageLatency(d), ee = h.useBufferOccupancyABR();
              return isNaN(ae) || !S || ee || B.getAbandonmentStateFor($, d) !== e.Z.ABANDON_LOAD && (S.state === e.Z.BUFFER_LOADED || M) && (n.quality = B.getQualityForBitrate(c, ae, $, j), x.setTimeToLoadDelay(0), n.reason = { throughput: ae, latency: j }), n;
            }, reset: function() {
            } };
          }
          p.__dashjs_factory_name = "ThroughputRule", Ee.Z = ie.Z.getClassFactory(p);
        }, 4722: function(Pe, Ee, C) {
          var ie = C(5448), T = C(6398);
          function t() {
            var e, p, m, o, E, h, n, c, d, S = this.context;
            function x() {
              m = null, o = 1, E = 100, h = 0, n = null, c = null, d = "dynamic_weight_selection";
            }
            function B() {
              var ae = 0;
              if (m) for (var j = 0; j < m.length; j++) {
                var ee = m[j];
                ee.state.throughput > ae && (ae = ee.state.throughput);
              }
              return ae;
            }
            function L(ae, j, ee) {
              var ue = ae.map(function(Ae, Q) {
                return ee[Q] * Math.pow(Ae - j[Q], 2);
              }).reduce(function(Ae, Q) {
                return Ae + Q;
              });
              return (ue < 0 ? -1 : 1) * Math.sqrt(Math.abs(ue));
            }
            function $(ae, j) {
              return L([ae.state.throughput, ae.state.latency, ae.state.rebuffer, ae.state.switch], [j.state.throughput, j.state.latency, j.state.rebuffer, j.state.switch], [1, 1, 1, 1]);
            }
            function M(ae, j, ee) {
              for (var ue = 0; ue < j.length; ue++) {
                var Ae = j[ue], Q = $(Ae, ae);
                K(Ae, ee, Math.exp(-1 * Math.pow(Q, 2) / (2 * Math.pow(0.1, 2))));
              }
            }
            function K(ae, j, ee) {
              var ue = ae.state, Ae = [0.01, 0.01, 0.01, 0.01];
              ue.throughput = ue.throughput + (j[0] - ue.throughput) * Ae[0] * ee, ue.latency = ue.latency + (j[1] - ue.latency) * Ae[1] * ee, ue.rebuffer = ue.rebuffer + (j[2] - ue.rebuffer) * Ae[2] * ee, ue.switch = ue.switch + (j[3] - ue.switch) * Ae[3] * ee;
            }
            return e = { getNextQuality: function(ae, j, ee, ue, Ae, Q, Ne) {
              var Ue = ee, ze = ue, Te = j, Oe = function(Y) {
                if (!m) {
                  m = [];
                  var Re = Y.bitrateList, Je = [];
                  h = Re[0].bandwidth, Re.forEach(function(Ge) {
                    Je.push(Ge.bandwidth), Ge.bandwidth < h && (h = Ge.bandwidth);
                  }), we = Je.map(function(Ge) {
                    return Math.pow(Ge, 2);
                  }).reduce(function(Ge, nt) {
                    return Ge + nt;
                  }), o = Math.sqrt(we);
                  for (var Ze = 0; Ze < Re.length; Ze++) {
                    var Fe = { qualityIndex: Ze, bitrate: Re[Ze].bandwidth, state: { throughput: Re[Ze].bandwidth / o, latency: 0, rebuffer: 0, switch: 0 } };
                    m.push(Fe);
                  }
                  c = function(Ge) {
                    var nt = [], Tt = function(ei) {
                      for (var Nt = [], At = 0; At < ei; At++) {
                        var wt = [Math.random() * B(), Math.random(), Math.random(), Math.random()];
                        Nt.push(wt);
                      }
                      return Nt;
                    }(Math.pow(Ge.length, 2));
                    nt.push(Tt[0]);
                    for (var ft = [1, 1, 1, 1], Yt = 1; Yt < Ge.length; Yt++) {
                      for (var Ot = null, qt = null, Bt = 0; Bt < Tt.length; Bt++) {
                        for (var cn = Tt[Bt], vn = null, Pn = 0; Pn < nt.length; Pn++) {
                          var Dn = L(cn, nt[Pn], ft);
                          (vn === null || Dn < vn) && (vn = Dn);
                        }
                        (qt === null || vn > qt) && (Ot = cn, qt = vn);
                      }
                      nt.push(Ot);
                    }
                    for (var xn = null, er = null, In = 0; In < nt.length; In++) {
                      for (var cr = 0, Yn = 0; Yn < nt.length; Yn++) In !== Yn && (cr += L(nt[In], nt[Yn], ft));
                      (xn === null || cr > xn) && (xn = cr, er = In);
                    }
                    var ir = [];
                    for (ir.push(nt[er]), nt.splice(er, 1); nt.length > 0; ) {
                      for (var mr = null, ar = null, Er = 0; Er < nt.length; Er++) {
                        var vr = L(ir[0], nt[Er], ft);
                        (mr === null || vr < mr) && (mr = vr, ar = Er);
                      }
                      ir.push(nt[ar]), nt.splice(ar, 1);
                    }
                    return ir;
                  }(m);
                }
                var we;
                return m;
              }(ae), We = j / o;
              We > 1 && (We = B()), ee /= E, p.debug("getNextQuality called throughput:".concat(We, " latency:").concat(ee, " bufferSize:").concat(ue, " currentQualityIndex:").concat(Q, " playbackRate:").concat(Ae));
              var at = Oe[Q], Se = at.bitrate * Ne.getSegmentDuration() / Te, ke = Math.max(0, Se - ze);
              if (ze - Se < Ne.getMinBuffer()) return p.debug("Buffer is low for bitrate= ".concat(at.bitrate, " downloadTime=").concat(Se, " currentBuffer=").concat(ze, " rebuffer=").concat(ke)), function(Y, Re) {
                var Je = 0, Ze = Y;
                if (m) for (var Fe = 0; Fe < m.length; Fe++) {
                  var we = m[Fe];
                  we.bitrate < Y.bitrate && we.bitrate > Je && Re > we.bitrate && (Je = we.bitrate, Ze = we);
                }
                return Ze;
              }(at, Te).qualityIndex;
              switch (d) {
                case "manual_weight_selection":
                  n = [0.4, 0.4, 0.4, 0.4];
                  break;
                case "random_weight_selection":
                  (function(Y) {
                    n = function(Re, Je) {
                      for (var Ze = [], Fe = Math.sqrt(2 / Re), we = 0; we < 4; we++) Ze.push(Math.random() * Fe);
                      return n = Ze;
                    }(Y.length);
                  })(Oe);
                  break;
                default:
                  (function(Y, Re, Je, Ze, Fe, we, Ge) {
                    n || (n = c[c.length - 1]);
                    var nt = Y.findWeightVector(Re, Je, Ze, Fe, we, Ge);
                    nt !== null && nt !== -1 && (n = nt);
                  })(Ne, Oe, Ue, ze, ke, Te, Ae);
              }
              for (var Rt = null, _t = null, qe = null, it = 0; it < Oe.length; it++) {
                var me = Oe[it], ye = me.state, Ve = [ye.throughput, ye.latency, ye.rebuffer, ye.switch], f = n.slice(), u = Ne.getNextBufferWithBitrate(me.bitrate, ze, Te), v = u < Ne.getMinBuffer();
                v && p.debug("Buffer is low for bitrate=".concat(me.bitrate, " downloadTime=").concat(Se, " currentBuffer=").concat(ze, " nextBuffer=").concat(u)), (me.bitrate > j - 1e4 || v) && me.bitrate !== h && (f[0] = 100);
                var b = L(Ve, [We, 0, 0, 0], f);
                (Rt === null || b < Rt) && (Rt = b, _t = me.qualityIndex, qe = me);
              }
              var W = Math.abs(at.bitrate - qe.bitrate) / o;
              return M(at, Oe, [We, ee, ke, W]), M(qe, Oe, [We, 0, 0, W]), _t;
            }, reset: function() {
              x();
            } }, p = (0, T.Z)(S).getInstance().getLogger(e), x(), e;
          }
          t.__dashjs_factory_name = "LearningAbrController", Ee.Z = ie.Z.getClassFactory(t);
        }, 5317: function(Pe, Ee, C) {
          var ie = C(5448), T = C(2298);
          function t() {
            var e, p, m, o, E;
            function h() {
              p = null, m = null, o = null, E = null;
            }
            function n(d, S, x, B) {
              var L = new T.Z();
              return L.type = d, L.weights.bitrateReward = S || 1, L.weights.bitrateSwitchPenalty = 1, L.weights.rebufferPenalty = x || 1e3, L.weights.latencyPenalty = [], L.weights.latencyPenalty.push({ threshold: 1.1, penalty: 0.05 * B }), L.weights.latencyPenalty.push({ threshold: 1e8, penalty: 0.1 * x }), L.weights.playbackSpeedPenalty = B || 200, L;
            }
            function c(d, S, x, B, L) {
              L.bitrateWSum += L.weights.bitrateReward * d, L.lastBitrate && (L.bitrateSwitchWSum += L.weights.bitrateSwitchPenalty * Math.abs(d - L.lastBitrate)), L.lastBitrate = d, L.rebufferWSum += L.weights.rebufferPenalty * S;
              for (var $ = 0; $ < L.weights.latencyPenalty.length; $++) {
                var M = L.weights.latencyPenalty[$];
                if (x <= M.threshold) {
                  L.latencyWSum += M.penalty * x;
                  break;
                }
              }
              L.playbackSpeedWSum += L.weights.playbackSpeedPenalty * Math.abs(1 - B), L.totalQoe = L.bitrateWSum - L.bitrateSwitchWSum - L.rebufferWSum - L.latencyWSum - L.playbackSpeedWSum;
            }
            return e = { setupPerSegmentQoe: function(d, S, x) {
              p = n("segment", d, S, x), m = d, o = S, E = x;
            }, logSegmentMetrics: function(d, S, x, B) {
              p && c(d, S, x, B, p);
            }, getPerSegmentQoe: function() {
              return p;
            }, calculateSingleUseQoe: function(d, S, x, B) {
              var L = null;
              return m && o && E && (L = n("segment", m, o, E)), L ? (c(d, S, x, B, L), L.totalQoe) : 0;
            }, reset: function() {
              h();
            } }, h(), e;
          }
          t.__dashjs_factory_name = "LoLpQoeEvaluator", Ee.Z = ie.Z.getClassFactory(t);
        }, 5435: function(Pe, Ee, C) {
          var ie = C(6398), T = C(5448), t = C(4722), e = C(5317), p = C(2068), m = C(3860), o = C(6523), E = C(3393);
          function h(n) {
            var c, d, S, x, B = (n = n || {}).dashMetrics, L = this.context;
            return d = { getMaxIndex: function($) {
              try {
                var M = (0, p.Z)(L).create(), K = $.getMediaInfo().type, ae = $.getAbrController(), j = $.getStreamInfo(), ee = ae.getQualityFor(K, j.id), ue = $.getMediaInfo(), Ae = B.getCurrentBufferState(K), Q = $.getScheduleController(), Ne = B.getCurrentBufferLevel(K, !0), Ue = j && j.manifestInfo ? j.manifestInfo.isDynamic : null, ze = Q.getPlaybackController(), Te = ze.getCurrentLiveLatency();
                if (!$.useLoLPABR() || K === E.Z.AUDIO) return M;
                Te || (Te = 0);
                var Oe = ze.getPlaybackRate(), We = ae.getThroughputHistory().getSafeAverageThroughput(K, Ue);
                if (c.debug("Throughput ".concat(Math.round(We), " kbps")), isNaN(We) || !Ae || ae.getAbandonmentStateFor(j.id, K) === m.Z.ABANDON_LOAD) return M;
                for (var at = ue.bitrateList, Se = $.getRepresentationInfo().fragmentDuration, ke = at[0].bandwidth / 1e3, Rt = at[at.length - 1].bandwidth / 1e3, _t = 0; _t < at.length; _t++) {
                  var qe = at[_t].bandwidth / 1e3;
                  qe > Rt ? Rt = qe : qe < ke && (ke = qe);
                }
                var it = at[ee].bandwidth / 1e3, me = B.getCurrentHttpRequest(K, !0), ye = (me.tresponse.getTime() - me.trequest.getTime()) / 1e3, Ve = ye > Se ? ye - Se : 0;
                x.setupPerSegmentQoe(Se, Rt, ke), x.logSegmentMetrics(it, Ve, Te, Oe);
                var f = (0, o.Z)(L).create({ targetLatency: 1.5, bufferMin: 0.3, segmentDuration: Se, qoeEvaluator: x });
                return M.quality = S.getNextQuality(ue, 1e3 * We, Te, Ne, Oe, ee, f), M.reason = { throughput: We, latency: Te }, M.priority = p.Z.PRIORITY.STRONG, Q.setTimeToLoadDelay(0), M.quality !== ee && c.debug("[TgcLearningRule][" + K + "] requesting switch to index: ", M.quality, "Average throughput", Math.round(We), "kbps"), M;
              } catch (u) {
                throw u;
              }
            }, reset: function() {
              S.reset(), x.reset();
            } }, c = (0, ie.Z)(L).getInstance().getLogger(d), S = (0, t.Z)(L).create(), x = (0, e.Z)(L).create(), d;
          }
          h.__dashjs_factory_name = "LoLPRule", Ee.Z = T.Z.getClassFactory(h);
        }, 6523: function(Pe, Ee, C) {
          var ie = C(5448);
          function T(t) {
            var e, p, m, o, E = t.targetLatency, h = t.bufferMin, n = t.segmentDuration, c = t.qoeEvaluator;
            function d() {
              return n;
            }
            function S(x, B) {
              var L = d();
              return B > L ? x - L : x + L - B;
            }
            return e = { getMinBuffer: function() {
              return h;
            }, getSegmentDuration: d, getNextBufferWithBitrate: function(x, B, L) {
              return S(B, x * n / L);
            }, getNextBuffer: S, findWeightVector: function(x, B, L, $, M, K) {
              var ae = null, j = null, ee = null, ue = Math.abs(B - m);
              return x.forEach(function(Ae) {
                p.forEach(function(Q) {
                  Q[0];
                  var Ne = Q[1], Ue = Q[2], ze = (Q[3], Ae.bitrate * n / M), Te = S(L, ze), Oe = (Ue === 0 ? 10 : 1 / Ue) * Math.max(1e-5, ze - Te), We = (Ne === 0 ? 10 : 1 / Ne) * Ae.state.latency, at = c.calculateSingleUseQoe(Ae.bitrate, Oe, We, K);
                  (ae === null || at > ae) && function(Se, ke, Rt) {
                    return !(Se > E + Rt) && ke >= h;
                  }(B, Te, ue) && (ae = at, j = Q, ee = Ae.bitrate);
                });
              }), j === null && ee === null && (j = -1), m = B, j;
            } }, p = function x(B, L, $) {
              if ($ === L) return B;
              for (var M = B.length, K = 0; K < M; K++) for (var ae = B.shift(), j = 0; j < o.length; j++) B.push(ae.concat(o[j]));
              return x(B, L, $ + 1);
            }((o = [0.2, 0.4, 0.6, 0.8, 1]).map(function(x) {
              return [x];
            }), 4, 1), m = 0, e;
          }
          T.__dashjs_factory_name = "LoLpWeightSelector", Ee.Z = ie.Z.getClassFactory(T);
        }, 2298: function(Pe, Ee) {
          Ee.Z = function C() {
            (function(ie, T) {
              if (!(ie instanceof T)) throw new TypeError("Cannot call a class as a function");
            })(this, C), this.type = null, this.lastBitrate = null, this.weights = {}, this.weights.bitrateReward = null, this.weights.bitrateSwitchPenalty = null, this.weights.rebufferPenalty = null, this.weights.latencyPenalty = null, this.weights.playbackSpeedPenalty = null, this.bitrateWSum = 0, this.bitrateSwitchWSum = 0, this.rebufferWSum = 0, this.latencyWSum = 0, this.playbackSpeedWSum = 0, this.totalQoe = 0;
          };
        }, 7803: function(Pe, Ee, C) {
          C.d(Ee, { Y: function() {
            return c;
          } });
          var ie = C(3393), T = C(1553), t = C(5448), e = C(2128), p = C(2594), m = C(7387), o = C(7417), E = C(9032), h = C(9326), n = C(7802), c = ["http://dashif.org/thumbnail_tile", "http://dashif.org/guidelines/thumbnail_tile"];
          function d(S) {
            var x, B, L, $, M, K, ae, j, ee = this.context, ue = S.adapter, Ae = S.baseURLController, Q = S.streamInfo, Ne = S.timelineConverter, Ue = S.debug, ze = S.eventBus, Te = S.events, Oe = S.dashConstants, We = (0, p.Z)(ee).getInstance();
            function at(ke, Rt) {
              var _t = new e.Z();
              _t.id = ke.id, _t.bitrate = ke.bandwidth, _t.width = ke.width, _t.height = ke.height, _t.tilesHor = 1, _t.tilesVert = 1, ke.essentialProperties && ke.essentialProperties.forEach(function(qe) {
                if (c.indexOf(qe.schemeIdUri) >= 0 && qe.value) {
                  var it = qe.value.split("x");
                  it.length !== 2 || isNaN(it[0]) || isNaN(it[1]) || (_t.tilesHor = parseInt(it[0], 10), _t.tilesVert = parseInt(it[1], 10));
                }
              }), Rt ? K.updateSegmentData(ke).then(function(qe) {
                (function(it, me, ye) {
                  var Ve = [], f = function(u, v) {
                    var b, W, Y, Re, Je = [], Ze = 0;
                    for (b = 0, W = u.segments.length; b < W; b++) Y = u.segments[b], (Re = (0, m.TJ)(Ne, ue.getIsDynamic(), v, Y.startTime, Y.duration, Y.timescale, Y.media, Y.mediaRange, Ze)) && (Je.push(Re), Re = null, Ze++);
                    return Je;
                  }(ye, me);
                  me.segments = f, it.segmentDuration = me.segments[0].duration, it.readThumbnail = function(u, v) {
                    var b = null;
                    Ve.some(function(W) {
                      if (W.start <= u && W.end > u) return b = W.url, !0;
                    }), b ? v(b) : me.segments.some(function(W) {
                      if (W.mediaStartTime <= u && W.mediaStartTime + W.duration > u) {
                        var Y = Ae.resolve(me.path);
                        return ae.load({ method: "get", url: Y.url, request: { range: W.mediaRange, responseType: "arraybuffer" }, onload: function(Re) {
                          var Je = j.getSamplesInfo(Re.target.response), Ze = new Blob([Re.target.response.slice(Je.sampleList[0].offset, Je.sampleList[0].offset + Je.sampleList[0].size)], { type: "image/jpeg" }), Fe = window.URL.createObjectURL(Ze);
                          Ve.push({ start: W.mediaStartTime, end: W.mediaStartTime + W.duration, url: Fe }), v && v(Fe);
                        } }), !0;
                      }
                    });
                  };
                })(_t, ke, qe);
              }) : (_t.startNumber = ke.startNumber, _t.segmentDuration = ke.segmentDuration, _t.timescale = ke.timescale, _t.templateUrl = function(qe) {
                var it = We.isRelative(qe.media) ? We.resolve(qe.media, Ae.resolve(qe.path).url) : qe.media;
                return it ? (0, m.Aj)(it, qe.id) : "";
              }(ke)), _t.tilesHor > 0 && _t.tilesVert > 0 && (_t.widthPerTile = _t.width / _t.tilesHor, _t.heightPerTile = _t.height / _t.tilesVert, B.push(_t));
            }
            function Se() {
              B = [], $ = -1, M = null;
            }
            return x = { getTracks: function() {
              return B;
            }, addTracks: function() {
              if (Q && ue && (M = ue.getMediaInfoForType(Q, ie.Z.IMAGE))) {
                var ke = ue.getVoRepresentations(M);
                ke && ke.length > 0 && ke.forEach(function(Rt) {
                  (Rt.segmentInfoType === T.Z.SEGMENT_TEMPLATE && Rt.segmentDuration > 0 && Rt.media || Rt.segmentInfoType === T.Z.SEGMENT_TIMELINE) && at(Rt), Rt.segmentInfoType === T.Z.SEGMENT_BASE && at(Rt, !0);
                }), B.length > 0 && B.sort(function(Rt, _t) {
                  return Rt.bitrate - _t.bitrate;
                });
              }
            }, reset: Se, setTrackByIndex: function(ke) {
              B && B.length !== 0 && (ke >= B.length && (ke = B.length - 1), $ = ke);
            }, getCurrentTrack: function() {
              return $ < 0 ? null : B[$];
            }, getCurrentTrackIndex: function() {
              return $;
            }, getThumbnailRequestForTime: function(ke) {
              for (var Rt, _t = ue.getVoRepresentations(M), qe = 0; qe < _t.length; qe++) if (B[$].id === _t[qe].id) {
                Rt = _t[qe];
                break;
              }
              return L.getSegmentRequestForTime(M, Rt, ke);
            } }, Se(), ae = (0, E.Z)(ee).create({}), j = (0, o.Z)(ee).getInstance(), K = (0, n.Z)(ee).create({ events: Te, eventBus: ze, streamInfo: Q, timelineConverter: Ne, dashConstants: Oe, dashMetrics: S.dashMetrics, segmentBaseController: S.segmentBaseController, type: ie.Z.IMAGE }), (L = (0, h.Z)(ee).create({ streamInfo: Q, type: ie.Z.IMAGE, timelineConverter: Ne, segmentsController: K, baseURLController: Ae, debug: Ue, eventBus: ze, events: Te, dashConstants: Oe, urlUtils: We })).initialize(!!ue && ue.getIsDynamic()), x;
          }
          d.__dashjs_factory_name = "ThumbnailTracks", Ee.Z = t.Z.getClassFactory(d);
        }, 7417: function(Pe, Ee, C) {
          var ie = C(6398), T = C(8260), t = C(5448), e = C(6934), p = C(9597);
          function m() {
            var o, E, h = this.context;
            function n(S) {
              if (!S) return null;
              S.fileStart === void 0 && (S.fileStart = 0);
              var x = e.parseBuffer(S), B = (0, T.Z)(h).create();
              return B.setData(x), B;
            }
            function c(S, x) {
              return S[x + 3] >>> 0 | S[x + 2] << 8 >>> 0 | S[x + 1] << 16 >>> 0 | S[x] << 24 >>> 0;
            }
            function d(S, x) {
              return String.fromCharCode(S[x++]) + String.fromCharCode(S[x++]) + String.fromCharCode(S[x++]) + String.fromCharCode(S[x]);
            }
            return E = { parse: n, findLastTopIsoBoxCompleted: function(S, x, B) {
              if (B === void 0 && (B = 0), !x || B + 8 >= x.byteLength) return new p.Z(0, !1);
              for (var L, $ = x instanceof ArrayBuffer ? new Uint8Array(x) : x, M = 0; B < $.byteLength; ) {
                var K = c($, B), ae = d($, B + 4);
                if (K === 0) break;
                B + K <= $.byteLength && (S.indexOf(ae) >= 0 ? L = new p.Z(B, !0, K) : M = B + K), B += K;
              }
              return L || new p.Z(M, !1);
            }, getMediaTimescaleFromMoov: function(S) {
              var x = n(S), B = x ? x.getBox("mdhd") : void 0;
              return B ? B.timescale : NaN;
            }, getSamplesInfo: function(S) {
              if (!S || S.byteLength === 0) return { sampleList: [], lastSequenceNumber: NaN, totalDuration: NaN, numSequences: NaN };
              var x, B, L, $, M, K, ae, j, ee, ue, Ae, Q, Ne, Ue, ze, Te, Oe = n(S), We = Oe.getBoxes("moof"), at = Oe.getBoxes("mfhd");
              ze = Oe.getBoxes("moof").length, Ue = at[at.length - 1].sequence_number, B = 0, M = [];
              var Se = -1, ke = -1;
              for (ue = 0; ue < We.length; ue++) {
                var Rt = We[ue], _t = Rt.getChildBoxes("traf");
                for (j = 0; j < _t.length; j++) {
                  var qe = _t[j], it = qe.getChildBox("tfhd"), me = qe.getChildBox("tfdt");
                  $ = me.baseMediaDecodeTime;
                  var ye = qe.getChildBoxes("trun"), Ve = qe.getChildBoxes("subs");
                  for (ee = 0; ee < ye.length; ee++) {
                    var f = ye[ee];
                    for (B = f.sample_count, Ne = (it.base_data_offset || 0) + (f.data_offset || 0), ae = 0; ae < B; ae++) {
                      x = (K = f.samples[ae]).sample_duration !== void 0 ? K.sample_duration : it.default_sample_duration, L = K.sample_size !== void 0 ? K.sample_size : it.default_sample_size;
                      var u = { dts: $, cts: $ + (K.sample_composition_time_offset !== void 0 ? K.sample_composition_time_offset : 0), duration: x, offset: Rt.offset + Ne, size: L, subSizes: [L] };
                      if (Ve) for (Ae = 0; Ae < Ve.length; Ae++) {
                        var v = Ve[Ae];
                        if (Se < v.entry_count - 1 && ae > ke && (Se++, ke += v.entries[Se].sample_delta), ae == ke) {
                          u.subSizes = [];
                          var b = v.entries[Se];
                          for (Q = 0; Q < b.subsample_count; Q++) u.subSizes.push(b.subsamples[Q].subsample_size);
                        }
                      }
                      M.push(u), Ne += L, $ += x;
                    }
                  }
                  Te = $ - me.baseMediaDecodeTime;
                }
              }
              return { sampleList: M, lastSequenceNumber: Ue, totalDuration: Te, numSequences: ze };
            }, findInitRange: function(S) {
              var x = null, B = n(S);
              if (!B) return x;
              var L = B.getBox("ftyp"), $ = B.getBox("moov");
              return o.debug("Searching for initialization."), $ && $.isComplete && (x = (L ? L.offset : $.offset) + "-" + ($.offset + $.size - 1), o.debug("Found the initialization.  Range: " + x)), x;
            }, parsePayload: function(S, x, B) {
              if (B === void 0 && (B = 0), !x || B + 8 >= x.byteLength) return new p.Z(0, !1);
              for (var L, $ = x instanceof ArrayBuffer ? new Uint8Array(x) : x, M = 0; B < $.byteLength; ) {
                var K = c($, B), ae = d($, B + 4);
                if (K === 0) break;
                B + K <= $.byteLength && (S.indexOf(ae) >= 0 ? L = new p.Z(B, !0, K, ae) : M = B + K), B += K;
              }
              return L || new p.Z(M, !1);
            } }, o = (0, ie.Z)(h).getInstance().getLogger(E), E;
          }
          m.__dashjs_factory_name = "BoxParser", Ee.Z = t.Z.getSingletonFactory(m);
        }, 1715: function(Pe, Ee, C) {
          C.d(Ee, { B: function() {
            return p;
          } });
          var ie = C(5448), T = C(7803), t = C(3393), e = [{ codec: "avc1", compatibleCodecs: ["avc3"] }, { codec: "avc3", compatibleCodecs: ["avc1"] }];
          function p() {
            var o = "ManagedMediaSource" in window, E = "WebKitMediaSource" in window, h = "MediaSource" in window;
            return o || E || h;
          }
          function m() {
            var o, E, h;
            return o = { setConfig: function(n) {
              n && n.settings && (E = n.settings);
            }, supportsMediaSource: p, supportsEncryptedMedia: function() {
              return h;
            }, supportsCodec: function(n, c) {
              return c !== t.Z.AUDIO && c !== t.Z.VIDEO ? Promise.resolve(!0) : function(d, S) {
                return E.get().streaming.capabilities.useMediaCapabilitiesApi && navigator.mediaCapabilities && navigator.mediaCapabilities.decodingInfo && (d.codec && S === t.Z.AUDIO || S === t.Z.VIDEO && d.codec && d.width && d.height && d.bitrate && d.framerate);
              }(n, c) ? function(d, S) {
                return new Promise(function(x) {
                  if (d && d.codec) {
                    var B = { type: "media-source" };
                    B[S] = {}, B[S].contentType = d.codec, B[S].width = d.width, B[S].height = d.height, B[S].bitrate = parseInt(d.bitrate), B[S].framerate = parseFloat(d.framerate), navigator.mediaCapabilities.decodingInfo(B).then(function(L) {
                      x(L.supported);
                    }).catch(function() {
                      x(!1);
                    });
                  } else x(!1);
                });
              }(n, c) : function(d) {
                return new Promise(function(S) {
                  if (d && d.codec) {
                    var x = d.codec;
                    d.width && d.height && (x += ';width="' + d.width + '";height="' + d.height + '"'), "ManagedMediaSource" in window && ManagedMediaSource.isTypeSupported(x) || "MediaSource" in window && MediaSource.isTypeSupported(x) || "WebKitMediaSource" in window && WebKitMediaSource.isTypeSupported(x) ? S(!0) : S(!1);
                  } else S(!1);
                });
              }(n);
            }, setEncryptedMediaSupported: function(n) {
              h = n;
            }, supportsEssentialProperty: function(n) {
              try {
                return T.Y.indexOf(n.schemeIdUri) !== -1 || t.Z.FONT_DOWNLOAD_DVB_SCHEME === n.schemeIdUri;
              } catch {
                return !0;
              }
            }, codecRootCompatibleWithCodec: function(n, c) {
              for (var d, S = n.split(".")[0], x = c.indexOf(S) === 0, B = 0; B < e.length; B++) if (e[B].codec === S) {
                d = e[B];
                break;
              }
              return d ? x || d.compatibleCodecs.some(function(L) {
                return c.indexOf(L) === 0;
              }) : x;
            } }, h = !1, o;
          }
          m.__dashjs_factory_name = "Capabilities", Ee.Z = ie.Z.getSingletonFactory(m);
        }, 2295: function(Pe, Ee, C) {
          var ie = C(5448), T = C(3106);
          function t() {
            return { customTimeRangeArray: [], length: 0, add: function(e, p) {
              var m;
              for (m = 0; m < this.customTimeRangeArray.length && e > this.customTimeRangeArray[m].start; m++) ;
              for (this.customTimeRangeArray.splice(m, 0, { start: e, end: p }), m = 0; m < this.customTimeRangeArray.length - 1; m++) this.mergeRanges(m, m + 1) && m--;
              this.length = this.customTimeRangeArray.length;
            }, clear: function() {
              this.customTimeRangeArray = [], this.length = 0;
            }, remove: function(e, p) {
              for (var m = 0; m < this.customTimeRangeArray.length; m++) if (e <= this.customTimeRangeArray[m].start && p >= this.customTimeRangeArray[m].end) this.customTimeRangeArray.splice(m, 1), m--;
              else {
                if (e > this.customTimeRangeArray[m].start && p < this.customTimeRangeArray[m].end) {
                  this.customTimeRangeArray.splice(m + 1, 0, { start: p, end: this.customTimeRangeArray[m].end }), this.customTimeRangeArray[m].end = e;
                  break;
                }
                e > this.customTimeRangeArray[m].start && e < this.customTimeRangeArray[m].end ? this.customTimeRangeArray[m].end = e : p > this.customTimeRangeArray[m].start && p < this.customTimeRangeArray[m].end && (this.customTimeRangeArray[m].start = p);
              }
              this.length = this.customTimeRangeArray.length;
            }, mergeRanges: function(e, p) {
              var m = this.customTimeRangeArray[e], o = this.customTimeRangeArray[p];
              return m.start <= o.start && o.start <= m.end && m.end <= o.end ? (m.end = o.end, this.customTimeRangeArray.splice(p, 1), !0) : o.start <= m.start && m.start <= o.end && o.end <= m.end ? (m.start = o.start, this.customTimeRangeArray.splice(p, 1), !0) : o.start <= m.start && m.start <= o.end && m.end <= o.end ? (this.customTimeRangeArray.splice(e, 1), !0) : m.start <= o.start && o.start <= m.end && o.end <= m.end && (this.customTimeRangeArray.splice(p, 1), !0);
            }, start: function(e) {
              return (0, T.SE)(e), e >= this.customTimeRangeArray.length || e < 0 ? NaN : this.customTimeRangeArray[e].start;
            }, end: function(e) {
              return (0, T.SE)(e), e >= this.customTimeRangeArray.length || e < 0 ? NaN : this.customTimeRangeArray[e].end;
            } };
          }
          t.__dashjs_factory_name = "CustomTimeRanges", Ee.Z = ie.Z.getClassFactory(t);
        }, 5: function(Pe, Ee, C) {
          var ie = C(5448);
          function T() {
            var t, e = /^[a-z][a-z0-9+\-_.]*:/i, p = /^https?:\/\//i, m = /^https:\/\//i, o = /^([a-z][a-z0-9+\-_.]*:\/\/[^\/]+)\/?/i, E = function(L, $) {
              try {
                return new window.URL(L, $).toString();
              } catch {
                return L;
              }
            }, h = function(L, $) {
              var M = n;
              if (!$ || !S(L)) return L;
              x(L) && (M = c), B(L) && (M = d);
              var K = M($), ae = K.charAt(K.length - 1) !== "/" && L.charAt(0) !== "/" ? "/" : "";
              return [K, L].join(ae);
            };
            function n(L) {
              var $ = L.indexOf("/"), M = L.lastIndexOf("/");
              return $ !== -1 ? M === $ + 1 ? L : (L.indexOf("?") !== -1 && (L = L.substring(0, L.indexOf("?"))), L.substring(0, M + 1)) : "";
            }
            function c(L) {
              var $ = L.match(o);
              return $ ? $[1] : "";
            }
            function d(L) {
              var $ = L.match(e);
              return $ ? $[0] : "";
            }
            function S(L) {
              return !e.test(L);
            }
            function x(L) {
              return S(L) && L.charAt(0) === "/";
            }
            function B(L) {
              return L.indexOf("//") === 0;
            }
            return function() {
              try {
                new window.URL("x", "http://y"), t = E;
              } catch {
              } finally {
                t = t || h;
              }
            }(), { parseBaseUrl: n, parseOrigin: c, parseScheme: d, isRelative: S, isPathAbsolute: x, isSchemeRelative: B, isHTTPURL: function(L) {
              return p.test(L);
            }, isHTTPS: function(L) {
              return m.test(L);
            }, removeHostname: function(L) {
              return /^(?:\w+\:\/\/)?([^\/]+)(.*)$/.exec(L)[2].substring(1);
            }, resolve: function(L, $) {
              return t(L, $);
            } };
          }
          T.__dashjs_factory_name = "DefaultURLUtils", Ee.Z = ie.Z.getSingletonFactory(T);
        }, 8260: function(Pe, Ee, C) {
          var ie = C(2839), T = C(5448);
          function t() {
            var e;
            function p(o) {
              var E = [];
              if (!o || !e || typeof e.fetchAll != "function") return E;
              for (var h, n = e.fetchAll(o), c = 0, d = n.length; c < d; c++) (h = m(n[c])) && E.push(h);
              return E;
            }
            function m(o) {
              if (!o) return null;
              var E = new ie.Z(o);
              return o.hasOwnProperty("_incomplete") && (E.isComplete = !o._incomplete), E;
            }
            return { getBox: function(o) {
              return o && e && e.boxes && e.boxes.length !== 0 && typeof e.fetch == "function" ? m(e.fetch(o)) : null;
            }, getBoxes: p, setData: function(o) {
              e = o;
            }, getLastBox: function() {
              if (!e || !e.boxes || !e.boxes.length) return null;
              var o = p(e.boxes[e.boxes.length - 1].type);
              return o.length > 0 ? o[o.length - 1] : null;
            } };
          }
          t.__dashjs_factory_name = "IsoFile", Ee.Z = T.Z.getClassFactory(t);
        }, 7473: function(Pe, Ee, C) {
          C.d(Ee, { k: function() {
            return T;
          } });
          var ie = C(5448);
          function T(e, p) {
            var m = { url: e.url, method: e.method, headers: Object.assign({}, e.headers), credentials: e.withCredentials ? "include" : void 0, range: e.request.range };
            return Promise.resolve(p.modifyRequest(m)).then(function() {
              return Object.assign(e, m, { withCredentials: m.credentials === "include" });
            });
          }
          function t() {
            return { modifyRequest: null, modifyRequestURL: function(e) {
              return e;
            }, modifyRequestHeader: function(e, p) {
              return p.url, e;
            } };
          }
          t.__dashjs_factory_name = "RequestModifier", Ee.Z = ie.Z.getSingletonFactory(t);
        }, 3106: function(Pe, Ee, C) {
          C.d(Ee, { PS: function() {
            return t;
          }, SE: function() {
            return e;
          } });
          var ie = C(3393);
          function T(p) {
            return T = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(m) {
              return typeof m;
            } : function(m) {
              return m && typeof Symbol == "function" && m.constructor === Symbol && m !== Symbol.prototype ? "symbol" : typeof m;
            }, T(p);
          }
          function t(p, m) {
            if (T(p) !== m) throw ie.Z.BAD_ARGUMENT_ERROR;
          }
          function e(p) {
            if (p === null || isNaN(p) || p % 1 != 0) throw ie.Z.BAD_ARGUMENT_ERROR + " : argument is not an integer";
          }
        }, 2594: function(Pe, Ee, C) {
          var ie = C(5448), T = C(5);
          function t() {
            var p, m = [], o = this.context;
            function E(h, n, c) {
              var d = function(S) {
                var x;
                for (x = 0; x < m.length; x++) if (m[x].regex.test(S)) return m[x].utils;
                return p;
              }(c || n);
              return d && typeof d[h] == "function" ? d[h](n, c) : p[h](n, c);
            }
            return p = (0, T.Z)(o).getInstance(), { registerUrlRegex: function(h, n) {
              m.push({ regex: h, utils: n });
            }, parseBaseUrl: function(h) {
              return E("parseBaseUrl", h);
            }, parseOrigin: function(h) {
              return E("parseOrigin", h);
            }, parseScheme: function(h) {
              return E("parseScheme", h);
            }, isRelative: function(h) {
              return E("isRelative", h);
            }, isPathAbsolute: function(h) {
              return E("isPathAbsolute", h);
            }, isSchemeRelative: function(h) {
              return E("isSchemeRelative", h);
            }, isHTTPURL: function(h) {
              return E("isHTTPURL", h);
            }, isHTTPS: function(h) {
              return E("isHTTPS", h);
            }, removeHostname: function(h) {
              return E("removeHostname", h);
            }, resolve: function(h, n) {
              return E("resolve", h, n);
            } };
          }
          t.__dashjs_factory_name = "URLUtils";
          var e = ie.Z.getSingletonFactory(t);
          Ee.Z = e;
        }, 5459: function(Pe, Ee) {
          Ee.Z = function C(ie, T, t) {
            (function(e, p) {
              if (!(e instanceof p)) throw new TypeError("Cannot call a class as a function");
            })(this, C), this.code = ie || null, this.message = T || null, this.data = t || null;
          };
        }, 3186: function(Pe, Ee, C) {
          var ie = C(7855);
          function T(e, p) {
            for (var m = 0; m < p.length; m++) {
              var o = p[m];
              o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
            }
          }
          var t = function() {
            function e(o) {
              (function(E, h) {
                if (!(E instanceof h)) throw new TypeError("Cannot call a class as a function");
              })(this, e), this.action = e.ACTION_DOWNLOAD, this.startTime = NaN, this.mediaStartTime = NaN, this.mediaType = null, this.mediaInfo = null, this.type = null, this.duration = NaN, this.timescale = NaN, this.range = null, this.url = o || null, this.serviceLocation = null, this.requestStartDate = null, this.firstByteDate = null, this.requestEndDate = null, this.quality = NaN, this.index = NaN, this.availabilityStartTime = null, this.availabilityEndTime = null, this.wallStartTime = null, this.bytesLoaded = NaN, this.bytesTotal = NaN, this.delayLoadingTime = NaN, this.responseType = "arraybuffer", this.representationId = null;
            }
            var p, m;
            return p = e, (m = [{ key: "isInitializationRequest", value: function() {
              return this.type && this.type === ie.w.INIT_SEGMENT_TYPE;
            } }, { key: "setInfo", value: function(o) {
              this.type = o && o.init ? ie.w.INIT_SEGMENT_TYPE : ie.w.MEDIA_SEGMENT_TYPE, this.url = o && o.url ? o.url : null, this.range = o && o.range ? o.range.start + "-" + o.range.end : null, this.mediaType = o && o.mediaType ? o.mediaType : null;
            } }]) && T(p.prototype, m), e;
          }();
          t.ACTION_DOWNLOAD = "download", t.ACTION_COMPLETE = "complete", Ee.Z = t;
        }, 2839: function(Pe, Ee) {
          function C(T, t) {
            for (var e = 0; e < t.length; e++) {
              var p = t[e];
              p.enumerable = p.enumerable || !1, p.configurable = !0, "value" in p && (p.writable = !0), Object.defineProperty(T, p.key, p);
            }
          }
          var ie = function() {
            function T(p) {
              if (function(d, S) {
                if (!(d instanceof S)) throw new TypeError("Cannot call a class as a function");
              }(this, T), this.offset = p._offset, this.type = p.type, this.size = p.size, this.boxes = [], p.boxes) for (var m = 0; m < p.boxes.length; m++) this.boxes.push(new T(p.boxes[m]));
              switch (this.isComplete = !0, p.type) {
                case "sidx":
                  if (this.timescale = p.timescale, this.earliest_presentation_time = p.earliest_presentation_time, this.first_offset = p.first_offset, this.references = p.references, p.references) {
                    this.references = [];
                    for (var o = 0; o < p.references.length; o++) {
                      var E = { reference_type: p.references[o].reference_type, referenced_size: p.references[o].referenced_size, subsegment_duration: p.references[o].subsegment_duration };
                      this.references.push(E);
                    }
                  }
                  break;
                case "emsg":
                  this.id = p.id, this.version = p.version === 1 ? 1 : 0, this.value = p.value, this.timescale = p.timescale, this.scheme_id_uri = p.scheme_id_uri, this.presentation_time_delta = p.version === 1 ? p.presentation_time : p.presentation_time_delta, this.event_duration = p.event_duration, this.message_data = p.message_data;
                  break;
                case "mdhd":
                  this.timescale = p.timescale;
                  break;
                case "mfhd":
                  this.sequence_number = p.sequence_number;
                  break;
                case "subs":
                  this.entry_count = p.entry_count, this.entries = p.entries;
                  break;
                case "tfhd":
                  this.base_data_offset = p.base_data_offset, this.sample_description_index = p.sample_description_index, this.default_sample_duration = p.default_sample_duration, this.default_sample_size = p.default_sample_size, this.default_sample_flags = p.default_sample_flags, this.flags = p.flags;
                  break;
                case "tfdt":
                  this.version = p.version, this.baseMediaDecodeTime = p.baseMediaDecodeTime, this.flags = p.flags;
                  break;
                case "trun":
                  if (this.sample_count = p.sample_count, this.first_sample_flags = p.first_sample_flags, this.data_offset = p.data_offset, this.flags = p.flags, this.samples = p.samples, p.samples) {
                    this.samples = [];
                    for (var h = 0, n = p.samples.length; h < n; h++) {
                      var c = { sample_size: p.samples[h].sample_size, sample_duration: p.samples[h].sample_duration, sample_composition_time_offset: p.samples[h].sample_composition_time_offset };
                      this.samples.push(c);
                    }
                  }
                  break;
                case "prft":
                  this.version = p.version, this.reference_track_ID = p.reference_track_ID, this.ntp_timestamp_sec = p.ntp_timestamp_sec, this.ntp_timestamp_frac = p.ntp_timestamp_frac, this.media_time = p.media_time, this.flags = p.flags;
              }
            }
            var t, e;
            return t = T, (e = [{ key: "getChildBox", value: function(p) {
              for (var m = 0; m < this.boxes.length; m++) if (this.boxes[m].type === p) return this.boxes[m];
            } }, { key: "getChildBoxes", value: function(p) {
              for (var m = [], o = 0; o < this.boxes.length; o++) this.boxes[o].type === p && m.push(this.boxes[o]);
              return m;
            } }]) && C(t.prototype, e), T;
          }();
          Ee.Z = ie;
        }, 9597: function(Pe, Ee) {
          Ee.Z = function C(ie, T, t) {
            (function(e, p) {
              if (!(e instanceof p)) throw new TypeError("Cannot call a class as a function");
            })(this, C), this.lastCompletedOffset = ie, this.found = T, this.size = t;
          };
        }, 2128: function(Pe, Ee) {
          Ee.Z = function C() {
            (function(ie, T) {
              if (!(ie instanceof T)) throw new TypeError("Cannot call a class as a function");
            })(this, C), this.bitrate = 0, this.width = 0, this.height = 0, this.tilesHor = 0, this.tilesVert = 0, this.widthPerTile = 0, this.heightPerTile = 0, this.startNumber = 0, this.segmentDuration = 0, this.timescale = 0, this.templateUrl = "", this.id = "";
          };
        }, 7855: function(Pe, Ee, C) {
          function ie(e, p) {
            if (!(e instanceof p)) throw new TypeError("Cannot call a class as a function");
          }
          C.d(Ee, { O: function() {
            return t;
          }, w: function() {
            return T;
          } });
          var T = function e() {
            ie(this, e), this.tcpid = null, this.type = null, this.url = null, this.actualurl = null, this.range = null, this.trequest = null, this.tresponse = null, this.responsecode = null, this.interval = null, this.trace = [], this.cmsd = null, this._stream = null, this._tfinish = null, this._mediaduration = null, this._quality = null, this._responseHeaders = null, this._serviceLocation = null, this._fileLoaderType = null;
          }, t = function e() {
            ie(this, e), this.s = null, this.d = null, this.b = [];
          };
          T.GET = "GET", T.HEAD = "HEAD", T.MPD_TYPE = "MPD", T.XLINK_EXPANSION_TYPE = "XLinkExpansion", T.INIT_SEGMENT_TYPE = "InitializationSegment", T.INDEX_SEGMENT_TYPE = "IndexSegment", T.MEDIA_SEGMENT_TYPE = "MediaSegment", T.BITSTREAM_SWITCHING_SEGMENT_TYPE = "BitstreamSwitchingSegment", T.MSS_FRAGMENT_INFO_SEGMENT_TYPE = "FragmentInfoSegment", T.DVB_REPORTING_TYPE = "DVBReporting", T.LICENSE = "license", T.CONTENT_STEERING_TYPE = "ContentSteering", T.OTHER_TYPE = "other";
        }, 3039: function(Pe, Ee) {
          function C(T, t) {
            return function(e, p) {
              for (var m, o, E, h = ie(e, "tag"), n = ie(p ?? "*", "range"), c = [], d = -1; ++d < n.length; ) if (m = n[d].toLowerCase(), t || m !== "*") {
                for (o = -1, E = []; ++o < h.length; ) if (T(h[o].toLowerCase(), m)) {
                  if (!t) return h[o];
                  c.push(h[o]);
                } else E.push(h[o]);
                h = E;
              }
              return t ? c : void 0;
            };
          }
          function ie(T, t) {
            var e = T && typeof T == "string" ? [T] : T;
            if (!e || typeof e != "object" || !("length" in e)) throw new Error("Invalid " + t + " `" + e + "`, expected non-empty string");
            return e;
          }
          Ee.basicFilter = C(function(T, t) {
            return t === "*" || T === t || T.indexOf(t + "-") > -1;
          }, !0), Ee.extendedFilter = C(function(T, t) {
            var e = T.split("-"), p = t.split("-"), m = 0, o = 0;
            if (p[o] !== "*" && e[m] !== p[o]) return !1;
            for (m++, o++; o < p.length; ) if (p[o] !== "*") {
              if (!e[m]) return !1;
              if (e[m] !== p[o]) {
                if (e[m].length === 1) return !1;
                m++;
              } else m++, o++;
            } else o++;
            return !0;
          }, !0), Ee.lookup = C(function(T, t) {
            for (var e, p = t; ; ) {
              if (p === "*" || T === p) return !0;
              if ((e = p.lastIndexOf("-")) < 0) return !1;
              p.charAt(e - 2) === "-" && (e -= 2), p = p.slice(0, e);
            }
          });
        }, 3973: function(Pe, Ee, C) {
          Pe.exports = C(3854);
        }, 3854: function(Pe, Ee, C) {
          var ie = C(2415), T = C(3039), t = C(7778), e = C(5813), p = C(3165), m = C(9460);
          Pe.exports = function(x, B) {
            var L, $ = B || {}, M = ie.parse(String(x || "").toLowerCase(), $), K = ie.stringify(M), ae = -1;
            if (!K) return K;
            for (; ++ae < t.length; ) T.extendedFilter(K, t[ae].from).length && (n(M, t[ae].from, t[ae].to), K = ie.stringify(M));
            for (ae = -1; ++ae < e.length; ) c(M, e[ae].from.field, e[ae].from.value) && d(M, e[ae].to.field, e[ae].to.value);
            for (K = ie.stringify(Object.assign({}, M, h)), ae = -1; ++ae < p.length; ) K === p[ae] && (n(M, p[ae], p[ae].split("-").slice(0, -1).join("-")), K = ie.stringify(Object.assign({}, M, h)));
            if (M.extensions.sort(S), $.warning) for (L in m) o.call(m[L], M[L]) && $.warning("Deprecated " + L + " `" + M[L] + "`, expected one of `" + m[L][M[L]].join("`, `") + "`", null, 7);
            return M.script && (M.script = M.script.charAt(0).toUpperCase() + M.script.slice(1)), M.region && (M.region = M.region.toUpperCase()), ie.stringify(M);
          };
          var o = {}.hasOwnProperty, E = new Intl.Collator(), h = { variants: [], extensions: [], privateuse: [], irregular: null, regular: null };
          function n(x, B, L) {
            var $, M = ie.parse(B), K = ie.parse(L), ae = [];
            for ($ in M) M[$] && M[$].length && c(x, $, M[$]) && ae.push($);
            for ($ in K) K[$] && K[$].length && (ae.indexOf($) > -1 || !x[$] || !x[$].length) && d(x, $, K[$]);
          }
          function c(x, B, L) {
            var $, M, K, ae, j = !1;
            if (L) {
              if (M = $ = x[B], $ && typeof $ == "object") for (M = [], K = -1; ++K < $.length; ) ae = $[K], L.indexOf(ae) < 0 ? M.push(ae) : j = !0;
              else $ === L && (M = null, j = !0);
              x[B] = M;
            }
            return j;
          }
          function d(x, B, L) {
            var $, M, K, ae = x[B];
            if (ae && typeof ae == "object") for ($ = [].concat(L), M = -1; ++M < $.length; ) K = $[M], ae.indexOf(K) < 0 && ae.push(K);
            else x[B] = L;
          }
          function S(x, B) {
            return E.compare(x.singleton, B.singleton);
          }
        }, 2415: function(Pe, Ee, C) {
          Ee.parse = C(6903), Ee.stringify = C(6713);
        }, 6903: function(Pe, Ee, C) {
          var ie = C(2219), T = C(3516), t = C(395), e = C(858), p = C(8589);
          Pe.exports = function o(E, h) {
            var n, c, d, S = h || {}, x = { language: null, extendedLanguageSubtags: [], script: null, region: null, variants: [], extensions: [], privateuse: [], irregular: null, regular: null }, B = String(E), L = B.toLowerCase(), $ = 0;
            if (E == null) throw new Error("Expected string, got `" + E + "`");
            if (m.call(p, L)) return (S.normalize == null || S.normalize) && p[L] ? o(p[L]) : (x[e.indexOf(L) === -1 ? "irregular" : "regular"] = B, x);
            for (; T(L.charCodeAt($)) && $ < 9; ) $++;
            if ($ > 1 && $ < 9) {
              if (x.language = B.slice(0, $), $ < 4) for (c = 0; L.charCodeAt($) === 45 && T(L.charCodeAt($ + 1)) && T(L.charCodeAt($ + 2)) && T(L.charCodeAt($ + 3)) && !T(L.charCodeAt($ + 4)); ) {
                if (c > 2) return M($, 3, "Too many extended language subtags, expected at most 3 subtags");
                x.extendedLanguageSubtags.push(B.slice($ + 1, $ + 4)), $ += 4, c++;
              }
              for (L.charCodeAt($) === 45 && T(L.charCodeAt($ + 1)) && T(L.charCodeAt($ + 2)) && T(L.charCodeAt($ + 3)) && T(L.charCodeAt($ + 4)) && !T(L.charCodeAt($ + 5)) && (x.script = B.slice($ + 1, $ + 5), $ += 5), L.charCodeAt($) === 45 && (T(L.charCodeAt($ + 1)) && T(L.charCodeAt($ + 2)) && !T(L.charCodeAt($ + 3)) ? (x.region = B.slice($ + 1, $ + 3), $ += 3) : t(L.charCodeAt($ + 1)) && t(L.charCodeAt($ + 2)) && t(L.charCodeAt($ + 3)) && !t(L.charCodeAt($ + 4)) && (x.region = B.slice($ + 1, $ + 4), $ += 4)); L.charCodeAt($) === 45; ) {
                for (d = n = $ + 1; ie(L.charCodeAt(d)); ) {
                  if (d - n > 7) return M(d, 1, "Too long variant, expected at most 8 characters");
                  d++;
                }
                if (!(d - n > 4 || d - n > 3 && t(L.charCodeAt(n)))) break;
                x.variants.push(B.slice(n, d)), $ = d;
              }
              for (; L.charCodeAt($) === 45 && L.charCodeAt($ + 1) !== 120 && ie(L.charCodeAt($ + 1)) && L.charCodeAt($ + 2) === 45 && ie(L.charCodeAt($ + 3)); ) {
                for (d = $ + 2, c = 0; L.charCodeAt(d) === 45 && ie(L.charCodeAt(d + 1)) && ie(L.charCodeAt(d + 2)); ) for (d = (n = d + 1) + 2, c++; ie(L.charCodeAt(d)); ) {
                  if (d - n > 7) return M(d, 2, "Too long extension, expected at most 8 characters");
                  d++;
                }
                if (!c) return M(d, 4, "Empty extension, extensions must have at least 2 characters of content");
                x.extensions.push({ singleton: B.charAt($ + 1), extensions: B.slice($ + 3, d).split("-") }), $ = d;
              }
            } else $ = 0;
            if ($ === 0 && L.charCodeAt($) === 120 || L.charCodeAt($) === 45 && L.charCodeAt($ + 1) === 120) for (d = $ = $ ? $ + 2 : 1; L.charCodeAt(d) === 45 && ie(L.charCodeAt(d + 1)); ) {
              for (d = n = $ + 1; ie(L.charCodeAt(d)); ) {
                if (d - n > 7) return M(d, 5, "Too long private-use area, expected at most 8 characters");
                d++;
              }
              x.privateuse.push(B.slice($ + 1, d)), $ = d;
            }
            return $ !== B.length ? M($, 6, "Found superfluous content after tag") : x;
            function M(K, ae, j) {
              return S.warning && S.warning(j, ae, K), S.forgiving ? x : { language: null, extendedLanguageSubtags: [], script: null, region: null, variants: [], extensions: [], privateuse: [], irregular: null, regular: null };
            }
          };
          var m = {}.hasOwnProperty;
        }, 6713: function(Pe) {
          Pe.exports = function(Ee) {
            var C, ie, T, t = Ee || {}, e = [];
            if (t.irregular || t.regular) return t.irregular || t.regular;
            if (t.language) for (e = e.concat(t.language, t.extendedLanguageSubtags || [], t.script || [], t.region || [], t.variants || []), C = t.extensions || [], ie = -1; ++ie < C.length; ) (T = C[ie]).singleton && T.extensions && T.extensions.length && (e = e.concat(T.singleton, T.extensions));
            return t.privateuse && t.privateuse.length && (e = e.concat("x", t.privateuse)), e.join("-");
          };
        }, 1549: function(Pe, Ee, C) {
          var ie = C(6693), T = C(2165), t = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
          Ee.Buffer = m, Ee.SlowBuffer = function(f) {
            return +f != f && (f = 0), m.alloc(+f);
          }, Ee.INSPECT_MAX_BYTES = 50;
          var e = 2147483647;
          function p(f) {
            if (f > e) throw new RangeError('The value "' + f + '" is invalid for option "size"');
            var u = new Uint8Array(f);
            return Object.setPrototypeOf(u, m.prototype), u;
          }
          function m(f, u, v) {
            if (typeof f == "number") {
              if (typeof u == "string") throw new TypeError('The "string" argument must be of type string. Received type number');
              return h(f);
            }
            return o(f, u, v);
          }
          function o(f, u, v) {
            if (typeof f == "string") return function(Y, Re) {
              if (typeof Re == "string" && Re !== "" || (Re = "utf8"), !m.isEncoding(Re)) throw new TypeError("Unknown encoding: " + Re);
              var Je = 0 | S(Y, Re), Ze = p(Je), Fe = Ze.write(Y, Re);
              return Fe !== Je && (Ze = Ze.slice(0, Fe)), Ze;
            }(f, u);
            if (ArrayBuffer.isView(f)) return function(Y) {
              if (me(Y, Uint8Array)) {
                var Re = new Uint8Array(Y);
                return c(Re.buffer, Re.byteOffset, Re.byteLength);
              }
              return n(Y);
            }(f);
            if (f == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof f);
            if (me(f, ArrayBuffer) || f && me(f.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (me(f, SharedArrayBuffer) || f && me(f.buffer, SharedArrayBuffer))) return c(f, u, v);
            if (typeof f == "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
            var b = f.valueOf && f.valueOf();
            if (b != null && b !== f) return m.from(b, u, v);
            var W = function(Y) {
              if (m.isBuffer(Y)) {
                var Re = 0 | d(Y.length), Je = p(Re);
                return Je.length === 0 || Y.copy(Je, 0, 0, Re), Je;
              }
              return Y.length !== void 0 ? typeof Y.length != "number" || ye(Y.length) ? p(0) : n(Y) : Y.type === "Buffer" && Array.isArray(Y.data) ? n(Y.data) : void 0;
            }(f);
            if (W) return W;
            if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof f[Symbol.toPrimitive] == "function") return m.from(f[Symbol.toPrimitive]("string"), u, v);
            throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof f);
          }
          function E(f) {
            if (typeof f != "number") throw new TypeError('"size" argument must be of type number');
            if (f < 0) throw new RangeError('The value "' + f + '" is invalid for option "size"');
          }
          function h(f) {
            return E(f), p(f < 0 ? 0 : 0 | d(f));
          }
          function n(f) {
            for (var u = f.length < 0 ? 0 : 0 | d(f.length), v = p(u), b = 0; b < u; b += 1) v[b] = 255 & f[b];
            return v;
          }
          function c(f, u, v) {
            if (u < 0 || f.byteLength < u) throw new RangeError('"offset" is outside of buffer bounds');
            if (f.byteLength < u + (v || 0)) throw new RangeError('"length" is outside of buffer bounds');
            var b;
            return b = u === void 0 && v === void 0 ? new Uint8Array(f) : v === void 0 ? new Uint8Array(f, u) : new Uint8Array(f, u, v), Object.setPrototypeOf(b, m.prototype), b;
          }
          function d(f) {
            if (f >= e) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + e.toString(16) + " bytes");
            return 0 | f;
          }
          function S(f, u) {
            if (m.isBuffer(f)) return f.length;
            if (ArrayBuffer.isView(f) || me(f, ArrayBuffer)) return f.byteLength;
            if (typeof f != "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof f);
            var v = f.length, b = arguments.length > 2 && arguments[2] === !0;
            if (!b && v === 0) return 0;
            for (var W = !1; ; ) switch (u) {
              case "ascii":
              case "latin1":
              case "binary":
                return v;
              case "utf8":
              case "utf-8":
                return _t(f).length;
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return 2 * v;
              case "hex":
                return v >>> 1;
              case "base64":
                return qe(f).length;
              default:
                if (W) return b ? -1 : _t(f).length;
                u = ("" + u).toLowerCase(), W = !0;
            }
          }
          function x(f, u, v) {
            var b = !1;
            if ((u === void 0 || u < 0) && (u = 0), u > this.length || ((v === void 0 || v > this.length) && (v = this.length), v <= 0) || (v >>>= 0) <= (u >>>= 0)) return "";
            for (f || (f = "utf8"); ; ) switch (f) {
              case "hex":
                return ze(this, u, v);
              case "utf8":
              case "utf-8":
                return Ae(this, u, v);
              case "ascii":
                return Ne(this, u, v);
              case "latin1":
              case "binary":
                return Ue(this, u, v);
              case "base64":
                return ue(this, u, v);
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return Te(this, u, v);
              default:
                if (b) throw new TypeError("Unknown encoding: " + f);
                f = (f + "").toLowerCase(), b = !0;
            }
          }
          function B(f, u, v) {
            var b = f[u];
            f[u] = f[v], f[v] = b;
          }
          function L(f, u, v, b, W) {
            if (f.length === 0) return -1;
            if (typeof v == "string" ? (b = v, v = 0) : v > 2147483647 ? v = 2147483647 : v < -2147483648 && (v = -2147483648), ye(v = +v) && (v = W ? 0 : f.length - 1), v < 0 && (v = f.length + v), v >= f.length) {
              if (W) return -1;
              v = f.length - 1;
            } else if (v < 0) {
              if (!W) return -1;
              v = 0;
            }
            if (typeof u == "string" && (u = m.from(u, b)), m.isBuffer(u)) return u.length === 0 ? -1 : $(f, u, v, b, W);
            if (typeof u == "number") return u &= 255, typeof Uint8Array.prototype.indexOf == "function" ? W ? Uint8Array.prototype.indexOf.call(f, u, v) : Uint8Array.prototype.lastIndexOf.call(f, u, v) : $(f, [u], v, b, W);
            throw new TypeError("val must be string, number or Buffer");
          }
          function $(f, u, v, b, W) {
            var Y, Re = 1, Je = f.length, Ze = u.length;
            if (b !== void 0 && ((b = String(b).toLowerCase()) === "ucs2" || b === "ucs-2" || b === "utf16le" || b === "utf-16le")) {
              if (f.length < 2 || u.length < 2) return -1;
              Re = 2, Je /= 2, Ze /= 2, v /= 2;
            }
            function Fe(Tt, ft) {
              return Re === 1 ? Tt[ft] : Tt.readUInt16BE(ft * Re);
            }
            if (W) {
              var we = -1;
              for (Y = v; Y < Je; Y++) if (Fe(f, Y) === Fe(u, we === -1 ? 0 : Y - we)) {
                if (we === -1 && (we = Y), Y - we + 1 === Ze) return we * Re;
              } else we !== -1 && (Y -= Y - we), we = -1;
            } else for (v + Ze > Je && (v = Je - Ze), Y = v; Y >= 0; Y--) {
              for (var Ge = !0, nt = 0; nt < Ze; nt++) if (Fe(f, Y + nt) !== Fe(u, nt)) {
                Ge = !1;
                break;
              }
              if (Ge) return Y;
            }
            return -1;
          }
          function M(f, u, v, b) {
            v = Number(v) || 0;
            var W = f.length - v;
            b ? (b = Number(b)) > W && (b = W) : b = W;
            var Y = u.length;
            b > Y / 2 && (b = Y / 2);
            for (var Re = 0; Re < b; ++Re) {
              var Je = parseInt(u.substr(2 * Re, 2), 16);
              if (ye(Je)) return Re;
              f[v + Re] = Je;
            }
            return Re;
          }
          function K(f, u, v, b) {
            return it(_t(u, f.length - v), f, v, b);
          }
          function ae(f, u, v, b) {
            return it(function(W) {
              for (var Y = [], Re = 0; Re < W.length; ++Re) Y.push(255 & W.charCodeAt(Re));
              return Y;
            }(u), f, v, b);
          }
          function j(f, u, v, b) {
            return it(qe(u), f, v, b);
          }
          function ee(f, u, v, b) {
            return it(function(W, Y) {
              for (var Re, Je, Ze, Fe = [], we = 0; we < W.length && !((Y -= 2) < 0); ++we) Je = (Re = W.charCodeAt(we)) >> 8, Ze = Re % 256, Fe.push(Ze), Fe.push(Je);
              return Fe;
            }(u, f.length - v), f, v, b);
          }
          function ue(f, u, v) {
            return u === 0 && v === f.length ? ie.fromByteArray(f) : ie.fromByteArray(f.slice(u, v));
          }
          function Ae(f, u, v) {
            v = Math.min(f.length, v);
            for (var b = [], W = u; W < v; ) {
              var Y, Re, Je, Ze, Fe = f[W], we = null, Ge = Fe > 239 ? 4 : Fe > 223 ? 3 : Fe > 191 ? 2 : 1;
              if (W + Ge <= v) switch (Ge) {
                case 1:
                  Fe < 128 && (we = Fe);
                  break;
                case 2:
                  (192 & (Y = f[W + 1])) == 128 && (Ze = (31 & Fe) << 6 | 63 & Y) > 127 && (we = Ze);
                  break;
                case 3:
                  Y = f[W + 1], Re = f[W + 2], (192 & Y) == 128 && (192 & Re) == 128 && (Ze = (15 & Fe) << 12 | (63 & Y) << 6 | 63 & Re) > 2047 && (Ze < 55296 || Ze > 57343) && (we = Ze);
                  break;
                case 4:
                  Y = f[W + 1], Re = f[W + 2], Je = f[W + 3], (192 & Y) == 128 && (192 & Re) == 128 && (192 & Je) == 128 && (Ze = (15 & Fe) << 18 | (63 & Y) << 12 | (63 & Re) << 6 | 63 & Je) > 65535 && Ze < 1114112 && (we = Ze);
              }
              we === null ? (we = 65533, Ge = 1) : we > 65535 && (we -= 65536, b.push(we >>> 10 & 1023 | 55296), we = 56320 | 1023 & we), b.push(we), W += Ge;
            }
            return function(nt) {
              var Tt = nt.length;
              if (Tt <= Q) return String.fromCharCode.apply(String, nt);
              for (var ft = "", Yt = 0; Yt < Tt; ) ft += String.fromCharCode.apply(String, nt.slice(Yt, Yt += Q));
              return ft;
            }(b);
          }
          Ee.kMaxLength = e, m.TYPED_ARRAY_SUPPORT = function() {
            try {
              var f = new Uint8Array(1), u = { foo: function() {
                return 42;
              } };
              return Object.setPrototypeOf(u, Uint8Array.prototype), Object.setPrototypeOf(f, u), f.foo() === 42;
            } catch {
              return !1;
            }
          }(), m.TYPED_ARRAY_SUPPORT || typeof console > "u" || typeof console.error != "function" || console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."), Object.defineProperty(m.prototype, "parent", { enumerable: !0, get: function() {
            if (m.isBuffer(this)) return this.buffer;
          } }), Object.defineProperty(m.prototype, "offset", { enumerable: !0, get: function() {
            if (m.isBuffer(this)) return this.byteOffset;
          } }), m.poolSize = 8192, m.from = function(f, u, v) {
            return o(f, u, v);
          }, Object.setPrototypeOf(m.prototype, Uint8Array.prototype), Object.setPrototypeOf(m, Uint8Array), m.alloc = function(f, u, v) {
            return function(b, W, Y) {
              return E(b), b <= 0 ? p(b) : W !== void 0 ? typeof Y == "string" ? p(b).fill(W, Y) : p(b).fill(W) : p(b);
            }(f, u, v);
          }, m.allocUnsafe = function(f) {
            return h(f);
          }, m.allocUnsafeSlow = function(f) {
            return h(f);
          }, m.isBuffer = function(f) {
            return f != null && f._isBuffer === !0 && f !== m.prototype;
          }, m.compare = function(f, u) {
            if (me(f, Uint8Array) && (f = m.from(f, f.offset, f.byteLength)), me(u, Uint8Array) && (u = m.from(u, u.offset, u.byteLength)), !m.isBuffer(f) || !m.isBuffer(u)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
            if (f === u) return 0;
            for (var v = f.length, b = u.length, W = 0, Y = Math.min(v, b); W < Y; ++W) if (f[W] !== u[W]) {
              v = f[W], b = u[W];
              break;
            }
            return v < b ? -1 : b < v ? 1 : 0;
          }, m.isEncoding = function(f) {
            switch (String(f).toLowerCase()) {
              case "hex":
              case "utf8":
              case "utf-8":
              case "ascii":
              case "latin1":
              case "binary":
              case "base64":
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return !0;
              default:
                return !1;
            }
          }, m.concat = function(f, u) {
            if (!Array.isArray(f)) throw new TypeError('"list" argument must be an Array of Buffers');
            if (f.length === 0) return m.alloc(0);
            var v;
            if (u === void 0) for (u = 0, v = 0; v < f.length; ++v) u += f[v].length;
            var b = m.allocUnsafe(u), W = 0;
            for (v = 0; v < f.length; ++v) {
              var Y = f[v];
              if (me(Y, Uint8Array)) W + Y.length > b.length ? m.from(Y).copy(b, W) : Uint8Array.prototype.set.call(b, Y, W);
              else {
                if (!m.isBuffer(Y)) throw new TypeError('"list" argument must be an Array of Buffers');
                Y.copy(b, W);
              }
              W += Y.length;
            }
            return b;
          }, m.byteLength = S, m.prototype._isBuffer = !0, m.prototype.swap16 = function() {
            var f = this.length;
            if (f % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
            for (var u = 0; u < f; u += 2) B(this, u, u + 1);
            return this;
          }, m.prototype.swap32 = function() {
            var f = this.length;
            if (f % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
            for (var u = 0; u < f; u += 4) B(this, u, u + 3), B(this, u + 1, u + 2);
            return this;
          }, m.prototype.swap64 = function() {
            var f = this.length;
            if (f % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
            for (var u = 0; u < f; u += 8) B(this, u, u + 7), B(this, u + 1, u + 6), B(this, u + 2, u + 5), B(this, u + 3, u + 4);
            return this;
          }, m.prototype.toString = function() {
            var f = this.length;
            return f === 0 ? "" : arguments.length === 0 ? Ae(this, 0, f) : x.apply(this, arguments);
          }, m.prototype.toLocaleString = m.prototype.toString, m.prototype.equals = function(f) {
            if (!m.isBuffer(f)) throw new TypeError("Argument must be a Buffer");
            return this === f || m.compare(this, f) === 0;
          }, m.prototype.inspect = function() {
            var f = "", u = Ee.INSPECT_MAX_BYTES;
            return f = this.toString("hex", 0, u).replace(/(.{2})/g, "$1 ").trim(), this.length > u && (f += " ... "), "<Buffer " + f + ">";
          }, t && (m.prototype[t] = m.prototype.inspect), m.prototype.compare = function(f, u, v, b, W) {
            if (me(f, Uint8Array) && (f = m.from(f, f.offset, f.byteLength)), !m.isBuffer(f)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof f);
            if (u === void 0 && (u = 0), v === void 0 && (v = f ? f.length : 0), b === void 0 && (b = 0), W === void 0 && (W = this.length), u < 0 || v > f.length || b < 0 || W > this.length) throw new RangeError("out of range index");
            if (b >= W && u >= v) return 0;
            if (b >= W) return -1;
            if (u >= v) return 1;
            if (this === f) return 0;
            for (var Y = (W >>>= 0) - (b >>>= 0), Re = (v >>>= 0) - (u >>>= 0), Je = Math.min(Y, Re), Ze = this.slice(b, W), Fe = f.slice(u, v), we = 0; we < Je; ++we) if (Ze[we] !== Fe[we]) {
              Y = Ze[we], Re = Fe[we];
              break;
            }
            return Y < Re ? -1 : Re < Y ? 1 : 0;
          }, m.prototype.includes = function(f, u, v) {
            return this.indexOf(f, u, v) !== -1;
          }, m.prototype.indexOf = function(f, u, v) {
            return L(this, f, u, v, !0);
          }, m.prototype.lastIndexOf = function(f, u, v) {
            return L(this, f, u, v, !1);
          }, m.prototype.write = function(f, u, v, b) {
            if (u === void 0) b = "utf8", v = this.length, u = 0;
            else if (v === void 0 && typeof u == "string") b = u, v = this.length, u = 0;
            else {
              if (!isFinite(u)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
              u >>>= 0, isFinite(v) ? (v >>>= 0, b === void 0 && (b = "utf8")) : (b = v, v = void 0);
            }
            var W = this.length - u;
            if ((v === void 0 || v > W) && (v = W), f.length > 0 && (v < 0 || u < 0) || u > this.length) throw new RangeError("Attempt to write outside buffer bounds");
            b || (b = "utf8");
            for (var Y = !1; ; ) switch (b) {
              case "hex":
                return M(this, f, u, v);
              case "utf8":
              case "utf-8":
                return K(this, f, u, v);
              case "ascii":
              case "latin1":
              case "binary":
                return ae(this, f, u, v);
              case "base64":
                return j(this, f, u, v);
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return ee(this, f, u, v);
              default:
                if (Y) throw new TypeError("Unknown encoding: " + b);
                b = ("" + b).toLowerCase(), Y = !0;
            }
          }, m.prototype.toJSON = function() {
            return { type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0) };
          };
          var Q = 4096;
          function Ne(f, u, v) {
            var b = "";
            v = Math.min(f.length, v);
            for (var W = u; W < v; ++W) b += String.fromCharCode(127 & f[W]);
            return b;
          }
          function Ue(f, u, v) {
            var b = "";
            v = Math.min(f.length, v);
            for (var W = u; W < v; ++W) b += String.fromCharCode(f[W]);
            return b;
          }
          function ze(f, u, v) {
            var b = f.length;
            (!u || u < 0) && (u = 0), (!v || v < 0 || v > b) && (v = b);
            for (var W = "", Y = u; Y < v; ++Y) W += Ve[f[Y]];
            return W;
          }
          function Te(f, u, v) {
            for (var b = f.slice(u, v), W = "", Y = 0; Y < b.length - 1; Y += 2) W += String.fromCharCode(b[Y] + 256 * b[Y + 1]);
            return W;
          }
          function Oe(f, u, v) {
            if (f % 1 != 0 || f < 0) throw new RangeError("offset is not uint");
            if (f + u > v) throw new RangeError("Trying to access beyond buffer length");
          }
          function We(f, u, v, b, W, Y) {
            if (!m.isBuffer(f)) throw new TypeError('"buffer" argument must be a Buffer instance');
            if (u > W || u < Y) throw new RangeError('"value" argument is out of bounds');
            if (v + b > f.length) throw new RangeError("Index out of range");
          }
          function at(f, u, v, b, W, Y) {
            if (v + b > f.length) throw new RangeError("Index out of range");
            if (v < 0) throw new RangeError("Index out of range");
          }
          function Se(f, u, v, b, W) {
            return u = +u, v >>>= 0, W || at(f, 0, v, 4), T.write(f, u, v, b, 23, 4), v + 4;
          }
          function ke(f, u, v, b, W) {
            return u = +u, v >>>= 0, W || at(f, 0, v, 8), T.write(f, u, v, b, 52, 8), v + 8;
          }
          m.prototype.slice = function(f, u) {
            var v = this.length;
            (f = ~~f) < 0 ? (f += v) < 0 && (f = 0) : f > v && (f = v), (u = u === void 0 ? v : ~~u) < 0 ? (u += v) < 0 && (u = 0) : u > v && (u = v), u < f && (u = f);
            var b = this.subarray(f, u);
            return Object.setPrototypeOf(b, m.prototype), b;
          }, m.prototype.readUintLE = m.prototype.readUIntLE = function(f, u, v) {
            f >>>= 0, u >>>= 0, v || Oe(f, u, this.length);
            for (var b = this[f], W = 1, Y = 0; ++Y < u && (W *= 256); ) b += this[f + Y] * W;
            return b;
          }, m.prototype.readUintBE = m.prototype.readUIntBE = function(f, u, v) {
            f >>>= 0, u >>>= 0, v || Oe(f, u, this.length);
            for (var b = this[f + --u], W = 1; u > 0 && (W *= 256); ) b += this[f + --u] * W;
            return b;
          }, m.prototype.readUint8 = m.prototype.readUInt8 = function(f, u) {
            return f >>>= 0, u || Oe(f, 1, this.length), this[f];
          }, m.prototype.readUint16LE = m.prototype.readUInt16LE = function(f, u) {
            return f >>>= 0, u || Oe(f, 2, this.length), this[f] | this[f + 1] << 8;
          }, m.prototype.readUint16BE = m.prototype.readUInt16BE = function(f, u) {
            return f >>>= 0, u || Oe(f, 2, this.length), this[f] << 8 | this[f + 1];
          }, m.prototype.readUint32LE = m.prototype.readUInt32LE = function(f, u) {
            return f >>>= 0, u || Oe(f, 4, this.length), (this[f] | this[f + 1] << 8 | this[f + 2] << 16) + 16777216 * this[f + 3];
          }, m.prototype.readUint32BE = m.prototype.readUInt32BE = function(f, u) {
            return f >>>= 0, u || Oe(f, 4, this.length), 16777216 * this[f] + (this[f + 1] << 16 | this[f + 2] << 8 | this[f + 3]);
          }, m.prototype.readIntLE = function(f, u, v) {
            f >>>= 0, u >>>= 0, v || Oe(f, u, this.length);
            for (var b = this[f], W = 1, Y = 0; ++Y < u && (W *= 256); ) b += this[f + Y] * W;
            return b >= (W *= 128) && (b -= Math.pow(2, 8 * u)), b;
          }, m.prototype.readIntBE = function(f, u, v) {
            f >>>= 0, u >>>= 0, v || Oe(f, u, this.length);
            for (var b = u, W = 1, Y = this[f + --b]; b > 0 && (W *= 256); ) Y += this[f + --b] * W;
            return Y >= (W *= 128) && (Y -= Math.pow(2, 8 * u)), Y;
          }, m.prototype.readInt8 = function(f, u) {
            return f >>>= 0, u || Oe(f, 1, this.length), 128 & this[f] ? -1 * (255 - this[f] + 1) : this[f];
          }, m.prototype.readInt16LE = function(f, u) {
            f >>>= 0, u || Oe(f, 2, this.length);
            var v = this[f] | this[f + 1] << 8;
            return 32768 & v ? 4294901760 | v : v;
          }, m.prototype.readInt16BE = function(f, u) {
            f >>>= 0, u || Oe(f, 2, this.length);
            var v = this[f + 1] | this[f] << 8;
            return 32768 & v ? 4294901760 | v : v;
          }, m.prototype.readInt32LE = function(f, u) {
            return f >>>= 0, u || Oe(f, 4, this.length), this[f] | this[f + 1] << 8 | this[f + 2] << 16 | this[f + 3] << 24;
          }, m.prototype.readInt32BE = function(f, u) {
            return f >>>= 0, u || Oe(f, 4, this.length), this[f] << 24 | this[f + 1] << 16 | this[f + 2] << 8 | this[f + 3];
          }, m.prototype.readFloatLE = function(f, u) {
            return f >>>= 0, u || Oe(f, 4, this.length), T.read(this, f, !0, 23, 4);
          }, m.prototype.readFloatBE = function(f, u) {
            return f >>>= 0, u || Oe(f, 4, this.length), T.read(this, f, !1, 23, 4);
          }, m.prototype.readDoubleLE = function(f, u) {
            return f >>>= 0, u || Oe(f, 8, this.length), T.read(this, f, !0, 52, 8);
          }, m.prototype.readDoubleBE = function(f, u) {
            return f >>>= 0, u || Oe(f, 8, this.length), T.read(this, f, !1, 52, 8);
          }, m.prototype.writeUintLE = m.prototype.writeUIntLE = function(f, u, v, b) {
            f = +f, u >>>= 0, v >>>= 0, b || We(this, f, u, v, Math.pow(2, 8 * v) - 1, 0);
            var W = 1, Y = 0;
            for (this[u] = 255 & f; ++Y < v && (W *= 256); ) this[u + Y] = f / W & 255;
            return u + v;
          }, m.prototype.writeUintBE = m.prototype.writeUIntBE = function(f, u, v, b) {
            f = +f, u >>>= 0, v >>>= 0, b || We(this, f, u, v, Math.pow(2, 8 * v) - 1, 0);
            var W = v - 1, Y = 1;
            for (this[u + W] = 255 & f; --W >= 0 && (Y *= 256); ) this[u + W] = f / Y & 255;
            return u + v;
          }, m.prototype.writeUint8 = m.prototype.writeUInt8 = function(f, u, v) {
            return f = +f, u >>>= 0, v || We(this, f, u, 1, 255, 0), this[u] = 255 & f, u + 1;
          }, m.prototype.writeUint16LE = m.prototype.writeUInt16LE = function(f, u, v) {
            return f = +f, u >>>= 0, v || We(this, f, u, 2, 65535, 0), this[u] = 255 & f, this[u + 1] = f >>> 8, u + 2;
          }, m.prototype.writeUint16BE = m.prototype.writeUInt16BE = function(f, u, v) {
            return f = +f, u >>>= 0, v || We(this, f, u, 2, 65535, 0), this[u] = f >>> 8, this[u + 1] = 255 & f, u + 2;
          }, m.prototype.writeUint32LE = m.prototype.writeUInt32LE = function(f, u, v) {
            return f = +f, u >>>= 0, v || We(this, f, u, 4, 4294967295, 0), this[u + 3] = f >>> 24, this[u + 2] = f >>> 16, this[u + 1] = f >>> 8, this[u] = 255 & f, u + 4;
          }, m.prototype.writeUint32BE = m.prototype.writeUInt32BE = function(f, u, v) {
            return f = +f, u >>>= 0, v || We(this, f, u, 4, 4294967295, 0), this[u] = f >>> 24, this[u + 1] = f >>> 16, this[u + 2] = f >>> 8, this[u + 3] = 255 & f, u + 4;
          }, m.prototype.writeIntLE = function(f, u, v, b) {
            if (f = +f, u >>>= 0, !b) {
              var W = Math.pow(2, 8 * v - 1);
              We(this, f, u, v, W - 1, -W);
            }
            var Y = 0, Re = 1, Je = 0;
            for (this[u] = 255 & f; ++Y < v && (Re *= 256); ) f < 0 && Je === 0 && this[u + Y - 1] !== 0 && (Je = 1), this[u + Y] = (f / Re >> 0) - Je & 255;
            return u + v;
          }, m.prototype.writeIntBE = function(f, u, v, b) {
            if (f = +f, u >>>= 0, !b) {
              var W = Math.pow(2, 8 * v - 1);
              We(this, f, u, v, W - 1, -W);
            }
            var Y = v - 1, Re = 1, Je = 0;
            for (this[u + Y] = 255 & f; --Y >= 0 && (Re *= 256); ) f < 0 && Je === 0 && this[u + Y + 1] !== 0 && (Je = 1), this[u + Y] = (f / Re >> 0) - Je & 255;
            return u + v;
          }, m.prototype.writeInt8 = function(f, u, v) {
            return f = +f, u >>>= 0, v || We(this, f, u, 1, 127, -128), f < 0 && (f = 255 + f + 1), this[u] = 255 & f, u + 1;
          }, m.prototype.writeInt16LE = function(f, u, v) {
            return f = +f, u >>>= 0, v || We(this, f, u, 2, 32767, -32768), this[u] = 255 & f, this[u + 1] = f >>> 8, u + 2;
          }, m.prototype.writeInt16BE = function(f, u, v) {
            return f = +f, u >>>= 0, v || We(this, f, u, 2, 32767, -32768), this[u] = f >>> 8, this[u + 1] = 255 & f, u + 2;
          }, m.prototype.writeInt32LE = function(f, u, v) {
            return f = +f, u >>>= 0, v || We(this, f, u, 4, 2147483647, -2147483648), this[u] = 255 & f, this[u + 1] = f >>> 8, this[u + 2] = f >>> 16, this[u + 3] = f >>> 24, u + 4;
          }, m.prototype.writeInt32BE = function(f, u, v) {
            return f = +f, u >>>= 0, v || We(this, f, u, 4, 2147483647, -2147483648), f < 0 && (f = 4294967295 + f + 1), this[u] = f >>> 24, this[u + 1] = f >>> 16, this[u + 2] = f >>> 8, this[u + 3] = 255 & f, u + 4;
          }, m.prototype.writeFloatLE = function(f, u, v) {
            return Se(this, f, u, !0, v);
          }, m.prototype.writeFloatBE = function(f, u, v) {
            return Se(this, f, u, !1, v);
          }, m.prototype.writeDoubleLE = function(f, u, v) {
            return ke(this, f, u, !0, v);
          }, m.prototype.writeDoubleBE = function(f, u, v) {
            return ke(this, f, u, !1, v);
          }, m.prototype.copy = function(f, u, v, b) {
            if (!m.isBuffer(f)) throw new TypeError("argument should be a Buffer");
            if (v || (v = 0), b || b === 0 || (b = this.length), u >= f.length && (u = f.length), u || (u = 0), b > 0 && b < v && (b = v), b === v || f.length === 0 || this.length === 0) return 0;
            if (u < 0) throw new RangeError("targetStart out of bounds");
            if (v < 0 || v >= this.length) throw new RangeError("Index out of range");
            if (b < 0) throw new RangeError("sourceEnd out of bounds");
            b > this.length && (b = this.length), f.length - u < b - v && (b = f.length - u + v);
            var W = b - v;
            return this === f && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(u, v, b) : Uint8Array.prototype.set.call(f, this.subarray(v, b), u), W;
          }, m.prototype.fill = function(f, u, v, b) {
            if (typeof f == "string") {
              if (typeof u == "string" ? (b = u, u = 0, v = this.length) : typeof v == "string" && (b = v, v = this.length), b !== void 0 && typeof b != "string") throw new TypeError("encoding must be a string");
              if (typeof b == "string" && !m.isEncoding(b)) throw new TypeError("Unknown encoding: " + b);
              if (f.length === 1) {
                var W = f.charCodeAt(0);
                (b === "utf8" && W < 128 || b === "latin1") && (f = W);
              }
            } else typeof f == "number" ? f &= 255 : typeof f == "boolean" && (f = Number(f));
            if (u < 0 || this.length < u || this.length < v) throw new RangeError("Out of range index");
            if (v <= u) return this;
            var Y;
            if (u >>>= 0, v = v === void 0 ? this.length : v >>> 0, f || (f = 0), typeof f == "number") for (Y = u; Y < v; ++Y) this[Y] = f;
            else {
              var Re = m.isBuffer(f) ? f : m.from(f, b), Je = Re.length;
              if (Je === 0) throw new TypeError('The value "' + f + '" is invalid for argument "value"');
              for (Y = 0; Y < v - u; ++Y) this[Y + u] = Re[Y % Je];
            }
            return this;
          };
          var Rt = /[^+/0-9A-Za-z-_]/g;
          function _t(f, u) {
            var v;
            u = u || 1 / 0;
            for (var b = f.length, W = null, Y = [], Re = 0; Re < b; ++Re) {
              if ((v = f.charCodeAt(Re)) > 55295 && v < 57344) {
                if (!W) {
                  if (v > 56319) {
                    (u -= 3) > -1 && Y.push(239, 191, 189);
                    continue;
                  }
                  if (Re + 1 === b) {
                    (u -= 3) > -1 && Y.push(239, 191, 189);
                    continue;
                  }
                  W = v;
                  continue;
                }
                if (v < 56320) {
                  (u -= 3) > -1 && Y.push(239, 191, 189), W = v;
                  continue;
                }
                v = 65536 + (W - 55296 << 10 | v - 56320);
              } else W && (u -= 3) > -1 && Y.push(239, 191, 189);
              if (W = null, v < 128) {
                if ((u -= 1) < 0) break;
                Y.push(v);
              } else if (v < 2048) {
                if ((u -= 2) < 0) break;
                Y.push(v >> 6 | 192, 63 & v | 128);
              } else if (v < 65536) {
                if ((u -= 3) < 0) break;
                Y.push(v >> 12 | 224, v >> 6 & 63 | 128, 63 & v | 128);
              } else {
                if (!(v < 1114112)) throw new Error("Invalid code point");
                if ((u -= 4) < 0) break;
                Y.push(v >> 18 | 240, v >> 12 & 63 | 128, v >> 6 & 63 | 128, 63 & v | 128);
              }
            }
            return Y;
          }
          function qe(f) {
            return ie.toByteArray(function(u) {
              if ((u = (u = u.split("=")[0]).trim().replace(Rt, "")).length < 2) return "";
              for (; u.length % 4 != 0; ) u += "=";
              return u;
            }(f));
          }
          function it(f, u, v, b) {
            for (var W = 0; W < b && !(W + v >= u.length || W >= f.length); ++W) u[W + v] = f[W];
            return W;
          }
          function me(f, u) {
            return f instanceof u || f != null && f.constructor != null && f.constructor.name != null && f.constructor.name === u.name;
          }
          function ye(f) {
            return f != f;
          }
          var Ve = function() {
            for (var f = "0123456789abcdef", u = new Array(256), v = 0; v < 16; ++v) for (var b = 16 * v, W = 0; W < 16; ++W) u[b + W] = f[v] + f[W];
            return u;
          }();
        }, 6693: function(Pe, Ee) {
          Ee.byteLength = function(E) {
            var h = m(E), n = h[0], c = h[1];
            return 3 * (n + c) / 4 - c;
          }, Ee.toByteArray = function(E) {
            var h, n, c = m(E), d = c[0], S = c[1], x = new T(function($, M, K) {
              return 3 * (M + K) / 4 - K;
            }(0, d, S)), B = 0, L = S > 0 ? d - 4 : d;
            for (n = 0; n < L; n += 4) h = ie[E.charCodeAt(n)] << 18 | ie[E.charCodeAt(n + 1)] << 12 | ie[E.charCodeAt(n + 2)] << 6 | ie[E.charCodeAt(n + 3)], x[B++] = h >> 16 & 255, x[B++] = h >> 8 & 255, x[B++] = 255 & h;
            return S === 2 && (h = ie[E.charCodeAt(n)] << 2 | ie[E.charCodeAt(n + 1)] >> 4, x[B++] = 255 & h), S === 1 && (h = ie[E.charCodeAt(n)] << 10 | ie[E.charCodeAt(n + 1)] << 4 | ie[E.charCodeAt(n + 2)] >> 2, x[B++] = h >> 8 & 255, x[B++] = 255 & h), x;
          }, Ee.fromByteArray = function(E) {
            for (var h, n = E.length, c = n % 3, d = [], S = 16383, x = 0, B = n - c; x < B; x += S) d.push(o(E, x, x + S > B ? B : x + S));
            return c === 1 ? (h = E[n - 1], d.push(C[h >> 2] + C[h << 4 & 63] + "==")) : c === 2 && (h = (E[n - 2] << 8) + E[n - 1], d.push(C[h >> 10] + C[h >> 4 & 63] + C[h << 2 & 63] + "=")), d.join("");
          };
          for (var C = [], ie = [], T = typeof Uint8Array < "u" ? Uint8Array : Array, t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", e = 0, p = t.length; e < p; ++e) C[e] = t[e], ie[t.charCodeAt(e)] = e;
          function m(E) {
            var h = E.length;
            if (h % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
            var n = E.indexOf("=");
            return n === -1 && (n = h), [n, n === h ? 0 : 4 - n % 4];
          }
          function o(E, h, n) {
            for (var c, d, S = [], x = h; x < n; x += 3) c = (E[x] << 16 & 16711680) + (E[x + 1] << 8 & 65280) + (255 & E[x + 2]), S.push(C[(d = c) >> 18 & 63] + C[d >> 12 & 63] + C[d >> 6 & 63] + C[63 & d]);
            return S.join("");
          }
          ie[45] = 62, ie[95] = 63;
        }, 2165: function(Pe, Ee) {
          Ee.read = function(C, ie, T, t, e) {
            var p, m, o = 8 * e - t - 1, E = (1 << o) - 1, h = E >> 1, n = -7, c = T ? e - 1 : 0, d = T ? -1 : 1, S = C[ie + c];
            for (c += d, p = S & (1 << -n) - 1, S >>= -n, n += o; n > 0; p = 256 * p + C[ie + c], c += d, n -= 8) ;
            for (m = p & (1 << -n) - 1, p >>= -n, n += t; n > 0; m = 256 * m + C[ie + c], c += d, n -= 8) ;
            if (p === 0) p = 1 - h;
            else {
              if (p === E) return m ? NaN : 1 / 0 * (S ? -1 : 1);
              m += Math.pow(2, t), p -= h;
            }
            return (S ? -1 : 1) * m * Math.pow(2, p - t);
          }, Ee.write = function(C, ie, T, t, e, p) {
            var m, o, E, h = 8 * p - e - 1, n = (1 << h) - 1, c = n >> 1, d = e === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, S = t ? 0 : p - 1, x = t ? 1 : -1, B = ie < 0 || ie === 0 && 1 / ie < 0 ? 1 : 0;
            for (ie = Math.abs(ie), isNaN(ie) || ie === 1 / 0 ? (o = isNaN(ie) ? 1 : 0, m = n) : (m = Math.floor(Math.log(ie) / Math.LN2), ie * (E = Math.pow(2, -m)) < 1 && (m--, E *= 2), (ie += m + c >= 1 ? d / E : d * Math.pow(2, 1 - c)) * E >= 2 && (m++, E /= 2), m + c >= n ? (o = 0, m = n) : m + c >= 1 ? (o = (ie * E - 1) * Math.pow(2, e), m += c) : (o = ie * Math.pow(2, c - 1) * Math.pow(2, e), m = 0)); e >= 8; C[T + S] = 255 & o, S += x, o /= 256, e -= 8) ;
            for (m = m << e | o, h += e; h > 0; C[T + S] = 255 & m, S += x, m /= 256, h -= 8) ;
            C[T + S - x] |= 128 * B;
          };
        }, 6934: function(Pe, Ee) {
          var C = { parseBuffer: function(t) {
            return new ie(t).parse();
          }, addBoxProcessor: function(t, e) {
            typeof t == "string" && typeof e == "function" && (T.prototype._boxProcessors[t] = e);
          }, createFile: function() {
            return new ie();
          }, createBox: function(t, e, p) {
            var m = T.create(t);
            return e && e.append(m, p), m;
          }, createFullBox: function(t, e, p) {
            var m = C.createBox(t, e, p);
            return m.version = 0, m.flags = 0, m;
          }, Utils: {} };
          C.Utils.dataViewToString = function(t, e) {
            var p = e || "utf-8";
            if (typeof TextDecoder < "u") return new TextDecoder(p).decode(t);
            var m = [], o = 0;
            if (p === "utf-8") for (; o < t.byteLength; ) {
              var E = t.getUint8(o++);
              E < 128 || (E < 224 ? (E = (31 & E) << 6, E |= 63 & t.getUint8(o++)) : E < 240 ? (E = (15 & E) << 12, E |= (63 & t.getUint8(o++)) << 6, E |= 63 & t.getUint8(o++)) : (E = (7 & E) << 18, E |= (63 & t.getUint8(o++)) << 12, E |= (63 & t.getUint8(o++)) << 6, E |= 63 & t.getUint8(o++))), m.push(String.fromCharCode(E));
            }
            else for (; o < t.byteLength; ) m.push(String.fromCharCode(t.getUint8(o++)));
            return m.join("");
          }, C.Utils.utf8ToByteArray = function(t) {
            var e, p;
            if (typeof TextEncoder < "u") e = new TextEncoder().encode(t);
            else for (e = [], p = 0; p < t.length; ++p) {
              var m = t.charCodeAt(p);
              m < 128 ? e.push(m) : m < 2048 ? (e.push(192 | m >> 6), e.push(128 | 63 & m)) : m < 65536 ? (e.push(224 | m >> 12), e.push(128 | 63 & m >> 6), e.push(128 | 63 & m)) : (e.push(240 | m >> 18), e.push(128 | 63 & m >> 12), e.push(128 | 63 & m >> 6), e.push(128 | 63 & m));
            }
            return e;
          }, C.Utils.appendBox = function(t, e, p) {
            if (e._offset = t._cursor.offset, e._root = t._root ? t._root : t, e._raw = t._raw, e._parent = t, p !== -1) if (p != null) {
              var m, o = -1;
              if (typeof p == "number") o = p;
              else {
                if (typeof p == "string") m = p;
                else {
                  if (typeof p != "object" || !p.type) return void t.boxes.push(e);
                  m = p.type;
                }
                for (var E = 0; E < t.boxes.length; E++) if (m === t.boxes[E].type) {
                  o = E + 1;
                  break;
                }
              }
              t.boxes.splice(o, 0, e);
            } else t.boxes.push(e);
          }, Ee.parseBuffer = C.parseBuffer, Ee.addBoxProcessor = C.addBoxProcessor, Ee.createFile = C.createFile, Ee.createBox = C.createBox, Ee.createFullBox = C.createFullBox, Ee.Utils = C.Utils, C.Cursor = function(t) {
            this.offset = t === void 0 ? 0 : t;
          };
          var ie = function(t) {
            this._cursor = new C.Cursor(), this.boxes = [], t && (this._raw = new DataView(t));
          };
          ie.prototype.fetch = function(t) {
            var e = this.fetchAll(t, !0);
            return e.length ? e[0] : null;
          }, ie.prototype.fetchAll = function(t, e) {
            var p = [];
            return ie._sweep.call(this, t, p, e), p;
          }, ie.prototype.parse = function() {
            for (this._cursor.offset = 0, this.boxes = []; this._cursor.offset < this._raw.byteLength; ) {
              var t = T.parse(this);
              if (t.type === void 0) break;
              this.boxes.push(t);
            }
            return this;
          }, ie._sweep = function(t, e, p) {
            for (var m in this.type && this.type == t && e.push(this), this.boxes) {
              if (e.length && p) return;
              ie._sweep.call(this.boxes[m], t, e, p);
            }
          }, ie.prototype.write = function() {
            var t, e = 0;
            for (t = 0; t < this.boxes.length; t++) e += this.boxes[t].getLength(!1);
            var p = new Uint8Array(e);
            for (this._rawo = new DataView(p.buffer), this.bytes = p, this._cursor.offset = 0, t = 0; t < this.boxes.length; t++) this.boxes[t].write();
            return p.buffer;
          }, ie.prototype.append = function(t, e) {
            C.Utils.appendBox(this, t, e);
          };
          var T = function() {
            this._cursor = new C.Cursor();
          };
          T.parse = function(t) {
            var e = new T();
            return e._offset = t._cursor.offset, e._root = t._root ? t._root : t, e._raw = t._raw, e._parent = t, e._parseBox(), t._cursor.offset = e._raw.byteOffset + e._raw.byteLength, e;
          }, T.create = function(t) {
            var e = new T();
            return e.type = t, e.boxes = [], e;
          }, T.prototype._boxContainers = ["dinf", "edts", "mdia", "meco", "mfra", "minf", "moof", "moov", "mvex", "stbl", "strk", "traf", "trak", "tref", "udta", "vttc", "sinf", "schi", "encv", "enca"], T.prototype._boxProcessors = {}, T.prototype._procField = function(t, e, p) {
            this._parsing ? this[t] = this._readField(e, p) : this._writeField(e, p, this[t]);
          }, T.prototype._procFieldArray = function(t, e, p, m) {
            var o;
            if (this._parsing) for (this[t] = [], o = 0; o < e; o++) this[t][o] = this._readField(p, m);
            else for (o = 0; o < this[t].length; o++) this._writeField(p, m, this[t][o]);
          }, T.prototype._procFullBox = function() {
            this._procField("version", "uint", 8), this._procField("flags", "uint", 24);
          }, T.prototype._procEntries = function(t, e, p) {
            var m;
            if (this._parsing) for (this[t] = [], m = 0; m < e; m++) this[t].push({}), p.call(this, this[t][m]);
            else for (m = 0; m < e; m++) p.call(this, this[t][m]);
          }, T.prototype._procSubEntries = function(t, e, p, m) {
            var o;
            if (this._parsing) for (t[e] = [], o = 0; o < p; o++) t[e].push({}), m.call(this, t[e][o]);
            else for (o = 0; o < p; o++) m.call(this, t[e][o]);
          }, T.prototype._procEntryField = function(t, e, p, m) {
            this._parsing ? t[e] = this._readField(p, m) : this._writeField(p, m, t[e]);
          }, T.prototype._procSubBoxes = function(t, e) {
            var p;
            if (this._parsing) for (this[t] = [], p = 0; p < e; p++) this[t].push(T.parse(this));
            else for (p = 0; p < e; p++) this._rawo ? this[t][p].write() : this.size += this[t][p].getLength();
          }, T.prototype._readField = function(t, e) {
            switch (t) {
              case "uint":
                return this._readUint(e);
              case "int":
                return this._readInt(e);
              case "template":
                return this._readTemplate(e);
              case "string":
                return e === -1 ? this._readTerminatedString() : this._readString(e);
              case "data":
                return this._readData(e);
              case "utf8":
                return this._readUTF8String();
              default:
                return -1;
            }
          }, T.prototype._readInt = function(t) {
            var e = null, p = this._cursor.offset - this._raw.byteOffset;
            switch (t) {
              case 8:
                e = this._raw.getInt8(p);
                break;
              case 16:
                e = this._raw.getInt16(p);
                break;
              case 32:
                e = this._raw.getInt32(p);
                break;
              case 64:
                var m = this._raw.getInt32(p), o = this._raw.getInt32(p + 4);
                e = m * Math.pow(2, 32) + o;
            }
            return this._cursor.offset += t >> 3, e;
          }, T.prototype._readUint = function(t) {
            var e, p, m = null, o = this._cursor.offset - this._raw.byteOffset;
            switch (t) {
              case 8:
                m = this._raw.getUint8(o);
                break;
              case 16:
                m = this._raw.getUint16(o);
                break;
              case 24:
                m = ((e = this._raw.getUint16(o)) << 8) + (p = this._raw.getUint8(o + 2));
                break;
              case 32:
                m = this._raw.getUint32(o);
                break;
              case 64:
                e = this._raw.getUint32(o), p = this._raw.getUint32(o + 4), m = e * Math.pow(2, 32) + p;
            }
            return this._cursor.offset += t >> 3, m;
          }, T.prototype._readString = function(t) {
            for (var e = "", p = 0; p < t; p++) {
              var m = this._readUint(8);
              e += String.fromCharCode(m);
            }
            return e;
          }, T.prototype._readTemplate = function(t) {
            return this._readUint(t / 2) + this._readUint(t / 2) / Math.pow(2, t / 2);
          }, T.prototype._readTerminatedString = function() {
            for (var t = ""; this._cursor.offset - this._offset < this._raw.byteLength; ) {
              var e = this._readUint(8);
              if (e === 0) break;
              t += String.fromCharCode(e);
            }
            return t;
          }, T.prototype._readData = function(t) {
            var e = t > 0 ? t : this._raw.byteLength - (this._cursor.offset - this._offset);
            if (e > 0) {
              var p = new Uint8Array(this._raw.buffer, this._cursor.offset, e);
              return this._cursor.offset += e, p;
            }
            return null;
          }, T.prototype._readUTF8String = function() {
            var t = this._raw.byteLength - (this._cursor.offset - this._offset), e = null;
            return t > 0 && (e = new DataView(this._raw.buffer, this._cursor.offset, t), this._cursor.offset += t), e && C.Utils.dataViewToString(e);
          }, T.prototype._parseBox = function() {
            if (this._parsing = !0, this._cursor.offset = this._offset, this._offset + 8 > this._raw.buffer.byteLength) this._root._incomplete = !0;
            else {
              switch (this._procField("size", "uint", 32), this._procField("type", "string", 4), this.size === 1 && this._procField("largesize", "uint", 64), this.type === "uuid" && this._procFieldArray("usertype", 16, "uint", 8), this.size) {
                case 0:
                  this._raw = new DataView(this._raw.buffer, this._offset);
                  break;
                case 1:
                  this._offset + this.size > this._raw.buffer.byteLength ? (this._incomplete = !0, this._root._incomplete = !0) : this._raw = new DataView(this._raw.buffer, this._offset, this.largesize);
                  break;
                default:
                  this._offset + this.size > this._raw.buffer.byteLength ? (this._incomplete = !0, this._root._incomplete = !0) : this._raw = new DataView(this._raw.buffer, this._offset, this.size);
              }
              this._incomplete || (this._boxProcessors[this.type] && this._boxProcessors[this.type].call(this), this._boxContainers.indexOf(this.type) !== -1 ? this._parseContainerBox() : this._data = this._readData());
            }
          }, T.prototype._parseFullBox = function() {
            this.version = this._readUint(8), this.flags = this._readUint(24);
          }, T.prototype._parseContainerBox = function() {
            for (this.boxes = []; this._cursor.offset - this._raw.byteOffset < this._raw.byteLength; ) this.boxes.push(T.parse(this));
          }, T.prototype.append = function(t, e) {
            C.Utils.appendBox(this, t, e);
          }, T.prototype.getLength = function() {
            if (this._parsing = !1, this._rawo = null, this.size = 0, this._procField("size", "uint", 32), this._procField("type", "string", 4), this.size === 1 && this._procField("largesize", "uint", 64), this.type === "uuid" && this._procFieldArray("usertype", 16, "uint", 8), this._boxProcessors[this.type] && this._boxProcessors[this.type].call(this), this._boxContainers.indexOf(this.type) !== -1) for (var t = 0; t < this.boxes.length; t++) this.size += this.boxes[t].getLength();
            return this._data && this._writeData(this._data), this.size;
          }, T.prototype.write = function() {
            switch (this._parsing = !1, this._cursor.offset = this._parent._cursor.offset, this.size) {
              case 0:
                this._rawo = new DataView(this._parent._rawo.buffer, this._cursor.offset, this.parent._rawo.byteLength - this._cursor.offset);
                break;
              case 1:
                this._rawo = new DataView(this._parent._rawo.buffer, this._cursor.offset, this.largesize);
                break;
              default:
                this._rawo = new DataView(this._parent._rawo.buffer, this._cursor.offset, this.size);
            }
            if (this._procField("size", "uint", 32), this._procField("type", "string", 4), this.size === 1 && this._procField("largesize", "uint", 64), this.type === "uuid" && this._procFieldArray("usertype", 16, "uint", 8), this._boxProcessors[this.type] && this._boxProcessors[this.type].call(this), this._boxContainers.indexOf(this.type) !== -1) for (var t = 0; t < this.boxes.length; t++) this.boxes[t].write();
            return this._data && this._writeData(this._data), this._parent._cursor.offset += this.size, this.size;
          }, T.prototype._writeInt = function(t, e) {
            if (this._rawo) {
              var p = this._cursor.offset - this._rawo.byteOffset;
              switch (t) {
                case 8:
                  this._rawo.setInt8(p, e);
                  break;
                case 16:
                  this._rawo.setInt16(p, e);
                  break;
                case 32:
                  this._rawo.setInt32(p, e);
                  break;
                case 64:
                  var m = Math.floor(e / Math.pow(2, 32)), o = e - m * Math.pow(2, 32);
                  this._rawo.setUint32(p, m), this._rawo.setUint32(p + 4, o);
              }
              this._cursor.offset += t >> 3;
            } else this.size += t >> 3;
          }, T.prototype._writeUint = function(t, e) {
            if (this._rawo) {
              var p, m, o = this._cursor.offset - this._rawo.byteOffset;
              switch (t) {
                case 8:
                  this._rawo.setUint8(o, e);
                  break;
                case 16:
                  this._rawo.setUint16(o, e);
                  break;
                case 24:
                  p = (16776960 & e) >> 8, m = 255 & e, this._rawo.setUint16(o, p), this._rawo.setUint8(o + 2, m);
                  break;
                case 32:
                  this._rawo.setUint32(o, e);
                  break;
                case 64:
                  m = e - (p = Math.floor(e / Math.pow(2, 32))) * Math.pow(2, 32), this._rawo.setUint32(o, p), this._rawo.setUint32(o + 4, m);
              }
              this._cursor.offset += t >> 3;
            } else this.size += t >> 3;
          }, T.prototype._writeString = function(t, e) {
            for (var p = 0; p < t; p++) this._writeUint(8, e.charCodeAt(p));
          }, T.prototype._writeTerminatedString = function(t) {
            if (t.length !== 0) {
              for (var e = 0; e < t.length; e++) this._writeUint(8, t.charCodeAt(e));
              this._writeUint(8, 0);
            }
          }, T.prototype._writeTemplate = function(t, e) {
            var p = Math.floor(e), m = (e - p) * Math.pow(2, t / 2);
            this._writeUint(t / 2, p), this._writeUint(t / 2, m);
          }, T.prototype._writeData = function(t) {
            if (t) if (this._rawo) {
              if (t instanceof Array) {
                for (var e = this._cursor.offset - this._rawo.byteOffset, p = 0; p < t.length; p++) this._rawo.setInt8(e + p, t[p]);
                this._cursor.offset += t.length;
              }
              t instanceof Uint8Array && (this._root.bytes.set(t, this._cursor.offset), this._cursor.offset += t.length);
            } else this.size += t.length;
          }, T.prototype._writeUTF8String = function(t) {
            var e = C.Utils.utf8ToByteArray(t);
            if (this._rawo) for (var p = new DataView(this._rawo.buffer, this._cursor.offset, e.length), m = 0; m < e.length; m++) p.setUint8(m, e[m]);
            else this.size += e.length;
          }, T.prototype._writeField = function(t, e, p) {
            switch (t) {
              case "uint":
                this._writeUint(e, p);
                break;
              case "int":
                this._writeInt(e, p);
                break;
              case "template":
                this._writeTemplate(e, p);
                break;
              case "string":
                e == -1 ? this._writeTerminatedString(p) : this._writeString(e, p);
                break;
              case "data":
                this._writeData(p);
                break;
              case "utf8":
                this._writeUTF8String(p);
            }
          }, T.prototype._boxProcessors.avc1 = T.prototype._boxProcessors.avc2 = T.prototype._boxProcessors.avc3 = T.prototype._boxProcessors.avc4 = T.prototype._boxProcessors.hvc1 = T.prototype._boxProcessors.hev1 = T.prototype._boxProcessors.encv = function() {
            this._procFieldArray("reserved1", 6, "uint", 8), this._procField("data_reference_index", "uint", 16), this._procField("pre_defined1", "uint", 16), this._procField("reserved2", "uint", 16), this._procFieldArray("pre_defined2", 3, "uint", 32), this._procField("width", "uint", 16), this._procField("height", "uint", 16), this._procField("horizresolution", "template", 32), this._procField("vertresolution", "template", 32), this._procField("reserved3", "uint", 32), this._procField("frame_count", "uint", 16), this._procFieldArray("compressorname", 32, "uint", 8), this._procField("depth", "uint", 16), this._procField("pre_defined3", "int", 16), this._procField("config", "data", -1);
          }, T.prototype._boxProcessors.ctts = function() {
            this._procFullBox(), this._procField("entry_count", "uint", 32), this._procEntries("entries", this.entry_count, function(t) {
              this._procEntryField(t, "sample_count", "uint", 32), this._procEntryField(t, "sample_offset", this.version === 1 ? "int" : "uint", 32);
            });
          }, T.prototype._boxProcessors.dref = function() {
            this._procFullBox(), this._procField("entry_count", "uint", 32), this._procSubBoxes("entries", this.entry_count);
          }, T.prototype._boxProcessors.elst = function() {
            this._procFullBox(), this._procField("entry_count", "uint", 32), this._procEntries("entries", this.entry_count, function(t) {
              this._procEntryField(t, "segment_duration", "uint", this.version === 1 ? 64 : 32), this._procEntryField(t, "media_time", "int", this.version === 1 ? 64 : 32), this._procEntryField(t, "media_rate_integer", "int", 16), this._procEntryField(t, "media_rate_fraction", "int", 16);
            });
          }, T.prototype._boxProcessors.emsg = function() {
            this._procFullBox(), this.version == 1 ? (this._procField("timescale", "uint", 32), this._procField("presentation_time", "uint", 64), this._procField("event_duration", "uint", 32), this._procField("id", "uint", 32), this._procField("scheme_id_uri", "string", -1), this._procField("value", "string", -1)) : (this._procField("scheme_id_uri", "string", -1), this._procField("value", "string", -1), this._procField("timescale", "uint", 32), this._procField("presentation_time_delta", "uint", 32), this._procField("event_duration", "uint", 32), this._procField("id", "uint", 32)), this._procField("message_data", "data", -1);
          }, T.prototype._boxProcessors.free = T.prototype._boxProcessors.skip = function() {
            this._procField("data", "data", -1);
          }, T.prototype._boxProcessors.frma = function() {
            this._procField("data_format", "uint", 32);
          }, T.prototype._boxProcessors.ftyp = T.prototype._boxProcessors.styp = function() {
            this._procField("major_brand", "string", 4), this._procField("minor_version", "uint", 32);
            var t = -1;
            this._parsing && (t = (this._raw.byteLength - (this._cursor.offset - this._raw.byteOffset)) / 4), this._procFieldArray("compatible_brands", t, "string", 4);
          }, T.prototype._boxProcessors.hdlr = function() {
            this._procFullBox(), this._procField("pre_defined", "uint", 32), this._procField("handler_type", "string", 4), this._procFieldArray("reserved", 3, "uint", 32), this._procField("name", "string", -1);
          }, T.prototype._boxProcessors.mdat = function() {
            this._procField("data", "data", -1);
          }, T.prototype._boxProcessors.mdhd = function() {
            this._procFullBox(), this._procField("creation_time", "uint", this.version == 1 ? 64 : 32), this._procField("modification_time", "uint", this.version == 1 ? 64 : 32), this._procField("timescale", "uint", 32), this._procField("duration", "uint", this.version == 1 ? 64 : 32), this._parsing || typeof this.language != "string" || (this.language = this.language.charCodeAt(0) - 96 << 10 | this.language.charCodeAt(1) - 96 << 5 | this.language.charCodeAt(2) - 96), this._procField("language", "uint", 16), this._parsing && (this.language = String.fromCharCode(96 + (this.language >> 10 & 31), 96 + (this.language >> 5 & 31), 96 + (31 & this.language))), this._procField("pre_defined", "uint", 16);
          }, T.prototype._boxProcessors.mehd = function() {
            this._procFullBox(), this._procField("fragment_duration", "uint", this.version == 1 ? 64 : 32);
          }, T.prototype._boxProcessors.mfhd = function() {
            this._procFullBox(), this._procField("sequence_number", "uint", 32);
          }, T.prototype._boxProcessors.mfro = function() {
            this._procFullBox(), this._procField("mfra_size", "uint", 32);
          }, T.prototype._boxProcessors.mp4a = T.prototype._boxProcessors.enca = function() {
            this._procFieldArray("reserved1", 6, "uint", 8), this._procField("data_reference_index", "uint", 16), this._procFieldArray("reserved2", 2, "uint", 32), this._procField("channelcount", "uint", 16), this._procField("samplesize", "uint", 16), this._procField("pre_defined", "uint", 16), this._procField("reserved3", "uint", 16), this._procField("samplerate", "template", 32), this._procField("esds", "data", -1);
          }, T.prototype._boxProcessors.mvhd = function() {
            this._procFullBox(), this._procField("creation_time", "uint", this.version == 1 ? 64 : 32), this._procField("modification_time", "uint", this.version == 1 ? 64 : 32), this._procField("timescale", "uint", 32), this._procField("duration", "uint", this.version == 1 ? 64 : 32), this._procField("rate", "template", 32), this._procField("volume", "template", 16), this._procField("reserved1", "uint", 16), this._procFieldArray("reserved2", 2, "uint", 32), this._procFieldArray("matrix", 9, "template", 32), this._procFieldArray("pre_defined", 6, "uint", 32), this._procField("next_track_ID", "uint", 32);
          }, T.prototype._boxProcessors.payl = function() {
            this._procField("cue_text", "utf8");
          }, T.prototype._boxProcessors.prft = function() {
            this._procFullBox(), this._procField("reference_track_ID", "uint", 32), this._procField("ntp_timestamp_sec", "uint", 32), this._procField("ntp_timestamp_frac", "uint", 32), this._procField("media_time", "uint", this.version == 1 ? 64 : 32);
          }, T.prototype._boxProcessors.pssh = function() {
            this._procFullBox(), this._procFieldArray("SystemID", 16, "uint", 8), this._procField("DataSize", "uint", 32), this._procFieldArray("Data", this.DataSize, "uint", 8);
          }, T.prototype._boxProcessors.schm = function() {
            this._procFullBox(), this._procField("scheme_type", "uint", 32), this._procField("scheme_version", "uint", 32), 1 & this.flags && this._procField("scheme_uri", "string", -1);
          }, T.prototype._boxProcessors.sdtp = function() {
            this._procFullBox();
            var t = -1;
            this._parsing && (t = this._raw.byteLength - (this._cursor.offset - this._raw.byteOffset)), this._procFieldArray("sample_dependency_table", t, "uint", 8);
          }, T.prototype._boxProcessors.sidx = function() {
            this._procFullBox(), this._procField("reference_ID", "uint", 32), this._procField("timescale", "uint", 32), this._procField("earliest_presentation_time", "uint", this.version == 1 ? 64 : 32), this._procField("first_offset", "uint", this.version == 1 ? 64 : 32), this._procField("reserved", "uint", 16), this._procField("reference_count", "uint", 16), this._procEntries("references", this.reference_count, function(t) {
              this._parsing || (t.reference = (1 & t.reference_type) << 31, t.reference |= 2147483647 & t.referenced_size, t.sap = (1 & t.starts_with_SAP) << 31, t.sap |= (3 & t.SAP_type) << 28, t.sap |= 268435455 & t.SAP_delta_time), this._procEntryField(t, "reference", "uint", 32), this._procEntryField(t, "subsegment_duration", "uint", 32), this._procEntryField(t, "sap", "uint", 32), this._parsing && (t.reference_type = t.reference >> 31 & 1, t.referenced_size = 2147483647 & t.reference, t.starts_with_SAP = t.sap >> 31 & 1, t.SAP_type = t.sap >> 28 & 7, t.SAP_delta_time = 268435455 & t.sap);
            });
          }, T.prototype._boxProcessors.smhd = function() {
            this._procFullBox(), this._procField("balance", "uint", 16), this._procField("reserved", "uint", 16);
          }, T.prototype._boxProcessors.ssix = function() {
            this._procFullBox(), this._procField("subsegment_count", "uint", 32), this._procEntries("subsegments", this.subsegment_count, function(t) {
              this._procEntryField(t, "ranges_count", "uint", 32), this._procSubEntries(t, "ranges", t.ranges_count, function(e) {
                this._procEntryField(e, "level", "uint", 8), this._procEntryField(e, "range_size", "uint", 24);
              });
            });
          }, T.prototype._boxProcessors.stsd = function() {
            this._procFullBox(), this._procField("entry_count", "uint", 32), this._procSubBoxes("entries", this.entry_count);
          }, T.prototype._boxProcessors.sttg = function() {
            this._procField("settings", "utf8");
          }, T.prototype._boxProcessors.stts = function() {
            this._procFullBox(), this._procField("entry_count", "uint", 32), this._procEntries("entries", this.entry_count, function(t) {
              this._procEntryField(t, "sample_count", "uint", 32), this._procEntryField(t, "sample_delta", "uint", 32);
            });
          }, T.prototype._boxProcessors.subs = function() {
            this._procFullBox(), this._procField("entry_count", "uint", 32), this._procEntries("entries", this.entry_count, function(t) {
              this._procEntryField(t, "sample_delta", "uint", 32), this._procEntryField(t, "subsample_count", "uint", 16), this._procSubEntries(t, "subsamples", t.subsample_count, function(e) {
                this._procEntryField(e, "subsample_size", "uint", this.version === 1 ? 32 : 16), this._procEntryField(e, "subsample_priority", "uint", 8), this._procEntryField(e, "discardable", "uint", 8), this._procEntryField(e, "codec_specific_parameters", "uint", 32);
              });
            });
          }, T.prototype._boxProcessors.tenc = function() {
            this._procFullBox(), this._procField("default_IsEncrypted", "uint", 24), this._procField("default_IV_size", "uint", 8), this._procFieldArray("default_KID", 16, "uint", 8);
          }, T.prototype._boxProcessors.tfdt = function() {
            this._procFullBox(), this._procField("baseMediaDecodeTime", "uint", this.version == 1 ? 64 : 32);
          }, T.prototype._boxProcessors.tfhd = function() {
            this._procFullBox(), this._procField("track_ID", "uint", 32), 1 & this.flags && this._procField("base_data_offset", "uint", 64), 2 & this.flags && this._procField("sample_description_offset", "uint", 32), 8 & this.flags && this._procField("default_sample_duration", "uint", 32), 16 & this.flags && this._procField("default_sample_size", "uint", 32), 32 & this.flags && this._procField("default_sample_flags", "uint", 32);
          }, T.prototype._boxProcessors.tfra = function() {
            this._procFullBox(), this._procField("track_ID", "uint", 32), this._parsing || (this.reserved = 0, this.reserved |= (48 & this.length_size_of_traf_num) << 4, this.reserved |= (12 & this.length_size_of_trun_num) << 2, this.reserved |= 3 & this.length_size_of_sample_num), this._procField("reserved", "uint", 32), this._parsing && (this.length_size_of_traf_num = (48 & this.reserved) >> 4, this.length_size_of_trun_num = (12 & this.reserved) >> 2, this.length_size_of_sample_num = 3 & this.reserved), this._procField("number_of_entry", "uint", 32), this._procEntries("entries", this.number_of_entry, function(t) {
              this._procEntryField(t, "time", "uint", this.version === 1 ? 64 : 32), this._procEntryField(t, "moof_offset", "uint", this.version === 1 ? 64 : 32), this._procEntryField(t, "traf_number", "uint", 8 * (this.length_size_of_traf_num + 1)), this._procEntryField(t, "trun_number", "uint", 8 * (this.length_size_of_trun_num + 1)), this._procEntryField(t, "sample_number", "uint", 8 * (this.length_size_of_sample_num + 1));
            });
          }, T.prototype._boxProcessors.tkhd = function() {
            this._procFullBox(), this._procField("creation_time", "uint", this.version == 1 ? 64 : 32), this._procField("modification_time", "uint", this.version == 1 ? 64 : 32), this._procField("track_ID", "uint", 32), this._procField("reserved1", "uint", 32), this._procField("duration", "uint", this.version == 1 ? 64 : 32), this._procFieldArray("reserved2", 2, "uint", 32), this._procField("layer", "uint", 16), this._procField("alternate_group", "uint", 16), this._procField("volume", "template", 16), this._procField("reserved3", "uint", 16), this._procFieldArray("matrix", 9, "template", 32), this._procField("width", "template", 32), this._procField("height", "template", 32);
          }, T.prototype._boxProcessors.trex = function() {
            this._procFullBox(), this._procField("track_ID", "uint", 32), this._procField("default_sample_description_index", "uint", 32), this._procField("default_sample_duration", "uint", 32), this._procField("default_sample_size", "uint", 32), this._procField("default_sample_flags", "uint", 32);
          }, T.prototype._boxProcessors.trun = function() {
            this._procFullBox(), this._procField("sample_count", "uint", 32), 1 & this.flags && this._procField("data_offset", "int", 32), 4 & this.flags && this._procField("first_sample_flags", "uint", 32), this._procEntries("samples", this.sample_count, function(t) {
              256 & this.flags && this._procEntryField(t, "sample_duration", "uint", 32), 512 & this.flags && this._procEntryField(t, "sample_size", "uint", 32), 1024 & this.flags && this._procEntryField(t, "sample_flags", "uint", 32), 2048 & this.flags && this._procEntryField(t, "sample_composition_time_offset", this.version === 1 ? "int" : "uint", 32);
            });
          }, T.prototype._boxProcessors["url "] = T.prototype._boxProcessors["urn "] = function() {
            this._procFullBox(), this.type === "urn " && this._procField("name", "string", -1), this._procField("location", "string", -1);
          }, T.prototype._boxProcessors.vlab = function() {
            this._procField("source_label", "utf8");
          }, T.prototype._boxProcessors.vmhd = function() {
            this._procFullBox(), this._procField("graphicsmode", "uint", 16), this._procFieldArray("opcolor", 3, "uint", 16);
          }, T.prototype._boxProcessors.vttC = function() {
            this._procField("config", "utf8");
          }, T.prototype._boxProcessors.vtte = function() {
          };
        }, 5530: function(Pe, Ee, C) {
          Pe.exports = C(6146).polyfill();
        }, 6146: function(Pe, Ee, C) {
          Pe.exports = function() {
            function ie(qe) {
              return typeof qe == "function";
            }
            var T = Array.isArray ? Array.isArray : function(qe) {
              return Object.prototype.toString.call(qe) === "[object Array]";
            }, t = 0, e = void 0, p = void 0, m = function(qe, it) {
              S[t] = qe, S[t + 1] = it, (t += 2) === 2 && (p ? p(x) : K());
            }, o = typeof window < "u" ? window : void 0, E = o || {}, h = E.MutationObserver || E.WebKitMutationObserver, n = typeof self > "u" && typeof process < "u" && {}.toString.call(process) === "[object process]", c = typeof Uint8ClampedArray < "u" && typeof importScripts < "u" && typeof MessageChannel < "u";
            function d() {
              var qe = setTimeout;
              return function() {
                return qe(x, 1);
              };
            }
            var S = new Array(1e3);
            function x() {
              for (var qe = 0; qe < t; qe += 2) (0, S[qe])(S[qe + 1]), S[qe] = void 0, S[qe + 1] = void 0;
              t = 0;
            }
            var B, L, $, M, K = void 0;
            function ae(qe, it) {
              var me = this, ye = new this.constructor(ue);
              ye[ee] === void 0 && ke(ye);
              var Ve = me._state;
              if (Ve) {
                var f = arguments[Ve - 1];
                m(function() {
                  return at(Ve, ye, f, me._result);
                });
              } else Oe(me, ye, qe, it);
              return ye;
            }
            function j(qe) {
              if (qe && typeof qe == "object" && qe.constructor === this) return qe;
              var it = new this(ue);
              return Ne(it, qe), it;
            }
            K = n ? function() {
              return process.nextTick(x);
            } : h ? (L = 0, $ = new h(x), M = document.createTextNode(""), $.observe(M, { characterData: !0 }), function() {
              M.data = L = ++L % 2;
            }) : c ? ((B = new MessageChannel()).port1.onmessage = x, function() {
              return B.port2.postMessage(0);
            }) : o === void 0 ? function() {
              try {
                var qe = Function("return this")().require("vertx");
                return (e = qe.runOnLoop || qe.runOnContext) !== void 0 ? function() {
                  e(x);
                } : d();
              } catch {
                return d();
              }
            }() : d();
            var ee = Math.random().toString(36).substring(2);
            function ue() {
            }
            var Ae = void 0;
            function Q(qe, it, me) {
              it.constructor === qe.constructor && me === ae && it.constructor.resolve === j ? function(ye, Ve) {
                Ve._state === 1 ? ze(ye, Ve._result) : Ve._state === 2 ? Te(ye, Ve._result) : Oe(Ve, void 0, function(f) {
                  return Ne(ye, f);
                }, function(f) {
                  return Te(ye, f);
                });
              }(qe, it) : me === void 0 ? ze(qe, it) : ie(me) ? function(ye, Ve, f) {
                m(function(u) {
                  var v = !1, b = function(W, Y, Re, Je) {
                    try {
                      W.call(Y, Re, Je);
                    } catch (Ze) {
                      return Ze;
                    }
                  }(f, Ve, function(W) {
                    v || (v = !0, Ve !== W ? Ne(u, W) : ze(u, W));
                  }, function(W) {
                    v || (v = !0, Te(u, W));
                  }, u._label);
                  !v && b && (v = !0, Te(u, b));
                }, ye);
              }(qe, it, me) : ze(qe, it);
            }
            function Ne(qe, it) {
              if (qe === it) Te(qe, new TypeError("You cannot resolve a promise with itself"));
              else if (Ve = typeof (ye = it), ye === null || Ve !== "object" && Ve !== "function") ze(qe, it);
              else {
                var me = void 0;
                try {
                  me = it.then;
                } catch (f) {
                  return void Te(qe, f);
                }
                Q(qe, it, me);
              }
              var ye, Ve;
            }
            function Ue(qe) {
              qe._onerror && qe._onerror(qe._result), We(qe);
            }
            function ze(qe, it) {
              qe._state === Ae && (qe._result = it, qe._state = 1, qe._subscribers.length !== 0 && m(We, qe));
            }
            function Te(qe, it) {
              qe._state === Ae && (qe._state = 2, qe._result = it, m(Ue, qe));
            }
            function Oe(qe, it, me, ye) {
              var Ve = qe._subscribers, f = Ve.length;
              qe._onerror = null, Ve[f] = it, Ve[f + 1] = me, Ve[f + 2] = ye, f === 0 && qe._state && m(We, qe);
            }
            function We(qe) {
              var it = qe._subscribers, me = qe._state;
              if (it.length !== 0) {
                for (var ye = void 0, Ve = void 0, f = qe._result, u = 0; u < it.length; u += 3) ye = it[u], Ve = it[u + me], ye ? at(me, ye, Ve, f) : Ve(f);
                qe._subscribers.length = 0;
              }
            }
            function at(qe, it, me, ye) {
              var Ve = ie(me), f = void 0, u = void 0, v = !0;
              if (Ve) {
                try {
                  f = me(ye);
                } catch (b) {
                  v = !1, u = b;
                }
                if (it === f) return void Te(it, new TypeError("A promises callback cannot return that same promise."));
              } else f = ye;
              it._state !== Ae || (Ve && v ? Ne(it, f) : v === !1 ? Te(it, u) : qe === 1 ? ze(it, f) : qe === 2 && Te(it, f));
            }
            var Se = 0;
            function ke(qe) {
              qe[ee] = Se++, qe._state = void 0, qe._result = void 0, qe._subscribers = [];
            }
            var Rt = function() {
              function qe(it, me) {
                this._instanceConstructor = it, this.promise = new it(ue), this.promise[ee] || ke(this.promise), T(me) ? (this.length = me.length, this._remaining = me.length, this._result = new Array(this.length), this.length === 0 ? ze(this.promise, this._result) : (this.length = this.length || 0, this._enumerate(me), this._remaining === 0 && ze(this.promise, this._result))) : Te(this.promise, new Error("Array Methods must be provided an Array"));
              }
              return qe.prototype._enumerate = function(it) {
                for (var me = 0; this._state === Ae && me < it.length; me++) this._eachEntry(it[me], me);
              }, qe.prototype._eachEntry = function(it, me) {
                var ye = this._instanceConstructor, Ve = ye.resolve;
                if (Ve === j) {
                  var f = void 0, u = void 0, v = !1;
                  try {
                    f = it.then;
                  } catch (W) {
                    v = !0, u = W;
                  }
                  if (f === ae && it._state !== Ae) this._settledAt(it._state, me, it._result);
                  else if (typeof f != "function") this._remaining--, this._result[me] = it;
                  else if (ye === _t) {
                    var b = new ye(ue);
                    v ? Te(b, u) : Q(b, it, f), this._willSettleAt(b, me);
                  } else this._willSettleAt(new ye(function(W) {
                    return W(it);
                  }), me);
                } else this._willSettleAt(Ve(it), me);
              }, qe.prototype._settledAt = function(it, me, ye) {
                var Ve = this.promise;
                Ve._state === Ae && (this._remaining--, it === 2 ? Te(Ve, ye) : this._result[me] = ye), this._remaining === 0 && ze(Ve, this._result);
              }, qe.prototype._willSettleAt = function(it, me) {
                var ye = this;
                Oe(it, void 0, function(Ve) {
                  return ye._settledAt(1, me, Ve);
                }, function(Ve) {
                  return ye._settledAt(2, me, Ve);
                });
              }, qe;
            }(), _t = function() {
              function qe(it) {
                this[ee] = Se++, this._result = this._state = void 0, this._subscribers = [], ue !== it && (typeof it != "function" && function() {
                  throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
                }(), this instanceof qe ? function(me, ye) {
                  try {
                    ye(function(Ve) {
                      Ne(me, Ve);
                    }, function(Ve) {
                      Te(me, Ve);
                    });
                  } catch (Ve) {
                    Te(me, Ve);
                  }
                }(this, it) : function() {
                  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
                }());
              }
              return qe.prototype.catch = function(it) {
                return this.then(null, it);
              }, qe.prototype.finally = function(it) {
                var me = this, ye = me.constructor;
                return ie(it) ? me.then(function(Ve) {
                  return ye.resolve(it()).then(function() {
                    return Ve;
                  });
                }, function(Ve) {
                  return ye.resolve(it()).then(function() {
                    throw Ve;
                  });
                }) : me.then(it, it);
              }, qe;
            }();
            return _t.prototype.then = ae, _t.all = function(qe) {
              return new Rt(this, qe).promise;
            }, _t.race = function(qe) {
              var it = this;
              return T(qe) ? new it(function(me, ye) {
                for (var Ve = qe.length, f = 0; f < Ve; f++) it.resolve(qe[f]).then(me, ye);
              }) : new it(function(me, ye) {
                return ye(new TypeError("You must pass an array to race."));
              });
            }, _t.resolve = j, _t.reject = function(qe) {
              var it = new this(ue);
              return Te(it, qe), it;
            }, _t._setScheduler = function(qe) {
              p = qe;
            }, _t._setAsap = function(qe) {
              m = qe;
            }, _t._asap = m, _t.polyfill = function() {
              var qe = void 0;
              if (C.g !== void 0) qe = C.g;
              else if (typeof self < "u") qe = self;
              else try {
                qe = Function("return this")();
              } catch {
                throw new Error("polyfill failed because global object is unavailable in this environment");
              }
              var it = qe.Promise;
              if (it) {
                var me = null;
                try {
                  me = Object.prototype.toString.call(it.resolve());
                } catch {
                }
                if (me === "[object Promise]" && !it.cast) return;
              }
              qe.Promise = _t;
            }, _t.Promise = _t, _t;
          }();
        }, 1159: function(Pe) {
          var Ee, C = typeof Reflect == "object" ? Reflect : null, ie = C && typeof C.apply == "function" ? C.apply : function(x, B, L) {
            return Function.prototype.apply.call(x, B, L);
          };
          Ee = C && typeof C.ownKeys == "function" ? C.ownKeys : Object.getOwnPropertySymbols ? function(x) {
            return Object.getOwnPropertyNames(x).concat(Object.getOwnPropertySymbols(x));
          } : function(x) {
            return Object.getOwnPropertyNames(x);
          };
          var T = Number.isNaN || function(x) {
            return x != x;
          };
          function t() {
            t.init.call(this);
          }
          Pe.exports = t, Pe.exports.once = function(x, B) {
            return new Promise(function(L, $) {
              function M(ae) {
                x.removeListener(B, K), $(ae);
              }
              function K() {
                typeof x.removeListener == "function" && x.removeListener("error", M), L([].slice.call(arguments));
              }
              S(x, B, K, { once: !0 }), B !== "error" && function(ae, j, ee) {
                typeof ae.on == "function" && S(ae, "error", j, { once: !0 });
              }(x, M);
            });
          }, t.EventEmitter = t, t.prototype._events = void 0, t.prototype._eventsCount = 0, t.prototype._maxListeners = void 0;
          var e = 10;
          function p(x) {
            if (typeof x != "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof x);
          }
          function m(x) {
            return x._maxListeners === void 0 ? t.defaultMaxListeners : x._maxListeners;
          }
          function o(x, B, L, $) {
            var M, K, ae, j;
            if (p(L), (K = x._events) === void 0 ? (K = x._events = /* @__PURE__ */ Object.create(null), x._eventsCount = 0) : (K.newListener !== void 0 && (x.emit("newListener", B, L.listener ? L.listener : L), K = x._events), ae = K[B]), ae === void 0) ae = K[B] = L, ++x._eventsCount;
            else if (typeof ae == "function" ? ae = K[B] = $ ? [L, ae] : [ae, L] : $ ? ae.unshift(L) : ae.push(L), (M = m(x)) > 0 && ae.length > M && !ae.warned) {
              ae.warned = !0;
              var ee = new Error("Possible EventEmitter memory leak detected. " + ae.length + " " + String(B) + " listeners added. Use emitter.setMaxListeners() to increase limit");
              ee.name = "MaxListenersExceededWarning", ee.emitter = x, ee.type = B, ee.count = ae.length, j = ee, console && console.warn && console.warn(j);
            }
            return x;
          }
          function E() {
            if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
          }
          function h(x, B, L) {
            var $ = { fired: !1, wrapFn: void 0, target: x, type: B, listener: L }, M = E.bind($);
            return M.listener = L, $.wrapFn = M, M;
          }
          function n(x, B, L) {
            var $ = x._events;
            if ($ === void 0) return [];
            var M = $[B];
            return M === void 0 ? [] : typeof M == "function" ? L ? [M.listener || M] : [M] : L ? function(K) {
              for (var ae = new Array(K.length), j = 0; j < ae.length; ++j) ae[j] = K[j].listener || K[j];
              return ae;
            }(M) : d(M, M.length);
          }
          function c(x) {
            var B = this._events;
            if (B !== void 0) {
              var L = B[x];
              if (typeof L == "function") return 1;
              if (L !== void 0) return L.length;
            }
            return 0;
          }
          function d(x, B) {
            for (var L = new Array(B), $ = 0; $ < B; ++$) L[$] = x[$];
            return L;
          }
          function S(x, B, L, $) {
            if (typeof x.on == "function") $.once ? x.once(B, L) : x.on(B, L);
            else {
              if (typeof x.addEventListener != "function") throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof x);
              x.addEventListener(B, function M(K) {
                $.once && x.removeEventListener(B, M), L(K);
              });
            }
          }
          Object.defineProperty(t, "defaultMaxListeners", { enumerable: !0, get: function() {
            return e;
          }, set: function(x) {
            if (typeof x != "number" || x < 0 || T(x)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + x + ".");
            e = x;
          } }), t.init = function() {
            this._events !== void 0 && this._events !== Object.getPrototypeOf(this)._events || (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
          }, t.prototype.setMaxListeners = function(x) {
            if (typeof x != "number" || x < 0 || T(x)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + x + ".");
            return this._maxListeners = x, this;
          }, t.prototype.getMaxListeners = function() {
            return m(this);
          }, t.prototype.emit = function(x) {
            for (var B = [], L = 1; L < arguments.length; L++) B.push(arguments[L]);
            var $ = x === "error", M = this._events;
            if (M !== void 0) $ = $ && M.error === void 0;
            else if (!$) return !1;
            if ($) {
              var K;
              if (B.length > 0 && (K = B[0]), K instanceof Error) throw K;
              var ae = new Error("Unhandled error." + (K ? " (" + K.message + ")" : ""));
              throw ae.context = K, ae;
            }
            var j = M[x];
            if (j === void 0) return !1;
            if (typeof j == "function") ie(j, this, B);
            else {
              var ee = j.length, ue = d(j, ee);
              for (L = 0; L < ee; ++L) ie(ue[L], this, B);
            }
            return !0;
          }, t.prototype.addListener = function(x, B) {
            return o(this, x, B, !1);
          }, t.prototype.on = t.prototype.addListener, t.prototype.prependListener = function(x, B) {
            return o(this, x, B, !0);
          }, t.prototype.once = function(x, B) {
            return p(B), this.on(x, h(this, x, B)), this;
          }, t.prototype.prependOnceListener = function(x, B) {
            return p(B), this.prependListener(x, h(this, x, B)), this;
          }, t.prototype.removeListener = function(x, B) {
            var L, $, M, K, ae;
            if (p(B), ($ = this._events) === void 0) return this;
            if ((L = $[x]) === void 0) return this;
            if (L === B || L.listener === B) --this._eventsCount == 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete $[x], $.removeListener && this.emit("removeListener", x, L.listener || B));
            else if (typeof L != "function") {
              for (M = -1, K = L.length - 1; K >= 0; K--) if (L[K] === B || L[K].listener === B) {
                ae = L[K].listener, M = K;
                break;
              }
              if (M < 0) return this;
              M === 0 ? L.shift() : function(j, ee) {
                for (; ee + 1 < j.length; ee++) j[ee] = j[ee + 1];
                j.pop();
              }(L, M), L.length === 1 && ($[x] = L[0]), $.removeListener !== void 0 && this.emit("removeListener", x, ae || B);
            }
            return this;
          }, t.prototype.off = t.prototype.removeListener, t.prototype.removeAllListeners = function(x) {
            var B, L, $;
            if ((L = this._events) === void 0) return this;
            if (L.removeListener === void 0) return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : L[x] !== void 0 && (--this._eventsCount == 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete L[x]), this;
            if (arguments.length === 0) {
              var M, K = Object.keys(L);
              for ($ = 0; $ < K.length; ++$) (M = K[$]) !== "removeListener" && this.removeAllListeners(M);
              return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
            }
            if (typeof (B = L[x]) == "function") this.removeListener(x, B);
            else if (B !== void 0) for ($ = B.length - 1; $ >= 0; $--) this.removeListener(x, B[$]);
            return this;
          }, t.prototype.listeners = function(x) {
            return n(this, x, !0);
          }, t.prototype.rawListeners = function(x) {
            return n(this, x, !1);
          }, t.listenerCount = function(x, B) {
            return typeof x.listenerCount == "function" ? x.listenerCount(B) : c.call(x, B);
          }, t.prototype.listenerCount = c, t.prototype.eventNames = function() {
            return this._eventsCount > 0 ? Ee(this._events) : [];
          };
        }, 3101: function(Pe) {
          var Ee = Array.isArray, C = Object.keys, ie = Object.prototype.hasOwnProperty;
          Pe.exports = function T(t, e) {
            if (t === e) return !0;
            if (t && e && typeof t == "object" && typeof e == "object") {
              var p, m, o, E = Ee(t), h = Ee(e);
              if (E && h) {
                if ((m = t.length) != e.length) return !1;
                for (p = m; p-- != 0; ) if (!T(t[p], e[p])) return !1;
                return !0;
              }
              if (E != h) return !1;
              var n = t instanceof Date, c = e instanceof Date;
              if (n != c) return !1;
              if (n && c) return t.getTime() == e.getTime();
              var d = t instanceof RegExp, S = e instanceof RegExp;
              if (d != S) return !1;
              if (d && S) return t.toString() == e.toString();
              var x = C(t);
              if ((m = x.length) !== C(e).length) return !1;
              for (p = m; p-- != 0; ) if (!ie.call(e, x[p])) return !1;
              for (p = m; p-- != 0; ) if (!T(t[o = x[p]], e[o])) return !1;
              return !0;
            }
            return t != t && e != e;
          };
        }, 3362: function(Pe, Ee, C) {
          (function(ie, T, t, e, p) {
            function m(u) {
              if ("contents" in u) for (var v = ("styleAttrs" in u) ? u.styleAttrs[e.byName.ruby.qname] : null, b = u.kind === "span" && (v === "container" || v === "textContainer" || v === "baseContainer"), W = u.contents.length - 1; W >= 0; W--) !b || "styleAttrs" in u.contents[W] && e.byName.ruby.qname in u.contents[W].styleAttrs ? m(u.contents[W]) : delete u.contents[W];
            }
            function o(u, v, b, W) {
              var Y = W && W.timeContainer === "seq", Re = 0;
              W && (Re = Y && b ? b.end : W.begin), v.begin = v.explicit_begin ? v.explicit_begin + Re : Re;
              var Je = v.begin, Ze = null;
              if ("sets" in v) for (var Fe = 0; Fe < v.sets.length; Fe++) o(u, v.sets[Fe], Ze, v), Je = v.timeContainer === "seq" ? v.sets[Fe].end : Math.max(Je, v.sets[Fe].end), Ze = v.sets[Fe];
              if ("contents" in v) {
                if ("contents" in v) for (var we = 0; we < v.contents.length; we++) o(u, v.contents[we], Ze, v), Je = v.timeContainer === "seq" ? v.contents[we].end : Math.max(Je, v.contents[we].end), Ze = v.contents[we];
              } else Je = Y ? v.begin : Number.POSITIVE_INFINITY;
              v.explicit_end !== null && v.explicit_dur !== null ? v.end = Math.min(v.begin + v.explicit_dur, Re + v.explicit_end) : v.explicit_end === null && v.explicit_dur !== null ? v.end = v.begin + v.explicit_dur : v.explicit_end !== null && v.explicit_dur === null ? v.end = Re + v.explicit_end : v.end = Je, delete v.explicit_begin, delete v.explicit_dur, delete v.explicit_end, u._registerEvent(v);
            }
            function E(u) {
              this.node = u;
            }
            function h() {
              this.events = [], this.head = new n(), this.body = null;
            }
            function n() {
              this.styling = new c(), this.layout = new x();
            }
            function c() {
              this.styles = {}, this.initials = {};
            }
            function d() {
              this.id = null, this.styleAttrs = null, this.styleRefs = null;
            }
            function S() {
              this.styleAttrs = null;
            }
            function x() {
              this.regions = {};
            }
            function B(u, v) {
              L.call(this, "image"), this.src = u, this.type = v;
            }
            function L(u) {
              this.kind = u;
            }
            function $(u) {
              this.id = u;
            }
            function M(u) {
              this.regionID = u;
            }
            function K(u) {
              this.styleAttrs = u;
            }
            function ae(u) {
              this.sets = u;
            }
            function j(u) {
              this.contents = u;
            }
            function ee(u, v, b) {
              this.explicit_begin = u, this.explicit_end = v, this.explicit_dur = b;
            }
            function ue() {
              L.call(this, "body");
            }
            function Ae() {
              L.call(this, "div");
            }
            function Q() {
              L.call(this, "p");
            }
            function Ne() {
              L.call(this, "span");
            }
            function Ue() {
              L.call(this, "span");
            }
            function ze() {
              L.call(this, "br");
            }
            function Te() {
            }
            function Oe() {
            }
            function We(u) {
              return u && "xml:id" in u.attributes && u.attributes["xml:id"].value || null;
            }
            function at(u) {
              return u && "style" in u.attributes ? u.attributes.style.value.split(" ") : [];
            }
            function Se(u, v) {
              var b = {};
              if (u !== null) for (var W in u.attributes) {
                var Y = u.attributes[W].uri + " " + u.attributes[W].local, Re = e.byQName[Y];
                if (Re !== void 0) {
                  var Je = Re.parse(u.attributes[W].value);
                  Je !== null ? (b[Y] = Je, Re === e.byName.zIndex && me(v, "zIndex attribute present but not used by IMSC1 since regions do not overlap")) : ye(v, "Cannot parse styling attribute " + Y + " --> " + u.attributes[W].value);
                }
              }
              return b;
            }
            function ke(u, v, b) {
              for (var W in u.attributes) if (u.attributes[W].uri === v && u.attributes[W].local === b) return u.attributes[W].value;
              return null;
            }
            function Rt(u, v, b) {
              var W, Y = null;
              return (W = /^(\d+(?:\.\d+)?)f$/.exec(b)) !== null ? v !== null && (Y = parseFloat(W[1]) / v) : (W = /^(\d+(?:\.\d+)?)t$/.exec(b)) !== null ? u !== null && (Y = parseFloat(W[1]) / u) : (W = /^(\d+(?:\.\d+)?)ms$/.exec(b)) !== null ? Y = parseFloat(W[1]) / 1e3 : (W = /^(\d+(?:\.\d+)?)s$/.exec(b)) !== null ? Y = parseFloat(W[1]) : (W = /^(\d+(?:\.\d+)?)h$/.exec(b)) !== null ? Y = 3600 * parseFloat(W[1]) : (W = /^(\d+(?:\.\d+)?)m$/.exec(b)) !== null ? Y = 60 * parseFloat(W[1]) : (W = /^(\d{2,}):(\d\d):(\d\d(?:\.\d+)?)$/.exec(b)) !== null ? Y = 3600 * parseInt(W[1]) + 60 * parseInt(W[2]) + parseFloat(W[3]) : (W = /^(\d{2,}):(\d\d):(\d\d)\:(\d{2,})$/.exec(b)) !== null && v !== null && (Y = 3600 * parseInt(W[1]) + 60 * parseInt(W[2]) + parseInt(W[3]) + (W[4] === null ? 0 : parseInt(W[4]) / v)), Y;
            }
            function _t(u, v, b) {
              for (; v.styleRefs.length > 0; ) {
                var W = v.styleRefs.pop();
                W in u.styles ? (_t(u, u.styles[W], b), it(u.styles[W].styleAttrs, v.styleAttrs)) : ye(b, "Non-existant style id referenced");
              }
            }
            function qe(u, v, b, W) {
              for (var Y = v.length - 1; Y >= 0; Y--) {
                var Re = v[Y];
                Re in u.styles ? it(u.styles[Re].styleAttrs, b) : ye(W, "Non-existant style id referenced");
              }
            }
            function it(u, v) {
              for (var b in u) u.hasOwnProperty(b) && (b in v || (v[b] = u[b]));
            }
            function me(u, v) {
              if (u && u.warn && u.warn(v)) throw v;
            }
            function ye(u, v) {
              if (u && u.error && u.error(v)) throw v;
            }
            function Ve(u, v) {
              throw u && u.fatal && u.fatal(v), v;
            }
            function f(u, v) {
              for (var b, W = 0, Y = u.length - 1; W <= Y; ) {
                var Re = u[b = Math.floor((W + Y) / 2)];
                if (Re < v) W = b + 1;
                else {
                  if (!(Re > v)) return { found: !0, index: b };
                  Y = b - 1;
                }
              }
              return { found: !1, index: W };
            }
            ie.fromXML = function(u, v, b) {
              var W = T.parser(!0, { xmlns: !0 }), Y = [], Re = [], Je = [], Ze = 0, Fe = null;
              W.onclosetag = function(ft) {
                if (Y[0] instanceof Te) Fe.head !== null && Fe.head.styling !== null && qe(Fe.head.styling, Y[0].styleRefs, Y[0].styleAttrs, v), delete Y[0].styleRefs;
                else if (Y[0] instanceof c) for (var Yt in Y[0].styles) Y[0].styles.hasOwnProperty(Yt) && _t(Y[0], Y[0].styles[Yt], v);
                else if (Y[0] instanceof Q || Y[0] instanceof Ne) {
                  if (Y[0].contents.length > 1) {
                    var Ot, qt = [Y[0].contents[0]];
                    for (Ot = 1; Ot < Y[0].contents.length; Ot++) Y[0].contents[Ot] instanceof Ue && qt[qt.length - 1] instanceof Ue ? qt[qt.length - 1].text += Y[0].contents[Ot].text : qt.push(Y[0].contents[Ot]);
                    Y[0].contents = qt;
                  }
                  Y[0] instanceof Ne && Y[0].contents.length === 1 && Y[0].contents[0] instanceof Ue && (Y[0].text = Y[0].contents[0].text, delete Y[0].contents);
                } else Y[0] instanceof E && (Y[0].node.uri === t.ns_tt && Y[0].node.local === "metadata" ? Ze-- : Ze > 0 && b && "onCloseTag" in b && b.onCloseTag());
                Je.shift(), Re.shift(), Y.shift();
              }, W.ontext = function(ft) {
                if (Y[0] !== void 0) if (Y[0] instanceof Ne || Y[0] instanceof Q) {
                  if (Y[0] instanceof Ne) {
                    var Yt = Y[0].styleAttrs[e.byName.ruby.qname];
                    if (Yt === "container" || Yt === "textContainer" || Yt === "baseContainer") return;
                  }
                  var Ot = new Ue();
                  Ot.initFromText(Fe, Y[0], ft, Re[0], Je[0], v), Y[0].contents.push(Ot);
                } else Y[0] instanceof E && Ze > 0 && b && "onText" in b && b.onText(ft);
              }, W.onopentag = function(ft) {
                var Yt = ft.attributes["xml:space"];
                Yt ? Je.unshift(Yt.value) : Je.length === 0 ? Je.unshift("default") : Je.unshift(Je[0]);
                var Ot = ft.attributes["xml:lang"];
                if (Ot ? Re.unshift(Ot.value) : Re.length === 0 ? Re.unshift("") : Re.unshift(Re[0]), ft.uri === t.ns_tt) if (ft.local === "tt") Fe !== null && Ve(v, "Two <tt> elements at (" + this.line + "," + this.column + ")"), (Fe = new h()).initFromNode(ft, Re[0], v), Y.unshift(Fe);
                else if (ft.local === "head") Y[0] instanceof h || Ve(v, "Parent of <head> element is not <tt> at (" + this.line + "," + this.column + ")"), Y.unshift(Fe.head);
                else if (ft.local === "styling") Y[0] instanceof n || Ve(v, "Parent of <styling> element is not <head> at (" + this.line + "," + this.column + ")"), Y.unshift(Fe.head.styling);
                else if (ft.local === "style") {
                  var qt;
                  Y[0] instanceof c ? ((qt = new d()).initFromNode(ft, v), qt.id ? Fe.head.styling.styles[qt.id] = qt : ye(v, "<style> element missing @id attribute"), Y.unshift(qt)) : Y[0] instanceof Te ? ((qt = new d()).initFromNode(ft, v), it(qt.styleAttrs, Y[0].styleAttrs), Y.unshift(qt)) : Ve(v, "Parent of <style> element is not <styling> or <region> at (" + this.line + "," + this.column + ")");
                } else if (ft.local === "initial") {
                  var Bt;
                  if (Y[0] instanceof c) {
                    for (var cn in (Bt = new S()).initFromNode(ft, v), Bt.styleAttrs) Bt.styleAttrs.hasOwnProperty(cn) && (Fe.head.styling.initials[cn] = Bt.styleAttrs[cn]);
                    Y.unshift(Bt);
                  } else Ve(v, "Parent of <initial> element is not <styling> at (" + this.line + "," + this.column + ")");
                } else if (ft.local === "layout") Y[0] instanceof n || Ve(v, "Parent of <layout> element is not <head> at " + this.line + "," + this.column + ")"), Y.unshift(Fe.head.layout);
                else if (ft.local === "region") {
                  Y[0] instanceof x || Ve(v, "Parent of <region> element is not <layout> at " + this.line + "," + this.column + ")");
                  var vn = new Te();
                  vn.initFromNode(Fe, ft, Re[0], v), !vn.id || vn.id in Fe.head.layout.regions ? ye(v, "Ignoring <region> with duplicate or missing @id at " + this.line + "," + this.column + ")") : Fe.head.layout.regions[vn.id] = vn, Y.unshift(vn);
                } else if (ft.local === "body") {
                  Y[0] instanceof h || Ve(v, "Parent of <body> element is not <tt> at " + this.line + "," + this.column + ")"), Fe.body !== null && Ve(v, "Second <body> element at " + this.line + "," + this.column + ")");
                  var Pn = new ue();
                  Pn.initFromNode(Fe, ft, Re[0], v), Fe.body = Pn, Y.unshift(Pn);
                } else if (ft.local === "div") {
                  Y[0] instanceof Ae || Y[0] instanceof ue || Ve(v, "Parent of <div> element is not <body> or <div> at " + this.line + "," + this.column + ")");
                  var Dn = new Ae();
                  Dn.initFromNode(Fe, Y[0], ft, Re[0], v);
                  var xn = Dn.styleAttrs[e.byName.backgroundImage.qname];
                  xn && (Dn.contents.push(new B(xn)), delete Dn.styleAttrs[e.byName.backgroundImage.qname]), Y[0].contents.push(Dn), Y.unshift(Dn);
                } else if (ft.local === "image") {
                  Y[0] instanceof Ae || Ve(v, "Parent of <image> element is not <div> at " + this.line + "," + this.column + ")");
                  var er = new B();
                  er.initFromNode(Fe, Y[0], ft, Re[0], v), Y[0].contents.push(er), Y.unshift(er);
                } else if (ft.local === "p") {
                  Y[0] instanceof Ae || Ve(v, "Parent of <p> element is not <div> at " + this.line + "," + this.column + ")");
                  var In = new Q();
                  In.initFromNode(Fe, Y[0], ft, Re[0], v), Y[0].contents.push(In), Y.unshift(In);
                } else if (ft.local === "span") {
                  Y[0] instanceof Ne || Y[0] instanceof Q || Ve(v, "Parent of <span> element is not <span> or <p> at " + this.line + "," + this.column + ")");
                  var cr = new Ne();
                  cr.initFromNode(Fe, Y[0], ft, Re[0], Je[0], v), Y[0].contents.push(cr), Y.unshift(cr);
                } else if (ft.local === "br") {
                  Y[0] instanceof Ne || Y[0] instanceof Q || Ve(v, "Parent of <br> element is not <span> or <p> at " + this.line + "," + this.column + ")");
                  var Yn = new ze();
                  Yn.initFromNode(Fe, Y[0], ft, Re[0], v), Y[0].contents.push(Yn), Y.unshift(Yn);
                } else if (ft.local === "set") {
                  Y[0] instanceof Ne || Y[0] instanceof Q || Y[0] instanceof Ae || Y[0] instanceof ue || Y[0] instanceof Te || Y[0] instanceof ze || Ve(v, "Parent of <set> element is not a content element or a region at " + this.line + "," + this.column + ")");
                  var ir = new Oe();
                  ir.initFromNode(Fe, Y[0], ft, v), Y[0].sets.push(ir), Y.unshift(ir);
                } else Y.unshift(new E(ft));
                else Y.unshift(new E(ft));
                if (Y[0] instanceof E) {
                  if (ft.uri === t.ns_tt && ft.local === "metadata") Ze++;
                  else if (Ze > 0 && b && "onOpenTag" in b) {
                    var mr = [];
                    for (var ar in ft.attributes) mr[ft.attributes[ar].uri + " " + ft.attributes[ar].local] = { uri: ft.attributes[ar].uri, local: ft.attributes[ar].local, value: ft.attributes[ar].value };
                    b.onOpenTag(ft.uri, ft.local, mr);
                  }
                }
              }, W.write(u).close(), delete Fe.head.styling.styles;
              var we = !1;
              for (var Ge in Fe.head.layout.regions) if (Fe.head.layout.regions.hasOwnProperty(Ge)) {
                we = !0;
                break;
              }
              if (!we) {
                var nt = Te.prototype.createDefaultRegion(Fe.lang);
                Fe.head.layout.regions[nt.id] = nt;
              }
              for (var Tt in Fe.head.layout.regions) Fe.head.layout.regions.hasOwnProperty(Tt) && o(Fe, Fe.head.layout.regions[Tt], null, null);
              return Fe.body && o(Fe, Fe.body, null, null), Fe.body && m(Fe.body), Fe;
            }, h.prototype.initFromNode = function(u, v, b) {
              var W = function(Ze, Fe) {
                var we = ke(Ze, t.ns_ttp, "cellResolution"), Ge = 15, nt = 32;
                if (we !== null) {
                  var Tt = /(\d+) (\d+)/.exec(we);
                  Tt !== null ? (nt = parseInt(Tt[1]), Ge = parseInt(Tt[2])) : me(Fe, "Malformed cellResolution value (using initial value instead)");
                }
                return { w: nt, h: Ge };
              }(u, b);
              this.cellLength = { h: new p.ComputedLength(0, 1 / W.h), w: new p.ComputedLength(1 / W.w, 0) };
              var Y = function(Ze, Fe) {
                var we, Ge = ke(Ze, t.ns_ttp, "frameRate"), nt = 30;
                Ge !== null && ((we = /(\d+)/.exec(Ge)) !== null ? nt = parseInt(we[1]) : me(Fe, "Malformed frame rate attribute (using initial value instead)"));
                var Tt = ke(Ze, t.ns_ttp, "frameRateMultiplier"), ft = 1;
                Tt !== null && ((we = /(\d+) (\d+)/.exec(Tt)) !== null ? ft = parseInt(we[1]) / parseInt(we[2]) : me(Fe, "Malformed frame rate multiplier attribute (using initial value instead)"));
                var Yt = ft * nt, Ot = 1, qt = ke(Ze, t.ns_ttp, "tickRate");
                return qt === null ? Ge !== null && (Ot = Yt) : (we = /(\d+)/.exec(qt)) !== null ? Ot = parseInt(we[1]) : me(Fe, "Malformed tick rate attribute (using initial value instead)"), { effectiveFrameRate: Yt, tickRate: Ot };
              }(u, b);
              this.effectiveFrameRate = Y.effectiveFrameRate, this.tickRate = Y.tickRate, this.aspectRatio = function(Ze, Fe) {
                var we = ke(Ze, t.ns_ittp, "aspectRatio");
                we === null && (we = ke(Ze, t.ns_ttp, "displayAspectRatio"));
                var Ge = null;
                if (we !== null) {
                  var nt = /(\d+)\s+(\d+)/.exec(we);
                  if (nt !== null) {
                    var Tt = parseInt(nt[1]), ft = parseInt(nt[2]);
                    Tt !== 0 && ft !== 0 ? Ge = Tt / ft : ye(Fe, "Illegal aspectRatio values (ignoring)");
                  } else ye(Fe, "Malformed aspectRatio attribute (ignoring)");
                }
                return Ge;
              }(u, b);
              var Re = ke(u, t.ns_ttp, "timeBase");
              Re !== null && Re !== "media" && Ve(b, "Unsupported time base");
              var Je = function(Ze, Fe) {
                var we = ke(Ze, t.ns_tts, "extent");
                if (we === null) return null;
                var Ge = we.split(" ");
                if (Ge.length !== 2) return me(Fe, "Malformed extent (ignoring)"), null;
                var nt = p.parseLength(Ge[0]), Tt = p.parseLength(Ge[1]);
                return Tt && nt ? { h: Tt, w: nt } : (me(Fe, "Malformed extent values (ignoring)"), null);
              }(u, b);
              Je === null ? this.pxLength = { h: null, w: null } : (Je.h.unit === "px" && Je.w.unit === "px" || Ve(b, "Extent on TT must be in px or absent"), this.pxLength = { h: new p.ComputedLength(0, 1 / Je.h.value), w: new p.ComputedLength(1 / Je.w.value, 0) }), this.dimensions = { h: new p.ComputedLength(0, 1), w: new p.ComputedLength(1, 0) }, this.lang = v;
            }, h.prototype._registerEvent = function(u) {
              if (!(u.end <= u.begin)) {
                var v = f(this.events, u.begin);
                if (v.found || this.events.splice(v.index, 0, u.begin), u.end !== Number.POSITIVE_INFINITY) {
                  var b = f(this.events, u.end);
                  b.found || this.events.splice(b.index, 0, u.end);
                }
              }
            }, h.prototype.getMediaTimeRange = function() {
              return [this.events[0], this.events[this.events.length - 1]];
            }, h.prototype.getMediaTimeEvents = function() {
              return this.events;
            }, d.prototype.initFromNode = function(u, v) {
              this.id = We(u), this.styleAttrs = Se(u, v), this.styleRefs = at(u);
            }, S.prototype.initFromNode = function(u, v) {
              for (var b in this.styleAttrs = {}, u.attributes) if (u.attributes[b].uri === t.ns_itts || u.attributes[b].uri === t.ns_ebutts || u.attributes[b].uri === t.ns_tts) {
                var W = u.attributes[b].uri + " " + u.attributes[b].local;
                this.styleAttrs[W] = u.attributes[b].value;
              }
            }, B.prototype.initFromNode = function(u, v, b, W, Y) {
              this.src = "src" in b.attributes ? b.attributes.src.value : null, this.src || ye(Y, "Invalid image@src attribute"), this.type = "type" in b.attributes ? b.attributes.type.value : null, this.type || ye(Y, "Invalid image@type attribute"), K.prototype.initFromNode.call(this, u, v, b, Y), ee.prototype.initFromNode.call(this, u, v, b, Y), ae.prototype.initFromNode.call(this, u, v, b, Y), M.prototype.initFromNode.call(this, u, v, b, Y), this.lang = W;
            }, $.prototype.initFromNode = function(u, v, b, W) {
              this.id = We(b);
            }, M.prototype.initFromNode = function(u, v, b, W) {
              this.regionID = function(Y) {
                return Y && "region" in Y.attributes ? Y.attributes.region.value : "";
              }(b);
            }, K.prototype.initFromNode = function(u, v, b, W) {
              this.styleAttrs = Se(b, W), u.head !== null && u.head.styling !== null && qe(u.head.styling, at(b), this.styleAttrs, W);
            }, ae.prototype.initFromNode = function(u, v, b, W) {
              this.sets = [];
            }, j.prototype.initFromNode = function(u, v, b, W) {
              this.contents = [];
            }, ee.prototype.initFromNode = function(u, v, b, W) {
              var Y = function(Re, Je, Ze, Fe) {
                var we = null;
                Ze && "begin" in Ze.attributes && (we = Rt(Re.tickRate, Re.effectiveFrameRate, Ze.attributes.begin.value)) === null && me(Fe, "Malformed begin value " + Ze.attributes.begin.value + " (using 0)");
                var Ge = null;
                Ze && "dur" in Ze.attributes && (Ge = Rt(Re.tickRate, Re.effectiveFrameRate, Ze.attributes.dur.value)) === null && me(Fe, "Malformed dur value " + Ze.attributes.dur.value + " (ignoring)");
                var nt = null;
                return Ze && "end" in Ze.attributes && (nt = Rt(Re.tickRate, Re.effectiveFrameRate, Ze.attributes.end.value)) === null && me(Fe, "Malformed end value (ignoring)"), { explicit_begin: we, explicit_end: nt, explicit_dur: Ge };
              }(u, 0, b, W);
              this.explicit_begin = Y.explicit_begin, this.explicit_end = Y.explicit_end, this.explicit_dur = Y.explicit_dur, this.timeContainer = function(Re, Je) {
                var Ze = Re && "timeContainer" in Re.attributes ? Re.attributes.timeContainer.value : null;
                return Ze && Ze !== "par" ? Ze === "seq" ? "seq" : (ye(Je, "Illegal value of timeContainer (assuming 'par')"), "par") : "par";
              }(b, W);
            }, ue.prototype.initFromNode = function(u, v, b, W) {
              K.prototype.initFromNode.call(this, u, null, v, W), ee.prototype.initFromNode.call(this, u, null, v, W), ae.prototype.initFromNode.call(this, u, null, v, W), M.prototype.initFromNode.call(this, u, null, v, W), j.prototype.initFromNode.call(this, u, null, v, W), this.lang = b;
            }, Ae.prototype.initFromNode = function(u, v, b, W, Y) {
              K.prototype.initFromNode.call(this, u, v, b, Y), ee.prototype.initFromNode.call(this, u, v, b, Y), ae.prototype.initFromNode.call(this, u, v, b, Y), M.prototype.initFromNode.call(this, u, v, b, Y), j.prototype.initFromNode.call(this, u, v, b, Y), this.lang = W;
            }, Q.prototype.initFromNode = function(u, v, b, W, Y) {
              K.prototype.initFromNode.call(this, u, v, b, Y), ee.prototype.initFromNode.call(this, u, v, b, Y), ae.prototype.initFromNode.call(this, u, v, b, Y), M.prototype.initFromNode.call(this, u, v, b, Y), j.prototype.initFromNode.call(this, u, v, b, Y), this.lang = W;
            }, Ne.prototype.initFromNode = function(u, v, b, W, Y, Re) {
              K.prototype.initFromNode.call(this, u, v, b, Re), ee.prototype.initFromNode.call(this, u, v, b, Re), ae.prototype.initFromNode.call(this, u, v, b, Re), M.prototype.initFromNode.call(this, u, v, b, Re), j.prototype.initFromNode.call(this, u, v, b, Re), this.space = Y, this.lang = W;
            }, Ue.prototype.initFromText = function(u, v, b, W, Y, Re) {
              ee.prototype.initFromNode.call(this, u, v, null, Re), this.text = b, this.space = Y, this.lang = W;
            }, ze.prototype.initFromNode = function(u, v, b, W, Y) {
              M.prototype.initFromNode.call(this, u, v, b, Y), ee.prototype.initFromNode.call(this, u, v, b, Y), this.lang = W;
            }, Te.prototype.createDefaultRegion = function(u) {
              var v = new Te();
              return $.call(v, ""), K.call(v, {}), ae.call(v, []), ee.call(v, 0, Number.POSITIVE_INFINITY, null), this.lang = u, v;
            }, Te.prototype.initFromNode = function(u, v, b, W) {
              $.prototype.initFromNode.call(this, u, null, v, W), ee.prototype.initFromNode.call(this, u, null, v, W), ae.prototype.initFromNode.call(this, u, null, v, W), this.styleAttrs = Se(v, W), this.styleRefs = at(v), this.lang = b;
            }, Oe.prototype.initFromNode = function(u, v, b, W) {
              ee.prototype.initFromNode.call(this, u, v, b, W);
              var Y = Se(b, W);
              for (var Re in this.qname = null, this.value = null, Y) if (Y.hasOwnProperty(Re)) {
                if (this.qname) {
                  ye(W, "More than one style specified on set");
                  break;
                }
                this.qname = Re, this.value = Y[Re];
              }
            };
          })(Ee, typeof sax > "u" ? C(5378) : sax, typeof imscNames > "u" ? C(210) : imscNames, typeof imscStyles > "u" ? C(6811) : imscStyles, typeof imscUtils > "u" ? C(5926) : imscUtils);
        }, 506: function(Pe, Ee, C) {
          var ie = /firefox/i.test(navigator.userAgent);
          (function(T, t, e) {
            function p(j, ee, ue, Ae) {
              var Q;
              if (ue.kind === "region") (Q = document.createElement("div")).style.position = "absolute";
              else if (ue.kind === "body") Q = document.createElement("div");
              else if (ue.kind === "div") Q = document.createElement("div");
              else if (ue.kind === "image") {
                if (Q = document.createElement("img"), j.imgResolver !== null && ue.src !== null) {
                  var Ne = j.imgResolver(ue.src, Q);
                  Ne && (Q.src = Ne), Q.height = j.regionH, Q.width = j.regionW;
                }
              } else if (ue.kind === "p") Q = document.createElement("p");
              else if (ue.kind === "span") if (ue.styleAttrs[e.byName.ruby.qname] === "container") Q = document.createElement("ruby"), j.ruby = !0;
              else if (ue.styleAttrs[e.byName.ruby.qname] === "base") Q = document.createElement("span");
              else if (ue.styleAttrs[e.byName.ruby.qname] === "text") Q = document.createElement("rt");
              else if (ue.styleAttrs[e.byName.ruby.qname] === "baseContainer") Q = document.createElement("rbc");
              else if (ue.styleAttrs[e.byName.ruby.qname] === "textContainer") Q = document.createElement("rtc");
              else {
                if (ue.styleAttrs[e.byName.ruby.qname] === "delimiter") return;
                Q = document.createElement("span");
              }
              else ue.kind === "br" && (Q = document.createElement("br"));
              if (Q) {
                if (ue.lang && (ue.kind !== "region" && ue.lang === Ae.lang || (Q.lang = ue.lang)), ee.appendChild(Q), Q.style.margin = "0", ue.kind === "region") {
                  var Ue = ue.styleAttrs[e.byName.writingMode.qname];
                  Ue === "lrtb" || Ue === "lr" ? (j.ipd = "lr", j.bpd = "tb") : Ue === "rltb" || Ue === "rl" ? (j.ipd = "rl", j.bpd = "tb") : Ue === "tblr" ? (j.ipd = "tb", j.bpd = "lr") : Ue !== "tbrl" && Ue !== "tb" || (j.ipd = "tb", j.bpd = "rl");
                } else if (ue.kind === "p" && j.bpd === "tb") {
                  var ze = ue.styleAttrs[e.byName.direction.qname];
                  j.ipd = ze === "ltr" ? "lr" : "rl";
                }
                for (var Te = 0; Te < S.length; Te++) {
                  var Oe = S[Te], We = ue.styleAttrs[Oe.qname];
                  We !== void 0 && Oe.map !== null && Oe.map(j, Q, ue, We);
                }
                var at = Q, Se = ue.styleAttrs[e.byName.linePadding.qname];
                if (Se && !Se.isZero()) {
                  var ke = Se.toUsedLength(j.w, j.h);
                  if (ke > 0) {
                    var Rt = Math.ceil(ke) + "px";
                    j.bpd === "tb" ? (at.style.paddingLeft = Rt, at.style.paddingRight = Rt) : (at.style.paddingTop = Rt, at.style.paddingBottom = Rt), j.lp = Se;
                  }
                }
                var _t = ue.styleAttrs[e.byName.multiRowAlign.qname];
                if (_t && _t !== "auto") {
                  var qe = document.createElement("span");
                  qe.style.display = "inline-block", qe.style.textAlign = _t, Q.appendChild(qe), at = qe, j.mra = _t;
                }
                var it = ue.styleAttrs[e.byName.rubyReserve.qname];
                if (it && it[0] !== "none" && (j.rubyReserve = it), ue.styleAttrs[e.byName.fillLineGap.qname] && (j.flg = !0), ue.kind === "span" && ue.text) {
                  var me = ue.styleAttrs[e.byName.textEmphasis.qname];
                  if (me && me.style !== "none" && (j.textEmphasis = !0), e.byName.textCombine.qname in ue.styleAttrs && ue.styleAttrs[e.byName.textCombine.qname] === "all") Q.textContent = ue.text, Q._isd_element = ue, me && c(j, Q, 0, me);
                  else for (var ye = "", Ve = 0; Ve < ue.text.length; Ve++) {
                    ye += ue.text.charAt(Ve);
                    var f = ue.text.charCodeAt(Ve);
                    if (f < 55296 || f > 56319 || Ve === ue.text.length - 1) {
                      var u = document.createElement("span");
                      u.textContent = ye, me && c(j, u, 0, me), Q.appendChild(u), ye = "", u._isd_element = ue;
                    }
                  }
                }
                if ("contents" in ue) for (var v = 0; v < ue.contents.length; v++) p(j, at, ue.contents[v], ue);
                var b = [];
                if (ue.kind === "p" && (n(j, at, b, null), j.rubyReserve && (function(Ze, Fe) {
                  for (var we = 0; we < Ze.length; we++) {
                    var Ge, nt, Tt = document.createElement("ruby"), ft = document.createElement("span");
                    ft.textContent = "​", Tt.appendChild(ft);
                    var Yt, Ot = Fe.rubyReserve[1].toUsedLength(Fe.w, Fe.h) + "px";
                    Fe.rubyReserve[0] === "both" || Fe.rubyReserve[0] === "outside" && Ze.length == 1 ? ((Ge = document.createElement("rtc")).style[$] = L ? "after" : "under", Ge.textContent = "​", Ge.style.fontSize = Ot, (nt = document.createElement("rtc")).style[$] = L ? "before" : "over", nt.textContent = "​", nt.style.fontSize = Ot, Tt.appendChild(Ge), Tt.appendChild(nt)) : ((Ge = document.createElement("rtc")).textContent = "​", Ge.style.fontSize = Ot, Yt = Fe.rubyReserve[0] === "after" || Fe.rubyReserve[0] === "outside" && we > 0 ? L ? "after" : Fe.bpd === "tb" || Fe.bpd === "rl" ? "under" : "over" : L ? "before" : Fe.bpd === "tb" || Fe.bpd === "rl" ? "over" : "under", Ge.style[$] = Yt, Tt.appendChild(Ge));
                    for (var qt = null, Bt = 0; Bt < Ze[we].rbc.length; Bt++) if (Ze[we].rbc[Bt].localName === "ruby") {
                      qt = Ze[we].rbc[Bt];
                      for (var cn = 0; cn < qt.style.length; cn++) Tt.style.setProperty(qt.style.item(cn), qt.style.getPropertyValue(qt.style.item(cn)));
                      break;
                    }
                    (qt = qt || Ze[we].elements[0].node).parentElement.insertBefore(Tt, qt);
                  }
                }(b, j), j.rubyReserve = null), (j.ruby || j.rubyReserve) && (function(Ze, Fe) {
                  for (var we = 0; we < Ze.length; we++) for (var Ge = 0; Ge < Ze[we].rbc.length; Ge++) {
                    var nt;
                    Ze[we].rbc[Ge].style[$] || (nt = L ? we === 0 ? "before" : "after" : Fe.bpd === "tb" || Fe.bpd === "rl" ? we === 0 ? "over" : "under" : we === 0 ? "under" : "over", Ze[we].rbc[Ge].style[$] = nt);
                  }
                }(b, j), j.ruby = null), j.textEmphasis && (function(Ze, Fe) {
                  for (var we = 0; we < Ze.length; we++) for (var Ge = 0; Ge < Ze[we].te.length; Ge++) {
                    var nt;
                    Ze[we].te[Ge].style[K] && Ze[we].te[Ge].style[K] !== "none" || (nt = Fe.bpd === "tb" ? we === 0 ? "left over" : "left under" : Fe.bpd === "rl" ? we === 0 ? "right under" : "left under" : we === 0 ? "left under" : "right under", Ze[we].te[Ge].style[K] = nt);
                  }
                }(b, j), j.textEmphasis = null), j.mra && (function(Ze) {
                  for (var Fe = 0; Fe < Ze.length - 1; Fe++) {
                    var we = Ze[Fe].elements.length;
                    if (we !== 0 && Ze[Fe].br === !1) {
                      var Ge = document.createElement("br"), nt = Ze[Fe].elements[we - 1].node;
                      nt.parentElement.insertBefore(Ge, nt.nextSibling);
                    }
                  }
                }(b), j.mra = null), j.lp && (function(Ze, Fe, we) {
                  if (Ze !== null) for (var Ge = 0; Ge < Ze.length; Ge++) {
                    var nt = Ze[Ge].elements.length, Tt = Math.ceil(Fe) + "px", ft = "-" + Math.ceil(Fe) + "px";
                    if (nt !== 0) {
                      var Yt = Ze[Ge].elements[Ze[Ge].start_elem], Ot = Ze[Ge].elements[Ze[Ge].end_elem];
                      if (Yt === Ot) {
                        var qt = Yt.node.getBoundingClientRect();
                        if (qt.width == 0 || qt.height == 0) continue;
                      }
                      we.ipd === "lr" ? (Yt.node.style.marginLeft = ft, Yt.node.style.paddingLeft = Tt) : we.ipd === "rl" ? (Yt.node.style.paddingRight = Tt, Yt.node.style.marginRight = ft) : we.ipd === "tb" && (Yt.node.style.paddingTop = Tt, Yt.node.style.marginTop = ft), we.ipd === "lr" ? (ie || (Ot.node.style.marginRight = ft), Ot.node.style.paddingRight = Tt) : we.ipd === "rl" ? (Ot.node.style.paddingLeft = Tt, ie || (Ot.node.style.marginLeft = ft)) : we.ipd === "tb" && (Ot.node.style.paddingBottom = Tt, Ot.node.style.marginBottom = ft);
                    }
                  }
                }(b, j.lp.toUsedLength(j.w, j.h), j), j.lp = null), function(Ze, Fe) {
                  for (var we = 0; we < Ze.length; we++) for (var Ge = Ze[we], nt = 1; nt < Ge.elements.length; ) {
                    var Tt = Ge.elements[nt - 1], ft = Ge.elements[nt];
                    o(Tt.node, ft.node, Fe) ? Ge.elements.splice(nt, 1) : nt++;
                  }
                  for (var Yt, Ot, qt = [], Bt = 0; Bt < Ze.length; Bt++) for (var cn = 0; cn < Ze[Bt].elements.length; cn++) (Ot = m(Yt = Ze[Bt].elements[cn].node, qt, !1)) && (Yt.style.backgroundColor = Ot);
                  for (var vn = 0; vn < qt.length; vn++) qt[vn].style.backgroundColor = "";
                }(b, j), j.flg)) {
                  var W = h(at.getBoundingClientRect(), j);
                  (function(Ze, Fe, we, Ge, nt) {
                    for (var Tt = Math.sign(we - Fe), ft = 0; ft <= Ze.length; ft++) {
                      var Yt, Ot, qt, Bt;
                      if (Yt = ft === 0 ? Math.round(Fe) : ft === Ze.length ? Math.round(we) : Math.round((Ze[ft - 1].after + Ze[ft].before) / 2), ft > 0 && Ze[ft - 1]) for (qt = 0; qt < Ze[ft - 1].elements.length; qt++) Ot = Tt * (Yt - (Bt = Ze[ft - 1].elements[qt]).after) + "px", Ge.bpd === "lr" ? Bt.node.style.paddingRight = Ot : Ge.bpd === "rl" ? Bt.node.style.paddingLeft = Ot : Ge.bpd === "tb" && (Bt.node.style.paddingBottom = Ot);
                      if (ft < Ze.length) for (qt = 0; qt < Ze[ft].elements.length; qt++) Ot = Tt * ((Bt = Ze[ft].elements[qt]).before - Yt) + "px", Ge.bpd === "lr" ? Bt.node.style.paddingLeft = Ot : Ge.bpd === "rl" ? Bt.node.style.paddingRight = Ot : Ge.bpd === "tb" && (Bt.node.style.paddingTop = Ot);
                    }
                  })(b, W.before, W.after, j), j.flg = null;
                }
                if (ue.kind === "region" && j.bpd === "tb" && j.enableRollUp && ue.contents.length > 0 && ue.styleAttrs[e.byName.displayAlign.qname] === "after") {
                  n(j, at, b, null);
                  var Y = new E(ue.id === "" ? "_" : ue.id, b);
                  if (j.currentISDState[Y.id] = Y, j.previousISDState && Y.id in j.previousISDState && j.previousISDState[Y.id].plist.length > 0 && Y.plist.length > 1 && Y.plist[Y.plist.length - 2].text === j.previousISDState[Y.id].plist[j.previousISDState[Y.id].plist.length - 1].text) {
                    var Re = Q.firstElementChild, Je = Y.plist[Y.plist.length - 1].after - Y.plist[Y.plist.length - 1].before;
                    Re.style.bottom = "-" + Je + "px", Re.style.transition = "transform 0.4s", Re.style.position = "relative", Re.style.transform = "translateY(-" + Je + "px)";
                  }
                }
              } else ae(j.errorHandler, "Error processing ISD element kind: " + ue.kind);
            }
            function m(j, ee, ue) {
              return j.style.backgroundColor ? (ue && !ee.includes(j) && ee.push(j), j.style.backgroundColor) : j.parentElement.nodeName === "SPAN" || j.parentElement.nodeName === "RUBY" || j.parentElement.nodeName === "RBC" || j.parentElement.nodeName === "RTC" || j.parentElement.nodeName === "RT" ? m(j.parentElement, ee, !0) : void 0;
            }
            function o(j, ee, ue) {
              if (j.tagName === "SPAN" && ee.tagName === "SPAN" && j._isd_element === ee._isd_element) {
                if (!j._isd_element) return ae(ue.errorHandler, "Internal error: HTML span is not linked to a source element; cannot merge spans."), !1;
                j.textContent += ee.textContent;
                for (var Ae = 0; Ae < ee.style.length; Ae++) {
                  var Q = ee.style[Ae];
                  (Q.indexOf("border") >= 0 || Q.indexOf("padding") >= 0 || Q.indexOf("margin") >= 0) && (j.style[Q] = ee.style[Q]);
                }
                return ee.parentElement.removeChild(ee), !0;
              }
              return !1;
            }
            function E(j, ee) {
              this.id = j, this.plist = ee;
            }
            function h(j, ee) {
              var ue = { before: null, after: null, start: null, end: null };
              return ee.bpd === "tb" ? (ue.before = j.top, ue.after = j.bottom, ee.ipd === "lr" ? (ue.start = j.left, ue.end = j.right) : (ue.start = j.right, ue.end = j.left)) : ee.bpd === "lr" ? (ue.before = j.left, ue.after = j.right, ue.start = j.top, ue.end = j.bottom) : ee.bpd === "rl" && (ue.before = j.right, ue.after = j.left, ue.start = j.top, ue.end = j.bottom), ue;
            }
            function n(j, ee, ue, Ae) {
              if (ee.localName !== "rt" && ee.localName !== "rtc") {
                var Q, Ne, Ue, ze, Te = ee.style.backgroundColor || Ae;
                if (ee.childElementCount === 0) if (ee.localName === "span" || ee.localName === "rb") {
                  var Oe = h(ee.getBoundingClientRect(), j);
                  if (ue.length !== 0 && (Q = Oe.before, Ne = Oe.after, Ue = ue[ue.length - 1].before, Ne < (ze = ue[ue.length - 1].after) && Q > Ue || ze <= Ne && Ue >= Q)) {
                    var We = Math.sign(Oe.after - Oe.before), at = Math.sign(Oe.end - Oe.start);
                    We * (Oe.before - ue[ue.length - 1].before) < 0 && (ue[ue.length - 1].before = Oe.before), We * (Oe.after - ue[ue.length - 1].after) > 0 && (ue[ue.length - 1].after = Oe.after), at * (Oe.start - ue[ue.length - 1].start) < 0 && (ue[ue.length - 1].start = Oe.start, ue[ue.length - 1].start_elem = ue[ue.length - 1].elements.length), at * (Oe.end - ue[ue.length - 1].end) > 0 && (ue[ue.length - 1].end = Oe.end, ue[ue.length - 1].end_elem = ue[ue.length - 1].elements.length);
                  } else ue.push({ before: Oe.before, after: Oe.after, start: Oe.start, end: Oe.end, start_elem: 0, end_elem: 0, elements: [], rbc: [], te: [], text: "", br: !1 });
                  ue[ue.length - 1].text += ee.textContent, ue[ue.length - 1].elements.push({ node: ee, bgcolor: Te, before: Oe.before, after: Oe.after });
                } else ee.localName === "br" && ue.length !== 0 && (ue[ue.length - 1].br = !0);
                else for (var Se = ee.firstChild; Se; ) Se.nodeType === Node.ELEMENT_NODE && (n(j, Se, ue, Te), Se.localName === "ruby" || Se.localName === "rtc" ? ue.length > 0 && ue[ue.length - 1].rbc.push(Se) : Se.localName === "span" && Se.style[M] && Se.style[M] !== "none" && ue.length > 0 && ue[ue.length - 1].te.push(Se)), Se = Se.nextSibling;
              }
            }
            function c(j, ee, ue, Ae) {
              var Q;
              Ae.style !== "none" && (Ae.style === "auto" ? ee.style[M] = "filled" : ee.style[M] = Ae.style + " " + Ae.symbol, (Ae.position === "before" || Ae.position === "after") && (Q = j.bpd === "tb" ? Ae.position === "before" ? "left over" : "left under" : j.bpd === "rl" ? Ae.position === "before" ? "right under" : "left under" : Ae.position === "before" ? "left under" : "right under", ee.style[K] = Q));
            }
            function d(j, ee) {
              this.qname = j, this.map = ee;
            }
            T.render = function(j, ee, ue, Ae, Q, Ne, Ue, ze, Te) {
              var Oe = Ae || ee.clientHeight, We = Q || ee.clientWidth;
              if (j.aspectRatio !== null) {
                var at = Oe * j.aspectRatio;
                at > We ? Oe = Math.round(We / j.aspectRatio) : We = at;
              }
              var Se = document.createElement("div");
              Se.style.position = "relative", Se.style.width = We + "px", Se.style.height = Oe + "px", Se.style.margin = "auto", Se.style.top = 0, Se.style.bottom = 0, Se.style.left = 0, Se.style.right = 0, Se.style.zIndex = 0;
              var ke = { h: Oe, w: We, regionH: null, regionW: null, imgResolver: ue, displayForcedOnlyMode: Ne || !1, isd: j, errorHandler: Ue, previousISDState: ze, enableRollUp: Te || !1, currentISDState: {}, flg: null, lp: null, mra: null, ipd: null, bpd: null, ruby: null, textEmphasis: null, rubyReserve: null };
              if (ee.appendChild(Se), "contents" in j) for (var Rt = 0; Rt < j.contents.length; Rt++) p(ke, Se, j.contents[Rt], j);
              return ke.currentISDState;
            };
            for (var S = [new d("http://www.w3.org/ns/ttml#styling backgroundColor", function(j, ee, ue, Ae) {
              Ae[3] !== 0 && (ee.style.backgroundColor = "rgba(" + Ae[0].toString() + "," + Ae[1].toString() + "," + Ae[2].toString() + "," + (Ae[3] / 255).toString() + ")");
            }), new d("http://www.w3.org/ns/ttml#styling color", function(j, ee, ue, Ae) {
              ee.style.color = "rgba(" + Ae[0].toString() + "," + Ae[1].toString() + "," + Ae[2].toString() + "," + (Ae[3] / 255).toString() + ")";
            }), new d("http://www.w3.org/ns/ttml#styling direction", function(j, ee, ue, Ae) {
              ee.style.direction = Ae;
            }), new d("http://www.w3.org/ns/ttml#styling display", function(j, ee, ue, Ae) {
            }), new d("http://www.w3.org/ns/ttml#styling displayAlign", function(j, ee, ue, Ae) {
              ee.style.display = "flex", ee.style.flexDirection = "column", Ae === "before" ? ee.style.justifyContent = "flex-start" : Ae === "center" ? ee.style.justifyContent = "center" : Ae === "after" && (ee.style.justifyContent = "flex-end");
            }), new d("http://www.w3.org/ns/ttml#styling extent", function(j, ee, ue, Ae) {
              j.regionH = Ae.h.toUsedLength(j.w, j.h), j.regionW = Ae.w.toUsedLength(j.w, j.h);
              var Q = 0, Ne = 0, Ue = ue.styleAttrs["http://www.w3.org/ns/ttml#styling padding"];
              Ue && (Q = Ue[0].toUsedLength(j.w, j.h) + Ue[2].toUsedLength(j.w, j.h), Ne = Ue[1].toUsedLength(j.w, j.h) + Ue[3].toUsedLength(j.w, j.h)), ee.style.height = j.regionH - Q + "px", ee.style.width = j.regionW - Ne + "px";
            }), new d("http://www.w3.org/ns/ttml#styling fontFamily", function(j, ee, ue, Ae) {
              for (var Q = [], Ne = 0; Ne < Ae.length; Ne++) Ae[Ne] = Ae[Ne].trim(), Ae[Ne] === "monospaceSerif" ? (Q.push("Courier New"), Q.push('"Liberation Mono"'), Q.push("Courier"), Q.push("monospace")) : Ae[Ne] === "proportionalSansSerif" ? (Q.push("Arial"), Q.push("Helvetica"), Q.push('"Liberation Sans"'), Q.push("sans-serif")) : Ae[Ne] === "monospace" ? Q.push("monospace") : Ae[Ne] === "sansSerif" ? Q.push("sans-serif") : Ae[Ne] === "serif" ? Q.push("serif") : Ae[Ne] === "monospaceSansSerif" ? (Q.push("Consolas"), Q.push("monospace")) : Ae[Ne] === "proportionalSerif" ? Q.push("serif") : Q.push(Ae[Ne]);
              if (Q.length > 0) {
                for (var Ue = [Q[0]], ze = 1; ze < Q.length; ze++) Ue.indexOf(Q[ze]) == -1 && Ue.push(Q[ze]);
                Q = Ue;
              }
              ee.style.fontFamily = Q.join(",");
            }), new d("http://www.w3.org/ns/ttml#styling shear", function(j, ee, ue, Ae) {
              if (Ae !== 0) {
                var Q = -0.9 * Ae;
                j.bpd === "tb" ? ee.style.transform = "skewX(" + Q + "deg)" : ee.style.transform = "skewY(" + Q + "deg)";
              }
            }), new d("http://www.w3.org/ns/ttml#styling fontSize", function(j, ee, ue, Ae) {
              ee.style.fontSize = Ae.toUsedLength(j.w, j.h) + "px";
            }), new d("http://www.w3.org/ns/ttml#styling fontStyle", function(j, ee, ue, Ae) {
              ee.style.fontStyle = Ae;
            }), new d("http://www.w3.org/ns/ttml#styling fontWeight", function(j, ee, ue, Ae) {
              ee.style.fontWeight = Ae;
            }), new d("http://www.w3.org/ns/ttml#styling lineHeight", function(j, ee, ue, Ae) {
              ee.style.lineHeight = Ae === "normal" ? "normal" : Ae.toUsedLength(j.w, j.h) + "px";
            }), new d("http://www.w3.org/ns/ttml#styling opacity", function(j, ee, ue, Ae) {
              ee.style.opacity = Ae;
            }), new d("http://www.w3.org/ns/ttml#styling origin", function(j, ee, ue, Ae) {
              ee.style.top = Ae.h.toUsedLength(j.w, j.h) + "px", ee.style.left = Ae.w.toUsedLength(j.w, j.h) + "px";
            }), new d("http://www.w3.org/ns/ttml#styling overflow", function(j, ee, ue, Ae) {
              ee.style.overflow = Ae;
            }), new d("http://www.w3.org/ns/ttml#styling padding", function(j, ee, ue, Ae) {
              var Q = [];
              Q[0] = Ae[0].toUsedLength(j.w, j.h) + "px", Q[1] = Ae[3].toUsedLength(j.w, j.h) + "px", Q[2] = Ae[2].toUsedLength(j.w, j.h) + "px", Q[3] = Ae[1].toUsedLength(j.w, j.h) + "px", ee.style.padding = Q.join(" ");
            }), new d("http://www.w3.org/ns/ttml#styling position", function(j, ee, ue, Ae) {
              ee.style.top = Ae.h.toUsedLength(j.w, j.h) + "px", ee.style.left = Ae.w.toUsedLength(j.w, j.h) + "px";
            }), new d("http://www.w3.org/ns/ttml#styling rubyAlign", function(j, ee, ue, Ae) {
              ee.style.rubyAlign = Ae === "spaceAround" ? "space-around" : "center";
            }), new d("http://www.w3.org/ns/ttml#styling rubyPosition", function(j, ee, ue, Ae) {
              var Q;
              Ae !== "before" && Ae !== "after" || (Q = L ? Ae : j.bpd === "tb" || j.bpd === "rl" ? Ae === "before" ? "over" : "under" : Ae === "before" ? "under" : "over", ee.parentElement.style[$] = Q);
            }), new d("http://www.w3.org/ns/ttml#styling showBackground", null), new d("http://www.w3.org/ns/ttml#styling textAlign", function(j, ee, ue, Ae) {
              var Q;
              Q = Ae === "start" ? j.ipd === "rl" ? "right" : "left" : Ae === "end" ? j.ipd === "rl" ? "left" : "right" : Ae, ee.style.textAlign = Q;
            }), new d("http://www.w3.org/ns/ttml#styling textDecoration", function(j, ee, ue, Ae) {
              ee.style.textDecoration = Ae.join(" ").replace("lineThrough", "line-through");
            }), new d("http://www.w3.org/ns/ttml#styling textOutline", function(j, ee, ue, Ae) {
            }), new d("http://www.w3.org/ns/ttml#styling textShadow", function(j, ee, ue, Ae) {
              var Q = ue.styleAttrs[e.byName.textOutline.qname];
              if (Ae === "none" && Q === "none") ee.style.textShadow = "";
              else {
                var Ne = [];
                if (Q !== "none") {
                  var Ue = "rgba(" + Q.color[0].toString() + "," + Q.color[1].toString() + "," + Q.color[2].toString() + "," + (Q.color[3] / 255).toString() + ")";
                  Ne.push("1px 1px 1px " + Ue), Ne.push("-1px 1px 1px " + Ue), Ne.push("1px -1px 1px " + Ue), Ne.push("-1px -1px 1px " + Ue);
                }
                if (Ae !== "none") for (var ze = 0; ze < Ae.length; ze++) Ne.push(Ae[ze].x_off.toUsedLength(j.w, j.h) + "px " + Ae[ze].y_off.toUsedLength(j.w, j.h) + "px " + Ae[ze].b_radius.toUsedLength(j.w, j.h) + "px rgba(" + Ae[ze].color[0].toString() + "," + Ae[ze].color[1].toString() + "," + Ae[ze].color[2].toString() + "," + (Ae[ze].color[3] / 255).toString() + ")");
                ee.style.textShadow = Ne.join(",");
              }
            }), new d("http://www.w3.org/ns/ttml#styling textCombine", function(j, ee, ue, Ae) {
              ee.style.textCombineUpright = Ae;
            }), new d("http://www.w3.org/ns/ttml#styling textEmphasis", function(j, ee, ue, Ae) {
            }), new d("http://www.w3.org/ns/ttml#styling unicodeBidi", function(j, ee, ue, Ae) {
              var Q;
              Q = Ae === "bidiOverride" ? "bidi-override" : Ae, ee.style.unicodeBidi = Q;
            }), new d("http://www.w3.org/ns/ttml#styling visibility", function(j, ee, ue, Ae) {
              ee.style.visibility = Ae;
            }), new d("http://www.w3.org/ns/ttml#styling wrapOption", function(j, ee, ue, Ae) {
              Ae === "wrap" ? ue.space === "preserve" ? ee.style.whiteSpace = "pre-wrap" : ee.style.whiteSpace = "normal" : ue.space === "preserve" ? ee.style.whiteSpace = "pre" : ee.style.whiteSpace = "noWrap";
            }), new d("http://www.w3.org/ns/ttml#styling writingMode", function(j, ee, ue, Ae) {
              Ae === "lrtb" || Ae === "lr" || Ae === "rltb" || Ae === "rl" ? ee.style.writingMode = "horizontal-tb" : Ae === "tblr" ? ee.style.writingMode = "vertical-lr" : Ae !== "tbrl" && Ae !== "tb" || (ee.style.writingMode = "vertical-rl");
            }), new d("http://www.w3.org/ns/ttml#styling zIndex", function(j, ee, ue, Ae) {
              ee.style.zIndex = Ae;
            }), new d("http://www.w3.org/ns/ttml/profile/imsc1#styling forcedDisplay", function(j, ee, ue, Ae) {
              j.displayForcedOnlyMode && Ae === !1 && (ee.style.visibility = "hidden");
            })], x = {}, B = 0; B < S.length; B++) x[S[B].qname] = S[B];
            var L = "webkitRubyPosition" in window.getComputedStyle(document.documentElement), $ = L ? "webkitRubyPosition" : "rubyPosition", M = "webkitTextEmphasisStyle" in window.getComputedStyle(document.documentElement) ? "webkitTextEmphasisStyle" : "textEmphasisStyle", K = "webkitTextEmphasisPosition" in window.getComputedStyle(document.documentElement) ? "webkitTextEmphasisPosition" : "textEmphasisPosition";
            function ae(j, ee) {
              if (j && j.error && j.error(ee)) throw ee;
            }
          })(Ee, typeof imscNames > "u" ? C(210) : imscNames, typeof imscStyles > "u" ? C(6811) : imscStyles, typeof imscUtils > "u" ? C(5926) : imscUtils);
        }, 4080: function(Pe, Ee, C) {
          (function(ie, T, t, e) {
            ie.generateISD = function(d, S, x) {
              var B, L = new h(d), $ = {}, M = {}, K = d.head.styling.initials[t.byName.showBackground.qname], ae = d.head.styling.initials[t.byName.backgroundColor.qname];
              for (var j in d.head.layout.regions) if (d.head.layout.regions.hasOwnProperty(j)) {
                var ee = d.head.layout.regions[j], ue = ee.styleAttrs[t.byName.showBackground.qname] || K, Ae = ee.styleAttrs[t.byName.backgroundColor.qname] || ae;
                M[ee.id] = (ue === "always" || ue === void 0) && Ae !== void 0 && !(S < ee.begin || S >= ee.end);
              }
              for (var Q in d.body && d.body.regionID && (M[d.body.regionID] = !0), B = d.body !== null ? function Ue(ze, Te) {
                if (Te.contents) {
                  var Oe = {};
                  for (var We in Te) Te.hasOwnProperty(We) && (Oe[We] = Te[We]);
                  return Oe.contents = [], Te.contents.filter(function(at) {
                    return !(ze < at.begin || ze >= at.end);
                  }).forEach(function(at) {
                    var Se = Ue(ze, at);
                    Se.regionID && (M[Se.regionID] = !0), Se !== null && Oe.contents.push(Se);
                  }), Oe;
                }
                return Te;
              }(S, d.body) : null, M[""] !== void 0 && (M[""] = !0), M) if (M[Q]) {
                var Ne = m(d, S, d.head.layout.regions[Q], B, null, "", d.head.layout.regions[Q], x, $);
                Ne !== null && L.contents.push(Ne.element);
              }
              return L;
            };
            var p = [t.byName.color.qname, t.byName.textCombine.qname, t.byName.textDecoration.qname, t.byName.textEmphasis.qname, t.byName.textOutline.qname, t.byName.textShadow.qname];
            function m(d, S, x, B, L, $, M, K, ae) {
              if (S < M.begin || S >= M.end) return null;
              var j = "regionID" in M && M.regionID !== "" ? M.regionID : $;
              if (L !== null && j !== x.id && (!("contents" in M) || "contents" in M && M.contents.length === 0 || j !== "")) return null;
              var ee = new n(M);
              if ("sets" in M) for (var ue = 0; ue < M.sets.length; ue++) S < M.sets[ue].begin || S >= M.sets[ue].end || (ee.styleAttrs[M.sets[ue].qname] = M.sets[ue].value);
              var Ae = {};
              for (var Q in ee.styleAttrs) if (ee.styleAttrs.hasOwnProperty(Q) && (Ae[Q] = !0, ee.kind === "region" && Q === t.byName.writingMode.qname && !(t.byName.direction.qname in ee.styleAttrs))) {
                var Ne = ee.styleAttrs[Q];
                Ne === "lrtb" || Ne === "lr" ? ee.styleAttrs[t.byName.direction.qname] = "ltr" : Ne !== "rltb" && Ne !== "rl" || (ee.styleAttrs[t.byName.direction.qname] = "rtl");
              }
              if (L !== null) for (var Ue = 0; Ue < t.all.length; Ue++) {
                var ze = t.all[Ue];
                if (ze.qname === t.byName.textDecoration.qname) {
                  var Te = L.styleAttrs[ze.qname], Oe = ee.styleAttrs[ze.qname], We = [];
                  Oe === void 0 ? We = Te : Oe.indexOf("none") === -1 ? ((Oe.indexOf("noUnderline") === -1 && Te.indexOf("underline") !== -1 || Oe.indexOf("underline") !== -1) && We.push("underline"), (Oe.indexOf("noLineThrough") === -1 && Te.indexOf("lineThrough") !== -1 || Oe.indexOf("lineThrough") !== -1) && We.push("lineThrough"), (Oe.indexOf("noOverline") === -1 && Te.indexOf("overline") !== -1 || Oe.indexOf("overline") !== -1) && We.push("overline")) : We.push("none"), ee.styleAttrs[ze.qname] = We;
                } else if (ze.qname !== t.byName.fontSize.qname || ze.qname in ee.styleAttrs || ee.kind !== "span" || ee.styleAttrs[t.byName.ruby.qname] !== "textContainer") if (ze.qname !== t.byName.fontSize.qname || ze.qname in ee.styleAttrs || ee.kind !== "span" || ee.styleAttrs[t.byName.ruby.qname] !== "text") ze.inherit && ze.qname in L.styleAttrs && !(ze.qname in ee.styleAttrs) && (ee.styleAttrs[ze.qname] = L.styleAttrs[ze.qname]);
                else {
                  var at = L.styleAttrs[t.byName.fontSize.qname];
                  L.styleAttrs[t.byName.ruby.qname] === "textContainer" ? ee.styleAttrs[ze.qname] = at : ee.styleAttrs[ze.qname] = new e.ComputedLength(0.5 * at.rw, 0.5 * at.rh);
                }
                else {
                  var Se = L.styleAttrs[t.byName.fontSize.qname];
                  ee.styleAttrs[ze.qname] = new e.ComputedLength(0.5 * Se.rw, 0.5 * Se.rh);
                }
              }
              for (var ke = 0; ke < t.all.length; ke++) {
                var Rt = t.all[ke];
                if (!(Rt.qname in ee.styleAttrs) && !(Rt.qname === t.byName.position.qname && t.byName.origin.qname in ee.styleAttrs || Rt.qname === t.byName.origin.qname && t.byName.position.qname in ee.styleAttrs)) {
                  var _t = d.head.styling.initials[Rt.qname] || Rt.initial;
                  if (_t !== null && (ee.kind === "region" || Rt.inherit === !1 && _t !== null)) {
                    var qe = Rt.parse(_t);
                    qe !== null ? (ee.styleAttrs[Rt.qname] = qe, Ae[Rt.qname] = !0) : c(K, "Invalid initial value for '" + Rt.qname + "' on element '" + ee.kind);
                  }
                }
              }
              for (var it = 0; it < t.all.length; it++) {
                var me = t.all[it];
                if (me.qname in Ae && me.compute !== null) {
                  var ye = me.compute(d, L, ee, ee.styleAttrs[me.qname], ae);
                  ye !== null ? ee.styleAttrs[me.qname] = ye : (ee.styleAttrs[me.qname] = me.compute(d, L, ee, me.parse(me.initial), ae), c(K, "Style '" + me.qname + "' on element '" + ee.kind + "' cannot be computed"));
                }
              }
              if (ee.styleAttrs[t.byName.display.qname] === "none") return null;
              var Ve = null;
              L === null ? Ve = B === null ? [] : [B] : "contents" in M && (Ve = M.contents);
              for (var f = 0; Ve !== null && f < Ve.length; f++) {
                var u = m(d, S, x, B, ee, j, Ve[f], K, ae);
                u !== null && ee.contents.push(u.element);
              }
              for (var v in ee.styleAttrs) if (ee.styleAttrs.hasOwnProperty(v)) {
                var b = !1;
                if (ee.kind === "span") {
                  var W = ee.styleAttrs[t.byName.ruby.qname];
                  (b = (W === "container" || W === "textContainer" || W === "baseContainer") && p.indexOf(v) !== -1) || (b = W !== "container" && v === t.byName.rubyAlign.qname), b || (b = !(W === "textContainer" || W === "text") && v === t.byName.rubyPosition.qname);
                }
                if (!b) {
                  var Y = t.byQName[v];
                  "applies" in Y && (b = Y.applies.indexOf(ee.kind) === -1);
                }
                b && delete ee.styleAttrs[v];
              }
              var Re = ee.styleAttrs[t.byName.ruby.qname];
              if (ee.kind === "p" || ee.kind === "span" && (Re === "textContainer" || Re === "text")) {
                var Je = [];
                o(ee, Je), function(Ze) {
                  for (var Fe, we = 0; we < Ze.length; ) if ((Fe = Ze[we]).kind !== "br" && Fe.space !== "preserve") {
                    var Ge = Fe.text.replace(/[\t\r\n ]+/g, " ");
                    /^[ ]/.test(Ge) && (we === 0 || (nt = Ze[we - 1]).kind === "br" || /[\r\n\t ]$/.test(nt.text)) && (Ge = Ge.substring(1)), Fe.text = Ge, Ge.length === 0 ? Ze.splice(we, 1) : we++;
                  } else we++;
                  var nt, Tt;
                  for (we = 0; we < Ze.length; we++) (Fe = Ze[we]).kind !== "br" && Fe.space !== "preserve" ? /[ ]$/.test(Fe.text) && (we === Ze.length - 1 || (Tt = Ze[we + 1]).kind === "br" || Tt.space === "preserve" && /^[\r\n]/.test(Tt.text)) && (Fe.text = Fe.text.slice(0, -1)) : we++;
                }(Je), E(ee);
              }
              return ee.kind === "div" && t.byName.backgroundImage.qname in ee.styleAttrs || ee.kind === "br" || ee.kind === "image" || "contents" in ee && ee.contents.length > 0 || ee.kind === "span" && ee.text !== null || ee.kind === "region" && ee.styleAttrs[t.byName.showBackground.qname] === "always" ? { region_id: j, element: ee } : null;
            }
            function o(d, S) {
              if ("contents" in d) for (var x = 0; x < d.contents.length; x++) {
                var B = d.contents[x], L = B.styleAttrs[t.byName.ruby.qname];
                (B.kind !== "span" || L !== "textContainer" && L !== "text") && ("contents" in B ? o(B, S) : (B.kind === "span" && B.text.length !== 0 || B.kind === "br") && S.push(B));
              }
            }
            function E(d) {
              if (d.kind === "br") return !1;
              if ("text" in d) return d.text.length === 0;
              if ("contents" in d) {
                for (var S = d.contents.length; S--; ) E(d.contents[S]) && d.contents.splice(S, 1);
                return d.contents.length === 0;
              }
            }
            function h(d) {
              this.contents = [], this.aspectRatio = d.aspectRatio, this.lang = d.lang;
            }
            function n(d) {
              for (var S in this.kind = d.kind || "region", this.lang = d.lang, d.id && (this.id = d.id), this.styleAttrs = {}, d.styleAttrs) d.styleAttrs.hasOwnProperty(S) && (this.styleAttrs[S] = d.styleAttrs[S]);
              "src" in d && (this.src = d.src), "type" in d && (this.type = d.type), "text" in d ? this.text = d.text : (this.kind === "region" || "contents" in d) && (this.contents = []), "space" in d && (this.space = d.space);
            }
            function c(d, S) {
              if (d && d.error && d.error(S)) throw S;
            }
          })(Ee, typeof imscNames > "u" ? C(210) : imscNames, typeof imscStyles > "u" ? C(6811) : imscStyles, typeof imscUtils > "u" ? C(5926) : imscUtils);
        }, 4403: function(Pe, Ee, C) {
          Ee.generateISD = C(4080).generateISD, Ee.fromXML = C(3362).fromXML, Ee.renderHTML = C(506).render;
        }, 210: function(Pe, Ee) {
          (function(C) {
            C.ns_tt = "http://www.w3.org/ns/ttml", C.ns_tts = "http://www.w3.org/ns/ttml#styling", C.ns_ttp = "http://www.w3.org/ns/ttml#parameter", C.ns_xml = "http://www.w3.org/XML/1998/namespace", C.ns_itts = "http://www.w3.org/ns/ttml/profile/imsc1#styling", C.ns_ittp = "http://www.w3.org/ns/ttml/profile/imsc1#parameter", C.ns_smpte = "http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt", C.ns_ebutts = "urn:ebu:tt:style";
          })(Ee);
        }, 6811: function(Pe, Ee, C) {
          (function(ie, T, t) {
            function e(o, E, h, n, c, d, S, x) {
              this.name = E, this.ns = o, this.qname = o + " " + E, this.inherit = c, this.animatable = d, this.initial = h, this.applies = n, this.parse = S, this.compute = x;
            }
            for (var p in ie.all = [new e(T.ns_tts, "backgroundColor", "transparent", ["body", "div", "p", "region", "span"], !1, !0, t.parseColor, null), new e(T.ns_tts, "color", "white", ["span"], !0, !0, t.parseColor, null), new e(T.ns_tts, "direction", "ltr", ["p", "span"], !0, !0, function(o) {
              return o;
            }, null), new e(T.ns_tts, "display", "auto", ["body", "div", "p", "region", "span"], !1, !0, function(o) {
              return o;
            }, null), new e(T.ns_tts, "displayAlign", "before", ["region"], !1, !0, function(o) {
              return o;
            }, null), new e(T.ns_tts, "extent", "auto", ["tt", "region"], !1, !0, function(o) {
              if (o === "auto") return o;
              var E = o.split(" ");
              if (E.length !== 2) return null;
              var h = t.parseLength(E[0]), n = t.parseLength(E[1]);
              return n && h ? { h: n, w: h } : null;
            }, function(o, E, h, n, c) {
              var d, S;
              if (n === "auto") d = new t.ComputedLength(0, 1);
              else if ((d = t.toComputedLength(n.h.value, n.h.unit, null, o.dimensions.h, null, o.pxLength.h)) === null) return null;
              if (n === "auto") S = new t.ComputedLength(1, 0);
              else if ((S = t.toComputedLength(n.w.value, n.w.unit, null, o.dimensions.w, null, o.pxLength.w)) === null) return null;
              return { h: d, w: S };
            }), new e(T.ns_tts, "fontFamily", "default", ["span", "p"], !0, !0, function(o) {
              for (var E = o.split(","), h = [], n = 0; n < E.length; n++) E[n] = E[n].trim(), E[n].charAt(0) !== "'" && E[n].charAt(0) !== '"' && E[n] === "default" ? h.push("monospaceSerif") : h.push(E[n]);
              return h;
            }, null), new e(T.ns_tts, "shear", "0%", ["p"], !0, !0, t.parseLength, function(o, E, h, n) {
              return n.unit !== "%" ? null : Math.abs(n.value) > 100 ? 100 * Math.sign(n.value) : n.value;
            }), new e(T.ns_tts, "fontSize", "1c", ["span", "p"], !0, !0, t.parseLength, function(o, E, h, n, c) {
              return t.toComputedLength(n.value, n.unit, E !== null ? E.styleAttrs[ie.byName.fontSize.qname] : o.cellLength.h, E !== null ? E.styleAttrs[ie.byName.fontSize.qname] : o.cellLength.h, o.cellLength.h, o.pxLength.h);
            }), new e(T.ns_tts, "fontStyle", "normal", ["span", "p"], !0, !0, function(o) {
              return o;
            }, null), new e(T.ns_tts, "fontWeight", "normal", ["span", "p"], !0, !0, function(o) {
              return o;
            }, null), new e(T.ns_tts, "lineHeight", "normal", ["p"], !0, !0, function(o) {
              return o === "normal" ? o : t.parseLength(o);
            }, function(o, E, h, n, c) {
              var d;
              if (n === "normal") d = n;
              else if ((d = t.toComputedLength(n.value, n.unit, h.styleAttrs[ie.byName.fontSize.qname], h.styleAttrs[ie.byName.fontSize.qname], o.cellLength.h, o.pxLength.h)) === null) return null;
              return d;
            }), new e(T.ns_tts, "opacity", 1, ["region"], !1, !0, parseFloat, null), new e(T.ns_tts, "origin", "auto", ["region"], !1, !0, function(o) {
              if (o === "auto") return o;
              var E = o.split(" ");
              if (E.length !== 2) return null;
              var h = t.parseLength(E[0]), n = t.parseLength(E[1]);
              return n && h ? { h: n, w: h } : null;
            }, function(o, E, h, n, c) {
              var d, S;
              if (n === "auto") d = new t.ComputedLength(0, 0);
              else if ((d = t.toComputedLength(n.h.value, n.h.unit, null, o.dimensions.h, null, o.pxLength.h)) === null) return null;
              if (n === "auto") S = new t.ComputedLength(0, 0);
              else if ((S = t.toComputedLength(n.w.value, n.w.unit, null, o.dimensions.w, null, o.pxLength.w)) === null) return null;
              return { h: d, w: S };
            }), new e(T.ns_tts, "overflow", "hidden", ["region"], !1, !0, function(o) {
              return o;
            }, null), new e(T.ns_tts, "padding", "0px", ["region"], !1, !0, function(o) {
              var E = o.split(" ");
              if (E.length > 4) return null;
              for (var h = [], n = 0; n < E.length; n++) {
                var c = t.parseLength(E[n]);
                if (!c) return null;
                h.push(c);
              }
              return h;
            }, function(o, E, h, n, c) {
              var d;
              if (n.length === 1) d = [n[0], n[0], n[0], n[0]];
              else if (n.length === 2) d = [n[0], n[1], n[0], n[1]];
              else if (n.length === 3) d = [n[0], n[1], n[2], n[1]];
              else {
                if (n.length !== 4) return null;
                d = [n[0], n[1], n[2], n[3]];
              }
              var S = h.styleAttrs[ie.byName.writingMode.qname];
              if (S === "lrtb" || S === "lr") d = [d[0], d[3], d[2], d[1]];
              else if (S === "rltb" || S === "rl") d = [d[0], d[1], d[2], d[3]];
              else if (S === "tblr") d = [d[3], d[0], d[1], d[2]];
              else {
                if (S !== "tbrl" && S !== "tb") return null;
                d = [d[3], d[2], d[1], d[0]];
              }
              for (var x = [], B = 0; B < d.length; B++) if (d[B].value === 0) x[B] = new t.ComputedLength(0, 0);
              else if (x[B] = t.toComputedLength(d[B].value, d[B].unit, h.styleAttrs[ie.byName.fontSize.qname], B === 0 || B === 2 ? h.styleAttrs[ie.byName.extent.qname].h : h.styleAttrs[ie.byName.extent.qname].w, B === 0 || B === 2 ? o.cellLength.h : o.cellLength.w, B === 0 || B === 2 ? o.pxLength.h : o.pxLength.w), x[B] === null) return null;
              return x;
            }), new e(T.ns_tts, "position", "top left", ["region"], !1, !0, function(o) {
              return t.parsePosition(o);
            }, function(o, E, h, n) {
              var c, d;
              return (c = t.toComputedLength(n.v.offset.value, n.v.offset.unit, null, new t.ComputedLength(-h.styleAttrs[ie.byName.extent.qname].h.rw, o.dimensions.h.rh - h.styleAttrs[ie.byName.extent.qname].h.rh), null, o.pxLength.h)) === null ? null : (n.v.edge === "bottom" && (c = new t.ComputedLength(-c.rw - h.styleAttrs[ie.byName.extent.qname].h.rw, o.dimensions.h.rh - c.rh - h.styleAttrs[ie.byName.extent.qname].h.rh)), d = t.toComputedLength(n.h.offset.value, n.h.offset.unit, null, new t.ComputedLength(o.dimensions.w.rw - h.styleAttrs[ie.byName.extent.qname].w.rw, -h.styleAttrs[ie.byName.extent.qname].w.rh), null, o.pxLength.w), c === null ? null : (n.h.edge === "right" && (d = new t.ComputedLength(o.dimensions.w.rw - d.rw - h.styleAttrs[ie.byName.extent.qname].w.rw, -d.rh - h.styleAttrs[ie.byName.extent.qname].w.rh)), { h: c, w: d }));
            }), new e(T.ns_tts, "ruby", "none", ["span"], !1, !0, function(o) {
              return o;
            }, null), new e(T.ns_tts, "rubyAlign", "center", ["span"], !0, !0, function(o) {
              return o !== "center" && o !== "spaceAround" ? null : o;
            }, null), new e(T.ns_tts, "rubyPosition", "outside", ["span"], !0, !0, function(o) {
              return o;
            }, null), new e(T.ns_tts, "rubyReserve", "none", ["p"], !0, !0, function(o) {
              var E = o.split(" "), h = [null, null];
              if (E.length === 0 || E.length > 2 || E[0] !== "none" && E[0] !== "both" && E[0] !== "after" && E[0] !== "before" && E[0] !== "outside") return null;
              if (h[0] = E[0], E.length === 2 && E[0] !== "none") {
                var n = t.parseLength(E[1]);
                if (!n) return null;
                h[1] = n;
              }
              return h;
            }, function(o, E, h, n, c) {
              if (n[0] === "none") return n;
              var d;
              return (d = n[1] === null ? new t.ComputedLength(0.5 * h.styleAttrs[ie.byName.fontSize.qname].rw, 0.5 * h.styleAttrs[ie.byName.fontSize.qname].rh) : t.toComputedLength(n[1].value, n[1].unit, h.styleAttrs[ie.byName.fontSize.qname], h.styleAttrs[ie.byName.fontSize.qname], o.cellLength.h, o.pxLength.h)) === null ? null : [n[0], d];
            }), new e(T.ns_tts, "showBackground", "always", ["region"], !1, !0, function(o) {
              return o;
            }, null), new e(T.ns_tts, "textAlign", "start", ["p"], !0, !0, function(o) {
              return o;
            }, function(o, E, h, n, c) {
              return n === "left" ? "start" : n === "right" ? "end" : n;
            }), new e(T.ns_tts, "textCombine", "none", ["span"], !0, !0, function(o) {
              return o === "none" || o === "all" ? o : null;
            }, null), new e(T.ns_tts, "textDecoration", "none", ["span"], !0, !0, function(o) {
              return o.split(" ");
            }, null), new e(T.ns_tts, "textEmphasis", "none", ["span"], !0, !0, function(o) {
              for (var E = o.split(" "), h = { style: null, symbol: null, color: null, position: null }, n = 0; n < E.length; n++) if (E[n] === "none" || E[n] === "auto") h.style = E[n];
              else if (E[n] === "filled" || E[n] === "open") h.style = E[n];
              else if (E[n] === "circle" || E[n] === "dot" || E[n] === "sesame") h.symbol = E[n];
              else if (E[n] === "current") h.color = E[n];
              else if (E[n] === "outside" || E[n] === "before" || E[n] === "after") h.position = E[n];
              else if (h.color = t.parseColor(E[n]), h.color === null) return null;
              return h.style == null && h.symbol == null ? h.style = "auto" : (h.symbol = h.symbol || "circle", h.style = h.style || "filled"), h.position = h.position || "outside", h.color = h.color || "current", h;
            }, null), new e(T.ns_tts, "textOutline", "none", ["span"], !0, !0, function(o) {
              if (o === "none") return o;
              var E = {}, h = o.split(" ");
              if (h.length === 0 || h.length > 2) return null;
              var n = t.parseColor(h[0]);
              if (E.color = n, n !== null && h.shift(), h.length !== 1) return null;
              var c = t.parseLength(h[0]);
              return c ? (E.thickness = c, E) : null;
            }, function(o, E, h, n, c) {
              if (n === "none") return n;
              var d = {};
              return n.color === null ? d.color = h.styleAttrs[ie.byName.color.qname] : d.color = n.color, d.thickness = t.toComputedLength(n.thickness.value, n.thickness.unit, h.styleAttrs[ie.byName.fontSize.qname], h.styleAttrs[ie.byName.fontSize.qname], o.cellLength.h, o.pxLength.h), d.thickness === null ? null : d;
            }), new e(T.ns_tts, "textShadow", "none", ["span"], !0, !0, t.parseTextShadow, function(o, E, h, n) {
              if (n === "none") return n;
              for (var c = [], d = 0; d < n.length; d++) {
                var S = {};
                if (S.x_off = t.toComputedLength(n[d][0].value, n[d][0].unit, null, h.styleAttrs[ie.byName.fontSize.qname], null, o.pxLength.w), S.x_off === null || (S.y_off = t.toComputedLength(n[d][1].value, n[d][1].unit, null, h.styleAttrs[ie.byName.fontSize.qname], null, o.pxLength.h), S.y_off === null)) return null;
                if (n[d][2] === null) S.b_radius = 0;
                else if (S.b_radius = t.toComputedLength(n[d][2].value, n[d][2].unit, null, h.styleAttrs[ie.byName.fontSize.qname], null, o.pxLength.h), S.b_radius === null) return null;
                n[d][3] === null ? S.color = h.styleAttrs[ie.byName.color.qname] : S.color = n[d][3], c.push(S);
              }
              return c;
            }), new e(T.ns_tts, "unicodeBidi", "normal", ["span", "p"], !1, !0, function(o) {
              return o;
            }, null), new e(T.ns_tts, "visibility", "visible", ["body", "div", "p", "region", "span"], !0, !0, function(o) {
              return o;
            }, null), new e(T.ns_tts, "wrapOption", "wrap", ["span"], !0, !0, function(o) {
              return o;
            }, null), new e(T.ns_tts, "writingMode", "lrtb", ["region"], !1, !0, function(o) {
              return o;
            }, null), new e(T.ns_tts, "zIndex", "auto", ["region"], !1, !0, function(o) {
              var E;
              return o === "auto" ? E = o : (E = parseInt(o), isNaN(E) && (E = null)), E;
            }, null), new e(T.ns_ebutts, "linePadding", "0c", ["p"], !0, !1, t.parseLength, function(o, E, h, n, c) {
              return t.toComputedLength(n.value, n.unit, null, null, o.cellLength.w, null);
            }), new e(T.ns_ebutts, "multiRowAlign", "auto", ["p"], !0, !1, function(o) {
              return o;
            }, null), new e(T.ns_smpte, "backgroundImage", null, ["div"], !1, !1, function(o) {
              return o;
            }, null), new e(T.ns_itts, "forcedDisplay", "false", ["body", "div", "p", "region", "span"], !0, !0, function(o) {
              return o === "true";
            }, null), new e(T.ns_itts, "fillLineGap", "false", ["p"], !0, !0, function(o) {
              return o === "true";
            }, null)], ie.byQName = {}, ie.all) ie.byQName[ie.all[p].qname] = ie.all[p];
            for (var m in ie.byName = {}, ie.all) ie.byName[ie.all[m].name] = ie.all[m];
          })(Ee, typeof imscNames > "u" ? C(210) : imscNames, typeof imscUtils > "u" ? C(5926) : imscUtils);
        }, 5926: function(Pe, Ee) {
          (function(C) {
            var ie = /#([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})?/, T = /rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/, t = /rgba\(\s*(\d+),\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/, e = { transparent: [0, 0, 0, 0], black: [0, 0, 0, 255], silver: [192, 192, 192, 255], gray: [128, 128, 128, 255], white: [255, 255, 255, 255], maroon: [128, 0, 0, 255], red: [255, 0, 0, 255], purple: [128, 0, 128, 255], fuchsia: [255, 0, 255, 255], magenta: [255, 0, 255, 255], green: [0, 128, 0, 255], lime: [0, 255, 0, 255], olive: [128, 128, 0, 255], yellow: [255, 255, 0, 255], navy: [0, 0, 128, 255], blue: [0, 0, 255, 255], teal: [0, 128, 128, 255], aqua: [0, 255, 255, 255], cyan: [0, 255, 255, 255] };
            C.parseColor = function(m) {
              var o, E = null, h = e[m.toLowerCase()];
              return h !== void 0 ? E = h : (o = ie.exec(m)) !== null ? E = [parseInt(o[1], 16), parseInt(o[2], 16), parseInt(o[3], 16), o[4] !== void 0 ? parseInt(o[4], 16) : 255] : (o = T.exec(m)) !== null ? E = [parseInt(o[1]), parseInt(o[2]), parseInt(o[3]), 255] : (o = t.exec(m)) !== null && (E = [parseInt(o[1]), parseInt(o[2]), parseInt(o[3]), parseInt(o[4])]), E;
            };
            var p = /^((?:\+|\-)?\d*(?:\.\d+)?)(px|em|c|%|rh|rw)$/;
            C.parseLength = function(m) {
              var o, E = null;
              return (o = p.exec(m)) !== null && (E = { value: parseFloat(o[1]), unit: o[2] }), E;
            }, C.parseTextShadow = function(m) {
              for (var o = m.match(/([^\(,\)]|\([^\)]+\))+/g), E = [], h = 0; h < o.length; h++) {
                var n = o[h].split(" ");
                if (n.length === 1 && n[0] === "none") return "none";
                if (n.length > 1 && n.length < 5) {
                  var c = [null, null, null, null], d = C.parseLength(n.shift());
                  if (d === null || (c[0] = d, (d = C.parseLength(n.shift())) === null)) return null;
                  if (c[1] = d, n.length === 0) {
                    E.push(c);
                    continue;
                  }
                  if ((d = C.parseLength(n[0])) !== null && (c[2] = d, n.shift()), n.length === 0) {
                    E.push(c);
                    continue;
                  }
                  var S = C.parseColor(n[0]);
                  if (S === null) return null;
                  c[3] = S, E.push(c);
                }
              }
              return E;
            }, C.parsePosition = function(m) {
              var o = m.split(" "), E = function(B) {
                return B === "center" || B === "left" || B === "top" || B === "bottom" || B === "right";
              };
              if (o.length > 4) return null;
              for (var h = 0; h < o.length; h++) if (!E(o[h])) {
                var n = C.parseLength(o[h]);
                if (n === null) return null;
                o[h] = n;
              }
              for (var c = { h: { edge: "left", offset: { value: 50, unit: "%" } }, v: { edge: "top", offset: { value: 50, unit: "%" } } }, d = 0; d < o.length; ) {
                var S = o[d++];
                if (E(S)) {
                  var x = { value: 0, unit: "%" };
                  o.length !== 2 && d < o.length && !E(o[d]) && (x = o[d++]), S === "right" ? (c.h.edge = S, c.h.offset = x) : S === "bottom" ? (c.v.edge = S, c.v.offset = x) : S === "left" ? c.h.offset = x : S === "top" && (c.v.offset = x);
                } else {
                  if (o.length !== 1 && o.length !== 2) return null;
                  d === 1 ? c.h.offset = S : c.v.offset = S;
                }
              }
              return c;
            }, C.ComputedLength = function(m, o) {
              this.rw = m, this.rh = o;
            }, C.ComputedLength.prototype.toUsedLength = function(m, o) {
              return m * this.rw + o * this.rh;
            }, C.ComputedLength.prototype.isZero = function() {
              return this.rw === 0 && this.rh === 0;
            }, C.toComputedLength = function(m, o, E, h, n, c) {
              return o === "%" && h ? new C.ComputedLength(h.rw * m / 100, h.rh * m / 100) : o === "em" && E ? new C.ComputedLength(E.rw * m, E.rh * m) : o === "c" && n ? new C.ComputedLength(m * n.rw, m * n.rh) : o === "px" && c ? new C.ComputedLength(m * c.rw, m * c.rh) : o === "rh" ? new C.ComputedLength(0, m / 100) : o === "rw" ? new C.ComputedLength(m / 100, 0) : null;
            };
          })(Ee);
        }, 3516: function(Pe) {
          Pe.exports = function(Ee) {
            var C = typeof Ee == "string" ? Ee.charCodeAt(0) : Ee;
            return C >= 97 && C <= 122 || C >= 65 && C <= 90;
          };
        }, 2219: function(Pe, Ee, C) {
          var ie = C(3516), T = C(395);
          Pe.exports = function(t) {
            return ie(t) || T(t);
          };
        }, 395: function(Pe) {
          Pe.exports = function(Ee) {
            var C = typeof Ee == "string" ? Ee.charCodeAt(0) : Ee;
            return C >= 48 && C <= 57;
          };
        }, 3875: function(Pe) {
          function Ee(T) {
            if (typeof T != "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(T));
          }
          function C(T, t) {
            for (var e, p = "", m = 0, o = -1, E = 0, h = 0; h <= T.length; ++h) {
              if (h < T.length) e = T.charCodeAt(h);
              else {
                if (e === 47) break;
                e = 47;
              }
              if (e === 47) {
                if (!(o === h - 1 || E === 1)) if (o !== h - 1 && E === 2) {
                  if (p.length < 2 || m !== 2 || p.charCodeAt(p.length - 1) !== 46 || p.charCodeAt(p.length - 2) !== 46) {
                    if (p.length > 2) {
                      var n = p.lastIndexOf("/");
                      if (n !== p.length - 1) {
                        n === -1 ? (p = "", m = 0) : m = (p = p.slice(0, n)).length - 1 - p.lastIndexOf("/"), o = h, E = 0;
                        continue;
                      }
                    } else if (p.length === 2 || p.length === 1) {
                      p = "", m = 0, o = h, E = 0;
                      continue;
                    }
                  }
                  t && (p.length > 0 ? p += "/.." : p = "..", m = 2);
                } else p.length > 0 ? p += "/" + T.slice(o + 1, h) : p = T.slice(o + 1, h), m = h - o - 1;
                o = h, E = 0;
              } else e === 46 && E !== -1 ? ++E : E = -1;
            }
            return p;
          }
          var ie = { resolve: function() {
            for (var T, t = "", e = !1, p = arguments.length - 1; p >= -1 && !e; p--) {
              var m;
              p >= 0 ? m = arguments[p] : (T === void 0 && (T = process.cwd()), m = T), Ee(m), m.length !== 0 && (t = m + "/" + t, e = m.charCodeAt(0) === 47);
            }
            return t = C(t, !e), e ? t.length > 0 ? "/" + t : "/" : t.length > 0 ? t : ".";
          }, normalize: function(T) {
            if (Ee(T), T.length === 0) return ".";
            var t = T.charCodeAt(0) === 47, e = T.charCodeAt(T.length - 1) === 47;
            return (T = C(T, !t)).length !== 0 || t || (T = "."), T.length > 0 && e && (T += "/"), t ? "/" + T : T;
          }, isAbsolute: function(T) {
            return Ee(T), T.length > 0 && T.charCodeAt(0) === 47;
          }, join: function() {
            if (arguments.length === 0) return ".";
            for (var T, t = 0; t < arguments.length; ++t) {
              var e = arguments[t];
              Ee(e), e.length > 0 && (T === void 0 ? T = e : T += "/" + e);
            }
            return T === void 0 ? "." : ie.normalize(T);
          }, relative: function(T, t) {
            if (Ee(T), Ee(t), T === t || (T = ie.resolve(T)) === (t = ie.resolve(t))) return "";
            for (var e = 1; e < T.length && T.charCodeAt(e) === 47; ++e) ;
            for (var p = T.length, m = p - e, o = 1; o < t.length && t.charCodeAt(o) === 47; ++o) ;
            for (var E = t.length - o, h = m < E ? m : E, n = -1, c = 0; c <= h; ++c) {
              if (c === h) {
                if (E > h) {
                  if (t.charCodeAt(o + c) === 47) return t.slice(o + c + 1);
                  if (c === 0) return t.slice(o + c);
                } else m > h && (T.charCodeAt(e + c) === 47 ? n = c : c === 0 && (n = 0));
                break;
              }
              var d = T.charCodeAt(e + c);
              if (d !== t.charCodeAt(o + c)) break;
              d === 47 && (n = c);
            }
            var S = "";
            for (c = e + n + 1; c <= p; ++c) c !== p && T.charCodeAt(c) !== 47 || (S.length === 0 ? S += ".." : S += "/..");
            return S.length > 0 ? S + t.slice(o + n) : (o += n, t.charCodeAt(o) === 47 && ++o, t.slice(o));
          }, _makeLong: function(T) {
            return T;
          }, dirname: function(T) {
            if (Ee(T), T.length === 0) return ".";
            for (var t = T.charCodeAt(0), e = t === 47, p = -1, m = !0, o = T.length - 1; o >= 1; --o) if ((t = T.charCodeAt(o)) === 47) {
              if (!m) {
                p = o;
                break;
              }
            } else m = !1;
            return p === -1 ? e ? "/" : "." : e && p === 1 ? "//" : T.slice(0, p);
          }, basename: function(T, t) {
            if (t !== void 0 && typeof t != "string") throw new TypeError('"ext" argument must be a string');
            Ee(T);
            var e, p = 0, m = -1, o = !0;
            if (t !== void 0 && t.length > 0 && t.length <= T.length) {
              if (t.length === T.length && t === T) return "";
              var E = t.length - 1, h = -1;
              for (e = T.length - 1; e >= 0; --e) {
                var n = T.charCodeAt(e);
                if (n === 47) {
                  if (!o) {
                    p = e + 1;
                    break;
                  }
                } else h === -1 && (o = !1, h = e + 1), E >= 0 && (n === t.charCodeAt(E) ? --E == -1 && (m = e) : (E = -1, m = h));
              }
              return p === m ? m = h : m === -1 && (m = T.length), T.slice(p, m);
            }
            for (e = T.length - 1; e >= 0; --e) if (T.charCodeAt(e) === 47) {
              if (!o) {
                p = e + 1;
                break;
              }
            } else m === -1 && (o = !1, m = e + 1);
            return m === -1 ? "" : T.slice(p, m);
          }, extname: function(T) {
            Ee(T);
            for (var t = -1, e = 0, p = -1, m = !0, o = 0, E = T.length - 1; E >= 0; --E) {
              var h = T.charCodeAt(E);
              if (h !== 47) p === -1 && (m = !1, p = E + 1), h === 46 ? t === -1 ? t = E : o !== 1 && (o = 1) : t !== -1 && (o = -1);
              else if (!m) {
                e = E + 1;
                break;
              }
            }
            return t === -1 || p === -1 || o === 0 || o === 1 && t === p - 1 && t === e + 1 ? "" : T.slice(t, p);
          }, format: function(T) {
            if (T === null || typeof T != "object") throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof T);
            return function(t, e) {
              var p = e.dir || e.root, m = e.base || (e.name || "") + (e.ext || "");
              return p ? p === e.root ? p + m : p + "/" + m : m;
            }(0, T);
          }, parse: function(T) {
            Ee(T);
            var t = { root: "", dir: "", base: "", ext: "", name: "" };
            if (T.length === 0) return t;
            var e, p = T.charCodeAt(0), m = p === 47;
            m ? (t.root = "/", e = 1) : e = 0;
            for (var o = -1, E = 0, h = -1, n = !0, c = T.length - 1, d = 0; c >= e; --c) if ((p = T.charCodeAt(c)) !== 47) h === -1 && (n = !1, h = c + 1), p === 46 ? o === -1 ? o = c : d !== 1 && (d = 1) : o !== -1 && (d = -1);
            else if (!n) {
              E = c + 1;
              break;
            }
            return o === -1 || h === -1 || d === 0 || d === 1 && o === h - 1 && o === E + 1 ? h !== -1 && (t.base = t.name = E === 0 && m ? T.slice(1, h) : T.slice(E, h)) : (E === 0 && m ? (t.name = T.slice(1, o), t.base = T.slice(1, h)) : (t.name = T.slice(E, o), t.base = T.slice(E, h)), t.ext = T.slice(o, h)), E > 0 ? t.dir = T.slice(0, E - 1) : m && (t.dir = "/"), t;
          }, sep: "/", delimiter: ":", win32: null, posix: null };
          ie.posix = ie, Pe.exports = ie;
        }, 8387: function(Pe, Ee, C) {
          var ie = C(1549), T = ie.Buffer;
          function t(p, m) {
            for (var o in p) m[o] = p[o];
          }
          function e(p, m, o) {
            return T(p, m, o);
          }
          T.from && T.alloc && T.allocUnsafe && T.allocUnsafeSlow ? Pe.exports = ie : (t(ie, Ee), Ee.Buffer = e), t(T, e), e.from = function(p, m, o) {
            if (typeof p == "number") throw new TypeError("Argument must not be a number");
            return T(p, m, o);
          }, e.alloc = function(p, m, o) {
            if (typeof p != "number") throw new TypeError("Argument must be a number");
            var E = T(p);
            return m !== void 0 ? typeof o == "string" ? E.fill(m, o) : E.fill(m) : E.fill(0), E;
          }, e.allocUnsafe = function(p) {
            if (typeof p != "number") throw new TypeError("Argument must be a number");
            return T(p);
          }, e.allocUnsafeSlow = function(p) {
            if (typeof p != "number") throw new TypeError("Argument must be a number");
            return ie.SlowBuffer(p);
          };
        }, 5378: function(Pe, Ee, C) {
          (function(ie) {
            ie.parser = function(f, u) {
              return new e(f, u);
            }, ie.SAXParser = e, ie.SAXStream = m, ie.createStream = function(f, u) {
              return new m(f, u);
            }, ie.MAX_BUFFER_LENGTH = 65536;
            var T, t = ["comment", "sgmlDecl", "textNode", "tagName", "doctype", "procInstName", "procInstBody", "entity", "attribName", "attribValue", "cdata", "script"];
            function e(f, u) {
              if (!(this instanceof e)) return new e(f, u);
              var v = this;
              (function(b) {
                for (var W = 0, Y = t.length; W < Y; W++) b[t[W]] = "";
              })(v), v.q = v.c = "", v.bufferCheckPosition = ie.MAX_BUFFER_LENGTH, v.opt = u || {}, v.opt.lowercase = v.opt.lowercase || v.opt.lowercasetags, v.looseCase = v.opt.lowercase ? "toLowerCase" : "toUpperCase", v.tags = [], v.closed = v.closedRoot = v.sawRoot = !1, v.tag = v.error = null, v.strict = !!f, v.noscript = !(!f && !v.opt.noscript), v.state = Q.BEGIN, v.strictEntities = v.opt.strictEntities, v.ENTITIES = v.strictEntities ? Object.create(ie.XML_ENTITIES) : Object.create(ie.ENTITIES), v.attribList = [], v.opt.xmlns && (v.ns = Object.create(x)), v.trackPosition = v.opt.position !== !1, v.trackPosition && (v.position = v.line = v.column = 0), Ue(v, "onready");
            }
            ie.EVENTS = ["text", "processinginstruction", "sgmldeclaration", "doctype", "comment", "opentagstart", "attribute", "opentag", "closetag", "opencdata", "cdata", "closecdata", "error", "end", "ready", "script", "opennamespace", "closenamespace"], Object.create || (Object.create = function(f) {
              function u() {
              }
              return u.prototype = f, new u();
            }), Object.keys || (Object.keys = function(f) {
              var u = [];
              for (var v in f) f.hasOwnProperty(v) && u.push(v);
              return u;
            }), e.prototype = { end: function() {
              at(this);
            }, write: function(f) {
              var u = this;
              if (this.error) throw this.error;
              if (u.closed) return We(u, "Cannot write after close. Assign an onready handler.");
              if (f === null) return at(u);
              typeof f == "object" && (f = f.toString());
              for (var v = 0, b = ""; b = Ve(f, v++), u.c = b, b; ) switch (u.trackPosition && (u.position++, b === `
` ? (u.line++, u.column = 0) : u.column++), u.state) {
                case Q.BEGIN:
                  if (u.state = Q.BEGIN_WHITESPACE, b === "\uFEFF") continue;
                  ye(u, b);
                  continue;
                case Q.BEGIN_WHITESPACE:
                  ye(u, b);
                  continue;
                case Q.TEXT:
                  if (u.sawRoot && !u.closedRoot) {
                    for (var W = v - 1; b && b !== "<" && b !== "&"; ) (b = Ve(f, v++)) && u.trackPosition && (u.position++, b === `
` ? (u.line++, u.column = 0) : u.column++);
                    u.textNode += f.substring(W, v - 1);
                  }
                  b !== "<" || u.sawRoot && u.closedRoot && !u.strict ? (!j(o, b) || u.sawRoot && !u.closedRoot || Se(u, "Text data outside of root node."), b === "&" ? u.state = Q.TEXT_ENTITY : u.textNode += b) : (u.state = Q.OPEN_WAKA, u.startTagPosition = u.position);
                  continue;
                case Q.SCRIPT:
                  b === "<" ? u.state = Q.SCRIPT_ENDING : u.script += b;
                  continue;
                case Q.SCRIPT_ENDING:
                  b === "/" ? u.state = Q.CLOSE_TAG : (u.script += "<" + b, u.state = Q.SCRIPT);
                  continue;
                case Q.OPEN_WAKA:
                  if (b === "!") u.state = Q.SGML_DECL, u.sgmlDecl = "";
                  else if (!ae(o, b)) if (ae(B, b)) u.state = Q.OPEN_TAG, u.tagName = b;
                  else if (b === "/") u.state = Q.CLOSE_TAG, u.tagName = "";
                  else if (b === "?") u.state = Q.PROC_INST, u.procInstName = u.procInstBody = "";
                  else {
                    if (Se(u, "Unencoded <"), u.startTagPosition + 1 < u.position) {
                      var Y = u.position - u.startTagPosition;
                      b = new Array(Y).join(" ") + b;
                    }
                    u.textNode += "<" + b, u.state = Q.TEXT;
                  }
                  continue;
                case Q.SGML_DECL:
                  (u.sgmlDecl + b).toUpperCase() === "[CDATA[" ? (ze(u, "onopencdata"), u.state = Q.CDATA, u.sgmlDecl = "", u.cdata = "") : u.sgmlDecl + b === "--" ? (u.state = Q.COMMENT, u.comment = "", u.sgmlDecl = "") : (u.sgmlDecl + b).toUpperCase() === "DOCTYPE" ? (u.state = Q.DOCTYPE, (u.doctype || u.sawRoot) && Se(u, "Inappropriately located doctype declaration"), u.doctype = "", u.sgmlDecl = "") : b === ">" ? (ze(u, "onsgmldeclaration", u.sgmlDecl), u.sgmlDecl = "", u.state = Q.TEXT) : (ae(n, b) && (u.state = Q.SGML_DECL_QUOTED), u.sgmlDecl += b);
                  continue;
                case Q.SGML_DECL_QUOTED:
                  b === u.q && (u.state = Q.SGML_DECL, u.q = ""), u.sgmlDecl += b;
                  continue;
                case Q.DOCTYPE:
                  b === ">" ? (u.state = Q.TEXT, ze(u, "ondoctype", u.doctype), u.doctype = !0) : (u.doctype += b, b === "[" ? u.state = Q.DOCTYPE_DTD : ae(n, b) && (u.state = Q.DOCTYPE_QUOTED, u.q = b));
                  continue;
                case Q.DOCTYPE_QUOTED:
                  u.doctype += b, b === u.q && (u.q = "", u.state = Q.DOCTYPE);
                  continue;
                case Q.DOCTYPE_DTD:
                  u.doctype += b, b === "]" ? u.state = Q.DOCTYPE : ae(n, b) && (u.state = Q.DOCTYPE_DTD_QUOTED, u.q = b);
                  continue;
                case Q.DOCTYPE_DTD_QUOTED:
                  u.doctype += b, b === u.q && (u.state = Q.DOCTYPE_DTD, u.q = "");
                  continue;
                case Q.COMMENT:
                  b === "-" ? u.state = Q.COMMENT_ENDING : u.comment += b;
                  continue;
                case Q.COMMENT_ENDING:
                  b === "-" ? (u.state = Q.COMMENT_ENDED, u.comment = Oe(u.opt, u.comment), u.comment && ze(u, "oncomment", u.comment), u.comment = "") : (u.comment += "-" + b, u.state = Q.COMMENT);
                  continue;
                case Q.COMMENT_ENDED:
                  b !== ">" ? (Se(u, "Malformed comment"), u.comment += "--" + b, u.state = Q.COMMENT) : u.state = Q.TEXT;
                  continue;
                case Q.CDATA:
                  b === "]" ? u.state = Q.CDATA_ENDING : u.cdata += b;
                  continue;
                case Q.CDATA_ENDING:
                  b === "]" ? u.state = Q.CDATA_ENDING_2 : (u.cdata += "]" + b, u.state = Q.CDATA);
                  continue;
                case Q.CDATA_ENDING_2:
                  b === ">" ? (u.cdata && ze(u, "oncdata", u.cdata), ze(u, "onclosecdata"), u.cdata = "", u.state = Q.TEXT) : b === "]" ? u.cdata += "]" : (u.cdata += "]]" + b, u.state = Q.CDATA);
                  continue;
                case Q.PROC_INST:
                  b === "?" ? u.state = Q.PROC_INST_ENDING : ae(o, b) ? u.state = Q.PROC_INST_BODY : u.procInstName += b;
                  continue;
                case Q.PROC_INST_BODY:
                  if (!u.procInstBody && ae(o, b)) continue;
                  b === "?" ? u.state = Q.PROC_INST_ENDING : u.procInstBody += b;
                  continue;
                case Q.PROC_INST_ENDING:
                  b === ">" ? (ze(u, "onprocessinginstruction", { name: u.procInstName, body: u.procInstBody }), u.procInstName = u.procInstBody = "", u.state = Q.TEXT) : (u.procInstBody += "?" + b, u.state = Q.PROC_INST_BODY);
                  continue;
                case Q.OPEN_TAG:
                  ae(L, b) ? u.tagName += b : (ke(u), b === ">" ? qe(u) : b === "/" ? u.state = Q.OPEN_TAG_SLASH : (j(o, b) && Se(u, "Invalid character in tag name"), u.state = Q.ATTRIB));
                  continue;
                case Q.OPEN_TAG_SLASH:
                  b === ">" ? (qe(u, !0), it(u)) : (Se(u, "Forward-slash in opening tag not followed by >"), u.state = Q.ATTRIB);
                  continue;
                case Q.ATTRIB:
                  if (ae(o, b)) continue;
                  b === ">" ? qe(u) : b === "/" ? u.state = Q.OPEN_TAG_SLASH : ae(B, b) ? (u.attribName = b, u.attribValue = "", u.state = Q.ATTRIB_NAME) : Se(u, "Invalid attribute name");
                  continue;
                case Q.ATTRIB_NAME:
                  b === "=" ? u.state = Q.ATTRIB_VALUE : b === ">" ? (Se(u, "Attribute without value"), u.attribValue = u.attribName, _t(u), qe(u)) : ae(o, b) ? u.state = Q.ATTRIB_NAME_SAW_WHITE : ae(L, b) ? u.attribName += b : Se(u, "Invalid attribute name");
                  continue;
                case Q.ATTRIB_NAME_SAW_WHITE:
                  if (b === "=") u.state = Q.ATTRIB_VALUE;
                  else {
                    if (ae(o, b)) continue;
                    Se(u, "Attribute without value"), u.tag.attributes[u.attribName] = "", u.attribValue = "", ze(u, "onattribute", { name: u.attribName, value: "" }), u.attribName = "", b === ">" ? qe(u) : ae(B, b) ? (u.attribName = b, u.state = Q.ATTRIB_NAME) : (Se(u, "Invalid attribute name"), u.state = Q.ATTRIB);
                  }
                  continue;
                case Q.ATTRIB_VALUE:
                  if (ae(o, b)) continue;
                  ae(n, b) ? (u.q = b, u.state = Q.ATTRIB_VALUE_QUOTED) : (Se(u, "Unquoted attribute value"), u.state = Q.ATTRIB_VALUE_UNQUOTED, u.attribValue = b);
                  continue;
                case Q.ATTRIB_VALUE_QUOTED:
                  if (b !== u.q) {
                    b === "&" ? u.state = Q.ATTRIB_VALUE_ENTITY_Q : u.attribValue += b;
                    continue;
                  }
                  _t(u), u.q = "", u.state = Q.ATTRIB_VALUE_CLOSED;
                  continue;
                case Q.ATTRIB_VALUE_CLOSED:
                  ae(o, b) ? u.state = Q.ATTRIB : b === ">" ? qe(u) : b === "/" ? u.state = Q.OPEN_TAG_SLASH : ae(B, b) ? (Se(u, "No whitespace between attributes"), u.attribName = b, u.attribValue = "", u.state = Q.ATTRIB_NAME) : Se(u, "Invalid attribute name");
                  continue;
                case Q.ATTRIB_VALUE_UNQUOTED:
                  if (j(c, b)) {
                    b === "&" ? u.state = Q.ATTRIB_VALUE_ENTITY_U : u.attribValue += b;
                    continue;
                  }
                  _t(u), b === ">" ? qe(u) : u.state = Q.ATTRIB;
                  continue;
                case Q.CLOSE_TAG:
                  if (u.tagName) b === ">" ? it(u) : ae(L, b) ? u.tagName += b : u.script ? (u.script += "</" + u.tagName, u.tagName = "", u.state = Q.SCRIPT) : (j(o, b) && Se(u, "Invalid tagname in closing tag"), u.state = Q.CLOSE_TAG_SAW_WHITE);
                  else {
                    if (ae(o, b)) continue;
                    j(B, b) ? u.script ? (u.script += "</" + b, u.state = Q.SCRIPT) : Se(u, "Invalid tagname in closing tag.") : u.tagName = b;
                  }
                  continue;
                case Q.CLOSE_TAG_SAW_WHITE:
                  if (ae(o, b)) continue;
                  b === ">" ? it(u) : Se(u, "Invalid characters in closing tag");
                  continue;
                case Q.TEXT_ENTITY:
                case Q.ATTRIB_VALUE_ENTITY_Q:
                case Q.ATTRIB_VALUE_ENTITY_U:
                  var Re, Je;
                  switch (u.state) {
                    case Q.TEXT_ENTITY:
                      Re = Q.TEXT, Je = "textNode";
                      break;
                    case Q.ATTRIB_VALUE_ENTITY_Q:
                      Re = Q.ATTRIB_VALUE_QUOTED, Je = "attribValue";
                      break;
                    case Q.ATTRIB_VALUE_ENTITY_U:
                      Re = Q.ATTRIB_VALUE_UNQUOTED, Je = "attribValue";
                  }
                  b === ";" ? (u[Je] += me(u), u.entity = "", u.state = Re) : ae(u.entity.length ? M : $, b) ? u.entity += b : (Se(u, "Invalid character in entity name"), u[Je] += "&" + u.entity + b, u.entity = "", u.state = Re);
                  continue;
                default:
                  throw new Error(u, "Unknown state: " + u.state);
              }
              return u.position >= u.bufferCheckPosition && function(Ze) {
                for (var Fe = Math.max(ie.MAX_BUFFER_LENGTH, 10), we = 0, Ge = 0, nt = t.length; Ge < nt; Ge++) {
                  var Tt = Ze[t[Ge]].length;
                  if (Tt > Fe) switch (t[Ge]) {
                    case "textNode":
                      Te(Ze);
                      break;
                    case "cdata":
                      ze(Ze, "oncdata", Ze.cdata), Ze.cdata = "";
                      break;
                    case "script":
                      ze(Ze, "onscript", Ze.script), Ze.script = "";
                      break;
                    default:
                      We(Ze, "Max buffer length exceeded: " + t[Ge]);
                  }
                  we = Math.max(we, Tt);
                }
                var ft = ie.MAX_BUFFER_LENGTH - we;
                Ze.bufferCheckPosition = ft + Ze.position;
              }(u), u;
            }, resume: function() {
              return this.error = null, this;
            }, close: function() {
              return this.write(null);
            }, flush: function() {
              var f;
              Te(f = this), f.cdata !== "" && (ze(f, "oncdata", f.cdata), f.cdata = ""), f.script !== "" && (ze(f, "onscript", f.script), f.script = "");
            } };
            try {
              T = C(182).Stream;
            } catch {
              T = function() {
              };
            }
            var p = ie.EVENTS.filter(function(f) {
              return f !== "error" && f !== "end";
            });
            function m(f, u) {
              if (!(this instanceof m)) return new m(f, u);
              T.apply(this), this._parser = new e(f, u), this.writable = !0, this.readable = !0;
              var v = this;
              this._parser.onend = function() {
                v.emit("end");
              }, this._parser.onerror = function(b) {
                v.emit("error", b), v._parser.error = null;
              }, this._decoder = null, p.forEach(function(b) {
                Object.defineProperty(v, "on" + b, { get: function() {
                  return v._parser["on" + b];
                }, set: function(W) {
                  if (!W) return v.removeAllListeners(b), v._parser["on" + b] = W, W;
                  v.on(b, W);
                }, enumerable: !0, configurable: !1 });
              });
            }
            m.prototype = Object.create(T.prototype, { constructor: { value: m } }), m.prototype.write = function(f) {
              if (typeof Buffer == "function" && typeof Buffer.isBuffer == "function" && Buffer.isBuffer(f)) {
                if (!this._decoder) {
                  var u = C(7503).s;
                  this._decoder = new u("utf8");
                }
                f = this._decoder.write(f);
              }
              return this._parser.write(f.toString()), this.emit("data", f), !0;
            }, m.prototype.end = function(f) {
              return f && f.length && this.write(f), this._parser.end(), !0;
            }, m.prototype.on = function(f, u) {
              var v = this;
              return v._parser["on" + f] || p.indexOf(f) === -1 || (v._parser["on" + f] = function() {
                var b = arguments.length === 1 ? [arguments[0]] : Array.apply(null, arguments);
                b.splice(0, 0, f), v.emit.apply(v, b);
              }), T.prototype.on.call(v, f, u);
            };
            var o = `\r
	 `, E = "0124356789", h = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ", n = `'"`, c = o + ">", d = "http://www.w3.org/XML/1998/namespace", S = "http://www.w3.org/2000/xmlns/", x = { xml: d, xmlns: S };
            o = K(o), E = K(E), h = K(h);
            var B = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, L = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040\.\d-]/, $ = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, M = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040\.\d-]/;
            function K(f) {
              return f.split("").reduce(function(u, v) {
                return u[v] = !0, u;
              }, {});
            }
            function ae(f, u) {
              return function(v) {
                return Object.prototype.toString.call(v) === "[object RegExp]";
              }(f) ? !!u.match(f) : f[u];
            }
            function j(f, u) {
              return !ae(f, u);
            }
            n = K(n), c = K(c);
            var ee, ue, Ae, Q = 0;
            for (var Ne in ie.STATE = { BEGIN: Q++, BEGIN_WHITESPACE: Q++, TEXT: Q++, TEXT_ENTITY: Q++, OPEN_WAKA: Q++, SGML_DECL: Q++, SGML_DECL_QUOTED: Q++, DOCTYPE: Q++, DOCTYPE_QUOTED: Q++, DOCTYPE_DTD: Q++, DOCTYPE_DTD_QUOTED: Q++, COMMENT_STARTING: Q++, COMMENT: Q++, COMMENT_ENDING: Q++, COMMENT_ENDED: Q++, CDATA: Q++, CDATA_ENDING: Q++, CDATA_ENDING_2: Q++, PROC_INST: Q++, PROC_INST_BODY: Q++, PROC_INST_ENDING: Q++, OPEN_TAG: Q++, OPEN_TAG_SLASH: Q++, ATTRIB: Q++, ATTRIB_NAME: Q++, ATTRIB_NAME_SAW_WHITE: Q++, ATTRIB_VALUE: Q++, ATTRIB_VALUE_QUOTED: Q++, ATTRIB_VALUE_CLOSED: Q++, ATTRIB_VALUE_UNQUOTED: Q++, ATTRIB_VALUE_ENTITY_Q: Q++, ATTRIB_VALUE_ENTITY_U: Q++, CLOSE_TAG: Q++, CLOSE_TAG_SAW_WHITE: Q++, SCRIPT: Q++, SCRIPT_ENDING: Q++ }, ie.XML_ENTITIES = { amp: "&", gt: ">", lt: "<", quot: '"', apos: "'" }, ie.ENTITIES = { amp: "&", gt: ">", lt: "<", quot: '"', apos: "'", AElig: 198, Aacute: 193, Acirc: 194, Agrave: 192, Aring: 197, Atilde: 195, Auml: 196, Ccedil: 199, ETH: 208, Eacute: 201, Ecirc: 202, Egrave: 200, Euml: 203, Iacute: 205, Icirc: 206, Igrave: 204, Iuml: 207, Ntilde: 209, Oacute: 211, Ocirc: 212, Ograve: 210, Oslash: 216, Otilde: 213, Ouml: 214, THORN: 222, Uacute: 218, Ucirc: 219, Ugrave: 217, Uuml: 220, Yacute: 221, aacute: 225, acirc: 226, aelig: 230, agrave: 224, aring: 229, atilde: 227, auml: 228, ccedil: 231, eacute: 233, ecirc: 234, egrave: 232, eth: 240, euml: 235, iacute: 237, icirc: 238, igrave: 236, iuml: 239, ntilde: 241, oacute: 243, ocirc: 244, ograve: 242, oslash: 248, otilde: 245, ouml: 246, szlig: 223, thorn: 254, uacute: 250, ucirc: 251, ugrave: 249, uuml: 252, yacute: 253, yuml: 255, copy: 169, reg: 174, nbsp: 160, iexcl: 161, cent: 162, pound: 163, curren: 164, yen: 165, brvbar: 166, sect: 167, uml: 168, ordf: 170, laquo: 171, not: 172, shy: 173, macr: 175, deg: 176, plusmn: 177, sup1: 185, sup2: 178, sup3: 179, acute: 180, micro: 181, para: 182, middot: 183, cedil: 184, ordm: 186, raquo: 187, frac14: 188, frac12: 189, frac34: 190, iquest: 191, times: 215, divide: 247, OElig: 338, oelig: 339, Scaron: 352, scaron: 353, Yuml: 376, fnof: 402, circ: 710, tilde: 732, Alpha: 913, Beta: 914, Gamma: 915, Delta: 916, Epsilon: 917, Zeta: 918, Eta: 919, Theta: 920, Iota: 921, Kappa: 922, Lambda: 923, Mu: 924, Nu: 925, Xi: 926, Omicron: 927, Pi: 928, Rho: 929, Sigma: 931, Tau: 932, Upsilon: 933, Phi: 934, Chi: 935, Psi: 936, Omega: 937, alpha: 945, beta: 946, gamma: 947, delta: 948, epsilon: 949, zeta: 950, eta: 951, theta: 952, iota: 953, kappa: 954, lambda: 955, mu: 956, nu: 957, xi: 958, omicron: 959, pi: 960, rho: 961, sigmaf: 962, sigma: 963, tau: 964, upsilon: 965, phi: 966, chi: 967, psi: 968, omega: 969, thetasym: 977, upsih: 978, piv: 982, ensp: 8194, emsp: 8195, thinsp: 8201, zwnj: 8204, zwj: 8205, lrm: 8206, rlm: 8207, ndash: 8211, mdash: 8212, lsquo: 8216, rsquo: 8217, sbquo: 8218, ldquo: 8220, rdquo: 8221, bdquo: 8222, dagger: 8224, Dagger: 8225, bull: 8226, hellip: 8230, permil: 8240, prime: 8242, Prime: 8243, lsaquo: 8249, rsaquo: 8250, oline: 8254, frasl: 8260, euro: 8364, image: 8465, weierp: 8472, real: 8476, trade: 8482, alefsym: 8501, larr: 8592, uarr: 8593, rarr: 8594, darr: 8595, harr: 8596, crarr: 8629, lArr: 8656, uArr: 8657, rArr: 8658, dArr: 8659, hArr: 8660, forall: 8704, part: 8706, exist: 8707, empty: 8709, nabla: 8711, isin: 8712, notin: 8713, ni: 8715, prod: 8719, sum: 8721, minus: 8722, lowast: 8727, radic: 8730, prop: 8733, infin: 8734, ang: 8736, and: 8743, or: 8744, cap: 8745, cup: 8746, int: 8747, there4: 8756, sim: 8764, cong: 8773, asymp: 8776, ne: 8800, equiv: 8801, le: 8804, ge: 8805, sub: 8834, sup: 8835, nsub: 8836, sube: 8838, supe: 8839, oplus: 8853, otimes: 8855, perp: 8869, sdot: 8901, lceil: 8968, rceil: 8969, lfloor: 8970, rfloor: 8971, lang: 9001, rang: 9002, loz: 9674, spades: 9824, clubs: 9827, hearts: 9829, diams: 9830 }, Object.keys(ie.ENTITIES).forEach(function(f) {
              var u = ie.ENTITIES[f], v = typeof u == "number" ? String.fromCharCode(u) : u;
              ie.ENTITIES[f] = v;
            }), ie.STATE) ie.STATE[ie.STATE[Ne]] = Ne;
            function Ue(f, u, v) {
              f[u] && f[u](v);
            }
            function ze(f, u, v) {
              f.textNode && Te(f), Ue(f, u, v);
            }
            function Te(f) {
              f.textNode = Oe(f.opt, f.textNode), f.textNode && Ue(f, "ontext", f.textNode), f.textNode = "";
            }
            function Oe(f, u) {
              return f.trim && (u = u.trim()), f.normalize && (u = u.replace(/\s+/g, " ")), u;
            }
            function We(f, u) {
              return Te(f), f.trackPosition && (u += `
Line: ` + f.line + `
Column: ` + f.column + `
Char: ` + f.c), u = new Error(u), f.error = u, Ue(f, "onerror", u), f;
            }
            function at(f) {
              return f.sawRoot && !f.closedRoot && Se(f, "Unclosed root tag"), f.state !== Q.BEGIN && f.state !== Q.BEGIN_WHITESPACE && f.state !== Q.TEXT && We(f, "Unexpected end"), Te(f), f.c = "", f.closed = !0, Ue(f, "onend"), e.call(f, f.strict, f.opt), f;
            }
            function Se(f, u) {
              if (typeof f != "object" || !(f instanceof e)) throw new Error("bad call to strictFail");
              f.strict && We(f, u);
            }
            function ke(f) {
              f.strict || (f.tagName = f.tagName[f.looseCase]());
              var u = f.tags[f.tags.length - 1] || f, v = f.tag = { name: f.tagName, attributes: {} };
              f.opt.xmlns && (v.ns = u.ns), f.attribList.length = 0, ze(f, "onopentagstart", v);
            }
            function Rt(f, u) {
              var v = f.indexOf(":") < 0 ? ["", f] : f.split(":"), b = v[0], W = v[1];
              return u && f === "xmlns" && (b = "xmlns", W = ""), { prefix: b, local: W };
            }
            function _t(f) {
              if (f.strict || (f.attribName = f.attribName[f.looseCase]()), f.attribList.indexOf(f.attribName) !== -1 || f.tag.attributes.hasOwnProperty(f.attribName)) f.attribName = f.attribValue = "";
              else {
                if (f.opt.xmlns) {
                  var u = Rt(f.attribName, !0), v = u.prefix, b = u.local;
                  if (v === "xmlns") if (b === "xml" && f.attribValue !== d) Se(f, "xml: prefix must be bound to " + d + `
Actual: ` + f.attribValue);
                  else if (b === "xmlns" && f.attribValue !== S) Se(f, "xmlns: prefix must be bound to " + S + `
Actual: ` + f.attribValue);
                  else {
                    var W = f.tag, Y = f.tags[f.tags.length - 1] || f;
                    W.ns === Y.ns && (W.ns = Object.create(Y.ns)), W.ns[b] = f.attribValue;
                  }
                  f.attribList.push([f.attribName, f.attribValue]);
                } else f.tag.attributes[f.attribName] = f.attribValue, ze(f, "onattribute", { name: f.attribName, value: f.attribValue });
                f.attribName = f.attribValue = "";
              }
            }
            function qe(f, u) {
              if (f.opt.xmlns) {
                var v = f.tag, b = Rt(f.tagName);
                v.prefix = b.prefix, v.local = b.local, v.uri = v.ns[b.prefix] || "", v.prefix && !v.uri && (Se(f, "Unbound namespace prefix: " + JSON.stringify(f.tagName)), v.uri = b.prefix);
                var W = f.tags[f.tags.length - 1] || f;
                v.ns && W.ns !== v.ns && Object.keys(v.ns).forEach(function(Yt) {
                  ze(f, "onopennamespace", { prefix: Yt, uri: v.ns[Yt] });
                });
                for (var Y = 0, Re = f.attribList.length; Y < Re; Y++) {
                  var Je = f.attribList[Y], Ze = Je[0], Fe = Je[1], we = Rt(Ze, !0), Ge = we.prefix, nt = we.local, Tt = Ge === "" ? "" : v.ns[Ge] || "", ft = { name: Ze, value: Fe, prefix: Ge, local: nt, uri: Tt };
                  Ge && Ge !== "xmlns" && !Tt && (Se(f, "Unbound namespace prefix: " + JSON.stringify(Ge)), ft.uri = Ge), f.tag.attributes[Ze] = ft, ze(f, "onattribute", ft);
                }
                f.attribList.length = 0;
              }
              f.tag.isSelfClosing = !!u, f.sawRoot = !0, f.tags.push(f.tag), ze(f, "onopentag", f.tag), u || (f.noscript || f.tagName.toLowerCase() !== "script" ? f.state = Q.TEXT : f.state = Q.SCRIPT, f.tag = null, f.tagName = ""), f.attribName = f.attribValue = "", f.attribList.length = 0;
            }
            function it(f) {
              if (!f.tagName) return Se(f, "Weird empty close tag."), f.textNode += "</>", void (f.state = Q.TEXT);
              if (f.script) {
                if (f.tagName !== "script") return f.script += "</" + f.tagName + ">", f.tagName = "", void (f.state = Q.SCRIPT);
                ze(f, "onscript", f.script), f.script = "";
              }
              var u = f.tags.length, v = f.tagName;
              f.strict || (v = v[f.looseCase]());
              for (var b = v; u-- && f.tags[u].name !== b; ) Se(f, "Unexpected close tag");
              if (u < 0) return Se(f, "Unmatched closing tag: " + f.tagName), f.textNode += "</" + f.tagName + ">", void (f.state = Q.TEXT);
              f.tagName = v;
              for (var W = f.tags.length; W-- > u; ) {
                var Y = f.tag = f.tags.pop();
                f.tagName = f.tag.name, ze(f, "onclosetag", f.tagName);
                var Re = {};
                for (var Je in Y.ns) Re[Je] = Y.ns[Je];
                var Ze = f.tags[f.tags.length - 1] || f;
                f.opt.xmlns && Y.ns !== Ze.ns && Object.keys(Y.ns).forEach(function(Fe) {
                  var we = Y.ns[Fe];
                  ze(f, "onclosenamespace", { prefix: Fe, uri: we });
                });
              }
              u === 0 && (f.closedRoot = !0), f.tagName = f.attribValue = f.attribName = "", f.attribList.length = 0, f.state = Q.TEXT;
            }
            function me(f) {
              var u, v = f.entity, b = v.toLowerCase(), W = "";
              return f.ENTITIES[v] ? f.ENTITIES[v] : f.ENTITIES[b] ? f.ENTITIES[b] : ((v = b).charAt(0) === "#" && (v.charAt(1) === "x" ? (v = v.slice(2), W = (u = parseInt(v, 16)).toString(16)) : (v = v.slice(1), W = (u = parseInt(v, 10)).toString(10))), v = v.replace(/^0+/, ""), W.toLowerCase() !== v ? (Se(f, "Invalid character entity"), "&" + f.entity + ";") : String.fromCodePoint(u));
            }
            function ye(f, u) {
              u === "<" ? (f.state = Q.OPEN_WAKA, f.startTagPosition = f.position) : j(o, u) && (Se(f, "Non-whitespace before first tag."), f.textNode = u, f.state = Q.TEXT);
            }
            function Ve(f, u) {
              var v = "";
              return u < f.length && (v = f.charAt(u)), v;
            }
            Q = ie.STATE, String.fromCodePoint || (ee = String.fromCharCode, ue = Math.floor, Ae = function() {
              var f, u, v = 16384, b = [], W = -1, Y = arguments.length;
              if (!Y) return "";
              for (var Re = ""; ++W < Y; ) {
                var Je = Number(arguments[W]);
                if (!isFinite(Je) || Je < 0 || Je > 1114111 || ue(Je) !== Je) throw RangeError("Invalid code point: " + Je);
                Je <= 65535 ? b.push(Je) : (f = 55296 + ((Je -= 65536) >> 10), u = Je % 1024 + 56320, b.push(f, u)), (W + 1 === Y || b.length > v) && (Re += ee.apply(null, b), b.length = 0);
              }
              return Re;
            }, Object.defineProperty ? Object.defineProperty(String, "fromCodePoint", { value: Ae, configurable: !0, writable: !0 }) : String.fromCodePoint = Ae);
          })(Ee);
        }, 182: function(Pe, Ee, C) {
          Pe.exports = T;
          var ie = C(1159).EventEmitter;
          function T() {
            ie.call(this);
          }
          C(1765)(T, ie), T.Readable = C(2846), T.Writable = C(8318), T.Duplex = C(6138), T.Transform = C(9798), T.PassThrough = C(5472), T.finished = C(8800), T.pipeline = C(7295), T.Stream = T, T.prototype.pipe = function(t, e) {
            var p = this;
            function m(S) {
              t.writable && t.write(S) === !1 && p.pause && p.pause();
            }
            function o() {
              p.readable && p.resume && p.resume();
            }
            p.on("data", m), t.on("drain", o), t._isStdio || e && e.end === !1 || (p.on("end", h), p.on("close", n));
            var E = !1;
            function h() {
              E || (E = !0, t.end());
            }
            function n() {
              E || (E = !0, typeof t.destroy == "function" && t.destroy());
            }
            function c(S) {
              if (d(), ie.listenerCount(this, "error") === 0) throw S;
            }
            function d() {
              p.removeListener("data", m), t.removeListener("drain", o), p.removeListener("end", h), p.removeListener("close", n), p.removeListener("error", c), t.removeListener("error", c), p.removeListener("end", d), p.removeListener("close", d), t.removeListener("close", d);
            }
            return p.on("error", c), t.on("error", c), p.on("end", d), p.on("close", d), t.on("close", d), t.emit("pipe", p), t;
          };
        }, 1765: function(Pe) {
          typeof Object.create == "function" ? Pe.exports = function(Ee, C) {
            C && (Ee.super_ = C, Ee.prototype = Object.create(C.prototype, { constructor: { value: Ee, enumerable: !1, writable: !0, configurable: !0 } }));
          } : Pe.exports = function(Ee, C) {
            if (C) {
              Ee.super_ = C;
              var ie = function() {
              };
              ie.prototype = C.prototype, Ee.prototype = new ie(), Ee.prototype.constructor = Ee;
            }
          };
        }, 3690: function(Pe) {
          var Ee = {};
          function C(T, t, e) {
            e || (e = Error);
            var p = function(m) {
              var o, E;
              function h(n, c, d) {
                return m.call(this, function(S, x, B) {
                  return typeof t == "string" ? t : t(S, x, B);
                }(n, c, d)) || this;
              }
              return E = m, (o = h).prototype = Object.create(E.prototype), o.prototype.constructor = o, o.__proto__ = E, h;
            }(e);
            p.prototype.name = e.name, p.prototype.code = T, Ee[T] = p;
          }
          function ie(T, t) {
            if (Array.isArray(T)) {
              var e = T.length;
              return T = T.map(function(p) {
                return String(p);
              }), e > 2 ? "one of ".concat(t, " ").concat(T.slice(0, e - 1).join(", "), ", or ") + T[e - 1] : e === 2 ? "one of ".concat(t, " ").concat(T[0], " or ").concat(T[1]) : "of ".concat(t, " ").concat(T[0]);
            }
            return "of ".concat(t, " ").concat(String(T));
          }
          C("ERR_INVALID_OPT_VALUE", function(T, t) {
            return 'The value "' + t + '" is invalid for option "' + T + '"';
          }, TypeError), C("ERR_INVALID_ARG_TYPE", function(T, t, e) {
            var p, m, o, E, h;
            if (typeof t == "string" && (m = "not ", t.substr(0, m.length) === m) ? (p = "must not be", t = t.replace(/^not /, "")) : p = "must be", function(c, d, S) {
              return (S === void 0 || S > c.length) && (S = c.length), c.substring(S - d.length, S) === d;
            }(T, " argument")) o = "The ".concat(T, " ").concat(p, " ").concat(ie(t, "type"));
            else {
              var n = (typeof h != "number" && (h = 0), h + 1 > (E = T).length || E.indexOf(".", h) === -1 ? "argument" : "property");
              o = 'The "'.concat(T, '" ').concat(n, " ").concat(p, " ").concat(ie(t, "type"));
            }
            return o + ". Received type ".concat(typeof e);
          }, TypeError), C("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), C("ERR_METHOD_NOT_IMPLEMENTED", function(T) {
            return "The " + T + " method is not implemented";
          }), C("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), C("ERR_STREAM_DESTROYED", function(T) {
            return "Cannot call " + T + " after a stream was destroyed";
          }), C("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), C("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), C("ERR_STREAM_WRITE_AFTER_END", "write after end"), C("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), C("ERR_UNKNOWN_ENCODING", function(T) {
            return "Unknown encoding: " + T;
          }, TypeError), C("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), Pe.exports.q = Ee;
        }, 6138: function(Pe, Ee, C) {
          var ie = Object.keys || function(n) {
            var c = [];
            for (var d in n) c.push(d);
            return c;
          };
          Pe.exports = o;
          var T = C(2846), t = C(8318);
          C(1765)(o, T);
          for (var e = ie(t.prototype), p = 0; p < e.length; p++) {
            var m = e[p];
            o.prototype[m] || (o.prototype[m] = t.prototype[m]);
          }
          function o(n) {
            if (!(this instanceof o)) return new o(n);
            T.call(this, n), t.call(this, n), this.allowHalfOpen = !0, n && (n.readable === !1 && (this.readable = !1), n.writable === !1 && (this.writable = !1), n.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", E)));
          }
          function E() {
            this._writableState.ended || process.nextTick(h, this);
          }
          function h(n) {
            n.end();
          }
          Object.defineProperty(o.prototype, "writableHighWaterMark", { enumerable: !1, get: function() {
            return this._writableState.highWaterMark;
          } }), Object.defineProperty(o.prototype, "writableBuffer", { enumerable: !1, get: function() {
            return this._writableState && this._writableState.getBuffer();
          } }), Object.defineProperty(o.prototype, "writableLength", { enumerable: !1, get: function() {
            return this._writableState.length;
          } }), Object.defineProperty(o.prototype, "destroyed", { enumerable: !1, get: function() {
            return this._readableState !== void 0 && this._writableState !== void 0 && this._readableState.destroyed && this._writableState.destroyed;
          }, set: function(n) {
            this._readableState !== void 0 && this._writableState !== void 0 && (this._readableState.destroyed = n, this._writableState.destroyed = n);
          } });
        }, 5472: function(Pe, Ee, C) {
          Pe.exports = T;
          var ie = C(9798);
          function T(t) {
            if (!(this instanceof T)) return new T(t);
            ie.call(this, t);
          }
          C(1765)(T, ie), T.prototype._transform = function(t, e, p) {
            p(null, t);
          };
        }, 2846: function(Pe, Ee, C) {
          var ie;
          Pe.exports = ee, ee.ReadableState = j, C(1159).EventEmitter;
          var T, t = function(me, ye) {
            return me.listeners(ye).length;
          }, e = C(9299), p = C(1549).Buffer, m = C.g.Uint8Array || function() {
          }, o = C(964);
          T = o && o.debuglog ? o.debuglog("stream") : function() {
          };
          var E, h, n, c = C(8393), d = C(6163), S = C(7269).getHighWaterMark, x = C(3690).q, B = x.ERR_INVALID_ARG_TYPE, L = x.ERR_STREAM_PUSH_AFTER_EOF, $ = x.ERR_METHOD_NOT_IMPLEMENTED, M = x.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
          C(1765)(ee, e);
          var K = d.errorOrDestroy, ae = ["error", "close", "destroy", "pause", "resume"];
          function j(me, ye, Ve) {
            ie = ie || C(6138), me = me || {}, typeof Ve != "boolean" && (Ve = ye instanceof ie), this.objectMode = !!me.objectMode, Ve && (this.objectMode = this.objectMode || !!me.readableObjectMode), this.highWaterMark = S(this, me, "readableHighWaterMark", Ve), this.buffer = new c(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = me.emitClose !== !1, this.autoDestroy = !!me.autoDestroy, this.destroyed = !1, this.defaultEncoding = me.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, me.encoding && (E || (E = C(7503).s), this.decoder = new E(me.encoding), this.encoding = me.encoding);
          }
          function ee(me) {
            if (ie = ie || C(6138), !(this instanceof ee)) return new ee(me);
            var ye = this instanceof ie;
            this._readableState = new j(me, this, ye), this.readable = !0, me && (typeof me.read == "function" && (this._read = me.read), typeof me.destroy == "function" && (this._destroy = me.destroy)), e.call(this);
          }
          function ue(me, ye, Ve, f, u) {
            T("readableAddChunk", ye);
            var v, b = me._readableState;
            if (ye === null) b.reading = !1, function(W, Y) {
              if (T("onEofChunk"), !Y.ended) {
                if (Y.decoder) {
                  var Re = Y.decoder.end();
                  Re && Re.length && (Y.buffer.push(Re), Y.length += Y.objectMode ? 1 : Re.length);
                }
                Y.ended = !0, Y.sync ? Ue(W) : (Y.needReadable = !1, Y.emittedReadable || (Y.emittedReadable = !0, ze(W)));
              }
            }(me, b);
            else if (u || (v = function(W, Y) {
              var Re, Je;
              return Je = Y, p.isBuffer(Je) || Je instanceof m || typeof Y == "string" || Y === void 0 || W.objectMode || (Re = new B("chunk", ["string", "Buffer", "Uint8Array"], Y)), Re;
            }(b, ye)), v) K(me, v);
            else if (b.objectMode || ye && ye.length > 0) if (typeof ye == "string" || b.objectMode || Object.getPrototypeOf(ye) === p.prototype || (ye = function(W) {
              return p.from(W);
            }(ye)), f) b.endEmitted ? K(me, new M()) : Ae(me, b, ye, !0);
            else if (b.ended) K(me, new L());
            else {
              if (b.destroyed) return !1;
              b.reading = !1, b.decoder && !Ve ? (ye = b.decoder.write(ye), b.objectMode || ye.length !== 0 ? Ae(me, b, ye, !1) : Te(me, b)) : Ae(me, b, ye, !1);
            }
            else f || (b.reading = !1, Te(me, b));
            return !b.ended && (b.length < b.highWaterMark || b.length === 0);
          }
          function Ae(me, ye, Ve, f) {
            ye.flowing && ye.length === 0 && !ye.sync ? (ye.awaitDrain = 0, me.emit("data", Ve)) : (ye.length += ye.objectMode ? 1 : Ve.length, f ? ye.buffer.unshift(Ve) : ye.buffer.push(Ve), ye.needReadable && Ue(me)), Te(me, ye);
          }
          Object.defineProperty(ee.prototype, "destroyed", { enumerable: !1, get: function() {
            return this._readableState !== void 0 && this._readableState.destroyed;
          }, set: function(me) {
            this._readableState && (this._readableState.destroyed = me);
          } }), ee.prototype.destroy = d.destroy, ee.prototype._undestroy = d.undestroy, ee.prototype._destroy = function(me, ye) {
            ye(me);
          }, ee.prototype.push = function(me, ye) {
            var Ve, f = this._readableState;
            return f.objectMode ? Ve = !0 : typeof me == "string" && ((ye = ye || f.defaultEncoding) !== f.encoding && (me = p.from(me, ye), ye = ""), Ve = !0), ue(this, me, ye, !1, Ve);
          }, ee.prototype.unshift = function(me) {
            return ue(this, me, null, !0, !1);
          }, ee.prototype.isPaused = function() {
            return this._readableState.flowing === !1;
          }, ee.prototype.setEncoding = function(me) {
            E || (E = C(7503).s);
            var ye = new E(me);
            this._readableState.decoder = ye, this._readableState.encoding = this._readableState.decoder.encoding;
            for (var Ve = this._readableState.buffer.head, f = ""; Ve !== null; ) f += ye.write(Ve.data), Ve = Ve.next;
            return this._readableState.buffer.clear(), f !== "" && this._readableState.buffer.push(f), this._readableState.length = f.length, this;
          };
          var Q = 1073741824;
          function Ne(me, ye) {
            return me <= 0 || ye.length === 0 && ye.ended ? 0 : ye.objectMode ? 1 : me != me ? ye.flowing && ye.length ? ye.buffer.head.data.length : ye.length : (me > ye.highWaterMark && (ye.highWaterMark = function(Ve) {
              return Ve >= Q ? Ve = Q : (Ve--, Ve |= Ve >>> 1, Ve |= Ve >>> 2, Ve |= Ve >>> 4, Ve |= Ve >>> 8, Ve |= Ve >>> 16, Ve++), Ve;
            }(me)), me <= ye.length ? me : ye.ended ? ye.length : (ye.needReadable = !0, 0));
          }
          function Ue(me) {
            var ye = me._readableState;
            T("emitReadable", ye.needReadable, ye.emittedReadable), ye.needReadable = !1, ye.emittedReadable || (T("emitReadable", ye.flowing), ye.emittedReadable = !0, process.nextTick(ze, me));
          }
          function ze(me) {
            var ye = me._readableState;
            T("emitReadable_", ye.destroyed, ye.length, ye.ended), ye.destroyed || !ye.length && !ye.ended || (me.emit("readable"), ye.emittedReadable = !1), ye.needReadable = !ye.flowing && !ye.ended && ye.length <= ye.highWaterMark, ke(me);
          }
          function Te(me, ye) {
            ye.readingMore || (ye.readingMore = !0, process.nextTick(Oe, me, ye));
          }
          function Oe(me, ye) {
            for (; !ye.reading && !ye.ended && (ye.length < ye.highWaterMark || ye.flowing && ye.length === 0); ) {
              var Ve = ye.length;
              if (T("maybeReadMore read 0"), me.read(0), Ve === ye.length) break;
            }
            ye.readingMore = !1;
          }
          function We(me) {
            var ye = me._readableState;
            ye.readableListening = me.listenerCount("readable") > 0, ye.resumeScheduled && !ye.paused ? ye.flowing = !0 : me.listenerCount("data") > 0 && me.resume();
          }
          function at(me) {
            T("readable nexttick read 0"), me.read(0);
          }
          function Se(me, ye) {
            T("resume", ye.reading), ye.reading || me.read(0), ye.resumeScheduled = !1, me.emit("resume"), ke(me), ye.flowing && !ye.reading && me.read(0);
          }
          function ke(me) {
            var ye = me._readableState;
            for (T("flow", ye.flowing); ye.flowing && me.read() !== null; ) ;
          }
          function Rt(me, ye) {
            return ye.length === 0 ? null : (ye.objectMode ? Ve = ye.buffer.shift() : !me || me >= ye.length ? (Ve = ye.decoder ? ye.buffer.join("") : ye.buffer.length === 1 ? ye.buffer.first() : ye.buffer.concat(ye.length), ye.buffer.clear()) : Ve = ye.buffer.consume(me, ye.decoder), Ve);
            var Ve;
          }
          function _t(me) {
            var ye = me._readableState;
            T("endReadable", ye.endEmitted), ye.endEmitted || (ye.ended = !0, process.nextTick(qe, ye, me));
          }
          function qe(me, ye) {
            if (T("endReadableNT", me.endEmitted, me.length), !me.endEmitted && me.length === 0 && (me.endEmitted = !0, ye.readable = !1, ye.emit("end"), me.autoDestroy)) {
              var Ve = ye._writableState;
              (!Ve || Ve.autoDestroy && Ve.finished) && ye.destroy();
            }
          }
          function it(me, ye) {
            for (var Ve = 0, f = me.length; Ve < f; Ve++) if (me[Ve] === ye) return Ve;
            return -1;
          }
          ee.prototype.read = function(me) {
            T("read", me), me = parseInt(me, 10);
            var ye = this._readableState, Ve = me;
            if (me !== 0 && (ye.emittedReadable = !1), me === 0 && ye.needReadable && ((ye.highWaterMark !== 0 ? ye.length >= ye.highWaterMark : ye.length > 0) || ye.ended)) return T("read: emitReadable", ye.length, ye.ended), ye.length === 0 && ye.ended ? _t(this) : Ue(this), null;
            if ((me = Ne(me, ye)) === 0 && ye.ended) return ye.length === 0 && _t(this), null;
            var f, u = ye.needReadable;
            return T("need readable", u), (ye.length === 0 || ye.length - me < ye.highWaterMark) && T("length less than watermark", u = !0), ye.ended || ye.reading ? T("reading or ended", u = !1) : u && (T("do read"), ye.reading = !0, ye.sync = !0, ye.length === 0 && (ye.needReadable = !0), this._read(ye.highWaterMark), ye.sync = !1, ye.reading || (me = Ne(Ve, ye))), (f = me > 0 ? Rt(me, ye) : null) === null ? (ye.needReadable = ye.length <= ye.highWaterMark, me = 0) : (ye.length -= me, ye.awaitDrain = 0), ye.length === 0 && (ye.ended || (ye.needReadable = !0), Ve !== me && ye.ended && _t(this)), f !== null && this.emit("data", f), f;
          }, ee.prototype._read = function(me) {
            K(this, new $("_read()"));
          }, ee.prototype.pipe = function(me, ye) {
            var Ve = this, f = this._readableState;
            switch (f.pipesCount) {
              case 0:
                f.pipes = me;
                break;
              case 1:
                f.pipes = [f.pipes, me];
                break;
              default:
                f.pipes.push(me);
            }
            f.pipesCount += 1, T("pipe count=%d opts=%j", f.pipesCount, ye);
            var u = ye && ye.end === !1 || me === process.stdout || me === process.stderr ? Fe : v;
            function v() {
              T("onend"), me.end();
            }
            f.endEmitted ? process.nextTick(u) : Ve.once("end", u), me.on("unpipe", function we(Ge, nt) {
              T("onunpipe"), Ge === Ve && nt && nt.hasUnpiped === !1 && (nt.hasUnpiped = !0, T("cleanup"), me.removeListener("close", Je), me.removeListener("finish", Ze), me.removeListener("drain", b), me.removeListener("error", Re), me.removeListener("unpipe", we), Ve.removeListener("end", v), Ve.removeListener("end", Fe), Ve.removeListener("data", Y), W = !0, !f.awaitDrain || me._writableState && !me._writableState.needDrain || b());
            });
            var b = /* @__PURE__ */ function(we) {
              return function() {
                var Ge = we._readableState;
                T("pipeOnDrain", Ge.awaitDrain), Ge.awaitDrain && Ge.awaitDrain--, Ge.awaitDrain === 0 && t(we, "data") && (Ge.flowing = !0, ke(we));
              };
            }(Ve);
            me.on("drain", b);
            var W = !1;
            function Y(we) {
              T("ondata");
              var Ge = me.write(we);
              T("dest.write", Ge), Ge === !1 && ((f.pipesCount === 1 && f.pipes === me || f.pipesCount > 1 && it(f.pipes, me) !== -1) && !W && (T("false write response, pause", f.awaitDrain), f.awaitDrain++), Ve.pause());
            }
            function Re(we) {
              T("onerror", we), Fe(), me.removeListener("error", Re), t(me, "error") === 0 && K(me, we);
            }
            function Je() {
              me.removeListener("finish", Ze), Fe();
            }
            function Ze() {
              T("onfinish"), me.removeListener("close", Je), Fe();
            }
            function Fe() {
              T("unpipe"), Ve.unpipe(me);
            }
            return Ve.on("data", Y), function(we, Ge, nt) {
              if (typeof we.prependListener == "function") return we.prependListener(Ge, nt);
              we._events && we._events[Ge] ? Array.isArray(we._events[Ge]) ? we._events[Ge].unshift(nt) : we._events[Ge] = [nt, we._events[Ge]] : we.on(Ge, nt);
            }(me, "error", Re), me.once("close", Je), me.once("finish", Ze), me.emit("pipe", Ve), f.flowing || (T("pipe resume"), Ve.resume()), me;
          }, ee.prototype.unpipe = function(me) {
            var ye = this._readableState, Ve = { hasUnpiped: !1 };
            if (ye.pipesCount === 0) return this;
            if (ye.pipesCount === 1) return me && me !== ye.pipes || (me || (me = ye.pipes), ye.pipes = null, ye.pipesCount = 0, ye.flowing = !1, me && me.emit("unpipe", this, Ve)), this;
            if (!me) {
              var f = ye.pipes, u = ye.pipesCount;
              ye.pipes = null, ye.pipesCount = 0, ye.flowing = !1;
              for (var v = 0; v < u; v++) f[v].emit("unpipe", this, { hasUnpiped: !1 });
              return this;
            }
            var b = it(ye.pipes, me);
            return b === -1 || (ye.pipes.splice(b, 1), ye.pipesCount -= 1, ye.pipesCount === 1 && (ye.pipes = ye.pipes[0]), me.emit("unpipe", this, Ve)), this;
          }, ee.prototype.on = function(me, ye) {
            var Ve = e.prototype.on.call(this, me, ye), f = this._readableState;
            return me === "data" ? (f.readableListening = this.listenerCount("readable") > 0, f.flowing !== !1 && this.resume()) : me === "readable" && (f.endEmitted || f.readableListening || (f.readableListening = f.needReadable = !0, f.flowing = !1, f.emittedReadable = !1, T("on readable", f.length, f.reading), f.length ? Ue(this) : f.reading || process.nextTick(at, this))), Ve;
          }, ee.prototype.addListener = ee.prototype.on, ee.prototype.removeListener = function(me, ye) {
            var Ve = e.prototype.removeListener.call(this, me, ye);
            return me === "readable" && process.nextTick(We, this), Ve;
          }, ee.prototype.removeAllListeners = function(me) {
            var ye = e.prototype.removeAllListeners.apply(this, arguments);
            return me !== "readable" && me !== void 0 || process.nextTick(We, this), ye;
          }, ee.prototype.resume = function() {
            var me = this._readableState;
            return me.flowing || (T("resume"), me.flowing = !me.readableListening, function(ye, Ve) {
              Ve.resumeScheduled || (Ve.resumeScheduled = !0, process.nextTick(Se, ye, Ve));
            }(this, me)), me.paused = !1, this;
          }, ee.prototype.pause = function() {
            return T("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (T("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
          }, ee.prototype.wrap = function(me) {
            var ye = this, Ve = this._readableState, f = !1;
            for (var u in me.on("end", function() {
              if (T("wrapped end"), Ve.decoder && !Ve.ended) {
                var b = Ve.decoder.end();
                b && b.length && ye.push(b);
              }
              ye.push(null);
            }), me.on("data", function(b) {
              T("wrapped data"), Ve.decoder && (b = Ve.decoder.write(b)), Ve.objectMode && b == null || (Ve.objectMode || b && b.length) && (ye.push(b) || (f = !0, me.pause()));
            }), me) this[u] === void 0 && typeof me[u] == "function" && (this[u] = /* @__PURE__ */ function(b) {
              return function() {
                return me[b].apply(me, arguments);
              };
            }(u));
            for (var v = 0; v < ae.length; v++) me.on(ae[v], this.emit.bind(this, ae[v]));
            return this._read = function(b) {
              T("wrapped _read", b), f && (f = !1, me.resume());
            }, this;
          }, typeof Symbol == "function" && (ee.prototype[Symbol.asyncIterator] = function() {
            return h === void 0 && (h = C(7299)), h(this);
          }), Object.defineProperty(ee.prototype, "readableHighWaterMark", { enumerable: !1, get: function() {
            return this._readableState.highWaterMark;
          } }), Object.defineProperty(ee.prototype, "readableBuffer", { enumerable: !1, get: function() {
            return this._readableState && this._readableState.buffer;
          } }), Object.defineProperty(ee.prototype, "readableFlowing", { enumerable: !1, get: function() {
            return this._readableState.flowing;
          }, set: function(me) {
            this._readableState && (this._readableState.flowing = me);
          } }), ee._fromList = Rt, Object.defineProperty(ee.prototype, "readableLength", { enumerable: !1, get: function() {
            return this._readableState.length;
          } }), typeof Symbol == "function" && (ee.from = function(me, ye) {
            return n === void 0 && (n = C(6233)), n(ee, me, ye);
          });
        }, 9798: function(Pe, Ee, C) {
          Pe.exports = E;
          var ie = C(3690).q, T = ie.ERR_METHOD_NOT_IMPLEMENTED, t = ie.ERR_MULTIPLE_CALLBACK, e = ie.ERR_TRANSFORM_ALREADY_TRANSFORMING, p = ie.ERR_TRANSFORM_WITH_LENGTH_0, m = C(6138);
          function o(c, d) {
            var S = this._transformState;
            S.transforming = !1;
            var x = S.writecb;
            if (x === null) return this.emit("error", new t());
            S.writechunk = null, S.writecb = null, d != null && this.push(d), x(c);
            var B = this._readableState;
            B.reading = !1, (B.needReadable || B.length < B.highWaterMark) && this._read(B.highWaterMark);
          }
          function E(c) {
            if (!(this instanceof E)) return new E(c);
            m.call(this, c), this._transformState = { afterTransform: o.bind(this), needTransform: !1, transforming: !1, writecb: null, writechunk: null, writeencoding: null }, this._readableState.needReadable = !0, this._readableState.sync = !1, c && (typeof c.transform == "function" && (this._transform = c.transform), typeof c.flush == "function" && (this._flush = c.flush)), this.on("prefinish", h);
          }
          function h() {
            var c = this;
            typeof this._flush != "function" || this._readableState.destroyed ? n(this, null, null) : this._flush(function(d, S) {
              n(c, d, S);
            });
          }
          function n(c, d, S) {
            if (d) return c.emit("error", d);
            if (S != null && c.push(S), c._writableState.length) throw new p();
            if (c._transformState.transforming) throw new e();
            return c.push(null);
          }
          C(1765)(E, m), E.prototype.push = function(c, d) {
            return this._transformState.needTransform = !1, m.prototype.push.call(this, c, d);
          }, E.prototype._transform = function(c, d, S) {
            S(new T("_transform()"));
          }, E.prototype._write = function(c, d, S) {
            var x = this._transformState;
            if (x.writecb = S, x.writechunk = c, x.writeencoding = d, !x.transforming) {
              var B = this._readableState;
              (x.needTransform || B.needReadable || B.length < B.highWaterMark) && this._read(B.highWaterMark);
            }
          }, E.prototype._read = function(c) {
            var d = this._transformState;
            d.writechunk === null || d.transforming ? d.needTransform = !0 : (d.transforming = !0, this._transform(d.writechunk, d.writeencoding, d.afterTransform));
          }, E.prototype._destroy = function(c, d) {
            m.prototype._destroy.call(this, c, function(S) {
              d(S);
            });
          };
        }, 8318: function(Pe, Ee, C) {
          function ie(Te) {
            var Oe = this;
            this.next = null, this.entry = null, this.finish = function() {
              (function(We, at, Se) {
                var ke = We.entry;
                for (We.entry = null; ke; ) {
                  var Rt = ke.callback;
                  at.pendingcb--, Rt(void 0), ke = ke.next;
                }
                at.corkedRequestsFree.next = We;
              })(Oe, Te);
            };
          }
          var T;
          Pe.exports = ee, ee.WritableState = j;
          var t, e = { deprecate: C(7839) }, p = C(9299), m = C(1549).Buffer, o = C.g.Uint8Array || function() {
          }, E = C(6163), h = C(7269).getHighWaterMark, n = C(3690).q, c = n.ERR_INVALID_ARG_TYPE, d = n.ERR_METHOD_NOT_IMPLEMENTED, S = n.ERR_MULTIPLE_CALLBACK, x = n.ERR_STREAM_CANNOT_PIPE, B = n.ERR_STREAM_DESTROYED, L = n.ERR_STREAM_NULL_VALUES, $ = n.ERR_STREAM_WRITE_AFTER_END, M = n.ERR_UNKNOWN_ENCODING, K = E.errorOrDestroy;
          function ae() {
          }
          function j(Te, Oe, We) {
            T = T || C(6138), Te = Te || {}, typeof We != "boolean" && (We = Oe instanceof T), this.objectMode = !!Te.objectMode, We && (this.objectMode = this.objectMode || !!Te.writableObjectMode), this.highWaterMark = h(this, Te, "writableHighWaterMark", We), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
            var at = Te.decodeStrings === !1;
            this.decodeStrings = !at, this.defaultEncoding = Te.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(Se) {
              (function(ke, Rt) {
                var _t = ke._writableState, qe = _t.sync, it = _t.writecb;
                if (typeof it != "function") throw new S();
                if (function(ye) {
                  ye.writing = !1, ye.writecb = null, ye.length -= ye.writelen, ye.writelen = 0;
                }(_t), Rt) (function(ye, Ve, f, u, v) {
                  --Ve.pendingcb, f ? (process.nextTick(v, u), process.nextTick(ze, ye, Ve), ye._writableState.errorEmitted = !0, K(ye, u)) : (v(u), ye._writableState.errorEmitted = !0, K(ye, u), ze(ye, Ve));
                })(ke, _t, qe, Rt, it);
                else {
                  var me = Ne(_t) || ke.destroyed;
                  me || _t.corked || _t.bufferProcessing || !_t.bufferedRequest || Q(ke, _t), qe ? process.nextTick(Ae, ke, _t, me, it) : Ae(ke, _t, me, it);
                }
              })(Oe, Se);
            }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = Te.emitClose !== !1, this.autoDestroy = !!Te.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new ie(this);
          }
          function ee(Te) {
            var Oe = this instanceof (T = T || C(6138));
            if (!Oe && !t.call(ee, this)) return new ee(Te);
            this._writableState = new j(Te, this, Oe), this.writable = !0, Te && (typeof Te.write == "function" && (this._write = Te.write), typeof Te.writev == "function" && (this._writev = Te.writev), typeof Te.destroy == "function" && (this._destroy = Te.destroy), typeof Te.final == "function" && (this._final = Te.final)), p.call(this);
          }
          function ue(Te, Oe, We, at, Se, ke, Rt) {
            Oe.writelen = at, Oe.writecb = Rt, Oe.writing = !0, Oe.sync = !0, Oe.destroyed ? Oe.onwrite(new B("write")) : We ? Te._writev(Se, Oe.onwrite) : Te._write(Se, ke, Oe.onwrite), Oe.sync = !1;
          }
          function Ae(Te, Oe, We, at) {
            We || function(Se, ke) {
              ke.length === 0 && ke.needDrain && (ke.needDrain = !1, Se.emit("drain"));
            }(Te, Oe), Oe.pendingcb--, at(), ze(Te, Oe);
          }
          function Q(Te, Oe) {
            Oe.bufferProcessing = !0;
            var We = Oe.bufferedRequest;
            if (Te._writev && We && We.next) {
              var at = Oe.bufferedRequestCount, Se = new Array(at), ke = Oe.corkedRequestsFree;
              ke.entry = We;
              for (var Rt = 0, _t = !0; We; ) Se[Rt] = We, We.isBuf || (_t = !1), We = We.next, Rt += 1;
              Se.allBuffers = _t, ue(Te, Oe, !0, Oe.length, Se, "", ke.finish), Oe.pendingcb++, Oe.lastBufferedRequest = null, ke.next ? (Oe.corkedRequestsFree = ke.next, ke.next = null) : Oe.corkedRequestsFree = new ie(Oe), Oe.bufferedRequestCount = 0;
            } else {
              for (; We; ) {
                var qe = We.chunk, it = We.encoding, me = We.callback;
                if (ue(Te, Oe, !1, Oe.objectMode ? 1 : qe.length, qe, it, me), We = We.next, Oe.bufferedRequestCount--, Oe.writing) break;
              }
              We === null && (Oe.lastBufferedRequest = null);
            }
            Oe.bufferedRequest = We, Oe.bufferProcessing = !1;
          }
          function Ne(Te) {
            return Te.ending && Te.length === 0 && Te.bufferedRequest === null && !Te.finished && !Te.writing;
          }
          function Ue(Te, Oe) {
            Te._final(function(We) {
              Oe.pendingcb--, We && K(Te, We), Oe.prefinished = !0, Te.emit("prefinish"), ze(Te, Oe);
            });
          }
          function ze(Te, Oe) {
            var We = Ne(Oe);
            if (We && (function(Se, ke) {
              ke.prefinished || ke.finalCalled || (typeof Se._final != "function" || ke.destroyed ? (ke.prefinished = !0, Se.emit("prefinish")) : (ke.pendingcb++, ke.finalCalled = !0, process.nextTick(Ue, Se, ke)));
            }(Te, Oe), Oe.pendingcb === 0 && (Oe.finished = !0, Te.emit("finish"), Oe.autoDestroy))) {
              var at = Te._readableState;
              (!at || at.autoDestroy && at.endEmitted) && Te.destroy();
            }
            return We;
          }
          C(1765)(ee, p), j.prototype.getBuffer = function() {
            for (var Te = this.bufferedRequest, Oe = []; Te; ) Oe.push(Te), Te = Te.next;
            return Oe;
          }, function() {
            try {
              Object.defineProperty(j.prototype, "buffer", { get: e.deprecate(function() {
                return this.getBuffer();
              }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003") });
            } catch {
            }
          }(), typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (t = Function.prototype[Symbol.hasInstance], Object.defineProperty(ee, Symbol.hasInstance, { value: function(Te) {
            return !!t.call(this, Te) || this === ee && Te && Te._writableState instanceof j;
          } })) : t = function(Te) {
            return Te instanceof this;
          }, ee.prototype.pipe = function() {
            K(this, new x());
          }, ee.prototype.write = function(Te, Oe, We) {
            var at, Se = this._writableState, ke = !1, Rt = !Se.objectMode && (at = Te, m.isBuffer(at) || at instanceof o);
            return Rt && !m.isBuffer(Te) && (Te = function(_t) {
              return m.from(_t);
            }(Te)), typeof Oe == "function" && (We = Oe, Oe = null), Rt ? Oe = "buffer" : Oe || (Oe = Se.defaultEncoding), typeof We != "function" && (We = ae), Se.ending ? function(_t, qe) {
              var it = new $();
              K(_t, it), process.nextTick(qe, it);
            }(this, We) : (Rt || function(_t, qe, it, me) {
              var ye;
              return it === null ? ye = new L() : typeof it == "string" || qe.objectMode || (ye = new c("chunk", ["string", "Buffer"], it)), !ye || (K(_t, ye), process.nextTick(me, ye), !1);
            }(this, Se, Te, We)) && (Se.pendingcb++, ke = function(_t, qe, it, me, ye, Ve) {
              if (!it) {
                var f = function(W, Y, Re) {
                  return W.objectMode || W.decodeStrings === !1 || typeof Y != "string" || (Y = m.from(Y, Re)), Y;
                }(qe, me, ye);
                me !== f && (it = !0, ye = "buffer", me = f);
              }
              var u = qe.objectMode ? 1 : me.length;
              qe.length += u;
              var v = qe.length < qe.highWaterMark;
              if (v || (qe.needDrain = !0), qe.writing || qe.corked) {
                var b = qe.lastBufferedRequest;
                qe.lastBufferedRequest = { chunk: me, encoding: ye, isBuf: it, callback: Ve, next: null }, b ? b.next = qe.lastBufferedRequest : qe.bufferedRequest = qe.lastBufferedRequest, qe.bufferedRequestCount += 1;
              } else ue(_t, qe, !1, u, me, ye, Ve);
              return v;
            }(this, Se, Rt, Te, Oe, We)), ke;
          }, ee.prototype.cork = function() {
            this._writableState.corked++;
          }, ee.prototype.uncork = function() {
            var Te = this._writableState;
            Te.corked && (Te.corked--, Te.writing || Te.corked || Te.bufferProcessing || !Te.bufferedRequest || Q(this, Te));
          }, ee.prototype.setDefaultEncoding = function(Te) {
            if (typeof Te == "string" && (Te = Te.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((Te + "").toLowerCase()) > -1)) throw new M(Te);
            return this._writableState.defaultEncoding = Te, this;
          }, Object.defineProperty(ee.prototype, "writableBuffer", { enumerable: !1, get: function() {
            return this._writableState && this._writableState.getBuffer();
          } }), Object.defineProperty(ee.prototype, "writableHighWaterMark", { enumerable: !1, get: function() {
            return this._writableState.highWaterMark;
          } }), ee.prototype._write = function(Te, Oe, We) {
            We(new d("_write()"));
          }, ee.prototype._writev = null, ee.prototype.end = function(Te, Oe, We) {
            var at = this._writableState;
            return typeof Te == "function" ? (We = Te, Te = null, Oe = null) : typeof Oe == "function" && (We = Oe, Oe = null), Te != null && this.write(Te, Oe), at.corked && (at.corked = 1, this.uncork()), at.ending || function(Se, ke, Rt) {
              ke.ending = !0, ze(Se, ke), Rt && (ke.finished ? process.nextTick(Rt) : Se.once("finish", Rt)), ke.ended = !0, Se.writable = !1;
            }(this, at, We), this;
          }, Object.defineProperty(ee.prototype, "writableLength", { enumerable: !1, get: function() {
            return this._writableState.length;
          } }), Object.defineProperty(ee.prototype, "destroyed", { enumerable: !1, get: function() {
            return this._writableState !== void 0 && this._writableState.destroyed;
          }, set: function(Te) {
            this._writableState && (this._writableState.destroyed = Te);
          } }), ee.prototype.destroy = E.destroy, ee.prototype._undestroy = E.undestroy, ee.prototype._destroy = function(Te, Oe) {
            Oe(Te);
          };
        }, 7299: function(Pe, Ee, C) {
          var ie;
          function T(L, $, M) {
            return $ in L ? Object.defineProperty(L, $, { value: M, enumerable: !0, configurable: !0, writable: !0 }) : L[$] = M, L;
          }
          var t = C(8800), e = Symbol("lastResolve"), p = Symbol("lastReject"), m = Symbol("error"), o = Symbol("ended"), E = Symbol("lastPromise"), h = Symbol("handlePromise"), n = Symbol("stream");
          function c(L, $) {
            return { value: L, done: $ };
          }
          function d(L) {
            var $ = L[e];
            if ($ !== null) {
              var M = L[n].read();
              M !== null && (L[E] = null, L[e] = null, L[p] = null, $(c(M, !1)));
            }
          }
          function S(L) {
            process.nextTick(d, L);
          }
          var x = Object.getPrototypeOf(function() {
          }), B = Object.setPrototypeOf((T(ie = { get stream() {
            return this[n];
          }, next: function() {
            var L = this, $ = this[m];
            if ($ !== null) return Promise.reject($);
            if (this[o]) return Promise.resolve(c(void 0, !0));
            if (this[n].destroyed) return new Promise(function(j, ee) {
              process.nextTick(function() {
                L[m] ? ee(L[m]) : j(c(void 0, !0));
              });
            });
            var M, K = this[E];
            if (K) M = new Promise(/* @__PURE__ */ function(j, ee) {
              return function(ue, Ae) {
                j.then(function() {
                  ee[o] ? ue(c(void 0, !0)) : ee[h](ue, Ae);
                }, Ae);
              };
            }(K, this));
            else {
              var ae = this[n].read();
              if (ae !== null) return Promise.resolve(c(ae, !1));
              M = new Promise(this[h]);
            }
            return this[E] = M, M;
          } }, Symbol.asyncIterator, function() {
            return this;
          }), T(ie, "return", function() {
            var L = this;
            return new Promise(function($, M) {
              L[n].destroy(null, function(K) {
                K ? M(K) : $(c(void 0, !0));
              });
            });
          }), ie), x);
          Pe.exports = function(L) {
            var $, M = Object.create(B, (T($ = {}, n, { value: L, writable: !0 }), T($, e, { value: null, writable: !0 }), T($, p, { value: null, writable: !0 }), T($, m, { value: null, writable: !0 }), T($, o, { value: L._readableState.endEmitted, writable: !0 }), T($, h, { value: function(K, ae) {
              var j = M[n].read();
              j ? (M[E] = null, M[e] = null, M[p] = null, K(c(j, !1))) : (M[e] = K, M[p] = ae);
            }, writable: !0 }), $));
            return M[E] = null, t(L, function(K) {
              if (K && K.code !== "ERR_STREAM_PREMATURE_CLOSE") {
                var ae = M[p];
                return ae !== null && (M[E] = null, M[e] = null, M[p] = null, ae(K)), void (M[m] = K);
              }
              var j = M[e];
              j !== null && (M[E] = null, M[e] = null, M[p] = null, j(c(void 0, !0))), M[o] = !0;
            }), L.on("readable", S.bind(null, M)), M;
          };
        }, 8393: function(Pe, Ee, C) {
          function ie(o, E) {
            var h = Object.keys(o);
            if (Object.getOwnPropertySymbols) {
              var n = Object.getOwnPropertySymbols(o);
              E && (n = n.filter(function(c) {
                return Object.getOwnPropertyDescriptor(o, c).enumerable;
              })), h.push.apply(h, n);
            }
            return h;
          }
          function T(o, E, h) {
            return E in o ? Object.defineProperty(o, E, { value: h, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = h, o;
          }
          function t(o, E) {
            for (var h = 0; h < E.length; h++) {
              var n = E[h];
              n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(o, n.key, n);
            }
          }
          var e = C(1549).Buffer, p = C(9862).inspect, m = p && p.custom || "inspect";
          Pe.exports = function() {
            function o() {
              (function(n, c) {
                if (!(n instanceof c)) throw new TypeError("Cannot call a class as a function");
              })(this, o), this.head = null, this.tail = null, this.length = 0;
            }
            var E, h;
            return E = o, h = [{ key: "push", value: function(n) {
              var c = { data: n, next: null };
              this.length > 0 ? this.tail.next = c : this.head = c, this.tail = c, ++this.length;
            } }, { key: "unshift", value: function(n) {
              var c = { data: n, next: this.head };
              this.length === 0 && (this.tail = c), this.head = c, ++this.length;
            } }, { key: "shift", value: function() {
              if (this.length !== 0) {
                var n = this.head.data;
                return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, n;
              }
            } }, { key: "clear", value: function() {
              this.head = this.tail = null, this.length = 0;
            } }, { key: "join", value: function(n) {
              if (this.length === 0) return "";
              for (var c = this.head, d = "" + c.data; c = c.next; ) d += n + c.data;
              return d;
            } }, { key: "concat", value: function(n) {
              if (this.length === 0) return e.alloc(0);
              for (var c, d, S, x = e.allocUnsafe(n >>> 0), B = this.head, L = 0; B; ) c = B.data, d = x, S = L, e.prototype.copy.call(c, d, S), L += B.data.length, B = B.next;
              return x;
            } }, { key: "consume", value: function(n, c) {
              var d;
              return n < this.head.data.length ? (d = this.head.data.slice(0, n), this.head.data = this.head.data.slice(n)) : d = n === this.head.data.length ? this.shift() : c ? this._getString(n) : this._getBuffer(n), d;
            } }, { key: "first", value: function() {
              return this.head.data;
            } }, { key: "_getString", value: function(n) {
              var c = this.head, d = 1, S = c.data;
              for (n -= S.length; c = c.next; ) {
                var x = c.data, B = n > x.length ? x.length : n;
                if (B === x.length ? S += x : S += x.slice(0, n), (n -= B) == 0) {
                  B === x.length ? (++d, c.next ? this.head = c.next : this.head = this.tail = null) : (this.head = c, c.data = x.slice(B));
                  break;
                }
                ++d;
              }
              return this.length -= d, S;
            } }, { key: "_getBuffer", value: function(n) {
              var c = e.allocUnsafe(n), d = this.head, S = 1;
              for (d.data.copy(c), n -= d.data.length; d = d.next; ) {
                var x = d.data, B = n > x.length ? x.length : n;
                if (x.copy(c, c.length - n, 0, B), (n -= B) == 0) {
                  B === x.length ? (++S, d.next ? this.head = d.next : this.head = this.tail = null) : (this.head = d, d.data = x.slice(B));
                  break;
                }
                ++S;
              }
              return this.length -= S, c;
            } }, { key: m, value: function(n, c) {
              return p(this, function(d) {
                for (var S = 1; S < arguments.length; S++) {
                  var x = arguments[S] != null ? arguments[S] : {};
                  S % 2 ? ie(Object(x), !0).forEach(function(B) {
                    T(d, B, x[B]);
                  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(d, Object.getOwnPropertyDescriptors(x)) : ie(Object(x)).forEach(function(B) {
                    Object.defineProperty(d, B, Object.getOwnPropertyDescriptor(x, B));
                  });
                }
                return d;
              }({}, c, { depth: 0, customInspect: !1 }));
            } }], h && t(E.prototype, h), o;
          }();
        }, 6163: function(Pe) {
          function Ee(T, t) {
            ie(T, t), C(T);
          }
          function C(T) {
            T._writableState && !T._writableState.emitClose || T._readableState && !T._readableState.emitClose || T.emit("close");
          }
          function ie(T, t) {
            T.emit("error", t);
          }
          Pe.exports = { destroy: function(T, t) {
            var e = this, p = this._readableState && this._readableState.destroyed, m = this._writableState && this._writableState.destroyed;
            return p || m ? (t ? t(T) : T && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, process.nextTick(ie, this, T)) : process.nextTick(ie, this, T)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(T || null, function(o) {
              !t && o ? e._writableState ? e._writableState.errorEmitted ? process.nextTick(C, e) : (e._writableState.errorEmitted = !0, process.nextTick(Ee, e, o)) : process.nextTick(Ee, e, o) : t ? (process.nextTick(C, e), t(o)) : process.nextTick(C, e);
            }), this);
          }, undestroy: function() {
            this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
          }, errorOrDestroy: function(T, t) {
            var e = T._readableState, p = T._writableState;
            e && e.autoDestroy || p && p.autoDestroy ? T.destroy(t) : T.emit("error", t);
          } };
        }, 8800: function(Pe, Ee, C) {
          var ie = C(3690).q.ERR_STREAM_PREMATURE_CLOSE;
          function T() {
          }
          Pe.exports = function t(e, p, m) {
            if (typeof p == "function") return t(e, null, p);
            p || (p = {}), m = /* @__PURE__ */ function($) {
              var M = !1;
              return function() {
                if (!M) {
                  M = !0;
                  for (var K = arguments.length, ae = new Array(K), j = 0; j < K; j++) ae[j] = arguments[j];
                  $.apply(this, ae);
                }
              };
            }(m || T);
            var o = p.readable || p.readable !== !1 && e.readable, E = p.writable || p.writable !== !1 && e.writable, h = function() {
              e.writable || c();
            }, n = e._writableState && e._writableState.finished, c = function() {
              E = !1, n = !0, o || m.call(e);
            }, d = e._readableState && e._readableState.endEmitted, S = function() {
              o = !1, d = !0, E || m.call(e);
            }, x = function($) {
              m.call(e, $);
            }, B = function() {
              var $;
              return o && !d ? (e._readableState && e._readableState.ended || ($ = new ie()), m.call(e, $)) : E && !n ? (e._writableState && e._writableState.ended || ($ = new ie()), m.call(e, $)) : void 0;
            }, L = function() {
              e.req.on("finish", c);
            };
            return function($) {
              return $.setHeader && typeof $.abort == "function";
            }(e) ? (e.on("complete", c), e.on("abort", B), e.req ? L() : e.on("request", L)) : E && !e._writableState && (e.on("end", h), e.on("close", h)), e.on("end", S), e.on("finish", c), p.error !== !1 && e.on("error", x), e.on("close", B), function() {
              e.removeListener("complete", c), e.removeListener("abort", B), e.removeListener("request", L), e.req && e.req.removeListener("finish", c), e.removeListener("end", h), e.removeListener("close", h), e.removeListener("finish", c), e.removeListener("end", S), e.removeListener("error", x), e.removeListener("close", B);
            };
          };
        }, 6233: function(Pe) {
          Pe.exports = function() {
            throw new Error("Readable.from is not available in the browser");
          };
        }, 7295: function(Pe, Ee, C) {
          var ie, T = C(3690).q, t = T.ERR_MISSING_ARGS, e = T.ERR_STREAM_DESTROYED;
          function p(n) {
            if (n) throw n;
          }
          function m(n, c, d, S) {
            S = /* @__PURE__ */ function(L) {
              var $ = !1;
              return function() {
                $ || ($ = !0, L.apply(void 0, arguments));
              };
            }(S);
            var x = !1;
            n.on("close", function() {
              x = !0;
            }), ie === void 0 && (ie = C(8800)), ie(n, { readable: c, writable: d }, function(L) {
              if (L) return S(L);
              x = !0, S();
            });
            var B = !1;
            return function(L) {
              if (!x && !B) return B = !0, function($) {
                return $.setHeader && typeof $.abort == "function";
              }(n) ? n.abort() : typeof n.destroy == "function" ? n.destroy() : void S(L || new e("pipe"));
            };
          }
          function o(n) {
            n();
          }
          function E(n, c) {
            return n.pipe(c);
          }
          function h(n) {
            return n.length ? typeof n[n.length - 1] != "function" ? p : n.pop() : p;
          }
          Pe.exports = function() {
            for (var n = arguments.length, c = new Array(n), d = 0; d < n; d++) c[d] = arguments[d];
            var S, x = h(c);
            if (Array.isArray(c[0]) && (c = c[0]), c.length < 2) throw new t("streams");
            var B = c.map(function(L, $) {
              var M = $ < c.length - 1;
              return m(L, M, $ > 0, function(K) {
                S || (S = K), K && B.forEach(o), M || (B.forEach(o), x(S));
              });
            });
            return c.reduce(E);
          };
        }, 7269: function(Pe, Ee, C) {
          var ie = C(3690).q.ERR_INVALID_OPT_VALUE;
          Pe.exports = { getHighWaterMark: function(T, t, e, p) {
            var m = function(o, E, h) {
              return o.highWaterMark != null ? o.highWaterMark : E ? o[h] : null;
            }(t, p, e);
            if (m != null) {
              if (!isFinite(m) || Math.floor(m) !== m || m < 0) throw new ie(p ? e : "highWaterMark", m);
              return Math.floor(m);
            }
            return T.objectMode ? 16 : 16384;
          } };
        }, 9299: function(Pe, Ee, C) {
          Pe.exports = C(1159).EventEmitter;
        }, 7503: function(Pe, Ee, C) {
          var ie = C(8387).Buffer, T = ie.isEncoding || function(d) {
            switch ((d = "" + d) && d.toLowerCase()) {
              case "hex":
              case "utf8":
              case "utf-8":
              case "ascii":
              case "binary":
              case "base64":
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
              case "raw":
                return !0;
              default:
                return !1;
            }
          };
          function t(d) {
            var S;
            switch (this.encoding = function(x) {
              var B = function(L) {
                if (!L) return "utf8";
                for (var $; ; ) switch (L) {
                  case "utf8":
                  case "utf-8":
                    return "utf8";
                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return "utf16le";
                  case "latin1":
                  case "binary":
                    return "latin1";
                  case "base64":
                  case "ascii":
                  case "hex":
                    return L;
                  default:
                    if ($) return;
                    L = ("" + L).toLowerCase(), $ = !0;
                }
              }(x);
              if (typeof B != "string" && (ie.isEncoding === T || !T(x))) throw new Error("Unknown encoding: " + x);
              return B || x;
            }(d), this.encoding) {
              case "utf16le":
                this.text = m, this.end = o, S = 4;
                break;
              case "utf8":
                this.fillLast = p, S = 4;
                break;
              case "base64":
                this.text = E, this.end = h, S = 3;
                break;
              default:
                return this.write = n, void (this.end = c);
            }
            this.lastNeed = 0, this.lastTotal = 0, this.lastChar = ie.allocUnsafe(S);
          }
          function e(d) {
            return d <= 127 ? 0 : d >> 5 == 6 ? 2 : d >> 4 == 14 ? 3 : d >> 3 == 30 ? 4 : d >> 6 == 2 ? -1 : -2;
          }
          function p(d) {
            var S = this.lastTotal - this.lastNeed, x = function(B, L, $) {
              if ((192 & L[0]) != 128) return B.lastNeed = 0, "�";
              if (B.lastNeed > 1 && L.length > 1) {
                if ((192 & L[1]) != 128) return B.lastNeed = 1, "�";
                if (B.lastNeed > 2 && L.length > 2 && (192 & L[2]) != 128) return B.lastNeed = 2, "�";
              }
            }(this, d);
            return x !== void 0 ? x : this.lastNeed <= d.length ? (d.copy(this.lastChar, S, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (d.copy(this.lastChar, S, 0, d.length), void (this.lastNeed -= d.length));
          }
          function m(d, S) {
            if ((d.length - S) % 2 == 0) {
              var x = d.toString("utf16le", S);
              if (x) {
                var B = x.charCodeAt(x.length - 1);
                if (B >= 55296 && B <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = d[d.length - 2], this.lastChar[1] = d[d.length - 1], x.slice(0, -1);
              }
              return x;
            }
            return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = d[d.length - 1], d.toString("utf16le", S, d.length - 1);
          }
          function o(d) {
            var S = d && d.length ? this.write(d) : "";
            if (this.lastNeed) {
              var x = this.lastTotal - this.lastNeed;
              return S + this.lastChar.toString("utf16le", 0, x);
            }
            return S;
          }
          function E(d, S) {
            var x = (d.length - S) % 3;
            return x === 0 ? d.toString("base64", S) : (this.lastNeed = 3 - x, this.lastTotal = 3, x === 1 ? this.lastChar[0] = d[d.length - 1] : (this.lastChar[0] = d[d.length - 2], this.lastChar[1] = d[d.length - 1]), d.toString("base64", S, d.length - x));
          }
          function h(d) {
            var S = d && d.length ? this.write(d) : "";
            return this.lastNeed ? S + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : S;
          }
          function n(d) {
            return d.toString(this.encoding);
          }
          function c(d) {
            return d && d.length ? this.write(d) : "";
          }
          Ee.s = t, t.prototype.write = function(d) {
            if (d.length === 0) return "";
            var S, x;
            if (this.lastNeed) {
              if ((S = this.fillLast(d)) === void 0) return "";
              x = this.lastNeed, this.lastNeed = 0;
            } else x = 0;
            return x < d.length ? S ? S + this.text(d, x) : this.text(d, x) : S || "";
          }, t.prototype.end = function(d) {
            var S = d && d.length ? this.write(d) : "";
            return this.lastNeed ? S + "�" : S;
          }, t.prototype.text = function(d, S) {
            var x = function(L, $, M) {
              var K = $.length - 1;
              if (K < M) return 0;
              var ae = e($[K]);
              return ae >= 0 ? (ae > 0 && (L.lastNeed = ae - 1), ae) : --K < M || ae === -2 ? 0 : (ae = e($[K])) >= 0 ? (ae > 0 && (L.lastNeed = ae - 2), ae) : --K < M || ae === -2 ? 0 : (ae = e($[K])) >= 0 ? (ae > 0 && (ae === 2 ? ae = 0 : L.lastNeed = ae - 3), ae) : 0;
            }(this, d, S);
            if (!this.lastNeed) return d.toString("utf8", S);
            this.lastTotal = x;
            var B = d.length - (x - this.lastNeed);
            return d.copy(this.lastChar, 0, B), d.toString("utf8", S, B);
          }, t.prototype.fillLast = function(d) {
            if (this.lastNeed <= d.length) return d.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
            d.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, d.length), this.lastNeed -= d.length;
          };
        }, 1067: function(Pe, Ee, C) {
          var ie;
          (function(T, t) {
            var e = "function", p = "undefined", m = "object", o = "string", E = "major", h = "model", n = "name", c = "type", d = "vendor", S = "version", x = "architecture", B = "console", L = "mobile", $ = "tablet", M = "smarttv", K = "wearable", ae = "embedded", j = "Amazon", ee = "Apple", ue = "ASUS", Ae = "BlackBerry", Q = "Browser", Ne = "Chrome", Ue = "Firefox", ze = "Google", Te = "Huawei", Oe = "LG", We = "Microsoft", at = "Motorola", Se = "Opera", ke = "Samsung", Rt = "Sharp", _t = "Sony", qe = "Xiaomi", it = "Zebra", me = "Facebook", ye = "Chromium OS", Ve = "Mac OS", f = function(Ge) {
              for (var nt = {}, Tt = 0; Tt < Ge.length; Tt++) nt[Ge[Tt].toUpperCase()] = Ge[Tt];
              return nt;
            }, u = function(Ge, nt) {
              return typeof Ge === o && v(nt).indexOf(v(Ge)) !== -1;
            }, v = function(Ge) {
              return Ge.toLowerCase();
            }, b = function(Ge, nt) {
              if (typeof Ge === o) return Ge = Ge.replace(/^\s\s*/, ""), typeof nt === p ? Ge : Ge.substring(0, 500);
            }, W = function(Ge, nt) {
              for (var Tt, ft, Yt, Ot, qt, Bt, cn = 0; cn < nt.length && !qt; ) {
                var vn = nt[cn], Pn = nt[cn + 1];
                for (Tt = ft = 0; Tt < vn.length && !qt && vn[Tt]; ) if (qt = vn[Tt++].exec(Ge)) for (Yt = 0; Yt < Pn.length; Yt++) Bt = qt[++ft], typeof (Ot = Pn[Yt]) === m && Ot.length > 0 ? Ot.length === 2 ? typeof Ot[1] == e ? this[Ot[0]] = Ot[1].call(this, Bt) : this[Ot[0]] = Ot[1] : Ot.length === 3 ? typeof Ot[1] !== e || Ot[1].exec && Ot[1].test ? this[Ot[0]] = Bt ? Bt.replace(Ot[1], Ot[2]) : t : this[Ot[0]] = Bt ? Ot[1].call(this, Bt, Ot[2]) : t : Ot.length === 4 && (this[Ot[0]] = Bt ? Ot[3].call(this, Bt.replace(Ot[1], Ot[2])) : t) : this[Ot] = Bt || t;
                cn += 2;
              }
            }, Y = function(Ge, nt) {
              for (var Tt in nt) if (typeof nt[Tt] === m && nt[Tt].length > 0) {
                for (var ft = 0; ft < nt[Tt].length; ft++) if (u(nt[Tt][ft], Ge)) return Tt === "?" ? t : Tt;
              } else if (u(nt[Tt], Ge)) return Tt === "?" ? t : Tt;
              return Ge;
            }, Re = { ME: "4.90", "NT 3.11": "NT3.51", "NT 4.0": "NT4.0", 2e3: "NT 5.0", XP: ["NT 5.1", "NT 5.2"], Vista: "NT 6.0", 7: "NT 6.1", 8: "NT 6.2", 8.1: "NT 6.3", 10: ["NT 6.4", "NT 10.0"], RT: "ARM" }, Je = { browser: [[/\b(?:crmo|crios)\/([\w\.]+)/i], [S, [n, "Chrome"]], [/edg(?:e|ios|a)?\/([\w\.]+)/i], [S, [n, "Edge"]], [/(opera mini)\/([-\w\.]+)/i, /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i, /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i], [n, S], [/opios[\/ ]+([\w\.]+)/i], [S, [n, Se + " Mini"]], [/\bopr\/([\w\.]+)/i], [S, [n, Se]], [/\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i], [S, [n, "Baidu"]], [/(kindle)\/([\w\.]+)/i, /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i, /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i, /(?:ms|\()(ie) ([\w\.]+)/i, /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i, /(heytap|ovi)browser\/([\d\.]+)/i, /(weibo)__([\d\.]+)/i], [n, S], [/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i], [S, [n, "UC" + Q]], [/microm.+\bqbcore\/([\w\.]+)/i, /\bqbcore\/([\w\.]+).+microm/i, /micromessenger\/([\w\.]+)/i], [S, [n, "WeChat"]], [/konqueror\/([\w\.]+)/i], [S, [n, "Konqueror"]], [/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i], [S, [n, "IE"]], [/ya(?:search)?browser\/([\w\.]+)/i], [S, [n, "Yandex"]], [/slbrowser\/([\w\.]+)/i], [S, [n, "Smart Lenovo " + Q]], [/(avast|avg)\/([\w\.]+)/i], [[n, /(.+)/, "$1 Secure " + Q], S], [/\bfocus\/([\w\.]+)/i], [S, [n, Ue + " Focus"]], [/\bopt\/([\w\.]+)/i], [S, [n, Se + " Touch"]], [/coc_coc\w+\/([\w\.]+)/i], [S, [n, "Coc Coc"]], [/dolfin\/([\w\.]+)/i], [S, [n, "Dolphin"]], [/coast\/([\w\.]+)/i], [S, [n, Se + " Coast"]], [/miuibrowser\/([\w\.]+)/i], [S, [n, "MIUI " + Q]], [/fxios\/([-\w\.]+)/i], [S, [n, Ue]], [/\bqihu|(qi?ho?o?|360)browser/i], [[n, "360 " + Q]], [/(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i], [[n, /(.+)/, "$1 " + Q], S], [/samsungbrowser\/([\w\.]+)/i], [S, [n, ke + " Internet"]], [/(comodo_dragon)\/([\w\.]+)/i], [[n, /_/g, " "], S], [/metasr[\/ ]?([\d\.]+)/i], [S, [n, "Sogou Explorer"]], [/(sogou)mo\w+\/([\d\.]+)/i], [[n, "Sogou Mobile"], S], [/(electron)\/([\w\.]+) safari/i, /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i, /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i], [n, S], [/(lbbrowser)/i, /\[(linkedin)app\]/i], [n], [/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i], [[n, me], S], [/(Klarna)\/([\w\.]+)/i, /(kakao(?:talk|story))[\/ ]([\w\.]+)/i, /(naver)\(.*?(\d+\.[\w\.]+).*\)/i, /safari (line)\/([\w\.]+)/i, /\b(line)\/([\w\.]+)\/iab/i, /(alipay)client\/([\w\.]+)/i, /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i], [n, S], [/\bgsa\/([\w\.]+) .*safari\//i], [S, [n, "GSA"]], [/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i], [S, [n, "TikTok"]], [/headlesschrome(?:\/([\w\.]+)| )/i], [S, [n, Ne + " Headless"]], [/ wv\).+(chrome)\/([\w\.]+)/i], [[n, Ne + " WebView"], S], [/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i], [S, [n, "Android " + Q]], [/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i], [n, S], [/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i], [S, [n, "Mobile Safari"]], [/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i], [S, n], [/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i], [n, [S, Y, { "1.0": "/8", 1.2: "/1", 1.3: "/3", "2.0": "/412", "2.0.2": "/416", "2.0.3": "/417", "2.0.4": "/419", "?": "/" }]], [/(webkit|khtml)\/([\w\.]+)/i], [n, S], [/(navigator|netscape\d?)\/([-\w\.]+)/i], [[n, "Netscape"], S], [/mobile vr; rv:([\w\.]+)\).+firefox/i], [S, [n, Ue + " Reality"]], [/ekiohf.+(flow)\/([\w\.]+)/i, /(swiftfox)/i, /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i, /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i, /(firefox)\/([\w\.]+)/i, /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i, /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i, /(links) \(([\w\.]+)/i, /panasonic;(viera)/i], [n, S], [/(cobalt)\/([\w\.]+)/i], [n, [S, /master.|lts./, ""]]], cpu: [[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i], [[x, "amd64"]], [/(ia32(?=;))/i], [[x, v]], [/((?:i[346]|x)86)[;\)]/i], [[x, "ia32"]], [/\b(aarch64|arm(v?8e?l?|_?64))\b/i], [[x, "arm64"]], [/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i], [[x, "armhf"]], [/windows (ce|mobile); ppc;/i], [[x, "arm"]], [/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i], [[x, /ower/, "", v]], [/(sun4\w)[;\)]/i], [[x, "sparc"]], [/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i], [[x, v]]], device: [[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i], [h, [d, ke], [c, $]], [/\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i, /samsung[- ]([-\w]+)/i, /sec-(sgh\w+)/i], [h, [d, ke], [c, L]], [/(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i], [h, [d, ee], [c, L]], [/\((ipad);[-\w\),; ]+apple/i, /applecoremedia\/[\w\.]+ \((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [h, [d, ee], [c, $]], [/(macintosh);/i], [h, [d, ee]], [/\b(sh-?[altvz]?\d\d[a-ekm]?)/i], [h, [d, Rt], [c, L]], [/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i], [h, [d, Te], [c, $]], [/(?:huawei|honor)([-\w ]+)[;\)]/i, /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i], [h, [d, Te], [c, L]], [/\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i, /\b; (\w+) build\/hm\1/i, /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i, /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i, /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i, /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i], [[h, /_/g, " "], [d, qe], [c, L]], [/oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i, /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i], [[h, /_/g, " "], [d, qe], [c, $]], [/; (\w+) bui.+ oppo/i, /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i], [h, [d, "OPPO"], [c, L]], [/vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i], [h, [d, "Vivo"], [c, L]], [/\b(rmx[1-3]\d{3})(?: bui|;|\))/i], [h, [d, "Realme"], [c, L]], [/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i, /\bmot(?:orola)?[- ](\w*)/i, /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i], [h, [d, at], [c, L]], [/\b(mz60\d|xoom[2 ]{0,2}) build\//i], [h, [d, at], [c, $]], [/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i], [h, [d, Oe], [c, $]], [/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i, /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i, /\blg-?([\d\w]+) bui/i], [h, [d, Oe], [c, L]], [/(ideatab[-\w ]+)/i, /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i], [h, [d, "Lenovo"], [c, $]], [/(?:maemo|nokia).*(n900|lumia \d+)/i, /nokia[-_ ]?([-\w\.]*)/i], [[h, /_/g, " "], [d, "Nokia"], [c, L]], [/(pixel c)\b/i], [h, [d, ze], [c, $]], [/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i], [h, [d, ze], [c, L]], [/droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [h, [d, _t], [c, L]], [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i], [[h, "Xperia Tablet"], [d, _t], [c, $]], [/ (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i], [h, [d, "OnePlus"], [c, L]], [/(alexa)webm/i, /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i, /(kf[a-z]+)( bui|\)).+silk\//i], [h, [d, j], [c, $]], [/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i], [[h, /(.+)/g, "Fire Phone $1"], [d, j], [c, L]], [/(playbook);[-\w\),; ]+(rim)/i], [h, d, [c, $]], [/\b((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10; (\w+)/i], [h, [d, Ae], [c, L]], [/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i], [h, [d, ue], [c, $]], [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i], [h, [d, ue], [c, L]], [/(nexus 9)/i], [h, [d, "HTC"], [c, $]], [/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i, /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i, /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i], [d, [h, /_/g, " "], [c, L]], [/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i], [h, [d, "Acer"], [c, $]], [/droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i], [h, [d, "Meizu"], [c, L]], [/; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i], [h, [d, "Ulefone"], [c, L]], [/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i, /(hp) ([\w ]+\w)/i, /(asus)-?(\w+)/i, /(microsoft); (lumia[\w ]+)/i, /(lenovo)[-_ ]?([-\w]+)/i, /(jolla)/i, /(oppo) ?([\w ]+) bui/i], [d, h, [c, L]], [/(kobo)\s(ereader|touch)/i, /(archos) (gamepad2?)/i, /(hp).+(touchpad(?!.+tablet)|tablet)/i, /(kindle)\/([\w\.]+)/i, /(nook)[\w ]+build\/(\w+)/i, /(dell) (strea[kpr\d ]*[\dko])/i, /(le[- ]+pan)[- ]+(\w{1,9}) bui/i, /(trinity)[- ]*(t\d{3}) bui/i, /(gigaset)[- ]+(q\w{1,9}) bui/i, /(vodafone) ([\w ]+)(?:\)| bui)/i], [d, h, [c, $]], [/(surface duo)/i], [h, [d, We], [c, $]], [/droid [\d\.]+; (fp\du?)(?: b|\))/i], [h, [d, "Fairphone"], [c, L]], [/(u304aa)/i], [h, [d, "AT&T"], [c, L]], [/\bsie-(\w*)/i], [h, [d, "Siemens"], [c, L]], [/\b(rct\w+) b/i], [h, [d, "RCA"], [c, $]], [/\b(venue[\d ]{2,7}) b/i], [h, [d, "Dell"], [c, $]], [/\b(q(?:mv|ta)\w+) b/i], [h, [d, "Verizon"], [c, $]], [/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i], [h, [d, "Barnes & Noble"], [c, $]], [/\b(tm\d{3}\w+) b/i], [h, [d, "NuVision"], [c, $]], [/\b(k88) b/i], [h, [d, "ZTE"], [c, $]], [/\b(nx\d{3}j) b/i], [h, [d, "ZTE"], [c, L]], [/\b(gen\d{3}) b.+49h/i], [h, [d, "Swiss"], [c, L]], [/\b(zur\d{3}) b/i], [h, [d, "Swiss"], [c, $]], [/\b((zeki)?tb.*\b) b/i], [h, [d, "Zeki"], [c, $]], [/\b([yr]\d{2}) b/i, /\b(dragon[- ]+touch |dt)(\w{5}) b/i], [[d, "Dragon Touch"], h, [c, $]], [/\b(ns-?\w{0,9}) b/i], [h, [d, "Insignia"], [c, $]], [/\b((nxa|next)-?\w{0,9}) b/i], [h, [d, "NextBook"], [c, $]], [/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i], [[d, "Voice"], h, [c, L]], [/\b(lvtel\-)?(v1[12]) b/i], [[d, "LvTel"], h, [c, L]], [/\b(ph-1) /i], [h, [d, "Essential"], [c, L]], [/\b(v(100md|700na|7011|917g).*\b) b/i], [h, [d, "Envizen"], [c, $]], [/\b(trio[-\w\. ]+) b/i], [h, [d, "MachSpeed"], [c, $]], [/\btu_(1491) b/i], [h, [d, "Rotor"], [c, $]], [/(shield[\w ]+) b/i], [h, [d, "Nvidia"], [c, $]], [/(sprint) (\w+)/i], [d, h, [c, L]], [/(kin\.[onetw]{3})/i], [[h, /\./g, " "], [d, We], [c, L]], [/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i], [h, [d, it], [c, $]], [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i], [h, [d, it], [c, L]], [/smart-tv.+(samsung)/i], [d, [c, M]], [/hbbtv.+maple;(\d+)/i], [[h, /^/, "SmartTV"], [d, ke], [c, M]], [/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i], [[d, Oe], [c, M]], [/(apple) ?tv/i], [d, [h, ee + " TV"], [c, M]], [/crkey/i], [[h, Ne + "cast"], [d, ze], [c, M]], [/droid.+aft(\w+)( bui|\))/i], [h, [d, j], [c, M]], [/\(dtv[\);].+(aquos)/i, /(aquos-tv[\w ]+)\)/i], [h, [d, Rt], [c, M]], [/(bravia[\w ]+)( bui|\))/i], [h, [d, _t], [c, M]], [/(mitv-\w{5}) bui/i], [h, [d, qe], [c, M]], [/Hbbtv.*(technisat) (.*);/i], [d, h, [c, M]], [/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i, /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i], [[d, b], [h, b], [c, M]], [/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i], [[c, M]], [/(ouya)/i, /(nintendo) ([wids3utch]+)/i], [d, h, [c, B]], [/droid.+; (shield) bui/i], [h, [d, "Nvidia"], [c, B]], [/(playstation [345portablevi]+)/i], [h, [d, _t], [c, B]], [/\b(xbox(?: one)?(?!; xbox))[\); ]/i], [h, [d, We], [c, B]], [/((pebble))app/i], [d, h, [c, K]], [/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i], [h, [d, ee], [c, K]], [/droid.+; (glass) \d/i], [h, [d, ze], [c, K]], [/droid.+; (wt63?0{2,3})\)/i], [h, [d, it], [c, K]], [/(quest( 2| pro)?)/i], [h, [d, me], [c, K]], [/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i], [d, [c, ae]], [/(aeobc)\b/i], [h, [d, j], [c, ae]], [/droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i], [h, [c, L]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i], [h, [c, $]], [/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i], [[c, $]], [/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i], [[c, L]], [/(android[-\w\. ]{0,9});.+buil/i], [h, [d, "Generic"]]], engine: [[/windows.+ edge\/([\w\.]+)/i], [S, [n, "EdgeHTML"]], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i], [S, [n, "Blink"]], [/(presto)\/([\w\.]+)/i, /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, /ekioh(flow)\/([\w\.]+)/i, /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i, /(icab)[\/ ]([23]\.[\d\.]+)/i, /\b(libweb)/i], [n, S], [/rv\:([\w\.]{1,9})\b.+(gecko)/i], [S, n]], os: [[/microsoft (windows) (vista|xp)/i], [n, S], [/(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i], [n, [S, Y, Re]], [/windows nt 6\.2; (arm)/i, /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i, /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i], [[S, Y, Re], [n, "Windows"]], [/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i, /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i, /cfnetwork\/.+darwin/i], [[S, /_/g, "."], [n, "iOS"]], [/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i], [[n, Ve], [S, /_/g, "."]], [/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i], [S, n], [/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i, /(blackberry)\w*\/([\w\.]*)/i, /(tizen|kaios)[\/ ]([\w\.]+)/i, /\((series40);/i], [n, S], [/\(bb(10);/i], [S, [n, Ae]], [/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i], [S, [n, "Symbian"]], [/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i], [S, [n, Ue + " OS"]], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i], [S, [n, "webOS"]], [/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i], [S, [n, "watchOS"]], [/crkey\/([\d\.]+)/i], [S, [n, Ne + "cast"]], [/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i], [[n, ye], S], [/panasonic;(viera)/i, /(netrange)mmh/i, /(nettv)\/(\d+\.[\w\.]+)/i, /(nintendo|playstation) ([wids345portablevuch]+)/i, /(xbox); +xbox ([^\);]+)/i, /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i, /(mint)[\/\(\) ]?(\w*)/i, /(mageia|vectorlinux)[; ]/i, /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i, /(hurd|linux) ?([\w\.]*)/i, /(gnu) ?([\w\.]*)/i, /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, /(haiku) (\w+)/i], [n, S], [/(sunos) ?([\w\.\d]*)/i], [[n, "Solaris"], S], [/((?:open)?solaris)[-\/ ]?([\w\.]*)/i, /(aix) ((\d)(?=\.|\)| )[\w\.])*/i, /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i, /(unix) ?([\w\.]*)/i], [n, S]] }, Ze = function(Ge, nt) {
              if (typeof Ge === m && (nt = Ge, Ge = t), !(this instanceof Ze)) return new Ze(Ge, nt).getResult();
              var Tt = typeof T !== p && T.navigator ? T.navigator : t, ft = Ge || (Tt && Tt.userAgent ? Tt.userAgent : ""), Yt = Tt && Tt.userAgentData ? Tt.userAgentData : t, Ot = nt ? function(Bt, cn) {
                var vn = {};
                for (var Pn in Bt) cn[Pn] && cn[Pn].length % 2 == 0 ? vn[Pn] = cn[Pn].concat(Bt[Pn]) : vn[Pn] = Bt[Pn];
                return vn;
              }(Je, nt) : Je, qt = Tt && Tt.userAgent == ft;
              return this.getBrowser = function() {
                var Bt, cn = {};
                return cn[n] = t, cn[S] = t, W.call(cn, ft, Ot.browser), cn[E] = typeof (Bt = cn[S]) === o ? Bt.replace(/[^\d\.]/g, "").split(".")[0] : t, qt && Tt && Tt.brave && typeof Tt.brave.isBrave == e && (cn[n] = "Brave"), cn;
              }, this.getCPU = function() {
                var Bt = {};
                return Bt[x] = t, W.call(Bt, ft, Ot.cpu), Bt;
              }, this.getDevice = function() {
                var Bt = {};
                return Bt[d] = t, Bt[h] = t, Bt[c] = t, W.call(Bt, ft, Ot.device), qt && !Bt[c] && Yt && Yt.mobile && (Bt[c] = L), qt && Bt[h] == "Macintosh" && Tt && typeof Tt.standalone !== p && Tt.maxTouchPoints && Tt.maxTouchPoints > 2 && (Bt[h] = "iPad", Bt[c] = $), Bt;
              }, this.getEngine = function() {
                var Bt = {};
                return Bt[n] = t, Bt[S] = t, W.call(Bt, ft, Ot.engine), Bt;
              }, this.getOS = function() {
                var Bt = {};
                return Bt[n] = t, Bt[S] = t, W.call(Bt, ft, Ot.os), qt && !Bt[n] && Yt && Yt.platform != "Unknown" && (Bt[n] = Yt.platform.replace(/chrome os/i, ye).replace(/macos/i, Ve)), Bt;
              }, this.getResult = function() {
                return { ua: this.getUA(), browser: this.getBrowser(), engine: this.getEngine(), os: this.getOS(), device: this.getDevice(), cpu: this.getCPU() };
              }, this.getUA = function() {
                return ft;
              }, this.setUA = function(Bt) {
                return ft = typeof Bt === o && Bt.length > 500 ? b(Bt, 500) : Bt, this;
              }, this.setUA(ft), this;
            };
            Ze.VERSION = "1.0.37", Ze.BROWSER = f([n, S, E]), Ze.CPU = f([x]), Ze.DEVICE = f([h, d, c, B, L, M, $, K, ae]), Ze.ENGINE = Ze.OS = f([n, S]), typeof Ee !== p ? (Pe.exports && (Ee = Pe.exports = Ze), Ee.UAParser = Ze) : C.amdO ? (ie = (function() {
              return Ze;
            }).call(Ee, C, Ee, Pe)) === t || (Pe.exports = ie) : typeof T !== p && (T.UAParser = Ze);
            var Fe = typeof T !== p && (T.jQuery || T.Zepto);
            if (Fe && !Fe.ua) {
              var we = new Ze();
              Fe.ua = we.getResult(), Fe.ua.get = function() {
                return we.getUA();
              }, Fe.ua.set = function(Ge) {
                we.setUA(Ge);
                var nt = we.getResult();
                for (var Tt in nt) Fe.ua[Tt] = nt[Tt];
              };
            }
          })(typeof window == "object" ? window : this);
        }, 7839: function(Pe, Ee, C) {
          function ie(T) {
            try {
              if (!C.g.localStorage) return !1;
            } catch {
              return !1;
            }
            var t = C.g.localStorage[T];
            return t != null && String(t).toLowerCase() === "true";
          }
          Pe.exports = function(T, t) {
            if (ie("noDeprecation")) return T;
            var e = !1;
            return function() {
              if (!e) {
                if (ie("throwDeprecation")) throw new Error(t);
                ie("traceDeprecation") ? console.trace(t) : console.warn(t), e = !0;
              }
              return T.apply(this, arguments);
            };
          };
        }, 9862: function() {
        }, 964: function() {
        }, 3165: function(Pe) {
          Pe.exports = JSON.parse('["mni-beng-in","mni-mtei-in","sat-deva-in","sat-olck-in","shi-latn-ma","shi-tfng-ma","vai-latn-lr","vai-vaii-lr","yue-hans-cn","yue-hant-hk","az-arab-ir","az-cyrl-az","az-latn-az","bm-nkoo-ml","bs-cyrl-ba","bs-latn-ba","en-dsrt-us","ff-adlm-gn","ff-latn-sn","ha-arab-ng","hi-latn-in","iu-latn-ca","ks-arab-in","ks-deva-in","mn-mong-cn","ms-arab-my","pa-arab-pk","pa-guru-in","sd-arab-pk","sd-deva-in","sr-cyrl-rs","sr-latn-rs","su-latn-id","uz-arab-af","uz-cyrl-uz","uz-latn-uz","zh-hans-cn","zh-hant-tw","mni-beng","sat-olck","shi-tfng","vai-vaii","yue-hant","az-latn","bs-latn","ff-latn","jbo-001","ks-arab","pa-guru","prg-001","sd-arab","sr-cyrl","su-latn","uz-latn","zh-hans","agq-cm","ar-001","arn-cl","asa-tz","ast-es","bas-cm","bem-zm","bez-tz","bgn-pk","blt-vn","brx-in","bss-cm","byn-er","cad-us","cch-ng","ccp-bd","ceb-ph","cgg-ug","chr-us","cic-us","ckb-iq","dav-ke","dje-ne","doi-in","dsb-de","dua-cm","dyo-sn","ebu-ke","eo-001","ewo-cm","fil-ph","fur-it","gaa-gh","gez-et","gsw-ch","guz-ke","haw-us","hsb-de","ia-001","ife-tg","io-001","jgo-cm","jmc-tz","kab-dz","kaj-ng","kam-ke","kcg-ng","kde-tz","kea-cv","ken-cm","khq-ml","kkj-cm","kln-ke","kok-in","kpe-lr","ksb-tz","ksf-cm","ksh-de","lag-tz","lkt-us","lrc-ir","luo-ke","luy-ke","mai-in","mas-ke","mer-ke","mfe-mu","mgh-mz","mgo-cm","moh-ca","mua-cm","mus-us","myv-ru","mzn-ir","naq-na","nds-de","nmg-cm","nnh-cm","nqo-gn","nso-za","nus-ss","nyn-ug","osa-us","pcm-ng","quc-gt","rof-tz","rwk-tz","sah-ru","saq-ke","sbp-tz","scn-it","sdh-ir","seh-mz","ses-ml","sid-et","sma-se","smj-se","smn-fi","sms-fi","ssy-er","syr-iq","szl-pl","teo-ug","tig-er","trv-tw","trw-pk","twq-ne","tzm-ma","vo-001","vun-tz","wae-ch","wal-et","wbp-au","xog-ug","yav-cm","yi-001","zgh-ma","aa-et","af-za","ak-gh","am-et","an-es","as-in","ba-ru","be-by","bg-bg","bm-ml","bn-bd","bo-cn","br-fr","ca-es","ce-ru","co-fr","cs-cz","cu-ru","cv-ru","cy-gb","da-dk","de-de","dv-mv","dz-bt","ee-gh","el-gr","en-us","es-es","et-ee","eu-es","fa-ir","fi-fi","fo-fo","fr-fr","fy-nl","ga-ie","gd-gb","gl-es","gn-py","gu-in","gv-im","ha-ng","he-il","hi-in","hr-hr","hu-hu","hy-am","id-id","ig-ng","ii-cn","is-is","it-it","iu-ca","ja-jp","jv-id","ka-ge","ki-ke","kk-kz","kl-gl","km-kh","kn-in","ko-kr","ku-tr","kw-gb","ky-kg","lb-lu","lg-ug","ln-cd","lo-la","lt-lt","lu-cd","lv-lv","mg-mg","mi-nz","mk-mk","ml-in","mn-mn","mr-in","ms-my","mt-mt","my-mm","nb-no","nd-zw","ne-np","nl-nl","nn-no","nr-za","nv-us","ny-mw","oc-fr","om-et","or-in","os-ge","pl-pl","ps-af","pt-br","qu-pe","rm-ch","rn-bi","ro-ro","ru-ru","rw-rw","sa-in","sc-it","se-no","sg-cf","si-lk","sk-sk","sl-si","sn-zw","so-so","sq-al","ss-za","st-za","sv-se","sw-tz","ta-in","te-in","tg-tj","th-th","ti-et","tk-tm","tn-za","to-to","tr-tr","ts-za","tt-ru","ug-cn","uk-ua","ur-pk","ve-za","vi-vn","wa-be","wo-sn","xh-za","yo-ng","zu-za"]');
        }, 5813: function(Pe) {
          Pe.exports = JSON.parse('[{"from":{"field":"script","value":"qaai"},"to":{"field":"script","value":"zinh"}},{"from":{"field":"region","value":"bu"},"to":{"field":"region","value":"mm"}},{"from":{"field":"region","value":"ct"},"to":{"field":"region","value":"ki"}},{"from":{"field":"region","value":"dd"},"to":{"field":"region","value":"de"}},{"from":{"field":"region","value":"dy"},"to":{"field":"region","value":"bj"}},{"from":{"field":"region","value":"fx"},"to":{"field":"region","value":"fr"}},{"from":{"field":"region","value":"hv"},"to":{"field":"region","value":"bf"}},{"from":{"field":"region","value":"jt"},"to":{"field":"region","value":"um"}},{"from":{"field":"region","value":"mi"},"to":{"field":"region","value":"um"}},{"from":{"field":"region","value":"nh"},"to":{"field":"region","value":"vu"}},{"from":{"field":"region","value":"nq"},"to":{"field":"region","value":"aq"}},{"from":{"field":"region","value":"pu"},"to":{"field":"region","value":"um"}},{"from":{"field":"region","value":"pz"},"to":{"field":"region","value":"pa"}},{"from":{"field":"region","value":"qu"},"to":{"field":"region","value":"eu"}},{"from":{"field":"region","value":"rh"},"to":{"field":"region","value":"zw"}},{"from":{"field":"region","value":"tp"},"to":{"field":"region","value":"tl"}},{"from":{"field":"region","value":"uk"},"to":{"field":"region","value":"gb"}},{"from":{"field":"region","value":"vd"},"to":{"field":"region","value":"vn"}},{"from":{"field":"region","value":"wk"},"to":{"field":"region","value":"um"}},{"from":{"field":"region","value":"yd"},"to":{"field":"region","value":"ye"}},{"from":{"field":"region","value":"zr"},"to":{"field":"region","value":"cd"}},{"from":{"field":"region","value":"230"},"to":{"field":"region","value":"et"}},{"from":{"field":"region","value":"280"},"to":{"field":"region","value":"de"}},{"from":{"field":"region","value":"736"},"to":{"field":"region","value":"sd"}},{"from":{"field":"region","value":"886"},"to":{"field":"region","value":"ye"}},{"from":{"field":"region","value":"958"},"to":{"field":"region","value":"aa"}},{"from":{"field":"region","value":"020"},"to":{"field":"region","value":"ad"}},{"from":{"field":"region","value":"784"},"to":{"field":"region","value":"ae"}},{"from":{"field":"region","value":"004"},"to":{"field":"region","value":"af"}},{"from":{"field":"region","value":"028"},"to":{"field":"region","value":"ag"}},{"from":{"field":"region","value":"660"},"to":{"field":"region","value":"ai"}},{"from":{"field":"region","value":"008"},"to":{"field":"region","value":"al"}},{"from":{"field":"region","value":"051"},"to":{"field":"region","value":"am"}},{"from":{"field":"region","value":"024"},"to":{"field":"region","value":"ao"}},{"from":{"field":"region","value":"010"},"to":{"field":"region","value":"aq"}},{"from":{"field":"region","value":"032"},"to":{"field":"region","value":"ar"}},{"from":{"field":"region","value":"016"},"to":{"field":"region","value":"as"}},{"from":{"field":"region","value":"040"},"to":{"field":"region","value":"at"}},{"from":{"field":"region","value":"036"},"to":{"field":"region","value":"au"}},{"from":{"field":"region","value":"533"},"to":{"field":"region","value":"aw"}},{"from":{"field":"region","value":"248"},"to":{"field":"region","value":"ax"}},{"from":{"field":"region","value":"031"},"to":{"field":"region","value":"az"}},{"from":{"field":"region","value":"070"},"to":{"field":"region","value":"ba"}},{"from":{"field":"region","value":"052"},"to":{"field":"region","value":"bb"}},{"from":{"field":"region","value":"050"},"to":{"field":"region","value":"bd"}},{"from":{"field":"region","value":"056"},"to":{"field":"region","value":"be"}},{"from":{"field":"region","value":"854"},"to":{"field":"region","value":"bf"}},{"from":{"field":"region","value":"100"},"to":{"field":"region","value":"bg"}},{"from":{"field":"region","value":"048"},"to":{"field":"region","value":"bh"}},{"from":{"field":"region","value":"108"},"to":{"field":"region","value":"bi"}},{"from":{"field":"region","value":"204"},"to":{"field":"region","value":"bj"}},{"from":{"field":"region","value":"652"},"to":{"field":"region","value":"bl"}},{"from":{"field":"region","value":"060"},"to":{"field":"region","value":"bm"}},{"from":{"field":"region","value":"096"},"to":{"field":"region","value":"bn"}},{"from":{"field":"region","value":"068"},"to":{"field":"region","value":"bo"}},{"from":{"field":"region","value":"535"},"to":{"field":"region","value":"bq"}},{"from":{"field":"region","value":"076"},"to":{"field":"region","value":"br"}},{"from":{"field":"region","value":"044"},"to":{"field":"region","value":"bs"}},{"from":{"field":"region","value":"064"},"to":{"field":"region","value":"bt"}},{"from":{"field":"region","value":"104"},"to":{"field":"region","value":"mm"}},{"from":{"field":"region","value":"074"},"to":{"field":"region","value":"bv"}},{"from":{"field":"region","value":"072"},"to":{"field":"region","value":"bw"}},{"from":{"field":"region","value":"112"},"to":{"field":"region","value":"by"}},{"from":{"field":"region","value":"084"},"to":{"field":"region","value":"bz"}},{"from":{"field":"region","value":"124"},"to":{"field":"region","value":"ca"}},{"from":{"field":"region","value":"166"},"to":{"field":"region","value":"cc"}},{"from":{"field":"region","value":"180"},"to":{"field":"region","value":"cd"}},{"from":{"field":"region","value":"140"},"to":{"field":"region","value":"cf"}},{"from":{"field":"region","value":"178"},"to":{"field":"region","value":"cg"}},{"from":{"field":"region","value":"756"},"to":{"field":"region","value":"ch"}},{"from":{"field":"region","value":"384"},"to":{"field":"region","value":"ci"}},{"from":{"field":"region","value":"184"},"to":{"field":"region","value":"ck"}},{"from":{"field":"region","value":"152"},"to":{"field":"region","value":"cl"}},{"from":{"field":"region","value":"120"},"to":{"field":"region","value":"cm"}},{"from":{"field":"region","value":"156"},"to":{"field":"region","value":"cn"}},{"from":{"field":"region","value":"170"},"to":{"field":"region","value":"co"}},{"from":{"field":"region","value":"188"},"to":{"field":"region","value":"cr"}},{"from":{"field":"region","value":"192"},"to":{"field":"region","value":"cu"}},{"from":{"field":"region","value":"132"},"to":{"field":"region","value":"cv"}},{"from":{"field":"region","value":"531"},"to":{"field":"region","value":"cw"}},{"from":{"field":"region","value":"162"},"to":{"field":"region","value":"cx"}},{"from":{"field":"region","value":"196"},"to":{"field":"region","value":"cy"}},{"from":{"field":"region","value":"203"},"to":{"field":"region","value":"cz"}},{"from":{"field":"region","value":"278"},"to":{"field":"region","value":"de"}},{"from":{"field":"region","value":"276"},"to":{"field":"region","value":"de"}},{"from":{"field":"region","value":"262"},"to":{"field":"region","value":"dj"}},{"from":{"field":"region","value":"208"},"to":{"field":"region","value":"dk"}},{"from":{"field":"region","value":"212"},"to":{"field":"region","value":"dm"}},{"from":{"field":"region","value":"214"},"to":{"field":"region","value":"do"}},{"from":{"field":"region","value":"012"},"to":{"field":"region","value":"dz"}},{"from":{"field":"region","value":"218"},"to":{"field":"region","value":"ec"}},{"from":{"field":"region","value":"233"},"to":{"field":"region","value":"ee"}},{"from":{"field":"region","value":"818"},"to":{"field":"region","value":"eg"}},{"from":{"field":"region","value":"732"},"to":{"field":"region","value":"eh"}},{"from":{"field":"region","value":"232"},"to":{"field":"region","value":"er"}},{"from":{"field":"region","value":"724"},"to":{"field":"region","value":"es"}},{"from":{"field":"region","value":"231"},"to":{"field":"region","value":"et"}},{"from":{"field":"region","value":"246"},"to":{"field":"region","value":"fi"}},{"from":{"field":"region","value":"242"},"to":{"field":"region","value":"fj"}},{"from":{"field":"region","value":"238"},"to":{"field":"region","value":"fk"}},{"from":{"field":"region","value":"583"},"to":{"field":"region","value":"fm"}},{"from":{"field":"region","value":"234"},"to":{"field":"region","value":"fo"}},{"from":{"field":"region","value":"250"},"to":{"field":"region","value":"fr"}},{"from":{"field":"region","value":"249"},"to":{"field":"region","value":"fr"}},{"from":{"field":"region","value":"266"},"to":{"field":"region","value":"ga"}},{"from":{"field":"region","value":"826"},"to":{"field":"region","value":"gb"}},{"from":{"field":"region","value":"308"},"to":{"field":"region","value":"gd"}},{"from":{"field":"region","value":"268"},"to":{"field":"region","value":"ge"}},{"from":{"field":"region","value":"254"},"to":{"field":"region","value":"gf"}},{"from":{"field":"region","value":"831"},"to":{"field":"region","value":"gg"}},{"from":{"field":"region","value":"288"},"to":{"field":"region","value":"gh"}},{"from":{"field":"region","value":"292"},"to":{"field":"region","value":"gi"}},{"from":{"field":"region","value":"304"},"to":{"field":"region","value":"gl"}},{"from":{"field":"region","value":"270"},"to":{"field":"region","value":"gm"}},{"from":{"field":"region","value":"324"},"to":{"field":"region","value":"gn"}},{"from":{"field":"region","value":"312"},"to":{"field":"region","value":"gp"}},{"from":{"field":"region","value":"226"},"to":{"field":"region","value":"gq"}},{"from":{"field":"region","value":"300"},"to":{"field":"region","value":"gr"}},{"from":{"field":"region","value":"239"},"to":{"field":"region","value":"gs"}},{"from":{"field":"region","value":"320"},"to":{"field":"region","value":"gt"}},{"from":{"field":"region","value":"316"},"to":{"field":"region","value":"gu"}},{"from":{"field":"region","value":"624"},"to":{"field":"region","value":"gw"}},{"from":{"field":"region","value":"328"},"to":{"field":"region","value":"gy"}},{"from":{"field":"region","value":"344"},"to":{"field":"region","value":"hk"}},{"from":{"field":"region","value":"334"},"to":{"field":"region","value":"hm"}},{"from":{"field":"region","value":"340"},"to":{"field":"region","value":"hn"}},{"from":{"field":"region","value":"191"},"to":{"field":"region","value":"hr"}},{"from":{"field":"region","value":"332"},"to":{"field":"region","value":"ht"}},{"from":{"field":"region","value":"348"},"to":{"field":"region","value":"hu"}},{"from":{"field":"region","value":"360"},"to":{"field":"region","value":"id"}},{"from":{"field":"region","value":"372"},"to":{"field":"region","value":"ie"}},{"from":{"field":"region","value":"376"},"to":{"field":"region","value":"il"}},{"from":{"field":"region","value":"833"},"to":{"field":"region","value":"im"}},{"from":{"field":"region","value":"356"},"to":{"field":"region","value":"in"}},{"from":{"field":"region","value":"086"},"to":{"field":"region","value":"io"}},{"from":{"field":"region","value":"368"},"to":{"field":"region","value":"iq"}},{"from":{"field":"region","value":"364"},"to":{"field":"region","value":"ir"}},{"from":{"field":"region","value":"352"},"to":{"field":"region","value":"is"}},{"from":{"field":"region","value":"380"},"to":{"field":"region","value":"it"}},{"from":{"field":"region","value":"832"},"to":{"field":"region","value":"je"}},{"from":{"field":"region","value":"388"},"to":{"field":"region","value":"jm"}},{"from":{"field":"region","value":"400"},"to":{"field":"region","value":"jo"}},{"from":{"field":"region","value":"392"},"to":{"field":"region","value":"jp"}},{"from":{"field":"region","value":"404"},"to":{"field":"region","value":"ke"}},{"from":{"field":"region","value":"417"},"to":{"field":"region","value":"kg"}},{"from":{"field":"region","value":"116"},"to":{"field":"region","value":"kh"}},{"from":{"field":"region","value":"296"},"to":{"field":"region","value":"ki"}},{"from":{"field":"region","value":"174"},"to":{"field":"region","value":"km"}},{"from":{"field":"region","value":"659"},"to":{"field":"region","value":"kn"}},{"from":{"field":"region","value":"408"},"to":{"field":"region","value":"kp"}},{"from":{"field":"region","value":"410"},"to":{"field":"region","value":"kr"}},{"from":{"field":"region","value":"414"},"to":{"field":"region","value":"kw"}},{"from":{"field":"region","value":"136"},"to":{"field":"region","value":"ky"}},{"from":{"field":"region","value":"398"},"to":{"field":"region","value":"kz"}},{"from":{"field":"region","value":"418"},"to":{"field":"region","value":"la"}},{"from":{"field":"region","value":"422"},"to":{"field":"region","value":"lb"}},{"from":{"field":"region","value":"662"},"to":{"field":"region","value":"lc"}},{"from":{"field":"region","value":"438"},"to":{"field":"region","value":"li"}},{"from":{"field":"region","value":"144"},"to":{"field":"region","value":"lk"}},{"from":{"field":"region","value":"430"},"to":{"field":"region","value":"lr"}},{"from":{"field":"region","value":"426"},"to":{"field":"region","value":"ls"}},{"from":{"field":"region","value":"440"},"to":{"field":"region","value":"lt"}},{"from":{"field":"region","value":"442"},"to":{"field":"region","value":"lu"}},{"from":{"field":"region","value":"428"},"to":{"field":"region","value":"lv"}},{"from":{"field":"region","value":"434"},"to":{"field":"region","value":"ly"}},{"from":{"field":"region","value":"504"},"to":{"field":"region","value":"ma"}},{"from":{"field":"region","value":"492"},"to":{"field":"region","value":"mc"}},{"from":{"field":"region","value":"498"},"to":{"field":"region","value":"md"}},{"from":{"field":"region","value":"499"},"to":{"field":"region","value":"me"}},{"from":{"field":"region","value":"663"},"to":{"field":"region","value":"mf"}},{"from":{"field":"region","value":"450"},"to":{"field":"region","value":"mg"}},{"from":{"field":"region","value":"584"},"to":{"field":"region","value":"mh"}},{"from":{"field":"region","value":"807"},"to":{"field":"region","value":"mk"}},{"from":{"field":"region","value":"466"},"to":{"field":"region","value":"ml"}},{"from":{"field":"region","value":"496"},"to":{"field":"region","value":"mn"}},{"from":{"field":"region","value":"446"},"to":{"field":"region","value":"mo"}},{"from":{"field":"region","value":"580"},"to":{"field":"region","value":"mp"}},{"from":{"field":"region","value":"474"},"to":{"field":"region","value":"mq"}},{"from":{"field":"region","value":"478"},"to":{"field":"region","value":"mr"}},{"from":{"field":"region","value":"500"},"to":{"field":"region","value":"ms"}},{"from":{"field":"region","value":"470"},"to":{"field":"region","value":"mt"}},{"from":{"field":"region","value":"480"},"to":{"field":"region","value":"mu"}},{"from":{"field":"region","value":"462"},"to":{"field":"region","value":"mv"}},{"from":{"field":"region","value":"454"},"to":{"field":"region","value":"mw"}},{"from":{"field":"region","value":"484"},"to":{"field":"region","value":"mx"}},{"from":{"field":"region","value":"458"},"to":{"field":"region","value":"my"}},{"from":{"field":"region","value":"508"},"to":{"field":"region","value":"mz"}},{"from":{"field":"region","value":"516"},"to":{"field":"region","value":"na"}},{"from":{"field":"region","value":"540"},"to":{"field":"region","value":"nc"}},{"from":{"field":"region","value":"562"},"to":{"field":"region","value":"ne"}},{"from":{"field":"region","value":"574"},"to":{"field":"region","value":"nf"}},{"from":{"field":"region","value":"566"},"to":{"field":"region","value":"ng"}},{"from":{"field":"region","value":"558"},"to":{"field":"region","value":"ni"}},{"from":{"field":"region","value":"528"},"to":{"field":"region","value":"nl"}},{"from":{"field":"region","value":"578"},"to":{"field":"region","value":"no"}},{"from":{"field":"region","value":"524"},"to":{"field":"region","value":"np"}},{"from":{"field":"region","value":"520"},"to":{"field":"region","value":"nr"}},{"from":{"field":"region","value":"570"},"to":{"field":"region","value":"nu"}},{"from":{"field":"region","value":"554"},"to":{"field":"region","value":"nz"}},{"from":{"field":"region","value":"512"},"to":{"field":"region","value":"om"}},{"from":{"field":"region","value":"591"},"to":{"field":"region","value":"pa"}},{"from":{"field":"region","value":"604"},"to":{"field":"region","value":"pe"}},{"from":{"field":"region","value":"258"},"to":{"field":"region","value":"pf"}},{"from":{"field":"region","value":"598"},"to":{"field":"region","value":"pg"}},{"from":{"field":"region","value":"608"},"to":{"field":"region","value":"ph"}},{"from":{"field":"region","value":"586"},"to":{"field":"region","value":"pk"}},{"from":{"field":"region","value":"616"},"to":{"field":"region","value":"pl"}},{"from":{"field":"region","value":"666"},"to":{"field":"region","value":"pm"}},{"from":{"field":"region","value":"612"},"to":{"field":"region","value":"pn"}},{"from":{"field":"region","value":"630"},"to":{"field":"region","value":"pr"}},{"from":{"field":"region","value":"275"},"to":{"field":"region","value":"ps"}},{"from":{"field":"region","value":"620"},"to":{"field":"region","value":"pt"}},{"from":{"field":"region","value":"585"},"to":{"field":"region","value":"pw"}},{"from":{"field":"region","value":"600"},"to":{"field":"region","value":"py"}},{"from":{"field":"region","value":"634"},"to":{"field":"region","value":"qa"}},{"from":{"field":"region","value":"959"},"to":{"field":"region","value":"qm"}},{"from":{"field":"region","value":"960"},"to":{"field":"region","value":"qn"}},{"from":{"field":"region","value":"962"},"to":{"field":"region","value":"qp"}},{"from":{"field":"region","value":"963"},"to":{"field":"region","value":"qq"}},{"from":{"field":"region","value":"964"},"to":{"field":"region","value":"qr"}},{"from":{"field":"region","value":"965"},"to":{"field":"region","value":"qs"}},{"from":{"field":"region","value":"966"},"to":{"field":"region","value":"qt"}},{"from":{"field":"region","value":"967"},"to":{"field":"region","value":"eu"}},{"from":{"field":"region","value":"968"},"to":{"field":"region","value":"qv"}},{"from":{"field":"region","value":"969"},"to":{"field":"region","value":"qw"}},{"from":{"field":"region","value":"970"},"to":{"field":"region","value":"qx"}},{"from":{"field":"region","value":"971"},"to":{"field":"region","value":"qy"}},{"from":{"field":"region","value":"972"},"to":{"field":"region","value":"qz"}},{"from":{"field":"region","value":"638"},"to":{"field":"region","value":"re"}},{"from":{"field":"region","value":"642"},"to":{"field":"region","value":"ro"}},{"from":{"field":"region","value":"688"},"to":{"field":"region","value":"rs"}},{"from":{"field":"region","value":"643"},"to":{"field":"region","value":"ru"}},{"from":{"field":"region","value":"646"},"to":{"field":"region","value":"rw"}},{"from":{"field":"region","value":"682"},"to":{"field":"region","value":"sa"}},{"from":{"field":"region","value":"090"},"to":{"field":"region","value":"sb"}},{"from":{"field":"region","value":"690"},"to":{"field":"region","value":"sc"}},{"from":{"field":"region","value":"729"},"to":{"field":"region","value":"sd"}},{"from":{"field":"region","value":"752"},"to":{"field":"region","value":"se"}},{"from":{"field":"region","value":"702"},"to":{"field":"region","value":"sg"}},{"from":{"field":"region","value":"654"},"to":{"field":"region","value":"sh"}},{"from":{"field":"region","value":"705"},"to":{"field":"region","value":"si"}},{"from":{"field":"region","value":"744"},"to":{"field":"region","value":"sj"}},{"from":{"field":"region","value":"703"},"to":{"field":"region","value":"sk"}},{"from":{"field":"region","value":"694"},"to":{"field":"region","value":"sl"}},{"from":{"field":"region","value":"674"},"to":{"field":"region","value":"sm"}},{"from":{"field":"region","value":"686"},"to":{"field":"region","value":"sn"}},{"from":{"field":"region","value":"706"},"to":{"field":"region","value":"so"}},{"from":{"field":"region","value":"740"},"to":{"field":"region","value":"sr"}},{"from":{"field":"region","value":"728"},"to":{"field":"region","value":"ss"}},{"from":{"field":"region","value":"678"},"to":{"field":"region","value":"st"}},{"from":{"field":"region","value":"222"},"to":{"field":"region","value":"sv"}},{"from":{"field":"region","value":"534"},"to":{"field":"region","value":"sx"}},{"from":{"field":"region","value":"760"},"to":{"field":"region","value":"sy"}},{"from":{"field":"region","value":"748"},"to":{"field":"region","value":"sz"}},{"from":{"field":"region","value":"796"},"to":{"field":"region","value":"tc"}},{"from":{"field":"region","value":"148"},"to":{"field":"region","value":"td"}},{"from":{"field":"region","value":"260"},"to":{"field":"region","value":"tf"}},{"from":{"field":"region","value":"768"},"to":{"field":"region","value":"tg"}},{"from":{"field":"region","value":"764"},"to":{"field":"region","value":"th"}},{"from":{"field":"region","value":"762"},"to":{"field":"region","value":"tj"}},{"from":{"field":"region","value":"772"},"to":{"field":"region","value":"tk"}},{"from":{"field":"region","value":"626"},"to":{"field":"region","value":"tl"}},{"from":{"field":"region","value":"795"},"to":{"field":"region","value":"tm"}},{"from":{"field":"region","value":"788"},"to":{"field":"region","value":"tn"}},{"from":{"field":"region","value":"776"},"to":{"field":"region","value":"to"}},{"from":{"field":"region","value":"792"},"to":{"field":"region","value":"tr"}},{"from":{"field":"region","value":"780"},"to":{"field":"region","value":"tt"}},{"from":{"field":"region","value":"798"},"to":{"field":"region","value":"tv"}},{"from":{"field":"region","value":"158"},"to":{"field":"region","value":"tw"}},{"from":{"field":"region","value":"834"},"to":{"field":"region","value":"tz"}},{"from":{"field":"region","value":"804"},"to":{"field":"region","value":"ua"}},{"from":{"field":"region","value":"800"},"to":{"field":"region","value":"ug"}},{"from":{"field":"region","value":"581"},"to":{"field":"region","value":"um"}},{"from":{"field":"region","value":"840"},"to":{"field":"region","value":"us"}},{"from":{"field":"region","value":"858"},"to":{"field":"region","value":"uy"}},{"from":{"field":"region","value":"860"},"to":{"field":"region","value":"uz"}},{"from":{"field":"region","value":"336"},"to":{"field":"region","value":"va"}},{"from":{"field":"region","value":"670"},"to":{"field":"region","value":"vc"}},{"from":{"field":"region","value":"862"},"to":{"field":"region","value":"ve"}},{"from":{"field":"region","value":"092"},"to":{"field":"region","value":"vg"}},{"from":{"field":"region","value":"850"},"to":{"field":"region","value":"vi"}},{"from":{"field":"region","value":"704"},"to":{"field":"region","value":"vn"}},{"from":{"field":"region","value":"548"},"to":{"field":"region","value":"vu"}},{"from":{"field":"region","value":"876"},"to":{"field":"region","value":"wf"}},{"from":{"field":"region","value":"882"},"to":{"field":"region","value":"ws"}},{"from":{"field":"region","value":"973"},"to":{"field":"region","value":"xa"}},{"from":{"field":"region","value":"974"},"to":{"field":"region","value":"xb"}},{"from":{"field":"region","value":"975"},"to":{"field":"region","value":"xc"}},{"from":{"field":"region","value":"976"},"to":{"field":"region","value":"xd"}},{"from":{"field":"region","value":"977"},"to":{"field":"region","value":"xe"}},{"from":{"field":"region","value":"978"},"to":{"field":"region","value":"xf"}},{"from":{"field":"region","value":"979"},"to":{"field":"region","value":"xg"}},{"from":{"field":"region","value":"980"},"to":{"field":"region","value":"xh"}},{"from":{"field":"region","value":"981"},"to":{"field":"region","value":"xi"}},{"from":{"field":"region","value":"982"},"to":{"field":"region","value":"xj"}},{"from":{"field":"region","value":"983"},"to":{"field":"region","value":"xk"}},{"from":{"field":"region","value":"984"},"to":{"field":"region","value":"xl"}},{"from":{"field":"region","value":"985"},"to":{"field":"region","value":"xm"}},{"from":{"field":"region","value":"986"},"to":{"field":"region","value":"xn"}},{"from":{"field":"region","value":"987"},"to":{"field":"region","value":"xo"}},{"from":{"field":"region","value":"988"},"to":{"field":"region","value":"xp"}},{"from":{"field":"region","value":"989"},"to":{"field":"region","value":"xq"}},{"from":{"field":"region","value":"990"},"to":{"field":"region","value":"xr"}},{"from":{"field":"region","value":"991"},"to":{"field":"region","value":"xs"}},{"from":{"field":"region","value":"992"},"to":{"field":"region","value":"xt"}},{"from":{"field":"region","value":"993"},"to":{"field":"region","value":"xu"}},{"from":{"field":"region","value":"994"},"to":{"field":"region","value":"xv"}},{"from":{"field":"region","value":"995"},"to":{"field":"region","value":"xw"}},{"from":{"field":"region","value":"996"},"to":{"field":"region","value":"xx"}},{"from":{"field":"region","value":"997"},"to":{"field":"region","value":"xy"}},{"from":{"field":"region","value":"998"},"to":{"field":"region","value":"xz"}},{"from":{"field":"region","value":"720"},"to":{"field":"region","value":"ye"}},{"from":{"field":"region","value":"887"},"to":{"field":"region","value":"ye"}},{"from":{"field":"region","value":"175"},"to":{"field":"region","value":"yt"}},{"from":{"field":"region","value":"710"},"to":{"field":"region","value":"za"}},{"from":{"field":"region","value":"894"},"to":{"field":"region","value":"zm"}},{"from":{"field":"region","value":"716"},"to":{"field":"region","value":"zw"}},{"from":{"field":"region","value":"999"},"to":{"field":"region","value":"zz"}},{"from":{"field":"variants","value":"aaland"},"to":{"field":"region","value":"ax"}},{"from":{"field":"variants","value":"polytoni"},"to":{"field":"variants","value":"polyton"}},{"from":{"field":"variants","value":"heploc"},"to":{"field":"variants","value":"alalc97"}},{"from":{"field":"variants","value":"arevela"},"to":{"field":"language","value":"hy"}},{"from":{"field":"variants","value":"arevmda"},"to":{"field":"language","value":"hyw"}}]');
        }, 9460: function(Pe) {
          Pe.exports = JSON.parse('{"region":{"172":["ru","am","az","by","ge","kg","kz","md","tj","tm","ua","uz"],"200":["cz","sk"],"530":["cw","sx","bq"],"532":["cw","sx","bq"],"536":["sa","iq"],"582":["fm","mh","mp","pw"],"810":["ru","am","az","by","ee","ge","kz","kg","lv","lt","md","tj","tm","ua","uz"],"830":["je","gg"],"890":["rs","me","si","hr","mk","ba"],"891":["rs","me"],"an":["cw","sx","bq"],"cs":["rs","me"],"fq":["aq","tf"],"nt":["sa","iq"],"pc":["fm","mh","mp","pw"],"su":["ru","am","az","by","ee","ge","kz","kg","lv","lt","md","tj","tm","ua","uz"],"yu":["rs","me"],"062":["034","143"],"ant":["cw","sx","bq"],"scg":["rs","me"],"ntz":["sa","iq"],"sun":["ru","am","az","by","ee","ge","kz","kg","lv","lt","md","tj","tm","ua","uz"],"yug":["rs","me"]}}');
        }, 7778: function(Pe) {
          Pe.exports = JSON.parse('[{"from":"in","to":"id"},{"from":"iw","to":"he"},{"from":"ji","to":"yi"},{"from":"jw","to":"jv"},{"from":"mo","to":"ro"},{"from":"scc","to":"sr"},{"from":"scr","to":"hr"},{"from":"aam","to":"aas"},{"from":"adp","to":"dz"},{"from":"aue","to":"ktz"},{"from":"ayx","to":"nun"},{"from":"bgm","to":"bcg"},{"from":"bjd","to":"drl"},{"from":"ccq","to":"rki"},{"from":"cjr","to":"mom"},{"from":"cka","to":"cmr"},{"from":"cmk","to":"xch"},{"from":"coy","to":"pij"},{"from":"cqu","to":"quh"},{"from":"drh","to":"mn"},{"from":"drw","to":"fa-af"},{"from":"gav","to":"dev"},{"from":"gfx","to":"vaj"},{"from":"ggn","to":"gvr"},{"from":"gti","to":"nyc"},{"from":"guv","to":"duz"},{"from":"hrr","to":"jal"},{"from":"ibi","to":"opa"},{"from":"ilw","to":"gal"},{"from":"jeg","to":"oyb"},{"from":"kgc","to":"tdf"},{"from":"kgh","to":"kml"},{"from":"koj","to":"kwv"},{"from":"krm","to":"bmf"},{"from":"ktr","to":"dtp"},{"from":"kvs","to":"gdj"},{"from":"kwq","to":"yam"},{"from":"kxe","to":"tvd"},{"from":"kzj","to":"dtp"},{"from":"kzt","to":"dtp"},{"from":"lii","to":"raq"},{"from":"lmm","to":"rmx"},{"from":"meg","to":"cir"},{"from":"mst","to":"mry"},{"from":"mwj","to":"vaj"},{"from":"myt","to":"mry"},{"from":"nad","to":"xny"},{"from":"ncp","to":"kdz"},{"from":"nnx","to":"ngv"},{"from":"nts","to":"pij"},{"from":"oun","to":"vaj"},{"from":"pcr","to":"adx"},{"from":"pmc","to":"huw"},{"from":"pmu","to":"phr"},{"from":"ppa","to":"bfy"},{"from":"ppr","to":"lcq"},{"from":"pry","to":"prt"},{"from":"puz","to":"pub"},{"from":"sca","to":"hle"},{"from":"skk","to":"oyb"},{"from":"tdu","to":"dtp"},{"from":"thc","to":"tpo"},{"from":"thx","to":"oyb"},{"from":"tie","to":"ras"},{"from":"tkk","to":"twm"},{"from":"tlw","to":"weo"},{"from":"tmp","to":"tyj"},{"from":"tne","to":"kak"},{"from":"tnf","to":"fa-af"},{"from":"tsf","to":"taj"},{"from":"uok","to":"ema"},{"from":"xba","to":"cax"},{"from":"xia","to":"acn"},{"from":"xkh","to":"waw"},{"from":"xsj","to":"suj"},{"from":"ybd","to":"rki"},{"from":"yma","to":"lrr"},{"from":"ymt","to":"mtm"},{"from":"yos","to":"zom"},{"from":"yuu","to":"yug"},{"from":"asd","to":"snz"},{"from":"dit","to":"dif"},{"from":"llo","to":"ngt"},{"from":"myd","to":"aog"},{"from":"nns","to":"nbr"},{"from":"sgn-br","to":"bzs"},{"from":"sgn-co","to":"csn"},{"from":"sgn-de","to":"gsg"},{"from":"sgn-dk","to":"dsl"},{"from":"sgn-fr","to":"fsl"},{"from":"sgn-gb","to":"bfi"},{"from":"sgn-gr","to":"gss"},{"from":"sgn-ie","to":"isg"},{"from":"sgn-it","to":"ise"},{"from":"sgn-jp","to":"jsl"},{"from":"sgn-mx","to":"mfs"},{"from":"sgn-ni","to":"ncs"},{"from":"sgn-nl","to":"dse"},{"from":"sgn-no","to":"nsi"},{"from":"sgn-pt","to":"psr"},{"from":"sgn-se","to":"swl"},{"from":"sgn-us","to":"ase"},{"from":"sgn-za","to":"sfs"},{"from":"no-bokmal","to":"nb"},{"from":"no-nynorsk","to":"nn"},{"from":"aa-saaho","to":"ssy"},{"from":"sh","to":"sr-latn"},{"from":"cnr","to":"sr-me"},{"from":"no","to":"nb"},{"from":"tl","to":"fil"},{"from":"az-az","to":"az-latn-az"},{"from":"bs-ba","to":"bs-latn-ba"},{"from":"ha-latn-gh","to":"ha-gh"},{"from":"ha-latn-ne","to":"ha-ne"},{"from":"ha-latn-ng","to":"ha-ng"},{"from":"kk-cyrl-kz","to":"kk-kz"},{"from":"ky-cyrl-kg","to":"ky-kg"},{"from":"ks-arab-in","to":"ks-in"},{"from":"mn-cyrl-mn","to":"mn-mn"},{"from":"ms-latn-bn","to":"ms-bn"},{"from":"ms-latn-my","to":"ms-my"},{"from":"ms-latn-sg","to":"ms-sg"},{"from":"pa-in","to":"pa-guru-in"},{"from":"pa-pk","to":"pa-arab-pk"},{"from":"shi-ma","to":"shi-tfng-ma"},{"from":"sr-ba","to":"sr-cyrl-ba"},{"from":"sr-me","to":"sr-latn-me"},{"from":"sr-rs","to":"sr-cyrl-rs"},{"from":"sr-xk","to":"sr-cyrl-xk"},{"from":"tzm-latn-ma","to":"tzm-ma"},{"from":"ug-arab-cn","to":"ug-cn"},{"from":"uz-af","to":"uz-arab-af"},{"from":"uz-uz","to":"uz-latn-uz"},{"from":"vai-lr","to":"vai-vaii-lr"},{"from":"yue-cn","to":"yue-hans-cn"},{"from":"yue-hk","to":"yue-hant-hk"},{"from":"zh-cn","to":"zh-hans-cn"},{"from":"zh-hk","to":"zh-hant-hk"},{"from":"zh-mo","to":"zh-hant-mo"},{"from":"zh-sg","to":"zh-hans-sg"},{"from":"zh-tw","to":"zh-hant-tw"},{"from":"aju","to":"jrb"},{"from":"als","to":"sq"},{"from":"arb","to":"ar"},{"from":"ayr","to":"ay"},{"from":"azj","to":"az"},{"from":"bcc","to":"bal"},{"from":"bcl","to":"bik"},{"from":"bxk","to":"luy"},{"from":"bxr","to":"bua"},{"from":"cld","to":"syr"},{"from":"cmn","to":"zh"},{"from":"cwd","to":"cr"},{"from":"dgo","to":"doi"},{"from":"dhd","to":"mwr"},{"from":"dik","to":"din"},{"from":"diq","to":"zza"},{"from":"lbk","to":"bnc"},{"from":"ekk","to":"et"},{"from":"emk","to":"man"},{"from":"esk","to":"ik"},{"from":"fat","to":"ak"},{"from":"fuc","to":"ff"},{"from":"gaz","to":"om"},{"from":"gbo","to":"grb"},{"from":"gno","to":"gon"},{"from":"gug","to":"gn"},{"from":"gya","to":"gba"},{"from":"hdn","to":"hai"},{"from":"hea","to":"hmn"},{"from":"ike","to":"iu"},{"from":"kmr","to":"ku"},{"from":"knc","to":"kr"},{"from":"kng","to":"kg"},{"from":"knn","to":"kok"},{"from":"kpv","to":"kv"},{"from":"lvs","to":"lv"},{"from":"mhr","to":"chm"},{"from":"mup","to":"raj"},{"from":"khk","to":"mn"},{"from":"npi","to":"ne"},{"from":"ojg","to":"oj"},{"from":"ory","to":"or"},{"from":"pbu","to":"ps"},{"from":"pes","to":"fa"},{"from":"plt","to":"mg"},{"from":"pnb","to":"lah"},{"from":"quz","to":"qu"},{"from":"rmy","to":"rom"},{"from":"spy","to":"kln"},{"from":"src","to":"sc"},{"from":"swh","to":"sw"},{"from":"ttq","to":"tmh"},{"from":"tw","to":"ak"},{"from":"umu","to":"del"},{"from":"uzn","to":"uz"},{"from":"xpe","to":"kpe"},{"from":"xsl","to":"den"},{"from":"ydd","to":"yi"},{"from":"zai","to":"zap"},{"from":"zsm","to":"ms"},{"from":"zyb","to":"za"},{"from":"him","to":"srx"},{"from":"mnk","to":"man"},{"from":"bh","to":"bho"},{"from":"prs","to":"fa-af"},{"from":"swc","to":"sw-cd"},{"from":"aar","to":"aa"},{"from":"abk","to":"ab"},{"from":"ave","to":"ae"},{"from":"afr","to":"af"},{"from":"aka","to":"ak"},{"from":"amh","to":"am"},{"from":"arg","to":"an"},{"from":"ara","to":"ar"},{"from":"asm","to":"as"},{"from":"ava","to":"av"},{"from":"aym","to":"ay"},{"from":"aze","to":"az"},{"from":"bak","to":"ba"},{"from":"bel","to":"be"},{"from":"bul","to":"bg"},{"from":"bih","to":"bho"},{"from":"bis","to":"bi"},{"from":"bam","to":"bm"},{"from":"ben","to":"bn"},{"from":"bod","to":"bo"},{"from":"bre","to":"br"},{"from":"bos","to":"bs"},{"from":"cat","to":"ca"},{"from":"che","to":"ce"},{"from":"cha","to":"ch"},{"from":"cos","to":"co"},{"from":"cre","to":"cr"},{"from":"ces","to":"cs"},{"from":"chu","to":"cu"},{"from":"chv","to":"cv"},{"from":"cym","to":"cy"},{"from":"dan","to":"da"},{"from":"deu","to":"de"},{"from":"div","to":"dv"},{"from":"dzo","to":"dz"},{"from":"ewe","to":"ee"},{"from":"ell","to":"el"},{"from":"eng","to":"en"},{"from":"epo","to":"eo"},{"from":"spa","to":"es"},{"from":"est","to":"et"},{"from":"eus","to":"eu"},{"from":"fas","to":"fa"},{"from":"ful","to":"ff"},{"from":"fin","to":"fi"},{"from":"fij","to":"fj"},{"from":"fao","to":"fo"},{"from":"fra","to":"fr"},{"from":"fry","to":"fy"},{"from":"gle","to":"ga"},{"from":"gla","to":"gd"},{"from":"glg","to":"gl"},{"from":"grn","to":"gn"},{"from":"guj","to":"gu"},{"from":"glv","to":"gv"},{"from":"hau","to":"ha"},{"from":"heb","to":"he"},{"from":"hin","to":"hi"},{"from":"hmo","to":"ho"},{"from":"hrv","to":"hr"},{"from":"hat","to":"ht"},{"from":"hun","to":"hu"},{"from":"hye","to":"hy"},{"from":"her","to":"hz"},{"from":"ina","to":"ia"},{"from":"ind","to":"id"},{"from":"ile","to":"ie"},{"from":"ibo","to":"ig"},{"from":"iii","to":"ii"},{"from":"ipk","to":"ik"},{"from":"ido","to":"io"},{"from":"isl","to":"is"},{"from":"ita","to":"it"},{"from":"iku","to":"iu"},{"from":"jpn","to":"ja"},{"from":"jav","to":"jv"},{"from":"kat","to":"ka"},{"from":"kon","to":"kg"},{"from":"kik","to":"ki"},{"from":"kua","to":"kj"},{"from":"kaz","to":"kk"},{"from":"kal","to":"kl"},{"from":"khm","to":"km"},{"from":"kan","to":"kn"},{"from":"kor","to":"ko"},{"from":"kau","to":"kr"},{"from":"kas","to":"ks"},{"from":"kur","to":"ku"},{"from":"kom","to":"kv"},{"from":"cor","to":"kw"},{"from":"kir","to":"ky"},{"from":"lat","to":"la"},{"from":"ltz","to":"lb"},{"from":"lug","to":"lg"},{"from":"lim","to":"li"},{"from":"lin","to":"ln"},{"from":"lao","to":"lo"},{"from":"lit","to":"lt"},{"from":"lub","to":"lu"},{"from":"lav","to":"lv"},{"from":"mlg","to":"mg"},{"from":"mah","to":"mh"},{"from":"mri","to":"mi"},{"from":"mkd","to":"mk"},{"from":"mal","to":"ml"},{"from":"mon","to":"mn"},{"from":"mol","to":"ro"},{"from":"mar","to":"mr"},{"from":"msa","to":"ms"},{"from":"mlt","to":"mt"},{"from":"mya","to":"my"},{"from":"nau","to":"na"},{"from":"nob","to":"nb"},{"from":"nde","to":"nd"},{"from":"nep","to":"ne"},{"from":"ndo","to":"ng"},{"from":"nld","to":"nl"},{"from":"nno","to":"nn"},{"from":"nor","to":"nb"},{"from":"nbl","to":"nr"},{"from":"nav","to":"nv"},{"from":"nya","to":"ny"},{"from":"oci","to":"oc"},{"from":"oji","to":"oj"},{"from":"orm","to":"om"},{"from":"ori","to":"or"},{"from":"oss","to":"os"},{"from":"pan","to":"pa"},{"from":"pli","to":"pi"},{"from":"pol","to":"pl"},{"from":"pus","to":"ps"},{"from":"por","to":"pt"},{"from":"que","to":"qu"},{"from":"roh","to":"rm"},{"from":"run","to":"rn"},{"from":"ron","to":"ro"},{"from":"rus","to":"ru"},{"from":"kin","to":"rw"},{"from":"san","to":"sa"},{"from":"srd","to":"sc"},{"from":"snd","to":"sd"},{"from":"sme","to":"se"},{"from":"sag","to":"sg"},{"from":"hbs","to":"sr-latn"},{"from":"sin","to":"si"},{"from":"slk","to":"sk"},{"from":"slv","to":"sl"},{"from":"smo","to":"sm"},{"from":"sna","to":"sn"},{"from":"som","to":"so"},{"from":"sqi","to":"sq"},{"from":"srp","to":"sr"},{"from":"ssw","to":"ss"},{"from":"sot","to":"st"},{"from":"sun","to":"su"},{"from":"swe","to":"sv"},{"from":"swa","to":"sw"},{"from":"tam","to":"ta"},{"from":"tel","to":"te"},{"from":"tgk","to":"tg"},{"from":"tha","to":"th"},{"from":"tir","to":"ti"},{"from":"tuk","to":"tk"},{"from":"tgl","to":"fil"},{"from":"tsn","to":"tn"},{"from":"ton","to":"to"},{"from":"tur","to":"tr"},{"from":"tso","to":"ts"},{"from":"tat","to":"tt"},{"from":"twi","to":"ak"},{"from":"tah","to":"ty"},{"from":"uig","to":"ug"},{"from":"ukr","to":"uk"},{"from":"urd","to":"ur"},{"from":"uzb","to":"uz"},{"from":"ven","to":"ve"},{"from":"vie","to":"vi"},{"from":"vol","to":"vo"},{"from":"wln","to":"wa"},{"from":"wol","to":"wo"},{"from":"xho","to":"xh"},{"from":"yid","to":"yi"},{"from":"yor","to":"yo"},{"from":"zha","to":"za"},{"from":"zho","to":"zh"},{"from":"zul","to":"zu"},{"from":"alb","to":"sq"},{"from":"arm","to":"hy"},{"from":"baq","to":"eu"},{"from":"bur","to":"my"},{"from":"chi","to":"zh"},{"from":"cze","to":"cs"},{"from":"dut","to":"nl"},{"from":"fre","to":"fr"},{"from":"geo","to":"ka"},{"from":"ger","to":"de"},{"from":"gre","to":"el"},{"from":"ice","to":"is"},{"from":"mac","to":"mk"},{"from":"mao","to":"mi"},{"from":"may","to":"ms"},{"from":"per","to":"fa"},{"from":"rum","to":"ro"},{"from":"slo","to":"sk"},{"from":"tib","to":"bo"},{"from":"wel","to":"cy"}]');
        }, 8589: function(Pe) {
          Pe.exports = JSON.parse('{"en-gb-oed":"en-GB-oxendict","i-ami":"ami","i-bnn":"bnn","i-default":null,"i-enochian":null,"i-hak":"hak","i-klingon":"tlh","i-lux":"lb","i-mingo":null,"i-navajo":"nv","i-pwn":"pwn","i-tao":"tao","i-tay":"tay","i-tsu":"tsu","sgn-be-fr":"sfb","sgn-be-nl":"vgt","sgn-ch-de":"sgg","art-lojban":"jbo","cel-gaulish":null,"no-bok":"nb","no-nyn":"nn","zh-guoyu":"cmn","zh-hakka":"hak","zh-min":null,"zh-min-nan":"nan","zh-xiang":"hsn"}');
        }, 858: function(Pe) {
          Pe.exports = JSON.parse('["art-lojban","cel-gaulish","no-bok","no-nyn","zh-guoyu","zh-hakka","zh-min","zh-min-nan","zh-xiang"]');
        } }, rt = {};
        function lt(Pe) {
          var Ee = rt[Pe];
          if (Ee !== void 0) return Ee.exports;
          var C = rt[Pe] = { exports: {} };
          return Ce[Pe].call(C.exports, C, C.exports, lt), C.exports;
        }
        lt.amdO = {}, lt.n = function(Pe) {
          var Ee = Pe && Pe.__esModule ? function() {
            return Pe.default;
          } : function() {
            return Pe;
          };
          return lt.d(Ee, { a: Ee }), Ee;
        }, lt.d = function(Pe, Ee) {
          for (var C in Ee) lt.o(Ee, C) && !lt.o(Pe, C) && Object.defineProperty(Pe, C, { enumerable: !0, get: Ee[C] });
        }, lt.g = function() {
          if (typeof globalThis == "object") return globalThis;
          try {
            return this || new Function("return this")();
          } catch {
            if (typeof window == "object") return window;
          }
        }(), lt.o = function(Pe, Ee) {
          return Object.prototype.hasOwnProperty.call(Pe, Ee);
        };
        var Mt = {};
        return function() {
          lt.d(Mt, { default: function() {
            return m;
          } }), lt(8416);
          var Pe, Ee = lt(1715), C = lt(8080), ie = lt(1737), T = lt(1139), t = /* @__PURE__ */ function() {
            var o, E = "application/dash+xml";
            function h(c, d, S) {
              if (!c || !/^VIDEO$/i.test(c.nodeName)) return null;
              if (c._dashjs_player) return c._dashjs_player;
              var x, B = c.id || c.name || "video element";
              if (!(d = d || [].slice.call(c.querySelectorAll("source")).filter(function(L) {
                return L.type == E;
              })[0]) && c.src) (d = document.createElement("source")).src = c.src;
              else if (!d && !c.src) return null;
              return S = S || {}, (x = (0, T.Z)(S).create()).initialize(c, d.src, c.autoplay), o || (o = x.getDebug().getLogger()), o.debug("Converted " + B + " to dash.js player and added content: " + d.src), c._dashjs_player = x, x;
            }
            function n(c) {
              return /^VIDEO$/i.test(c.nodeName) ? c : n(c.parentNode);
            }
            return { create: h, createAll: function(c, d) {
              var S = [];
              c = c || "[data-dashjs-player]";
              for (var x = (d = d || document).querySelectorAll(c), B = 0; B < x.length; B++) {
                var L = h(x[B], null);
                S.push(L);
              }
              for (var $ = d.querySelectorAll('source[type="' + E + '"]'), M = 0; M < $.length; M++) {
                var K = h(n($[M]), null);
                S.push(K);
              }
              return S;
            } };
          }();
          !(typeof window < "u" && window && window.dashjs && window.dashjs.skipAutoCreate) && typeof window < "u" && window && window.addEventListener && (window.document.readyState === "complete" ? window.dashjs ? t.createAll() : Pe = window.setInterval(function() {
            window.dashjs && (window.clearInterval(Pe), t.createAll());
          }, 500) : window.addEventListener("load", function o() {
            window.removeEventListener("load", o), t.createAll();
          }));
          var e = t, p = lt(6398);
          dashjs.Protection = ie.default, dashjs.MetricsReporting = C.default, dashjs.MediaPlayerFactory = e, dashjs.Debug = p.Z, dashjs.supportsMediaSource = Ee.B;
          var m = dashjs;
        }(), Mt.default;
      }();
    });
  }(Ya)), Ya.exports;
}
var fc = cc();
const dc = (re, he, Ce) => {
  const rt = re[he];
  return rt ? typeof rt == "function" ? rt() : Promise.resolve(rt) : new Promise((lt, Mt) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(
      Mt.bind(
        null,
        new Error(
          "Unknown variable dynamic import: " + he + (he.split("/").length !== Ce ? ". Note that variables only represent file names one level deep." : "")
        )
      )
    );
  });
};
sc.use(oc).use(
  uc(
    (re) => dc(/* @__PURE__ */ Object.assign({ "./locales/ar.json": () => import("./ar-DWuLBmz_.js"), "./locales/ca.json": () => import("./ca-Qqae8qG8.js"), "./locales/cy.json": () => import("./cy-BpEFkqco.js"), "./locales/da-x-k12.json": () => import("./da-x-k12-COGvNdvr.js"), "./locales/da.json": () => import("./da-wed3aJ7h.js"), "./locales/de.json": () => import("./de-nKvELG0o.js"), "./locales/en-AU-x-unimelb.json": () => import("./en-AU-x-unimelb-CkNBO1qD.js"), "./locales/en-GB-x-ukhe.json": () => import("./en-GB-x-ukhe-B4JozeRC.js"), "./locales/en.json": () => import("./en-Da2QqQzB.js"), "./locales/en_AU.json": () => import("./en_AU-MbaPa8_v.js"), "./locales/en_CY.json": () => import("./en_CY-Bic0boap.js"), "./locales/en_GB.json": () => import("./en_GB-Bic0boap.js"), "./locales/es.json": () => import("./es-BcgDzQZG.js"), "./locales/es_ES.json": () => import("./es_ES-Dpu1hibc.js"), "./locales/fi.json": () => import("./fi-BEWl8re7.js"), "./locales/fr.json": () => import("./fr-DiQce0QU.js"), "./locales/fr_CA.json": () => import("./fr_CA-zzDHXzBI.js"), "./locales/ga.json": () => import("./ga-BnfTovup.js"), "./locales/hi.json": () => import("./hi-DFgKd5Rh.js"), "./locales/ht.json": () => import("./ht-DmkZypkC.js"), "./locales/id.json": () => import("./id-D12ot73_.js"), "./locales/is.json": () => import("./is-CTl9VBTw.js"), "./locales/it.json": () => import("./it-DS73ictn.js"), "./locales/ja.json": () => import("./ja-B0B-sKEG.js"), "./locales/kl.json": () => import("./kl-CBFEKDWH.js"), "./locales/mi.json": () => import("./mi-BX_XpUQT.js"), "./locales/ms.json": () => import("./ms-C_fuUCcA.js"), "./locales/nb-x-k12.json": () => import("./nb-x-k12-LqbRKYNM.js"), "./locales/nb.json": () => import("./nb-CrJr2akb.js"), "./locales/nl.json": () => import("./nl-CrynP9Ac.js"), "./locales/pl.json": () => import("./pl-CBE8GSTo.js"), "./locales/pt.json": () => import("./pt-GnFuQolP.js"), "./locales/pt_BR.json": () => import("./pt_BR-Bw-U8Fma.js"), "./locales/ru.json": () => import("./ru-Din5Ed0v.js"), "./locales/sl.json": () => import("./sl-DOsudmDY.js"), "./locales/sv-x-k12.json": () => import("./sv-x-k12-C3MKrKJe.js"), "./locales/sv.json": () => import("./sv-CxnJbrMd.js"), "./locales/th.json": () => import("./th-DY_qsUyE.js"), "./locales/vi.json": () => import("./vi-CZWY3NLh.js"), "./locales/zh-Hans.json": () => import("./zh-Hans-C6EE8GVu.js"), "./locales/zh-Hant.json": () => import("./zh-Hant-DuAgeN0L.js"), "./locales/zh.json": () => import("./zh-Cb-utrSO.js"), "./locales/zh_HK.json": () => import("./zh_HK-BaabEC8v.js") }), `./locales/${re}.json`, 3)
  )
).init({
  fallbackLng: "en",
  partialBundledLanguages: !0,
  ns: [],
  resources: {},
  interpolation: {
    escapeValue: !1
  }
});
const Zs = Wa(null);
function gc({
  children: re,
  contextValue: he
}) {
  return /* @__PURE__ */ ve(Zs.Provider, { value: he, children: re });
}
function Wn() {
  const re = Qa(Zs);
  if (!re)
    throw new Error(
      "useStudioPlayerContext must be used within a StudioPlayerContextProvider"
    );
  return re;
}
const Us = Wa(null);
function hc({
  title: re,
  hideFullScreen: he,
  comments: Ce,
  captions: rt,
  thumbnail: lt,
  annotations: Mt,
  quizMarkers: Pe,
  interactive: Ee,
  onAnnotationClick: C,
  onQuizMarkerClick: ie,
  onInteractivePinClick: T,
  interactiveMenuElements: t,
  kebabMenuElements: e,
  darkMode: p,
  children: m,
  forceComments: o,
  disableCaptionSettings: E,
  disableStorage: h,
  captionOffsetOverride: n,
  disableInteractivePinRanges: c,
  onQuizMarkerShow: d,
  onCaptionsDelete: S,
  controlsLayout: x,
  startAt: B,
  hideQuizMarkers: L
}) {
  const $ = {
    title: re,
    hideFullScreen: he,
    comments: Ce,
    captions: rt,
    thumbnail: lt,
    annotations: Mt,
    quizMarkers: Pe,
    interactive: Ee,
    onAnnotationClick: C,
    onQuizMarkerClick: ie,
    onInteractivePinClick: T,
    interactiveMenuElements: t,
    kebabMenuElements: e,
    darkMode: p,
    hasComments: Ce.length > 0,
    hasAnnotations: Mt.length > 0,
    hasQuizmarkers: Pe.length > 0,
    forceComments: o,
    disableCaptionSettings: E,
    disableStorage: h,
    captionOffsetOverride: n,
    disableInteractivePinRanges: c,
    onQuizMarkerShow: d,
    onCaptionsDelete: S,
    controlsLayout: x,
    startAt: B,
    hideQuizMarkers: L
  };
  return /* @__PURE__ */ ve(Us.Provider, { value: $, children: m });
}
function lr() {
  const re = Qa(Us);
  if (!re)
    throw new Error(
      "useStudioPlayerPropsContext must be used within a StudioPlayerPropsContextProvider"
    );
  return re;
}
const mc = "_annotation-overlay_1kxzn_1", pc = {
  "annotation-overlay": "_annotation-overlay_1kxzn_1",
  annotationOverlay: mc
}, Ns = 0.25, yc = (re, he) => {
  let Ce = !1;
  return (rt) => {
    const lt = rt.detail.currentTime;
    lt >= re.time && lt < re.time + Ns && !Ce && (Ce = !0, he(re)), (lt < re.time || lt >= re.time + Ns) && Ce && (Ce = !1);
  };
};
function _c({ annotations: re }) {
  const he = Dr(), Ce = Wn(), rt = lr(), [lt, Mt] = _r(
    null
  ), Pe = Zn(
    (C) => {
      he == null || he.pause(), rt.interactive || Ce.disableInteractions(), Mt(C);
    },
    [he, Ce]
  ), Ee = () => {
    rt.interactive || (he == null || he.play(), Ce.enableInteractions()), Mt(null), he == null || he.dispatchEvent(new CustomEvent("annotationHidden"));
  };
  return Pr(() => {
    if (!he)
      return;
    const C = new AbortController();
    return requestAnimationFrame(() => {
      for (const ie of re) {
        const T = yc(ie, Pe);
        he.addEventListener("time-update", T, {
          signal: C.signal
        });
      }
      if (lt) {
        const ie = re.find(
          (T) => T.id === lt.id
        );
        ie ? Mt(ie) : (Mt(null), Ce.enableInteractions());
      }
    }), () => C.abort();
  }, [he, re]), lt ? /* @__PURE__ */ ve("div", { className: pc.annotationOverlay, children: lt.render(Ee) }) : null;
}
const Ec = "_media-buffering-indicator_1fwjr_1", vc = "_media-buffering-spinner_1fwjr_17", Tc = "_media-buffering-spin_1fwjr_17", bc = "_media-buffering-track_1fwjr_22", Sc = "_media-buffering-track-fill_1fwjr_27", na = {
  "media-buffering-indicator": "_media-buffering-indicator_1fwjr_1",
  mediaBufferingIndicator: Ec,
  "media-buffering-spinner": "_media-buffering-spinner_1fwjr_17",
  mediaBufferingSpinner: vc,
  "media-buffering-spin": "_media-buffering-spin_1fwjr_17",
  mediaBufferingSpin: Tc,
  "media-buffering-track": "_media-buffering-track_1fwjr_22",
  mediaBufferingTrack: bc,
  "media-buffering-track-fill": "_media-buffering-track-fill_1fwjr_27",
  mediaBufferingTrackFill: Sc
};
function Bs() {
  return /* @__PURE__ */ ve("div", { className: na.mediaBufferingIndicator, children: /* @__PURE__ */ ln(Va.Root, { className: na.mediaBufferingSpinner, size: 96, children: [
    /* @__PURE__ */ ve(Va.Track, { className: na.mediaBufferingTrack, width: 8 }),
    /* @__PURE__ */ ve(
      Va.TrackFill,
      {
        className: na.mediaBufferingTrackFill,
        width: 8
      }
    )
  ] }) });
}
const Ac = [
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight",
  "Escape"
];
function ao(re, he = !1, Ce = !0) {
  Pr(() => {
    if (!Ce)
      return;
    const rt = new AbortController();
    return document.addEventListener(
      "keydown",
      (lt) => {
        var Mt;
        return (Mt = re[lt.key]) == null ? void 0 : Mt.call(re, lt);
      },
      {
        passive: !0,
        signal: rt.signal
      }
    ), he && window.addEventListener(
      "keydown",
      (lt) => {
        Ac.includes(lt.code) && lt.preventDefault();
      },
      { signal: rt.signal }
    ), () => {
      rt.abort();
    };
  }, [re, he, Ce]);
}
function Ic(re) {
  const he = Mr(() => ({ Escape: re }), [re]);
  return ao(he);
}
const Gs = (re) => /* @__PURE__ */ ve("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...re, children: /* @__PURE__ */ ve("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.94968 7.74766L3.99993 2.79791L2.79785 3.99999L7.7476 8.94974L2.79785 13.8995L3.99993 15.1016L8.94968 10.1518L13.8994 15.1016L15.1015 13.8995L10.1518 8.94974L15.1015 3.99999L13.8994 2.79791L8.94968 7.74766Z", fill: "currentColor" }) }), Rc = "_controls-overlay_5ej4z_1", wc = "_keyboard-shortcuts-overlay_5ej4z_11", Cc = "_screen-reader-content_5ej4z_76", Nc = "_controls-button_5ej4z_90", Dc = "_keyboard-shortcuts-button_5ej4z_106", Oc = "_kebab-menu-button_5ej4z_116", Mc = "_kebab-menu_5ej4z_116", Pc = "_kebab-menu-item_5ej4z_145", Lc = "_close-button_5ej4z_180", xc = "_arrow_5ej4z_194", Fr = {
  "controls-overlay": "_controls-overlay_5ej4z_1",
  controlsOverlay: Rc,
  "keyboard-shortcuts-overlay": "_keyboard-shortcuts-overlay_5ej4z_11",
  keyboardShortcutsOverlay: wc,
  "screen-reader-content": "_screen-reader-content_5ej4z_76",
  screenReaderContent: Cc,
  "controls-button": "_controls-button_5ej4z_90",
  controlsButton: Nc,
  "keyboard-shortcuts-button": "_keyboard-shortcuts-button_5ej4z_106",
  keyboardShortcutsButton: Dc,
  "kebab-menu-button": "_kebab-menu-button_5ej4z_116",
  kebabMenuButton: Oc,
  "kebab-menu": "_kebab-menu_5ej4z_116",
  kebabMenu: Mc,
  "kebab-menu-item": "_kebab-menu-item_5ej4z_145",
  kebabMenuItem: Pc,
  "close-button": "_close-button_5ej4z_180",
  closeButton: Lc,
  arrow: xc
};
function Fc({ onClose: re }) {
  const { t: he } = Hn();
  return Ic(re), /* @__PURE__ */ ln(
    "div",
    {
      className: Fr.keyboardShortcutsOverlay,
      tabIndex: 0,
      role: "dialog",
      "aria-label": he("KEYBOARD_SHORTCUTS"),
      children: [
        /* @__PURE__ */ ln("header", { children: [
          /* @__PURE__ */ ve("h2", { children: he("KEYBOARD_SHORTCUTS") }),
          /* @__PURE__ */ ve(
            "button",
            {
              type: "button",
              className: Fr.closeButton,
              onClick: re,
              "aria-label": he("CLOSE"),
              autoFocus: !0,
              children: /* @__PURE__ */ ve(Gs, {})
            }
          )
        ] }),
        /* @__PURE__ */ ln("table", { children: [
          /* @__PURE__ */ ve("caption", { className: Fr.screenReaderContent, children: he("KEYBOARD_SHORTCUTS") }),
          /* @__PURE__ */ ve("thead", { children: /* @__PURE__ */ ln("tr", { children: [
            /* @__PURE__ */ ve("th", { children: he("ACTION") }),
            /* @__PURE__ */ ve("th", { children: he("SHORTCUT") })
          ] }) }),
          /* @__PURE__ */ ln("tbody", { children: [
            /* @__PURE__ */ ln("tr", { children: [
              /* @__PURE__ */ ve("td", { children: he("SEEK_BACKWARD", { seconds: 5 }) }),
              /* @__PURE__ */ ve("td", { children: he("LEFT_ARROW") })
            ] }),
            /* @__PURE__ */ ln("tr", { children: [
              /* @__PURE__ */ ve("td", { children: he("SEEK_FORWARD", { seconds: 5 }) }),
              /* @__PURE__ */ ve("td", { children: he("RIGHT_ARROW") })
            ] }),
            /* @__PURE__ */ ln("tr", { children: [
              /* @__PURE__ */ ve("td", { children: he("SEEK_BACKWARD", { seconds: 10 }) }),
              /* @__PURE__ */ ve("td", { children: "J" })
            ] }),
            /* @__PURE__ */ ln("tr", { children: [
              /* @__PURE__ */ ve("td", { children: he("SEEK_FORWARD", { seconds: 10 }) }),
              /* @__PURE__ */ ve("td", { children: "L" })
            ] }),
            /* @__PURE__ */ ln("tr", { children: [
              /* @__PURE__ */ ve("td", { children: he("INCREASE_VOLUME", { percent: 5 }) }),
              /* @__PURE__ */ ve("td", { children: he("UP_ARROW") })
            ] }),
            /* @__PURE__ */ ln("tr", { children: [
              /* @__PURE__ */ ve("td", { children: he("DECREASE_VOLUME", { percent: 5 }) }),
              /* @__PURE__ */ ve("td", { children: he("DOWN_ARROW") })
            ] }),
            /* @__PURE__ */ ln("tr", { children: [
              /* @__PURE__ */ ve("td", { children: he("TOGGLE_MUTED") }),
              /* @__PURE__ */ ve("td", { children: "M" })
            ] }),
            /* @__PURE__ */ ln("tr", { children: [
              /* @__PURE__ */ ve("td", { children: he("TOGGLE_PLAY_PAUSE") }),
              /* @__PURE__ */ ln("td", { children: [
                he("SPACE"),
                ", K"
              ] })
            ] }),
            /* @__PURE__ */ ln("tr", { children: [
              /* @__PURE__ */ ve("td", { children: he("ENTER_FULLSCREEN") }),
              /* @__PURE__ */ ve("td", { children: "F" })
            ] }),
            /* @__PURE__ */ ln("tr", { children: [
              /* @__PURE__ */ ve("td", { children: he("EXIT_FULLSCREEN") }),
              /* @__PURE__ */ ve("td", { children: "Esc, F" })
            ] }),
            /* @__PURE__ */ ln("tr", { children: [
              /* @__PURE__ */ ve("td", { children: he("TOGGLE_CAPTIONS") }),
              /* @__PURE__ */ ve("td", { children: "C" })
            ] }),
            /* @__PURE__ */ ln("tr", { children: [
              /* @__PURE__ */ ve("td", { children: he("NEXT_CAPTION_LANGUAGE") }),
              /* @__PURE__ */ ve("td", { children: "V" })
            ] }),
            /* @__PURE__ */ ln("tr", { children: [
              /* @__PURE__ */ ve("td", { children: he("PREVIOUS_CAPTION_LANGUAGE") }),
              /* @__PURE__ */ ve("td", { children: "X" })
            ] }),
            /* @__PURE__ */ ln("tr", { children: [
              /* @__PURE__ */ ve("td", { children: he("DECREASE_PLAYBACK_SPEED") }),
              /* @__PURE__ */ ve("td", { children: "A" })
            ] }),
            /* @__PURE__ */ ln("tr", { children: [
              /* @__PURE__ */ ve("td", { children: he("RESET_PLAYBACK_SPEED") }),
              /* @__PURE__ */ ve("td", { children: "S" })
            ] }),
            /* @__PURE__ */ ln("tr", { children: [
              /* @__PURE__ */ ve("td", { children: he("INCREASE_PLAYBACK_SPEED") }),
              /* @__PURE__ */ ve("td", { children: "D" })
            ] }),
            /* @__PURE__ */ ln("tr", { children: [
              /* @__PURE__ */ ve("td", { children: he("JUMP_TO_START") }),
              /* @__PURE__ */ ve("td", { children: "0" })
            ] }),
            /* @__PURE__ */ ln("tr", { children: [
              /* @__PURE__ */ ve("td", { children: he("JUMP_TO_PERCENTAGE") }),
              /* @__PURE__ */ ve("td", { children: "1-9" })
            ] })
          ] })
        ] })
      ]
    }
  );
}
function qs(re) {
  var he, Ce, rt = "";
  if (typeof re == "string" || typeof re == "number") rt += re;
  else if (typeof re == "object") if (Array.isArray(re)) {
    var lt = re.length;
    for (he = 0; he < lt; he++) re[he] && (Ce = qs(re[he])) && (rt && (rt += " "), rt += Ce);
  } else for (Ce in re) re[Ce] && (rt && (rt += " "), rt += Ce);
  return rt;
}
function Ii() {
  for (var re, he, Ce = 0, rt = "", lt = arguments.length; Ce < lt; Ce++) (re = arguments[Ce]) && (he = qs(re)) && (rt && (rt += " "), rt += he);
  return rt;
}
const kc = (re) => /* @__PURE__ */ ve("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...re, children: /* @__PURE__ */ ve("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.8 3.6C9.79288 3.6 10.6 2.79288 10.6 1.8C10.6 0.80712 9.79288 0 8.8 0C7.80712 0 7 0.80712 7 1.8C7 2.79288 7.80712 3.6 8.8 3.6ZM10.6 8.99999C10.6 9.99287 9.79288 10.8 8.8 10.8C7.80712 10.8 7 9.99287 7 8.99999C7 8.00711 7.80712 7.19999 8.8 7.19999C9.79288 7.19999 10.6 8.00711 10.6 8.99999ZM10.6 16.2C10.6 17.1929 9.79288 18 8.8 18C7.80712 18 7 17.1929 7 16.2C7 15.2071 7.80712 14.4 8.8 14.4C9.79288 14.4 10.6 15.2071 10.6 16.2Z", fill: "currentColor" }) }), Zc = (re) => /* @__PURE__ */ ve("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...re, children: /* @__PURE__ */ ve("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.1074 16.8677C12.8638 16.8677 11.8524 15.8563 11.8524 14.6127C11.8524 14.4154 11.8862 14.2271 11.9336 14.0444C12.0317 13.6701 12.22 13.3318 12.4804 13.059C12.8908 12.6294 13.467 12.3576 14.1074 12.3576C15.3511 12.3576 16.3625 13.369 16.3625 14.6127C16.3625 15.8563 15.3511 16.8677 14.1074 16.8677ZM4.38257 11.2301C3.13891 11.2301 2.12752 10.2187 2.12752 8.97507C2.12752 7.73141 3.13891 6.72002 4.38257 6.72002C5.01623 6.72002 5.58676 6.98386 5.99718 7.40556C6.25989 7.67616 6.44819 8.01329 6.54966 8.38763C6.60153 8.57592 6.63761 8.76986 6.63761 8.97507C6.63761 9.2017 6.59364 9.41818 6.53049 9.62452C6.41887 9.99435 6.22155 10.327 5.94982 10.5908C5.54391 10.9843 4.99256 11.2301 4.38257 11.2301ZM11.8524 3.38257C11.8524 2.13891 12.8638 1.12753 14.1074 1.12753C15.3511 1.12753 16.3625 2.13891 16.3625 3.38257C16.3625 4.62622 15.3511 5.63761 14.1074 5.63761C13.4749 5.63761 12.9055 5.3749 12.4962 4.95546C12.2324 4.68485 12.0429 4.34773 11.9415 3.97339C11.8896 3.78397 11.8524 3.5889 11.8524 3.38257ZM14.1074 11.2301C13.0498 11.2301 12.1151 11.7273 11.495 12.4907L7.52722 10.1996C7.67605 9.81846 7.76513 9.40804 7.76513 8.97507C7.76513 8.56465 7.68056 8.17678 7.54639 7.8126L11.5108 5.5226C12.132 6.27466 13.0588 6.76513 14.1074 6.76513C15.9724 6.76513 17.49 5.24748 17.49 3.38256C17.49 1.51764 15.9724 0 14.1074 0C12.2425 0 10.7249 1.51764 10.7249 3.38256C10.7249 3.79411 10.8094 4.18423 10.9447 4.54842L6.9815 6.83729C6.36136 6.08411 5.43341 5.59251 4.38256 5.59251C2.51764 5.59251 1 7.11015 1 8.97507C1 10.84 2.51764 12.3576 4.38256 12.3576C5.40974 12.3576 6.32077 11.8875 6.94091 11.1625L10.9368 13.4694C10.8072 13.829 10.7249 14.2102 10.7249 14.6127C10.7249 16.4776 12.2425 17.9952 14.1074 17.9952C15.9724 17.9952 17.49 16.4776 17.49 14.6127C17.49 12.7478 15.9724 11.2301 14.1074 11.2301Z", fill: "currentColor" }) }), Uc = (re) => /* @__PURE__ */ ve("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...re, children: /* @__PURE__ */ ve("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.7647 16.9412H2.05882V1.05883H10.5294V5.29412H14.7647V16.9412ZM11.5882 1.278L14.5455 4.2353H11.5882V1.278ZM15.3587 3.55129L12.2722 0.464824C11.9715 0.165176 11.5724 0 11.1488 0H1V18H15.8235V4.67471C15.8235 4.25118 15.6584 3.852 15.3587 3.55129ZM1 0H15.8235V18H1V0ZM1 18H15.8235V0H1V18ZM4.17649 5.29412H8.41178V4.23529H4.17649V5.29412ZM4.17649 9.52941H10.5294V8.47059H4.17649V9.52941ZM4.17649 13.7647H8.41178V12.7059H4.17649V13.7647ZM4.17649 7.41177H12.6471V6.35294H4.17649V7.41177ZM4.17649 11.6471H11.5883V10.5882H4.17649V11.6471Z", fill: "currentColor" }) }), Bc = (re) => /* @__PURE__ */ ve("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...re, children: /* @__PURE__ */ ve("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.30365 10.9535V0H9.3637V10.9535L12.6986 7.61855L13.4491 8.368L8.83261 12.9824L4.21823 8.368L4.96875 7.61855L8.30365 10.9535ZM3.77376 16.94H13.9354L16.9607 13.9146L17.7091 14.6651L14.3742 18H3.3349L0 14.6651L0.749452 13.9146L3.77376 16.94Z", fill: "currentColor" }) }), Hs = (re) => /* @__PURE__ */ ve("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...re, children: /* @__PURE__ */ ve("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.8234 16.4118C14.8234 16.7029 14.5852 16.9412 14.294 16.9412H3.70577C3.41459 16.9412 3.17636 16.7029 3.17636 16.4118V5.29412H2.11753V16.4118C2.11753 17.2874 2.83012 18 3.70577 18H14.294C15.1697 18 15.8822 17.2874 15.8822 16.4118V5.29412H14.8234V16.4118ZM6.35284 14.8235H7.41166V6.35294H6.35284V14.8235ZM10.5881 14.8235H11.6469V6.35294H10.5881V14.8235ZM12.5682 3.17647L11.4099 0H6.51176L5.35553 3.17647H0V4.23529H18V3.17647H12.5682ZM6.48105 3.17647L7.25293 1.05882H10.6698L11.4416 3.17647H6.48105Z", fill: "currentColor" }) }), Gc = (re) => /* @__PURE__ */ ve("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...re, children: /* @__PURE__ */ ve("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.9412 15.2941C16.9412 15.5853 16.704 15.8235 16.4118 15.8235H1.58823C1.296 15.8235 1.05882 15.5853 1.05882 15.2941V6.82353C1.05882 6.53235 1.296 6.29412 1.58823 6.29412H16.4118C16.704 6.29412 16.9412 6.53235 16.9412 6.82353V15.2941ZM16.4118 5.23529H9.57494C9.71471 4.42 10.1933 4.17118 10.8254 3.85565C11.6629 3.43741 12.7059 2.91541 12.7059 1H11.6471C11.6471 2.26106 11.1039 2.53212 10.3511 2.90906C9.59824 3.28494 8.68659 3.75506 8.50871 5.23529H1.58824C0.712588 5.23529 0 5.94788 0 6.82353V15.2941C0 16.1698 0.712588 16.8824 1.58824 16.8824H16.4118C17.2874 16.8824 18 16.1698 18 15.2941V6.82353C18 5.94788 17.2874 5.23529 16.4118 5.23529ZM11.1177 11.5882H6.88236C6.59013 11.5882 6.35295 11.8254 6.35295 12.1176V13.1765C6.35295 13.4687 6.59013 13.7059 6.88236 13.7059H11.1177C11.4099 13.7059 11.6471 13.4687 11.6471 13.1765V12.1176C11.6471 11.8254 11.4099 11.5882 11.1177 11.5882ZM14.2941 11.5882H13.2353C12.943 11.5882 12.7059 11.8254 12.7059 12.1176V13.1765C12.7059 13.4687 12.943 13.7059 13.2353 13.7059H14.2941C14.5863 13.7059 14.8235 13.4687 14.8235 13.1765V12.1176C14.8235 11.8254 14.5863 11.5882 14.2941 11.5882ZM4.76472 11.5882H3.7059C3.41366 11.5882 3.17649 11.8254 3.17649 12.1176V13.1765C3.17649 13.4687 3.41366 13.7059 3.7059 13.7059H4.76472C5.05696 13.7059 5.29413 13.4687 5.29413 13.1765V12.1176C5.29413 11.8254 5.05696 11.5882 4.76472 11.5882ZM4.76472 8.41176H3.7059C3.41366 8.41176 3.17649 8.64894 3.17649 8.94118V10C3.17649 10.2922 3.41366 10.5294 3.7059 10.5294H4.76472C5.05696 10.5294 5.29413 10.2922 5.29413 10V8.94118C5.29413 8.64894 5.05696 8.41176 4.76472 8.41176ZM6.88236 10.5294H7.94118C8.23342 10.5294 8.4706 10.2922 8.4706 10V8.94118C8.4706 8.64894 8.23342 8.41176 7.94118 8.41176H6.88236C6.59013 8.41176 6.35295 8.64894 6.35295 8.94118V10C6.35295 10.2922 6.59013 10.5294 6.88236 10.5294ZM11.1176 8.41176H10.0588C9.76658 8.41176 9.52941 8.64894 9.52941 8.94118V10C9.52941 10.2922 9.76658 10.5294 10.0588 10.5294H11.1176C11.4099 10.5294 11.6471 10.2922 11.6471 10V8.94118C11.6471 8.64894 11.4099 8.41176 11.1176 8.41176ZM14.2941 8.41176H13.2353C12.943 8.41176 12.7059 8.64894 12.7059 8.94118V10C12.7059 10.2922 12.943 10.5294 13.2353 10.5294H14.2941C14.5863 10.5294 14.8235 10.2922 14.8235 10V8.94118C14.8235 8.64894 14.5863 8.41176 14.2941 8.41176Z", fill: "currentColor" }) }), qc = {
  share: /* @__PURE__ */ ve(Zc, {}),
  transcript: /* @__PURE__ */ ve(Uc, {}),
  media: /* @__PURE__ */ ve(Bc, {}),
  delete: /* @__PURE__ */ ve(Hs, {}),
  shortcuts: /* @__PURE__ */ ve(Gc, {})
}, Hc = (re) => typeof re != "string";
function Vc({ openShortcuts: re, shouldFocus: he }) {
  const [Ce, rt] = _r(!1), [lt, Mt] = _r(null), Pe = Wn(), Ee = lr(), C = () => {
    rt(!Ce), Pe.setGlobalKeysDisabled(!Ce);
  }, ie = Nr(null), T = Nr([]), { refs: t, floatingStyles: e, context: p } = sa({
    open: Ce,
    onOpenChange: C,
    whileElementsMounted: ua,
    placement: "bottom-end",
    middleware: [
      Xa(),
      $a(10),
      Ja({
        element: ie
      })
    ]
  }), m = (B) => {
    B !== null && he && B.focus();
  }, o = eo([t.setReference, m]), E = ks(p, {
    listRef: T,
    activeIndex: lt,
    onNavigate: Mt,
    loop: !0
  }), h = to(p), { getReferenceProps: n, getFloatingProps: c, getItemProps: d } = no(
    [h, E]
  ), { t: S } = Hn(), x = Mr(
    () => [
      ...Ee.kebabMenuElements,
      {
        id: "keyboard-shortcuts",
        text: S("KEYBOARD_SHORTCUTS"),
        icon: "shortcuts",
        onClick: re
      }
    ],
    [Ee.kebabMenuElements, S, re]
  );
  return /* @__PURE__ */ ln(pi, { children: [
    /* @__PURE__ */ ve(
      "button",
      {
        id: "kebab-menu-button",
        type: "button",
        "aria-label": S("KEBAB_MENU", { title: Ee.title }),
        "aria-haspopup": "true",
        "aria-expanded": Ce,
        className: Ii(Fr.controlsButton, Fr.kebabMenuButton),
        tabIndex: Pe.state.interactionsDisabled || Ce ? -1 : 0,
        ref: o,
        ...n({
          onClick: () => C()
        }),
        children: /* @__PURE__ */ ve(kc, {})
      }
    ),
    Ce && /* @__PURE__ */ ve(ro, { context: p, guards: !1, children: /* @__PURE__ */ ln(
      "div",
      {
        id: "kebab-menu",
        ref: t.setFloating,
        style: e,
        className: Fr.kebabMenu,
        role: "menu",
        "aria-labelledby": "kebab-menu-button",
        ...c(),
        children: [
          x.map(({ id: B, text: L, icon: $, onClick: M }, K) => /* @__PURE__ */ ln(
            "button",
            {
              tabIndex: lt === K ? 0 : -1,
              type: "button",
              role: "menuitem",
              className: Fr.kebabMenuItem,
              ref: (ae) => {
                T.current[K] = ae;
              },
              ...d({
                onClick: () => {
                  M(B), rt(!1);
                }
              }),
              children: [
                Hc($) ? $ : qc[$],
                L
              ]
            },
            B
          )),
          /* @__PURE__ */ ve(
            io,
            {
              ref: ie,
              context: p,
              className: Fr.arrow
            }
          )
        ]
      }
    ) })
  ] });
}
function jc() {
  const re = Wn(), he = oa(), Ce = Nr(!1), rt = Nr(!1), lt = Zn(() => {
    re.setKeyboardShortcutsOpen(!0), re.disableInteractions();
    const Pe = he.getPlayer();
    Pe != null && Pe.state.playing && (Ce.current = !0, he.pause()), rt.current = !0;
  }, [he, re]), Mt = Zn(() => {
    re.setKeyboardShortcutsOpen(!1), re.enableInteractions(), Ce.current && (Ce.current = !1, he.play());
  }, [he, re]);
  return re.state.isKeyboardShortcutsOpen ? /* @__PURE__ */ ve(Fc, { onClose: Mt }) : /* @__PURE__ */ ve("div", { className: Fr.controlsOverlay, children: /* @__PURE__ */ ve(
    Vc,
    {
      openShortcuts: lt,
      shouldFocus: rt.current
    }
  ) });
}
const Vs = (re) => /* @__PURE__ */ ln("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...re, children: [
  /* @__PURE__ */ ve("defs", { children: /* @__PURE__ */ ve("clipPath", { id: "clip0_149_104418", children: /* @__PURE__ */ ve("rect", { width: 24, height: 24, fill: "white" }) }) }),
  /* @__PURE__ */ ve("g", { clipPath: "url(#clip0_149_104418)", children: /* @__PURE__ */ ve("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.5 21.8125V2.3125C22.5 1.9 22.1625 1.5625 21.75 1.5625H2.25C1.8375 1.5625 1.5 1.9 1.5 2.3125V21.8125C1.5 22.225 1.8375 22.5625 2.25 22.5625H21.75C22.1625 22.5625 22.5 22.225 22.5 21.8125ZM21.75 0.0625C22.9905 0.0625 24 1.072 24 2.3125V21.8125C24 23.053 22.9905 24.0625 21.75 24.0625H2.25C1.0095 24.0625 0 23.053 0 21.8125V2.3125C0 1.072 1.0095 0.0625 2.25 0.0625H21.75ZM10.744 10.6709H8.74403V10.0042H6.07736V14.0042H8.74403V13.3375H10.744V14.6709C10.744 15.4042 10.144 16.0042 9.41069 16.0042H5.41069C4.67736 16.0042 4.07736 15.4042 4.07736 14.6709V9.33753C4.07736 8.6042 4.67736 8.0042 5.41069 8.0042H9.41069C10.144 8.0042 10.744 8.6042 10.744 9.33753V10.6709ZM19.8065 10.6709H17.8065V10.0042H15.1399V14.0042H17.8065V13.3375H19.8065V14.6709C19.8065 15.4042 19.2065 16.0042 18.4732 16.0042H14.4732C13.7399 16.0042 13.1399 15.4042 13.1399 14.6709V9.33753C13.1399 8.6042 13.7399 8.0042 14.4732 8.0042H18.4732C19.2065 8.0042 19.8065 8.6042 19.8065 9.33753V10.6709Z", fill: "currentColor" }) })
] }), js = (re) => /* @__PURE__ */ ln("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...re, children: [
  /* @__PURE__ */ ve("defs", { children: /* @__PURE__ */ ve("clipPath", { id: "clip0_149_104406", children: /* @__PURE__ */ ve("rect", { width: 24, height: 24, fill: "white" }) }) }),
  /* @__PURE__ */ ve("g", { clipPath: "url(#clip0_149_104406)", children: /* @__PURE__ */ ve("path", { d: "M21.3333 0H2.66666C1.18666 0 0 1.35 0 3V21C0 22.65 1.18666 24 2.66666 24H21.3333C22.8 24 24 22.65 24 21V3C24 1.35 22.8 0 21.3333 0ZM10.6667 10.6667H8.66666V10H6V14H8.66666V13.3333H10.6667V14.6667C10.6667 15.4 10.0667 16 9.33334 16H5.33334C4.6 16 4 15.4 4 14.6667V9.33334C4 8.6 4.6 8 5.33334 8H9.33334C10.0667 8 10.6667 8.6 10.6667 9.33334V10.6667ZM20.0042 10.6667H18.0042V10H15.3375V14H18.0042V13.3333H20.0042V14.6667C20.0042 15.4 19.4042 16 18.6708 16H14.6708C13.9375 16 13.3375 15.4 13.3375 14.6667V9.33334C13.3375 8.6 13.9375 8 14.6708 8H18.6708C19.4042 8 20.0042 8.6 20.0042 9.33334V10.6667Z", fill: "currentColor" }) })
] });
function Yc() {
  const re = oa(), he = $n("textTrack"), Ce = $n("hasCaptions"), rt = he && zl(he), lt = Wn(), { t: Mt } = Hn(), Pe = Zn(
    (Ee) => {
      re.toggleCaptions(Ee.nativeEvent);
    },
    [re]
  );
  return Ce ? /* @__PURE__ */ ve(
    "button",
    {
      type: "button",
      className: "controls-button",
      onClick: Pe,
      "aria-label": Mt(rt ? "CAPTIONS_DISABLE" : "CAPTIONS_ENABLE"),
      "aria-pressed": rt ? "true" : "false",
      tabIndex: lt.state.interactionsDisabled ? -1 : 0,
      children: rt ? /* @__PURE__ */ ve(js, { className: "controls-button-icon" }) : /* @__PURE__ */ ve(Vs, { className: "controls-button-icon" })
    }
  ) : null;
}
const Kc = "_captions_1qij2_1", zc = {
  captions: Kc
}, Wc = (re, he) => re ? he.top : he.bottom;
function Ys({ captions: re }) {
  const he = re.length > 0, Ce = Wn(), { captionOffsetOverride: rt } = lr(), lt = Ce.state.captionPositionOnTop, Mt = Wc(
    lt,
    rt ?? {}
  );
  return /* @__PURE__ */ ln(pi, { children: [
    re.map((Pe) => /* @__PURE__ */ ve(
      Wl,
      {
        kind: "subtitles",
        type: Pe.type,
        language: Pe.language,
        label: Pe.label,
        src: Pe.src
      },
      Pe.label
    )),
    he ? /* @__PURE__ */ ve(
      "div",
      {
        style: {
          display: "contents",
          ...Mt ? { "--caption-offset": Mt } : {},
          "--captions-font-size-multiplier": Ce.state.captionsFontSizeMultiplier ?? 1,
          "--captions-flex-direction": Ce.state.captionPositionOnTop ? "column" : "column-reverse",
          "--captions-color": Ce.state.captionsInvertColors ? "rgba(22, 22, 22)" : "white",
          "--captions-background-color": Ce.state.captionsInvertColors ? "rgba(255, 255, 255, 0.75)" : "rgba(22, 22, 22, 0.75)"
        },
        children: /* @__PURE__ */ ve(Ql, { className: zc.captions })
      }
    ) : null
  ] });
}
const mi = [0.5, 0.75, 1, 1.25, 1.5, 2], Qc = [0.5, 1, 2, 3, 4], Xc = 5, $c = (re) => {
  const [, he] = _r({});
  return Mr(() => {
    let Ce = [];
    return {
      add(rt) {
        Ce.length >= re && Ce.shift(), Ce.push(rt), he({});
      },
      remove(rt) {
        Ce = Ce.filter((lt) => lt !== rt), he({});
      },
      clear() {
        Ce = [], he({});
      },
      map(rt) {
        return Ce.map(rt);
      }
    };
  }, []);
}, Jc = (re, he, Ce) => {
  let rt = !1;
  return (lt) => {
    const Mt = lt.detail.currentTime;
    Mt >= re.timestamp && Mt < re.timestamp + he && !rt && (Ce.add(re), rt = !0), (Mt < re.timestamp || Mt >= re.timestamp + he) && rt && (Ce.remove(re), rt = !1);
  };
}, ef = (re, he = 5) => {
  const Ce = Dr(), rt = $c(he);
  return Pr(() => {
    if (!Ce)
      return;
    const lt = new AbortController();
    return requestAnimationFrame(() => {
      for (const Mt of re) {
        const Pe = Jc(Mt, Xc, rt);
        Ce.addEventListener("time-update", Pe, {
          signal: lt.signal
        });
      }
      Ce.dispatchEvent(
        new CustomEvent("time-update", {
          detail: { currentTime: Ce.currentTime }
        })
      );
    }), () => {
      lt.abort(), rt.clear();
    };
  }, [Ce, rt, re]), rt;
}, tf = "_comments-overlay_bymws_1", nf = "_comments-container_bymws_10", rf = "_kebab_bymws_20", af = "_comment_bymws_1", of = "_comment-text_bymws_51", sf = "_comment-author-avatar_bymws_71", uf = "_comment-author-name_bymws_95", Vr = {
  "comments-overlay": "_comments-overlay_bymws_1",
  commentsOverlay: tf,
  "comments-container": "_comments-container_bymws_10",
  commentsContainer: nf,
  kebab: rf,
  comment: af,
  "comment-text": "_comment-text_bymws_51",
  commentText: of,
  "comment-author-avatar": "_comment-author-avatar_bymws_71",
  commentAuthorAvatar: sf,
  "comment-author-name": "_comment-author-name_bymws_95",
  commentAuthorName: uf
};
function lf({ comment: re }) {
  return re.render ? re.render(re, Vr) : /* @__PURE__ */ ln("div", { className: Vr.comment, onClick: () => {
    var he;
    return (he = re.onClick) == null ? void 0 : he.call(re, re);
  }, children: [
    /* @__PURE__ */ ve(
      "img",
      {
        className: Vr.commentAuthorAvatar,
        src: re.user.avatar,
        alt: re.user.name
      }
    ),
    /* @__PURE__ */ ve("span", { className: Vr.commentText, children: re.text }),
    /* @__PURE__ */ ve("span", { className: Vr.commentAuthorName, children: re.user.name })
  ] });
}
const cf = 4;
function ff({
  comments: re,
  isKebabMenuVisible: he
}) {
  const Ce = Wn(), rt = ef(re, cf), lt = !!$n("textTrack"), Mt = rt.map((Pe) => /* @__PURE__ */ ve(lf, { comment: Pe }, Pe.id));
  return re.length > 0 && Ce.state.commentsEnabled ? /* @__PURE__ */ ve(
    "div",
    {
      className: Vr.commentsOverlay,
      style: {
        flexDirection: Ce.state.captionPositionOnTop && lt ? "column-reverse" : "column"
      },
      children: /* @__PURE__ */ ve(
        "div",
        {
          className: Ii(Vr.commentsContainer, {
            [Vr.kebab]: he
          }),
          children: lt ? Mt.slice(-3) : Mt
        }
      )
    }
  ) : null;
}
function df({ renderOverlay: re }) {
  const he = Wn();
  return re(he);
}
const gf = (re) => /* @__PURE__ */ ve("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...re, children: /* @__PURE__ */ ve("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.0692 12C21.0692 11.4776 21.0212 10.944 20.9238 10.4104L23.5511 8.13318L21.0579 3.87247L17.7431 4.97788C16.9059 4.28329 15.9515 3.73553 14.9449 3.37271L14.2616 0H9.28941L8.60612 3.37129C7.58823 3.73553 6.65082 4.27482 5.80659 4.97647L2.49318 3.87247L0 8.13318L2.62729 10.4104C2.52988 10.944 2.48188 11.4776 2.48188 12C2.48188 12.5224 2.52988 13.056 2.62729 13.5896L0 15.8668L2.49318 20.1275L5.808 19.0221C6.64518 19.7167 7.59953 20.2645 8.60612 20.6273L9.28941 24H14.2616L14.9449 20.6287C15.9614 20.2645 16.9002 19.7252 17.7445 19.0235L21.0579 20.1289L23.5511 15.8682L20.9238 13.5911C21.0212 13.056 21.0692 12.5224 21.0692 12ZM11.7755 16.9412C9.05082 16.9412 6.83435 14.7247 6.83435 12C6.83435 9.2753 9.05082 7.05883 11.7755 7.05883C14.5002 7.05883 16.7167 9.2753 16.7167 12C16.7167 14.7247 14.5002 16.9412 11.7755 16.9412Z", fill: "currentColor" }) }), hf = (re) => /* @__PURE__ */ ve("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...re, children: /* @__PURE__ */ ve("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.037 3.03704L6.07407 9L12.037 14.963L11 16L4 9L11 2L12.037 3.03704Z", fill: "currentColor" }) }), mf = "_settings-menu_1gbpr_1", pf = "_menu-heading_1gbpr_37", yf = "_check-icon_1gbpr_48", _f = "_trash-icon_1gbpr_49", Ef = "_menu-item-label_1gbpr_62", vf = "_menu-item_1gbpr_62", Tf = "_menu-back-button_1gbpr_99", bf = "_arrow_1gbpr_125", kr = {
  "settings-menu": "_settings-menu_1gbpr_1",
  settingsMenu: mf,
  "menu-heading": "_menu-heading_1gbpr_37",
  menuHeading: pf,
  "check-icon": "_check-icon_1gbpr_48",
  checkIcon: yf,
  "trash-icon": "_trash-icon_1gbpr_49",
  trashIcon: _f,
  "menu-item-label": "_menu-item-label_1gbpr_62",
  menuItemLabel: Ef,
  "menu-item": "_menu-item_1gbpr_62",
  menuItem: vf,
  "menu-back-button": "_menu-back-button_1gbpr_99",
  menuBackButton: Tf,
  arrow: bf
};
function Jr({
  noBackButton: re,
  heading: he,
  children: Ce
}) {
  const rt = jr(), { t: lt } = Hn();
  return /* @__PURE__ */ ln(pi, { children: [
    !re && /* @__PURE__ */ ln(
      "button",
      {
        type: "button",
        role: "menuitem",
        tabIndex: -1,
        className: kr.menuBackButton,
        onClick: rt.back,
        children: [
          /* @__PURE__ */ ve(hf, {}),
          /* @__PURE__ */ ve("span", { children: lt("BACK") })
        ]
      }
    ),
    he && /* @__PURE__ */ ve(
      "strong",
      {
        role: "presentation",
        id: "menu-heading",
        className: kr.menuHeading,
        children: he
      }
    ),
    Ce
  ] });
}
const Sf = (re) => /* @__PURE__ */ ve("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...re, children: /* @__PURE__ */ ve("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 3.03704L7.03704 2L14.037 9L7.03704 16L6 14.963L11.963 9L6 3.03704Z", fill: "currentColor" }) }), Af = "_menu-hint_1wiu5_1", If = "_menu-button_1wiu5_5", Rf = "_menu-label_1wiu5_37", wf = "_menu-icon_1wiu5_42", ra = {
  "menu-hint": "_menu-hint_1wiu5_1",
  menuHint: Af,
  "menu-button": "_menu-button_1wiu5_5",
  menuButton: If,
  "menu-label": "_menu-label_1wiu5_37",
  menuLabel: Rf,
  "menu-icon": "_menu-icon_1wiu5_42",
  menuIcon: wf
};
function yi({ label: re, hint: he, onClick: Ce, Icon: rt }) {
  return /* @__PURE__ */ ln(
    "button",
    {
      type: "button",
      role: "menuitem",
      "aria-haspopup": "true",
      tabIndex: -1,
      onClick: Ce,
      className: ra.menuButton,
      children: [
        rt && /* @__PURE__ */ ve(rt, { className: ra.menuIcon }),
        /* @__PURE__ */ ve("span", { className: ra.menuLabel, children: re }),
        he && /* @__PURE__ */ ve("span", { className: ra.menuHint, children: he }),
        /* @__PURE__ */ ve(Sf, {})
      ]
    }
  );
}
const Cf = (re) => /* @__PURE__ */ ve("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...re, children: /* @__PURE__ */ ve("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.42229 2.82911C4.71149 1.83006 6.23876 1.19768 7.8383 1L7.96797 2.05432C6.55867 2.22862 5.21101 2.7866 4.07273 3.66874L3.42229 2.82911ZM5.44493 6.71393L9.49745 10.7665L17.0924 3.1705L17.8438 3.92297L9.49745 12.2693L4.69352 7.46534L5.44493 6.71393ZM17.932 8.83829C17.8618 8.27074 17.7364 7.70745 17.5589 7.16222L16.5482 7.49276C16.7055 7.97209 16.816 8.46843 16.8766 8.96689C16.917 9.29742 16.9372 9.6269 16.9372 9.96594C16.9372 10.305 16.917 10.6344 16.8777 10.9639C16.7033 12.3732 16.1454 13.7209 15.2632 14.8592L16.1029 15.5096C17.1019 14.2204 17.7343 12.6931 17.932 11.0925C17.9766 10.7205 18 10.3486 18 9.96594C18 9.58332 17.9766 9.21134 17.932 8.83829ZM1.05432 8.96795L0 8.83829C0.197684 7.23874 0.830061 5.71147 1.82911 4.42228L2.66874 5.07272C1.7866 6.211 1.22862 7.55865 1.05432 8.96795ZM0 11.0936C0.197684 12.6931 0.830061 14.2204 1.82911 15.5096L2.66874 14.8591C1.7866 13.7209 1.22862 12.3732 1.05432 10.9639L0 11.0936ZM10.0939 1.00011C11.6935 1.19673 13.2207 1.83017 14.5099 2.82922L13.8595 3.66884C12.7202 2.7867 11.3736 2.22872 9.96426 2.05442L10.0939 1.00011Z", fill: "currentColor" }) });
function Nf() {
  const re = jr(), he = $n("playbackRate"), { t: Ce } = Hn(), rt = Zn(() => {
    re.setPage("speed");
  }, [re]);
  return /* @__PURE__ */ ve(
    yi,
    {
      label: Ce("PLAYBACK_SPEED"),
      hint: `${he}x`,
      onClick: rt,
      Icon: Cf
    }
  );
}
const Df = (re) => /* @__PURE__ */ ln("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...re, children: [
  /* @__PURE__ */ ve("defs", { children: /* @__PURE__ */ ve("clipPath", { id: "clip0_412_23039", children: /* @__PURE__ */ ve("rect", { width: 18, height: 18, fill: "white" }) }) }),
  /* @__PURE__ */ ln("g", { clipPath: "url(#clip0_412_23039)", children: [
    /* @__PURE__ */ ve("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.46326 3.85039H0V2.65039H2.46326C2.7388 1.36449 3.88181 0.400391 5.24999 0.400391C6.61818 0.400391 7.76119 1.36449 8.03673 2.65039H18V3.85039H8.03673C7.76119 5.13629 6.61818 6.10039 5.24999 6.10039C3.88181 6.10039 2.7388 5.13629 2.46326 3.85039ZM3.59999 3.25039C3.59999 2.33912 4.33872 1.60039 5.24999 1.60039C6.16126 1.60039 6.89999 2.33912 6.89999 3.25039C6.89999 4.16166 6.16126 4.90039 5.24999 4.90039C4.33872 4.90039 3.59999 4.16166 3.59999 3.25039Z", fill: "currentColor" }),
    /* @__PURE__ */ ve("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 8.40039H9.46326C9.7388 7.11449 10.8818 6.15039 12.25 6.15039C13.6182 6.15039 14.7612 7.11449 15.0367 8.40039H18V9.60039H15.0367C14.7612 10.8863 13.6182 11.8504 12.25 11.8504C10.8818 11.8504 9.7388 10.8863 9.46326 9.60039H0V8.40039ZM12.25 7.35039C11.3387 7.35039 10.6 8.08912 10.6 9.00039C10.6 9.91166 11.3387 10.6504 12.25 10.6504C13.1613 10.6504 13.9 9.91166 13.9 9.00039C13.9 8.08912 13.1613 7.35039 12.25 7.35039Z", fill: "currentColor" }),
    /* @__PURE__ */ ve("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.24999 17.6004C6.61818 17.6004 7.76119 16.6363 8.03673 15.3504H18V14.1504H8.03673C7.76119 12.8645 6.61818 11.9004 5.24999 11.9004C3.88181 11.9004 2.7388 12.8645 2.46326 14.1504H0V15.3504H2.46326C2.7388 16.6363 3.88181 17.6004 5.24999 17.6004ZM5.24999 13.1004C4.33872 13.1004 3.59999 13.8391 3.59999 14.7504C3.59999 15.6617 4.33872 16.4004 5.24999 16.4004C6.16126 16.4004 6.89999 15.6617 6.89999 14.7504C6.89999 13.8391 6.16126 13.1004 5.24999 13.1004Z", fill: "currentColor" })
  ] })
] });
function Ks(re) {
  const { width: he, height: Ce } = re;
  if (he >= 3800 || Ce >= 2100)
    return "2160p";
  const rt = Ce > he, lt = rt ? he : Ce, Mt = rt ? Ce : he;
  return lt >= 1400 || Mt >= 2500 ? "1440p" : lt >= 1e3 || Mt >= 1800 ? "1080p" : lt >= 700 || Mt >= 1200 ? "720p" : lt >= 460 || Mt >= 800 ? "480p" : lt >= 300 || Mt >= 540 ? "360p" : lt >= 200 || Mt >= 360 ? "240p" : "144p";
}
function Of() {
  const re = jr(), he = $n("autoQuality"), Ce = $n("quality"), { t: rt } = Hn(), lt = Zn(() => {
    re.setPage("quality");
  }, [re]);
  if (!Ce)
    return null;
  const Mt = Ks(Ce);
  return /* @__PURE__ */ ve(
    yi,
    {
      label: rt("QUALITY"),
      hint: he ? rt("AUTO", { quality: Mt }) : Mt,
      onClick: lt,
      Icon: Df
    }
  );
}
function Mf() {
  const re = jr(), he = $n("hasCaptions"), Ce = $n("textTrack"), { t: rt } = Hn(), lt = Zn(() => {
    re.setPage("captions");
  }, [re]);
  return he ? /* @__PURE__ */ ve(
    yi,
    {
      label: rt("CAPTIONS"),
      hint: (Ce == null ? void 0 : Ce.label) ?? rt("OFF"),
      onClick: lt,
      Icon: Vs
    }
  ) : null;
}
const Pf = (re) => /* @__PURE__ */ ve("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...re, children: /* @__PURE__ */ ve("path", { d: "M 21.798373,3.342155 8.8843977,16.256145 2.2000774,9.571825 0,11.771895 8.8843977,20.657845 24,5.543795 Z", fill: "currentColor" }) }), Lf = (re) => /* @__PURE__ */ ve("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...re, children: /* @__PURE__ */ ve("path", { d: "M 9.64706,12 4,17.64706 6.35293,20 12,14.35293 17.64706,20 20,17.64706 14.35293,12 20,6.35293 17.64706,4 12,9.64706 6.35293,4 4,6.35293 Z", fill: "currentColor" }) }), xf = "_switch-track_7nhpo_1", Ff = "_switch-thumb_7nhpo_17", kf = "_switch-icon_7nhpo_31", Zf = "_switch-body_7nhpo_37", Uf = "_switch-label_7nhpo_78", Bf = "_menu-icon_7nhpo_82", $r = {
  "switch-track": "_switch-track_7nhpo_1",
  switchTrack: xf,
  "switch-thumb": "_switch-thumb_7nhpo_17",
  switchThumb: Ff,
  "switch-icon": "_switch-icon_7nhpo_31",
  switchIcon: kf,
  "switch-body": "_switch-body_7nhpo_37",
  switchBody: Zf,
  "switch-label": "_switch-label_7nhpo_78",
  switchLabel: Uf,
  "menu-icon": "_menu-icon_7nhpo_82",
  menuIcon: Bf
};
function oo({
  label: re,
  checked: he = !1,
  onClick: Ce,
  Icon: rt
}) {
  return /* @__PURE__ */ ln(
    "button",
    {
      className: $r.switchBody,
      role: "menuitemcheckbox",
      "aria-label": re,
      "aria-checked": he,
      onClick: Ce,
      tabIndex: -1,
      children: [
        rt && /* @__PURE__ */ ve(rt, { className: $r.menuIcon }),
        /* @__PURE__ */ ve("span", { className: $r.switchLabel, children: re }),
        /* @__PURE__ */ ve("div", { className: $r.switchTrack, children: /* @__PURE__ */ ve("div", { className: $r.switchThumb, children: he ? /* @__PURE__ */ ve(Pf, { className: $r.switchIcon }) : /* @__PURE__ */ ve(Lf, { className: $r.switchIcon }) }) })
      ]
    }
  );
}
const Gf = (re) => /* @__PURE__ */ ve("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...re, children: /* @__PURE__ */ ve("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 0V12.7489H5.44V18L10.5007 12.7489H16.582V0H1ZM2 1H15.58V11.7339H9.98655L6.52667 15.25V11.7339H2V1ZM5.24963 5.35011H12.3323V4.24835H5.24963V5.35011ZM5.24963 8.18462H9.50067V7.08285H5.24963V8.18462Z", fill: "currentColor" }) });
function qf() {
  const { t: re } = Hn(), he = lr(), Ce = Wn();
  return !he.forceComments && he.hasComments ? /* @__PURE__ */ ve(
    oo,
    {
      Icon: Gf,
      label: re("COMMENTS"),
      onClick: Ce.toggleComments,
      checked: Ce.state.commentsEnabled
    }
  ) : null;
}
function Hf() {
  return /* @__PURE__ */ ln(Jr, { noBackButton: !0, children: [
    /* @__PURE__ */ ve(Nf, {}),
    /* @__PURE__ */ ve(Mf, {}),
    /* @__PURE__ */ ve(qf, {}),
    /* @__PURE__ */ ve(Of, {})
  ] });
}
const Vf = (re) => /* @__PURE__ */ ve("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...re, children: /* @__PURE__ */ ve("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.1347 3.00061L6.55157 13.5825L0.865302 7.89624L0 8.76154L6.55157 15.3131L17.9988 3.86469L17.1347 3.00061Z", fill: "currentColor" }) });
function la({ selected: re, label: he, onClick: Ce }) {
  return /* @__PURE__ */ ln(
    "button",
    {
      type: "button",
      role: "menuitemradio",
      "aria-checked": re,
      onClick: Ce,
      tabIndex: -1,
      className: kr.menuItem,
      children: [
        /* @__PURE__ */ ve(Vf, { className: kr.checkIcon }),
        /* @__PURE__ */ ve("span", { className: kr.menuItemLabel, children: he })
      ]
    }
  );
}
function jf() {
  const re = Xl({
    rates: mi,
    normalLabel: "1x"
  }), { t: he } = Hn();
  return /* @__PURE__ */ ve(Jr, { heading: he("PLAYBACK_SPEED"), children: re.map(({ value: Ce, label: rt, select: lt, selected: Mt }) => /* @__PURE__ */ ve(
    la,
    {
      selected: Mt,
      onClick: () => lt(),
      label: rt
    },
    Ce
  )) });
}
function Yf() {
  const re = jr(), { t: he } = Hn(), Ce = Zn(() => {
    re.setPage("captionManage");
  }, [re]);
  return /* @__PURE__ */ ve(yi, { label: he("CAPTIONS_MANAGE"), onClick: Ce });
}
function Kf() {
  const { t: re } = Hn(), he = Wn(), Ce = jr(), rt = Zn(() => {
    Ce.setPage("captionFontSize");
  }, [Ce]);
  return /* @__PURE__ */ ve(
    yi,
    {
      label: re("CAPTION_FONT_SIZE"),
      hint: `${he.state.captionsFontSizeMultiplier * 100}%`,
      onClick: rt
    }
  );
}
function zf() {
  const re = jr(), he = $n("textTrack"), { t: Ce } = Hn(), { disableCaptionSettings: rt } = Wn(), lt = Zn(() => {
    re.setPage("captionLanguage");
  }, [re]);
  return rt ? null : /* @__PURE__ */ ve(
    yi,
    {
      label: Ce("LANGUAGE"),
      hint: (he == null ? void 0 : he.label) ?? Ce("OFF"),
      onClick: lt
    }
  );
}
function Wf() {
  const { t: re } = Hn(), he = Wn();
  return /* @__PURE__ */ ve(
    oo,
    {
      label: re("ON_TOP"),
      onClick: he.toggleCaptionPositionOnTop,
      checked: he.state.captionPositionOnTop
    }
  );
}
function Qf() {
  const { t: re } = Hn(), he = Wn();
  return /* @__PURE__ */ ve(
    oo,
    {
      label: re("INVERT_COLORS"),
      onClick: he.toggleCaptionsInvertColors,
      checked: he.state.captionsInvertColors
    }
  );
}
function Xf() {
  const re = lr(), { t: he } = Hn();
  return /* @__PURE__ */ ln(Jr, { heading: he("CAPTIONS"), children: [
    /* @__PURE__ */ ve(zf, {}),
    /* @__PURE__ */ ve(Kf, {}),
    /* @__PURE__ */ ve(Wf, {}),
    /* @__PURE__ */ ve(Qf, {}),
    re.onCaptionsDelete && /* @__PURE__ */ ve(Yf, {})
  ] });
}
function $f() {
  const re = $l(), { t: he } = Hn();
  return /* @__PURE__ */ ve(Jr, { heading: he("CAPTIONS_LANGUAGE"), children: re.map(({ value: Ce, label: rt, select: lt, selected: Mt }) => /* @__PURE__ */ ve(
    la,
    {
      selected: Mt,
      onClick: () => lt(),
      label: rt
    },
    Ce
  )) });
}
function Jf() {
  const re = Wn(), { t: he } = Hn();
  return /* @__PURE__ */ ve(Jr, { heading: he("CAPTION_FONT_SIZE"), children: Qc.map((Ce) => /* @__PURE__ */ ve(
    la,
    {
      selected: Ce === re.state.captionsFontSizeMultiplier,
      onClick: () => {
        re.setCaptionsFontSizeMultiplier(Ce);
      },
      label: `${Ce * 100}%`
    },
    Ce
  )) });
}
const jr = () => {
  const re = Qa(zs);
  if (!re)
    throw new Error(
      "useCustomSettingsMenuContext must be used within a CustomSettingsMenuContext.Provider"
    );
  return re;
};
function ed() {
  const re = jr(), he = lr(), { t: Ce } = Hn();
  return Pr(() => {
    he.captions.length === 0 && re.backToMain();
  }, [he.captions]), /* @__PURE__ */ ve(Jr, { heading: Ce("CAPTIONS_MANAGE"), children: he.captions.map((rt) => /* @__PURE__ */ ln(
    "button",
    {
      type: "button",
      role: "menuitem",
      onClick: () => {
        var lt;
        (lt = he.onCaptionsDelete) == null || lt.call(he, rt);
      },
      tabIndex: -1,
      className: kr.menuItem,
      children: [
        /* @__PURE__ */ ve(Hs, { className: kr.trashIcon }),
        /* @__PURE__ */ ve("span", { className: kr.menuItemLabel, children: Ce("CAPTION_DELETE", { language: rt.label }) })
      ]
    },
    rt.language
  )) });
}
function td() {
  const re = $n("autoQuality"), he = Jl({ sort: "descending" }), { t: Ce } = Hn();
  return /* @__PURE__ */ ve(Jr, { heading: Ce("QUALITY"), children: he.map(({ value: rt, select: lt, selected: Mt, label: Pe, quality: Ee }) => /* @__PURE__ */ ve(
    la,
    {
      selected: rt === "auto" && re || Mt && !re,
      onClick: () => lt(),
      label: Ee ? Ks(Ee) : Pe
    },
    rt
  )) });
}
function nd(re, he) {
  const Ce = Array.from(re.querySelectorAll("button")), rt = Ce.indexOf(he);
  return Ce[rt - 1] ?? null;
}
function rd(re, he) {
  const Ce = Array.from(re.querySelectorAll("button")), rt = Ce.indexOf(he);
  return Ce[rt + 1] ?? null;
}
function Ds(re) {
  return re.querySelector("button");
}
function Os(re) {
  const he = Array.from(re.querySelectorAll("button"));
  return he[he.length - 1] ?? null;
}
function id(re, he) {
  const Ce = Nr(null), rt = Mr(
    () => ({
      Escape: re.toggle,
      ArrowUp: () => {
        const lt = document.activeElement;
        if (lt && Ce.current && Ce.current.contains(lt)) {
          const Mt = nd(
            Ce.current,
            lt
          );
          if (Mt)
            Mt.focus();
          else {
            const Pe = Os(Ce.current);
            Pe == null || Pe.focus();
          }
        } else if (Ce.current) {
          const Mt = Os(Ce.current);
          Mt == null || Mt.focus();
        }
      },
      ArrowDown: () => {
        const lt = document.activeElement;
        if (lt && Ce.current && Ce.current.contains(lt)) {
          const Mt = rd(
            Ce.current,
            lt
          );
          if (Mt)
            Mt.focus();
          else {
            const Pe = Ds(Ce.current);
            Pe == null || Pe.focus();
          }
        } else if (Ce.current) {
          const Mt = Ds(Ce.current);
          Mt == null || Mt.focus();
        }
      },
      ArrowRight: () => {
        const lt = document.activeElement;
        lt && lt.getAttribute("aria-haspopup") === "true" && Ce.current && Ce.current.contains(lt) && lt.click();
      },
      ArrowLeft: re.back
    }),
    [re]
  );
  return ao(rt, !0, he), Ce;
}
const zs = Wa(null), ad = {
  main: Hf,
  speed: jf,
  captions: Xf,
  captionLanguage: $f,
  captionFontSize: Jf,
  captionManage: ed,
  quality: td
}, od = {
  name: "middleware",
  async fn(re) {
    const he = await lc(re);
    return {
      x: re.x - he.right - 4,
      y: re.y - 4
    };
  }
};
function sd() {
  const re = Wn(), [he, Ce] = _r(["main"]), [rt, lt] = _r(!1), Mt = Zn(() => {
    lt(!rt), Ce(["main"]), re.setGlobalKeysDisabled(!rt);
  }, [rt]), Pe = Zn((c) => {
    Ce((d) => d.concat(c));
  }, []), Ee = Zn(() => {
    Ce((c) => c.length > 1 ? c.slice(0, -1) : c);
  }, []), C = Zn(() => {
    Ce(["main"]);
  }, []), ie = Mr(() => ad[he[he.length - 1]], [he]), { refs: T, floatingStyles: t, context: e } = sa({
    open: rt,
    onOpenChange: Mt,
    placement: "top-end",
    whileElementsMounted: ua,
    middleware: [od]
  }), p = to(e, { escapeKey: !1 }), { getReferenceProps: m, getFloatingProps: o } = no([p]), E = Mr(
    () => ({ setPage: Pe, back: Ee, backToMain: C, toggle: Mt }),
    [Pe, Ee, C, Mt]
  ), h = id(E, rt), n = eo([T.setFloating, h]);
  return {
    Page: ie,
    open: rt,
    floatingRef: n,
    referenceRef: T.setReference,
    floatingStyles: t,
    context: e,
    getReferenceProps() {
      return {
        ...m(),
        tabIndex: re.state.interactionsDisabled ? -1 : 0
      };
    },
    getFloatingProps: o,
    contextValue: E
  };
}
function ud() {
  const {
    Page: re,
    context: he,
    floatingStyles: Ce,
    getFloatingProps: rt,
    getReferenceProps: lt,
    open: Mt,
    floatingRef: Pe,
    referenceRef: Ee,
    contextValue: C
  } = sd(), { t: ie } = Hn();
  return /* @__PURE__ */ ln(pi, { children: [
    /* @__PURE__ */ ve(
      "button",
      {
        ref: Ee,
        type: "button",
        className: "controls-button",
        "aria-label": ie("SETTINGS"),
        onClick: C.toggle,
        "aria-expanded": Mt,
        "aria-haspopup": "true",
        ...lt(),
        children: /* @__PURE__ */ ve(gf, { className: "controls-button-icon icon-rotate" })
      }
    ),
    Mt && /* @__PURE__ */ ve(
      ro,
      {
        context: he,
        restoreFocus: !0,
        guards: !1,
        initialFocus: -1,
        children: /* @__PURE__ */ ve(
          "div",
          {
            role: "menu",
            "aria-label": ie("VIDEO_SETTINGS"),
            "aria-labelledby": "menu-heading",
            className: kr.settingsMenu,
            ref: Pe,
            style: Ce,
            ...rt(),
            children: /* @__PURE__ */ ve(zs.Provider, { value: C, children: /* @__PURE__ */ ve(re, {}) })
          }
        )
      }
    )
  ] });
}
function Ws(re, he = 1e3) {
  return function() {
    const rt = Dr(), [lt, Mt] = _r(null), Pe = Zn(() => Mt(null), []);
    return Pr(() => {
      if (!rt)
        return () => {
        };
      const Ee = new AbortController();
      let C;
      return requestAnimationFrame(() => {
        rt.addEventListener(
          "keyboardAction",
          (ie) => {
            clearTimeout(C);
            const T = ie.detail;
            Mt(/* @__PURE__ */ ve(re, { action: T })), C = setTimeout(Pe, he);
          },
          { signal: Ee.signal }
        );
      }), () => {
        clearTimeout(C), Ee.abort();
      };
    }, [he]), lt;
  };
}
const so = (re) => /* @__PURE__ */ ve("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...re, children: /* @__PURE__ */ ve("path", { d: "M 11,21 H 5 V 3 h 6 z m 8,0 H 13 V 3 h 6 z", fill: "currentColor" }) }), uo = (re) => /* @__PURE__ */ ve("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...re, children: /* @__PURE__ */ ve("path", { d: "M 5,2 V 22 L 21,12.000665 Z", fill: "currentColor" }) }), ld = (re) => /* @__PURE__ */ ve("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...re, children: /* @__PURE__ */ ve("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.691 3.99987V10.5281L0 4.00655V20.2596L10.691 13.7367V20.2663L23.9987 12.1331L10.691 3.99987Z", fill: "currentColor" }) }), cd = (re) => /* @__PURE__ */ ve("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...re, children: /* @__PURE__ */ ve("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.309 3.99987L0 12.1331L13.309 20.2663V13.7367L23.9987 20.2596V4.00655L13.309 10.5281V3.99987Z", fill: "currentColor" }) }), Qs = (re) => /* @__PURE__ */ ve("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...re, children: /* @__PURE__ */ ve("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.1179 1.41211V22.589H11.2943L5.64717 16.9418V7.05928L11.2943 1.41211H14.1179ZM4.23537 7.05928V16.9418H2.11769C0.957618 16.9418 0.0189406 16.0147 0.00028305 14.8592L0 14.8241V9.17696C0 8.01689 0.927077 7.07822 2.0826 7.05956L2.11769 7.05928H4.23537ZM22.3744 7.93711L24 9.56119L21.5623 11.9988L24 14.4365L22.3744 16.0621L19.9383 13.6245L17.5006 16.0621L15.875 14.4365L18.3127 11.9988L15.875 9.56119L17.5006 7.93711L19.9383 10.3748L22.3744 7.93711Z", fill: "currentColor" }) }), Xs = (re) => /* @__PURE__ */ ve("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...re, children: /* @__PURE__ */ ve("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.64714 6.98017V16.8627L11.2943 22.5099H14.1179V1.33301H11.2943L5.64714 6.98017ZM0 9.09785V14.745C0 15.9168 0.945899 16.8627 2.11768 16.8627H4.23537V6.98017H2.11768C0.945899 6.98017 0 7.92607 0 9.09785ZM18.3527 11.9207C18.3527 10.6134 17.8388 9.36962 16.9056 8.4209L17.9094 7.43123C19.1066 8.64396 19.7645 10.2393 19.7645 11.9207C19.7645 13.6036 19.1066 15.1989 17.9094 16.4116L16.9056 15.422C17.8388 14.4732 18.3527 13.2295 18.3527 11.9207Z", fill: "currentColor" }) }), $s = (re) => /* @__PURE__ */ ve("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...re, children: /* @__PURE__ */ ve("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.64714 16.8627V6.98017L11.2943 1.33301H14.1179V22.5099H11.2943L5.64714 16.8627ZM0 14.745V9.09785C0 7.92607 0.945899 6.98017 2.11768 6.98017H4.23537V16.8627H2.11768C0.945899 16.8627 0 15.9168 0 14.745ZM16.9056 8.4209C17.8388 9.36962 18.3527 10.6134 18.3527 11.9207C18.3527 13.2295 17.8388 14.4732 16.9056 15.422L17.9094 16.4116C19.1066 15.1989 19.7645 13.6036 19.7645 11.9207C19.7645 10.2393 19.1066 8.64396 17.9094 7.43123L16.9056 8.4209ZM19.9016 5.43185L20.8997 4.43372C22.9002 6.43422 24 9.09403 24 11.9219C24 14.7497 22.9002 17.4081 20.8997 19.4086L19.9016 18.4104C21.6353 16.6782 22.5882 14.3727 22.5882 11.9219C22.5882 9.46957 21.6353 7.16553 19.9016 5.43185Z", fill: "currentColor" }) }), fd = "_feedback-overlay_3kkqe_1", dd = "_feedback-message_3kkqe_14", gd = "_feedback-icon_3kkqe_30", hd = "_feedback-icon-animation_3kkqe_1", yr = {
  "feedback-overlay": "_feedback-overlay_3kkqe_1",
  feedbackOverlay: fd,
  "feedback-message": "_feedback-message_3kkqe_14",
  feedbackMessage: dd,
  "feedback-icon": "_feedback-icon_3kkqe_30",
  feedbackIcon: gd,
  "feedback-icon-animation": "_feedback-icon-animation_3kkqe_1",
  feedbackIconAnimation: hd
};
function md({ action: re }) {
  const he = Dr();
  if (!he)
    return null;
  switch (re) {
    case "togglePaused":
      return /* @__PURE__ */ ve("i", { className: yr.feedbackIcon, children: he.paused ? /* @__PURE__ */ ve(so, {}) : /* @__PURE__ */ ve(uo, {}) });
    case "seekForward":
    case "seekForward10":
      return /* @__PURE__ */ ve("i", { className: yr.feedbackIcon, children: /* @__PURE__ */ ve(ld, { className: "right" }) });
    case "seekBackward":
    case "seekBackward10":
      return /* @__PURE__ */ ve("i", { className: yr.feedbackIcon, children: /* @__PURE__ */ ve(cd, { className: "left" }) });
    case "captionsChange":
      return /* @__PURE__ */ ve("i", { className: yr.feedbackIcon, children: /* @__PURE__ */ ve(js, {}) });
    case "volumeChange":
      return /* @__PURE__ */ ve("i", { className: yr.feedbackIcon, children: he.muted || he.volume === 0 ? /* @__PURE__ */ ve(Qs, {}) : he.volume >= 0.5 ? /* @__PURE__ */ ve($s, {}) : /* @__PURE__ */ ve(Xs, {}) });
    default:
      return null;
  }
}
function pd({ action: re }) {
  const { t: he } = Hn(), Ce = Dr();
  if (!Ce)
    return null;
  switch (re) {
    case "captionsChange":
      return /* @__PURE__ */ ve("div", { className: yr.feedbackMessage, children: Ce.textTracks.selected ? he("CAPTION_LANGUAGE", {
        language: Ce.textTracks.selected.label
      }) : `${he("CAPTIONS")}: ${he("OFF")}` });
    case "volumeChange":
      return /* @__PURE__ */ ve("div", { className: yr.feedbackMessage, children: Ce.muted || Ce.volume === 0 ? he("MUTED") : he("VOLUME_VALUE", { volume: (Ce.volume * 100).toFixed(0) }) });
    case "playbackRateChange":
      return /* @__PURE__ */ ve("div", { className: yr.feedbackMessage, children: he("PLAYBACK_SPEED_MESSAGE", { speed: Ce.playbackRate }) });
    case "seekForward":
      return /* @__PURE__ */ ve("div", { className: yr.feedbackMessage, children: he("SEEK_FORWARD", { seconds: 5 }) });
    case "seekForward10":
      return /* @__PURE__ */ ve("div", { className: yr.feedbackMessage, children: he("SEEK_FORWARD", { seconds: 10 }) });
    case "seekBackward":
      return /* @__PURE__ */ ve("div", { className: yr.feedbackMessage, children: he("SEEK_BACKWARD", { seconds: 5 }) });
    case "seekBackward10":
      return /* @__PURE__ */ ve("div", { className: yr.feedbackMessage, children: he("SEEK_BACKWARD", { seconds: 10 }) });
    default:
      return null;
  }
}
const yd = Ws(md, 300), _d = Ws(pd, 1e3);
function Js() {
  return /* @__PURE__ */ ln("div", { className: yr.feedbackOverlay, children: [
    /* @__PURE__ */ ve(yd, {}),
    /* @__PURE__ */ ve(_d, {})
  ] });
}
const Ed = (re) => /* @__PURE__ */ ve("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...re, children: /* @__PURE__ */ ve("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.1383 0.999867V3.66268H18.4561L3.66281 18.4546V14.1382H1V23H9.86449V20.3372H5.54542L20.3387 5.54528V9.86303H23.0001V0.999867H14.1383Z", fill: "currentColor" }) }), vd = (re) => /* @__PURE__ */ ve("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...re, children: /* @__PURE__ */ ve("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.562 6.58944L22.1514 0L24.0005 1.84907L17.4111 8.43851H21.6506V11.0552H12.9453V2.34861H15.562V6.58944ZM2.34861 15.5615V12.9461H11.0539V21.6501H8.43982V17.4106L1.84907 24L0 22.1509L6.59075 15.5615H2.34861Z", fill: "currentColor" }) }), Td = "_full-screen-button_1xm32_2", bd = {
  "full-screen-button": "_full-screen-button_1xm32_2",
  fullScreenButton: Td
};
function Sd() {
  const re = $n("fullscreen"), he = Dr(), Ce = Wn(), rt = lr(), { t: lt } = Hn();
  return rt.hideFullScreen ? null : /* @__PURE__ */ ve(
    "button",
    {
      role: "button",
      type: "button",
      "aria-label": lt(re ? "EXIT_FULLSCREEN" : "ENTER_FULLSCREEN"),
      tabIndex: Ce.state.interactionsDisabled ? -1 : 0,
      className: `controls-button ${bd.fullScreenButton}`,
      onClick: () => {
        re ? he == null || he.exitFullscreen() : he == null || he.enterFullscreen();
      },
      children: re ? /* @__PURE__ */ ve(vd, { className: "controls-button-icon" }) : /* @__PURE__ */ ve(Ed, { className: "controls-button-icon" })
    }
  );
}
const Ad = "_gestures-container_1fn3b_1", Id = "_gesture_1fn3b_1", Ms = {
  "gestures-container": "_gestures-container_1fn3b_1",
  gesturesContainer: Ad,
  gesture: Id
};
function eu() {
  const re = oa(), he = () => {
    re.togglePaused();
  };
  return /* @__PURE__ */ ve("div", { className: Ms.gesturesContainer, children: /* @__PURE__ */ ve("div", { "aria-hidden": !0, className: Ms.gesture, onClick: he }) });
}
const Rd = (re) => /* @__PURE__ */ ve("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...re, children: /* @__PURE__ */ ve("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 0V2.66667C17.1453 2.66667 21.3333 6.85333 21.3333 12C21.3333 17.1467 17.1453 21.3333 12 21.3333C6.85467 21.3333 2.66667 17.1467 2.66667 12C2.66667 9.53733 3.64667 7.21867 5.33333 5.49067V8.66667H8V1.33333H0.666667V4H3.05467C1.108 6.176 0 9.012 0 12C0 18.616 5.38267 24 12 24C18.6173 24 24 18.616 24 12C24 5.384 18.6173 0 12 0Z", fill: "currentColor" }) }), wd = "_play-pause-button_vj8da_1", Cd = {
  "play-pause-button": "_play-pause-button_vj8da_1",
  playPauseButton: wd
};
function Nd(re, he) {
  return he ? Rd : re ? uo : so;
}
function Dd(re, he) {
  return he ? "REPLAY" : re ? "PLAY" : "PAUSE";
}
function Od() {
  const re = Dr(), he = Wn(), Ce = $n("paused"), rt = $n("ended"), { t: lt } = Hn(), Mt = Nr(null), Pe = Nd(Ce, rt);
  return Pr(() => {
    const Ee = new AbortController();
    return re == null || re.addEventListener(
      "annotationHidden",
      () => {
        requestAnimationFrame(() => {
          var C;
          (C = Mt.current) == null || C.focus();
        });
      },
      { signal: Ee.signal }
    ), () => {
      Ee.abort();
    };
  }, [re]), re ? /* @__PURE__ */ ve(
    "button",
    {
      ref: Mt,
      role: "button",
      type: "button",
      className: `controls-button ${Cd.playPauseButton}`,
      "aria-label": lt(Dd(Ce, rt)),
      tabIndex: he.state.interactionsDisabled ? -1 : 0,
      onClick: () => {
        re.paused ? re.remoteControl.play() : re.remoteControl.pause();
      },
      children: /* @__PURE__ */ ve(Pe, { className: "controls-button-icon" })
    }
  ) : null;
}
const Md = "_small-layout-overlay_cmaq3_1", Pd = "_small-layout-button_cmaq3_14", Ld = "_small-layout-icon-play_cmaq3_24", xd = "_small-layout-icon-pause_cmaq3_30", Fd = "_small-layout-timestamp_cmaq3_36", kd = "_full-screen-close-icon_cmaq3_49", Zd = "_fade-out_cmaq3_1", gi = {
  "small-layout-overlay": "_small-layout-overlay_cmaq3_1",
  smallLayoutOverlay: Md,
  "small-layout-button": "_small-layout-button_cmaq3_14",
  smallLayoutButton: Pd,
  "small-layout-icon-play": "_small-layout-icon-play_cmaq3_24",
  smallLayoutIconPlay: Ld,
  "small-layout-icon-pause": "_small-layout-icon-pause_cmaq3_30",
  smallLayoutIconPause: xd,
  "small-layout-timestamp": "_small-layout-timestamp_cmaq3_36",
  smallLayoutTimestamp: Fd,
  "full-screen-close-icon": "_full-screen-close-icon_cmaq3_49",
  fullScreenCloseIcon: kd,
  "fade-out": "_fade-out_cmaq3_1",
  fadeOut: Zd
};
function tu() {
  const re = $n("paused");
  return /* @__PURE__ */ ln(
    "div",
    {
      className: gi.smallLayoutOverlay,
      "data-testid": "small-layout-overlay",
      children: [
        /* @__PURE__ */ ve(ec, { className: gi.fullScreenCloseIcon, children: /* @__PURE__ */ ve(Gs, {}) }),
        /* @__PURE__ */ ve("i", { className: gi.smallLayoutButton, children: re ? /* @__PURE__ */ ve(uo, { className: gi.smallLayoutIconPlay }) : /* @__PURE__ */ ve(so, { className: gi.smallLayoutIconPause }) }),
        /* @__PURE__ */ ln("div", { className: gi.smallLayoutTimestamp, children: [
          /* @__PURE__ */ ve(aa, { type: "current" }),
          "/",
          /* @__PURE__ */ ve(aa, { type: "duration" })
        ] })
      ]
    }
  );
}
const Ud = "_time-indicator_1uygf_1", Bd = {
  "time-indicator": "_time-indicator_1uygf_1",
  timeIndicator: Ud
};
function Gd() {
  return /* @__PURE__ */ ln("div", { className: Bd.timeIndicator, children: [
    /* @__PURE__ */ ve(aa, { type: "current" }),
    "/",
    /* @__PURE__ */ ve(aa, { type: "duration" })
  ] });
}
const qd = "_comment-markers_tqdlg_1", Hd = "_comment-marker_tqdlg_1", Vd = "_timeline-wrapper_tqdlg_23", jd = "_timeline-wrapper-compact_tqdlg_24", Yd = "_track_tqdlg_33", Kd = "_thumb_tqdlg_46", zd = "_root_tqdlg_60", Wd = "_track-inner_tqdlg_90", Qd = "_progress_tqdlg_96", Xd = "_track-fill_tqdlg_102", $d = "_pins_tqdlg_119", Jd = "_pin-button_tqdlg_127", eg = "_annotation-pin_tqdlg_153", tg = "_quiz-pin_tqdlg_162", ng = "_annotation-pin-child_tqdlg_171", rg = "_quiz-pin-child_tqdlg_175", ig = "_interactive-pin-container_tqdlg_180", ag = "_interactive-pin-wrapper_tqdlg_187", og = "_interactive-pin-icon_tqdlg_193", sg = "_interactive-pin_tqdlg_180", ug = "_bg_tqdlg_207", lg = "_symbol_tqdlg_211", cg = "_interactive-pin-button_tqdlg_216", fg = "_interactive-pin-menu_tqdlg_245", dg = "_interactive-pin-menu-item_tqdlg_266", gg = "_arrow_tqdlg_292", hg = "_tooltip_tqdlg_296", mg = "_tooltip-arrow_tqdlg_305", Mn = {
  "comment-markers": "_comment-markers_tqdlg_1",
  commentMarkers: qd,
  "comment-marker": "_comment-marker_tqdlg_1",
  commentMarker: Hd,
  "timeline-wrapper": "_timeline-wrapper_tqdlg_23",
  timelineWrapper: Vd,
  "timeline-wrapper-compact": "_timeline-wrapper-compact_tqdlg_24",
  timelineWrapperCompact: jd,
  track: Yd,
  thumb: Kd,
  root: zd,
  "track-inner": "_track-inner_tqdlg_90",
  trackInner: Wd,
  progress: Qd,
  "track-fill": "_track-fill_tqdlg_102",
  trackFill: Xd,
  pins: $d,
  "pin-button": "_pin-button_tqdlg_127",
  pinButton: Jd,
  "annotation-pin": "_annotation-pin_tqdlg_153",
  annotationPin: eg,
  "quiz-pin": "_quiz-pin_tqdlg_162",
  quizPin: tg,
  "annotation-pin-child": "_annotation-pin-child_tqdlg_171",
  annotationPinChild: ng,
  "quiz-pin-child": "_quiz-pin-child_tqdlg_175",
  quizPinChild: rg,
  "interactive-pin-container": "_interactive-pin-container_tqdlg_180",
  interactivePinContainer: ig,
  "interactive-pin-wrapper": "_interactive-pin-wrapper_tqdlg_187",
  interactivePinWrapper: ag,
  "interactive-pin-icon": "_interactive-pin-icon_tqdlg_193",
  interactivePinIcon: og,
  "interactive-pin": "_interactive-pin_tqdlg_180",
  interactivePin: sg,
  bg: ug,
  symbol: lg,
  "interactive-pin-button": "_interactive-pin-button_tqdlg_216",
  interactivePinButton: cg,
  "interactive-pin-menu": "_interactive-pin-menu_tqdlg_245",
  interactivePinMenu: fg,
  "interactive-pin-menu-item": "_interactive-pin-menu-item_tqdlg_266",
  interactivePinMenuItem: dg,
  arrow: gg,
  tooltip: hg,
  "tooltip-arrow": "_tooltip-arrow_tqdlg_305",
  tooltipArrow: mg
};
function Ps() {
  const re = $n("duration"), he = lr(), Ce = Wn();
  return re > 0 && he.hasComments && Ce.state.commentsEnabled ? /* @__PURE__ */ ve("div", { className: Mn.commentMarkers, children: he.comments.map((rt) => /* @__PURE__ */ ve(
    "span",
    {
      className: Mn.commentMarker,
      style: {
        left: `${rt.timestamp / re * 100}%`
      }
    },
    rt.id
  )) }) : null;
}
const pg = ac(function({ currentTime: he, position: Ce }, rt) {
  const [lt, Mt] = _r(!1), [Pe, Ee] = _r(null), C = lr(), ie = Wn(), T = Zn(() => {
    C.interactiveMenuElements.length > 0 ? Mt((L) => (ie.setGlobalKeysDisabled(!L), !L)) : C.onInteractivePinClick(he);
  }, [
    C.interactiveMenuElements,
    C.onInteractivePinClick,
    he
  ]), t = Nr(null), { refs: e, floatingStyles: p, context: m } = sa({
    open: lt,
    onOpenChange: T,
    whileElementsMounted: ua,
    placement: "top",
    middleware: [
      Xa(),
      $a(6),
      Ja({
        element: t
      })
    ]
  }), o = Nr([]), E = to(m), h = ks(m, {
    listRef: o,
    activeIndex: Pe,
    onNavigate: Ee,
    loop: !0,
    openOnArrowKeyDown: !1
  }), { getReferenceProps: n, getFloatingProps: c, getItemProps: d } = no(
    [E, h]
  ), S = eo([e.setReference, rt]), { t: x } = Hn(), B = Ka(he);
  return /* @__PURE__ */ ln(pi, { children: [
    /* @__PURE__ */ ve(
      "button",
      {
        id: "interactive-pin",
        tabIndex: ie.state.interactionsDisabled ? -1 : 0,
        type: "button",
        "aria-label": C.interactiveMenuElements.length > 0 ? x("ADD_QUIZ_AT", { time: B }) : x("ADD_ANNOTATION_AT", { time: B }),
        "aria-haspopup": C.interactiveMenuElements.length > 0 ? "true" : void 0,
        className: Mn.interactivePinButton,
        ref: S,
        style: { left: `${Ce}%` },
        ...n({
          onClick: T
        }),
        children: /* @__PURE__ */ ln(
          "svg",
          {
            className: Mn.interactivePin,
            width: "36",
            height: "44",
            fill: "none",
            viewBox: "0 0 36 44",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
              /* @__PURE__ */ ve(
                "path",
                {
                  className: Mn.bg,
                  d: "M 33.1703,27.499961 C 34.9615,24.721661 36,21.418761 36,17.874961 36,8.0028612 27.9411,-3.8819277e-5 18,-3.8819277e-5 8.0588999,-3.8819277e-5 -1.5e-7,8.0028612 -1.5e-7,17.874961 c 0,3.5438 1.03844995,6.8467 2.82964995,9.625 4.5447501,6.8094 10.1600502,10.1014 15.2487502,16.5 5.0364,-6.3985 10.5573,-9.7259 15.0919,-16.5 z"
                }
              ),
              /* @__PURE__ */ ve(
                "path",
                {
                  className: Mn.symbol,
                  d: "m 35.499961,17.877772 c 0,3.443549 -1.008198,6.652061 -2.747494,9.351891 -2.235095,3.338633 -4.71529,5.832631 -7.286584,8.306425 -0.277599,0.267143 -0.556499,0.534085 -0.836198,0.801928 -2.174595,2.082232 -4.40389,4.216673 -6.553385,6.870196 -2.158995,-2.636621 -4.40379,-4.754859 -6.591985,-6.819788 -0.2979,-0.281145 -0.594699,-0.561289 -0.890198,-0.841534 C 7.9918219,33.077896 5.4869279,30.584698 3.2477829,27.230063 1.5082968,24.530133 0.50003905,21.321521 0.50003905,17.877772 0.50003905,8.2835422 8.3317219,0.50000048 18,0.50000048 c 9.668278,0 17.499961,7.78354172 17.499961,17.37777152 z"
                }
              ),
              /* @__PURE__ */ ve(
                "path",
                {
                  className: Mn.interactivePinIcon,
                  "data-open": lt,
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "m 18.75,17.388467 v -6.25 h -1.5 v 6.25 H 11 v 1.5 h 6.25 v 6.25 h 1.5 v -6.25 H 25 v -1.5 z",
                  fill: "white"
                }
              )
            ]
          }
        )
      }
    ),
    lt && /* @__PURE__ */ ve(ro, { context: m, initialFocus: -1, modal: !0, children: /* @__PURE__ */ ln(
      "div",
      {
        ref: e.setFloating,
        style: p,
        className: Mn.interactivePinMenu,
        "aria-labelledby": "interactive-pin",
        ...c(),
        children: [
          C.interactiveMenuElements.map(
            ({ id: L, text: $, onClick: M }, K) => /* @__PURE__ */ ln(
              "button",
              {
                type: "button",
                className: Mn.interactivePinMenuItem,
                ref: (ae) => {
                  o.current[K] = ae;
                },
                tabIndex: Pe === K ? 0 : -1,
                ...d({
                  onClick: () => {
                    M(L, he), Mt(!1), ie.setGlobalKeysDisabled(!1);
                  }
                }),
                children: [
                  /* @__PURE__ */ ve(
                    "svg",
                    {
                      width: "16",
                      height: "16",
                      viewBox: "0 0 16 16",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                      children: /* @__PURE__ */ ve(
                        "path",
                        {
                          fillRule: "evenodd",
                          clipRule: "evenodd",
                          d: "M7.33339 7.33339H1.77783V8.66672H7.33339V14.2223H8.66672V8.66672H14.2223V7.33339H8.66672V1.77783H7.33339V7.33339Z",
                          fill: "#273540"
                        }
                      )
                    }
                  ),
                  $
                ]
              },
              L
            )
          ),
          /* @__PURE__ */ ve(
            io,
            {
              ref: t,
              context: m,
              className: Mn.arrow
            }
          )
        ]
      }
    ) })
  ] });
}), yg = () => {
  const re = Nr(!1), he = Nr(!1), Ce = Mr(() => ({
    ArrowLeft: () => {
      he.current = !0;
    },
    ArrowRight: () => {
      he.current = !0;
    },
    Tab: () => {
      he.current = !1;
    }
  }), []);
  return ao(Ce), { focusCallback: Zn((lt) => {
    lt && (lt.addEventListener("focus", () => {
      re.current = !0;
    }), lt.addEventListener("blur", () => {
      he.current || (re.current = !1);
    }), re.current && lt.focus());
  }, []), wasPinFocused: re.current };
};
function _g() {
  var Ee;
  const re = $n("duration"), he = $n("currentTime"), Ce = he / re * 100, { disableInteractivePinRanges: rt } = lr(), lt = !rt.some(
    ([C, ie]) => he >= C && he <= ie
  ), { wasPinFocused: Mt, focusCallback: Pe } = yg();
  return lt ? /* @__PURE__ */ ve("div", { className: Mn.interactivePinContainer, children: /* @__PURE__ */ ve("div", { className: Mn.interactivePinWrapper, children: /* @__PURE__ */ ve(
    pg,
    {
      ref: Pe,
      currentTime: he,
      position: Ce
    }
  ) }) }) : (Mt && ((Ee = document.querySelector("[data-media-time-slider]")) == null || Ee.focus()), null);
}
function Eg() {
  const re = $n("paused"), he = Wn();
  return re && !he.state.interactionsDisabled ? /* @__PURE__ */ ve(_g, {}) : null;
}
const vg = {
  annotation: Mn.annotationPin,
  quiz: Mn.quizPin
}, Tg = (re, he, Ce, rt = !1) => he === "annotation" ? re("OPEN_ANNOTATION_AT", { time: Ka(Ce) }) : he === "quiz" ? re(rt ? "OPEN_COMPLETED_QUIZ_AT" : "OPEN_QUIZ_AT", {
  time: Ka(Ce)
}) : "";
function nu({
  type: re,
  position: he,
  children: Ce,
  onClick: rt,
  id: lt,
  time: Mt,
  completed: Pe
}) {
  const Ee = Wn(), { t: C } = Hn();
  return /* @__PURE__ */ ve(
    "button",
    {
      type: "button",
      tabIndex: Ee.state.interactionsDisabled ? -1 : 0,
      className: Mn.pinButton,
      style: { left: `${he}%` },
      onClick: rt,
      "data-marker-id": lt,
      "aria-label": Tg(C, re, Mt, Pe),
      children: /* @__PURE__ */ ln(
        "svg",
        {
          className: vg[re],
          width: "26",
          height: "32",
          viewBox: "0 0 26 32",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            /* @__PURE__ */ ve("path", { d: "M25.5 13C25.5 15.4774 24.7798 17.785 23.5376 19.7268C21.932 22.1411 20.1501 23.9459 18.2945 25.7433C18.0942 25.9373 17.8929 26.1314 17.6908 26.3262C16.157 27.8047 14.5793 29.3256 13.0545 31.2007C11.5227 29.3377 9.93394 27.8282 8.39067 26.362C8.17552 26.1576 7.96126 25.954 7.74816 25.7505C5.87029 23.9566 4.07076 22.1526 2.46259 19.7271C1.22024 17.7852 0.5 15.4775 0.5 13C0.5 6.09644 6.09644 0.5 13 0.5C19.9036 0.5 25.5 6.09644 25.5 13Z" }),
            Ce
          ]
        }
      )
    }
  );
}
function bg(re) {
  return /* @__PURE__ */ ve(nu, { type: "annotation", ...re, children: /* @__PURE__ */ ve(
    "path",
    {
      className: Mn.annotationPinChild,
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7 8V19.25H8.875V18.875C8.875 17.8415 9.7165 17 10.75 17H19V8H7ZM10 11.75H16V11H10V11.75ZM14.5 14H10V13.25H14.5V14Z",
      fill: "currentColor",
      stroke: "none"
    }
  ) });
}
function Sg(re) {
  const he = re.completed ? /* @__PURE__ */ ve(
    "path",
    {
      className: Mn.quizPinChild,
      transform: "translate(6, 6)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.7156 2.33212L5.18253 9.86522L1.28337 5.96607L0 7.24944L5.18253 12.4329L13.9999 3.6164L12.7156 2.33212Z",
      fill: "currentColor",
      "data-completed": "true"
    }
  ) : /* @__PURE__ */ ve(
    "text",
    {
      className: Mn.quizPinChild,
      x: "50%",
      y: "56%",
      textAnchor: "middle",
      fill: "currentColor",
      stroke: "none",
      children: re.ordinal
    }
  );
  return /* @__PURE__ */ ve(nu, { type: "quiz", ...re, children: re.multiple ? /* @__PURE__ */ ve("circle", { className: Mn.quizPinChild, cx: "13", cy: "13", r: "6" }) : he });
}
function Ag(re, he) {
  return re.map((Ce, rt) => ({
    id: Ce.id,
    time: Ce.time,
    type: "annotation",
    ordinal: rt + 1,
    onClick: () => he(Ce)
  }));
}
function Ig(re, he) {
  const Ce = /* @__PURE__ */ new Map();
  re.forEach((Mt) => {
    var Ee;
    const Pe = Mt.time;
    Ce.has(Pe) || Ce.set(Pe, []), (Ee = Ce.get(Pe)) == null || Ee.push(Mt);
  });
  const rt = [];
  let lt = 0;
  return Ce.forEach((Mt, Pe) => {
    rt.push({
      id: Mt.map((Ee) => Ee.id).join("-"),
      time: Pe,
      type: "quiz",
      ordinal: lt + 1,
      onClick: () => he(Mt),
      multiple: Mt.length > 1,
      completed: Mt.every((Ee) => Ee.completed)
    }), lt++;
  }), rt;
}
function Rg(re, he, Ce, rt) {
  switch (re.type) {
    case "annotation": {
      const lt = () => rt ? re.onClick() : Ce.seek(re.time);
      return /* @__PURE__ */ ve(
        bg,
        {
          id: re.id,
          position: re.time / he * 100,
          onClick: lt,
          time: re.time
        },
        re.id
      );
    }
    case "quiz":
      return /* @__PURE__ */ ve(
        Sg,
        {
          id: re.id,
          position: re.time / he * 100,
          ordinal: re.ordinal,
          multiple: re.multiple,
          onClick: re.onClick,
          completed: re.completed,
          time: re.time
        },
        re.id
      );
    default:
      return null;
  }
}
function wg() {
  const re = oa(), he = $n("duration"), Ce = lr(), rt = Mr(() => [
    ...Ag(
      Ce.annotations,
      Ce.onAnnotationClick
    ),
    ...Ce.hideQuizMarkers ? [] : Ig(
      Ce.quizMarkers,
      Ce.onQuizMarkerClick
    )
  ].sort((Mt, Pe) => Mt.time - Pe.time).map((Mt) => Rg(Mt, he, re, Ce.interactive)), [Ce.annotations, Ce.quizMarkers, he, re]);
  return Ce.interactive || rt.length > 0 ? /* @__PURE__ */ ve("div", { className: Mn.pins, children: rt }) : null;
}
const Cg = {
  normal: Mn.timelineWrapper,
  compact: Mn.timelineWrapperCompact
};
function Ls({
  layout: re,
  interactionsDisabled: he,
  children: Ce
}) {
  const [rt, lt] = _r(!1), Mt = Zn(() => lt(!0), []), Pe = Zn(() => lt(!1), []), Ee = Nr(null), { refs: C, floatingStyles: ie, context: T } = sa({
    open: rt,
    onOpenChange: lt,
    whileElementsMounted: (t, e, p) => ua(t, e, p, {
      animationFrame: !0
    }),
    placement: "top",
    middleware: [
      Xa(),
      $a(18),
      Ja({
        element: Ee
      })
    ]
  });
  return /* @__PURE__ */ ln("div", { className: Cg[re], children: [
    Ce,
    /* @__PURE__ */ ln(
      di.Root,
      {
        tabIndex: he ? -1 : 0,
        className: Mn.root,
        onDragStart: Mt,
        onDragEnd: Pe,
        children: [
          /* @__PURE__ */ ln(di.Track, { className: Mn.track, children: [
            /* @__PURE__ */ ve(
              di.Progress,
              {
                className: Ii(Mn.progress, Mn.trackInner)
              }
            ),
            /* @__PURE__ */ ve(
              di.TrackFill,
              {
                className: Ii(Mn.trackFill, Mn.trackInner)
              }
            )
          ] }),
          /* @__PURE__ */ ve(di.Thumb, { className: Mn.thumb, ref: C.setReference }),
          rt ? /* @__PURE__ */ ln(
            "div",
            {
              role: "tooltip",
              ref: C.setFloating,
              style: ie,
              className: Mn.tooltip,
              children: [
                /* @__PURE__ */ ve(di.Value, {}),
                /* @__PURE__ */ ve(
                  io,
                  {
                    ref: Ee,
                    context: T,
                    className: Mn.tooltipArrow,
                    width: 20,
                    height: 10
                  }
                )
              ]
            }
          ) : null
        ]
      }
    )
  ] });
}
const Ng = "_wrapper_1ijfr_1", Dg = "_track_1ijfr_6", Og = "_thumb_1ijfr_16", Mg = "_track-fill_1ijfr_30", Pg = "_root_1ijfr_49", Ai = {
  wrapper: Ng,
  track: Dg,
  thumb: Og,
  "track-fill": "_track-fill_1ijfr_30",
  trackFill: Mg,
  root: Pg
};
function Lg() {
  const re = Dr(), he = $n("volume"), Ce = $n("muted"), rt = Wn(), lt = Ce || he === 0, { t: Mt } = Hn();
  return /* @__PURE__ */ ln("div", { className: Ai.wrapper, children: [
    /* @__PURE__ */ ve(
      "button",
      {
        role: "button",
        type: "button",
        tabIndex: rt.state.interactionsDisabled ? -1 : 0,
        className: "controls-button",
        "aria-label": Mt(lt ? "VOLUME" : "MUTE"),
        onClick: () => {
          lt ? re == null || re.remoteControl.unmute() : re == null || re.remoteControl.mute();
        },
        children: lt ? /* @__PURE__ */ ve(Qs, { className: "controls-button-icon" }) : he < 0.5 ? /* @__PURE__ */ ve(Xs, { className: "controls-button-icon" }) : /* @__PURE__ */ ve($s, { className: "controls-button-icon" })
      }
    ),
    /* @__PURE__ */ ln(
      ta.Root,
      {
        className: Ai.root,
        tabIndex: rt.state.interactionsDisabled ? -1 : 0,
        children: [
          /* @__PURE__ */ ve(ta.Track, { className: Ai.track, children: /* @__PURE__ */ ve(ta.TrackFill, { className: Ai.trackFill }) }),
          /* @__PURE__ */ ve(ta.Thumb, { className: Ai.thumb })
        ]
      }
    )
  ] });
}
function gr(re, he) {
  re.dispatchEvent(
    new CustomEvent("keyboardAction", {
      detail: he
    })
  );
}
function hr(re, he) {
  re.preventDefault(), he();
}
const xs = {
  togglePaused: {
    keys: ["Space", "Enter", "k"],
    onKeyDown({ player: re, remote: he, event: Ce }) {
      var rt;
      (rt = document.activeElement) != null && rt.hasAttribute("data-media-player") && hr(Ce, () => {
        he.togglePaused(Ce), gr(re, "togglePaused");
      });
    }
  },
  seekForward: {
    keys: ["ArrowRight"],
    onKeyDown({ player: re, remote: he, event: Ce }) {
      Ce.preventDefault(), hr(Ce, () => {
        he.seek(re.currentTime + 5, Ce), gr(re, "seekForward");
      });
    }
  },
  seekBackward: {
    keys: ["ArrowLeft"],
    onKeyDown({ player: re, remote: he, event: Ce }) {
      hr(Ce, () => {
        he.seek(re.currentTime - 5, Ce), gr(re, "seekBackward");
      });
    }
  },
  volumeUp: {
    keys: ["ArrowUp"],
    onKeyDown({ player: re, remote: he, event: Ce }) {
      hr(Ce, () => {
        he.changeVolume(re.volume + 0.05, Ce), gr(re, "volumeChange");
      });
    }
  },
  volumeDown: {
    keys: ["ArrowDown"],
    onKeyDown({ player: re, remote: he, event: Ce }) {
      hr(Ce, () => {
        he.changeVolume(re.volume - 0.05, Ce), gr(re, "volumeChange");
      });
    }
  },
  toggleFullscreen: ["f"],
  toggleMuted: {
    keys: ["m"],
    onKeyDown({ player: re, remote: he, event: Ce }) {
      hr(Ce, () => {
        he.toggleMuted(Ce), gr(re, "volumeChange");
      });
    }
  },
  toggleCaptions: {
    keys: ["c"],
    onKeyDown({ player: re, remote: he, event: Ce }) {
      hr(Ce, () => {
        he.toggleCaptions(Ce), gr(re, "captionsChange");
      });
    }
  },
  nextCaptionLanguage: {
    keys: ["v"],
    onKeyDown({ event: re, player: he, remote: Ce }) {
      hr(re, () => {
        const rt = he.textTracks.selectedIndex, lt = rt + 1;
        Ce.changeTextTrackMode(rt, "hidden", re), Ce.changeTextTrackMode(
          lt >= he.textTracks.length ? 0 : lt,
          "showing",
          re
        ), gr(he, "captionsChange");
      });
    }
  },
  previousCaptionLanguage: {
    keys: ["x"],
    onKeyDown({ event: re, player: he, remote: Ce }) {
      hr(re, () => {
        const rt = he.textTracks.selectedIndex, lt = rt - 1;
        Ce.changeTextTrackMode(rt, "hidden", re), Ce.changeTextTrackMode(
          lt < 0 ? he.textTracks.length - 1 : lt,
          "showing",
          re
        ), gr(he, "captionsChange");
      });
    }
  },
  decreasePlaybackRate: {
    keys: ["a"],
    onKeyDown({ event: re, player: he, remote: Ce }) {
      hr(re, () => {
        const lt = mi.indexOf(he.playbackRate) - 1;
        lt >= 0 && (Ce.changePlaybackRate(mi[lt], re), gr(he, "playbackRateChange"));
      });
    }
  },
  increasePlaybackRate: {
    keys: ["d"],
    onKeyDown({ event: re, player: he, remote: Ce }) {
      hr(re, () => {
        const lt = mi.indexOf(he.playbackRate) + 1;
        lt < mi.length && (Ce.changePlaybackRate(mi[lt], re), gr(he, "playbackRateChange"));
      });
    }
  },
  resetPlaybackRate: {
    keys: ["s"],
    onKeyDown({ event: re, player: he, remote: Ce }) {
      hr(re, () => {
        Ce.changePlaybackRate(1, re), gr(he, "playbackRateChange");
      });
    }
  },
  seekForward10Seconds: {
    keys: ["l"],
    onKeyDown({ event: re, player: he, remote: Ce }) {
      hr(re, () => {
        Ce.seek(he.currentTime + 10, re), gr(he, "seekForward10");
      });
    }
  },
  seekBackward10Seconds: {
    keys: ["j"],
    onKeyDown({ event: re, player: he, remote: Ce }) {
      hr(re, () => {
        Ce.seek(he.currentTime - 10, re), gr(he, "seekBackward10");
      });
    }
  }
};
function xg(re) {
  return Array.isArray(re) && typeof re[0] == "object";
}
function Fg(re) {
  return xg(re) && re.length === 1 ? re[0].src : re;
}
function za(re) {
  return typeof re == "number" && !isNaN(re);
}
function kg(re, he = 1e3) {
  let Ce = !1;
  return () => {
    Ce || (re(), Ce = !0, setTimeout(() => {
      Ce = !1;
    }, he));
  };
}
const Fs = {
  volume: 1,
  muted: !1,
  lang: null,
  captions: !1,
  rate: 1,
  multiplier: 1,
  ontop: !1,
  invert: !1,
  comments: !1
};
class Zg {
  constructor() {
    Or(this, "playerId", "studio-player");
    Or(this, "mediaId", null);
    Or(this, "data", Fs);
    Or(this, "time", null);
    Or(this, "overrideTime", null);
    Or(this, "saveTime", () => {
      if (!this.mediaId) return;
      const he = (this.time ?? 0).toString();
      localStorage.setItem(this.mediaId, he);
    });
    Or(this, "saveTimeThrottled", kg(this.saveTime, 1e3));
    // only used for useStudioPlayer hook's state initialization
    Or(this, "initializeState", (he) => {
      const Ce = localStorage.getItem(this.playerId);
      if (za(he) && he >= 0 && (this.overrideTime = he), Ce)
        try {
          this.data = JSON.parse(Ce);
        } catch {
        }
      return {
        captionsFontSizeMultiplier: this.data.multiplier,
        captionPositionOnTop: this.data.ontop,
        captionsInvertColors: this.data.invert,
        commentsEnabled: this.data.comments,
        interactionsDisabled: !1,
        globalKeysDisabled: !1,
        disableCaptionSettings: !1,
        isKeyboardShortcutsOpen: !1
      };
    });
    Or(this, "saveData", (he, Ce) => {
      this.data = {
        ...this.data,
        [he]: Ce
      }, this.save();
    });
  }
  async getVideoQuality() {
    return null;
  }
  async getAudioGain() {
    return null;
  }
  async getLang() {
    return this.data.lang;
  }
  async setLang(he) {
    this.data.lang = he, this.save();
  }
  async getVolume() {
    return this.data.volume;
  }
  async setVolume(he) {
    this.data.volume = he, this.save();
  }
  async getMuted() {
    return this.data.muted;
  }
  async setMuted(he) {
    this.data.muted = he, this.save();
  }
  async getTime() {
    return this.time;
  }
  // TODO: temporarily disabled
  // async setTime(time: number, ended: boolean) {
  //   const shouldClear = time < 0;
  //
  //   this.time = !shouldClear ? time : null;
  //
  //   if (shouldClear || ended) this.saveTime();
  //   else this.saveTimeThrottled();
  // }
  async getCaptions() {
    return this.data.captions;
  }
  async setCaptions(he) {
    this.data.captions = he, this.save();
  }
  async getPlaybackRate() {
    return this.data.rate;
  }
  async setPlaybackRate(he) {
    this.data.rate = he, this.save();
  }
  onChange(he, Ce, rt = "studio-player") {
    const lt = rt ? localStorage.getItem(rt) : null, Mt = Ce ? localStorage.getItem(Ce) : null;
    this.playerId = rt, this.mediaId = Ce;
    let Pe = {};
    if (lt)
      try {
        Pe = JSON.parse(lt);
      } catch {
      }
    this.data = {
      ...Fs,
      ...Pe
    }, za(this.overrideTime) && this.overrideTime >= 0 ? this.time = this.overrideTime : this.time = Mt ? +Mt : null;
  }
  save() {
    if (!this.playerId) return;
    const he = JSON.stringify(this.data);
    localStorage.setItem(this.playerId, he);
  }
}
function Ug(re, he, Ce, rt) {
  const lt = Mr(() => new Zg(), []), [Mt, Pe] = _r(
    lt.initializeState(rt)
  ), Ee = Zn(
    (E) => {
      Pe((h) => (lt.saveData("multiplier", E), {
        ...h,
        captionsFontSizeMultiplier: E
      }));
    },
    [lt]
  ), C = Zn(() => {
    Pe((E) => {
      const h = !E.captionPositionOnTop;
      return lt.saveData("ontop", h), {
        ...E,
        captionPositionOnTop: h
      };
    });
  }, [lt]), ie = Zn(() => {
    Pe((E) => {
      const h = !E.captionsInvertColors;
      return lt.saveData("invert", h), {
        ...E,
        captionsInvertColors: h
      };
    });
  }, [lt]), T = Zn(() => {
    Pe((E) => {
      const h = !E.commentsEnabled;
      return lt.saveData("comments", h), {
        ...E,
        commentsEnabled: h
      };
    });
  }, [lt]), t = Zn(() => {
    Pe((E) => ({
      ...E,
      interactionsDisabled: !1
    }));
  }, []), e = Zn(() => {
    Pe((E) => ({
      ...E,
      interactionsDisabled: !0
    }));
  }, []), p = Zn((E) => {
    Pe((h) => ({
      ...h,
      globalKeysDisabled: E
    }));
  }, []), m = Zn((E) => {
    Pe((h) => ({
      ...h,
      isKeyboardShortcutsOpen: E
    }));
  }, []), o = Mr(() => re ? {
    ...xs,
    toggleFullscreen: []
  } : xs, [re]);
  return {
    contextValue: {
      state: {
        ...Mt,
        commentsEnabled: he || Mt.commentsEnabled
      },
      setCaptionsFontSizeMultiplier: Ee,
      toggleCaptionPositionOnTop: C,
      toggleCaptionsInvertColors: ie,
      enableInteractions: t,
      disableInteractions: e,
      setGlobalKeysDisabled: p,
      toggleComments: T,
      disableCaptionSettings: Ce,
      setKeyboardShortcutsOpen: m
    },
    shortcuts: o,
    storage: lt
  };
}
const Bg = (re) => /* @__PURE__ */ ve("svg", { width: 56, height: 72, viewBox: "0 0 28 36", xmlns: "http://www.w3.org/2000/svg", ...re, children: /* @__PURE__ */ ve("g", { id: "Icons", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd", children: /* @__PURE__ */ ln("g", { id: "audio", children: [
  /* @__PURE__ */ ln("g", { id: "icon-file-base-2", children: [
    /* @__PURE__ */ ve("path", { d: "M0,2 L0,34 C0,35.105 0.899,36 1.993,36 L26.006,36 C27.107,36 28,35.11 28,34 L28,10 L18,0 L1.993,0 C0.892,0 0,0.89 0,2 Z", fill: "#FFFFFF" }),
    /* @__PURE__ */ ve("path", { d: "M0,2 L0,34 C0,35.105 0.899,36 1.993,36 L26.006,36 C27.107,36 28,35.11 28,34 L28,10 L18,0 L1.993,0 C0.892,0 0,0.89 0,2 Z M1.993,35 C1.445,35 1,34.552 1,34 L1,2 C1,1.448 1.445,1 1.993,1 L16.5,1 L16.5,9 C16.5,10.379 17.621,11.5 18.999,11.5 L27,11.5 L27,34 C27,34.552 26.554,35 26.006,35 L1.993,35 Z M27,10.5 L18.999,10.5 C18.173,10.5 17.5,9.827 17.5,9 L17.5,1 L17.585,1 L27,10.414 L27,10.5 L27,10.5 Z", id: "icon-file-base", fill: "#FFFFFF" }),
    /* @__PURE__ */ ve("path", { d: "M0,2 L0,34 C0,35.105 0.899,36 1.993,36 L26.006,36 C27.107,36 28,35.11 28,34 L28,10 L18,0 L1.993,0 C0.892,0 0,0.89 0,2 Z M1.993,35 C1.445,35 1,34.552 1,34 L1,2 C1,1.448 1.445,1 1.993,1 L16.5,1 L16.5,9 C16.5,10.379 17.621,11.5 18.999,11.5 L27,11.5 L27,34 C27,34.552 26.554,35 26.006,35 L1.993,35 Z M27,10.5 L18.999,10.5 C18.173,10.5 17.5,9.827 17.5,9 L17.5,1 L17.585,1 L27,10.414 L27,10.5 L27,10.5 Z", fill: "#384A58" })
  ] }),
  /* @__PURE__ */ ve("path", { d: "M14.7142857,14.2824 L14.7142857,13 L13.2857143,13.2548 L13.2857143,23.0912 C12.8642857,22.9106 12.3785714,22.8 11.8571429,22.8 C10.2771429,22.8 9,23.7408 9,24.9 C9,26.0592 10.2771429,27 11.8571429,27 C12.3785714,27 12.8642857,26.8894 13.2857143,26.7088 C14.1371429,26.3448 14.7142857,25.6756 14.7142857,24.9 L14.7142857,17.0824 C17.5714286,17.0824 19,20 19,21.4 C19,15.8 16.1428571,14.2824 14.7142857,14.2824", id: "Fill-776", fill: "#384A58" })
] }) }) });
function Gg() {
  const re = lr();
  return /* @__PURE__ */ ln("div", { className: "audio-layout-wrapper", children: [
    /* @__PURE__ */ ve(Bg, {}),
    /* @__PURE__ */ ve(Js, {}),
    /* @__PURE__ */ ve(Bs, {}),
    /* @__PURE__ */ ve(Ys, { captions: re.captions }),
    /* @__PURE__ */ ve(tu, {}),
    /* @__PURE__ */ ve(eu, {})
  ] });
}
function qg() {
  const re = lr(), he = re.kebabMenuElements.length > 0;
  return /* @__PURE__ */ ln(pi, { children: [
    /* @__PURE__ */ ve(Js, {}),
    /* @__PURE__ */ ve(Bs, {}),
    /* @__PURE__ */ ve(Ys, { captions: re.captions }),
    /* @__PURE__ */ ve(tu, {}),
    /* @__PURE__ */ ve(eu, {}),
    /* @__PURE__ */ ve(
      ff,
      {
        comments: re.comments,
        isKebabMenuVisible: he
      }
    )
  ] });
}
const Hg = "_root_5cfhx_1", Vg = "_normal_5cfhx_14", jg = "_compact_5cfhx_21", Yg = "_left-controls_5cfhx_36", Kg = "_right-controls_5cfhx_42", zg = "_indicators_5cfhx_48", hi = {
  root: Hg,
  normal: Vg,
  compact: jg,
  "left-controls": "_left-controls_5cfhx_36",
  leftControls: Yg,
  "right-controls": "_right-controls_5cfhx_42",
  rightControls: Kg,
  indicators: zg
};
function Wg() {
  const re = Dr(), he = lr();
  Pr(() => {
    const Ce = () => {
      const rt = he.startAt;
      re && he.disableStorage && za(rt) && re.remoteControl.seek(rt);
    };
    return re == null || re.addEventListener("loaded-metadata", Ce), () => {
      re == null || re.removeEventListener("loaded-metadata", Ce);
    };
  }, [re]);
}
function Qg({
  darkMode: re,
  playerRef: he,
  controlsLayout: Ce,
  showCaptionsButton: rt
}) {
  const lt = Dr(), Mt = Wn(), { hasAnnotations: Pe, hasQuizmarkers: Ee, interactive: C } = lr(), ie = Mt.state.interactionsDisabled || Mt.state.isKeyboardShortcutsOpen;
  return Wg(), Pr(() => {
    lt && (lt.remoteControl.pauseControls(), he && (typeof he == "function" ? he(lt) : he.current = lt));
  }, [lt, he]), /* @__PURE__ */ ln(
    "div",
    {
      "data-darkmode": re,
      className: Ii(hi.root, {
        [hi.normal]: Ce === "normal",
        [hi.compact]: Ce === "compact"
      }),
      inert: ie ? "true" : void 0,
      children: [
        Ce === "normal" ? /* @__PURE__ */ ln(
          Ls,
          {
            layout: "normal",
            interactionsDisabled: Mt.state.interactionsDisabled,
            children: [
              C || Pe || Ee ? /* @__PURE__ */ ve(wg, {}) : null,
              C ? /* @__PURE__ */ ve(Eg, {}) : null,
              /* @__PURE__ */ ve(Ps, {})
            ]
          }
        ) : null,
        /* @__PURE__ */ ln("div", { className: hi.leftControls, children: [
          /* @__PURE__ */ ve(Od, {}),
          /* @__PURE__ */ ve(Lg, {})
        ] }),
        /* @__PURE__ */ ve("div", { className: hi.indicators, children: /* @__PURE__ */ ve(Gd, {}) }),
        Ce === "compact" ? /* @__PURE__ */ ve(
          Ls,
          {
            layout: "compact",
            interactionsDisabled: Mt.state.interactionsDisabled,
            children: /* @__PURE__ */ ve(Ps, {})
          }
        ) : null,
        /* @__PURE__ */ ln("div", { className: hi.rightControls, children: [
          rt && /* @__PURE__ */ ve(Yc, {}),
          /* @__PURE__ */ ve(ud, {}),
          /* @__PURE__ */ ve(Sd, {})
        ] })
      ]
    }
  );
}
function Xg(re, he) {
  return re.reduce((Ce, rt) => (Object.keys(he).includes(rt.id) || (Ce[rt.id] = !0), Ce), he);
}
function $g(re, he, Ce, rt, lt) {
  return (Mt) => {
    const Pe = Mt.detail.currentTime, Ee = !Ce.paused, C = Math.min(Ce.duration * 0.05, 2);
    Pe >= re.time && Pe < re.time + C && !rt[re.id] && (lt({ ...rt, [re.id]: !0 }), he(re, Ee));
  };
}
function Jg() {
  const re = Dr(), { quizMarkers: he, onQuizMarkerShow: Ce } = lr(), [rt, lt] = _r(
    he.reduce((Mt, Pe) => (Mt[Pe.id] = !1, Mt), {})
  );
  Pr(() => {
    if (!re)
      return;
    he.length > Object.keys(rt).length && lt(Xg(he, rt));
    const Mt = [], Pe = (Ee) => {
      var T;
      const C = (T = Ee == null ? void 0 : Ee.request) == null ? void 0 : T.detail, ie = he.reduce((t, e) => (t[e.id] = e.time <= C, t), {});
      lt({ ...rt, ...ie });
    };
    re.addEventListener("seeked", Pe);
    for (const Ee of he) {
      const C = $g(
        Ee,
        Ce,
        re,
        rt,
        lt
      );
      re.addEventListener("time-update", C), Mt.push(C);
    }
    return () => {
      for (const Ee of Mt)
        re.removeEventListener("time-update", Ee);
      re.removeEventListener("seeked", Pe);
    };
  }, [he, re, rt]);
}
function eh() {
  return Jg(), null;
}
const th = {}, ia = () => {
};
function ch({
  title: re,
  playerRef: he,
  src: Ce,
  captions: rt = [],
  thumbnail: lt,
  hideFullScreen: Mt = !1,
  comments: Pe = [],
  locale: Ee = "en",
  annotations: C = [],
  quizMarkers: ie = [],
  interactive: T = !1,
  onAnnotationClick: t = ia,
  onQuizMarkerClick: e = ia,
  onQuizMarkerShow: p = ia,
  onInteractivePinClick: m = ia,
  onCaptionsDelete: o,
  interactiveMenuElements: E = [],
  kebabMenuElements: h = [],
  darkMode: n = !1,
  autoLoadCaptionSrc: c = "",
  forceComments: d = !1,
  disableCaptionSettings: S = !1,
  disableStorage: x = !1,
  startAt: B,
  crossOrigin: L,
  captionOffsetOverride: $,
  disableInteractivePinRanges: M = [],
  customOverlay: K,
  controlsLayout: ae = "compact",
  hideQuizMarkers: j = !1
}) {
  const { contextValue: ee, shortcuts: ue, storage: Ae } = Ug(
    Mt,
    d,
    S,
    B
  ), { i18n: Q } = Hn();
  Pr(() => {
    Q.changeLanguage(Ee);
  }, [Q, Ee]);
  const [Ne, Ue] = _r("none"), ze = Zn(
    (Oe) => {
      tc(Oe) ? Ue("audio") : (Rs(Oe) || ws(Oe) || nc(Oe)) && Ue("video"), (Rs(Oe) || ja(Oe)) && lt && (Oe.video.poster = lt);
    },
    [lt]
  ), Te = Zn(
    (Oe) => {
      ja(Oe) ? Oe.library = fc.MediaPlayer : ws(Oe) && (Oe.cookies = !0);
    },
    []
  );
  return /* @__PURE__ */ ve(
    hc,
    {
      title: re,
      hideFullScreen: Mt,
      comments: Pe,
      captions: rt,
      thumbnail: lt,
      annotations: C,
      quizMarkers: ie,
      interactive: T,
      onAnnotationClick: t,
      onQuizMarkerClick: e,
      onInteractivePinClick: m,
      interactiveMenuElements: E,
      kebabMenuElements: h,
      darkMode: n,
      forceComments: d,
      disableCaptionSettings: S,
      disableStorage: x,
      captionOffsetOverride: $,
      disableInteractivePinRanges: M,
      onQuizMarkerShow: p,
      onCaptionsDelete: o,
      controlsLayout: ae,
      startAt: B,
      hideQuizMarkers: j,
      children: /* @__PURE__ */ ve(gc, { contextValue: ee, children: /* @__PURE__ */ ln(
        rc,
        {
          "data-version": "1.1.12",
          crossOrigin: L,
          storage: x ? null : Ae,
          title: re,
          src: Fg(Ce),
          keyShortcuts: ue,
          playsInline: !0,
          keyDisabled: ee.state.interactionsDisabled || ee.state.globalKeysDisabled,
          onTextTracksChange: (Oe) => {
            const We = Oe == null ? void 0 : Oe.findIndex(
              (at) => at.src === c
            );
            We > -1 && (Oe[We].mode = "showing");
          },
          onProviderChange: Te,
          onProviderSetup: ze,
          onCanPlay: ({ provider: Oe }) => {
            ja(Oe) && (Oe.ctx.qualities.items.length === 0 ? Ue("audio") : Ue("video"));
          },
          children: [
            /* @__PURE__ */ ln(ic, { className: th.mediaProvider, children: [
              Ne === "audio" && /* @__PURE__ */ ve(Gg, {}),
              Ne === "video" && /* @__PURE__ */ ve(qg, {})
            ] }),
            /* @__PURE__ */ ve(jc, {}),
            K && /* @__PURE__ */ ve(df, { renderOverlay: K }),
            /* @__PURE__ */ ve(
              Qg,
              {
                darkMode: n,
                playerRef: he,
                showCaptionsButton: !S,
                controlsLayout: ae
              }
            ),
            /* @__PURE__ */ ve(_c, { annotations: C }),
            !!ie.length && /* @__PURE__ */ ve(eh, {})
          ]
        }
      ) })
    }
  );
}
export {
  Qc as CAPTION_FONT_SIZE_MULTIPLIERS,
  Xc as COMMENT_DURATION,
  mi as PLAYBACK_RATES,
  ch as StudioPlayer,
  $n as useMediaState,
  gh as useMediaStore
};
